/* eslint spaced-comment: 0 */


//
// vendor:













//
// local:
//
// FIXME: remove require marketing/pricing-tests after test

// FIXME: remove require marketing/shipping-speed-test after test








// FIXME: remove mega-nav after mega nav A/B test




























;
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */

( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var version = "3.7.1",

	rhtmlSuffix = /HTML$/i,

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},


	// Retrieve the text value of an array of DOM nodes
	text: function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;

		if ( !nodeType ) {

			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {

				// Do not traverse comment nodes
				ret += jQuery.text( node );
			}
		}
		if ( nodeType === 1 || nodeType === 11 ) {
			return elem.textContent;
		}
		if ( nodeType === 9 ) {
			return elem.documentElement.textContent;
		}
		if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}

		// Do not include comment or processing instruction nodes

		return ret;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	isXMLDoc: function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;

		// Assume HTML when documentElement doesn't yet exist, such as inside
		// document fragments.
		return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}


function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var pop = arr.pop;


var sort = arr.sort;


var splice = arr.splice;


var whitespace = "[\\x20\\t\\r\\n\\f]";


var rtrimCSS = new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);




// Note: an element does not contain itself
jQuery.contains = function( a, b ) {
	var bup = b && b.parentNode;

	return a === bup || !!( bup && bup.nodeType === 1 && (

		// Support: IE 9 - 11+
		// IE doesn't have `contains` on SVG.
		a.contains ?
			a.contains( bup ) :
			a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
	) );
};




// CSS string/identifier serialization
// https://drafts.csswg.org/cssom/#common-serializing-idioms
var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;

function fcssescape( ch, asCodePoint ) {
	if ( asCodePoint ) {

		// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
		if ( ch === "\0" ) {
			return "\uFFFD";
		}

		// Control characters and (dependent upon position) numbers get escaped as code points
		return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
	}

	// Other potentially-special ASCII characters get backslash-escaped
	return "\\" + ch;
}

jQuery.escapeSelector = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};




var preferredDoc = document,
	pushNative = push;

( function() {

var i,
	Expr,
	outermostContext,
	sortInput,
	hasDuplicate,
	push = pushNative,

	// Local document vars
	document,
	documentElement,
	documentIsHTML,
	rbuggyQSA,
	matches,

	// Instance-specific data
	expando = jQuery.expando,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
		"loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
		whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		ID: new RegExp( "^#(" + identifier + ")" ),
		CLASS: new RegExp( "^\\.(" + identifier + ")" ),
		TAG: new RegExp( "^(" + identifier + "|[*])" ),
		ATTR: new RegExp( "^" + attributes ),
		PSEUDO: new RegExp( "^" + pseudos ),
		CHILD: new RegExp(
			"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		bool: new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		needsContext: new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		if ( nonHex ) {

			// Strip the backslash prefix from a non-hex escape sequence
			return nonHex;
		}

		// Replace a hexadecimal escape sequence with the encoded Unicode code point
		// Support: IE <=11+
		// For values outside the Basic Multilingual Plane (BMP), manually construct a
		// surrogate pair
		return high < 0 ?
			String.fromCharCode( high + 0x10000 ) :
			String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes; see `setDocument`.
	// Support: IE 9 - 11+, Edge 12 - 18+
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE/Edge.
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && nodeName( elem, "fieldset" );
		},
		{ dir: "parentNode", next: "legend" }
	);

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android <=4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = {
		apply: function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		},
		call: function( target ) {
			pushNative.apply( target, slice.call( arguments, 1 ) );
		}
	};
}

function find( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								push.call( results, elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE 9 only
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							find.contains( context, elem ) &&
							elem.id === m ) {

							push.call( results, elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( !nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when
					// strict-comparing two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( newContext != context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = jQuery.escapeSelector( nid );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties
		// (see https://github.com/jquery/sizzle/issues/157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		return nodeName( elem, "input" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
			elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11+
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
function setDocument( node ) {
	var subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	documentElement = document.documentElement;
	documentIsHTML = !jQuery.isXMLDoc( document );

	// Support: iOS 7 only, IE 9 - 11+
	// Older browsers didn't support unprefixed `matches`.
	matches = documentElement.matches ||
		documentElement.webkitMatchesSelector ||
		documentElement.msMatchesSelector;

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors
	// (see trac-13936).
	// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
	// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
	if ( documentElement.msMatchesSelector &&

		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 9 - 11+, Edge 12 - 18+
		subWindow.addEventListener( "unload", unloadHandler );
	}

	// Support: IE <10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		documentElement.appendChild( el ).id = jQuery.expando;
		return !document.getElementsByName ||
			!document.getElementsByName( jQuery.expando ).length;
	} );

	// Support: IE 9 only
	// Check to see if it's possible to do matchesSelector
	// on a disconnected node.
	support.disconnectedMatch = assert( function( el ) {
		return matches.call( el, "*" );
	} );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// IE/Edge don't support the :scope pseudo-class.
	support.scope = assert( function() {
		return document.querySelectorAll( ":scope" );
	} );

	// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
	// Make sure the `:has()` argument is parsed unforgivingly.
	// We include `*` in the test to detect buggy implementations that are
	// _selectively_ forgiving (specifically when the list includes at least
	// one valid selector).
	// Note that we treat complete lack of support for `:has()` as if it were
	// spec-compliant support, which is fine because use of `:has()` in such
	// environments will fail in the qSA path and fall back to jQuery traversal
	// anyway.
	support.cssHas = assert( function() {
		try {
			document.querySelector( ":has(*,:jqfake)" );
			return false;
		} catch ( e ) {
			return true;
		}
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter.ID = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter.ID =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find.TAG = function( tag, context ) {
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			return context.getElementsByTagName( tag );

		// DocumentFragment nodes don't have gEBTN
		} else {
			return context.querySelectorAll( tag );
		}
	};

	// Class
	Expr.find.CLASS = function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	rbuggyQSA = [];

	// Build QSA regex
	// Regex strategy adopted from Diego Perini
	assert( function( el ) {

		var input;

		documentElement.appendChild( el ).innerHTML =
			"<a id='" + expando + "' href='' disabled='disabled'></a>" +
			"<select id='" + expando + "-\r\\' disabled='disabled'>" +
			"<option selected=''></option></select>";

		// Support: iOS <=7 - 8 only
		// Boolean attributes and "value" are not treated correctly in some XML documents
		if ( !el.querySelectorAll( "[selected]" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
		}

		// Support: iOS <=7 - 8 only
		if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
			rbuggyQSA.push( "~=" );
		}

		// Support: iOS 8 only
		// https://bugs.webkit.org/show_bug.cgi?id=136851
		// In-page `selector#id sibling-combinator selector` fails
		if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
			rbuggyQSA.push( ".#.+[+~]" );
		}

		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		if ( !el.querySelectorAll( ":checked" ).length ) {
			rbuggyQSA.push( ":checked" );
		}

		// Support: Windows 8 Native Apps
		// The type and name attributes are restricted during .innerHTML assignment
		input = document.createElement( "input" );
		input.setAttribute( "type", "hidden" );
		el.appendChild( input ).setAttribute( "name", "D" );

		// Support: IE 9 - 11+
		// IE's :disabled selector does not pick up the children of disabled fieldsets
		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		documentElement.appendChild( el ).disabled = true;
		if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
			rbuggyQSA.push( ":enabled", ":disabled" );
		}

		// Support: IE 11+, Edge 15 - 18+
		// IE 11/Edge don't find elements on a `[name='']` query in some cases.
		// Adding a temporary attribute to the document before the selection works
		// around the issue.
		// Interestingly, IE 10 & older don't seem to have the issue.
		input = document.createElement( "input" );
		input.setAttribute( "name", "" );
		el.appendChild( input );
		if ( !el.querySelectorAll( "[name='']" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
				whitespace + "*(?:''|\"\")" );
		}
	} );

	if ( !support.cssHas ) {

		// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
		// Our regular `try-catch` mechanism fails to detect natively-unsupported
		// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
		// in browsers that parse the `:has()` argument as a forgiving selector list.
		// https://drafts.csswg.org/selectors/#relational now requires the argument
		// to be parsed unforgivingly, but browsers have not yet fully adjusted.
		rbuggyQSA.push( ":has" );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a === document || a.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b === document || b.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	};

	return document;
}

find.matches = function( expr, elements ) {
	return find( expr, null, null, elements );
};

find.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return find( expr, document, null, [ elem ] ).length > 0;
};

find.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return jQuery.contains( context, elem );
};


find.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (see trac-13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	if ( val !== undefined ) {
		return val;
	}

	return elem.getAttribute( name );
};

find.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
jQuery.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	//
	// Support: Android <=4.0+
	// Testing for detecting duplicates is unpredictable so instead assume we can't
	// depend on duplicate detection in all browsers without a stable sort.
	hasDuplicate = !support.sortStable;
	sortInput = !support.sortStable && slice.call( results, 0 );
	sort.call( results, sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			splice.call( results, duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

jQuery.fn.uniqueSort = function() {
	return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
};

Expr = jQuery.expr = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		ATTR: function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
				.replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		CHILD: function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					find.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
				);
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

			// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				find.error( match[ 0 ] );
			}

			return match;
		},

		PSEUDO: function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		TAG: function( nodeNameSelector ) {
			var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return nodeName( elem, expectedNodeName );
				};
		},

		CLASS: function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace + ")" + className +
					"(" + whitespace + "|$)" ) ) &&
				classCache( className, function( elem ) {
					return pattern.test(
						typeof elem.className === "string" && elem.className ||
							typeof elem.getAttribute !== "undefined" &&
								elem.getAttribute( "class" ) ||
							""
					);
				} );
		},

		ATTR: function( name, operator, check ) {
			return function( elem ) {
				var result = find.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				if ( operator === "=" ) {
					return result === check;
				}
				if ( operator === "!=" ) {
					return result !== check;
				}
				if ( operator === "^=" ) {
					return check && result.indexOf( check ) === 0;
				}
				if ( operator === "*=" ) {
					return check && result.indexOf( check ) > -1;
				}
				if ( operator === "$=" ) {
					return check && result.slice( -check.length ) === check;
				}
				if ( operator === "~=" ) {
					return ( " " + result.replace( rwhitespace, " " ) + " " )
						.indexOf( check ) > -1;
				}
				if ( operator === "|=" ) {
					return result === check || result.slice( 0, check.length + 1 ) === check + "-";
				}

				return false;
			};
		},

		CHILD: function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || ( parent[ expando ] = {} );
							cache = outerCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {
								outerCache = elem[ expando ] || ( elem[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );
											outerCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		PSEUDO: function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// https://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					find.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as jQuery does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf.call( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		not: markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrimCSS, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element
					// (see https://github.com/jquery/sizzle/issues/299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		has: markFunction( function( selector ) {
			return function( elem ) {
				return find( selector, elem ).length > 0;
			};
		} ),

		contains: markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// https://www.w3.org/TR/selectors/#lang-pseudo
		lang: markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				find.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		target: function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		root: function( elem ) {
			return elem === documentElement;
		},

		focus: function( elem ) {
			return elem === safeActiveElement() &&
				document.hasFocus() &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		enabled: createDisabledPseudo( false ),
		disabled: createDisabledPseudo( true ),

		checked: function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			return ( nodeName( elem, "input" ) && !!elem.checked ) ||
				( nodeName( elem, "option" ) && !!elem.selected );
		},

		selected: function( elem ) {

			// Support: IE <=11+
			// Accessing the selectedIndex property
			// forces the browser to treat the default option as
			// selected when in an optgroup.
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		empty: function( elem ) {

			// https://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		parent: function( elem ) {
			return !Expr.pseudos.empty( elem );
		},

		// Element/input types
		header: function( elem ) {
			return rheader.test( elem.nodeName );
		},

		input: function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		button: function( elem ) {
			return nodeName( elem, "input" ) && elem.type === "button" ||
				nodeName( elem, "button" );
		},

		text: function( elem ) {
			var attr;
			return nodeName( elem, "input" ) && elem.type === "text" &&

				// Support: IE <10 only
				// New HTML5 attribute values (e.g., "search") appear
				// with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		first: createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		last: createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		even: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		odd: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i;

			if ( argument < 0 ) {
				i = argument + length;
			} else if ( argument > length ) {
				i = length;
			} else {
				i = argument;
			}

			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos.nth = Expr.pseudos.eq;

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

function tokenize( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrimCSS, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	if ( parseOnly ) {
		return soFar.length;
	}

	return soFar ?
		find.error( selector ) :

		// Cache the tokens
		tokenCache( selector, groups ).slice( 0 );
}

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						if ( skip && nodeName( elem, skip ) ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = outerCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							outerCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		find( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem, matcherOut,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed ||
				multipleContexts( selector || "*",
					context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems;

		if ( matcher ) {

			// If we have a postFinder, or filtered seed, or non-seed postFilter
			// or preexisting results,
			matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

				// ...intermediate processing is necessary
				[] :

				// ...otherwise use results directly
				results;

			// Find primary matches
			matcher( matcherIn, matcherOut, context, xml );
		} else {
			matcherOut = matcherIn;
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf.call( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element
			// (see https://github.com/jquery/sizzle/issues/299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrimCSS, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find.TAG( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: iOS <=7 - 9 only
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
			// elements by id. (see trac-14142)
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							push.call( results, elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					jQuery.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

function compile( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
}

/**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
function select( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find.ID(
				token.matches[ 0 ].replace( runescape, funescape ),
				context
			) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) &&
						testContext( context.parentNode ) || context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
}

// One-time assignments

// Support: Android <=4.0 - 4.1+
// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Initialize against the default document
setDocument();

// Support: Android <=4.0 - 4.1+
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

jQuery.find = find;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.unique = jQuery.uniqueSort;

// These have always been private, but they used to be documented as part of
// Sizzle so let's maintain them for now for backwards compatibility purposes.
find.compile = compile;
find.select = select;
find.setDocument = setDocument;
find.tokenize = tokenize;

find.escape = jQuery.escapeSelector;
find.getText = jQuery.text;
find.isXML = jQuery.isXMLDoc;
find.selectors = jQuery.expr;
find.support = jQuery.support;
find.uniqueSort = jQuery.uniqueSort;

	/* eslint-enable */

} )();


var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
	// Strict HTML recognition (trac-11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to jQuery#find
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.error );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the error, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getErrorHook ) {
									process.error = jQuery.Deferred.getErrorHook();

								// The deprecated alias of the above. While the name suggests
								// returning the stack, not an error instance, jQuery just passes
								// it directly to `console.warn` so both will work; an instance
								// just better cooperates with source maps.
								} else if ( jQuery.Deferred.getStackHook ) {
									process.error = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
// captured before the async barrier to get the original error cause
// which may otherwise be hidden.
jQuery.Deferred.exceptionHook = function( error, asyncError ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message,
			error.stack, asyncError );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See trac-6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see trac-8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (trac-14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (trac-11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (trac-14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (trac-13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (trac-12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (trac-13208)
				// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (trac-13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", true );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, isSetup ) {

	// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
	if ( !isSetup ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				if ( !saved ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					this[ type ]();
					result = dataPriv.get( this, type );
					dataPriv.set( this, type, false );

					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						return result;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering
				// the native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved ) {

				// ...and capture the result
				dataPriv.set( this, type, jQuery.event.trigger(
					saved[ 0 ],
					saved.slice( 1 ),
					this
				) );

				// Abort handling of the native event by all jQuery handlers while allowing
				// native handlers on the same element to run. On target, this is achieved
				// by stopping immediate propagation just on the jQuery event. However,
				// the native event is re-wrapped by a jQuery one on each level of the
				// propagation so the only way to stop it for jQuery is to stop it for
				// everyone via native `stopPropagation()`. This is not a problem for
				// focus/blur which don't bubble, but it does also stop click on checkboxes
				// and radios. We accept this limitation.
				event.stopPropagation();
				event.isImmediatePropagationStopped = returnTrue;
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (trac-504, trac-13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {

	function focusMappedHandler( nativeEvent ) {
		if ( document.documentMode ) {

			// Support: IE 11+
			// Attach a single focusin/focusout handler on the document while someone wants
			// focus/blur. This is because the former are synchronous in IE while the latter
			// are async. In other browsers, all those handlers are invoked synchronously.

			// `handle` from private data would already wrap the event, but we need
			// to change the `type` here.
			var handle = dataPriv.get( this, "handle" ),
				event = jQuery.event.fix( nativeEvent );
			event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
			event.isSimulated = true;

			// First, handle focusin/focusout
			handle( nativeEvent );

			// ...then, handle focus/blur
			//
			// focus/blur don't bubble while focusin/focusout do; simulate the former by only
			// invoking the handler at the lower level.
			if ( event.target === event.currentTarget ) {

				// The setup part calls `leverageNative`, which, in turn, calls
				// `jQuery.event.add`, so event handle will already have been set
				// by this point.
				handle( event );
			}
		} else {

			// For non-IE browsers, attach a single capturing handler on the document
			// while someone wants focusin/focusout.
			jQuery.event.simulate( delegateType, nativeEvent.target,
				jQuery.event.fix( nativeEvent ) );
		}
	}

	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			var attaches;

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, true );

			if ( document.documentMode ) {

				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				attaches = dataPriv.get( this, delegateType );
				if ( !attaches ) {
					this.addEventListener( delegateType, focusMappedHandler );
				}
				dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
			} else {

				// Return false to allow normal processing in the caller
				return false;
			}
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		teardown: function() {
			var attaches;

			if ( document.documentMode ) {
				attaches = dataPriv.get( this, delegateType ) - 1;
				if ( !attaches ) {
					this.removeEventListener( delegateType, focusMappedHandler );
					dataPriv.remove( this, delegateType );
				} else {
					dataPriv.set( this, delegateType, attaches );
				}
			} else {

				// Return false to indicate standard teardown should be applied
				return false;
			}
		},

		// Suppress native focus or blur if we're currently inside
		// a leveraged native-event stack
		_default: function( event ) {
			return dataPriv.get( event.target, type );
		},

		delegateType: delegateType
	};

	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	//
	// Support: IE 9 - 11+
	// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
	// attach a single handler for both events in IE.
	jQuery.event.special[ delegateType ] = {
		setup: function() {

			// Handle: regular nodes (via `this.ownerDocument`), window
			// (via `this.document`) & document (via `this`).
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType );

			// Support: IE 9 - 11+
			// We use the same native handler for focusin & focus (and focusout & blur)
			// so we need to coordinate setup & teardown parts between those events.
			// Use `delegateType` as the key as `type` is already used by `leverageNative`.
			if ( !attaches ) {
				if ( document.documentMode ) {
					this.addEventListener( delegateType, focusMappedHandler );
				} else {
					doc.addEventListener( type, focusMappedHandler, true );
				}
			}
			dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
		},
		teardown: function() {
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType ) - 1;

			if ( !attaches ) {
				if ( document.documentMode ) {
					this.removeEventListener( delegateType, focusMappedHandler );
				} else {
					doc.removeEventListener( type, focusMappedHandler, true );
				}
				dataPriv.remove( dataHolder, delegateType );
			} else {
				dataPriv.set( dataHolder, delegateType, attaches );
			}
		}
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

	rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (trac-8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Re-enable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {

							// Unwrap a CDATA section containing script contents. This shouldn't be
							// needed as in XML documents they're already not visible when
							// inspecting element contents and in HTML documents they have no
							// meaning but we're preserving that logic for backwards compatibility.
							// This will be removed completely in 4.0. See gh-4904.
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew jQuery#find here for performance reasons:
			// https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var rcustomProp = /^--/;


var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (trac-8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "box-sizing:content-box;border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is `display: block`
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		isCustomProp = rcustomProp.test( name ),

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, trac-12537)
	//   .css('--customProperty) (gh-3144)
	if ( computed ) {

		// Support: IE <=9 - 11+
		// IE only supports `"float"` in `getPropertyValue`; in computed styles
		// it's only available as `"cssFloat"`. We no longer modify properties
		// sent to `.css()` apart from camelCasing, so we need to check both.
		// Normally, this would create difference in behavior: if
		// `getPropertyValue` returns an empty string, the value returned
		// by `.css()` would be `undefined`. This is usually the case for
		// disconnected elements. However, in IE even disconnected elements
		// with no styles return `"none"` for `getPropertyValue( "float" )`
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( isCustomProp && ret ) {

			// Support: Firefox 105+, Chrome <=105+
			// Spec requires trimming whitespace for custom properties (gh-4926).
			// Firefox only trims leading whitespace. Chrome just collapses
			// both leading & trailing whitespace to a single space.
			//
			// Fall back to `undefined` if empty string returned.
			// This collapses a missing definition with property defined
			// and set to an empty string but there's no standard API
			// allowing us to differentiate them without a performance penalty
			// and returning `undefined` aligns with older jQuery.
			//
			// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
			// as whitespace while CSS does not, but this is not a problem
			// because CSS preprocessing replaces them with U+000A LINE FEED
			// (which *is* CSS whitespace)
			// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
			ret = ret.replace( rtrimCSS, "$1" ) || undefined;
		}

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0,
		marginDelta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		// Count margin delta separately to only add it after scroll gutter adjustment.
		// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
		if ( box === "margin" ) {
			marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta + marginDelta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		animationIterationCount: true,
		aspectRatio: true,
		borderImageSlice: true,
		columnCount: true,
		flexGrow: true,
		flexShrink: true,
		fontWeight: true,
		gridArea: true,
		gridColumn: true,
		gridColumnEnd: true,
		gridColumnStart: true,
		gridRow: true,
		gridRowEnd: true,
		gridRowStart: true,
		lineHeight: true,
		opacity: true,
		order: true,
		orphans: true,
		scale: true,
		widows: true,
		zIndex: true,
		zoom: true,

		// SVG-related
		fillOpacity: true,
		floodOpacity: true,
		stopOpacity: true,
		strokeMiterlimit: true,
		strokeOpacity: true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (trac-7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug trac-9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (trac-7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// Use proper attribute retrieval (trac-12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
						if ( cur.indexOf( " " + className + " " ) < 0 ) {
							cur += className + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );

				// This expression is here for better compressibility (see addClass)
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						// Remove *all* instances
						while ( cur.indexOf( " " + className + " " ) > -1 ) {
							cur = cur.replace( " " + className + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var classNames, className, i, self,
			type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		classNames = classesToArray( value );

		return this.each( function() {
			if ( isValidValue ) {

				// Toggle individual class names
				self = jQuery( this );

				for ( i = 0; i < classNames.length; i++ ) {
					className = classNames[ i ];

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (trac-14686, trac-14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (trac-2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (trac-9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (trac-6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// trac-7653, trac-8125, trac-8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (trac-10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket trac-12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// trac-9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (trac-11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// trac-1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see trac-8605, trac-14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// trac-14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this
			.on( "mouseenter", fnOver )
			.on( "mouseleave", fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "$1" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof define === "function" && define.amd ) {
	define( "jquery", [], function() {
		return jQuery;
	} );
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );
/*!
 * jQuery Validation Plugin v1.17.0
 *
 * https://jqueryvalidation.org/
 *
 * Copyright (c) 2017 Jörn Zaefferer
 * Released under the MIT license
 */

(function( factory ) {
  if ( typeof define === "function" && define.amd ) {
    define( ["jquery"], factory );
  } else if (typeof module === "object" && module.exports) {
    module.exports = factory( require( "jquery" ) );
  } else {
    factory( jQuery );
  }
}(function( $ ) {

$.extend( $.fn, {

  // https://jqueryvalidation.org/validate/
  validate: function( options ) {

    // If nothing is selected, return nothing; can't chain anyway
    if ( !this.length ) {
      if ( options && options.debug && window.console ) {
        console.warn( "Nothing selected, can't validate, returning nothing." );
      }
      return;
    }

    // Check if a validator for this form was already created
    var validator = $.data( this[ 0 ], "validator" );
    if ( validator ) {
      return validator;
    }

    // Add novalidate tag if HTML5.
    this.attr( "novalidate", "novalidate" );

    validator = new $.validator( options, this[ 0 ] );
    $.data( this[ 0 ], "validator", validator );

    if ( validator.settings.onsubmit ) {

      this.on( "click.validate", ":submit", function( event ) {

        // Track the used submit button to properly handle scripted
        // submits later.
        validator.submitButton = event.currentTarget;

        // Allow suppressing validation by adding a cancel class to the submit button
        if ( $( this ).hasClass( "cancel" ) ) {
          validator.cancelSubmit = true;
        }

        // Allow suppressing validation by adding the html5 formnovalidate attribute to the submit button
        if ( $( this ).attr( "formnovalidate" ) !== undefined ) {
          validator.cancelSubmit = true;
        }
      } );

      // Validate the form on submit
      this.on( "submit.validate", function( event ) {
        if ( validator.settings.debug ) {

          // Prevent form submit to be able to see console output
          event.preventDefault();
        }
        function handle() {
          var hidden, result;

          // Insert a hidden input as a replacement for the missing submit button
          // The hidden input is inserted in two cases:
          //   - A user defined a `submitHandler`
          //   - There was a pending request due to `remote` method and `stopRequest()`
          //     was called to submit the form in case it's valid
          if ( validator.submitButton && ( validator.settings.submitHandler || validator.formSubmitted ) ) {
            hidden = $( "<input type='hidden'/>" )
              .attr( "name", validator.submitButton.name )
              .val( $( validator.submitButton ).val() )
              .appendTo( validator.currentForm );
          }

          if ( validator.settings.submitHandler ) {
            result = validator.settings.submitHandler.call( validator, validator.currentForm, event );
            if ( hidden ) {

              // And clean up afterwards; thanks to no-block-scope, hidden can be referenced
              hidden.remove();
            }
            if ( result !== undefined ) {
              return result;
            }
            return false;
          }
          return true;
        }

        // Prevent submit for invalid forms or custom submit handlers
        if ( validator.cancelSubmit ) {
          validator.cancelSubmit = false;
          return handle();
        }
        if ( validator.form() ) {
          if ( validator.pendingRequest ) {
            validator.formSubmitted = true;
            return false;
          }
          return handle();
        } else {
          validator.focusInvalid();
          return false;
        }
      } );
    }

    return validator;
  },

  // https://jqueryvalidation.org/valid/
  valid: function() {
    var valid, validator, errorList;

    if ( $( this[ 0 ] ).is( "form" ) ) {
      valid = this.validate().form();
    } else {
      errorList = [];
      valid = true;
      validator = $( this[ 0 ].form ).validate();
      this.each( function() {
        valid = validator.element( this ) && valid;
        if ( !valid ) {
          errorList = errorList.concat( validator.errorList );
        }
      } );
      validator.errorList = errorList;
    }
    return valid;
  },

  // https://jqueryvalidation.org/rules/
  rules: function( command, argument ) {
    var element = this[ 0 ],
      settings, staticRules, existingRules, data, param, filtered;

    // If nothing is selected, return empty object; can't chain anyway
    if ( element == null ) {
      return;
    }

    if ( !element.form && element.hasAttribute( "contenteditable" ) ) {
      element.form = this.closest( "form" )[ 0 ];
      element.name = this.attr( "name" );
    }

    if ( element.form == null ) {
      return;
    }

    if ( command ) {
      settings = $.data( element.form, "validator" ).settings;
      staticRules = settings.rules;
      existingRules = $.validator.staticRules( element );
      switch ( command ) {
      case "add":
        $.extend( existingRules, $.validator.normalizeRule( argument ) );

        // Remove messages from rules, but allow them to be set separately
        delete existingRules.messages;
        staticRules[ element.name ] = existingRules;
        if ( argument.messages ) {
          settings.messages[ element.name ] = $.extend( settings.messages[ element.name ], argument.messages );
        }
        break;
      case "remove":
        if ( !argument ) {
          delete staticRules[ element.name ];
          return existingRules;
        }
        filtered = {};
        $.each( argument.split( /\s/ ), function( index, method ) {
          filtered[ method ] = existingRules[ method ];
          delete existingRules[ method ];
        } );
        return filtered;
      }
    }

    data = $.validator.normalizeRules(
    $.extend(
      {},
      $.validator.classRules( element ),
      $.validator.attributeRules( element ),
      $.validator.dataRules( element ),
      $.validator.staticRules( element )
    ), element );

    // Make sure required is at front
    if ( data.required ) {
      param = data.required;
      delete data.required;
      data = $.extend( { required: param }, data );
    }

    // Make sure remote is at back
    if ( data.remote ) {
      param = data.remote;
      delete data.remote;
      data = $.extend( data, { remote: param } );
    }

    return data;
  }
} );

// Custom selectors
$.extend( $.expr.pseudos || $.expr[ ":" ], {    // '|| $.expr[ ":" ]' here enables backwards compatibility to jQuery 1.7. Can be removed when dropping jQ 1.7.x support

  // https://jqueryvalidation.org/blank-selector/
  blank: function( a ) {
    return !$.trim( "" + $( a ).val() );
  },

  // https://jqueryvalidation.org/filled-selector/
  filled: function( a ) {
    var val = $( a ).val();
    return val !== null && !!$.trim( "" + val );
  },

  // https://jqueryvalidation.org/unchecked-selector/
  unchecked: function( a ) {
    return !$( a ).prop( "checked" );
  }
} );

// Constructor for validator
$.validator = function( options, form ) {
  this.settings = $.extend( true, {}, $.validator.defaults, options );
  this.currentForm = form;
  this.init();
};

// https://jqueryvalidation.org/jQuery.validator.format/
$.validator.format = function( source, params ) {
  if ( arguments.length === 1 ) {
    return function() {
      var args = $.makeArray( arguments );
      args.unshift( source );
      return $.validator.format.apply( this, args );
    };
  }
  if ( params === undefined ) {
    return source;
  }
  if ( arguments.length > 2 && params.constructor !== Array  ) {
    params = $.makeArray( arguments ).slice( 1 );
  }
  if ( params.constructor !== Array ) {
    params = [ params ];
  }
  $.each( params, function( i, n ) {
    source = source.replace( new RegExp( "\\{" + i + "\\}", "g" ), function() {
      return n;
    } );
  } );
  return source;
};

$.extend( $.validator, {

  defaults: {
    messages: {},
    groups: {},
    rules: {},
    errorClass: "error",
    pendingClass: "pending",
    validClass: "valid",
    errorElement: "label",
    focusCleanup: false,
    focusInvalid: true,
    errorContainer: $( [] ),
    errorLabelContainer: $( [] ),
    onsubmit: true,
    ignore: ":hidden",
    ignoreTitle: false,
    onfocusin: function( element ) {
      this.lastActive = element;

      // Hide error label and remove error class on focus if enabled
      if ( this.settings.focusCleanup ) {
        if ( this.settings.unhighlight ) {
          this.settings.unhighlight.call( this, element, this.settings.errorClass, this.settings.validClass );
        }
        this.hideThese( this.errorsFor( element ) );
      }
    },
    onfocusout: function( element ) {
      if ( !this.checkable( element ) && ( element.name in this.submitted || !this.optional( element ) ) ) {
        this.element( element );
      }
    },
    onkeyup: function( element, event ) {

      // Avoid revalidate the field when pressing one of the following keys
      // Shift       => 16
      // Ctrl        => 17
      // Alt         => 18
      // Caps lock   => 20
      // End         => 35
      // Home        => 36
      // Left arrow  => 37
      // Up arrow    => 38
      // Right arrow => 39
      // Down arrow  => 40
      // Insert      => 45
      // Num lock    => 144
      // AltGr key   => 225
      var excludedKeys = [
        16, 17, 18, 20, 35, 36, 37,
        38, 39, 40, 45, 144, 225
      ];

      if ( event.which === 9 && this.elementValue( element ) === "" || $.inArray( event.keyCode, excludedKeys ) !== -1 ) {
        return;
      } else if ( element.name in this.submitted || element.name in this.invalid ) {
        this.element( element );
      }
    },
    onclick: function( element ) {

      // Click on selects, radiobuttons and checkboxes
      if ( element.name in this.submitted ) {
        this.element( element );

      // Or option elements, check parent select in that case
      } else if ( element.parentNode.name in this.submitted ) {
        this.element( element.parentNode );
      }
    },
    highlight: function( element, errorClass, validClass ) {
      if ( element.type === "radio" ) {
        this.findByName( element.name ).addClass( errorClass ).removeClass( validClass );
      } else {
        $( element ).addClass( errorClass ).removeClass( validClass );
      }
    },
    unhighlight: function( element, errorClass, validClass ) {
      if ( element.type === "radio" ) {
        this.findByName( element.name ).removeClass( errorClass ).addClass( validClass );
      } else {
        $( element ).removeClass( errorClass ).addClass( validClass );
      }
    }
  },

  // https://jqueryvalidation.org/jQuery.validator.setDefaults/
  setDefaults: function( settings ) {
    $.extend( $.validator.defaults, settings );
  },

  messages: {
    required: "This field is required.",
    remote: "Please fix this field.",
    email: "Please enter a valid email address.",
    url: "Please enter a valid URL.",
    date: "Please enter a valid date.",
    dateISO: "Please enter a valid date (ISO).",
    number: "Please enter a valid number.",
    digits: "Please enter only digits.",
    equalTo: "Please enter the same value again.",
    maxlength: $.validator.format( "Please enter no more than {0} characters." ),
    minlength: $.validator.format( "Please enter at least {0} characters." ),
    rangelength: $.validator.format( "Please enter a value between {0} and {1} characters long." ),
    range: $.validator.format( "Please enter a value between {0} and {1}." ),
    max: $.validator.format( "Please enter a value less than or equal to {0}." ),
    min: $.validator.format( "Please enter a value greater than or equal to {0}." ),
    step: $.validator.format( "Please enter a multiple of {0}." )
  },

  autoCreateRanges: false,

  prototype: {

    init: function() {
      this.labelContainer = $( this.settings.errorLabelContainer );
      this.errorContext = this.labelContainer.length && this.labelContainer || $( this.currentForm );
      this.containers = $( this.settings.errorContainer ).add( this.settings.errorLabelContainer );
      this.submitted = {};
      this.valueCache = {};
      this.pendingRequest = 0;
      this.pending = {};
      this.invalid = {};
      this.reset();

      var groups = ( this.groups = {} ),
        rules;
      $.each( this.settings.groups, function( key, value ) {
        if ( typeof value === "string" ) {
          value = value.split( /\s/ );
        }
        $.each( value, function( index, name ) {
          groups[ name ] = key;
        } );
      } );
      rules = this.settings.rules;
      $.each( rules, function( key, value ) {
        rules[ key ] = $.validator.normalizeRule( value );
      } );

      function delegate( event ) {

        // Set form expando on contenteditable
        if ( !this.form && this.hasAttribute( "contenteditable" ) ) {
          this.form = $( this ).closest( "form" )[ 0 ];
          this.name = $( this ).attr( "name" );
        }

        var validator = $.data( this.form, "validator" ),
          eventType = "on" + event.type.replace( /^validate/, "" ),
          settings = validator.settings;
        if ( settings[ eventType ] && !$( this ).is( settings.ignore ) ) {
          settings[ eventType ].call( validator, this, event );
        }
      }

      $( this.currentForm )
        .on( "focusin.validate focusout.validate keyup.validate",
          ":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'], " +
          "[type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], " +
          "[type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'], " +
          "[type='radio'], [type='checkbox'], [contenteditable], [type='button']", delegate )

        // Support: Chrome, oldIE
        // "select" is provided as event.target when clicking a option
        .on( "click.validate", "select, option, [type='radio'], [type='checkbox']", delegate );

      if ( this.settings.invalidHandler ) {
        $( this.currentForm ).on( "invalid-form.validate", this.settings.invalidHandler );
      }
    },

    // https://jqueryvalidation.org/Validator.form/
    form: function() {
      this.checkForm();
      $.extend( this.submitted, this.errorMap );
      this.invalid = $.extend( {}, this.errorMap );
      if ( !this.valid() ) {
        $( this.currentForm ).triggerHandler( "invalid-form", [ this ] );
      }
      this.showErrors();
      return this.valid();
    },

    checkForm: function() {
      this.prepareForm();
      for ( var i = 0, elements = ( this.currentElements = this.elements() ); elements[ i ]; i++ ) {
        this.check( elements[ i ] );
      }
      return this.valid();
    },

    // https://jqueryvalidation.org/Validator.element/
    element: function( element ) {
      var cleanElement = this.clean( element ),
        checkElement = this.validationTargetFor( cleanElement ),
        v = this,
        result = true,
        rs, group;

      if ( checkElement === undefined ) {
        delete this.invalid[ cleanElement.name ];
      } else {
        this.prepareElement( checkElement );
        this.currentElements = $( checkElement );

        // If this element is grouped, then validate all group elements already
        // containing a value
        group = this.groups[ checkElement.name ];
        if ( group ) {
          $.each( this.groups, function( name, testgroup ) {
            if ( testgroup === group && name !== checkElement.name ) {
              cleanElement = v.validationTargetFor( v.clean( v.findByName( name ) ) );
              if ( cleanElement && cleanElement.name in v.invalid ) {
                v.currentElements.push( cleanElement );
                result = v.check( cleanElement ) && result;
              }
            }
          } );
        }

        rs = this.check( checkElement ) !== false;
        result = result && rs;
        if ( rs ) {
          this.invalid[ checkElement.name ] = false;
        } else {
          this.invalid[ checkElement.name ] = true;
        }

        if ( !this.numberOfInvalids() ) {

          // Hide error containers on last error
          this.toHide = this.toHide.add( this.containers );
        }
        this.showErrors();

        // Add aria-invalid status for screen readers
        $( element ).attr( "aria-invalid", !rs );
      }

      return result;
    },

    // https://jqueryvalidation.org/Validator.showErrors/
    showErrors: function( errors ) {
      if ( errors ) {
        var validator = this;

        // Add items to error list and map
        $.extend( this.errorMap, errors );
        this.errorList = $.map( this.errorMap, function( message, name ) {
          return {
            message: message,
            element: validator.findByName( name )[ 0 ]
          };
        } );

        // Remove items from success list
        this.successList = $.grep( this.successList, function( element ) {
          return !( element.name in errors );
        } );
      }
      if ( this.settings.showErrors ) {
        this.settings.showErrors.call( this, this.errorMap, this.errorList );
      } else {
        this.defaultShowErrors();
      }
    },

    // https://jqueryvalidation.org/Validator.resetForm/
    resetForm: function() {
      if ( $.fn.resetForm ) {
        $( this.currentForm ).resetForm();
      }
      this.invalid = {};
      this.submitted = {};
      this.prepareForm();
      this.hideErrors();
      var elements = this.elements()
        .removeData( "previousValue" )
        .removeAttr( "aria-invalid" );

      this.resetElements( elements );
    },

    resetElements: function( elements ) {
      var i;

      if ( this.settings.unhighlight ) {
        for ( i = 0; elements[ i ]; i++ ) {
          this.settings.unhighlight.call( this, elements[ i ],
            this.settings.errorClass, "" );
          this.findByName( elements[ i ].name ).removeClass( this.settings.validClass );
        }
      } else {
        elements
          .removeClass( this.settings.errorClass )
          .removeClass( this.settings.validClass );
      }
    },

    numberOfInvalids: function() {
      return this.objectLength( this.invalid );
    },

    objectLength: function( obj ) {
      /* jshint unused: false */
      var count = 0,
        i;
      for ( i in obj ) {

        // This check allows counting elements with empty error
        // message as invalid elements
        if ( obj[ i ] !== undefined && obj[ i ] !== null && obj[ i ] !== false ) {
          count++;
        }
      }
      return count;
    },

    hideErrors: function() {
      this.hideThese( this.toHide );
    },

    hideThese: function( errors ) {
      errors.not( this.containers ).text( "" );
      this.addWrapper( errors ).hide();
    },

    valid: function() {
      return this.size() === 0;
    },

    size: function() {
      return this.errorList.length;
    },

    focusInvalid: function() {
      if ( this.settings.focusInvalid ) {
        try {
          $( this.findLastActive() || this.errorList.length && this.errorList[ 0 ].element || [] )
          .filter( ":visible" )
          .focus()

          // Manually trigger focusin event; without it, focusin handler isn't called, findLastActive won't have anything to find
          .trigger( "focusin" );
        } catch ( e ) {

          // Ignore IE throwing errors when focusing hidden elements
        }
      }
    },

    findLastActive: function() {
      var lastActive = this.lastActive;
      return lastActive && $.grep( this.errorList, function( n ) {
        return n.element.name === lastActive.name;
      } ).length === 1 && lastActive;
    },

    elements: function() {
      var validator = this,
        rulesCache = {};

      // Select all valid inputs inside the form (no submit or reset buttons)
      return $( this.currentForm )
      .find( "input, select, textarea, [contenteditable]" )
      .not( ":submit, :reset, :image, :disabled" )
      .not( this.settings.ignore )
      .filter( function() {
        var name = this.name || $( this ).attr( "name" ); // For contenteditable
        if ( !name && validator.settings.debug && window.console ) {
          console.error( "%o has no name assigned", this );
        }

        // Set form expando on contenteditable
        if ( this.hasAttribute( "contenteditable" ) ) {
          this.form = $( this ).closest( "form" )[ 0 ];
          this.name = name;
        }

        // Select only the first element for each name, and only those with rules specified
        if ( name in rulesCache || !validator.objectLength( $( this ).rules() ) ) {
          return false;
        }

        rulesCache[ name ] = true;
        return true;
      } );
    },

    clean: function( selector ) {
      return $( selector )[ 0 ];
    },

    errors: function() {
      var errorClass = this.settings.errorClass.split( " " ).join( "." );
      return $( this.settings.errorElement + "." + errorClass, this.errorContext );
    },

    resetInternals: function() {
      this.successList = [];
      this.errorList = [];
      this.errorMap = {};
      this.toShow = $( [] );
      this.toHide = $( [] );
    },

    reset: function() {
      this.resetInternals();
      this.currentElements = $( [] );
    },

    prepareForm: function() {
      this.reset();
      this.toHide = this.errors().add( this.containers );
    },

    prepareElement: function( element ) {
      this.reset();
      this.toHide = this.errorsFor( element );
    },

    elementValue: function( element ) {
      var $element = $( element ),
        type = element.type,
        val, idx;

      if ( type === "radio" || type === "checkbox" ) {
        return this.findByName( element.name ).filter( ":checked" ).val();
      } else if ( type === "number" && typeof element.validity !== "undefined" ) {
        return element.validity.badInput ? "NaN" : $element.val();
      }

      if ( element.hasAttribute( "contenteditable" ) ) {
        val = $element.text();
      } else {
        val = $element.val();
      }

      if ( type === "file" ) {

        // Modern browser (chrome & safari)
        if ( val.substr( 0, 12 ) === "C:\\fakepath\\" ) {
          return val.substr( 12 );
        }

        // Legacy browsers
        // Unix-based path
        idx = val.lastIndexOf( "/" );
        if ( idx >= 0 ) {
          return val.substr( idx + 1 );
        }

        // Windows-based path
        idx = val.lastIndexOf( "\\" );
        if ( idx >= 0 ) {
          return val.substr( idx + 1 );
        }

        // Just the file name
        return val;
      }

      if ( typeof val === "string" ) {
        return val.replace( /\r/g, "" );
      }
      return val;
    },

    check: function( element ) {
      element = this.validationTargetFor( this.clean( element ) );

      var rules = $( element ).rules(),
        rulesCount = $.map( rules, function( n, i ) {
          return i;
        } ).length,
        dependencyMismatch = false,
        val = this.elementValue( element ),
        result, method, rule, normalizer;

      // Prioritize the local normalizer defined for this element over the global one
      // if the former exists, otherwise user the global one in case it exists.
      if ( typeof rules.normalizer === "function" ) {
        normalizer = rules.normalizer;
      } else if ( typeof this.settings.normalizer === "function" ) {
        normalizer = this.settings.normalizer;
      }

      // If normalizer is defined, then call it to retreive the changed value instead
      // of using the real one.
      // Note that `this` in the normalizer is `element`.
      if ( normalizer ) {
        val = normalizer.call( element, val );

        if ( typeof val !== "string" ) {
          throw new TypeError( "The normalizer should return a string value." );
        }

        // Delete the normalizer from rules to avoid treating it as a pre-defined method.
        delete rules.normalizer;
      }

      for ( method in rules ) {
        rule = { method: method, parameters: rules[ method ] };
        try {
          result = $.validator.methods[ method ].call( this, val, element, rule.parameters );

          // If a method indicates that the field is optional and therefore valid,
          // don't mark it as valid when there are no other rules
          if ( result === "dependency-mismatch" && rulesCount === 1 ) {
            dependencyMismatch = true;
            continue;
          }
          dependencyMismatch = false;

          if ( result === "pending" ) {
            this.toHide = this.toHide.not( this.errorsFor( element ) );
            return;
          }

          if ( !result ) {
            this.formatAndAdd( element, rule );
            return false;
          }
        } catch ( e ) {
          if ( this.settings.debug && window.console ) {
            console.log( "Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.", e );
          }
          if ( e instanceof TypeError ) {
            e.message += ".  Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.";
          }

          throw e;
        }
      }
      if ( dependencyMismatch ) {
        return;
      }
      if ( this.objectLength( rules ) ) {
        this.successList.push( element );
      }
      return true;
    },

    // Return the custom message for the given element and validation method
    // specified in the element's HTML5 data attribute
    // return the generic message if present and no method specific message is present
    customDataMessage: function( element, method ) {
      return $( element ).data( "msg" + method.charAt( 0 ).toUpperCase() +
        method.substring( 1 ).toLowerCase() ) || $( element ).data( "msg" );
    },

    // Return the custom message for the given element name and validation method
    customMessage: function( name, method ) {
      var m = this.settings.messages[ name ];
      return m && ( m.constructor === String ? m : m[ method ] );
    },

    // Return the first defined argument, allowing empty strings
    findDefined: function() {
      for ( var i = 0; i < arguments.length; i++ ) {
        if ( arguments[ i ] !== undefined ) {
          return arguments[ i ];
        }
      }
      return undefined;
    },

    // The second parameter 'rule' used to be a string, and extended to an object literal
    // of the following form:
    // rule = {
    //     method: "method name",
    //     parameters: "the given method parameters"
    // }
    //
    // The old behavior still supported, kept to maintain backward compatibility with
    // old code, and will be removed in the next major release.
    defaultMessage: function( element, rule ) {
      if ( typeof rule === "string" ) {
        rule = { method: rule };
      }

      var message = this.findDefined(
          this.customMessage( element.name, rule.method ),
          this.customDataMessage( element, rule.method ),

          // 'title' is never undefined, so handle empty string as undefined
          !this.settings.ignoreTitle && element.title || undefined,
          $.validator.messages[ rule.method ],
          "<strong>Warning: No message defined for " + element.name + "</strong>"
        ),
        theregex = /\$?\{(\d+)\}/g;
      if ( typeof message === "function" ) {
        message = message.call( this, rule.parameters, element );
      } else if ( theregex.test( message ) ) {
        message = $.validator.format( message.replace( theregex, "{$1}" ), rule.parameters );
      }

      return message;
    },

    formatAndAdd: function( element, rule ) {
      var message = this.defaultMessage( element, rule );

      this.errorList.push( {
        message: message,
        element: element,
        method: rule.method
      } );

      this.errorMap[ element.name ] = message;
      this.submitted[ element.name ] = message;
    },

    addWrapper: function( toToggle ) {
      if ( this.settings.wrapper ) {
        toToggle = toToggle.add( toToggle.parent( this.settings.wrapper ) );
      }
      return toToggle;
    },

    defaultShowErrors: function() {
      var i, elements, error;
      for ( i = 0; this.errorList[ i ]; i++ ) {
        error = this.errorList[ i ];
        if ( this.settings.highlight ) {
          this.settings.highlight.call( this, error.element, this.settings.errorClass, this.settings.validClass );
        }
        this.showLabel( error.element, error.message );
      }
      if ( this.errorList.length ) {
        this.toShow = this.toShow.add( this.containers );
      }
      if ( this.settings.success ) {
        for ( i = 0; this.successList[ i ]; i++ ) {
          this.showLabel( this.successList[ i ] );
        }
      }
      if ( this.settings.unhighlight ) {
        for ( i = 0, elements = this.validElements(); elements[ i ]; i++ ) {
          this.settings.unhighlight.call( this, elements[ i ], this.settings.errorClass, this.settings.validClass );
        }
      }
      this.toHide = this.toHide.not( this.toShow );
      this.hideErrors();
      this.addWrapper( this.toShow ).show();
    },

    validElements: function() {
      return this.currentElements.not( this.invalidElements() );
    },

    invalidElements: function() {
      return $( this.errorList ).map( function() {
        return this.element;
      } );
    },

    showLabel: function( element, message ) {
      var place, group, errorID, v,
        error = this.errorsFor( element ),
        elementID = this.idOrName( element ),
        describedBy = $( element ).attr( "aria-describedby" );

      if ( error.length ) {

        // Refresh error/success class
        error.removeClass( this.settings.validClass ).addClass( this.settings.errorClass );

        // Replace message on existing label
        error.html( message );
      } else {

        // Create error element
        error = $( "<" + this.settings.errorElement + ">" )
          .attr( "id", elementID + "-error" )
          .addClass( this.settings.errorClass )
          .html( message || "" );

        // Maintain reference to the element to be placed into the DOM
        place = error;
        if ( this.settings.wrapper ) {

          // Make sure the element is visible, even in IE
          // actually showing the wrapped element is handled elsewhere
          place = error.hide().show().wrap( "<" + this.settings.wrapper + "/>" ).parent();
        }
        if ( this.labelContainer.length ) {
          this.labelContainer.append( place );
        } else if ( this.settings.errorPlacement ) {
          this.settings.errorPlacement.call( this, place, $( element ) );
        } else {
          place.insertAfter( element );
        }

        // Link error back to the element
        if ( error.is( "label" ) ) {

          // If the error is a label, then associate using 'for'
          error.attr( "for", elementID );

          // If the element is not a child of an associated label, then it's necessary
          // to explicitly apply aria-describedby
        } else if ( error.parents( "label[for='" + this.escapeCssMeta( elementID ) + "']" ).length === 0 ) {
          errorID = error.attr( "id" );

          // Respect existing non-error aria-describedby
          if ( !describedBy ) {
            describedBy = errorID;
          } else if ( !describedBy.match( new RegExp( "\\b" + this.escapeCssMeta( errorID ) + "\\b" ) ) ) {

            // Add to end of list if not already present
            describedBy += " " + errorID;
          }
          $( element ).attr( "aria-describedby", describedBy );

          // If this element is grouped, then assign to all elements in the same group
          group = this.groups[ element.name ];
          if ( group ) {
            v = this;
            $.each( v.groups, function( name, testgroup ) {
              if ( testgroup === group ) {
                $( "[name='" + v.escapeCssMeta( name ) + "']", v.currentForm )
                  .attr( "aria-describedby", error.attr( "id" ) );
              }
            } );
          }
        }
      }
      if ( !message && this.settings.success ) {
        error.text( "" );
        if ( typeof this.settings.success === "string" ) {
          error.addClass( this.settings.success );
        } else {
          this.settings.success( error, element );
        }
      }
      this.toShow = this.toShow.add( error );
    },

    errorsFor: function( element ) {
      var name = this.escapeCssMeta( this.idOrName( element ) ),
        describer = $( element ).attr( "aria-describedby" ),
        selector = "label[for='" + name + "'], label[for='" + name + "'] *";

      // 'aria-describedby' should directly reference the error element
      if ( describer ) {
        selector = selector + ", #" + this.escapeCssMeta( describer )
          .replace( /\s+/g, ", #" );
      }

      return this
        .errors()
        .filter( selector );
    },

    // See https://api.jquery.com/category/selectors/, for CSS
    // meta-characters that should be escaped in order to be used with JQuery
    // as a literal part of a name/id or any selector.
    escapeCssMeta: function( string ) {
      return string.replace( /([\\!"#$%&'()*+,./:;<=>?@\[\]^`{|}~])/g, "\\$1" );
    },

    idOrName: function( element ) {
      return this.groups[ element.name ] || ( this.checkable( element ) ? element.name : element.id || element.name );
    },

    validationTargetFor: function( element ) {

      // If radio/checkbox, validate first element in group instead
      if ( this.checkable( element ) ) {
        element = this.findByName( element.name );
      }

      // Always apply ignore filter
      return $( element ).not( this.settings.ignore )[ 0 ];
    },

    checkable: function( element ) {
      return ( /radio|checkbox/i ).test( element.type );
    },

    findByName: function( name ) {
      return $( this.currentForm ).find( "[name='" + this.escapeCssMeta( name ) + "']" );
    },

    getLength: function( value, element ) {
      switch ( element.nodeName.toLowerCase() ) {
      case "select":
        return $( "option:selected", element ).length;
      case "input":
        if ( this.checkable( element ) ) {
          return this.findByName( element.name ).filter( ":checked" ).length;
        }
      }
      return value.length;
    },

    depend: function( param, element ) {
      return this.dependTypes[ typeof param ] ? this.dependTypes[ typeof param ]( param, element ) : true;
    },

    dependTypes: {
      "boolean": function( param ) {
        return param;
      },
      "string": function( param, element ) {
        return !!$( param, element.form ).length;
      },
      "function": function( param, element ) {
        return param( element );
      }
    },

    optional: function( element ) {
      var val = this.elementValue( element );
      return !$.validator.methods.required.call( this, val, element ) && "dependency-mismatch";
    },

    startRequest: function( element ) {
      if ( !this.pending[ element.name ] ) {
        this.pendingRequest++;
        $( element ).addClass( this.settings.pendingClass );
        this.pending[ element.name ] = true;
      }
    },

    stopRequest: function( element, valid ) {
      this.pendingRequest--;

      // Sometimes synchronization fails, make sure pendingRequest is never < 0
      if ( this.pendingRequest < 0 ) {
        this.pendingRequest = 0;
      }
      delete this.pending[ element.name ];
      $( element ).removeClass( this.settings.pendingClass );
      if ( valid && this.pendingRequest === 0 && this.formSubmitted && this.form() ) {
        $( this.currentForm ).submit();

        // Remove the hidden input that was used as a replacement for the
        // missing submit button. The hidden input is added by `handle()`
        // to ensure that the value of the used submit button is passed on
        // for scripted submits triggered by this method
        if ( this.submitButton ) {
          $( "input:hidden[name='" + this.submitButton.name + "']", this.currentForm ).remove();
        }

        this.formSubmitted = false;
      } else if ( !valid && this.pendingRequest === 0 && this.formSubmitted ) {
        $( this.currentForm ).triggerHandler( "invalid-form", [ this ] );
        this.formSubmitted = false;
      }
    },

    previousValue: function( element, method ) {
      method = typeof method === "string" && method || "remote";

      return $.data( element, "previousValue" ) || $.data( element, "previousValue", {
        old: null,
        valid: true,
        message: this.defaultMessage( element, { method: method } )
      } );
    },

    // Cleans up all forms and elements, removes validator-specific events
    destroy: function() {
      this.resetForm();

      $( this.currentForm )
        .off( ".validate" )
        .removeData( "validator" )
        .find( ".validate-equalTo-blur" )
          .off( ".validate-equalTo" )
          .removeClass( "validate-equalTo-blur" );
    }

  },

  classRuleSettings: {
    required: { required: true },
    email: { email: true },
    url: { url: true },
    date: { date: true },
    dateISO: { dateISO: true },
    number: { number: true },
    digits: { digits: true },
    creditcard: { creditcard: true }
  },

  addClassRules: function( className, rules ) {
    if ( className.constructor === String ) {
      this.classRuleSettings[ className ] = rules;
    } else {
      $.extend( this.classRuleSettings, className );
    }
  },

  classRules: function( element ) {
    var rules = {},
      classes = $( element ).attr( "class" );

    if ( classes ) {
      $.each( classes.split( " " ), function() {
        if ( this in $.validator.classRuleSettings ) {
          $.extend( rules, $.validator.classRuleSettings[ this ] );
        }
      } );
    }
    return rules;
  },

  normalizeAttributeRule: function( rules, type, method, value ) {

    // Convert the value to a number for number inputs, and for text for backwards compability
    // allows type="date" and others to be compared as strings
    if ( /min|max|step/.test( method ) && ( type === null || /number|range|text/.test( type ) ) ) {
      value = Number( value );

      // Support Opera Mini, which returns NaN for undefined minlength
      if ( isNaN( value ) ) {
        value = undefined;
      }
    }

    if ( value || value === 0 ) {
      rules[ method ] = value;
    } else if ( type === method && type !== "range" ) {

      // Exception: the jquery validate 'range' method
      // does not test for the html5 'range' type
      rules[ method ] = true;
    }
  },

  attributeRules: function( element ) {
    var rules = {},
      $element = $( element ),
      type = element.getAttribute( "type" ),
      method, value;

    for ( method in $.validator.methods ) {

      // Support for <input required> in both html5 and older browsers
      if ( method === "required" ) {
        value = element.getAttribute( method );

        // Some browsers return an empty string for the required attribute
        // and non-HTML5 browsers might have required="" markup
        if ( value === "" ) {
          value = true;
        }

        // Force non-HTML5 browsers to return bool
        value = !!value;
      } else {
        value = $element.attr( method );
      }

      this.normalizeAttributeRule( rules, type, method, value );
    }

    // 'maxlength' may be returned as -1, 2147483647 ( IE ) and 524288 ( safari ) for text inputs
    if ( rules.maxlength && /-1|2147483647|524288/.test( rules.maxlength ) ) {
      delete rules.maxlength;
    }

    return rules;
  },

  dataRules: function( element ) {
    var rules = {},
      $element = $( element ),
      type = element.getAttribute( "type" ),
      method, value;

    for ( method in $.validator.methods ) {
      value = $element.data( "rule" + method.charAt( 0 ).toUpperCase() + method.substring( 1 ).toLowerCase() );
      this.normalizeAttributeRule( rules, type, method, value );
    }
    return rules;
  },

  staticRules: function( element ) {
    var rules = {},
      validator = $.data( element.form, "validator" );

    if ( validator.settings.rules ) {
      rules = $.validator.normalizeRule( validator.settings.rules[ element.name ] ) || {};
    }
    return rules;
  },

  normalizeRules: function( rules, element ) {

    // Handle dependency check
    $.each( rules, function( prop, val ) {

      // Ignore rule when param is explicitly false, eg. required:false
      if ( val === false ) {
        delete rules[ prop ];
        return;
      }
      if ( val.param || val.depends ) {
        var keepRule = true;
        switch ( typeof val.depends ) {
        case "string":
          keepRule = !!$( val.depends, element.form ).length;
          break;
        case "function":
          keepRule = val.depends.call( element, element );
          break;
        }
        if ( keepRule ) {
          rules[ prop ] = val.param !== undefined ? val.param : true;
        } else {
          $.data( element.form, "validator" ).resetElements( $( element ) );
          delete rules[ prop ];
        }
      }
    } );

    // Evaluate parameters
    $.each( rules, function( rule, parameter ) {
      rules[ rule ] = $.isFunction( parameter ) && rule !== "normalizer" ? parameter( element ) : parameter;
    } );

    // Clean number parameters
    $.each( [ "minlength", "maxlength" ], function() {
      if ( rules[ this ] ) {
        rules[ this ] = Number( rules[ this ] );
      }
    } );
    $.each( [ "rangelength", "range" ], function() {
      var parts;
      if ( rules[ this ] ) {
        if ( $.isArray( rules[ this ] ) ) {
          rules[ this ] = [ Number( rules[ this ][ 0 ] ), Number( rules[ this ][ 1 ] ) ];
        } else if ( typeof rules[ this ] === "string" ) {
          parts = rules[ this ].replace( /[\[\]]/g, "" ).split( /[\s,]+/ );
          rules[ this ] = [ Number( parts[ 0 ] ), Number( parts[ 1 ] ) ];
        }
      }
    } );

    if ( $.validator.autoCreateRanges ) {

      // Auto-create ranges
      if ( rules.min != null && rules.max != null ) {
        rules.range = [ rules.min, rules.max ];
        delete rules.min;
        delete rules.max;
      }
      if ( rules.minlength != null && rules.maxlength != null ) {
        rules.rangelength = [ rules.minlength, rules.maxlength ];
        delete rules.minlength;
        delete rules.maxlength;
      }
    }

    return rules;
  },

  // Converts a simple string to a {string: true} rule, e.g., "required" to {required:true}
  normalizeRule: function( data ) {
    if ( typeof data === "string" ) {
      var transformed = {};
      $.each( data.split( /\s/ ), function() {
        transformed[ this ] = true;
      } );
      data = transformed;
    }
    return data;
  },

  // https://jqueryvalidation.org/jQuery.validator.addMethod/
  addMethod: function( name, method, message ) {
    $.validator.methods[ name ] = method;
    $.validator.messages[ name ] = message !== undefined ? message : $.validator.messages[ name ];
    if ( method.length < 3 ) {
      $.validator.addClassRules( name, $.validator.normalizeRule( name ) );
    }
  },

  // https://jqueryvalidation.org/jQuery.validator.methods/
  methods: {

    // https://jqueryvalidation.org/required-method/
    required: function( value, element, param ) {

      // Check if dependency is met
      if ( !this.depend( param, element ) ) {
        return "dependency-mismatch";
      }
      if ( element.nodeName.toLowerCase() === "select" ) {

        // Could be an array for select-multiple or a string, both are fine this way
        var val = $( element ).val();
        return val && val.length > 0;
      }
      if ( this.checkable( element ) ) {
        return this.getLength( value, element ) > 0;
      }
      return value.length > 0;
    },

    // https://jqueryvalidation.org/email-method/
    email: function( value, element ) {

      // From https://html.spec.whatwg.org/multipage/forms.html#valid-e-mail-address
      // Retrieved 2014-01-14
      // If you have a problem with this implementation, report a bug against the above spec
      // Or use custom methods to implement your own email validation
      return this.optional( element ) || /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test( value );
    },

    // https://jqueryvalidation.org/url-method/
    url: function( value, element ) {

      // Copyright (c) 2010-2013 Diego Perini, MIT licensed
      // https://gist.github.com/dperini/729294
      // see also https://mathiasbynens.be/demo/url-regex
      // modified to allow protocol-relative URLs
      return this.optional( element ) || /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test( value );
    },

    // https://jqueryvalidation.org/date-method/
    date: function( value, element ) {
      return this.optional( element ) || !/Invalid|NaN/.test( new Date( value ).toString() );
    },

    // https://jqueryvalidation.org/dateISO-method/
    dateISO: function( value, element ) {
      return this.optional( element ) || /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test( value );
    },

    // https://jqueryvalidation.org/number-method/
    number: function( value, element ) {
      return this.optional( element ) || /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test( value );
    },

    // https://jqueryvalidation.org/digits-method/
    digits: function( value, element ) {
      return this.optional( element ) || /^\d+$/.test( value );
    },

    // https://jqueryvalidation.org/minlength-method/
    minlength: function( value, element, param ) {
      var length = $.isArray( value ) ? value.length : this.getLength( value, element );
      return this.optional( element ) || length >= param;
    },

    // https://jqueryvalidation.org/maxlength-method/
    maxlength: function( value, element, param ) {
      var length = $.isArray( value ) ? value.length : this.getLength( value, element );
      return this.optional( element ) || length <= param;
    },

    // https://jqueryvalidation.org/rangelength-method/
    rangelength: function( value, element, param ) {
      var length = $.isArray( value ) ? value.length : this.getLength( value, element );
      return this.optional( element ) || ( length >= param[ 0 ] && length <= param[ 1 ] );
    },

    // https://jqueryvalidation.org/min-method/
    min: function( value, element, param ) {
      return this.optional( element ) || value >= param;
    },

    // https://jqueryvalidation.org/max-method/
    max: function( value, element, param ) {
      return this.optional( element ) || value <= param;
    },

    // https://jqueryvalidation.org/range-method/
    range: function( value, element, param ) {
      return this.optional( element ) || ( value >= param[ 0 ] && value <= param[ 1 ] );
    },

    // https://jqueryvalidation.org/step-method/
    step: function( value, element, param ) {
      var type = $( element ).attr( "type" ),
        errorMessage = "Step attribute on input type " + type + " is not supported.",
        supportedTypes = [ "text", "number", "range" ],
        re = new RegExp( "\\b" + type + "\\b" ),
        notSupported = type && !re.test( supportedTypes.join() ),
        decimalPlaces = function( num ) {
          var match = ( "" + num ).match( /(?:\.(\d+))?$/ );
          if ( !match ) {
            return 0;
          }

          // Number of digits right of decimal point.
          return match[ 1 ] ? match[ 1 ].length : 0;
        },
        toInt = function( num ) {
          return Math.round( num * Math.pow( 10, decimals ) );
        },
        valid = true,
        decimals;

      // Works only for text, number and range input types
      // TODO find a way to support input types date, datetime, datetime-local, month, time and week
      if ( notSupported ) {
        throw new Error( errorMessage );
      }

      decimals = decimalPlaces( param );

      // Value can't have too many decimals
      if ( decimalPlaces( value ) > decimals || toInt( value ) % toInt( param ) !== 0 ) {
        valid = false;
      }

      return this.optional( element ) || valid;
    },

    // https://jqueryvalidation.org/equalTo-method/
    equalTo: function( value, element, param ) {

      // Bind to the blur event of the target in order to revalidate whenever the target field is updated
      var target = $( param );
      if ( this.settings.onfocusout && target.not( ".validate-equalTo-blur" ).length ) {
        target.addClass( "validate-equalTo-blur" ).on( "blur.validate-equalTo", function() {
          $( element ).valid();
        } );
      }
      return value === target.val();
    },

    // https://jqueryvalidation.org/remote-method/
    remote: function( value, element, param, method ) {
      if ( this.optional( element ) ) {
        return "dependency-mismatch";
      }

      method = typeof method === "string" && method || "remote";

      var previous = this.previousValue( element, method ),
        validator, data, optionDataString;

      if ( !this.settings.messages[ element.name ] ) {
        this.settings.messages[ element.name ] = {};
      }
      previous.originalMessage = previous.originalMessage || this.settings.messages[ element.name ][ method ];
      this.settings.messages[ element.name ][ method ] = previous.message;

      param = typeof param === "string" && { url: param } || param;
      optionDataString = $.param( $.extend( { data: value }, param.data ) );
      if ( previous.old === optionDataString ) {
        return previous.valid;
      }

      previous.old = optionDataString;
      validator = this;
      this.startRequest( element );
      data = {};
      data[ element.name ] = value;
      $.ajax( $.extend( true, {
        mode: "abort",
        port: "validate" + element.name,
        dataType: "json",
        data: data,
        context: validator.currentForm,
        success: function( response ) {
          var valid = response === true || response === "true",
            errors, message, submitted;

          validator.settings.messages[ element.name ][ method ] = previous.originalMessage;
          if ( valid ) {
            submitted = validator.formSubmitted;
            validator.resetInternals();
            validator.toHide = validator.errorsFor( element );
            validator.formSubmitted = submitted;
            validator.successList.push( element );
            validator.invalid[ element.name ] = false;
            validator.showErrors();
          } else {
            errors = {};
            message = response || validator.defaultMessage( element, { method: method, parameters: value } );
            errors[ element.name ] = previous.message = message;
            validator.invalid[ element.name ] = true;
            validator.showErrors( errors );
          }
          previous.valid = valid;
          validator.stopRequest( element, valid );
        }
      }, param ) );
      return "pending";
    }
  }

} );

// Ajax mode: abort
// usage: $.ajax({ mode: "abort"[, port: "uniqueport"]});
// if mode:"abort" is used, the previous request on that port (port can be undefined) is aborted via XMLHttpRequest.abort()

var pendingRequests = {},
  ajax;

// Use a prefilter if available (1.5+)
if ( $.ajaxPrefilter ) {
  $.ajaxPrefilter( function( settings, _, xhr ) {
    var port = settings.port;
    if ( settings.mode === "abort" ) {
      if ( pendingRequests[ port ] ) {
        pendingRequests[ port ].abort();
      }
      pendingRequests[ port ] = xhr;
    }
  } );
} else {

  // Proxy ajax
  ajax = $.ajax;
  $.ajax = function( settings ) {
    var mode = ( "mode" in settings ? settings : $.ajaxSettings ).mode,
      port = ( "port" in settings ? settings : $.ajaxSettings ).port;
    if ( mode === "abort" ) {
      if ( pendingRequests[ port ] ) {
        pendingRequests[ port ].abort();
      }
      pendingRequests[ port ] = ajax.apply( this, arguments );
      return pendingRequests[ port ];
    }
    return ajax.apply( this, arguments );
  };
}
return $;
}));
/*!
 * jQuery Validation Plugin v1.17.0
 *
 * https://jqueryvalidation.org/
 *
 * Copyright (c) 2017 Jörn Zaefferer
 * Released under the MIT license
 */

(function( factory ) {
  if ( typeof define === "function" && define.amd ) {
    define( ["jquery", "./jquery.validate"], factory );
  } else if (typeof module === "object" && module.exports) {
    module.exports = factory( require( "jquery" ) );
  } else {
    factory( jQuery );
  }
}(function( $ ) {

( function() {

  function stripHtml( value ) {

    // Remove html tags and space chars
    return value.replace( /<.[^<>]*?>/g, " " ).replace( /&nbsp;|&#160;/gi, " " )

    // Remove punctuation
    .replace( /[.(),;:!?%#$'\"_+=\/\-“”’]*/g, "" );
  }

  $.validator.addMethod( "maxWords", function( value, element, params ) {
    return this.optional( element ) || stripHtml( value ).match( /\b\w+\b/g ).length <= params;
  }, $.validator.format( "Please enter {0} words or less." ) );

  $.validator.addMethod( "minWords", function( value, element, params ) {
    return this.optional( element ) || stripHtml( value ).match( /\b\w+\b/g ).length >= params;
  }, $.validator.format( "Please enter at least {0} words." ) );

  $.validator.addMethod( "rangeWords", function( value, element, params ) {
    var valueStripped = stripHtml( value ),
      regex = /\b\w+\b/g;
    return this.optional( element ) || valueStripped.match( regex ).length >= params[ 0 ] && valueStripped.match( regex ).length <= params[ 1 ];
  }, $.validator.format( "Please enter between {0} and {1} words." ) );

}() );

// Accept a value from a file input based on a required mimetype
$.validator.addMethod( "accept", function( value, element, param ) {

  // Split mime on commas in case we have multiple types we can accept
  var typeParam = typeof param === "string" ? param.replace( /\s/g, "" ) : "image/*",
    optionalValue = this.optional( element ),
    i, file, regex;

  // Element is optional
  if ( optionalValue ) {
    return optionalValue;
  }

  if ( $( element ).attr( "type" ) === "file" ) {

    // Escape string to be used in the regex
    // see: https://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
    // Escape also "/*" as "/.*" as a wildcard
    typeParam = typeParam
        .replace( /[\-\[\]\/\{\}\(\)\+\?\.\\\^\$\|]/g, "\\$&" )
        .replace( /,/g, "|" )
        .replace( /\/\*/g, "/.*" );

    // Check if the element has a FileList before checking each file
    if ( element.files && element.files.length ) {
      regex = new RegExp( ".?(" + typeParam + ")$", "i" );
      for ( i = 0; i < element.files.length; i++ ) {
        file = element.files[ i ];

        // Grab the mimetype from the loaded file, verify it matches
        if ( !file.type.match( regex ) ) {
          return false;
        }
      }
    }
  }

  // Either return true because we've validated each file, or because the
  // browser does not support element.files and the FileList feature
  return true;
}, $.validator.format( "Please enter a value with a valid mimetype." ) );

$.validator.addMethod( "alphanumeric", function( value, element ) {
  return this.optional( element ) || /^\w+$/i.test( value );
}, "Letters, numbers, and underscores only please" );

/*
 * Dutch bank account numbers (not 'giro' numbers) have 9 digits
 * and pass the '11 check'.
 * We accept the notation with spaces, as that is common.
 * acceptable: 123456789 or 12 34 56 789
 */
$.validator.addMethod( "bankaccountNL", function( value, element ) {
  if ( this.optional( element ) ) {
    return true;
  }
  if ( !( /^[0-9]{9}|([0-9]{2} ){3}[0-9]{3}$/.test( value ) ) ) {
    return false;
  }

  // Now '11 check'
  var account = value.replace( / /g, "" ), // Remove spaces
    sum = 0,
    len = account.length,
    pos, factor, digit;
  for ( pos = 0; pos < len; pos++ ) {
    factor = len - pos;
    digit = account.substring( pos, pos + 1 );
    sum = sum + factor * digit;
  }
  return sum % 11 === 0;
}, "Please specify a valid bank account number" );

$.validator.addMethod( "bankorgiroaccountNL", function( value, element ) {
  return this.optional( element ) ||
      ( $.validator.methods.bankaccountNL.call( this, value, element ) ) ||
      ( $.validator.methods.giroaccountNL.call( this, value, element ) );
}, "Please specify a valid bank or giro account number" );

/**
 * BIC is the business identifier code (ISO 9362). This BIC check is not a guarantee for authenticity.
 *
 * BIC pattern: BBBBCCLLbbb (8 or 11 characters long; bbb is optional)
 *
 * Validation is case-insensitive. Please make sure to normalize input yourself.
 *
 * BIC definition in detail:
 * - First 4 characters - bank code (only letters)
 * - Next 2 characters - ISO 3166-1 alpha-2 country code (only letters)
 * - Next 2 characters - location code (letters and digits)
 *   a. shall not start with '0' or '1'
 *   b. second character must be a letter ('O' is not allowed) or digit ('0' for test (therefore not allowed), '1' denoting passive participant, '2' typically reverse-billing)
 * - Last 3 characters - branch code, optional (shall not start with 'X' except in case of 'XXX' for primary office) (letters and digits)
 */
$.validator.addMethod( "bic", function( value, element ) {
    return this.optional( element ) || /^([A-Z]{6}[A-Z2-9][A-NP-Z1-9])(X{3}|[A-WY-Z0-9][A-Z0-9]{2})?$/.test( value.toUpperCase() );
}, "Please specify a valid BIC code" );

/*
 * Código de identificación fiscal ( CIF ) is the tax identification code for Spanish legal entities
 * Further rules can be found in Spanish on http://es.wikipedia.org/wiki/C%C3%B3digo_de_identificaci%C3%B3n_fiscal
 *
 * Spanish CIF structure:
 *
 * [ T ][ P ][ P ][ N ][ N ][ N ][ N ][ N ][ C ]
 *
 * Where:
 *
 * T: 1 character. Kind of Organization Letter: [ABCDEFGHJKLMNPQRSUVW]
 * P: 2 characters. Province.
 * N: 5 characters. Secuencial Number within the province.
 * C: 1 character. Control Digit: [0-9A-J].
 *
 * [ T ]: Kind of Organizations. Possible values:
 *
 *   A. Corporations
 *   B. LLCs
 *   C. General partnerships
 *   D. Companies limited partnerships
 *   E. Communities of goods
 *   F. Cooperative Societies
 *   G. Associations
 *   H. Communities of homeowners in horizontal property regime
 *   J. Civil Societies
 *   K. Old format
 *   L. Old format
 *   M. Old format
 *   N. Nonresident entities
 *   P. Local authorities
 *   Q. Autonomous bodies, state or not, and the like, and congregations and religious institutions
 *   R. Congregations and religious institutions (since 2008 ORDER EHA/451/2008)
 *   S. Organs of State Administration and regions
 *   V. Agrarian Transformation
 *   W. Permanent establishments of non-resident in Spain
 *
 * [ C ]: Control Digit. It can be a number or a letter depending on T value:
 * [ T ]  -->  [ C ]
 * ------    ----------
 *   A         Number
 *   B         Number
 *   E         Number
 *   H         Number
 *   K         Letter
 *   P         Letter
 *   Q         Letter
 *   S         Letter
 *
 */
$.validator.addMethod( "cifES", function( value, element ) {
  "use strict";

  if ( this.optional( element ) ) {
    return true;
  }

  var cifRegEx = new RegExp( /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/gi );
  var letter  = value.substring( 0, 1 ), // [ T ]
    number  = value.substring( 1, 8 ), // [ P ][ P ][ N ][ N ][ N ][ N ][ N ]
    control = value.substring( 8, 9 ), // [ C ]
    all_sum = 0,
    even_sum = 0,
    odd_sum = 0,
    i, n,
    control_digit,
    control_letter;

  function isOdd( n ) {
    return n % 2 === 0;
  }

  // Quick format test
  if ( value.length !== 9 || !cifRegEx.test( value ) ) {
    return false;
  }

  for ( i = 0; i < number.length; i++ ) {
    n = parseInt( number[ i ], 10 );

    // Odd positions
    if ( isOdd( i ) ) {

      // Odd positions are multiplied first.
      n *= 2;

      // If the multiplication is bigger than 10 we need to adjust
      odd_sum += n < 10 ? n : n - 9;

    // Even positions
    // Just sum them
    } else {
      even_sum += n;
    }
  }

  all_sum = even_sum + odd_sum;
  control_digit = ( 10 - ( all_sum ).toString().substr( -1 ) ).toString();
  control_digit = parseInt( control_digit, 10 ) > 9 ? "0" : control_digit;
  control_letter = "JABCDEFGHI".substr( control_digit, 1 ).toString();

  // Control must be a digit
  if ( letter.match( /[ABEH]/ ) ) {
    return control === control_digit;

  // Control must be a letter
  } else if ( letter.match( /[KPQS]/ ) ) {
    return control === control_letter;
  }

  // Can be either
  return control === control_digit || control === control_letter;

}, "Please specify a valid CIF number." );

/*
 * Brazillian CPF number (Cadastrado de Pessoas Físicas) is the equivalent of a Brazilian tax registration number.
 * CPF numbers have 11 digits in total: 9 numbers followed by 2 check numbers that are being used for validation.
 */
$.validator.addMethod( "cpfBR", function( value ) {

  // Removing special characters from value
  value = value.replace( /([~!@#$%^&*()_+=`{}\[\]\-|\\:;'<>,.\/? ])+/g, "" );

  // Checking value to have 11 digits only
  if ( value.length !== 11 ) {
    return false;
  }

  var sum = 0,
    firstCN, secondCN, checkResult, i;

  firstCN = parseInt( value.substring( 9, 10 ), 10 );
  secondCN = parseInt( value.substring( 10, 11 ), 10 );

  checkResult = function( sum, cn ) {
    var result = ( sum * 10 ) % 11;
    if ( ( result === 10 ) || ( result === 11 ) ) {
      result = 0;
    }
    return ( result === cn );
  };

  // Checking for dump data
  if ( value === "" ||
    value === "00000000000" ||
    value === "11111111111" ||
    value === "22222222222" ||
    value === "33333333333" ||
    value === "44444444444" ||
    value === "55555555555" ||
    value === "66666666666" ||
    value === "77777777777" ||
    value === "88888888888" ||
    value === "99999999999"
  ) {
    return false;
  }

  // Step 1 - using first Check Number:
  for ( i = 1; i <= 9; i++ ) {
    sum = sum + parseInt( value.substring( i - 1, i ), 10 ) * ( 11 - i );
  }

  // If first Check Number (CN) is valid, move to Step 2 - using second Check Number:
  if ( checkResult( sum, firstCN ) ) {
    sum = 0;
    for ( i = 1; i <= 10; i++ ) {
      sum = sum + parseInt( value.substring( i - 1, i ), 10 ) * ( 12 - i );
    }
    return checkResult( sum, secondCN );
  }
  return false;

}, "Please specify a valid CPF number" );

// https://jqueryvalidation.org/creditcard-method/
// based on https://en.wikipedia.org/wiki/Luhn_algorithm
$.validator.addMethod( "creditcard", function( value, element ) {
  if ( this.optional( element ) ) {
    return "dependency-mismatch";
  }

  // Accept only spaces, digits and dashes
  if ( /[^0-9 \-]+/.test( value ) ) {
    return false;
  }

  var nCheck = 0,
    nDigit = 0,
    bEven = false,
    n, cDigit;

  value = value.replace( /\D/g, "" );

  // Basing min and max length on
  // https://developer.ean.com/general_info/Valid_Credit_Card_Types
  if ( value.length < 13 || value.length > 19 ) {
    return false;
  }

  for ( n = value.length - 1; n >= 0; n-- ) {
    cDigit = value.charAt( n );
    nDigit = parseInt( cDigit, 10 );
    if ( bEven ) {
      if ( ( nDigit *= 2 ) > 9 ) {
        nDigit -= 9;
      }
    }

    nCheck += nDigit;
    bEven = !bEven;
  }

  return ( nCheck % 10 ) === 0;
}, "Please enter a valid credit card number." );

/* NOTICE: Modified version of Castle.Components.Validator.CreditCardValidator
 * Redistributed under the the Apache License 2.0 at http://www.apache.org/licenses/LICENSE-2.0
 * Valid Types: mastercard, visa, amex, dinersclub, enroute, discover, jcb, unknown, all (overrides all other settings)
 */
$.validator.addMethod( "creditcardtypes", function( value, element, param ) {
  if ( /[^0-9\-]+/.test( value ) ) {
    return false;
  }

  value = value.replace( /\D/g, "" );

  var validTypes = 0x0000;

  if ( param.mastercard ) {
    validTypes |= 0x0001;
  }
  if ( param.visa ) {
    validTypes |= 0x0002;
  }
  if ( param.amex ) {
    validTypes |= 0x0004;
  }
  if ( param.dinersclub ) {
    validTypes |= 0x0008;
  }
  if ( param.enroute ) {
    validTypes |= 0x0010;
  }
  if ( param.discover ) {
    validTypes |= 0x0020;
  }
  if ( param.jcb ) {
    validTypes |= 0x0040;
  }
  if ( param.unknown ) {
    validTypes |= 0x0080;
  }
  if ( param.all ) {
    validTypes = 0x0001 | 0x0002 | 0x0004 | 0x0008 | 0x0010 | 0x0020 | 0x0040 | 0x0080;
  }
  if ( validTypes & 0x0001 && /^(5[12345])/.test( value ) ) { // Mastercard
    return value.length === 16;
  }
  if ( validTypes & 0x0002 && /^(4)/.test( value ) ) { // Visa
    return value.length === 16;
  }
  if ( validTypes & 0x0004 && /^(3[47])/.test( value ) ) { // Amex
    return value.length === 15;
  }
  if ( validTypes & 0x0008 && /^(3(0[012345]|[68]))/.test( value ) ) { // Dinersclub
    return value.length === 14;
  }
  if ( validTypes & 0x0010 && /^(2(014|149))/.test( value ) ) { // Enroute
    return value.length === 15;
  }
  if ( validTypes & 0x0020 && /^(6011)/.test( value ) ) { // Discover
    return value.length === 16;
  }
  if ( validTypes & 0x0040 && /^(3)/.test( value ) ) { // Jcb
    return value.length === 16;
  }
  if ( validTypes & 0x0040 && /^(2131|1800)/.test( value ) ) { // Jcb
    return value.length === 15;
  }
  if ( validTypes & 0x0080 ) { // Unknown
    return true;
  }
  return false;
}, "Please enter a valid credit card number." );

/**
 * Validates currencies with any given symbols by @jameslouiz
 * Symbols can be optional or required. Symbols required by default
 *
 * Usage examples:
 *  currency: ["£", false] - Use false for soft currency validation
 *  currency: ["$", false]
 *  currency: ["RM", false] - also works with text based symbols such as "RM" - Malaysia Ringgit etc
 *
 *  <input class="currencyInput" name="currencyInput">
 *
 * Soft symbol checking
 *  currencyInput: {
 *     currency: ["$", false]
 *  }
 *
 * Strict symbol checking (default)
 *  currencyInput: {
 *     currency: "$"
 *     //OR
 *     currency: ["$", true]
 *  }
 *
 * Multiple Symbols
 *  currencyInput: {
 *     currency: "$,£,¢"
 *  }
 */
$.validator.addMethod( "currency", function( value, element, param ) {
    var isParamString = typeof param === "string",
        symbol = isParamString ? param : param[ 0 ],
        soft = isParamString ? true : param[ 1 ],
        regex;

    symbol = symbol.replace( /,/g, "" );
    symbol = soft ? symbol + "]" : symbol + "]?";
    regex = "^[" + symbol + "([1-9]{1}[0-9]{0,2}(\\,[0-9]{3})*(\\.[0-9]{0,2})?|[1-9]{1}[0-9]{0,}(\\.[0-9]{0,2})?|0(\\.[0-9]{0,2})?|(\\.[0-9]{1,2})?)$";
    regex = new RegExp( regex );
    return this.optional( element ) || regex.test( value );

}, "Please specify a valid currency" );

$.validator.addMethod( "dateFA", function( value, element ) {
  return this.optional( element ) || /^[1-4]\d{3}\/((0?[1-6]\/((3[0-1])|([1-2][0-9])|(0?[1-9])))|((1[0-2]|(0?[7-9]))\/(30|([1-2][0-9])|(0?[1-9]))))$/.test( value );
}, $.validator.messages.date );

/**
 * Return true, if the value is a valid date, also making this formal check dd/mm/yyyy.
 *
 * @example $.validator.methods.date("01/01/1900")
 * @result true
 *
 * @example $.validator.methods.date("01/13/1990")
 * @result false
 *
 * @example $.validator.methods.date("01.01.1900")
 * @result false
 *
 * @example <input name="pippo" class="{dateITA:true}" />
 * @desc Declares an optional input element whose value must be a valid date.
 *
 * @name $.validator.methods.dateITA
 * @type Boolean
 * @cat Plugins/Validate/Methods
 */
$.validator.addMethod( "dateITA", function( value, element ) {
  var check = false,
    re = /^\d{1,2}\/\d{1,2}\/\d{4}$/,
    adata, gg, mm, aaaa, xdata;
  if ( re.test( value ) ) {
    adata = value.split( "/" );
    gg = parseInt( adata[ 0 ], 10 );
    mm = parseInt( adata[ 1 ], 10 );
    aaaa = parseInt( adata[ 2 ], 10 );
    xdata = new Date( Date.UTC( aaaa, mm - 1, gg, 12, 0, 0, 0 ) );
    if ( ( xdata.getUTCFullYear() === aaaa ) && ( xdata.getUTCMonth() === mm - 1 ) && ( xdata.getUTCDate() === gg ) ) {
      check = true;
    } else {
      check = false;
    }
  } else {
    check = false;
  }
  return this.optional( element ) || check;
}, $.validator.messages.date );

$.validator.addMethod( "dateNL", function( value, element ) {
  return this.optional( element ) || /^(0?[1-9]|[12]\d|3[01])[\.\/\-](0?[1-9]|1[012])[\.\/\-]([12]\d)?(\d\d)$/.test( value );
}, $.validator.messages.date );

// Older "accept" file extension method. Old docs: http://docs.jquery.com/Plugins/Validation/Methods/accept
$.validator.addMethod( "extension", function( value, element, param ) {
  param = typeof param === "string" ? param.replace( /,/g, "|" ) : "png|jpe?g|gif";
  return this.optional( element ) || value.match( new RegExp( "\\.(" + param + ")$", "i" ) );
}, $.validator.format( "Please enter a value with a valid extension." ) );

/**
 * Dutch giro account numbers (not bank numbers) have max 7 digits
 */
$.validator.addMethod( "giroaccountNL", function( value, element ) {
  return this.optional( element ) || /^[0-9]{1,7}$/.test( value );
}, "Please specify a valid giro account number" );

/**
 * IBAN is the international bank account number.
 * It has a country - specific format, that is checked here too
 *
 * Validation is case-insensitive. Please make sure to normalize input yourself.
 */
$.validator.addMethod( "iban", function( value, element ) {

  // Some quick simple tests to prevent needless work
  if ( this.optional( element ) ) {
    return true;
  }

  // Remove spaces and to upper case
  var iban = value.replace( / /g, "" ).toUpperCase(),
    ibancheckdigits = "",
    leadingZeroes = true,
    cRest = "",
    cOperator = "",
    countrycode, ibancheck, charAt, cChar, bbanpattern, bbancountrypatterns, ibanregexp, i, p;

  // Check for IBAN code length.
  // It contains:
  // country code ISO 3166-1 - two letters,
  // two check digits,
  // Basic Bank Account Number (BBAN) - up to 30 chars
  var minimalIBANlength = 5;
  if ( iban.length < minimalIBANlength ) {
    return false;
  }

  // Check the country code and find the country specific format
  countrycode = iban.substring( 0, 2 );
  bbancountrypatterns = {
    "AL": "\\d{8}[\\dA-Z]{16}",
    "AD": "\\d{8}[\\dA-Z]{12}",
    "AT": "\\d{16}",
    "AZ": "[\\dA-Z]{4}\\d{20}",
    "BE": "\\d{12}",
    "BH": "[A-Z]{4}[\\dA-Z]{14}",
    "BA": "\\d{16}",
    "BR": "\\d{23}[A-Z][\\dA-Z]",
    "BG": "[A-Z]{4}\\d{6}[\\dA-Z]{8}",
    "CR": "\\d{17}",
    "HR": "\\d{17}",
    "CY": "\\d{8}[\\dA-Z]{16}",
    "CZ": "\\d{20}",
    "DK": "\\d{14}",
    "DO": "[A-Z]{4}\\d{20}",
    "EE": "\\d{16}",
    "FO": "\\d{14}",
    "FI": "\\d{14}",
    "FR": "\\d{10}[\\dA-Z]{11}\\d{2}",
    "GE": "[\\dA-Z]{2}\\d{16}",
    "DE": "\\d{18}",
    "GI": "[A-Z]{4}[\\dA-Z]{15}",
    "GR": "\\d{7}[\\dA-Z]{16}",
    "GL": "\\d{14}",
    "GT": "[\\dA-Z]{4}[\\dA-Z]{20}",
    "HU": "\\d{24}",
    "IS": "\\d{22}",
    "IE": "[\\dA-Z]{4}\\d{14}",
    "IL": "\\d{19}",
    "IT": "[A-Z]\\d{10}[\\dA-Z]{12}",
    "KZ": "\\d{3}[\\dA-Z]{13}",
    "KW": "[A-Z]{4}[\\dA-Z]{22}",
    "LV": "[A-Z]{4}[\\dA-Z]{13}",
    "LB": "\\d{4}[\\dA-Z]{20}",
    "LI": "\\d{5}[\\dA-Z]{12}",
    "LT": "\\d{16}",
    "LU": "\\d{3}[\\dA-Z]{13}",
    "MK": "\\d{3}[\\dA-Z]{10}\\d{2}",
    "MT": "[A-Z]{4}\\d{5}[\\dA-Z]{18}",
    "MR": "\\d{23}",
    "MU": "[A-Z]{4}\\d{19}[A-Z]{3}",
    "MC": "\\d{10}[\\dA-Z]{11}\\d{2}",
    "MD": "[\\dA-Z]{2}\\d{18}",
    "ME": "\\d{18}",
    "NL": "[A-Z]{4}\\d{10}",
    "NO": "\\d{11}",
    "PK": "[\\dA-Z]{4}\\d{16}",
    "PS": "[\\dA-Z]{4}\\d{21}",
    "PL": "\\d{24}",
    "PT": "\\d{21}",
    "RO": "[A-Z]{4}[\\dA-Z]{16}",
    "SM": "[A-Z]\\d{10}[\\dA-Z]{12}",
    "SA": "\\d{2}[\\dA-Z]{18}",
    "RS": "\\d{18}",
    "SK": "\\d{20}",
    "SI": "\\d{15}",
    "ES": "\\d{20}",
    "SE": "\\d{20}",
    "CH": "\\d{5}[\\dA-Z]{12}",
    "TN": "\\d{20}",
    "TR": "\\d{5}[\\dA-Z]{17}",
    "AE": "\\d{3}\\d{16}",
    "GB": "[A-Z]{4}\\d{14}",
    "VG": "[\\dA-Z]{4}\\d{16}"
  };

  bbanpattern = bbancountrypatterns[ countrycode ];

  // As new countries will start using IBAN in the
  // future, we only check if the countrycode is known.
  // This prevents false negatives, while almost all
  // false positives introduced by this, will be caught
  // by the checksum validation below anyway.
  // Strict checking should return FALSE for unknown
  // countries.
  if ( typeof bbanpattern !== "undefined" ) {
    ibanregexp = new RegExp( "^[A-Z]{2}\\d{2}" + bbanpattern + "$", "" );
    if ( !( ibanregexp.test( iban ) ) ) {
      return false; // Invalid country specific format
    }
  }

  // Now check the checksum, first convert to digits
  ibancheck = iban.substring( 4, iban.length ) + iban.substring( 0, 4 );
  for ( i = 0; i < ibancheck.length; i++ ) {
    charAt = ibancheck.charAt( i );
    if ( charAt !== "0" ) {
      leadingZeroes = false;
    }
    if ( !leadingZeroes ) {
      ibancheckdigits += "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ".indexOf( charAt );
    }
  }

  // Calculate the result of: ibancheckdigits % 97
  for ( p = 0; p < ibancheckdigits.length; p++ ) {
    cChar = ibancheckdigits.charAt( p );
    cOperator = "" + cRest + "" + cChar;
    cRest = cOperator % 97;
  }
  return cRest === 1;
}, "Please specify a valid IBAN" );

$.validator.addMethod( "integer", function( value, element ) {
  return this.optional( element ) || /^-?\d+$/.test( value );
}, "A positive or negative non-decimal number please" );

$.validator.addMethod( "ipv4", function( value, element ) {
  return this.optional( element ) || /^(25[0-5]|2[0-4]\d|[01]?\d\d?)\.(25[0-5]|2[0-4]\d|[01]?\d\d?)\.(25[0-5]|2[0-4]\d|[01]?\d\d?)\.(25[0-5]|2[0-4]\d|[01]?\d\d?)$/i.test( value );
}, "Please enter a valid IP v4 address." );

$.validator.addMethod( "ipv6", function( value, element ) {
  return this.optional( element ) || /^((([0-9A-Fa-f]{1,4}:){7}[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){6}:[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){5}:([0-9A-Fa-f]{1,4}:)?[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){4}:([0-9A-Fa-f]{1,4}:){0,2}[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){3}:([0-9A-Fa-f]{1,4}:){0,3}[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){2}:([0-9A-Fa-f]{1,4}:){0,4}[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){6}((\b((25[0-5])|(1\d{2})|(2[0-4]\d)|(\d{1,2}))\b)\.){3}(\b((25[0-5])|(1\d{2})|(2[0-4]\d)|(\d{1,2}))\b))|(([0-9A-Fa-f]{1,4}:){0,5}:((\b((25[0-5])|(1\d{2})|(2[0-4]\d)|(\d{1,2}))\b)\.){3}(\b((25[0-5])|(1\d{2})|(2[0-4]\d)|(\d{1,2}))\b))|(::([0-9A-Fa-f]{1,4}:){0,5}((\b((25[0-5])|(1\d{2})|(2[0-4]\d)|(\d{1,2}))\b)\.){3}(\b((25[0-5])|(1\d{2})|(2[0-4]\d)|(\d{1,2}))\b))|([0-9A-Fa-f]{1,4}::([0-9A-Fa-f]{1,4}:){0,5}[0-9A-Fa-f]{1,4})|(::([0-9A-Fa-f]{1,4}:){0,6}[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){1,7}:))$/i.test( value );
}, "Please enter a valid IP v6 address." );

$.validator.addMethod( "lettersonly", function( value, element ) {
  return this.optional( element ) || /^[a-z]+$/i.test( value );
}, "Letters only please" );

$.validator.addMethod( "letterswithbasicpunc", function( value, element ) {
  return this.optional( element ) || /^[a-z\-.,()'"\s]+$/i.test( value );
}, "Letters or punctuation only please" );

$.validator.addMethod( "mobileNL", function( value, element ) {
  return this.optional( element ) || /^((\+|00(\s|\s?\-\s?)?)31(\s|\s?\-\s?)?(\(0\)[\-\s]?)?|0)6((\s|\s?\-\s?)?[0-9]){8}$/.test( value );
}, "Please specify a valid mobile number" );

/* For UK phone functions, do the following server side processing:
 * Compare original input with this RegEx pattern:
 * ^\(?(?:(?:00\)?[\s\-]?\(?|\+)(44)\)?[\s\-]?\(?(?:0\)?[\s\-]?\(?)?|0)([1-9]\d{1,4}\)?[\s\d\-]+)$
 * Extract $1 and set $prefix to '+44<space>' if $1 is '44', otherwise set $prefix to '0'
 * Extract $2 and remove hyphens, spaces and parentheses. Phone number is combined $prefix and $2.
 * A number of very detailed GB telephone number RegEx patterns can also be found at:
 * http://www.aa-asterisk.org.uk/index.php/Regular_Expressions_for_Validating_and_Formatting_GB_Telephone_Numbers
 */
$.validator.addMethod( "mobileUK", function( phone_number, element ) {
  phone_number = phone_number.replace( /\(|\)|\s+|-/g, "" );
  return this.optional( element ) || phone_number.length > 9 &&
    phone_number.match( /^(?:(?:(?:00\s?|\+)44\s?|0)7(?:[1345789]\d{2}|624)\s?\d{3}\s?\d{3})$/ );
}, "Please specify a valid mobile number" );

$.validator.addMethod( "netmask", function( value, element ) {
    return this.optional( element ) || /^(254|252|248|240|224|192|128)\.0\.0\.0|255\.(254|252|248|240|224|192|128|0)\.0\.0|255\.255\.(254|252|248|240|224|192|128|0)\.0|255\.255\.255\.(254|252|248|240|224|192|128|0)/i.test( value );
}, "Please enter a valid netmask." );

/*
 * The NIE (Número de Identificación de Extranjero) is a Spanish tax identification number assigned by the Spanish
 * authorities to any foreigner.
 *
 * The NIE is the equivalent of a Spaniards Número de Identificación Fiscal (NIF) which serves as a fiscal
 * identification number. The CIF number (Certificado de Identificación Fiscal) is equivalent to the NIF, but applies to
 * companies rather than individuals. The NIE consists of an 'X' or 'Y' followed by 7 or 8 digits then another letter.
 */
$.validator.addMethod( "nieES", function( value, element ) {
  "use strict";

  if ( this.optional( element ) ) {
    return true;
  }

  var nieRegEx = new RegExp( /^[MXYZ]{1}[0-9]{7,8}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/gi );
  var validChars = "TRWAGMYFPDXBNJZSQVHLCKET",
    letter = value.substr( value.length - 1 ).toUpperCase(),
    number;

  value = value.toString().toUpperCase();

  // Quick format test
  if ( value.length > 10 || value.length < 9 || !nieRegEx.test( value ) ) {
    return false;
  }

  // X means same number
  // Y means number + 10000000
  // Z means number + 20000000
  value = value.replace( /^[X]/, "0" )
    .replace( /^[Y]/, "1" )
    .replace( /^[Z]/, "2" );

  number = value.length === 9 ? value.substr( 0, 8 ) : value.substr( 0, 9 );

  return validChars.charAt( parseInt( number, 10 ) % 23 ) === letter;

}, "Please specify a valid NIE number." );

/*
 * The Número de Identificación Fiscal ( NIF ) is the way tax identification used in Spain for individuals
 */
$.validator.addMethod( "nifES", function( value, element ) {
  "use strict";

  if ( this.optional( element ) ) {
    return true;
  }

  value = value.toUpperCase();

  // Basic format test
  if ( !value.match( "((^[A-Z]{1}[0-9]{7}[A-Z0-9]{1}$|^[T]{1}[A-Z0-9]{8}$)|^[0-9]{8}[A-Z]{1}$)" ) ) {
    return false;
  }

  // Test NIF
  if ( /^[0-9]{8}[A-Z]{1}$/.test( value ) ) {
    return ( "TRWAGMYFPDXBNJZSQVHLCKE".charAt( value.substring( 8, 0 ) % 23 ) === value.charAt( 8 ) );
  }

  // Test specials NIF (starts with K, L or M)
  if ( /^[KLM]{1}/.test( value ) ) {
    return ( value[ 8 ] === "TRWAGMYFPDXBNJZSQVHLCKE".charAt( value.substring( 8, 1 ) % 23 ) );
  }

  return false;

}, "Please specify a valid NIF number." );

/*
 * Numer identyfikacji podatkowej ( NIP ) is the way tax identification used in Poland for companies
 */
$.validator.addMethod( "nipPL", function( value ) {
  "use strict";

  value = value.replace( /[^0-9]/g, "" );

  if ( value.length !== 10 ) {
    return false;
  }

  var arrSteps = [ 6, 5, 7, 2, 3, 4, 5, 6, 7 ];
  var intSum = 0;
  for ( var i = 0; i < 9; i++ ) {
    intSum += arrSteps[ i ] * value[ i ];
  }
  var int2 = intSum % 11;
  var intControlNr = ( int2 === 10 ) ? 0 : int2;

  return ( intControlNr === parseInt( value[ 9 ], 10 ) );
}, "Please specify a valid NIP number." );

$.validator.addMethod( "notEqualTo", function( value, element, param ) {
  return this.optional( element ) || !$.validator.methods.equalTo.call( this, value, element, param );
}, "Please enter a different value, values must not be the same." );

$.validator.addMethod( "nowhitespace", function( value, element ) {
  return this.optional( element ) || /^\S+$/i.test( value );
}, "No white space please" );

/**
* Return true if the field value matches the given format RegExp
*
* @example $.validator.methods.pattern("AR1004",element,/^AR\d{4}$/)
* @result true
*
* @example $.validator.methods.pattern("BR1004",element,/^AR\d{4}$/)
* @result false
*
* @name $.validator.methods.pattern
* @type Boolean
* @cat Plugins/Validate/Methods
*/
$.validator.addMethod( "pattern", function( value, element, param ) {
  if ( this.optional( element ) ) {
    return true;
  }
  if ( typeof param === "string" ) {
    param = new RegExp( "^(?:" + param + ")$" );
  }
  return param.test( value );
}, "Invalid format." );

/**
 * Dutch phone numbers have 10 digits (or 11 and start with +31).
 */
$.validator.addMethod( "phoneNL", function( value, element ) {
  return this.optional( element ) || /^((\+|00(\s|\s?\-\s?)?)31(\s|\s?\-\s?)?(\(0\)[\-\s]?)?|0)[1-9]((\s|\s?\-\s?)?[0-9]){8}$/.test( value );
}, "Please specify a valid phone number." );

/* For UK phone functions, do the following server side processing:
 * Compare original input with this RegEx pattern:
 * ^\(?(?:(?:00\)?[\s\-]?\(?|\+)(44)\)?[\s\-]?\(?(?:0\)?[\s\-]?\(?)?|0)([1-9]\d{1,4}\)?[\s\d\-]+)$
 * Extract $1 and set $prefix to '+44<space>' if $1 is '44', otherwise set $prefix to '0'
 * Extract $2 and remove hyphens, spaces and parentheses. Phone number is combined $prefix and $2.
 * A number of very detailed GB telephone number RegEx patterns can also be found at:
 * http://www.aa-asterisk.org.uk/index.php/Regular_Expressions_for_Validating_and_Formatting_GB_Telephone_Numbers
 */

// Matches UK landline + mobile, accepting only 01-3 for landline or 07 for mobile to exclude many premium numbers
$.validator.addMethod( "phonesUK", function( phone_number, element ) {
  phone_number = phone_number.replace( /\(|\)|\s+|-/g, "" );
  return this.optional( element ) || phone_number.length > 9 &&
    phone_number.match( /^(?:(?:(?:00\s?|\+)44\s?|0)(?:1\d{8,9}|[23]\d{9}|7(?:[1345789]\d{8}|624\d{6})))$/ );
}, "Please specify a valid uk phone number" );

/* For UK phone functions, do the following server side processing:
 * Compare original input with this RegEx pattern:
 * ^\(?(?:(?:00\)?[\s\-]?\(?|\+)(44)\)?[\s\-]?\(?(?:0\)?[\s\-]?\(?)?|0)([1-9]\d{1,4}\)?[\s\d\-]+)$
 * Extract $1 and set $prefix to '+44<space>' if $1 is '44', otherwise set $prefix to '0'
 * Extract $2 and remove hyphens, spaces and parentheses. Phone number is combined $prefix and $2.
 * A number of very detailed GB telephone number RegEx patterns can also be found at:
 * http://www.aa-asterisk.org.uk/index.php/Regular_Expressions_for_Validating_and_Formatting_GB_Telephone_Numbers
 */
$.validator.addMethod( "phoneUK", function( phone_number, element ) {
  phone_number = phone_number.replace( /\(|\)|\s+|-/g, "" );
  return this.optional( element ) || phone_number.length > 9 &&
    phone_number.match( /^(?:(?:(?:00\s?|\+)44\s?)|(?:\(?0))(?:\d{2}\)?\s?\d{4}\s?\d{4}|\d{3}\)?\s?\d{3}\s?\d{3,4}|\d{4}\)?\s?(?:\d{5}|\d{3}\s?\d{3})|\d{5}\)?\s?\d{4,5})$/ );
}, "Please specify a valid phone number" );

/**
 * Matches US phone number format
 *
 * where the area code may not start with 1 and the prefix may not start with 1
 * allows '-' or ' ' as a separator and allows parens around area code
 * some people may want to put a '1' in front of their number
 *
 * 1(212)-999-2345 or
 * 212 999 2344 or
 * 212-999-0983
 *
 * but not
 * 111-123-5434
 * and not
 * 212 123 4567
 */
$.validator.addMethod( "phoneUS", function( phone_number, element ) {
  phone_number = phone_number.replace( /\s+/g, "" );
  return this.optional( element ) || phone_number.length > 9 &&
    phone_number.match( /^(\+?1-?)?(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9]))-?[2-9]([02-9]\d|1[02-9])-?\d{4}$/ );
}, "Please specify a valid phone number" );

/*
* Valida CEPs do brasileiros:
*
* Formatos aceitos:
* 99999-999
* 99.999-999
* 99999999
*/
$.validator.addMethod( "postalcodeBR", function( cep_value, element ) {
  return this.optional( element ) || /^\d{2}.\d{3}-\d{3}?$|^\d{5}-?\d{3}?$/.test( cep_value );
}, "Informe um CEP válido." );

/**
 * Matches a valid Canadian Postal Code
 *
 * @example jQuery.validator.methods.postalCodeCA( "H0H 0H0", element )
 * @result true
 *
 * @example jQuery.validator.methods.postalCodeCA( "H0H0H0", element )
 * @result false
 *
 * @name jQuery.validator.methods.postalCodeCA
 * @type Boolean
 * @cat Plugins/Validate/Methods
 */
$.validator.addMethod( "postalCodeCA", function( value, element ) {
  return this.optional( element ) || /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ] *\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i.test( value );
}, "Please specify a valid postal code" );

/* Matches Italian postcode (CAP) */
$.validator.addMethod( "postalcodeIT", function( value, element ) {
  return this.optional( element ) || /^\d{5}$/.test( value );
}, "Please specify a valid postal code" );

$.validator.addMethod( "postalcodeNL", function( value, element ) {
  return this.optional( element ) || /^[1-9][0-9]{3}\s?[a-zA-Z]{2}$/.test( value );
}, "Please specify a valid postal code" );

// Matches UK postcode. Does not match to UK Channel Islands that have their own postcodes (non standard UK)
$.validator.addMethod( "postcodeUK", function( value, element ) {
  return this.optional( element ) || /^((([A-PR-UWYZ][0-9])|([A-PR-UWYZ][0-9][0-9])|([A-PR-UWYZ][A-HK-Y][0-9])|([A-PR-UWYZ][A-HK-Y][0-9][0-9])|([A-PR-UWYZ][0-9][A-HJKSTUW])|([A-PR-UWYZ][A-HK-Y][0-9][ABEHMNPRVWXY]))\s?([0-9][ABD-HJLNP-UW-Z]{2})|(GIR)\s?(0AA))$/i.test( value );
}, "Please specify a valid UK postcode" );

/*
 * Lets you say "at least X inputs that match selector Y must be filled."
 *
 * The end result is that neither of these inputs:
 *
 *  <input class="productinfo" name="partnumber">
 *  <input class="productinfo" name="description">
 *
 *  ...will validate unless at least one of them is filled.
 *
 * partnumber:  {require_from_group: [1,".productinfo"]},
 * description: {require_from_group: [1,".productinfo"]}
 *
 * options[0]: number of fields that must be filled in the group
 * options[1]: CSS selector that defines the group of conditionally required fields
 */
$.validator.addMethod( "require_from_group", function( value, element, options ) {
  var $fields = $( options[ 1 ], element.form ),
    $fieldsFirst = $fields.eq( 0 ),
    validator = $fieldsFirst.data( "valid_req_grp" ) ? $fieldsFirst.data( "valid_req_grp" ) : $.extend( {}, this ),
    isValid = $fields.filter( function() {
      return validator.elementValue( this );
    } ).length >= options[ 0 ];

  // Store the cloned validator for future validation
  $fieldsFirst.data( "valid_req_grp", validator );

  // If element isn't being validated, run each require_from_group field's validation rules
  if ( !$( element ).data( "being_validated" ) ) {
    $fields.data( "being_validated", true );
    $fields.each( function() {
      validator.element( this );
    } );
    $fields.data( "being_validated", false );
  }
  return isValid;
}, $.validator.format( "Please fill at least {0} of these fields." ) );

/*
 * Lets you say "either at least X inputs that match selector Y must be filled,
 * OR they must all be skipped (left blank)."
 *
 * The end result, is that none of these inputs:
 *
 *  <input class="productinfo" name="partnumber">
 *  <input class="productinfo" name="description">
 *  <input class="productinfo" name="color">
 *
 *  ...will validate unless either at least two of them are filled,
 *  OR none of them are.
 *
 * partnumber:  {skip_or_fill_minimum: [2,".productinfo"]},
 * description: {skip_or_fill_minimum: [2,".productinfo"]},
 * color:   {skip_or_fill_minimum: [2,".productinfo"]}
 *
 * options[0]: number of fields that must be filled in the group
 * options[1]: CSS selector that defines the group of conditionally required fields
 *
 */
$.validator.addMethod( "skip_or_fill_minimum", function( value, element, options ) {
  var $fields = $( options[ 1 ], element.form ),
    $fieldsFirst = $fields.eq( 0 ),
    validator = $fieldsFirst.data( "valid_skip" ) ? $fieldsFirst.data( "valid_skip" ) : $.extend( {}, this ),
    numberFilled = $fields.filter( function() {
      return validator.elementValue( this );
    } ).length,
    isValid = numberFilled === 0 || numberFilled >= options[ 0 ];

  // Store the cloned validator for future validation
  $fieldsFirst.data( "valid_skip", validator );

  // If element isn't being validated, run each skip_or_fill_minimum field's validation rules
  if ( !$( element ).data( "being_validated" ) ) {
    $fields.data( "being_validated", true );
    $fields.each( function() {
      validator.element( this );
    } );
    $fields.data( "being_validated", false );
  }
  return isValid;
}, $.validator.format( "Please either skip these fields or fill at least {0} of them." ) );

/* Validates US States and/or Territories by @jdforsythe
 * Can be case insensitive or require capitalization - default is case insensitive
 * Can include US Territories or not - default does not
 * Can include US Military postal abbreviations (AA, AE, AP) - default does not
 *
 * Note: "States" always includes DC (District of Colombia)
 *
 * Usage examples:
 *
 *  This is the default - case insensitive, no territories, no military zones
 *  stateInput: {
 *     caseSensitive: false,
 *     includeTerritories: false,
 *     includeMilitary: false
 *  }
 *
 *  Only allow capital letters, no territories, no military zones
 *  stateInput: {
 *     caseSensitive: false
 *  }
 *
 *  Case insensitive, include territories but not military zones
 *  stateInput: {
 *     includeTerritories: true
 *  }
 *
 *  Only allow capital letters, include territories and military zones
 *  stateInput: {
 *     caseSensitive: true,
 *     includeTerritories: true,
 *     includeMilitary: true
 *  }
 *
 */
$.validator.addMethod( "stateUS", function( value, element, options ) {
  var isDefault = typeof options === "undefined",
    caseSensitive = ( isDefault || typeof options.caseSensitive === "undefined" ) ? false : options.caseSensitive,
    includeTerritories = ( isDefault || typeof options.includeTerritories === "undefined" ) ? false : options.includeTerritories,
    includeMilitary = ( isDefault || typeof options.includeMilitary === "undefined" ) ? false : options.includeMilitary,
    regex;

  if ( !includeTerritories && !includeMilitary ) {
    regex = "^(A[KLRZ]|C[AOT]|D[CE]|FL|GA|HI|I[ADLN]|K[SY]|LA|M[ADEINOST]|N[CDEHJMVY]|O[HKR]|PA|RI|S[CD]|T[NX]|UT|V[AT]|W[AIVY])$";
  } else if ( includeTerritories && includeMilitary ) {
    regex = "^(A[AEKLPRSZ]|C[AOT]|D[CE]|FL|G[AU]|HI|I[ADLN]|K[SY]|LA|M[ADEINOPST]|N[CDEHJMVY]|O[HKR]|P[AR]|RI|S[CD]|T[NX]|UT|V[AIT]|W[AIVY])$";
  } else if ( includeTerritories ) {
    regex = "^(A[KLRSZ]|C[AOT]|D[CE]|FL|G[AU]|HI|I[ADLN]|K[SY]|LA|M[ADEINOPST]|N[CDEHJMVY]|O[HKR]|P[AR]|RI|S[CD]|T[NX]|UT|V[AIT]|W[AIVY])$";
  } else {
    regex = "^(A[AEKLPRZ]|C[AOT]|D[CE]|FL|GA|HI|I[ADLN]|K[SY]|LA|M[ADEINOST]|N[CDEHJMVY]|O[HKR]|PA|RI|S[CD]|T[NX]|UT|V[AT]|W[AIVY])$";
  }

  regex = caseSensitive ? new RegExp( regex ) : new RegExp( regex, "i" );
  return this.optional( element ) || regex.test( value );
}, "Please specify a valid state" );

// TODO check if value starts with <, otherwise don't try stripping anything
$.validator.addMethod( "strippedminlength", function( value, element, param ) {
  return $( value ).text().length >= param;
}, $.validator.format( "Please enter at least {0} characters" ) );

$.validator.addMethod( "time", function( value, element ) {
  return this.optional( element ) || /^([01]\d|2[0-3]|[0-9])(:[0-5]\d){1,2}$/.test( value );
}, "Please enter a valid time, between 00:00 and 23:59" );

$.validator.addMethod( "time12h", function( value, element ) {
  return this.optional( element ) || /^((0?[1-9]|1[012])(:[0-5]\d){1,2}(\ ?[AP]M))$/i.test( value );
}, "Please enter a valid time in 12-hour am/pm format" );

// Same as url, but TLD is optional
$.validator.addMethod( "url2", function( value, element ) {
  return this.optional( element ) || /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)*(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test( value );
}, $.validator.messages.url );

/**
 * Return true, if the value is a valid vehicle identification number (VIN).
 *
 * Works with all kind of text inputs.
 *
 * @example <input type="text" size="20" name="VehicleID" class="{required:true,vinUS:true}" />
 * @desc Declares a required input element whose value must be a valid vehicle identification number.
 *
 * @name $.validator.methods.vinUS
 * @type Boolean
 * @cat Plugins/Validate/Methods
 */
$.validator.addMethod( "vinUS", function( v ) {
  if ( v.length !== 17 ) {
    return false;
  }

  var LL = [ "A", "B", "C", "D", "E", "F", "G", "H", "J", "K", "L", "M", "N", "P", "R", "S", "T", "U", "V", "W", "X", "Y", "Z" ],
    VL = [ 1, 2, 3, 4, 5, 6, 7, 8, 1, 2, 3, 4, 5, 7, 9, 2, 3, 4, 5, 6, 7, 8, 9 ],
    FL = [ 8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2 ],
    rs = 0,
    i, n, d, f, cd, cdv;

  for ( i = 0; i < 17; i++ ) {
    f = FL[ i ];
    d = v.slice( i, i + 1 );
    if ( i === 8 ) {
      cdv = d;
    }
    if ( !isNaN( d ) ) {
      d *= f;
    } else {
      for ( n = 0; n < LL.length; n++ ) {
        if ( d.toUpperCase() === LL[ n ] ) {
          d = VL[ n ];
          d *= f;
          if ( isNaN( cdv ) && n === 8 ) {
            cdv = LL[ n ];
          }
          break;
        }
      }
    }
    rs += d;
  }
  cd = rs % 11;
  if ( cd === 10 ) {
    cd = "X";
  }
  if ( cd === cdv ) {
    return true;
  }
  return false;
}, "The specified vehicle identification number (VIN) is invalid." );

$.validator.addMethod( "zipcodeUS", function( value, element ) {
  return this.optional( element ) || /^\d{5}(-\d{4})?$/.test( value );
}, "The specified US ZIP Code is invalid" );

$.validator.addMethod( "ziprange", function( value, element ) {
  return this.optional( element ) || /^90[2-5]\d\{2\}-\d{4}$/.test( value );
}, "Your ZIP-code must be in the range 902xx-xxxx to 905xx-xxxx" );
return $;
}));
/*!
 * @fileOverview TouchSwipe - jQuery Plugin
 * @version 1.6.18
 *
 * @author Matt Bryson http://www.github.com/mattbryson
 * @see https://github.com/mattbryson/TouchSwipe-Jquery-Plugin
 * @see http://labs.rampinteractive.co.uk/touchSwipe/
 * @see http://plugins.jquery.com/project/touchSwipe
 * @license
 * Copyright (c) 2010-2015 Matt Bryson
 * Dual licensed under the MIT or GPL Version 2 licenses.
 *
 */

!function(factory){"function"==typeof define&&define.amd&&define.amd.jQuery?define(["jquery"],factory):factory("undefined"!=typeof module&&module.exports?require("jquery"):jQuery)}(function($){"use strict";function init(options){return!options||void 0!==options.allowPageScroll||void 0===options.swipe&&void 0===options.swipeStatus||(options.allowPageScroll=NONE),void 0!==options.click&&void 0===options.tap&&(options.tap=options.click),options||(options={}),options=$.extend({},$.fn.swipe.defaults,options),this.each(function(){var $this=$(this),plugin=$this.data(PLUGIN_NS);plugin||(plugin=new TouchSwipe(this,options),$this.data(PLUGIN_NS,plugin))})}function TouchSwipe(element,options){function touchStart(jqEvent){if(!(getTouchInProgress()||$(jqEvent.target).closest(options.excludedElements,$element).length>0)){var event=jqEvent.originalEvent?jqEvent.originalEvent:jqEvent;if(!event.pointerType||"mouse"!=event.pointerType||0!=options.fallbackToMouseEvents){var ret,touches=event.touches,evt=touches?touches[0]:event;return phase=PHASE_START,touches?fingerCount=touches.length:options.preventDefaultEvents!==!1&&jqEvent.preventDefault(),distance=0,direction=null,currentDirection=null,pinchDirection=null,duration=0,startTouchesDistance=0,endTouchesDistance=0,pinchZoom=1,pinchDistance=0,maximumsMap=createMaximumsData(),cancelMultiFingerRelease(),createFingerData(0,evt),!touches||fingerCount===options.fingers||options.fingers===ALL_FINGERS||hasPinches()?(startTime=getTimeStamp(),2==fingerCount&&(createFingerData(1,touches[1]),startTouchesDistance=endTouchesDistance=calculateTouchesDistance(fingerData[0].start,fingerData[1].start)),(options.swipeStatus||options.pinchStatus)&&(ret=triggerHandler(event,phase))):ret=!1,ret===!1?(phase=PHASE_CANCEL,triggerHandler(event,phase),ret):(options.hold&&(holdTimeout=setTimeout($.proxy(function(){$element.trigger("hold",[event.target]),options.hold&&(ret=options.hold.call($element,event,event.target))},this),options.longTapThreshold)),setTouchInProgress(!0),null)}}}function touchMove(jqEvent){var event=jqEvent.originalEvent?jqEvent.originalEvent:jqEvent;if(phase!==PHASE_END&&phase!==PHASE_CANCEL&&!inMultiFingerRelease()){var ret,touches=event.touches,evt=touches?touches[0]:event,currentFinger=updateFingerData(evt);if(endTime=getTimeStamp(),touches&&(fingerCount=touches.length),options.hold&&clearTimeout(holdTimeout),phase=PHASE_MOVE,2==fingerCount&&(0==startTouchesDistance?(createFingerData(1,touches[1]),startTouchesDistance=endTouchesDistance=calculateTouchesDistance(fingerData[0].start,fingerData[1].start)):(updateFingerData(touches[1]),endTouchesDistance=calculateTouchesDistance(fingerData[0].end,fingerData[1].end),pinchDirection=calculatePinchDirection(fingerData[0].end,fingerData[1].end)),pinchZoom=calculatePinchZoom(startTouchesDistance,endTouchesDistance),pinchDistance=Math.abs(startTouchesDistance-endTouchesDistance)),fingerCount===options.fingers||options.fingers===ALL_FINGERS||!touches||hasPinches()){if(direction=calculateDirection(currentFinger.start,currentFinger.end),currentDirection=calculateDirection(currentFinger.last,currentFinger.end),validateDefaultEvent(jqEvent,currentDirection),distance=calculateDistance(currentFinger.start,currentFinger.end),duration=calculateDuration(),setMaxDistance(direction,distance),ret=triggerHandler(event,phase),!options.triggerOnTouchEnd||options.triggerOnTouchLeave){var inBounds=!0;if(options.triggerOnTouchLeave){var bounds=getbounds(this);inBounds=isInBounds(currentFinger.end,bounds)}!options.triggerOnTouchEnd&&inBounds?phase=getNextPhase(PHASE_MOVE):options.triggerOnTouchLeave&&!inBounds&&(phase=getNextPhase(PHASE_END)),phase!=PHASE_CANCEL&&phase!=PHASE_END||triggerHandler(event,phase)}}else phase=PHASE_CANCEL,triggerHandler(event,phase);ret===!1&&(phase=PHASE_CANCEL,triggerHandler(event,phase))}}function touchEnd(jqEvent){var event=jqEvent.originalEvent?jqEvent.originalEvent:jqEvent,touches=event.touches;if(touches){if(touches.length&&!inMultiFingerRelease())return startMultiFingerRelease(event),!0;if(touches.length&&inMultiFingerRelease())return!0}return inMultiFingerRelease()&&(fingerCount=fingerCountAtRelease),endTime=getTimeStamp(),duration=calculateDuration(),didSwipeBackToCancel()||!validateSwipeDistance()?(phase=PHASE_CANCEL,triggerHandler(event,phase)):options.triggerOnTouchEnd||options.triggerOnTouchEnd===!1&&phase===PHASE_MOVE?(options.preventDefaultEvents!==!1&&jqEvent.cancelable!==!1&&jqEvent.preventDefault(),phase=PHASE_END,triggerHandler(event,phase)):!options.triggerOnTouchEnd&&hasTap()?(phase=PHASE_END,triggerHandlerForGesture(event,phase,TAP)):phase===PHASE_MOVE&&(phase=PHASE_CANCEL,triggerHandler(event,phase)),setTouchInProgress(!1),null}function touchCancel(){fingerCount=0,endTime=0,startTime=0,startTouchesDistance=0,endTouchesDistance=0,pinchZoom=1,cancelMultiFingerRelease(),setTouchInProgress(!1)}function touchLeave(jqEvent){var event=jqEvent.originalEvent?jqEvent.originalEvent:jqEvent;options.triggerOnTouchLeave&&(phase=getNextPhase(PHASE_END),triggerHandler(event,phase))}function removeListeners(){$element.unbind(START_EV,touchStart),$element.unbind(CANCEL_EV,touchCancel),$element.unbind(MOVE_EV,touchMove),$element.unbind(END_EV,touchEnd),LEAVE_EV&&$element.unbind(LEAVE_EV,touchLeave),setTouchInProgress(!1)}function getNextPhase(currentPhase){var nextPhase=currentPhase,validTime=validateSwipeTime(),validDistance=validateSwipeDistance(),didCancel=didSwipeBackToCancel();return!validTime||didCancel?nextPhase=PHASE_CANCEL:!validDistance||currentPhase!=PHASE_MOVE||options.triggerOnTouchEnd&&!options.triggerOnTouchLeave?!validDistance&&currentPhase==PHASE_END&&options.triggerOnTouchLeave&&(nextPhase=PHASE_CANCEL):nextPhase=PHASE_END,nextPhase}function triggerHandler(event,phase){var ret,touches=event.touches;return(didSwipe()||hasSwipes())&&(ret=triggerHandlerForGesture(event,phase,SWIPE)),(didPinch()||hasPinches())&&ret!==!1&&(ret=triggerHandlerForGesture(event,phase,PINCH)),didDoubleTap()&&ret!==!1?ret=triggerHandlerForGesture(event,phase,DOUBLE_TAP):didLongTap()&&ret!==!1?ret=triggerHandlerForGesture(event,phase,LONG_TAP):didTap()&&ret!==!1&&(ret=triggerHandlerForGesture(event,phase,TAP)),phase===PHASE_CANCEL&&touchCancel(event),phase===PHASE_END&&(touches?touches.length||touchCancel(event):touchCancel(event)),ret}function triggerHandlerForGesture(event,phase,gesture){var ret;if(gesture==SWIPE){if($element.trigger("swipeStatus",[phase,direction||null,distance||0,duration||0,fingerCount,fingerData,currentDirection]),options.swipeStatus&&(ret=options.swipeStatus.call($element,event,phase,direction||null,distance||0,duration||0,fingerCount,fingerData,currentDirection),ret===!1))return!1;if(phase==PHASE_END&&validateSwipe()){if(clearTimeout(singleTapTimeout),clearTimeout(holdTimeout),$element.trigger("swipe",[direction,distance,duration,fingerCount,fingerData,currentDirection]),options.swipe&&(ret=options.swipe.call($element,event,direction,distance,duration,fingerCount,fingerData,currentDirection),ret===!1))return!1;switch(direction){case LEFT:$element.trigger("swipeLeft",[direction,distance,duration,fingerCount,fingerData,currentDirection]),options.swipeLeft&&(ret=options.swipeLeft.call($element,event,direction,distance,duration,fingerCount,fingerData,currentDirection));break;case RIGHT:$element.trigger("swipeRight",[direction,distance,duration,fingerCount,fingerData,currentDirection]),options.swipeRight&&(ret=options.swipeRight.call($element,event,direction,distance,duration,fingerCount,fingerData,currentDirection));break;case UP:$element.trigger("swipeUp",[direction,distance,duration,fingerCount,fingerData,currentDirection]),options.swipeUp&&(ret=options.swipeUp.call($element,event,direction,distance,duration,fingerCount,fingerData,currentDirection));break;case DOWN:$element.trigger("swipeDown",[direction,distance,duration,fingerCount,fingerData,currentDirection]),options.swipeDown&&(ret=options.swipeDown.call($element,event,direction,distance,duration,fingerCount,fingerData,currentDirection))}}}if(gesture==PINCH){if($element.trigger("pinchStatus",[phase,pinchDirection||null,pinchDistance||0,duration||0,fingerCount,pinchZoom,fingerData]),options.pinchStatus&&(ret=options.pinchStatus.call($element,event,phase,pinchDirection||null,pinchDistance||0,duration||0,fingerCount,pinchZoom,fingerData),ret===!1))return!1;if(phase==PHASE_END&&validatePinch())switch(pinchDirection){case IN:$element.trigger("pinchIn",[pinchDirection||null,pinchDistance||0,duration||0,fingerCount,pinchZoom,fingerData]),options.pinchIn&&(ret=options.pinchIn.call($element,event,pinchDirection||null,pinchDistance||0,duration||0,fingerCount,pinchZoom,fingerData));break;case OUT:$element.trigger("pinchOut",[pinchDirection||null,pinchDistance||0,duration||0,fingerCount,pinchZoom,fingerData]),options.pinchOut&&(ret=options.pinchOut.call($element,event,pinchDirection||null,pinchDistance||0,duration||0,fingerCount,pinchZoom,fingerData))}}return gesture==TAP?phase!==PHASE_CANCEL&&phase!==PHASE_END||(clearTimeout(singleTapTimeout),clearTimeout(holdTimeout),hasDoubleTap()&&!inDoubleTap()?(doubleTapStartTime=getTimeStamp(),singleTapTimeout=setTimeout($.proxy(function(){doubleTapStartTime=null,$element.trigger("tap",[event.target]),options.tap&&(ret=options.tap.call($element,event,event.target))},this),options.doubleTapThreshold)):(doubleTapStartTime=null,$element.trigger("tap",[event.target]),options.tap&&(ret=options.tap.call($element,event,event.target)))):gesture==DOUBLE_TAP?phase!==PHASE_CANCEL&&phase!==PHASE_END||(clearTimeout(singleTapTimeout),clearTimeout(holdTimeout),doubleTapStartTime=null,$element.trigger("doubletap",[event.target]),options.doubleTap&&(ret=options.doubleTap.call($element,event,event.target))):gesture==LONG_TAP&&(phase!==PHASE_CANCEL&&phase!==PHASE_END||(clearTimeout(singleTapTimeout),doubleTapStartTime=null,$element.trigger("longtap",[event.target]),options.longTap&&(ret=options.longTap.call($element,event,event.target)))),ret}function validateSwipeDistance(){var valid=!0;return null!==options.threshold&&(valid=distance>=options.threshold),valid}function didSwipeBackToCancel(){var cancelled=!1;return null!==options.cancelThreshold&&null!==direction&&(cancelled=getMaxDistance(direction)-distance>=options.cancelThreshold),cancelled}function validatePinchDistance(){return null===options.pinchThreshold||pinchDistance>=options.pinchThreshold}function validateSwipeTime(){var result;return result=!options.maxTimeThreshold||!(duration>=options.maxTimeThreshold)}function validateDefaultEvent(jqEvent,direction){if(options.preventDefaultEvents!==!1)if(options.allowPageScroll===NONE)jqEvent.preventDefault();else{var auto=options.allowPageScroll===AUTO;switch(direction){case LEFT:(options.swipeLeft&&auto||!auto&&options.allowPageScroll!=HORIZONTAL)&&jqEvent.preventDefault();break;case RIGHT:(options.swipeRight&&auto||!auto&&options.allowPageScroll!=HORIZONTAL)&&jqEvent.preventDefault();break;case UP:(options.swipeUp&&auto||!auto&&options.allowPageScroll!=VERTICAL)&&jqEvent.preventDefault();break;case DOWN:(options.swipeDown&&auto||!auto&&options.allowPageScroll!=VERTICAL)&&jqEvent.preventDefault();break;case NONE:}}}function validatePinch(){var hasCorrectFingerCount=validateFingers(),hasEndPoint=validateEndPoint(),hasCorrectDistance=validatePinchDistance();return hasCorrectFingerCount&&hasEndPoint&&hasCorrectDistance}function hasPinches(){return!!(options.pinchStatus||options.pinchIn||options.pinchOut)}function didPinch(){return!(!validatePinch()||!hasPinches())}function validateSwipe(){var hasValidTime=validateSwipeTime(),hasValidDistance=validateSwipeDistance(),hasCorrectFingerCount=validateFingers(),hasEndPoint=validateEndPoint(),didCancel=didSwipeBackToCancel(),valid=!didCancel&&hasEndPoint&&hasCorrectFingerCount&&hasValidDistance&&hasValidTime;return valid}function hasSwipes(){return!!(options.swipe||options.swipeStatus||options.swipeLeft||options.swipeRight||options.swipeUp||options.swipeDown)}function didSwipe(){return!(!validateSwipe()||!hasSwipes())}function validateFingers(){return fingerCount===options.fingers||options.fingers===ALL_FINGERS||!SUPPORTS_TOUCH}function validateEndPoint(){return 0!==fingerData[0].end.x}function hasTap(){return!!options.tap}function hasDoubleTap(){return!!options.doubleTap}function hasLongTap(){return!!options.longTap}function validateDoubleTap(){if(null==doubleTapStartTime)return!1;var now=getTimeStamp();return hasDoubleTap()&&now-doubleTapStartTime<=options.doubleTapThreshold}function inDoubleTap(){return validateDoubleTap()}function validateTap(){return(1===fingerCount||!SUPPORTS_TOUCH)&&(isNaN(distance)||distance<options.threshold)}function validateLongTap(){return duration>options.longTapThreshold&&distance<DOUBLE_TAP_THRESHOLD}function didTap(){return!(!validateTap()||!hasTap())}function didDoubleTap(){return!(!validateDoubleTap()||!hasDoubleTap())}function didLongTap(){return!(!validateLongTap()||!hasLongTap())}function startMultiFingerRelease(event){previousTouchEndTime=getTimeStamp(),fingerCountAtRelease=event.touches.length+1}function cancelMultiFingerRelease(){previousTouchEndTime=0,fingerCountAtRelease=0}function inMultiFingerRelease(){var withinThreshold=!1;if(previousTouchEndTime){var diff=getTimeStamp()-previousTouchEndTime;diff<=options.fingerReleaseThreshold&&(withinThreshold=!0)}return withinThreshold}function getTouchInProgress(){return!($element.data(PLUGIN_NS+"_intouch")!==!0)}function setTouchInProgress(val){$element&&(val===!0?($element.bind(MOVE_EV,touchMove),$element.bind(END_EV,touchEnd),LEAVE_EV&&$element.bind(LEAVE_EV,touchLeave)):($element.unbind(MOVE_EV,touchMove,!1),$element.unbind(END_EV,touchEnd,!1),LEAVE_EV&&$element.unbind(LEAVE_EV,touchLeave,!1)),$element.data(PLUGIN_NS+"_intouch",val===!0))}function createFingerData(id,evt){var f={start:{x:0,y:0},last:{x:0,y:0},end:{x:0,y:0}};return f.start.x=f.last.x=f.end.x=evt.pageX||evt.clientX,f.start.y=f.last.y=f.end.y=evt.pageY||evt.clientY,fingerData[id]=f,f}function updateFingerData(evt){var id=void 0!==evt.identifier?evt.identifier:0,f=getFingerData(id);return null===f&&(f=createFingerData(id,evt)),f.last.x=f.end.x,f.last.y=f.end.y,f.end.x=evt.pageX||evt.clientX,f.end.y=evt.pageY||evt.clientY,f}function getFingerData(id){return fingerData[id]||null}function setMaxDistance(direction,distance){direction!=NONE&&(distance=Math.max(distance,getMaxDistance(direction)),maximumsMap[direction].distance=distance)}function getMaxDistance(direction){if(maximumsMap[direction])return maximumsMap[direction].distance}function createMaximumsData(){var maxData={};return maxData[LEFT]=createMaximumVO(LEFT),maxData[RIGHT]=createMaximumVO(RIGHT),maxData[UP]=createMaximumVO(UP),maxData[DOWN]=createMaximumVO(DOWN),maxData}function createMaximumVO(dir){return{direction:dir,distance:0}}function calculateDuration(){return endTime-startTime}function calculateTouchesDistance(startPoint,endPoint){var diffX=Math.abs(startPoint.x-endPoint.x),diffY=Math.abs(startPoint.y-endPoint.y);return Math.round(Math.sqrt(diffX*diffX+diffY*diffY))}function calculatePinchZoom(startDistance,endDistance){var percent=endDistance/startDistance*1;return percent.toFixed(2)}function calculatePinchDirection(){return pinchZoom<1?OUT:IN}function calculateDistance(startPoint,endPoint){return Math.round(Math.sqrt(Math.pow(endPoint.x-startPoint.x,2)+Math.pow(endPoint.y-startPoint.y,2)))}function calculateAngle(startPoint,endPoint){var x=startPoint.x-endPoint.x,y=endPoint.y-startPoint.y,r=Math.atan2(y,x),angle=Math.round(180*r/Math.PI);return angle<0&&(angle=360-Math.abs(angle)),angle}function calculateDirection(startPoint,endPoint){if(comparePoints(startPoint,endPoint))return NONE;var angle=calculateAngle(startPoint,endPoint);return angle<=45&&angle>=0?LEFT:angle<=360&&angle>=315?LEFT:angle>=135&&angle<=225?RIGHT:angle>45&&angle<135?DOWN:UP}function getTimeStamp(){var now=new Date;return now.getTime()}function getbounds(el){el=$(el);var offset=el.offset(),bounds={left:offset.left,right:offset.left+el.outerWidth(),top:offset.top,bottom:offset.top+el.outerHeight()};return bounds}function isInBounds(point,bounds){return point.x>bounds.left&&point.x<bounds.right&&point.y>bounds.top&&point.y<bounds.bottom}function comparePoints(pointA,pointB){return pointA.x==pointB.x&&pointA.y==pointB.y}var options=$.extend({},options),useTouchEvents=SUPPORTS_TOUCH||SUPPORTS_POINTER||!options.fallbackToMouseEvents,START_EV=useTouchEvents?SUPPORTS_POINTER?SUPPORTS_POINTER_IE10?"MSPointerDown":"pointerdown":"touchstart":"mousedown",MOVE_EV=useTouchEvents?SUPPORTS_POINTER?SUPPORTS_POINTER_IE10?"MSPointerMove":"pointermove":"touchmove":"mousemove",END_EV=useTouchEvents?SUPPORTS_POINTER?SUPPORTS_POINTER_IE10?"MSPointerUp":"pointerup":"touchend":"mouseup",LEAVE_EV=useTouchEvents?SUPPORTS_POINTER?"mouseleave":null:"mouseleave",CANCEL_EV=SUPPORTS_POINTER?SUPPORTS_POINTER_IE10?"MSPointerCancel":"pointercancel":"touchcancel",distance=0,direction=null,currentDirection=null,duration=0,startTouchesDistance=0,endTouchesDistance=0,pinchZoom=1,pinchDistance=0,pinchDirection=0,maximumsMap=null,$element=$(element),phase="start",fingerCount=0,fingerData={},startTime=0,endTime=0,previousTouchEndTime=0,fingerCountAtRelease=0,doubleTapStartTime=0,singleTapTimeout=null,holdTimeout=null;try{$element.bind(START_EV,touchStart),$element.bind(CANCEL_EV,touchCancel)}catch(e){$.error("events not supported "+START_EV+","+CANCEL_EV+" on jQuery.swipe")}this.enable=function(){return this.disable(),$element.bind(START_EV,touchStart),$element.bind(CANCEL_EV,touchCancel),$element},this.disable=function(){return removeListeners(),$element},this.destroy=function(){removeListeners(),$element.data(PLUGIN_NS,null),$element=null},this.option=function(property,value){if("object"==typeof property)options=$.extend(options,property);else if(void 0!==options[property]){if(void 0===value)return options[property];options[property]=value}else{if(!property)return options;$.error("Option "+property+" does not exist on jQuery.swipe.options")}return null}}var VERSION="1.6.18",LEFT="left",RIGHT="right",UP="up",DOWN="down",IN="in",OUT="out",NONE="none",AUTO="auto",SWIPE="swipe",PINCH="pinch",TAP="tap",DOUBLE_TAP="doubletap",LONG_TAP="longtap",HORIZONTAL="horizontal",VERTICAL="vertical",ALL_FINGERS="all",DOUBLE_TAP_THRESHOLD=10,PHASE_START="start",PHASE_MOVE="move",PHASE_END="end",PHASE_CANCEL="cancel",SUPPORTS_TOUCH="ontouchstart"in window,SUPPORTS_POINTER_IE10=window.navigator.msPointerEnabled&&!window.navigator.pointerEnabled&&!SUPPORTS_TOUCH,SUPPORTS_POINTER=(window.navigator.pointerEnabled||window.navigator.msPointerEnabled)&&!SUPPORTS_TOUCH,PLUGIN_NS="TouchSwipe",defaults={fingers:1,threshold:75,cancelThreshold:null,pinchThreshold:20,maxTimeThreshold:null,fingerReleaseThreshold:250,longTapThreshold:500,doubleTapThreshold:200,swipe:null,swipeLeft:null,swipeRight:null,swipeUp:null,swipeDown:null,swipeStatus:null,pinchIn:null,pinchOut:null,pinchStatus:null,click:null,tap:null,doubleTap:null,longTap:null,hold:null,triggerOnTouchEnd:!0,triggerOnTouchLeave:!1,allowPageScroll:"auto",fallbackToMouseEvents:!0,excludedElements:".noSwipe",preventDefaultEvents:!0};$.fn.swipe=function(method){var $this=$(this),plugin=$this.data(PLUGIN_NS);if(plugin&&"string"==typeof method){if(plugin[method])return plugin[method].apply(plugin,Array.prototype.slice.call(arguments,1));$.error("Method "+method+" does not exist on jQuery.swipe")}else if(plugin&&"object"==typeof method)plugin.option.apply(plugin,arguments);else if(!(plugin||"object"!=typeof method&&method))return init.apply(this,arguments);return $this},$.fn.swipe.version=VERSION,$.fn.swipe.defaults=defaults,$.fn.swipe.phases={PHASE_START:PHASE_START,PHASE_MOVE:PHASE_MOVE,PHASE_END:PHASE_END,PHASE_CANCEL:PHASE_CANCEL},$.fn.swipe.directions={LEFT:LEFT,RIGHT:RIGHT,UP:UP,DOWN:DOWN,IN:IN,OUT:OUT},$.fn.swipe.pageScroll={NONE:NONE,HORIZONTAL:HORIZONTAL,VERTICAL:VERTICAL,AUTO:AUTO},$.fn.swipe.fingers={ONE:1,TWO:2,THREE:3,FOUR:4,FIVE:5,ALL:ALL_FINGERS}});
/*
       (accessible)
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1@accessible360.1
  Author: Jason Webb (Accessible360)
 Website: https://accessible360.com
    Docs: https://accessible360.github.io/accessible-slick
    Repo: https://github.com/Accessible360/accessible-slick
  Issues: https://github.com/Accessible360/accessible-slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */

;(function(factory) {
  'use strict';
  if (typeof define === 'function' && define.amd) {
      define(['jquery'], factory);
  } else if (typeof exports !== 'undefined') {
      module.exports = factory(require('jquery'));
  } else {
      factory(jQuery);
  }

}(function($) {
  'use strict';
  var Slick = window.Slick || {};

  Slick = (function() {

      var instanceUid = 0;

      function Slick(element, settings) {

          var _ = this, dataSettings;

          _.defaults = {
              adaptiveHeight: false,
              appendArrows: $(element),
              appendDots: $(element),
              arrows: true,
              arrowsPlacement: null,
              asNavFor: null,
              prevArrow: '<button class="slick-prev" type="button">'
                          + '<span class="slick-prev-icon" aria-hidden="true"></span>'
                          + '<span class="slick-sr-only">Previous</span>'
                       + '</button>',
              nextArrow: '<button class="slick-next" type="button">'
                          + '<span class="slick-next-icon" aria-hidden="true"></span>'
                          + '<span class="slick-sr-only">Next</span>'
                       + '</button>',
              autoplay: false,
              autoplaySpeed: 3000,
              centerMode: false,
              centerPadding: '50px',
              cssEase: 'ease',
              customPaging: function(slider, i) {
                  return $('<button type="button">'
                              + '<span class="slick-dot-icon" aria-hidden="true"></span>'
                              + '<span class="slick-sr-only">Go to slide ' + (i+1) + '</span>'
                          + '</button>');
              },
              dots: false,
              dotsClass: 'slick-dots',
              draggable: true,
              easing: 'linear',
              edgeFriction: 0.35,
              fade: false,
              infinite: true,
              initialSlide: 0,
              instructionsText: null,
              lazyLoad: 'ondemand',
              mobileFirst: false,
              playIcon: '<span class="slick-play-icon" aria-hidden="true"></span>',
              pauseIcon: '<span class="slick-pause-icon" aria-hidden="true"></span>',
              pauseOnHover: true,
              pauseOnFocus: true,
              pauseOnDotsHover: false,
              regionLabel: 'carousel',
              respondTo: 'window',
              responsive: null,
              rows: 1,
              rtl: false,
              slide: '',
              slidesPerRow: 1,
              slidesToShow: 1,
              slidesToScroll: 1,
              speed: 500,
              swipe: true,
              swipeToSlide: false,
              touchMove: true,
              touchThreshold: 5,
              useAutoplayToggleButton: true,
              useCSS: true,
              useGroupRole: true,
              useTransform: true,
              variableWidth: false,
              vertical: false,
              verticalSwiping: false,
              waitForAnimate: true,
              zIndex: 1000
          };

          _.initials = {
              animating: false,
              dragging: false,
              autoPlayTimer: null,
              currentDirection: 0,
              currentLeft: null,
              currentSlide: 0,
              direction: 1,
              $dots: null,
              $instructionsText: null,
              listWidth: null,
              listHeight: null,
              loadIndex: 0,
              $nextArrow: null,
              $pauseButton: null,
              $pauseIcon: null,
              $playIcon: null,
              $prevArrow: null,
              scrolling: false,
              slideCount: null,
              slideWidth: null,
              $slideTrack: null,
              $slides: null,
              sliding: false,
              slideOffset: 0,
              swipeLeft: null,
              swiping: false,
              $list: null,
              touchObject: {},
              transformsEnabled: false,
              unslicked: false
          };

          $.extend(_, _.initials);

          _.activeBreakpoint = null;
          _.animType = null;
          _.animProp = null;
          _.breakpoints = [];
          _.breakpointSettings = [];
          _.cssTransitions = false;
          _.focussed = false;
          _.interrupted = false;
          _.hidden = 'hidden';
          _.paused = true;
          _.positionProp = null;
          _.respondTo = null;
          _.rowCount = 1;
          _.shouldClick = true;
          _.$slider = $(element);
          _.$slidesCache = null;
          _.transformType = null;
          _.transitionType = null;
          _.visibilityChange = 'visibilitychange';
          _.windowWidth = 0;
          _.windowTimer = null;

          dataSettings = $(element).data('slick') || {};

          _.options = $.extend({}, _.defaults, settings, dataSettings);

          _.currentSlide = _.options.initialSlide;

          _.originalSettings = _.options;

          if (typeof document.mozHidden !== 'undefined') {
              _.hidden = 'mozHidden';
              _.visibilityChange = 'mozvisibilitychange';
          } else if (typeof document.webkitHidden !== 'undefined') {
              _.hidden = 'webkitHidden';
              _.visibilityChange = 'webkitvisibilitychange';
          }

          _.autoPlay = $.proxy(_.autoPlay, _);
          _.autoPlayClear = $.proxy(_.autoPlayClear, _);
          _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
          _.autoPlayToggleHandler = $.proxy(_.autoPlayToggleHandler, _);
          _.changeSlide = $.proxy(_.changeSlide, _);
          _.clickHandler = $.proxy(_.clickHandler, _);
          _.selectHandler = $.proxy(_.selectHandler, _);
          _.setPosition = $.proxy(_.setPosition, _);
          _.swipeHandler = $.proxy(_.swipeHandler, _);
          _.dragHandler = $.proxy(_.dragHandler, _);

          _.instanceUid = instanceUid++;

          // A simple way to check for HTML strings
          // Strict HTML recognition (must start with <)
          // Extracted from jQuery v1.11 source
          _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


          _.registerBreakpoints();
          _.init(true);

      }

      return Slick;

  }());

  Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {

      var _ = this;

      if (typeof(index) === 'boolean') {
          addBefore = index;
          index = null;
      } else if (index < 0 || (index >= _.slideCount)) {
          return false;
      }

      _.unload();

      if (typeof(index) === 'number') {
          if (index === 0 && _.$slides.length === 0) {
              $(markup).appendTo(_.$slideTrack);
          } else if (addBefore) {
              $(markup).insertBefore(_.$slides.eq(index));
          } else {
              $(markup).insertAfter(_.$slides.eq(index));
          }
      } else {
          if (addBefore === true) {
              $(markup).prependTo(_.$slideTrack);
          } else {
              $(markup).appendTo(_.$slideTrack);
          }
      }

      _.$slides = _.$slideTrack.children(this.options.slide);

      _.$slideTrack.children(this.options.slide).detach();

      _.$slideTrack.append(_.$slides);

      _.$slides.each(function(index, element) {
          $(element).attr('data-slick-index', index);
          $(element).attr('role', 'group');
          $(element).attr('aria-label', 'slide ' + index);
      });

      _.$slidesCache = _.$slides;

      _.reinit();

  };

  Slick.prototype.animateHeight = function() {
      var _ = this;
      if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
          var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
          _.$list.animate({
              height: targetHeight
          }, _.options.speed);
      }
  };

  Slick.prototype.animateSlide = function(targetLeft, callback) {

      var animProps = {},
          _ = this;

      _.animateHeight();

      if (_.options.rtl === true && _.options.vertical === false) {
          targetLeft = -targetLeft;
      }
      if (_.transformsEnabled === false) {
          if (_.options.vertical === false) {
              _.$slideTrack.animate({
                  left: targetLeft
              }, _.options.speed, _.options.easing, callback);
          } else {
              _.$slideTrack.animate({
                  top: targetLeft
              }, _.options.speed, _.options.easing, callback);
          }

      } else {

          if (_.cssTransitions === false) {
              if (_.options.rtl === true) {
                  _.currentLeft = -(_.currentLeft);
              }
              $({
                  animStart: _.currentLeft
              }).animate({
                  animStart: targetLeft
              }, {
                  duration: _.options.speed,
                  easing: _.options.easing,
                  step: function(now) {
                      now = Math.ceil(now);
                      if (_.options.vertical === false) {
                          animProps[_.animType] = 'translate(' +
                              now + 'px, 0px)';
                          _.$slideTrack.css(animProps);
                      } else {
                          animProps[_.animType] = 'translate(0px,' +
                              now + 'px)';
                          _.$slideTrack.css(animProps);
                      }
                  },
                  complete: function() {
                      if (callback) {
                          callback.call();
                      }
                  }
              });

          } else {

              _.applyTransition();
              targetLeft = Math.ceil(targetLeft);

              if (_.options.vertical === false) {
                  animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
              } else {
                  animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
              }
              _.$slideTrack.css(animProps);

              if (callback) {
                  setTimeout(function() {

                      _.disableTransition();

                      callback.call();
                  }, _.options.speed);
              }

          }

      }

  };

  Slick.prototype.getNavTarget = function() {

      var _ = this,
          asNavFor = _.options.asNavFor;

      if ( asNavFor && asNavFor !== null ) {
          asNavFor = $(asNavFor).not(_.$slider);
      }

      return asNavFor;

  };

  Slick.prototype.asNavFor = function(index) {

      var _ = this,
          asNavFor = _.getNavTarget();

      if ( asNavFor !== null && typeof asNavFor === 'object' ) {
          asNavFor.each(function() {
              var target = $(this).slick('getSlick');
              if(!target.unslicked) {
                  target.slideHandler(index, true);
              }
          });
      }

  };

  Slick.prototype.applyTransition = function(slide) {

      var _ = this,
          transition = {};

      if (_.options.fade === false) {
          transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
      } else {
          transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
      }

      if (_.options.fade === false) {
          _.$slideTrack.css(transition);
      } else {
          _.$slides.eq(slide).css(transition);
      }

  };

  Slick.prototype.autoPlay = function() {

      var _ = this;

      _.autoPlayClear();

      if ( _.slideCount > _.options.slidesToShow ) {
          _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
      }

  };

  Slick.prototype.autoPlayClear = function() {

      var _ = this;

      if (_.autoPlayTimer) {
          clearInterval(_.autoPlayTimer);
      }

  };

  Slick.prototype.autoPlayIterator = function() {

      var _ = this,
          slideTo = _.currentSlide + _.options.slidesToScroll;

      if ( !_.paused && !_.interrupted && !_.focussed ) {

          if ( _.options.infinite === false ) {

              if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
                  _.direction = 0;
              }

              else if ( _.direction === 0 ) {

                  slideTo = _.currentSlide - _.options.slidesToScroll;

                  if ( _.currentSlide - 1 === 0 ) {
                      _.direction = 1;
                  }

              }

          }

          _.slideHandler( slideTo );

      }

  };

  Slick.prototype.autoPlayToggleHandler = function() {
      var _ = this;

      if(_.paused) {
          _.$playIcon.css('display', 'none');
          _.$pauseIcon.css('display', 'inline');

          _.$pauseButton.find('.slick-play-text').attr('style', 'display: none');
          _.$pauseButton.find('.slick-pause-text').removeAttr('style');

          _.slickPlay();
      } else {
          _.$playIcon.css('display', 'inline');
          _.$pauseIcon.css('display', 'none');

          _.$pauseButton.find('.slick-play-text').removeAttr('style');
          _.$pauseButton.find('.slick-pause-text').attr('style', 'display: none');

          _.slickPause();
      }
  };

  Slick.prototype.buildArrows = function() {

      var _ = this;

      if (_.options.arrows === true ) {

          _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
          _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

          if( _.slideCount > _.options.slidesToShow ) {

              if (_.htmlExpr.test(_.options.prevArrow)) {
                  if(_.options.arrowsPlacement != null) {
                      switch(_.options.arrowsPlacement) {
                          case 'beforeSlides':
                          case 'split':
                              _.$prevArrow.prependTo(_.options.appendArrows);
                              break;

                          case 'afterSlides':
                              _.$prevArrow.appendTo(_.options.appendArrows);
                              break;
                      }

                  } else {
                      _.$prevArrow.prependTo(_.options.appendArrows);
                  }
              }

              if (_.htmlExpr.test(_.options.nextArrow)) {
                  if(_.options.arrowsPlacement != null) {
                      switch(_.options.arrowsPlacement) {
                          case 'beforeSlides':
                              _.$prevArrow.after(_.$nextArrow);
                              break;

                          case 'afterSlides':
                          case 'split':
                              _.$nextArrow.appendTo(_.options.appendArrows);
                      }
                  } else {
                     _.$nextArrow.appendTo(_.options.appendArrows);
                  }
              }

              if (_.options.infinite !== true) {
                  _.$prevArrow
                      .addClass('slick-disabled')
                      .prop('disabled', true);
              }

          } else {

              _.$prevArrow.add( _.$nextArrow )

                  .addClass('slick-hidden')
                  .prop('disabled', true);
          }

      }

  };

  Slick.prototype.buildDots = function() {

      var _ = this,
          i, dot;

      if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

          _.$slider.addClass('slick-dotted');

          dot = $('<ul />').addClass(_.options.dotsClass);

          for (i = 0; i <= _.getDotCount(); i += 1) {
              dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
          }

          _.$dots = dot.appendTo(_.options.appendDots);

          _.$dots.find('li').first().addClass('slick-active');

      }

  };

  Slick.prototype.buildOut = function() {

      var _ = this;

      _.$slides =
          _.$slider
              .children( _.options.slide + ':not(.slick-cloned)')
              .addClass('slick-slide');

      _.slideCount = _.$slides.length;

      _.$slides.each(function(index, element) {
          $(element)
              .attr('data-slick-index', index)
              .data('originalStyling', $(element).attr('style') || '');

          if(_.options.useGroupRole) {
              $(element)
                  .attr('role', 'group')
                  .attr('aria-label', 'slide ' + (index + 1));
          }
      });

      _.$slider.addClass('slick-slider');
      _.$slider.addClass('accessible-slick')

      _.$slider.attr('role', 'region');
      _.$slider.attr('aria-label', _.options.regionLabel);
      _.$slider.attr('tabindex', -1);

      _.$slideTrack = (_.slideCount === 0) ?
          $('<div class="slick-track"/>').appendTo(_.$slider) :
          _.$slides.wrapAll('<div class="slick-track"/>').parent();

      _.$list = _.$slideTrack.wrap(
          '<div class="slick-list"/>').parent();
      _.$slideTrack.css('opacity', 0);

      if (_.options.centerMode === true || _.options.swipeToSlide === true) {
          _.options.slidesToScroll = 1;
      }

      $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

      _.setupInfinite();

      _.buildArrows();

      _.buildDots();

      _.updateDots();


      _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

      if (_.options.draggable === true) {
          _.$list.addClass('draggable');
      }

      if ( _.options.autoplay && _.options.useAutoplayToggleButton && _.slideCount > 1 ) {
          _.$pauseIcon = $(_.options.pauseIcon).attr('aria-hidden', true);
          _.$playIcon = $(_.options.playIcon).attr('aria-hidden', true);

          _.$pauseButton = $('<button type="button" class="slick-autoplay-toggle-button">');
          _.$pauseButton.append(_.$pauseIcon);
          _.$pauseButton.append(_.$playIcon.css('display', 'none'));
          _.$pauseButton.append($('<span class="slick-pause-text slick-sr-only">Pause Carousel</span>'));
          _.$pauseButton.append($('<span class="slick-play-text slick-sr-only" style="display: none">Play Carousel</span>'));

          _.$pauseButton.prependTo(_.$slider);
      }

      if((_.options.instructionsText != null && _.options.instructionsText != '')) {
          _.$instructionsText = $('<p class="slick-instructions slick-sr-only">' + _.options.instructionsText + '</p>');
          _.$instructionsText.prependTo(_.$slider);
      }

  };

  Slick.prototype.buildRows = function() {

      var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;

      newSlides = document.createDocumentFragment();
      originalSlides = _.$slider.children();

      if(_.options.rows > 0) {

          slidesPerSection = _.options.slidesPerRow * _.options.rows;
          numOfSlides = Math.ceil(
              originalSlides.length / slidesPerSection
          );

          for(a = 0; a < numOfSlides; a++){
              var slide = document.createElement('div');
              for(b = 0; b < _.options.rows; b++) {
                  var row = document.createElement('div');
                  for(c = 0; c < _.options.slidesPerRow; c++) {
                      var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
                      if (originalSlides.get(target)) {
                          row.appendChild(originalSlides.get(target));
                      }
                  }
                  slide.appendChild(row);
              }
              newSlides.appendChild(slide);
          }

          _.$slider.empty().append(newSlides);
          _.$slider.children().children().children()
              .css({
                  'width':(100 / _.options.slidesPerRow) + '%',
                  'display': 'inline-block'
              });

      }

  };

  Slick.prototype.checkResponsive = function(initial, forceUpdate) {

      var _ = this,
          breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
      var sliderWidth = _.$slider.width();
      var windowWidth = window.innerWidth || $(window).width();

      if (_.respondTo === 'window') {
          respondToWidth = windowWidth;
      } else if (_.respondTo === 'slider') {
          respondToWidth = sliderWidth;
      } else if (_.respondTo === 'min') {
          respondToWidth = Math.min(windowWidth, sliderWidth);
      }

      if ( _.options.responsive &&
          _.options.responsive.length &&
          _.options.responsive !== null) {

          targetBreakpoint = null;

          for (breakpoint in _.breakpoints) {
              if (_.breakpoints.hasOwnProperty(breakpoint)) {
                  if (_.originalSettings.mobileFirst === false) {
                      if (respondToWidth < _.breakpoints[breakpoint]) {
                          targetBreakpoint = _.breakpoints[breakpoint];
                      }
                  } else {
                      if (respondToWidth > _.breakpoints[breakpoint]) {
                          targetBreakpoint = _.breakpoints[breakpoint];
                      }
                  }
              }
          }

          if (targetBreakpoint !== null) {
              if (_.activeBreakpoint !== null) {
                  if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                      _.activeBreakpoint =
                          targetBreakpoint;
                      if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                          _.unslick(targetBreakpoint);
                      } else {
                          _.options = $.extend({}, _.originalSettings,
                              _.breakpointSettings[
                                  targetBreakpoint]);
                          if (initial === true) {
                              _.currentSlide = _.options.initialSlide;
                          }
                          _.refresh(initial);
                      }
                      triggerBreakpoint = targetBreakpoint;
                  }
              } else {
                  _.activeBreakpoint = targetBreakpoint;
                  if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                      _.unslick(targetBreakpoint);
                  } else {
                      _.options = $.extend({}, _.originalSettings,
                          _.breakpointSettings[
                              targetBreakpoint]);
                      if (initial === true) {
                          _.currentSlide = _.options.initialSlide;
                      }
                      _.refresh(initial);
                  }
                  triggerBreakpoint = targetBreakpoint;
              }
          } else {
              if (_.activeBreakpoint !== null) {
                  _.activeBreakpoint = null;
                  _.options = _.originalSettings;
                  if (initial === true) {
                      _.currentSlide = _.options.initialSlide;
                  }
                  _.refresh(initial);
                  triggerBreakpoint = targetBreakpoint;
              }
          }

          // only trigger breakpoints during an actual break. not on initialize.
          if( !initial && triggerBreakpoint !== false ) {
              _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
          }
      }

  };

  Slick.prototype.changeSlide = function(event, dontAnimate) {

      var _ = this,
          $target = $(event.currentTarget),
          indexOffset, slideOffset, unevenOffset;

      // If target is a link, prevent default action.
      if($target.is('a')) {
          event.preventDefault();
      }

      // If target is not the <li> element (ie: a child), find the <li>.
      if(!$target.is('li')) {
          $target = $target.closest('li');
      }

      unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
      indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

      switch (event.data.message) {

          case 'previous':
              slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
              if (_.slideCount > _.options.slidesToShow) {
                  _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
              }
              break;

          case 'next':
              slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
              if (_.slideCount > _.options.slidesToShow) {
                  _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
              }
              break;

          case 'index':
              var index = event.data.index === 0 ? 0 :
                  event.data.index || $target.index() * _.options.slidesToScroll;

              _.slideHandler(_.checkNavigable(index), false, dontAnimate);
              $target.children().trigger('focus');
              break;

          default:
              return;
      }

  };

  Slick.prototype.checkNavigable = function(index) {

      var _ = this,
          navigables, prevNavigable;

      navigables = _.getNavigableIndexes();
      prevNavigable = 0;
      if (index > navigables[navigables.length - 1]) {
          index = navigables[navigables.length - 1];
      } else {
          for (var n in navigables) {
              if (index < navigables[n]) {
                  index = prevNavigable;
                  break;
              }
              prevNavigable = navigables[n];
          }
      }

      return index;
  };

  Slick.prototype.cleanUpEvents = function() {

      var _ = this;

      if(_.options.autoplay && _.options.useAutoplayToggleButton && _.slideCount > 1) {
          _.$pauseButton.off('click.slick', _.autoPlayToggleHandler);
      }

      if (_.options.dots && _.$dots !== null) {

          $('li', _.$dots)
              .off('click.slick', _.changeSlide)
              .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
              .off('mouseleave.slick', $.proxy(_.interrupt, _, false));
      }

      _.$slider.off('focus.slick blur.slick');

      if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
          _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
          _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
      }

      _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
      _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
      _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
      _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

      _.$list.off('click.slick', _.clickHandler);

      $(document).off(_.visibilityChange, _.visibility);

      _.cleanUpSlideEvents();

      $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

      $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

      $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

      $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);

  };

  Slick.prototype.cleanUpSlideEvents = function() {

      var _ = this;

      _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
      _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));

  };

  Slick.prototype.cleanUpRows = function() {

      var _ = this, originalSlides;

      if(_.options.rows > 0) {
          originalSlides = _.$slides.children().children();
          originalSlides.removeAttr('style');
          _.$slider.empty().append(originalSlides);
      }

  };

  Slick.prototype.clickHandler = function(event) {

      var _ = this;

      if (_.shouldClick === false) {
          event.stopImmediatePropagation();
          event.stopPropagation();
          event.preventDefault();
      }

  };

  Slick.prototype.destroy = function(refresh) {

      var _ = this;

      _.autoPlayClear();

      _.touchObject = {};

      _.cleanUpEvents();

      $('.slick-cloned', _.$slider).detach();

      if(_.options.autoplay && _.options.useAutoplayToggleButton && _.slideCount > 1 ) {
          _.$pauseButton.remove();
      }

      if (_.$dots) {
          _.$dots.remove();
      }

      if ( _.$prevArrow && _.$prevArrow.length ) {

          _.$prevArrow
              .removeClass('slick-disabled slick-arrow slick-hidden')
              .prop('disabled', false)
              .css('display','');

          if ( _.htmlExpr.test( _.options.prevArrow )) {
              _.$prevArrow.remove();
          }
      }

      if ( _.$nextArrow && _.$nextArrow.length ) {

          _.$nextArrow
              .removeClass('slick-disabled slick-arrow slick-hidden')
              .prop('disabled', false)
              .css('display','');

          if ( _.htmlExpr.test( _.options.nextArrow )) {
              _.$nextArrow.remove();
          }
      }


      if (_.$slides) {

          _.$slides
              .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
              .removeAttr('aria-hidden')
              .removeAttr('data-slick-index')
              .each(function(){
                  $(this).attr('style', $(this).data('originalStyling'));
              });

          _.$slideTrack.children(this.options.slide).detach();

          _.$slideTrack.detach();

          _.$list.detach();

          _.$slider.append(_.$slides);
      }

      _.cleanUpRows();

      _.$slider.removeClass('slick-slider');
      _.$slider.removeClass('slick-initialized');
      _.$slider.removeClass('slick-dotted');
      _.$slider.removeClass('accessible-slick')

      _.unslicked = true;

      if(!refresh) {
          _.$slider.trigger('destroy', [_]);
      }

  };

  Slick.prototype.disableTransition = function(slide) {

      var _ = this,
          transition = {};

      transition[_.transitionType] = '';

      if (_.options.fade === false) {
          _.$slideTrack.css(transition);
      } else {
          _.$slides.eq(slide).css(transition);
      }

  };

  Slick.prototype.fadeSlide = function(slideIndex, callback) {

      var _ = this;

      if (_.cssTransitions === false) {

          _.$slides.eq(slideIndex).css({
              zIndex: _.options.zIndex
          });

          _.$slides.eq(slideIndex).animate({
              opacity: 1
          }, _.options.speed, _.options.easing, callback);

      } else {

          _.applyTransition(slideIndex);

          _.$slides.eq(slideIndex).css({
              opacity: 1,
              zIndex: _.options.zIndex
          });

          if (callback) {
              setTimeout(function() {

                  _.disableTransition(slideIndex);

                  callback.call();
              }, _.options.speed);
          }

      }

  };

  Slick.prototype.fadeSlideOut = function(slideIndex) {

      var _ = this;

      if (_.cssTransitions === false) {

          _.$slides.eq(slideIndex).animate({
              opacity: 0,
              zIndex: _.options.zIndex - 2
          }, _.options.speed, _.options.easing);

      } else {

          _.applyTransition(slideIndex);

          _.$slides.eq(slideIndex).css({
              opacity: 0,
              zIndex: _.options.zIndex - 2
          });

      }

  };

  Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {

      var _ = this;

      if (filter !== null) {

          _.$slidesCache = _.$slides;

          _.unload();

          _.$slideTrack.children(this.options.slide).detach();

          _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

          _.reinit();

      }

  };

  Slick.prototype.focusHandler = function() {

      var _ = this;

      // If any child element receives focus within the slider we need to pause the autoplay
      _.$slider
          .off('focus.slick blur.slick')
          .on(
              'focus.slick',
              '*',
              function(event) {
                  var $sf = $(this);

                  setTimeout(function() {
                      if( _.options.pauseOnFocus ) {
                          if ($sf.is(':focus')) {
                              _.focussed = true;
                              _.autoPlay();
                          }
                      }
                  }, 0);
              }
          ).on(
              'blur.slick',
              '*',
              function(event) {
                  var $sf = $(this);

                  // When a blur occurs on any elements within the slider we become unfocused
                  if( _.options.pauseOnFocus ) {
                      _.focussed = false;
                      _.autoPlay();
                  }
              }
          );
  };

  Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {

      var _ = this;
      return _.currentSlide;

  };

  Slick.prototype.getDotCount = function() {

      var _ = this;

      var breakPoint = 0;
      var counter = 0;
      var pagerQty = 0;

      if (_.options.infinite === true) {
          if (_.slideCount <= _.options.slidesToShow) {
               ++pagerQty;
          } else {
              while (breakPoint < _.slideCount) {
                  ++pagerQty;
                  breakPoint = counter + _.options.slidesToScroll;
                  counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
              }
          }
      } else if (_.options.centerMode === true) {
          pagerQty = _.slideCount;
      } else if(!_.options.asNavFor) {
          pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
      }else {
          while (breakPoint < _.slideCount) {
              ++pagerQty;
              breakPoint = counter + _.options.slidesToScroll;
              counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
          }
      }

      return pagerQty - 1;

  };

  Slick.prototype.getLeft = function(slideIndex) {

      var _ = this,
          targetLeft,
          verticalHeight,
          verticalOffset = 0,
          targetSlide,
          coef;

      _.slideOffset = 0;
      verticalHeight = _.$slides.first().outerHeight(true);

      if (_.options.infinite === true) {
          if (_.slideCount > _.options.slidesToShow) {
              _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
              coef = -1

              if (_.options.vertical === true && _.options.centerMode === true) {
                  if (_.options.slidesToShow === 2) {
                      coef = -1.5;
                  } else if (_.options.slidesToShow === 1) {
                      coef = -2
                  }
              }
              verticalOffset = (verticalHeight * _.options.slidesToShow) * coef;
          }
          if (_.slideCount % _.options.slidesToScroll !== 0) {
              if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                  if (slideIndex > _.slideCount) {
                      _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                      verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
                  } else {
                      _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                      verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
                  }
              }
          }
      } else {
          if (slideIndex + _.options.slidesToShow > _.slideCount) {
              _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
              verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
          }
      }

      if (_.slideCount <= _.options.slidesToShow) {
          _.slideOffset = 0;
          verticalOffset = 0;
      }

      if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
          _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
      } else if (_.options.centerMode === true && _.options.infinite === true) {
          _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
      } else if (_.options.centerMode === true) {
          _.slideOffset = 0;
          _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
      }

      if (_.options.vertical === false) {
          targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
      } else {
          targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
      }

      if (_.options.variableWidth === true) {

          if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
              targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
          } else {
              targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
          }

          if (_.options.rtl === true) {
              if (targetSlide[0]) {
                  targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
              } else {
                  targetLeft =  0;
              }
          } else {
              targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
          }

          if (_.options.centerMode === true) {
              if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                  targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
              } else {
                  targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
              }

              if (_.options.rtl === true) {
                  if (targetSlide[0]) {
                      targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                  } else {
                      targetLeft =  0;
                  }
              } else {
                  targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
              }

              targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
          }
      }

      return targetLeft;

  };

  Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {

      var _ = this;

      return _.options[option];

  };

  Slick.prototype.getNavigableIndexes = function() {

      var _ = this,
          breakPoint = 0,
          counter = 0,
          indexes = [],
          max;

      if (_.options.infinite === false) {
          max = _.slideCount;
      } else {
          breakPoint = _.options.slidesToScroll * -1;
          counter = _.options.slidesToScroll * -1;
          max = _.slideCount * 2;
      }

      while (breakPoint < max) {
          indexes.push(breakPoint);
          breakPoint = counter + _.options.slidesToScroll;
          counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
      }

      return indexes;

  };

  Slick.prototype.getSlick = function() {

      return this;

  };

  Slick.prototype.getSlideCount = function() {

      var _ = this,
          slidesTraversed, swipedSlide, swipeTarget, centerOffset;

      centerOffset = _.options.centerMode === true ? Math.floor(_.$list.width() / 2) : 0;
      swipeTarget = (_.swipeLeft * -1) + centerOffset;

      if (_.options.swipeToSlide === true) {

          _.$slideTrack.find('.slick-slide').each(function(index, slide) {

              var slideOuterWidth, slideOffset, slideRightBoundary;
              slideOuterWidth = $(slide).outerWidth();
              slideOffset = slide.offsetLeft;
              if (_.options.centerMode !== true) {
                  slideOffset += (slideOuterWidth / 2);
              }

              slideRightBoundary = slideOffset + (slideOuterWidth);

              if (swipeTarget < slideRightBoundary) {
                  swipedSlide = slide;
                  return false;
              }
          });

          slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

          return slidesTraversed;

      } else {
          return _.options.slidesToScroll;
      }

  };

  Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {

      var _ = this;

      _.changeSlide({
          data: {
              message: 'index',
              index: parseInt(slide)
          }
      }, dontAnimate);

  };

  Slick.prototype.init = function(creation) {

      var _ = this;

      if (!$(_.$slider).hasClass('slick-initialized')) {

          $(_.$slider).addClass('slick-initialized');

          _.buildRows();
          _.buildOut();
          _.setProps();
          _.startLoad();
          _.loadSlider();
          _.initializeEvents();
          _.updateArrows();
          _.updateDots();
          _.checkResponsive(true);
          _.focusHandler();

      }

      if (creation) {
          _.$slider.trigger('init', [_]);
      }

      if ( _.options.autoplay ) {

          _.paused = false;
          _.autoPlay();

      }

      _.updateSlideVisibility();

      if(_.options.accessibility != undefined) {
          console.warn('accessibility setting is no longer supported.')
      }

      if(_.options.focusOnChange != undefined) {
          console.warn('focusOnChange is no longer supported.');
      }

      if(_.options.focusOnSelect != undefined) {
          console.warn('focusOnSelect is no longer supported.');
      }

  };

  Slick.prototype.initArrowEvents = function() {

      var _ = this;

      if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
          _.$prevArrow
             .off('click.slick')
             .on('click.slick', {
                  message: 'previous'
             }, _.changeSlide);
          _.$nextArrow
             .off('click.slick')
             .on('click.slick', {
                  message: 'next'
             }, _.changeSlide);
      }

  };

  Slick.prototype.initDotEvents = function() {

      var _ = this;

      if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
          $('li', _.$dots).on('click.slick', {
              message: 'index'
          }, _.changeSlide);
      }

      if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {

          $('li', _.$dots)
              .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
              .on('mouseleave.slick', $.proxy(_.interrupt, _, false));

      }

  };

  Slick.prototype.initSlideEvents = function() {

      var _ = this;

      if ( _.options.pauseOnHover ) {

          _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
          _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));

      }

  };

  Slick.prototype.initializeEvents = function() {

      var _ = this;

      _.initArrowEvents();

      _.initDotEvents();
      _.initSlideEvents();

      if(_.options.autoplay && _.options.useAutoplayToggleButton && _.slideCount > 1) {
          _.$pauseButton.on('click.slick', _.autoPlayToggleHandler);
      }

      _.$list.on('touchstart.slick mousedown.slick', {
          action: 'start'
      }, _.swipeHandler);
      _.$list.on('touchmove.slick mousemove.slick', {
          action: 'move'
      }, _.swipeHandler);
      _.$list.on('touchend.slick mouseup.slick', {
          action: 'end'
      }, _.swipeHandler);
      _.$list.on('touchcancel.slick mouseleave.slick', {
          action: 'end'
      }, _.swipeHandler);

      _.$list.on('click.slick', _.clickHandler);

      $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

      $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

      $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

      $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

      $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
      $(_.setPosition);

  };

  Slick.prototype.initUI = function() {

      var _ = this;

      if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

          _.$prevArrow.show();
          _.$nextArrow.show();

      }

      if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

          _.$dots.show();

      }

  };

  Slick.prototype.lazyLoad = function() {

      var _ = this,
          loadRange, cloneRange, rangeStart, rangeEnd;

      function loadImages(imagesScope) {

          $('img[data-lazy]', imagesScope).each(function() {

              var image = $(this),
                  imageSource = $(this).attr('data-lazy'),
                  imageSrcSet = $(this).attr('data-srcset'),
                  imageSizes  = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
                  imageToLoad = document.createElement('img');

              imageToLoad.onload = function() {

                  image
                      .animate({ opacity: 0 }, 100, function() {

                          if (imageSrcSet) {
                              image
                                  .attr('srcset', imageSrcSet );

                              if (imageSizes) {
                                  image
                                      .attr('sizes', imageSizes );
                              }
                          }

                          image
                              .attr('src', imageSource)
                              .animate({ opacity: 1 }, 200, function() {
                                  image
                                      .removeAttr('data-lazy data-srcset data-sizes')
                                      .removeClass('slick-loading');
                              });
                          _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                      });

              };

              imageToLoad.onerror = function() {

                  image
                      .removeAttr( 'data-lazy' )
                      .removeClass( 'slick-loading' )
                      .addClass( 'slick-lazyload-error' );

                  _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

              };

              imageToLoad.src = imageSource;

          });

      }

      if (_.options.centerMode === true) {
          if (_.options.infinite === true) {
              rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
              rangeEnd = rangeStart + _.options.slidesToShow + 2;
          } else {
              rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
              rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
          }
      } else {
          rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
          rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
          if (_.options.fade === true) {
              if (rangeStart > 0) rangeStart--;
              if (rangeEnd <= _.slideCount) rangeEnd++;
          }
      }

      loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

      if (_.options.lazyLoad === 'anticipated') {
          var prevSlide = rangeStart - 1,
              nextSlide = rangeEnd,
              $slides = _.$slider.find('.slick-slide');

          for (var i = 0; i < _.options.slidesToScroll; i++) {
              if (prevSlide < 0) prevSlide = _.slideCount - 1;
              loadRange = loadRange.add($slides.eq(prevSlide));
              loadRange = loadRange.add($slides.eq(nextSlide));
              prevSlide--;
              nextSlide++;
          }
      }

      loadImages(loadRange);

      if (_.slideCount <= _.options.slidesToShow) {
          cloneRange = _.$slider.find('.slick-slide');
          loadImages(cloneRange);
      } else
      if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
          cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
          loadImages(cloneRange);
      } else if (_.currentSlide === 0) {
          cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
          loadImages(cloneRange);
      }

  };

  Slick.prototype.loadSlider = function() {

      var _ = this;

      _.setPosition();

      _.$slideTrack.css({
          opacity: 1
      });

      _.$slider.removeClass('slick-loading');

      _.initUI();

      if (_.options.lazyLoad === 'progressive') {
          _.progressiveLazyLoad();
      }

  };

  Slick.prototype.next = Slick.prototype.slickNext = function() {

      var _ = this;

      _.changeSlide({
          data: {
              message: 'next'
          }
      });

  };

  Slick.prototype.orientationChange = function() {

      var _ = this;

      _.checkResponsive();
      _.setPosition();

  };

  Slick.prototype.pause = Slick.prototype.slickPause = function() {

      var _ = this;

      _.autoPlayClear();
      _.paused = true;

  };

  Slick.prototype.play = Slick.prototype.slickPlay = function() {

      var _ = this;

      _.autoPlay();
      _.options.autoplay = true;
      _.paused = false;
      _.focussed = false;
      _.interrupted = false;

  };

  Slick.prototype.postSlide = function(index) {

      var _ = this;

      if( !_.unslicked ) {

          _.$slider.trigger('afterChange', [_, index]);

          _.animating = false;

          if (_.slideCount > _.options.slidesToShow) {
              _.setPosition();
          }

          _.swipeLeft = null;

          if ( _.options.autoplay ) {
              _.autoPlay();
          }

          _.updateSlideVisibility();

      }

  };

  Slick.prototype.prev = Slick.prototype.slickPrev = function() {

      var _ = this;

      _.changeSlide({
          data: {
              message: 'previous'
          }
      });

  };

  Slick.prototype.preventDefault = function(event) {

      event.preventDefault();

  };

  Slick.prototype.progressiveLazyLoad = function( tryCount ) {

      tryCount = tryCount || 1;

      var _ = this,
          $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
          image,
          imageSource,
          imageSrcSet,
          imageSizes,
          imageToLoad;

      if ( $imgsToLoad.length ) {

          image = $imgsToLoad.first();
          imageSource = image.attr('data-lazy');
          imageSrcSet = image.attr('data-srcset');
          imageSizes  = image.attr('data-sizes') || _.$slider.attr('data-sizes');
          imageToLoad = document.createElement('img');

          imageToLoad.onload = function() {

              if (imageSrcSet) {
                  image
                      .attr('srcset', imageSrcSet );

                  if (imageSizes) {
                      image
                          .attr('sizes', imageSizes );
                  }
              }

              image
                  .attr( 'src', imageSource )
                  .removeAttr('data-lazy data-srcset data-sizes')
                  .removeClass('slick-loading');

              if ( _.options.adaptiveHeight === true ) {
                  _.setPosition();
              }

              _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
              _.progressiveLazyLoad();

          };

          imageToLoad.onerror = function() {

              if ( tryCount < 3 ) {

                  /**
                   * try to load the image 3 times,
                   * leave a slight delay so we don't get
                   * servers blocking the request.
                   */
                  setTimeout( function() {
                      _.progressiveLazyLoad( tryCount + 1 );
                  }, 500 );

              } else {

                  image
                      .removeAttr( 'data-lazy' )
                      .removeClass( 'slick-loading' )
                      .addClass( 'slick-lazyload-error' );

                  _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                  _.progressiveLazyLoad();

              }

          };

          imageToLoad.src = imageSource;

      } else {

          _.$slider.trigger('allImagesLoaded', [ _ ]);

      }

  };

  Slick.prototype.refresh = function( initializing ) {

      var _ = this, currentSlide, lastVisibleIndex;

      lastVisibleIndex = _.slideCount - _.options.slidesToShow;

      // in non-infinite sliders, we don't want to go past the
      // last visible index.
      if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
          _.currentSlide = lastVisibleIndex;
      }

      // if less slides than to show, go to start.
      if ( _.slideCount <= _.options.slidesToShow ) {
          _.currentSlide = 0;

      }

      currentSlide = _.currentSlide;

      _.destroy(true);

      $.extend(_, _.initials, { currentSlide: currentSlide });

      _.init();

      if( !initializing ) {

          _.changeSlide({
              data: {
                  message: 'index',
                  index: currentSlide
              }
          }, false);

      }

  };

  Slick.prototype.registerBreakpoints = function() {

      var _ = this, breakpoint, currentBreakpoint, l,
          responsiveSettings = _.options.responsive || null;

      if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {

          _.respondTo = _.options.respondTo || 'window';

          for ( breakpoint in responsiveSettings ) {

              l = _.breakpoints.length-1;

              if (responsiveSettings.hasOwnProperty(breakpoint)) {
                  currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                  // loop through the breakpoints and cut out any existing
                  // ones with the same breakpoint number, we don't want dupes.
                  while( l >= 0 ) {
                      if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
                          _.breakpoints.splice(l,1);
                      }
                      l--;
                  }

                  _.breakpoints.push(currentBreakpoint);
                  _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

              }

          }

          _.breakpoints.sort(function(a, b) {
              return ( _.options.mobileFirst ) ? a-b : b-a;
          });

      }

  };

  Slick.prototype.reinit = function() {

      var _ = this;

      _.$slides =
          _.$slideTrack
              .children(_.options.slide)
              .addClass('slick-slide');

      _.slideCount = _.$slides.length;

      if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
          _.currentSlide = _.currentSlide - _.options.slidesToScroll;
      }

      if (_.slideCount <= _.options.slidesToShow) {
          _.currentSlide = 0;
      }

      _.registerBreakpoints();

      _.setProps();
      _.setupInfinite();
      _.buildArrows();
      _.updateArrows();
      _.initArrowEvents();
      _.buildDots();
      _.updateDots();
      _.initDotEvents();
      _.cleanUpSlideEvents();
      _.initSlideEvents();

      _.checkResponsive(false, true);

      _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

      _.setPosition();
      _.focusHandler();

      _.paused = !_.options.autoplay;
      _.autoPlay();

      _.$slider.trigger('reInit', [_]);

  };

  Slick.prototype.resize = function() {

      var _ = this;

      if ($(window).width() !== _.windowWidth) {
          clearTimeout(_.windowDelay);
          _.windowDelay = window.setTimeout(function() {
              _.windowWidth = $(window).width();
              _.checkResponsive();
              if( !_.unslicked ) { _.setPosition(); }
          }, 50);
      }
  };

  Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {

      var _ = this;

      if (typeof(index) === 'boolean') {
          removeBefore = index;
          index = removeBefore === true ? 0 : _.slideCount - 1;
      } else {
          index = removeBefore === true ? --index : index;
      }

      if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
          return false;
      }

      _.unload();

      if (removeAll === true) {
          _.$slideTrack.children().remove();
      } else {
          _.$slideTrack.children(this.options.slide).eq(index).remove();
      }

      _.$slides = _.$slideTrack.children(this.options.slide);

      _.$slideTrack.children(this.options.slide).detach();

      _.$slideTrack.append(_.$slides);

      _.$slidesCache = _.$slides;

      _.reinit();

  };

  Slick.prototype.setCSS = function(position) {

      var _ = this,
          positionProps = {},
          x, y;

      if (_.options.rtl === true) {
          position = -position;
      }
      x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
      y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

      positionProps[_.positionProp] = position;

      if (_.transformsEnabled === false) {
          _.$slideTrack.css(positionProps);
      } else {
          positionProps = {};
          if (_.cssTransitions === false) {
              positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
              _.$slideTrack.css(positionProps);
          } else {
              positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
              _.$slideTrack.css(positionProps);
          }
      }

  };

  Slick.prototype.setDimensions = function() {

      var _ = this;

      if (_.options.vertical === false) {
          if (_.options.centerMode === true) {
              _.$list.css({
                  padding: ('0px ' + _.options.centerPadding)
              });
          }
      } else {
          _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
          if (_.options.centerMode === true) {
              _.$list.css({
                  padding: (_.options.centerPadding + ' 0px')
              });
          }
      }

      _.listWidth = _.$list.width();
      _.listHeight = _.$list.height();


      if (_.options.vertical === false && _.options.variableWidth === false) {
          _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
          _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

      } else if (_.options.variableWidth === true) {
          _.$slideTrack.width(5000 * _.slideCount);
      } else {
          _.slideWidth = Math.ceil(_.listWidth);
          _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
      }

      var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
      if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);

  };

  Slick.prototype.setFade = function() {

      var _ = this,
          targetLeft;

      _.$slides.each(function(index, element) {
          targetLeft = (_.slideWidth * index) * -1;
          if (_.options.rtl === true) {
              $(element).css({
                  position: 'relative',
                  right: targetLeft,
                  top: 0,
                  zIndex: _.options.zIndex - 2,
                  opacity: 0
              });
          } else {
              $(element).css({
                  position: 'relative',
                  left: targetLeft,
                  top: 0,
                  zIndex: _.options.zIndex - 2,
                  opacity: 0
              });
          }
      });

      _.$slides.eq(_.currentSlide).css({
          zIndex: _.options.zIndex - 1,
          opacity: 1
      });

  };

  Slick.prototype.setHeight = function() {

      var _ = this;

      if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
          var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
          _.$list.css('height', targetHeight);
      }

  };

  Slick.prototype.setOption =
  Slick.prototype.slickSetOption = function() {

      /**
       * accepts arguments in format of:
       *
       *  - for changing a single option's value:
       *     .slick("setOption", option, value, refresh )
       *
       *  - for changing a set of responsive options:
       *     .slick("setOption", 'responsive', [{}, ...], refresh )
       *
       *  - for updating multiple values at once (not responsive)
       *     .slick("setOption", { 'option': value, ... }, refresh )
       */

      var _ = this, l, item, option, value, refresh = false, type;

      if( $.type( arguments[0] ) === 'object' ) {

          option =  arguments[0];
          refresh = arguments[1];
          type = 'multiple';

      } else if ( $.type( arguments[0] ) === 'string' ) {

          option =  arguments[0];
          value = arguments[1];
          refresh = arguments[2];

          if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {

              type = 'responsive';

          } else if ( typeof arguments[1] !== 'undefined' ) {

              type = 'single';

          }

      }

      if ( type === 'single' ) {

          _.options[option] = value;


      } else if ( type === 'multiple' ) {

          $.each( option , function( opt, val ) {

              _.options[opt] = val;

          });


      } else if ( type === 'responsive' ) {

          for ( item in value ) {

              if( $.type( _.options.responsive ) !== 'array' ) {

                  _.options.responsive = [ value[item] ];

              } else {

                  l = _.options.responsive.length-1;

                  // loop through the responsive object and splice out duplicates.
                  while( l >= 0 ) {

                      if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {

                          _.options.responsive.splice(l,1);

                      }

                      l--;

                  }

                  _.options.responsive.push( value[item] );

              }

          }

      }

      if ( refresh ) {

          _.unload();
          _.reinit();

      }

  };

  Slick.prototype.setPosition = function() {

      var _ = this;

      _.setDimensions();

      _.setHeight();

      if (_.options.fade === false) {
          _.setCSS(_.getLeft(_.currentSlide));
      } else {
          _.setFade();
      }

      _.$slider.trigger('setPosition', [_]);

  };

  Slick.prototype.setProps = function() {

      var _ = this,
          bodyStyle = document.body.style;

      _.positionProp = _.options.vertical === true ? 'top' : 'left';

      if (_.positionProp === 'top') {
          _.$slider.addClass('slick-vertical');
      } else {
          _.$slider.removeClass('slick-vertical');
      }

      if (bodyStyle.WebkitTransition !== undefined ||
          bodyStyle.MozTransition !== undefined ||
          bodyStyle.msTransition !== undefined) {
          if (_.options.useCSS === true) {
              _.cssTransitions = true;
          }
      }

      if ( _.options.fade ) {
          if ( typeof _.options.zIndex === 'number' ) {
              if( _.options.zIndex < 3 ) {
                  _.options.zIndex = 3;
              }
          } else {
              _.options.zIndex = _.defaults.zIndex;
          }
      }

      if (bodyStyle.OTransform !== undefined) {
          _.animType = 'OTransform';
          _.transformType = '-o-transform';
          _.transitionType = 'OTransition';
          if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
      }
      if (bodyStyle.MozTransform !== undefined) {
          _.animType = 'MozTransform';
          _.transformType = '-moz-transform';
          _.transitionType = 'MozTransition';
          if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
      }
      if (bodyStyle.webkitTransform !== undefined) {
          _.animType = 'webkitTransform';
          _.transformType = '-webkit-transform';
          _.transitionType = 'webkitTransition';
          if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
      }
      if (bodyStyle.msTransform !== undefined) {
          _.animType = 'msTransform';
          _.transformType = '-ms-transform';
          _.transitionType = 'msTransition';
          if (bodyStyle.msTransform === undefined) _.animType = false;
      }
      if (bodyStyle.transform !== undefined && _.animType !== false) {
          _.animType = 'transform';
          _.transformType = 'transform';
          _.transitionType = 'transition';
      }
      _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
  };


  Slick.prototype.setSlideClasses = function(index) {

      var _ = this,
          centerOffset, allSlides, indexOffset, remainder;

      allSlides = _.$slider
          .find('.slick-slide')
          .removeClass('slick-active slick-center slick-current')
          .attr('aria-hidden', 'true');

      if (_.options.useGroupRole !== false && _.options.centerMode === true) {
          allSlides
              .attr('aria-label', function() {
                  return $(this).attr('aria-label').replace(' (centered)', '');
              });
      }

      _.$slides
          .eq(index)
          .addClass('slick-current');

      if (_.options.centerMode === true) {

          var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;

          centerOffset = Math.floor(_.options.slidesToShow / 2);

          if (_.options.infinite === true) {

              if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
                  _.$slides
                      .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
                      .addClass('slick-active')
                      .removeAttr('aria-hidden');

              } else {

                  indexOffset = _.options.slidesToShow + index;
                  allSlides
                      .slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2)
                      .addClass('slick-active')
                      .removeAttr('aria-hidden');

              }

              if (index === 0) {

                  allSlides
                      .eq( _.options.slidesToShow + _.slideCount + 1 )
                      .addClass('slick-center')
                      .attr('aria-label', function() {
                          return $(this).attr('aria-label') + ' (centered)';
                      });

              } else if (index === _.slideCount - 1) {

                  allSlides
                      .eq(_.options.slidesToShow)
                      .addClass('slick-center')
                      .attr('aria-label', function() {
                          return $(this).attr('aria-label') + ' (centered)';
                      });

              }

          }

          _.$slides
              .eq(index)
              .addClass('slick-center')
              .attr('aria-label', function() {
                  return $(this).attr('aria-label') + ' (centered)';
              });

      } else {

          if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

              _.$slides
                  .slice(index, index + _.options.slidesToShow)
                  .addClass('slick-active')
                  .removeAttr('aria-hidden');

          } else if (allSlides.length <= _.options.slidesToShow) {

              allSlides
                  .addClass('slick-active')
                  .removeAttr('aria-hidden');

          } else {

              remainder = _.slideCount % _.options.slidesToShow;
              indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

              if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

                  allSlides
                      .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                      .addClass('slick-active')
                      .removeAttr('aria-hidden');

              } else {

                  allSlides
                      .slice(indexOffset, indexOffset + _.options.slidesToShow)
                      .addClass('slick-active')
                      .removeAttr('aria-hidden');

              }

          }

      }

      if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
          _.lazyLoad();
      }
  };

  Slick.prototype.setupInfinite = function() {

      var _ = this,
          i, slideIndex, infiniteCount;

      if (_.options.fade === true) {
          _.options.centerMode = false;
      }

      if (_.options.infinite === true && _.options.fade === false) {

          slideIndex = null;

          if (_.slideCount > _.options.slidesToShow) {

              if (_.options.centerMode === true) {
                  infiniteCount = _.options.slidesToShow + 1;
              } else {
                  infiniteCount = _.options.slidesToShow;
              }

              for (i = _.slideCount; i > (_.slideCount -
                      infiniteCount); i -= 1) {
                  slideIndex = i - 1;
                  $(_.$slides[slideIndex]).clone(true).removeAttr('id')
                      .attr('data-slick-index', slideIndex - _.slideCount)
                      .prependTo(_.$slideTrack).addClass('slick-cloned');
              }
              for (i = 0; i < infiniteCount  + _.slideCount; i += 1) {
                  slideIndex = i;
                  $(_.$slides[slideIndex]).clone(true).removeAttr('id')
                      .attr('data-slick-index', slideIndex + _.slideCount)
                      .appendTo(_.$slideTrack).addClass('slick-cloned');
              }
              _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                  $(this).removeAttr('id');
              });

          }

      }

  };

  Slick.prototype.interrupt = function( toggle ) {

      var _ = this;

      if( !toggle ) {
          _.autoPlay();
      }
      _.interrupted = toggle;

  };

  Slick.prototype.selectHandler = function(event) {

      var _ = this;

      var targetElement =
          $(event.target).is('.slick-slide') ?
              $(event.target) :
              $(event.target).parents('.slick-slide');

      var index = parseInt(targetElement.attr('data-slick-index'));

      if (!index) index = 0;

      if (_.slideCount <= _.options.slidesToShow) {

          _.slideHandler(index, false, true);
          return;

      }

      _.slideHandler(index);

  };

  Slick.prototype.slideHandler = function(index, sync, dontAnimate) {

      var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
          _ = this, navTarget;

      sync = sync || false;

      if (_.animating === true && _.options.waitForAnimate === true) {
          return;
      }

      if (_.options.fade === true && _.currentSlide === index) {
          return;
      }

      if (sync === false) {
          _.asNavFor(index);
      }

      targetSlide = index;
      targetLeft = _.getLeft(targetSlide);
      slideLeft = _.getLeft(_.currentSlide);

      _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

      if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
          if (_.options.fade === false) {
              targetSlide = _.currentSlide;
              if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                  _.animateSlide(slideLeft, function() {
                      _.postSlide(targetSlide);
                  });
              } else {
                  _.postSlide(targetSlide);
              }
          }
          return;
      } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
          if (_.options.fade === false) {
              targetSlide = _.currentSlide;
              if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                  _.animateSlide(slideLeft, function() {
                      _.postSlide(targetSlide);
                  });
              } else {
                  _.postSlide(targetSlide);
              }
          }
          return;
      }

      if ( _.options.autoplay ) {
          clearInterval(_.autoPlayTimer);
      }

      if (targetSlide < 0) {
          if (_.slideCount % _.options.slidesToScroll !== 0) {
              animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
          } else {
              animSlide = _.slideCount + targetSlide;
          }
      } else if (targetSlide >= _.slideCount) {
          if (_.slideCount % _.options.slidesToScroll !== 0) {
              animSlide = 0;
          } else {
              animSlide = targetSlide - _.slideCount;
          }
      } else {
          animSlide = targetSlide;
      }

      _.animating = true;

      _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

      oldSlide = _.currentSlide;
      _.currentSlide = animSlide;

      _.setSlideClasses(_.currentSlide);

      if ( _.options.asNavFor ) {

          navTarget = _.getNavTarget();
          navTarget = navTarget.slick('getSlick');

          if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
              navTarget.setSlideClasses(_.currentSlide);
          }

      }

      _.updateDots();
      _.updateArrows();

      if (_.options.fade === true) {
          if (dontAnimate !== true) {

              _.fadeSlideOut(oldSlide);

              _.fadeSlide(animSlide, function() {
                  _.postSlide(animSlide);
              });

          } else {
              _.postSlide(animSlide);
          }
          _.animateHeight();
          return;
      }

      if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
          _.animateSlide(targetLeft, function() {
              _.postSlide(animSlide);
          });
      } else {
          _.postSlide(animSlide);
      }

  };

  Slick.prototype.startLoad = function() {

      var _ = this;

      if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

          _.$prevArrow.hide();
          _.$nextArrow.hide();

      }

      if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

          _.$dots.hide();

      }

      _.$slider.addClass('slick-loading');

  };

  Slick.prototype.swipeDirection = function() {

      var xDist, yDist, r, swipeAngle, _ = this;

      xDist = _.touchObject.startX - _.touchObject.curX;
      yDist = _.touchObject.startY - _.touchObject.curY;
      r = Math.atan2(yDist, xDist);

      swipeAngle = Math.round(r * 180 / Math.PI);
      if (swipeAngle < 0) {
          swipeAngle = 360 - Math.abs(swipeAngle);
      }

      if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
          return (_.options.rtl === false ? 'left' : 'right');
      }
      if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
          return (_.options.rtl === false ? 'left' : 'right');
      }
      if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
          return (_.options.rtl === false ? 'right' : 'left');
      }
      if (_.options.verticalSwiping === true) {
          if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
              return 'down';
          } else {
              return 'up';
          }
      }

      return 'vertical';

  };

  Slick.prototype.swipeEnd = function(event) {

      var _ = this,
          slideCount,
          direction;

      _.dragging = false;
      _.swiping = false;

      if (_.scrolling) {
          _.scrolling = false;
          return false;
      }

      _.interrupted = false;
      _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;

      if ( _.touchObject.curX === undefined ) {
          return false;
      }

      if ( _.touchObject.edgeHit === true ) {
          _.$slider.trigger('edge', [_, _.swipeDirection() ]);
      }

      if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {

          direction = _.swipeDirection();

          switch ( direction ) {

              case 'left':
              case 'down':

                  slideCount =
                      _.options.swipeToSlide ?
                          _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
                          _.currentSlide + _.getSlideCount();

                  _.currentDirection = 0;

                  break;

              case 'right':
              case 'up':

                  slideCount =
                      _.options.swipeToSlide ?
                          _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
                          _.currentSlide - _.getSlideCount();

                  _.currentDirection = 1;

                  break;

              default:


          }

          if( direction != 'vertical' ) {

              _.slideHandler( slideCount );
              _.touchObject = {};
              _.$slider.trigger('swipe', [_, direction ]);

          }

      } else {

          if ( _.touchObject.startX !== _.touchObject.curX ) {

              _.slideHandler( _.currentSlide );
              _.touchObject = {};

          }

      }

  };

  Slick.prototype.swipeHandler = function(event) {

      var _ = this;

      if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
          return;
      } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
          return;
      }

      _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
          event.originalEvent.touches.length : 1;

      _.touchObject.minSwipe = _.listWidth / _.options
          .touchThreshold;

      if (_.options.verticalSwiping === true) {
          _.touchObject.minSwipe = _.listHeight / _.options
              .touchThreshold;
      }

      switch (event.data.action) {

          case 'start':
              _.swipeStart(event);
              break;

          case 'move':
              _.swipeMove(event);
              break;

          case 'end':
              _.swipeEnd(event);
              break;

      }

  };

  Slick.prototype.swipeMove = function(event) {

      var _ = this,
          edgeWasHit = false,
          curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;

      touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

      if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
          return false;
      }

      curLeft = _.getLeft(_.currentSlide);

      _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
      _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

      _.touchObject.swipeLength = Math.round(Math.sqrt(
          Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

      verticalSwipeLength = Math.round(Math.sqrt(
          Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));

      if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
          _.scrolling = true;
          return false;
      }

      if (_.options.verticalSwiping === true) {
          _.touchObject.swipeLength = verticalSwipeLength;
      }

      swipeDirection = _.swipeDirection();

      if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
          _.swiping = true;
          event.preventDefault();
      }

      positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
      if (_.options.verticalSwiping === true) {
          positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
      }


      swipeLength = _.touchObject.swipeLength;

      _.touchObject.edgeHit = false;

      if (_.options.infinite === false) {
          if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
              swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
              _.touchObject.edgeHit = true;
          }
      }

      if (_.options.vertical === false) {
          _.swipeLeft = curLeft + swipeLength * positionOffset;
      } else {
          _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
      }
      if (_.options.verticalSwiping === true) {
          _.swipeLeft = curLeft + swipeLength * positionOffset;
      }

      if (_.options.fade === true || _.options.touchMove === false) {
          return false;
      }

      if (_.animating === true) {
          _.swipeLeft = null;
          return false;
      }

      _.setCSS(_.swipeLeft);

  };

  Slick.prototype.swipeStart = function(event) {

      var _ = this,
          touches;

      _.interrupted = true;

      if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
          _.touchObject = {};
          return false;
      }

      if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
          touches = event.originalEvent.touches[0];
      }

      _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
      _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

      _.dragging = true;

  };

  Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {

      var _ = this;

      if (_.$slidesCache !== null) {

          _.unload();

          _.$slideTrack.children(this.options.slide).detach();

          _.$slidesCache.appendTo(_.$slideTrack);

          _.reinit();

      }

  };

  Slick.prototype.unload = function() {

      var _ = this;

      $('.slick-cloned', _.$slider).remove();

      if (_.$dots) {
          _.$dots.remove();
      }

      if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
          _.$prevArrow.remove();
      }

      if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
          _.$nextArrow.remove();
      }

      _.$slides
          .removeClass('slick-slide slick-active slick-visible slick-current')
          .attr('aria-hidden', 'true')
          .css('width', '');

  };

  Slick.prototype.unslick = function(fromBreakpoint) {

      var _ = this;
      _.$slider.trigger('unslick', [_, fromBreakpoint]);
      _.destroy();

  };

  Slick.prototype.updateArrows = function() {
      var _ = this,
          centerOffset;

      centerOffset = Math.floor(_.options.slidesToShow / 2);

      if ( _.options.arrows === true &&
          _.slideCount > _.options.slidesToShow &&
          !_.options.infinite ) {

          _.$prevArrow.removeClass('slick-disabled').prop('disabled', false);
          _.$nextArrow.removeClass('slick-disabled').prop('disabled', false);

          if (_.currentSlide === 0) {

              if(document.activeElement === _.$prevArrow.get(0)) {
                  _.$slider.get(0).focus();
              }

              _.$prevArrow.addClass('slick-disabled').prop('disabled', true);
              _.$nextArrow.removeClass('slick-disabled').prop('disabled', false);

          } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

              if(document.activeElement === _.$nextArrow.get(0)) {
                  _.$slider.get(0).focus();
              }

              _.$nextArrow.addClass('slick-disabled').prop('disabled', true);
              _.$prevArrow.removeClass('slick-disabled').prop('disabled', false);

          } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

              if(document.activeElement === _.$nextArrow.get(0)) {
                  _.$slider.get(0).focus();
              }

              _.$nextArrow.addClass('slick-disabled').prop('disabled', true);
              _.$prevArrow.removeClass('slick-disabled').prop('disabled', false);

          }

      }

  };

  Slick.prototype.updateDots = function() {

      var _ = this;

      if (_.$dots !== null) {

          _.$dots
              .find('li')
                  .removeClass('slick-active')
                  .find('button')
                      .removeAttr('aria-current')
                      .end()
                  .end();

          _.$dots
              .find('li')
              .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                  .addClass('slick-active')
                  .find('button')
                      .attr('aria-current', true)
                      .end()
                  .end();

      }

  };

  Slick.prototype.updateSlideVisibility = function() {
      var _ = this;

      _.$slideTrack
          .find('.slick-slide')
              .attr('aria-hidden', 'true')
              .find('a, input, button, select')
                  .attr('tabindex', '-1');

      _.$slideTrack
          .find('.slick-active')
              .removeAttr('aria-hidden')
              .find('a, input, button, select')
                  .removeAttr('tabindex');
  }

  Slick.prototype.visibility = function() {

      var _ = this;

      if ( _.options.autoplay ) {

          if ( document[_.hidden] ) {

              _.interrupted = true;

          } else {

              _.interrupted = false;

          }

      }

  };

  $.fn.slick = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
          if (typeof opt == 'object' || typeof opt == 'undefined')
              _[i].slick = new Slick(_[i], opt);
          else
              ret = _[i].slick[opt].apply(_[i].slick, args);
          if (typeof ret != 'undefined') return ret;
      }
      return _;
  };

}));
/* ========================================================================
 * Bootstrap: modal.js v3.3.7
 * http://getbootstrap.com/javascript/#modals
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */



(function ($) {
  'use strict';

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options = options
    this.$body = $(document.body)
    this.$element = $(element)
    this.$dialog = this.$element.find('.modal-dialog')
    this.$backdrop = null
    this.isShown = null
    this.originalBodyPad = null
    this.scrollbarWidth = 0
    this.ignoreBackdropClick = false

    if (this.options.remote) {
      this.$element
        .find('.modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.bs.modal')
        }, this))
    }
  }

  Modal.VERSION = '3.3.7'

  Modal.TRANSITION_DURATION = 300
  Modal.BACKDROP_TRANSITION_DURATION = 150

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  }

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget)
  }

  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e = $.Event('show.bs.modal', {
      relatedTarget: _relatedTarget
    })

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.checkScrollbar()
    this.setScrollbar()
    this.$body.addClass('modal-open')

    this.escape()
    this.resize()

    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
      })
    })

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      that.adjustDialog()

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element.addClass('in')

      that.enforceFocus()

      var e = $.Event('shown.bs.modal', {
        relatedTarget: _relatedTarget
      })

      transition ?
        that.$dialog // wait for modal to slide in
        .one('bsTransitionEnd', function () {
          that.$element.trigger('focus').trigger(e)
        })
        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
        that.$element.trigger('focus').trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()

    e = $.Event('hide.bs.modal')

    this.$element.trigger(e)

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()
    this.resize()

    $(document).off('focusin.bs.modal')

    this.$element
      .removeClass('in')
      .off('click.dismiss.bs.modal')
      .off('mouseup.dismiss.bs.modal')

    this.$dialog.off('mousedown.dismiss.bs.modal')

    $.support.transition && this.$element.hasClass('fade') ?
      this.$element
      .one('bsTransitionEnd', $.proxy(this.hideModal, this))
      .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
      this.hideModal()
  }

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on('focusin.bs.modal', $.proxy(function (e) {
        if (document !== e.target &&
          this.$element[0] !== e.target &&
          !this.$element.has(e.target).length) {
          this.$element.trigger('focus')
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal')
    }
  }

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
    } else {
      $(window).off('resize.bs.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      that.$body.removeClass('modal-open')
      that.resetAdjustments()
      that.resetScrollbar()
      that.$element.trigger('hidden.bs.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var that = this
    var animate = this.$element.hasClass('fade') ? 'fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate

      this.$backdrop = $(document.createElement('div'))
        .addClass('modal-backdrop ' + animate)
        .appendTo(this.$body)

      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
        if (this.ignoreBackdropClick) {
          this.ignoreBackdropClick = false
          return
        }
        if (e.target !== e.currentTarget) return
        this.options.backdrop == 'static' ?
          this.$element[0].focus() :
          this.hide()
      }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
        .one('bsTransitionEnd', callback)
        .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      var callbackRemove = function () {
        that.removeBackdrop()
        callback && callback()
      }
      $.support.transition && this.$element.hasClass('fade') ?
        this.$backdrop
        .one('bsTransitionEnd', callbackRemove)
        .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callbackRemove()

    } else if (callback) {
      callback()
    }
  }

  // these following methods are used to handle overflowing modals

  Modal.prototype.handleUpdate = function () {
    this.adjustDialog()
  }

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

    this.$element.css({
      paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    })
  }

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    })
  }

  Modal.prototype.checkScrollbar = function () {
    var fullWindowWidth = window.innerWidth
    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
      var documentElementRect = document.documentElement.getBoundingClientRect()
      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
    }
    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
    this.scrollbarWidth = this.measureScrollbar()
  }

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
    this.originalBodyPad = document.body.style.paddingRight || ''
    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
  }

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', this.originalBodyPad)
  }

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement('div')
    scrollDiv.className = 'modal-scrollbar-measure'
    this.$body.append(scrollDiv)
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    this.$body[0].removeChild(scrollDiv)
    return scrollbarWidth
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this = $(this)
      var data = $this.data('bs.modal')
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option](_relatedTarget)
      else if (options.show) data.show(_relatedTarget)
    })
  }

  var old = $.fn.modal

  $.fn.modal = Plugin
  $.fn.modal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


  // MODAL DATA-API
  // ==============

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this = $(this)
    var href = $this.attr('href')
    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
    var option = $target.data('bs.modal') ? 'toggle' : $.extend({
      remote: !/#/.test(href) && href
    }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
      $target.one('hidden.bs.modal', function () {
        $this.is(':visible') && $this.trigger('focus')
      })
    })
    Plugin.call($target, option, this)
  })

})(jQuery);
/* airbrake-js v1.4.1 */

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.Airbrake = {}));
}(this, (function (exports) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    /**
     * @this {Promise}
     */
    function finallyConstructor(callback) {
      var constructor = this.constructor;
      return this.then(
        function(value) {
          // @ts-ignore
          return constructor.resolve(callback()).then(function() {
            return value;
          });
        },
        function(reason) {
          // @ts-ignore
          return constructor.resolve(callback()).then(function() {
            // @ts-ignore
            return constructor.reject(reason);
          });
        }
      );
    }

    // Store setTimeout reference so promise-polyfill will be unaffected by
    // other code modifying setTimeout (like sinon.useFakeTimers())
    var setTimeoutFunc = setTimeout;

    function isArray(x) {
      return Boolean(x && typeof x.length !== 'undefined');
    }

    function noop() {}

    // Polyfill for Function.prototype.bind
    function bind(fn, thisArg) {
      return function() {
        fn.apply(thisArg, arguments);
      };
    }

    /**
     * @constructor
     * @param {Function} fn
     */
    function Promise$1(fn) {
      if (!(this instanceof Promise$1))
        throw new TypeError('Promises must be constructed via new');
      if (typeof fn !== 'function') throw new TypeError('not a function');
      /** @type {!number} */
      this._state = 0;
      /** @type {!boolean} */
      this._handled = false;
      /** @type {Promise|undefined} */
      this._value = undefined;
      /** @type {!Array<!Function>} */
      this._deferreds = [];

      doResolve(fn, this);
    }

    function handle(self, deferred) {
      while (self._state === 3) {
        self = self._value;
      }
      if (self._state === 0) {
        self._deferreds.push(deferred);
        return;
      }
      self._handled = true;
      Promise$1._immediateFn(function() {
        var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
        if (cb === null) {
          (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
          return;
        }
        var ret;
        try {
          ret = cb(self._value);
        } catch (e) {
          reject(deferred.promise, e);
          return;
        }
        resolve(deferred.promise, ret);
      });
    }

    function resolve(self, newValue) {
      try {
        // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
        if (newValue === self)
          throw new TypeError('A promise cannot be resolved with itself.');
        if (
          newValue &&
          (typeof newValue === 'object' || typeof newValue === 'function')
        ) {
          var then = newValue.then;
          if (newValue instanceof Promise$1) {
            self._state = 3;
            self._value = newValue;
            finale(self);
            return;
          } else if (typeof then === 'function') {
            doResolve(bind(then, newValue), self);
            return;
          }
        }
        self._state = 1;
        self._value = newValue;
        finale(self);
      } catch (e) {
        reject(self, e);
      }
    }

    function reject(self, newValue) {
      self._state = 2;
      self._value = newValue;
      finale(self);
    }

    function finale(self) {
      if (self._state === 2 && self._deferreds.length === 0) {
        Promise$1._immediateFn(function() {
          if (!self._handled) {
            Promise$1._unhandledRejectionFn(self._value);
          }
        });
      }

      for (var i = 0, len = self._deferreds.length; i < len; i++) {
        handle(self, self._deferreds[i]);
      }
      self._deferreds = null;
    }

    /**
     * @constructor
     */
    function Handler(onFulfilled, onRejected, promise) {
      this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
      this.onRejected = typeof onRejected === 'function' ? onRejected : null;
      this.promise = promise;
    }

    /**
     * Take a potentially misbehaving resolver function and make sure
     * onFulfilled and onRejected are only called once.
     *
     * Makes no guarantees about asynchrony.
     */
    function doResolve(fn, self) {
      var done = false;
      try {
        fn(
          function(value) {
            if (done) return;
            done = true;
            resolve(self, value);
          },
          function(reason) {
            if (done) return;
            done = true;
            reject(self, reason);
          }
        );
      } catch (ex) {
        if (done) return;
        done = true;
        reject(self, ex);
      }
    }

    Promise$1.prototype['catch'] = function(onRejected) {
      return this.then(null, onRejected);
    };

    Promise$1.prototype.then = function(onFulfilled, onRejected) {
      // @ts-ignore
      var prom = new this.constructor(noop);

      handle(this, new Handler(onFulfilled, onRejected, prom));
      return prom;
    };

    Promise$1.prototype['finally'] = finallyConstructor;

    Promise$1.all = function(arr) {
      return new Promise$1(function(resolve, reject) {
        if (!isArray(arr)) {
          return reject(new TypeError('Promise.all accepts an array'));
        }

        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;

        function res(i, val) {
          try {
            if (val && (typeof val === 'object' || typeof val === 'function')) {
              var then = val.then;
              if (typeof then === 'function') {
                then.call(
                  val,
                  function(val) {
                    res(i, val);
                  },
                  reject
                );
                return;
              }
            }
            args[i] = val;
            if (--remaining === 0) {
              resolve(args);
            }
          } catch (ex) {
            reject(ex);
          }
        }

        for (var i = 0; i < args.length; i++) {
          res(i, args[i]);
        }
      });
    };

    Promise$1.resolve = function(value) {
      if (value && typeof value === 'object' && value.constructor === Promise$1) {
        return value;
      }

      return new Promise$1(function(resolve) {
        resolve(value);
      });
    };

    Promise$1.reject = function(value) {
      return new Promise$1(function(resolve, reject) {
        reject(value);
      });
    };

    Promise$1.race = function(arr) {
      return new Promise$1(function(resolve, reject) {
        if (!isArray(arr)) {
          return reject(new TypeError('Promise.race accepts an array'));
        }

        for (var i = 0, len = arr.length; i < len; i++) {
          Promise$1.resolve(arr[i]).then(resolve, reject);
        }
      });
    };

    // Use polyfill for setImmediate for performance gains
    Promise$1._immediateFn =
      // @ts-ignore
      (typeof setImmediate === 'function' &&
        function(fn) {
          // @ts-ignore
          setImmediate(fn);
        }) ||
      function(fn) {
        setTimeoutFunc(fn, 0);
      };

    Promise$1._unhandledRejectionFn = function _unhandledRejectionFn(err) {
      if (typeof console !== 'undefined' && console) {
        console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
      }
    };

    var FILTERED = '[Filtered]';
    var MAX_OBJ_LENGTH = 128;
    // jsonifyNotice serializes notice to JSON and truncates params,
    // environment and session keys.
    function jsonifyNotice(notice, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.maxLength, maxLength = _c === void 0 ? 64000 : _c, _d = _b.keysBlocklist, keysBlocklist = _d === void 0 ? [] : _d;
        if (notice.errors) {
            for (var i = 0; i < notice.errors.length; i++) {
                var t = new Truncator({ keysBlocklist: keysBlocklist });
                notice.errors[i] = t.truncate(notice.errors[i]);
            }
        }
        var s = '';
        var keys = ['context', 'params', 'environment', 'session'];
        for (var level = 0; level < 8; level++) {
            var opts = { level: level, keysBlocklist: keysBlocklist };
            for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                var key = keys_1[_i];
                var obj = notice[key];
                if (obj) {
                    notice[key] = truncate(obj, opts);
                }
            }
            s = JSON.stringify(notice);
            if (s.length < maxLength) {
                return s;
            }
        }
        var params = {
            json: s.slice(0, Math.floor(maxLength / 2)) + '...',
        };
        keys.push('errors');
        for (var _e = 0, keys_2 = keys; _e < keys_2.length; _e++) {
            var key = keys_2[_e];
            var obj = notice[key];
            if (!obj) {
                continue;
            }
            s = JSON.stringify(obj);
            params[key] = s.length;
        }
        var err = new Error("airbrake: notice exceeds max length and can't be truncated");
        err.params = params;
        throw err;
    }
    function scale(num, level) {
        return num >> level || 1;
    }
    var Truncator = /** @class */ (function () {
        function Truncator(opts) {
            this.maxStringLength = 1024;
            this.maxObjectLength = MAX_OBJ_LENGTH;
            this.maxArrayLength = MAX_OBJ_LENGTH;
            this.maxDepth = 8;
            this.keys = [];
            this.keysBlocklist = [];
            this.seen = [];
            var level = opts.level || 0;
            this.keysBlocklist = opts.keysBlocklist || [];
            this.maxStringLength = scale(this.maxStringLength, level);
            this.maxObjectLength = scale(this.maxObjectLength, level);
            this.maxArrayLength = scale(this.maxArrayLength, level);
            this.maxDepth = scale(this.maxDepth, level);
        }
        Truncator.prototype.truncate = function (value, key, depth) {
            if (key === void 0) { key = ''; }
            if (depth === void 0) { depth = 0; }
            if (value === null || value === undefined) {
                return value;
            }
            switch (typeof value) {
                case 'boolean':
                case 'number':
                case 'function':
                    return value;
                case 'string':
                    return this.truncateString(value);
                case 'object':
                    break;
                default:
                    return this.truncateString(String(value));
            }
            if (value instanceof String) {
                return this.truncateString(value.toString());
            }
            if (value instanceof Boolean ||
                value instanceof Number ||
                value instanceof Date ||
                value instanceof RegExp) {
                return value;
            }
            if (value instanceof Error) {
                return this.truncateString(value.toString());
            }
            if (this.seen.indexOf(value) >= 0) {
                return "[Circular " + this.getPath(value) + "]";
            }
            var type = objectType(value);
            depth++;
            if (depth > this.maxDepth) {
                return "[Truncated " + type + "]";
            }
            this.keys.push(key);
            this.seen.push(value);
            switch (type) {
                case 'Array':
                    return this.truncateArray(value, depth);
                case 'Object':
                    return this.truncateObject(value, depth);
                default:
                    var saved = this.maxDepth;
                    this.maxDepth = 0;
                    var obj = this.truncateObject(value, depth);
                    obj.__type = type;
                    this.maxDepth = saved;
                    return obj;
            }
        };
        Truncator.prototype.getPath = function (value) {
            var index = this.seen.indexOf(value);
            var path = [this.keys[index]];
            for (var i = index; i >= 0; i--) {
                var sub = this.seen[i];
                if (sub && getAttr(sub, path[0]) === value) {
                    value = sub;
                    path.unshift(this.keys[i]);
                }
            }
            return '~' + path.join('.');
        };
        Truncator.prototype.truncateString = function (s) {
            if (s.length > this.maxStringLength) {
                return s.slice(0, this.maxStringLength) + '...';
            }
            return s;
        };
        Truncator.prototype.truncateArray = function (arr, depth) {
            if (depth === void 0) { depth = 0; }
            var length = 0;
            var dst = [];
            for (var i = 0; i < arr.length; i++) {
                var el = arr[i];
                dst.push(this.truncate(el, i.toString(), depth));
                length++;
                if (length >= this.maxArrayLength) {
                    break;
                }
            }
            return dst;
        };
        Truncator.prototype.truncateObject = function (obj, depth) {
            if (depth === void 0) { depth = 0; }
            var length = 0;
            var dst = {};
            for (var key in obj) {
                if (!Object.prototype.hasOwnProperty.call(obj, key)) {
                    continue;
                }
                if (isBlocklisted(key, this.keysBlocklist)) {
                    dst[key] = FILTERED;
                    continue;
                }
                var value = getAttr(obj, key);
                if (value === undefined || typeof value === 'function') {
                    continue;
                }
                dst[key] = this.truncate(value, key, depth);
                length++;
                if (length >= this.maxObjectLength) {
                    break;
                }
            }
            return dst;
        };
        return Truncator;
    }());
    function truncate(value, opts) {
        if (opts === void 0) { opts = {}; }
        var t = new Truncator(opts);
        return t.truncate(value);
    }
    function getAttr(obj, attr) {
        // Ignore browser specific exception trying to read an attribute (#79).
        try {
            return obj[attr];
        }
        catch (_) {
            return;
        }
    }
    function objectType(obj) {
        var s = Object.prototype.toString.apply(obj);
        return s.slice('[object '.length, -1);
    }
    function isBlocklisted(key, keysBlocklist) {
        for (var _i = 0, keysBlocklist_1 = keysBlocklist; _i < keysBlocklist_1.length; _i++) {
            var v = keysBlocklist_1[_i];
            if (v === key) {
                return true;
            }
            if (v instanceof RegExp) {
                if (key.match(v)) {
                    return true;
                }
            }
        }
        return false;
    }

    var Span = /** @class */ (function () {
        function Span(metric, name, startTime) {
            this._dur = 0;
            this._level = 0;
            this._metric = metric;
            this.name = name;
            this.startTime = startTime || new Date();
        }
        Span.prototype.end = function (endTime) {
            this.endTime = endTime ? endTime : new Date();
            this._dur += this.endTime.getTime() - this.startTime.getTime();
            this._metric._incGroup(this.name, this._dur);
            this._metric = null;
        };
        Span.prototype._pause = function () {
            if (this._paused()) {
                return;
            }
            var now = new Date();
            this._dur += now.getTime() - this.startTime.getTime();
            this.startTime = null;
        };
        Span.prototype._resume = function () {
            if (!this._paused()) {
                return;
            }
            this.startTime = new Date();
        };
        Span.prototype._paused = function () {
            return this.startTime == null;
        };
        return Span;
    }());
    var BaseMetric = /** @class */ (function () {
        function BaseMetric() {
            this._spans = {};
            this._groups = {};
            this.startTime = new Date();
        }
        BaseMetric.prototype.end = function (endTime) {
            if (!this.endTime) {
                this.endTime = endTime || new Date();
            }
        };
        BaseMetric.prototype.isRecording = function () {
            return true;
        };
        BaseMetric.prototype.startSpan = function (name, startTime) {
            var span = this._spans[name];
            if (span) {
                span._level++;
            }
            else {
                span = new Span(this, name, startTime);
                this._spans[name] = span;
            }
        };
        BaseMetric.prototype.endSpan = function (name, endTime) {
            var span = this._spans[name];
            if (!span) {
                console.error('airbrake: span=%s does not exist', name);
                return;
            }
            if (span._level > 0) {
                span._level--;
            }
            else {
                span.end(endTime);
                delete this._spans[span.name];
            }
        };
        BaseMetric.prototype._incGroup = function (name, ms) {
            this._groups[name] = (this._groups[name] || 0) + ms;
        };
        BaseMetric.prototype._duration = function () {
            if (!this.endTime) {
                this.endTime = new Date();
            }
            return this.endTime.getTime() - this.startTime.getTime();
        };
        return BaseMetric;
    }());
    var NoopMetric = /** @class */ (function () {
        function NoopMetric() {
        }
        NoopMetric.prototype.isRecording = function () {
            return false;
        };
        NoopMetric.prototype.startSpan = function (_name, _startTime) { };
        NoopMetric.prototype.endSpan = function (_name, _startTime) { };
        NoopMetric.prototype._incGroup = function (_name, _ms) { };
        return NoopMetric;
    }());

    var Scope = /** @class */ (function () {
        function Scope() {
            this._noopMetric = new NoopMetric();
            this._context = {};
            this._historyMaxLen = 20;
            this._history = [];
        }
        Scope.prototype.clone = function () {
            var clone = new Scope();
            clone._context = __assign({}, this._context);
            clone._history = this._history.slice();
            return clone;
        };
        Scope.prototype.setContext = function (context) {
            this._context = __assign(__assign({}, this._context), context);
        };
        Scope.prototype.context = function () {
            var ctx = __assign({}, this._context);
            if (this._history.length > 0) {
                ctx.history = this._history.slice();
            }
            return ctx;
        };
        Scope.prototype.pushHistory = function (state) {
            if (this._isDupState(state)) {
                if (this._lastRecord.num) {
                    this._lastRecord.num++;
                }
                else {
                    this._lastRecord.num = 2;
                }
                return;
            }
            if (!state.date) {
                state.date = new Date();
            }
            this._history.push(state);
            this._lastRecord = state;
            if (this._history.length > this._historyMaxLen) {
                this._history = this._history.slice(-this._historyMaxLen);
            }
        };
        Scope.prototype._isDupState = function (state) {
            if (!this._lastRecord) {
                return false;
            }
            for (var key in state) {
                if (!state.hasOwnProperty(key) || key === 'date') {
                    continue;
                }
                if (state[key] !== this._lastRecord[key]) {
                    return false;
                }
            }
            return true;
        };
        Scope.prototype.routeMetric = function () {
            return this._routeMetric || this._noopMetric;
        };
        Scope.prototype.setRouteMetric = function (metric) {
            this._routeMetric = metric;
        };
        Scope.prototype.queueMetric = function () {
            return this._queueMetric || this._noopMetric;
        };
        Scope.prototype.setQueueMetric = function (metric) {
            this._queueMetric = metric;
        };
        return Scope;
    }());

    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

    function createCommonjsModule(fn, basedir, module) {
    	return module = {
    	  path: basedir,
    	  exports: {},
    	  require: function (path, base) {
          return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
        }
    	}, fn(module, module.exports), module.exports;
    }

    function commonjsRequire () {
    	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
    }

    var stackframe = createCommonjsModule(function (module, exports) {
    (function(root, factory) {
        // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

        /* istanbul ignore next */
        {
            module.exports = factory();
        }
    }(commonjsGlobal, function() {
        function _isNumber(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }

        function _capitalize(str) {
            return str.charAt(0).toUpperCase() + str.substring(1);
        }

        function _getter(p) {
            return function() {
                return this[p];
            };
        }

        var booleanProps = ['isConstructor', 'isEval', 'isNative', 'isToplevel'];
        var numericProps = ['columnNumber', 'lineNumber'];
        var stringProps = ['fileName', 'functionName', 'source'];
        var arrayProps = ['args'];

        var props = booleanProps.concat(numericProps, stringProps, arrayProps);

        function StackFrame(obj) {
            if (!obj) return;
            for (var i = 0; i < props.length; i++) {
                if (obj[props[i]] !== undefined) {
                    this['set' + _capitalize(props[i])](obj[props[i]]);
                }
            }
        }

        StackFrame.prototype = {
            getArgs: function() {
                return this.args;
            },
            setArgs: function(v) {
                if (Object.prototype.toString.call(v) !== '[object Array]') {
                    throw new TypeError('Args must be an Array');
                }
                this.args = v;
            },

            getEvalOrigin: function() {
                return this.evalOrigin;
            },
            setEvalOrigin: function(v) {
                if (v instanceof StackFrame) {
                    this.evalOrigin = v;
                } else if (v instanceof Object) {
                    this.evalOrigin = new StackFrame(v);
                } else {
                    throw new TypeError('Eval Origin must be an Object or StackFrame');
                }
            },

            toString: function() {
                var fileName = this.getFileName() || '';
                var lineNumber = this.getLineNumber() || '';
                var columnNumber = this.getColumnNumber() || '';
                var functionName = this.getFunctionName() || '';
                if (this.getIsEval()) {
                    if (fileName) {
                        return '[eval] (' + fileName + ':' + lineNumber + ':' + columnNumber + ')';
                    }
                    return '[eval]:' + lineNumber + ':' + columnNumber;
                }
                if (functionName) {
                    return functionName + ' (' + fileName + ':' + lineNumber + ':' + columnNumber + ')';
                }
                return fileName + ':' + lineNumber + ':' + columnNumber;
            }
        };

        StackFrame.fromString = function StackFrame$$fromString(str) {
            var argsStartIndex = str.indexOf('(');
            var argsEndIndex = str.lastIndexOf(')');

            var functionName = str.substring(0, argsStartIndex);
            var args = str.substring(argsStartIndex + 1, argsEndIndex).split(',');
            var locationString = str.substring(argsEndIndex + 1);

            if (locationString.indexOf('@') === 0) {
                var parts = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(locationString, '');
                var fileName = parts[1];
                var lineNumber = parts[2];
                var columnNumber = parts[3];
            }

            return new StackFrame({
                functionName: functionName,
                args: args || undefined,
                fileName: fileName,
                lineNumber: lineNumber || undefined,
                columnNumber: columnNumber || undefined
            });
        };

        for (var i = 0; i < booleanProps.length; i++) {
            StackFrame.prototype['get' + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);
            StackFrame.prototype['set' + _capitalize(booleanProps[i])] = (function(p) {
                return function(v) {
                    this[p] = Boolean(v);
                };
            })(booleanProps[i]);
        }

        for (var j = 0; j < numericProps.length; j++) {
            StackFrame.prototype['get' + _capitalize(numericProps[j])] = _getter(numericProps[j]);
            StackFrame.prototype['set' + _capitalize(numericProps[j])] = (function(p) {
                return function(v) {
                    if (!_isNumber(v)) {
                        throw new TypeError(p + ' must be a Number');
                    }
                    this[p] = Number(v);
                };
            })(numericProps[j]);
        }

        for (var k = 0; k < stringProps.length; k++) {
            StackFrame.prototype['get' + _capitalize(stringProps[k])] = _getter(stringProps[k]);
            StackFrame.prototype['set' + _capitalize(stringProps[k])] = (function(p) {
                return function(v) {
                    this[p] = String(v);
                };
            })(stringProps[k]);
        }

        return StackFrame;
    }));
    });

    var errorStackParser = createCommonjsModule(function (module, exports) {
    (function(root, factory) {
        // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

        /* istanbul ignore next */
        {
            module.exports = factory(stackframe);
        }
    }(commonjsGlobal, function ErrorStackParser(StackFrame) {

        var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+:\d+/;
        var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+:\d+|\(native\))/m;
        var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code])?$/;

        return {
            /**
             * Given an Error object, extract the most information from it.
             *
             * @param {Error} error object
             * @return {Array} of StackFrames
             */
            parse: function ErrorStackParser$$parse(error) {
                if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') {
                    return this.parseOpera(error);
                } else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) {
                    return this.parseV8OrIE(error);
                } else if (error.stack) {
                    return this.parseFFOrSafari(error);
                } else {
                    throw new Error('Cannot parse given Error object');
                }
            },

            // Separate line and column numbers from a string of the form: (URI:Line:Column)
            extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
                // Fail-fast but return locations like "(native)"
                if (urlLike.indexOf(':') === -1) {
                    return [urlLike];
                }

                var regExp = /(.+?)(?::(\d+))?(?::(\d+))?$/;
                var parts = regExp.exec(urlLike.replace(/[()]/g, ''));
                return [parts[1], parts[2] || undefined, parts[3] || undefined];
            },

            parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
                var filtered = error.stack.split('\n').filter(function(line) {
                    return !!line.match(CHROME_IE_STACK_REGEXP);
                }, this);

                return filtered.map(function(line) {
                    if (line.indexOf('(eval ') > -1) {
                        // Throw away eval information until we implement stacktrace.js/stackframe#8
                        line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^()]*)|(\),.*$)/g, '');
                    }
                    var sanitizedLine = line.replace(/^\s+/, '').replace(/\(eval code/g, '(');

                    // capture and preseve the parenthesized location "(/foo/my bar.js:12:87)" in
                    // case it has spaces in it, as the string is split on \s+ later on
                    var location = sanitizedLine.match(/ (\((.+):(\d+):(\d+)\)$)/);

                    // remove the parenthesized location from the line, if it was matched
                    sanitizedLine = location ? sanitizedLine.replace(location[0], '') : sanitizedLine;

                    var tokens = sanitizedLine.split(/\s+/).slice(1);
                    // if a location was matched, pass it to extractLocation() otherwise pop the last token
                    var locationParts = this.extractLocation(location ? location[1] : tokens.pop());
                    var functionName = tokens.join(' ') || undefined;
                    var fileName = ['eval', '<anonymous>'].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];

                    return new StackFrame({
                        functionName: functionName,
                        fileName: fileName,
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }, this);
            },

            parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
                var filtered = error.stack.split('\n').filter(function(line) {
                    return !line.match(SAFARI_NATIVE_CODE_REGEXP);
                }, this);

                return filtered.map(function(line) {
                    // Throw away eval information until we implement stacktrace.js/stackframe#8
                    if (line.indexOf(' > eval') > -1) {
                        line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ':$1');
                    }

                    if (line.indexOf('@') === -1 && line.indexOf(':') === -1) {
                        // Safari eval frames only have function names and nothing else
                        return new StackFrame({
                            functionName: line
                        });
                    } else {
                        var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
                        var matches = line.match(functionNameRegex);
                        var functionName = matches && matches[1] ? matches[1] : undefined;
                        var locationParts = this.extractLocation(line.replace(functionNameRegex, ''));

                        return new StackFrame({
                            functionName: functionName,
                            fileName: locationParts[0],
                            lineNumber: locationParts[1],
                            columnNumber: locationParts[2],
                            source: line
                        });
                    }
                }, this);
            },

            parseOpera: function ErrorStackParser$$parseOpera(e) {
                if (!e.stacktrace || (e.message.indexOf('\n') > -1 &&
                    e.message.split('\n').length > e.stacktrace.split('\n').length)) {
                    return this.parseOpera9(e);
                } else if (!e.stack) {
                    return this.parseOpera10(e);
                } else {
                    return this.parseOpera11(e);
                }
            },

            parseOpera9: function ErrorStackParser$$parseOpera9(e) {
                var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
                var lines = e.message.split('\n');
                var result = [];

                for (var i = 2, len = lines.length; i < len; i += 2) {
                    var match = lineRE.exec(lines[i]);
                    if (match) {
                        result.push(new StackFrame({
                            fileName: match[2],
                            lineNumber: match[1],
                            source: lines[i]
                        }));
                    }
                }

                return result;
            },

            parseOpera10: function ErrorStackParser$$parseOpera10(e) {
                var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
                var lines = e.stacktrace.split('\n');
                var result = [];

                for (var i = 0, len = lines.length; i < len; i += 2) {
                    var match = lineRE.exec(lines[i]);
                    if (match) {
                        result.push(
                            new StackFrame({
                                functionName: match[3] || undefined,
                                fileName: match[2],
                                lineNumber: match[1],
                                source: lines[i]
                            })
                        );
                    }
                }

                return result;
            },

            // Opera 10.65+ Error.stack very similar to FF/Safari
            parseOpera11: function ErrorStackParser$$parseOpera11(error) {
                var filtered = error.stack.split('\n').filter(function(line) {
                    return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
                }, this);

                return filtered.map(function(line) {
                    var tokens = line.split('@');
                    var locationParts = this.extractLocation(tokens.pop());
                    var functionCall = (tokens.shift() || '');
                    var functionName = functionCall
                        .replace(/<anonymous function(: (\w+))?>/, '$2')
                        .replace(/\([^)]*\)/g, '') || undefined;
                    var argsRaw;
                    if (functionCall.match(/\(([^)]*)\)/)) {
                        argsRaw = functionCall.replace(/^[^(]+\(([^)]*)\)$/, '$1');
                    }
                    var args = (argsRaw === undefined || argsRaw === '[arguments not available]') ?
                        undefined : argsRaw.split(',');

                    return new StackFrame({
                        functionName: functionName,
                        args: args,
                        fileName: locationParts[0],
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }, this);
            }
        };
    }));
    });

    var hasConsole = typeof console === 'object' && console.warn;
    function parse(err) {
        try {
            return errorStackParser.parse(err);
        }
        catch (parseErr) {
            if (hasConsole && err.stack) {
                console.warn('ErrorStackParser:', parseErr.toString(), err.stack);
            }
        }
        if (err.fileName) {
            return [err];
        }
        return [];
    }
    function espProcessor(err) {
        var backtrace = [];
        if (err.noStack) {
            backtrace.push({
                function: err.functionName || '',
                file: err.fileName || '',
                line: err.lineNumber || 0,
                column: err.columnNumber || 0,
            });
        }
        else {
            var frames_2 = parse(err);
            if (frames_2.length === 0) {
                try {
                    throw new Error('fake');
                }
                catch (fakeErr) {
                    frames_2 = parse(fakeErr);
                    frames_2.shift();
                    frames_2.shift();
                }
            }
            for (var _i = 0, frames_1 = frames_2; _i < frames_1.length; _i++) {
                var frame = frames_1[_i];
                backtrace.push({
                    function: frame.functionName || '',
                    file: frame.fileName || '',
                    line: frame.lineNumber || 0,
                    column: frame.columnNumber || 0,
                });
            }
        }
        var type = err.name ? err.name : '';
        var msg = err.message ? String(err.message) : String(err);
        return {
            type: type,
            message: msg,
            backtrace: backtrace,
        };
    }

    var re = new RegExp([
        '^',
        '\\[(\\$.+)\\]',
        '\\s',
        '([\\s\\S]+)',
        '$',
    ].join(''));
    function angularMessageFilter(notice) {
        var err = notice.errors[0];
        if (err.type !== '' && err.type !== 'Error') {
            return notice;
        }
        var m = err.message.match(re);
        if (m !== null) {
            err.type = m[1];
            err.message = m[2];
        }
        return notice;
    }

    function makeDebounceFilter() {
        var lastNoticeJSON;
        var timeout;
        return function (notice) {
            var s = JSON.stringify(notice.errors);
            if (s === lastNoticeJSON) {
                return null;
            }
            if (timeout) {
                clearTimeout(timeout);
            }
            lastNoticeJSON = s;
            timeout = setTimeout(function () {
                lastNoticeJSON = '';
            }, 1000);
            return notice;
        };
    }

    var IGNORED_MESSAGES = [
        'Script error',
        'Script error.',
        'InvalidAccessError',
    ];
    function ignoreNoiseFilter(notice) {
        var err = notice.errors[0];
        if (err.type === '' && IGNORED_MESSAGES.indexOf(err.message) !== -1) {
            return null;
        }
        if (err.backtrace && err.backtrace.length > 0) {
            var frame = err.backtrace[0];
            if (frame.file === '<anonymous>') {
                return null;
            }
        }
        return notice;
    }

    var re$1 = new RegExp([
        '^',
        'Uncaught\\s',
        '(.+?)',
        ':\\s',
        '(.+)',
        '$',
    ].join(''));
    function uncaughtMessageFilter(notice) {
        var err = notice.errors[0];
        if (err.type !== '' && err.type !== 'Error') {
            return notice;
        }
        var m = err.message.match(re$1);
        if (m !== null) {
            err.type = m[1];
            err.message = m[2];
        }
        return notice;
    }

    var browserPonyfill = createCommonjsModule(function (module, exports) {
    var __self__ = (function (root) {
    function F() {
    this.fetch = false;
    this.DOMException = root.DOMException;
    }
    F.prototype = root;
    return new F();
    })(typeof self !== 'undefined' ? self : commonjsGlobal);
    (function(self) {

    var irrelevant = (function (exports) {
      var support = {
        searchParams: 'URLSearchParams' in self,
        iterable: 'Symbol' in self && 'iterator' in Symbol,
        blob:
          'FileReader' in self &&
          'Blob' in self &&
          (function() {
            try {
              new Blob();
              return true
            } catch (e) {
              return false
            }
          })(),
        formData: 'FormData' in self,
        arrayBuffer: 'ArrayBuffer' in self
      };

      function isDataView(obj) {
        return obj && DataView.prototype.isPrototypeOf(obj)
      }

      if (support.arrayBuffer) {
        var viewClasses = [
          '[object Int8Array]',
          '[object Uint8Array]',
          '[object Uint8ClampedArray]',
          '[object Int16Array]',
          '[object Uint16Array]',
          '[object Int32Array]',
          '[object Uint32Array]',
          '[object Float32Array]',
          '[object Float64Array]'
        ];

        var isArrayBufferView =
          ArrayBuffer.isView ||
          function(obj) {
            return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
          };
      }

      function normalizeName(name) {
        if (typeof name !== 'string') {
          name = String(name);
        }
        if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
          throw new TypeError('Invalid character in header field name')
        }
        return name.toLowerCase()
      }

      function normalizeValue(value) {
        if (typeof value !== 'string') {
          value = String(value);
        }
        return value
      }

      // Build a destructive iterator for the value list
      function iteratorFor(items) {
        var iterator = {
          next: function() {
            var value = items.shift();
            return {done: value === undefined, value: value}
          }
        };

        if (support.iterable) {
          iterator[Symbol.iterator] = function() {
            return iterator
          };
        }

        return iterator
      }

      function Headers(headers) {
        this.map = {};

        if (headers instanceof Headers) {
          headers.forEach(function(value, name) {
            this.append(name, value);
          }, this);
        } else if (Array.isArray(headers)) {
          headers.forEach(function(header) {
            this.append(header[0], header[1]);
          }, this);
        } else if (headers) {
          Object.getOwnPropertyNames(headers).forEach(function(name) {
            this.append(name, headers[name]);
          }, this);
        }
      }

      Headers.prototype.append = function(name, value) {
        name = normalizeName(name);
        value = normalizeValue(value);
        var oldValue = this.map[name];
        this.map[name] = oldValue ? oldValue + ', ' + value : value;
      };

      Headers.prototype['delete'] = function(name) {
        delete this.map[normalizeName(name)];
      };

      Headers.prototype.get = function(name) {
        name = normalizeName(name);
        return this.has(name) ? this.map[name] : null
      };

      Headers.prototype.has = function(name) {
        return this.map.hasOwnProperty(normalizeName(name))
      };

      Headers.prototype.set = function(name, value) {
        this.map[normalizeName(name)] = normalizeValue(value);
      };

      Headers.prototype.forEach = function(callback, thisArg) {
        for (var name in this.map) {
          if (this.map.hasOwnProperty(name)) {
            callback.call(thisArg, this.map[name], name, this);
          }
        }
      };

      Headers.prototype.keys = function() {
        var items = [];
        this.forEach(function(value, name) {
          items.push(name);
        });
        return iteratorFor(items)
      };

      Headers.prototype.values = function() {
        var items = [];
        this.forEach(function(value) {
          items.push(value);
        });
        return iteratorFor(items)
      };

      Headers.prototype.entries = function() {
        var items = [];
        this.forEach(function(value, name) {
          items.push([name, value]);
        });
        return iteratorFor(items)
      };

      if (support.iterable) {
        Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
      }

      function consumed(body) {
        if (body.bodyUsed) {
          return Promise.reject(new TypeError('Already read'))
        }
        body.bodyUsed = true;
      }

      function fileReaderReady(reader) {
        return new Promise(function(resolve, reject) {
          reader.onload = function() {
            resolve(reader.result);
          };
          reader.onerror = function() {
            reject(reader.error);
          };
        })
      }

      function readBlobAsArrayBuffer(blob) {
        var reader = new FileReader();
        var promise = fileReaderReady(reader);
        reader.readAsArrayBuffer(blob);
        return promise
      }

      function readBlobAsText(blob) {
        var reader = new FileReader();
        var promise = fileReaderReady(reader);
        reader.readAsText(blob);
        return promise
      }

      function readArrayBufferAsText(buf) {
        var view = new Uint8Array(buf);
        var chars = new Array(view.length);

        for (var i = 0; i < view.length; i++) {
          chars[i] = String.fromCharCode(view[i]);
        }
        return chars.join('')
      }

      function bufferClone(buf) {
        if (buf.slice) {
          return buf.slice(0)
        } else {
          var view = new Uint8Array(buf.byteLength);
          view.set(new Uint8Array(buf));
          return view.buffer
        }
      }

      function Body() {
        this.bodyUsed = false;

        this._initBody = function(body) {
          this._bodyInit = body;
          if (!body) {
            this._bodyText = '';
          } else if (typeof body === 'string') {
            this._bodyText = body;
          } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
            this._bodyBlob = body;
          } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
            this._bodyFormData = body;
          } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
            this._bodyText = body.toString();
          } else if (support.arrayBuffer && support.blob && isDataView(body)) {
            this._bodyArrayBuffer = bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([this._bodyArrayBuffer]);
          } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
            this._bodyArrayBuffer = bufferClone(body);
          } else {
            this._bodyText = body = Object.prototype.toString.call(body);
          }

          if (!this.headers.get('content-type')) {
            if (typeof body === 'string') {
              this.headers.set('content-type', 'text/plain;charset=UTF-8');
            } else if (this._bodyBlob && this._bodyBlob.type) {
              this.headers.set('content-type', this._bodyBlob.type);
            } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
              this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
            }
          }
        };

        if (support.blob) {
          this.blob = function() {
            var rejected = consumed(this);
            if (rejected) {
              return rejected
            }

            if (this._bodyBlob) {
              return Promise.resolve(this._bodyBlob)
            } else if (this._bodyArrayBuffer) {
              return Promise.resolve(new Blob([this._bodyArrayBuffer]))
            } else if (this._bodyFormData) {
              throw new Error('could not read FormData body as blob')
            } else {
              return Promise.resolve(new Blob([this._bodyText]))
            }
          };

          this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
              return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
            } else {
              return this.blob().then(readBlobAsArrayBuffer)
            }
          };
        }

        this.text = function() {
          var rejected = consumed(this);
          if (rejected) {
            return rejected
          }

          if (this._bodyBlob) {
            return readBlobAsText(this._bodyBlob)
          } else if (this._bodyArrayBuffer) {
            return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
          } else if (this._bodyFormData) {
            throw new Error('could not read FormData body as text')
          } else {
            return Promise.resolve(this._bodyText)
          }
        };

        if (support.formData) {
          this.formData = function() {
            return this.text().then(decode)
          };
        }

        this.json = function() {
          return this.text().then(JSON.parse)
        };

        return this
      }

      // HTTP methods whose capitalization should be normalized
      var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

      function normalizeMethod(method) {
        var upcased = method.toUpperCase();
        return methods.indexOf(upcased) > -1 ? upcased : method
      }

      function Request(input, options) {
        options = options || {};
        var body = options.body;

        if (input instanceof Request) {
          if (input.bodyUsed) {
            throw new TypeError('Already read')
          }
          this.url = input.url;
          this.credentials = input.credentials;
          if (!options.headers) {
            this.headers = new Headers(input.headers);
          }
          this.method = input.method;
          this.mode = input.mode;
          this.signal = input.signal;
          if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
          }
        } else {
          this.url = String(input);
        }

        this.credentials = options.credentials || this.credentials || 'same-origin';
        if (options.headers || !this.headers) {
          this.headers = new Headers(options.headers);
        }
        this.method = normalizeMethod(options.method || this.method || 'GET');
        this.mode = options.mode || this.mode || null;
        this.signal = options.signal || this.signal;
        this.referrer = null;

        if ((this.method === 'GET' || this.method === 'HEAD') && body) {
          throw new TypeError('Body not allowed for GET or HEAD requests')
        }
        this._initBody(body);
      }

      Request.prototype.clone = function() {
        return new Request(this, {body: this._bodyInit})
      };

      function decode(body) {
        var form = new FormData();
        body
          .trim()
          .split('&')
          .forEach(function(bytes) {
            if (bytes) {
              var split = bytes.split('=');
              var name = split.shift().replace(/\+/g, ' ');
              var value = split.join('=').replace(/\+/g, ' ');
              form.append(decodeURIComponent(name), decodeURIComponent(value));
            }
          });
        return form
      }

      function parseHeaders(rawHeaders) {
        var headers = new Headers();
        // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
        // https://tools.ietf.org/html/rfc7230#section-3.2
        var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
        preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
          var parts = line.split(':');
          var key = parts.shift().trim();
          if (key) {
            var value = parts.join(':').trim();
            headers.append(key, value);
          }
        });
        return headers
      }

      Body.call(Request.prototype);

      function Response(bodyInit, options) {
        if (!options) {
          options = {};
        }

        this.type = 'default';
        this.status = options.status === undefined ? 200 : options.status;
        this.ok = this.status >= 200 && this.status < 300;
        this.statusText = 'statusText' in options ? options.statusText : 'OK';
        this.headers = new Headers(options.headers);
        this.url = options.url || '';
        this._initBody(bodyInit);
      }

      Body.call(Response.prototype);

      Response.prototype.clone = function() {
        return new Response(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new Headers(this.headers),
          url: this.url
        })
      };

      Response.error = function() {
        var response = new Response(null, {status: 0, statusText: ''});
        response.type = 'error';
        return response
      };

      var redirectStatuses = [301, 302, 303, 307, 308];

      Response.redirect = function(url, status) {
        if (redirectStatuses.indexOf(status) === -1) {
          throw new RangeError('Invalid status code')
        }

        return new Response(null, {status: status, headers: {location: url}})
      };

      exports.DOMException = self.DOMException;
      try {
        new exports.DOMException();
      } catch (err) {
        exports.DOMException = function(message, name) {
          this.message = message;
          this.name = name;
          var error = Error(message);
          this.stack = error.stack;
        };
        exports.DOMException.prototype = Object.create(Error.prototype);
        exports.DOMException.prototype.constructor = exports.DOMException;
      }

      function fetch(input, init) {
        return new Promise(function(resolve, reject) {
          var request = new Request(input, init);

          if (request.signal && request.signal.aborted) {
            return reject(new exports.DOMException('Aborted', 'AbortError'))
          }

          var xhr = new XMLHttpRequest();

          function abortXhr() {
            xhr.abort();
          }

          xhr.onload = function() {
            var options = {
              status: xhr.status,
              statusText: xhr.statusText,
              headers: parseHeaders(xhr.getAllResponseHeaders() || '')
            };
            options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
            var body = 'response' in xhr ? xhr.response : xhr.responseText;
            resolve(new Response(body, options));
          };

          xhr.onerror = function() {
            reject(new TypeError('Network request failed'));
          };

          xhr.ontimeout = function() {
            reject(new TypeError('Network request failed'));
          };

          xhr.onabort = function() {
            reject(new exports.DOMException('Aborted', 'AbortError'));
          };

          xhr.open(request.method, request.url, true);

          if (request.credentials === 'include') {
            xhr.withCredentials = true;
          } else if (request.credentials === 'omit') {
            xhr.withCredentials = false;
          }

          if ('responseType' in xhr && support.blob) {
            xhr.responseType = 'blob';
          }

          request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
          });

          if (request.signal) {
            request.signal.addEventListener('abort', abortXhr);

            xhr.onreadystatechange = function() {
              // DONE (success or failure)
              if (xhr.readyState === 4) {
                request.signal.removeEventListener('abort', abortXhr);
              }
            };
          }

          xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
        })
      }

      fetch.polyfill = true;

      if (!self.fetch) {
        self.fetch = fetch;
        self.Headers = Headers;
        self.Request = Request;
        self.Response = Response;
      }

      exports.Headers = Headers;
      exports.Request = Request;
      exports.Response = Response;
      exports.fetch = fetch;

      return exports;

    }({}));
    })(__self__);
    delete __self__.fetch.polyfill;
    exports = __self__.fetch; // To enable: import fetch from 'cross-fetch'
    exports.default = __self__.fetch; // For TypeScript consumers without esModuleInterop.
    exports.fetch = __self__.fetch; // To enable: import {fetch} from 'cross-fetch'
    exports.Headers = __self__.Headers;
    exports.Request = __self__.Request;
    exports.Response = __self__.Response;
    module.exports = exports;
    });

    var errors = {
        unauthorized: new Error('airbrake: unauthorized: project id or key are wrong'),
        ipRateLimited: new Error('airbrake: IP is rate limited'),
    };

    var rateLimitReset = 0;
    function request(req) {
        var utime = Date.now() / 1000;
        if (utime < rateLimitReset) {
            return Promise$1.reject(errors.ipRateLimited);
        }
        var opt = {
            method: req.method,
            body: req.body,
        };
        return browserPonyfill(req.url, opt).then(function (resp) {
            if (resp.status === 401) {
                throw errors.unauthorized;
            }
            if (resp.status === 429) {
                var s = resp.headers.get('X-RateLimit-Delay');
                if (!s) {
                    throw errors.ipRateLimited;
                }
                var n = parseInt(s, 10);
                if (n > 0) {
                    rateLimitReset = Date.now() / 1000 + n;
                }
                throw errors.ipRateLimited;
            }
            if (resp.status === 204) {
                return { json: null };
            }
            if (resp.status === 404) {
                throw new Error('404 Not Found');
            }
            if (resp.status >= 200 && resp.status < 300) {
                return resp.json().then(function (json) {
                    return { json: json };
                });
            }
            if (resp.status >= 400 && resp.status < 500) {
                return resp.json().then(function (json) {
                    var err = new Error(json.message);
                    throw err;
                });
            }
            return resp.text().then(function (body) {
                var err = new Error("airbrake: fetch: unexpected response: code=" + resp.status + " body='" + body + "'");
                throw err;
            });
        });
    }

    function makeRequester(api) {
        return function (req) {
            return request$1(req, api);
        };
    }
    var rateLimitReset$1 = 0;
    function request$1(req, api) {
        var utime = Date.now() / 1000;
        if (utime < rateLimitReset$1) {
            return Promise$1.reject(errors.ipRateLimited);
        }
        return new Promise$1(function (resolve, reject) {
            api({
                url: req.url,
                method: req.method,
                body: req.body,
                headers: {
                    'content-type': 'application/json',
                },
                timeout: req.timeout,
            }, function (error, resp, body) {
                if (error) {
                    reject(error);
                    return;
                }
                if (!resp.statusCode) {
                    error = new Error("airbrake: request: response statusCode is " + resp.statusCode);
                    reject(error);
                    return;
                }
                if (resp.statusCode === 401) {
                    reject(errors.unauthorized);
                    return;
                }
                if (resp.statusCode === 429) {
                    reject(errors.ipRateLimited);
                    var h = resp.headers['x-ratelimit-delay'];
                    if (!h) {
                        return;
                    }
                    var s = void 0;
                    if (typeof h === 'string') {
                        s = h;
                    }
                    else if (h instanceof Array) {
                        s = h[0];
                    }
                    else {
                        return;
                    }
                    var n = parseInt(s, 10);
                    if (n > 0) {
                        rateLimitReset$1 = Date.now() / 1000 + n;
                    }
                    return;
                }
                if (resp.statusCode === 204) {
                    resolve({ json: null });
                    return;
                }
                if (resp.statusCode >= 200 && resp.statusCode < 300) {
                    var json = void 0;
                    try {
                        json = JSON.parse(body);
                    }
                    catch (err) {
                        reject(err);
                        return;
                    }
                    resolve(json);
                    return;
                }
                if (resp.statusCode >= 400 && resp.statusCode < 500) {
                    var json = void 0;
                    try {
                        json = JSON.parse(body);
                    }
                    catch (err) {
                        reject(err);
                        return;
                    }
                    error = new Error(json.message);
                    reject(error);
                    return;
                }
                body = body.trim();
                error = new Error("airbrake: node: unexpected response: code=" + resp.statusCode + " body='" + body + "'");
                reject(error);
            });
        });
    }

    function makeRequester$1(opts) {
        if (opts.request) {
            return makeRequester(opts.request);
        }
        return request;
    }

    var tdigest;
    var hasTdigest = false;
    try {
        tdigest = require('tdigest');
        hasTdigest = true;
    }
    catch (err) { }
    var TDigestStat = /** @class */ (function () {
        function TDigestStat() {
            this.count = 0;
            this.sum = 0;
            this.sumsq = 0;
            this._td = new tdigest.Digest();
        }
        TDigestStat.prototype.add = function (ms) {
            if (ms === 0) {
                ms = 0.00001;
            }
            this.count += 1;
            this.sum += ms;
            this.sumsq += ms * ms;
            if (this._td) {
                this._td.push(ms);
            }
        };
        TDigestStat.prototype.toJSON = function () {
            return {
                count: this.count,
                sum: this.sum,
                sumsq: this.sumsq,
                tdigestCentroids: tdigestCentroids(this._td),
            };
        };
        return TDigestStat;
    }());
    var TDigestStatGroups = /** @class */ (function (_super) {
        __extends(TDigestStatGroups, _super);
        function TDigestStatGroups() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.groups = {};
            return _this;
        }
        TDigestStatGroups.prototype.addGroups = function (totalMs, groups) {
            this.add(totalMs);
            for (var name_1 in groups) {
                if (groups.hasOwnProperty(name_1)) {
                    this.addGroup(name_1, groups[name_1]);
                }
            }
        };
        TDigestStatGroups.prototype.addGroup = function (name, ms) {
            var stat = this.groups[name];
            if (!stat) {
                stat = new TDigestStat();
                this.groups[name] = stat;
            }
            stat.add(ms);
        };
        TDigestStatGroups.prototype.toJSON = function () {
            return {
                count: this.count,
                sum: this.sum,
                sumsq: this.sumsq,
                tdigestCentroids: tdigestCentroids(this._td),
                groups: this.groups,
            };
        };
        return TDigestStatGroups;
    }(TDigestStat));
    function tdigestCentroids(td) {
        var means = [];
        var counts = [];
        td.centroids.each(function (c) {
            means.push(c.mean);
            counts.push(c.n);
        });
        return {
            mean: means,
            count: counts,
        };
    }

    var FLUSH_INTERVAL = 15000; // 15 seconds
    var QueryInfo = /** @class */ (function () {
        function QueryInfo(query) {
            if (query === void 0) { query = ''; }
            this.method = '';
            this.route = '';
            this.query = '';
            this.func = '';
            this.file = '';
            this.line = 0;
            this.startTime = new Date();
            this.query = query;
        }
        QueryInfo.prototype._duration = function () {
            if (!this.endTime) {
                this.endTime = new Date();
            }
            return this.endTime.getTime() - this.startTime.getTime();
        };
        return QueryInfo;
    }());
    var QueriesStats = /** @class */ (function () {
        function QueriesStats(opt) {
            this._m = {};
            this._opt = opt;
            this._url = opt.host + "/api/v5/projects/" + opt.projectId + "/queries-stats?key=" + opt.projectKey;
            this._requester = makeRequester$1(opt);
        }
        QueriesStats.prototype.start = function (query) {
            if (query === void 0) { query = ''; }
            return new QueryInfo(query);
        };
        QueriesStats.prototype.notify = function (q) {
            var _this = this;
            if (!hasTdigest) {
                return;
            }
            var ms = q._duration();
            var minute = 60 * 1000;
            var startTime = new Date(Math.floor(q.startTime.getTime() / minute) * minute);
            var key = {
                method: q.method,
                route: q.route,
                query: q.query,
                func: q.func,
                file: q.file,
                line: q.line,
                time: startTime,
            };
            var keyStr = JSON.stringify(key);
            var stat = this._m[keyStr];
            if (!stat) {
                stat = new TDigestStat();
                this._m[keyStr] = stat;
            }
            stat.add(ms);
            if (this._timer) {
                return;
            }
            this._timer = setTimeout(function () {
                _this._flush();
            }, FLUSH_INTERVAL);
        };
        QueriesStats.prototype._flush = function () {
            var queries = [];
            for (var keyStr in this._m) {
                if (!this._m.hasOwnProperty(keyStr)) {
                    continue;
                }
                var key = JSON.parse(keyStr);
                var v = __assign(__assign({}, key), this._m[keyStr].toJSON());
                queries.push(v);
            }
            this._m = {};
            this._timer = null;
            var outJSON = JSON.stringify({
                environment: this._opt.environment,
                queries: queries,
            });
            var req = {
                method: 'POST',
                url: this._url,
                body: outJSON,
            };
            this._requester(req)
                .then(function (_resp) {
                // nothing
            })
                .catch(function (err) {
                if (console.error) {
                    console.error('can not report queries stats', err);
                }
            });
        };
        return QueriesStats;
    }());

    var FLUSH_INTERVAL$1 = 15000; // 15 seconds
    var QueueMetric = /** @class */ (function (_super) {
        __extends(QueueMetric, _super);
        function QueueMetric(queue) {
            var _this = _super.call(this) || this;
            _this.queue = queue;
            _this.startTime = new Date();
            return _this;
        }
        return QueueMetric;
    }(BaseMetric));
    var QueuesStats = /** @class */ (function () {
        function QueuesStats(opt) {
            this._m = {};
            this._opt = opt;
            this._url = opt.host + "/api/v5/projects/" + opt.projectId + "/queues-stats?key=" + opt.projectKey;
            this._requester = makeRequester$1(opt);
        }
        QueuesStats.prototype.notify = function (q) {
            var _this = this;
            if (!hasTdigest) {
                return;
            }
            var ms = q._duration();
            if (ms === 0) {
                ms = 0.00001;
            }
            var minute = 60 * 1000;
            var startTime = new Date(Math.floor(q.startTime.getTime() / minute) * minute);
            var key = {
                queue: q.queue,
                time: startTime,
            };
            var keyStr = JSON.stringify(key);
            var stat = this._m[keyStr];
            if (!stat) {
                stat = new TDigestStatGroups();
                this._m[keyStr] = stat;
            }
            stat.addGroups(ms, q._groups);
            if (this._timer) {
                return;
            }
            this._timer = setTimeout(function () {
                _this._flush();
            }, FLUSH_INTERVAL$1);
        };
        QueuesStats.prototype._flush = function () {
            var queues = [];
            for (var keyStr in this._m) {
                if (!this._m.hasOwnProperty(keyStr)) {
                    continue;
                }
                var key = JSON.parse(keyStr);
                var v = __assign(__assign({}, key), this._m[keyStr].toJSON());
                queues.push(v);
            }
            this._m = {};
            this._timer = null;
            var outJSON = JSON.stringify({
                environment: this._opt.environment,
                queues: queues,
            });
            var req = {
                method: 'POST',
                url: this._url,
                body: outJSON,
            };
            this._requester(req)
                .then(function (_resp) {
                // nothing
            })
                .catch(function (err) {
                if (console.error) {
                    console.error('can not report queues breakdowns', err);
                }
            });
        };
        return QueuesStats;
    }());

    var FLUSH_INTERVAL$2 = 15000; // 15 seconds
    var RouteMetric = /** @class */ (function (_super) {
        __extends(RouteMetric, _super);
        function RouteMetric(method, route, statusCode, contentType) {
            if (method === void 0) { method = ''; }
            if (route === void 0) { route = ''; }
            if (statusCode === void 0) { statusCode = 0; }
            if (contentType === void 0) { contentType = ''; }
            var _this = _super.call(this) || this;
            _this.method = method;
            _this.route = route;
            _this.statusCode = statusCode;
            _this.contentType = contentType;
            _this.startTime = new Date();
            return _this;
        }
        return RouteMetric;
    }(BaseMetric));
    var RoutesStats = /** @class */ (function () {
        function RoutesStats(opt) {
            this._m = {};
            this._opt = opt;
            this._url = opt.host + "/api/v5/projects/" + opt.projectId + "/routes-stats?key=" + opt.projectKey;
            this._requester = makeRequester$1(opt);
        }
        RoutesStats.prototype.notify = function (req) {
            var _this = this;
            if (!hasTdigest) {
                return;
            }
            var ms = req._duration();
            var minute = 60 * 1000;
            var startTime = new Date(Math.floor(req.startTime.getTime() / minute) * minute);
            var key = {
                method: req.method,
                route: req.route,
                statusCode: req.statusCode,
                time: startTime,
            };
            var keyStr = JSON.stringify(key);
            var stat = this._m[keyStr];
            if (!stat) {
                stat = new TDigestStat();
                this._m[keyStr] = stat;
            }
            stat.add(ms);
            if (this._timer) {
                return;
            }
            this._timer = setTimeout(function () {
                _this._flush();
            }, FLUSH_INTERVAL$2);
        };
        RoutesStats.prototype._flush = function () {
            var routes = [];
            for (var keyStr in this._m) {
                if (!this._m.hasOwnProperty(keyStr)) {
                    continue;
                }
                var key = JSON.parse(keyStr);
                var v = __assign(__assign({}, key), this._m[keyStr].toJSON());
                routes.push(v);
            }
            this._m = {};
            this._timer = null;
            var outJSON = JSON.stringify({
                environment: this._opt.environment,
                routes: routes,
            });
            var req = {
                method: 'POST',
                url: this._url,
                body: outJSON,
            };
            this._requester(req)
                .then(function (_resp) {
                // nothing
            })
                .catch(function (err) {
                if (console.error) {
                    console.error('can not report routes stats', err);
                }
            });
        };
        return RoutesStats;
    }());
    var RoutesBreakdowns = /** @class */ (function () {
        function RoutesBreakdowns(opt) {
            this._m = {};
            this._opt = opt;
            this._url = opt.host + "/api/v5/projects/" + opt.projectId + "/routes-breakdowns?key=" + opt.projectKey;
            this._requester = makeRequester$1(opt);
        }
        RoutesBreakdowns.prototype.notify = function (req) {
            var _this = this;
            if (!hasTdigest) {
                return;
            }
            if (req.statusCode < 200 ||
                (req.statusCode >= 300 && req.statusCode < 400) ||
                req.statusCode === 404 ||
                Object.keys(req._groups).length === 0) {
                return;
            }
            var ms = req._duration();
            if (ms === 0) {
                ms = 0.00001;
            }
            var minute = 60 * 1000;
            var startTime = new Date(Math.floor(req.startTime.getTime() / minute) * minute);
            var key = {
                method: req.method,
                route: req.route,
                responseType: this._responseType(req),
                time: startTime,
            };
            var keyStr = JSON.stringify(key);
            var stat = this._m[keyStr];
            if (!stat) {
                stat = new TDigestStatGroups();
                this._m[keyStr] = stat;
            }
            stat.addGroups(ms, req._groups);
            if (this._timer) {
                return;
            }
            this._timer = setTimeout(function () {
                _this._flush();
            }, FLUSH_INTERVAL$2);
        };
        RoutesBreakdowns.prototype._flush = function () {
            var routes = [];
            for (var keyStr in this._m) {
                if (!this._m.hasOwnProperty(keyStr)) {
                    continue;
                }
                var key = JSON.parse(keyStr);
                var v = __assign(__assign({}, key), this._m[keyStr].toJSON());
                routes.push(v);
            }
            this._m = {};
            this._timer = null;
            var outJSON = JSON.stringify({
                environment: this._opt.environment,
                routes: routes,
            });
            var req = {
                method: 'POST',
                url: this._url,
                body: outJSON,
            };
            this._requester(req)
                .then(function (_resp) {
                // nothing
            })
                .catch(function (err) {
                if (console.error) {
                    console.error('can not report routes breakdowns', err);
                }
            });
        };
        RoutesBreakdowns.prototype._responseType = function (req) {
            if (req.statusCode >= 500) {
                return '5xx';
            }
            if (req.statusCode >= 400) {
                return '4xx';
            }
            if (!req.contentType) {
                return '';
            }
            return req.contentType.split(';')[0].split('/')[-1];
        };
        return RoutesBreakdowns;
    }());

    var NOTIFIER_NAME = 'airbrake-js/browser';
    var NOTIFIER_VERSION = '1.4.1';
    var NOTIFIER_URL = 'https://github.com/airbrake/airbrake-js/tree/master/packages/browser';

    var BaseNotifier = /** @class */ (function () {
        function BaseNotifier(opt) {
            var _this = this;
            this._filters = [];
            this._performanceFilters = [];
            this._scope = new Scope();
            this._onClose = [];
            if (!opt.projectId || !opt.projectKey) {
                throw new Error('airbrake: projectId and projectKey are required');
            }
            this._opt = opt;
            this._opt.host = this._opt.host || 'https://api.airbrake.io';
            this._opt.timeout = this._opt.timeout || 10000;
            this._opt.keysBlocklist = this._opt.keysBlocklist ||
                this._opt.keysBlacklist || [/password/, /secret/];
            this._url = this._opt.host + "/api/v3/projects/" + this._opt.projectId + "/notices?key=" + this._opt.projectKey;
            this._processor = this._opt.processor || espProcessor;
            this._requester = makeRequester$1(this._opt);
            this.addFilter(ignoreNoiseFilter);
            this.addFilter(makeDebounceFilter());
            this.addFilter(uncaughtMessageFilter);
            this.addFilter(angularMessageFilter);
            this.addFilter(function (notice) {
                notice.context.notifier = {
                    name: NOTIFIER_NAME,
                    version: NOTIFIER_VERSION,
                    url: NOTIFIER_URL,
                };
                if (_this._opt.environment) {
                    notice.context.environment = _this._opt.environment;
                }
                return notice;
            });
            this.routes = new Routes(this);
            this.queues = new Queues(this);
            this.queries = new QueriesStats(this._opt);
        }
        BaseNotifier.prototype.close = function () {
            for (var _i = 0, _a = this._onClose; _i < _a.length; _i++) {
                var fn = _a[_i];
                fn();
            }
        };
        BaseNotifier.prototype.scope = function () {
            return this._scope;
        };
        BaseNotifier.prototype.setActiveScope = function (scope) {
            this._scope = scope;
        };
        BaseNotifier.prototype.addFilter = function (filter) {
            this._filters.push(filter);
        };
        BaseNotifier.prototype.addPerformanceFilter = function (performanceFilter) {
            this._performanceFilters.push(performanceFilter);
        };
        BaseNotifier.prototype.notify = function (err) {
            var notice = {
                errors: [],
                context: __assign(__assign({ severity: 'error' }, this.scope().context()), err.context),
                params: err.params || {},
                environment: err.environment || {},
                session: err.session || {},
            };
            if (typeof err !== 'object' || err.error === undefined) {
                err = { error: err };
            }
            if (!err.error) {
                notice.error = new Error("airbrake: got err=" + JSON.stringify(err.error) + ", wanted an Error");
                return Promise$1.resolve(notice);
            }
            var error = this._processor(err.error);
            notice.errors.push(error);
            for (var _i = 0, _a = this._filters; _i < _a.length; _i++) {
                var filter = _a[_i];
                var r = filter(notice);
                if (r === null) {
                    notice.error = new Error('airbrake: error is filtered');
                    return Promise$1.resolve(notice);
                }
                notice = r;
            }
            if (!notice.context) {
                notice.context = {};
            }
            notice.context.language = 'JavaScript';
            return this._sendNotice(notice);
        };
        BaseNotifier.prototype._sendNotice = function (notice) {
            var body = jsonifyNotice(notice, {
                keysBlocklist: this._opt.keysBlocklist,
            });
            if (this._opt.reporter) {
                if (typeof this._opt.reporter === 'function') {
                    return this._opt.reporter(notice);
                }
                else {
                    console.warn('airbrake: options.reporter must be a function');
                }
            }
            var req = {
                method: 'POST',
                url: this._url,
                body: body,
            };
            return this._requester(req)
                .then(function (resp) {
                notice.id = resp.json.id;
                notice.url = resp.json.url;
                return notice;
            })
                .catch(function (err) {
                notice.error = err;
                return notice;
            });
        };
        BaseNotifier.prototype.wrap = function (fn, props) {
            if (props === void 0) { props = []; }
            if (fn._airbrake) {
                return fn;
            }
            // tslint:disable-next-line:no-this-assignment
            var client = this;
            var airbrakeWrapper = function () {
                var fnArgs = Array.prototype.slice.call(arguments);
                var wrappedArgs = client._wrapArguments(fnArgs);
                try {
                    return fn.apply(this, wrappedArgs);
                }
                catch (err) {
                    client.notify({ error: err, params: { arguments: fnArgs } });
                    this._ignoreNextWindowError();
                    throw err;
                }
            };
            for (var prop in fn) {
                if (fn.hasOwnProperty(prop)) {
                    airbrakeWrapper[prop] = fn[prop];
                }
            }
            for (var _i = 0, props_1 = props; _i < props_1.length; _i++) {
                var prop = props_1[_i];
                if (fn.hasOwnProperty(prop)) {
                    airbrakeWrapper[prop] = fn[prop];
                }
            }
            airbrakeWrapper._airbrake = true;
            airbrakeWrapper.inner = fn;
            return airbrakeWrapper;
        };
        BaseNotifier.prototype._wrapArguments = function (args) {
            for (var i = 0; i < args.length; i++) {
                var arg = args[i];
                if (typeof arg === 'function') {
                    args[i] = this.wrap(arg);
                }
            }
            return args;
        };
        BaseNotifier.prototype._ignoreNextWindowError = function () { };
        BaseNotifier.prototype.call = function (fn) {
            var _args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                _args[_i - 1] = arguments[_i];
            }
            var wrapper = this.wrap(fn);
            return wrapper.apply(this, Array.prototype.slice.call(arguments, 1));
        };
        return BaseNotifier;
    }());
    var Routes = /** @class */ (function () {
        function Routes(notifier) {
            this._notifier = notifier;
            this._routes = new RoutesStats(notifier._opt);
            this._breakdowns = new RoutesBreakdowns(notifier._opt);
        }
        Routes.prototype.start = function (method, route, statusCode, contentType) {
            if (method === void 0) { method = ''; }
            if (route === void 0) { route = ''; }
            if (statusCode === void 0) { statusCode = 0; }
            if (contentType === void 0) { contentType = ''; }
            var metric = new RouteMetric(method, route, statusCode, contentType);
            var scope = this._notifier.scope().clone();
            scope.setContext({ httpMethod: method, route: route });
            scope.setRouteMetric(metric);
            this._notifier.setActiveScope(scope);
            return metric;
        };
        Routes.prototype.notify = function (req) {
            req.end();
            for (var _i = 0, _a = this._notifier._performanceFilters; _i < _a.length; _i++) {
                var performanceFilter = _a[_i];
                if (performanceFilter(req) === null) {
                    return;
                }
            }
            this._routes.notify(req);
            this._breakdowns.notify(req);
        };
        return Routes;
    }());
    var Queues = /** @class */ (function () {
        function Queues(notifier) {
            this._notifier = notifier;
            this._queues = new QueuesStats(notifier._opt);
        }
        Queues.prototype.start = function (queue) {
            var metric = new QueueMetric(queue);
            var scope = this._notifier.scope().clone();
            scope.setContext({ queue: queue });
            scope.setQueueMetric(metric);
            this._notifier.setActiveScope(scope);
            return metric;
        };
        Queues.prototype.notify = function (q) {
            q.end();
            this._queues.notify(q);
        };
        return Queues;
    }());

    function windowFilter(notice) {
        if (window.navigator && window.navigator.userAgent) {
            notice.context.userAgent = window.navigator.userAgent;
        }
        if (window.location) {
            notice.context.url = String(window.location);
            // Set root directory to group errors on different subdomains together.
            notice.context.rootDirectory =
                window.location.protocol + '//' + window.location.host;
        }
        return notice;
    }

    var CONSOLE_METHODS = ['debug', 'log', 'info', 'warn', 'error'];
    function instrumentConsole(notifier) {
        var _loop_1 = function (m) {
            if (!(m in console)) {
                return "continue";
            }
            var oldFn = console[m];
            var newFn = (function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                oldFn.apply(console, args);
                notifier.scope().pushHistory({
                    type: 'log',
                    severity: m,
                    arguments: args,
                });
            });
            newFn.inner = oldFn;
            console[m] = newFn;
        };
        // tslint:disable-next-line:no-this-assignment
        for (var _i = 0, CONSOLE_METHODS_1 = CONSOLE_METHODS; _i < CONSOLE_METHODS_1.length; _i++) {
            var m = CONSOLE_METHODS_1[_i];
            _loop_1(m);
        }
    }

    var elemAttrs = ['type', 'name', 'src'];
    function instrumentDOM(notifier) {
        var handler = makeEventHandler(notifier);
        if (window.addEventListener) {
            window.addEventListener('load', handler);
            window.addEventListener('error', function (event) {
                if (getProp(event, 'error')) {
                    return;
                }
                handler(event);
            }, true);
        }
        if (typeof document === 'object' && document.addEventListener) {
            document.addEventListener('DOMContentLoaded', handler);
            document.addEventListener('click', handler);
            document.addEventListener('keypress', handler);
        }
    }
    function makeEventHandler(notifier) {
        return function (event) {
            var target = getProp(event, 'target');
            if (!target) {
                return;
            }
            var state = { type: event.type };
            try {
                state.target = elemPath(target);
            }
            catch (err) {
                state.target = "<" + String(err) + ">";
            }
            notifier.scope().pushHistory(state);
        };
    }
    function elemName(elem) {
        if (!elem) {
            return '';
        }
        var s = [];
        if (elem.tagName) {
            s.push(elem.tagName.toLowerCase());
        }
        if (elem.id) {
            s.push('#');
            s.push(elem.id);
        }
        if (elem.classList && Array.from) {
            s.push('.');
            s.push(Array.from(elem.classList).join('.'));
        }
        else if (elem.className) {
            var str = classNameString(elem.className);
            if (str !== '') {
                s.push('.');
                s.push(str);
            }
        }
        if (elem.getAttribute) {
            for (var _i = 0, elemAttrs_1 = elemAttrs; _i < elemAttrs_1.length; _i++) {
                var attr = elemAttrs_1[_i];
                var value = elem.getAttribute(attr);
                if (value) {
                    s.push("[" + attr + "=\"" + value + "\"]");
                }
            }
        }
        return s.join('');
    }
    function classNameString(name) {
        if (name.split) {
            return name.split(' ').join('.');
        }
        if (name.baseVal && name.baseVal.split) {
            // SVGAnimatedString
            return name.baseVal.split(' ').join('.');
        }
        console.error('unsupported HTMLElement.className type', typeof name);
        return '';
    }
    function elemPath(elem) {
        var maxLen = 10;
        var path = [];
        var parent = elem;
        while (parent) {
            var name_1 = elemName(parent);
            if (name_1 !== '') {
                path.push(name_1);
                if (path.length > maxLen) {
                    break;
                }
            }
            parent = parent.parentNode;
        }
        if (path.length === 0) {
            return String(elem);
        }
        return path.reverse().join(' > ');
    }
    function getProp(obj, prop) {
        try {
            return obj[prop];
        }
        catch (_) {
            // Permission denied to access property
            return null;
        }
    }

    function instrumentFetch(notifier) {
        // tslint:disable-next-line:no-this-assignment
        var oldFetch = window.fetch;
        window.fetch = function (req, options) {
            var state = {
                type: 'xhr',
                date: new Date(),
            };
            state.method = options && options.method ? options.method : 'GET';
            if (typeof req === 'string') {
                state.url = req;
            }
            else {
                state.method = req.method;
                state.url = req.url;
            }
            // Some platforms (e.g. react-native) implement fetch via XHR.
            notifier._ignoreNextXHR++;
            setTimeout(function () { return notifier._ignoreNextXHR--; });
            return oldFetch
                .apply(this, arguments)
                .then(function (resp) {
                state.statusCode = resp.status;
                state.duration = new Date().getTime() - state.date.getTime();
                notifier.scope().pushHistory(state);
                return resp;
            })
                .catch(function (err) {
                state.error = err;
                state.duration = new Date().getTime() - state.date.getTime();
                notifier.scope().pushHistory(state);
                throw err;
            });
        };
    }

    var lastLocation = '';
    // In some environments (i.e. Cypress) document.location may sometimes be null
    function getCurrentLocation() {
        return document.location && document.location.pathname;
    }
    function instrumentLocation(notifier) {
        lastLocation = getCurrentLocation();
        var oldFn = window.onpopstate;
        window.onpopstate = function abOnpopstate(_event) {
            var url = getCurrentLocation();
            if (url) {
                recordLocation(notifier, url);
            }
            if (oldFn) {
                return oldFn.apply(this, arguments);
            }
        };
        var oldPushState = history.pushState;
        history.pushState = function abPushState(_state, _title, url) {
            if (url) {
                recordLocation(notifier, url.toString());
            }
            oldPushState.apply(this, arguments);
        };
    }
    function recordLocation(notifier, url) {
        var index = url.indexOf('://');
        if (index >= 0) {
            url = url.slice(index + 3);
            index = url.indexOf('/');
            url = index >= 0 ? url.slice(index) : '/';
        }
        else if (url.charAt(0) !== '/') {
            url = '/' + url;
        }
        notifier.scope().pushHistory({
            type: 'location',
            from: lastLocation,
            to: url,
        });
        lastLocation = url;
    }

    function instrumentXHR(notifier) {
        function recordReq(req) {
            var state = req.__state;
            state.statusCode = req.status;
            state.duration = new Date().getTime() - state.date.getTime();
            notifier.scope().pushHistory(state);
        }
        var oldOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function abOpen(method, url, _async, _user, _password) {
            if (notifier._ignoreNextXHR === 0) {
                this.__state = {
                    type: 'xhr',
                    method: method,
                    url: url,
                };
            }
            oldOpen.apply(this, arguments);
        };
        var oldSend = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.send = function abSend(_data) {
            var oldFn = this.onreadystatechange;
            this.onreadystatechange = function (_ev) {
                if (this.readyState === 4 && this.__state) {
                    recordReq(this);
                }
                if (oldFn) {
                    return oldFn.apply(this, arguments);
                }
            };
            if (this.__state) {
                this.__state.date = new Date();
            }
            return oldSend.apply(this, arguments);
        };
    }

    var Notifier = /** @class */ (function (_super) {
        __extends(Notifier, _super);
        function Notifier(opt) {
            var _this = _super.call(this, opt) || this;
            _this.offline = false;
            _this.todo = [];
            _this._ignoreWindowError = 0;
            _this._ignoreNextXHR = 0;
            if (typeof window === 'undefined') {
                return _this;
            }
            _this.addFilter(windowFilter);
            if (window.addEventListener) {
                _this.onOnline = _this.onOnline.bind(_this);
                window.addEventListener('online', _this.onOnline);
                _this.onOffline = _this.onOffline.bind(_this);
                window.addEventListener('offline', _this.onOffline);
                _this.onUnhandledrejection = _this.onUnhandledrejection.bind(_this);
                window.addEventListener('unhandledrejection', _this.onUnhandledrejection);
                _this._onClose.push(function () {
                    window.removeEventListener('online', _this.onOnline);
                    window.removeEventListener('offline', _this.onOffline);
                    window.removeEventListener('unhandledrejection', _this.onUnhandledrejection);
                });
            }
            // TODO: deprecated
            if (_this._opt.ignoreWindowError) {
                opt.instrumentation.onerror = false;
            }
            _this._instrument(opt.instrumentation);
            return _this;
        }
        Notifier.prototype._instrument = function (opt) {
            if (opt === void 0) { opt = {}; }
            opt.console = !isDevEnv(this._opt.environment);
            if (enabled(opt.onerror)) {
                // tslint:disable-next-line:no-this-assignment
                var self_1 = this;
                var oldHandler_1 = window.onerror;
                window.onerror = function abOnerror() {
                    if (oldHandler_1) {
                        oldHandler_1.apply(this, arguments);
                    }
                    self_1.onerror.apply(self_1, arguments);
                };
            }
            instrumentDOM(this);
            if (enabled(opt.fetch) && typeof fetch === 'function') {
                instrumentFetch(this);
            }
            if (enabled(opt.history) && typeof history === 'object') {
                instrumentLocation(this);
            }
            if (enabled(opt.console) && typeof console === 'object') {
                instrumentConsole(this);
            }
            if (enabled(opt.xhr) && typeof XMLHttpRequest !== 'undefined') {
                instrumentXHR(this);
            }
        };
        Notifier.prototype.notify = function (err) {
            var _this = this;
            if (this.offline) {
                return new Promise$1(function (resolve, reject) {
                    _this.todo.push({
                        err: err,
                        resolve: resolve,
                        reject: reject,
                    });
                    while (_this.todo.length > 100) {
                        var j = _this.todo.shift();
                        if (j === undefined) {
                            break;
                        }
                        j.resolve({
                            error: new Error('airbrake: offline queue is too large'),
                        });
                    }
                });
            }
            return _super.prototype.notify.call(this, err);
        };
        Notifier.prototype.onOnline = function () {
            this.offline = false;
            var _loop_1 = function (j) {
                this_1.notify(j.err).then(function (notice) {
                    j.resolve(notice);
                });
            };
            var this_1 = this;
            for (var _i = 0, _a = this.todo; _i < _a.length; _i++) {
                var j = _a[_i];
                _loop_1(j);
            }
            this.todo = [];
        };
        Notifier.prototype.onOffline = function () {
            this.offline = true;
        };
        Notifier.prototype.onUnhandledrejection = function (e) {
            // Handle native or bluebird Promise rejections
            // https://developer.mozilla.org/en-US/docs/Web/Events/unhandledrejection
            // http://bluebirdjs.com/docs/api/error-management-configuration.html
            var reason = e.reason || (e.detail && e.detail.reason);
            if (!reason) {
                return;
            }
            var msg = reason.message || String(reason);
            if (msg.indexOf && msg.indexOf('airbrake: ') === 0) {
                return;
            }
            if (typeof reason !== 'object' || reason.error === undefined) {
                this.notify({
                    error: reason,
                    context: {
                        unhandledRejection: true,
                    },
                });
                return;
            }
            this.notify(__assign(__assign({}, reason), { context: {
                    unhandledRejection: true,
                } }));
        };
        Notifier.prototype.onerror = function (message, filename, line, column, err) {
            if (this._ignoreWindowError > 0) {
                return;
            }
            if (err) {
                this.notify({
                    error: err,
                    context: {
                        windowError: true,
                    },
                });
                return;
            }
            // Ignore errors without file or line.
            if (!filename || !line) {
                return;
            }
            this.notify({
                error: {
                    message: message,
                    fileName: filename,
                    lineNumber: line,
                    columnNumber: column,
                    noStack: true,
                },
                context: {
                    windowError: true,
                },
            });
        };
        Notifier.prototype._ignoreNextWindowError = function () {
            var _this = this;
            this._ignoreWindowError++;
            setTimeout(function () { return _this._ignoreWindowError--; });
        };
        return Notifier;
    }(BaseNotifier));
    function isDevEnv(env) {
        return env && env.startsWith && env.startsWith('dev');
    }
    function enabled(v) {
        return v === undefined || v === true;
    }

    exports.BaseNotifier = BaseNotifier;
    exports.Notifier = Notifier;
    exports.QueryInfo = QueryInfo;
    exports.Scope = Scope;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
// **Initialize Airbrake Early**
//
// First things first, let's get Airbrake initialized and available on the `window` object before any of our scripts run.
// This way, we'll catch any errors right from the start.
//
(function () {
  // 1. Warn and return if Airbrake has already been initialized
  if (window.airbrake) {
    console.warn('Airbrake has already been initialized.');
    return;
  }

  // 2. Error and return if Airbrake.Notifier doesn't exist on window
  if (!window.Airbrake || !window.Airbrake.Notifier) {
    console.error('Airbrake.Notifier is not available on window. Cannot initialize Airbrake.');
    return;
  }

  // 3. Error and return if projectId or projectKey hasn't been set
  if (!window.airbrakeProjectId || !window.airbrakeProjectKey) {
    console.error('Airbrake project ID or key is not set. Cannot initialize Airbrake.');
    return;
  }

  // 4. Warn if environment isn't set, and use a local fallback
  if (!window.airbrakeEnvironment) {
    console.warn('Airbrake environment is not set. Using "development" as fallback.');
    window.airbrakeEnvironment = 'unknown-commerce-js';
  }

  // 5. Initialize Airbrake with custom options
  window.airbrake = new Airbrake.Notifier({
    // Project credentials
    projectId: window.airbrakeProjectId,
    projectKey: window.airbrakeProjectKey,
    environment: window.airbrakeEnvironment, // ('production-commerce-js', 'staging-commerce-js', 'unknown-commerce-js)

    // --- Additional Options (default) ---

    // Remote configuration
    // remoteConfig: true, // (true) - Enable/disable fetching remote configs

    // Instrumentation settings
    /*
    instrumentation: {
      onerror: true,             // (true) - Capture global errors
      fetch: true,               // (true) - Monitor fetch API calls
      history: true,             // (true) - Track browser history (for SPAs)
      console: true,            // (true) - Disable console.log tracking
      xhr: true,                 // (true) - Monitor XMLHttpRequest (XHR) calls
      unhandledrejection: true,  // (true) - Capture unhandled Promise rejections
    },
    */

    // Metrics collection
    /*
    errorNotifications: true,   // (true) - Capture errors
    performanceStats: true,     // (true) - Collect performance stats
    queryStats: true,           // (true) - Track query performance
    queueStats: true,           // (true) - Gather queue-related stats
    */

    // Custom hosts
    // host: 'https://api.airbrake.io', // (https://api.airbrake.io)
    // apmHost: 'https://api.airbrake.io',   // (https://api.airbrake.io)
    // remoteConfigHost: 'https://notifier-configs.airbrake.io', // (https://notifier-configs.airbrake.io)

    // Sensitive data filtering
    // keysBlocklist: [/password/, /secret/],  // (defaults: [/password/, /secret/])
    // keysAllowlist: undefined,               // (undefined) - No allowlist by default

    // Custom settings
    // timeout: 10000, // (10000 ms) - Request timeout
    // processor: espProcessor, // (espProcessor) - Default error processor
    // reporter: undefined, // (undefined) - Custom reporter function
    // request: undefined, // (undefined) - Custom request library (e.g., axios)
  });

  console.log('Airbrake has been successfully initialized.');

  // 6. Optionally, add filters to ignore specific errors or modify notices
  /*
  airbrake.addFilter((notice) => {
    // Ignore errors with a specific message
    if (notice.errors && notice.errors[0].message.includes('ignore this')) {
      return null;  // Prevent the notice from being sent
    }
  
    return notice;  // Send the notice if the condition is not met
  });
  */

  /*
  airbrake.addFilter((notice) => {
    // Adding annotations to the notice
    notice.context = {
      ...notice.context,
      component: 'delivery-estimate',  // Example annotation: component
      severity: 'warning',             // Setting the severity level to 'warning'
    };
    
    // Adding custom parameters to the notice
    notice.params = {
      ...notice.params,
      param1: 'custom param value',    // Example: custom parameter
    };
  
    return notice; // Always return the modified notice to ensure it's sent
  });
  */

  // 7. Optionally, add Route metrics to track performance
  /*
  const routeMetric = airbrake.routes.start(
    'GET',                           // HTTP method
    '/v5/delivery_estimate',          // Route path
    200,                              // Status code
    'application/json'                // Content-Type header
  );
  
  airbrake.routes.notify(routeMetric);
  */
})();
//
// **Reporting Errors with Airbrake**
//
// We've got two handy methods to report errors:
//
// **1. `airbrake.call` (Our Go-To Choice)**
//    - **Why Use It:** Wraps your functions and auto-reports any errors inside.
//    - **How to Use It:** Just wrap your function, and Airbrake takes care of the rest.
//
//    **Example with a named function:**
//    ```javascript
//    const initOnLoad = () => {
//      // Your app code here
//      throw new Error('Something went wrong!');
//    };
//
//    airbrake.call(initOnLoad);
//    ```
//
//    **Or just wrap the entire anonymous function:**
//    ```javascript
//    airbrake.call(function ($) {
//      ...
//      initOnLoad();
//    })(jQuery);
//    ```
//
// **2. `airbrake.notify`**
//    - **When to Use It:** Great for manually reporting errors when you need to.
//    - **How to Use It:** Pass the error directly to Airbrake.
//
//    **Example:**
//    ```javascript
//    try {
//      // Some code that might throw an error
//      throw new Error('Oops, an error occurred!');
//    } catch (err) {
//      airbrake.notify(err);
//    }
//    ```
//
// **Customize to Your Heart's Content**
//
// Airbrake is highly customizable. You can add filters, annotations, custom parameters, and more to your error reports.
// Check out the [Airbrake JS docs](https://github.com/airbrake/airbrake-js/tree/master/packages/browser) for more info.
//
;
// I18n.js
// =======
//
// This small library provides the Rails I18n API on the Javascript.
// You don't actually have to use Rails (or even Ruby) to use I18n.js.
// Just make sure you export all translations in an object like this:
//
//     I18n.translations.en = {
//       hello: "Hello World"
//     };
//
// See tests for specific formatting like numbers and dates.
//

// Using UMD pattern from
// https://github.com/umdjs/umd#regular-module
// `returnExports.js` version
;(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define("i18n", function(){ return factory(root);});
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory(root);
  } else {
    // Browser globals (root is window)
    root.I18n = factory(root);
  }
}(this, function(global) {
  "use strict";

  // Use previously defined object if exists in current scope
  var I18n = global && global.I18n || {};

  // Just cache the Array#slice function.
  var slice = Array.prototype.slice;

  // Apply number padding.
  var padding = function(number) {
    return ("0" + number.toString()).substr(-2);
  };

  // Improved toFixed number rounding function with support for unprecise floating points
  // JavaScript's standard toFixed function does not round certain numbers correctly (for example 0.105 with precision 2).
  var toFixed = function(number, precision) {
    return decimalAdjust('round', number, -precision).toFixed(precision);
  };

  // Is a given variable an object?
  // Borrowed from Underscore.js
  var isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object'
  };

  var isFunction = function(func) {
    var type = typeof func;
    return type === 'function'
  };

  // Check if value is different than undefined and null;
  var isSet = function(value) {
    return typeof(value) !== 'undefined' && value !== null;
  };

  // Is a given value an array?
  // Borrowed from Underscore.js
  var isArray = function(val) {
    if (Array.isArray) {
      return Array.isArray(val);
    }
    return Object.prototype.toString.call(val) === '[object Array]';
  };

  var isString = function(val) {
    return typeof val === 'string' || Object.prototype.toString.call(val) === '[object String]';
  };

  var isNumber = function(val) {
    return typeof val === 'number' || Object.prototype.toString.call(val) === '[object Number]';
  };

  var isBoolean = function(val) {
    return val === true || val === false;
  };

  var isNull = function(val) {
    return val === null;
  };

  var decimalAdjust = function(type, value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === 'undefined' || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // If the value is not a number or the exp is not an integer...
    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
    }
    // Shift
    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
  };

  var lazyEvaluate = function(message, scope) {
    if (isFunction(message)) {
      return message(scope);
    } else {
      return message;
    }
  };

  var merge = function (dest, obj) {
    var key, value;
    for (key in obj) if (obj.hasOwnProperty(key)) {
      value = obj[key];
      if (isString(value) || isNumber(value) || isBoolean(value) || isArray(value) || isNull(value)) {
        dest[key] = value;
      } else {
        if (dest[key] == null) dest[key] = {};
        merge(dest[key], value);
      }
    }
    return dest;
  };

  // Set default days/months translations.
  var DATE = {
      day_names: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    , abbr_day_names: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
    , month_names: [null, "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    , abbr_month_names: [null, "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    , meridian: ["AM", "PM"]
  };

  // Set default number format.
  var NUMBER_FORMAT = {
      precision: 3
    , separator: "."
    , delimiter: ","
    , strip_insignificant_zeros: false
  };

  // Set default currency format.
  var CURRENCY_FORMAT = {
      unit: "$"
    , precision: 2
    , format: "%u%n"
    , sign_first: true
    , delimiter: ","
    , separator: "."
  };

  // Set default percentage format.
  var PERCENTAGE_FORMAT = {
      unit: "%"
    , precision: 3
    , format: "%n%u"
    , separator: "."
    , delimiter: ""
  };

  // Set default size units.
  var SIZE_UNITS = [null, "kb", "mb", "gb", "tb"];

  // Other default options
  var DEFAULT_OPTIONS = {
    // Set default locale. This locale will be used when fallback is enabled and
    // the translation doesn't exist in a particular locale.
      defaultLocale: "en"
    // Set the current locale to `en`.
    , locale: "en"
    // Set the translation key separator.
    , defaultSeparator: "."
    // Set the placeholder format. Accepts `{{placeholder}}` and `%{placeholder}`.
    , placeholder: /(?:\{\{|%\{)(.*?)(?:\}\}?)/gm
    // Set if engine should fallback to the default locale when a translation
    // is missing.
    , fallbacks: false
    // Set the default translation object.
    , translations: {}
    // Set missing translation behavior. 'message' will display a message
    // that the translation is missing, 'guess' will try to guess the string
    , missingBehaviour: 'message'
    // if you use missingBehaviour with 'message', but want to know that the
    // string is actually missing for testing purposes, you can prefix the
    // guessed string by setting the value here. By default, no prefix!
    , missingTranslationPrefix: ''
  };

  // Set default locale. This locale will be used when fallback is enabled and
  // the translation doesn't exist in a particular locale.
  I18n.reset = function() {
    var key;
    for (key in DEFAULT_OPTIONS) {
      this[key] = DEFAULT_OPTIONS[key];
    }
  };

  // Much like `reset`, but only assign options if not already assigned
  I18n.initializeOptions = function() {
    var key;
    for (key in DEFAULT_OPTIONS) if (!isSet(this[key])) {
      this[key] = DEFAULT_OPTIONS[key];
    }
  };
  I18n.initializeOptions();

  // Return a list of all locales that must be tried before returning the
  // missing translation message. By default, this will consider the inline option,
  // current locale and fallback locale.
  //
  //     I18n.locales.get("de-DE");
  //     // ["de-DE", "de", "en"]
  //
  // You can define custom rules for any locale. Just make sure you return a array
  // containing all locales.
  //
  //     // Default the Wookie locale to English.
  //     I18n.locales["wk"] = function(locale) {
  //       return ["en"];
  //     };
  //
  I18n.locales = {};

  // Retrieve locales based on inline locale, current locale or default to
  // I18n's detection.
  I18n.locales.get = function(locale) {
    var result = this[locale] || this[I18n.locale] || this["default"];

    if (isFunction(result)) {
      result = result(locale);
    }

    if (isArray(result) === false) {
      result = [result];
    }

    return result;
  };

  // The default locale list.
  I18n.locales["default"] = function(locale) {
    var locales = []
      , list = []
    ;

    // Handle the inline locale option that can be provided to
    // the `I18n.t` options.
    if (locale) {
      locales.push(locale);
    }

    // Add the current locale to the list.
    if (!locale && I18n.locale) {
      locales.push(I18n.locale);
    }

    // Add the default locale if fallback strategy is enabled.
    if (I18n.fallbacks && I18n.defaultLocale) {
      locales.push(I18n.defaultLocale);
    }

    // Locale code format 1:
    // According to RFC4646 (https://www.ietf.org/rfc/rfc4646.txt)
    // language codes for Traditional Chinese should be `zh-Hant`
    //
    // But due to backward compatibility
    // We use older version of IETF language tag
    // @see https://www.w3.org/TR/html401/struct/dirlang.html
    // @see https://en.wikipedia.org/wiki/IETF_language_tag
    //
    // Format: `language-code = primary-code ( "-" subcode )*`
    //
    // primary-code uses ISO639-1
    // @see https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
    // @see https://www.iso.org/iso/home/standards/language_codes.htm
    //
    // subcode uses ISO 3166-1 alpha-2
    // @see https://en.wikipedia.org/wiki/ISO_3166
    // @see https://www.iso.org/iso/country_codes.htm
    //
    // @note
    //   subcode can be in upper case or lower case
    //   defining it in upper case is a convention only


    // Locale code format 2:
    // Format: `code = primary-code ( "-" region-code )*`
    // primary-code uses ISO 639-1
    // script-code uses ISO 15924
    // region-code uses ISO 3166-1 alpha-2
    // Example: zh-Hant-TW, en-HK, zh-Hant-CN
    //
    // It is similar to RFC4646 (or actually the same),
    // but seems to be limited to language, script, region

    // Compute each locale with its country code.
    // So this will return an array containing
    // `de-DE` and `de`
    // or
    // `zh-hans-tw`, `zh-hans`, `zh`
    // locales.
    locales.forEach(function(locale) {
      var localeParts = locale.split("-");
      var firstFallback = null;
      var secondFallback = null;
      if (localeParts.length === 3) {
        firstFallback = [
          localeParts[0],
          localeParts[1]
        ].join("-");
        secondFallback = localeParts[0];
      }
      else if (localeParts.length === 2) {
        firstFallback = localeParts[0];
      }

      if (list.indexOf(locale) === -1) {
        list.push(locale);
      }

      if (! I18n.fallbacks) {
        return;
      }

      [
        firstFallback,
        secondFallback
      ].forEach(function(nullableFallbackLocale) {
        // We don't want null values
        if (typeof nullableFallbackLocale === "undefined") { return; }
        if (nullableFallbackLocale === null) { return; }
        // We don't want duplicate values
        //
        // Comparing with `locale` first is faster than
        // checking whether value's presence in the list
        if (nullableFallbackLocale === locale) { return; }
        if (list.indexOf(nullableFallbackLocale) !== -1) { return; }

        list.push(nullableFallbackLocale);
      });
    });

    // No locales set? English it is.
    if (!locales.length) {
      locales.push("en");
    }

    return list;
  };

  // Hold pluralization rules.
  I18n.pluralization = {};

  // Return the pluralizer for a specific locale.
  // If no specify locale is found, then I18n's default will be used.
  I18n.pluralization.get = function(locale) {
    return this[locale] || this[I18n.locale] || this["default"];
  };

  // The default pluralizer rule.
  // It detects the `zero`, `one`, and `other` scopes.
  I18n.pluralization["default"] = function(count) {
    switch (count) {
      case 0: return ["zero", "other"];
      case 1: return ["one"];
      default: return ["other"];
    }
  };

  // Return current locale. If no locale has been set, then
  // the current locale will be the default locale.
  I18n.currentLocale = function() {
    return this.locale || this.defaultLocale;
  };

  // Check if value is different than undefined and null;
  I18n.isSet = isSet;

  // Find and process the translation using the provided scope and options.
  // This is used internally by some functions and should not be used as an
  // public API.
  I18n.lookup = function(scope, options) {
    options = options || {};

    var locales = this.locales.get(options.locale).slice()
      , locale
      , scopes
      , fullScope
      , translations
    ;

    fullScope = this.getFullScope(scope, options);

    while (locales.length) {
      locale = locales.shift();
      scopes = fullScope.split(options.separator || this.defaultSeparator);
      translations = this.translations[locale];

      if (!translations) {
        continue;
      }
      while (scopes.length) {
        translations = translations[scopes.shift()];

        if (translations === undefined || translations === null) {
          break;
        }
      }

      if (translations !== undefined && translations !== null) {
        return translations;
      }
    }

    if (isSet(options.defaultValue)) {
      return lazyEvaluate(options.defaultValue, scope);
    }
  };

  // lookup pluralization rule key into translations
  I18n.pluralizationLookupWithoutFallback = function(count, locale, translations) {
    var pluralizer = this.pluralization.get(locale)
      , pluralizerKeys = pluralizer(count)
      , pluralizerKey
      , message;

    if (translations && isObject(translations)) {
      while (pluralizerKeys.length) {
        pluralizerKey = pluralizerKeys.shift();
        if (isSet(translations[pluralizerKey])) {
          message = translations[pluralizerKey];
          break;
        }
      }
    }

    return message;
  };

  // Lookup dedicated to pluralization
  I18n.pluralizationLookup = function(count, scope, options) {
    options = options || {};
    var locales = this.locales.get(options.locale).slice()
      , locale
      , scopes
      , translations
      , message
    ;
    scope = this.getFullScope(scope, options);

    while (locales.length) {
      locale = locales.shift();
      scopes = scope.split(options.separator || this.defaultSeparator);
      translations = this.translations[locale];

      if (!translations) {
        continue;
      }

      while (scopes.length) {
        translations = translations[scopes.shift()];
        if (!isObject(translations)) {
          break;
        }
        if (scopes.length === 0) {
          message = this.pluralizationLookupWithoutFallback(count, locale, translations);
        }
      }
      if (typeof message !== "undefined" && message !== null) {
        break;
      }
    }

    if (typeof message === "undefined" || message === null) {
      if (isSet(options.defaultValue)) {
        if (isObject(options.defaultValue)) {
          message = this.pluralizationLookupWithoutFallback(count, options.locale, options.defaultValue);
        } else {
          message = options.defaultValue;
        }
        translations = options.defaultValue;
      }
    }

    return { message: message, translations: translations };
  };

  // Rails changed the way the meridian is stored.
  // It started with `date.meridian` returning an array,
  // then it switched to `time.am` and `time.pm`.
  // This function abstracts this difference and returns
  // the correct meridian or the default value when none is provided.
  I18n.meridian = function() {
    var time = this.lookup("time");
    var date = this.lookup("date");

    if (time && time.am && time.pm) {
      return [time.am, time.pm];
    } else if (date && date.meridian) {
      return date.meridian;
    } else {
      return DATE.meridian;
    }
  };

  // Merge serveral hash options, checking if value is set before
  // overwriting any value. The precedence is from left to right.
  //
  //     I18n.prepareOptions({name: "John Doe"}, {name: "Mary Doe", role: "user"});
  //     #=> {name: "John Doe", role: "user"}
  //
  I18n.prepareOptions = function() {
    var args = slice.call(arguments)
      , options = {}
      , subject
    ;

    while (args.length) {
      subject = args.shift();

      if (typeof(subject) != "object") {
        continue;
      }

      for (var attr in subject) {
        if (!subject.hasOwnProperty(attr)) {
          continue;
        }

        if (isSet(options[attr])) {
          continue;
        }

        options[attr] = subject[attr];
      }
    }

    return options;
  };

  // Generate a list of translation options for default fallbacks.
  // `defaultValue` is also deleted from options as it is returned as part of
  // the translationOptions array.
  I18n.createTranslationOptions = function(scope, options) {
    var translationOptions = [{scope: scope}];

    // Defaults should be an array of hashes containing either
    // fallback scopes or messages
    if (isSet(options.defaults)) {
      translationOptions = translationOptions.concat(options.defaults);
    }

    // Maintain support for defaultValue. Since it is always a message
    // insert it in to the translation options as such.
    if (isSet(options.defaultValue)) {
      translationOptions.push({ message: options.defaultValue });
    }

    return translationOptions;
  };

  // Translate the given scope with the provided options.
  I18n.translate = function(scope, options) {
    options = options || {};

    var translationOptions = this.createTranslationOptions(scope, options);

    var translation;
    var usedScope = scope;

    var optionsWithoutDefault = this.prepareOptions(options)
    delete optionsWithoutDefault.defaultValue

    // Iterate through the translation options until a translation
    // or message is found.
    var translationFound =
      translationOptions.some(function(translationOption) {
        if (isSet(translationOption.scope)) {
          usedScope = translationOption.scope;
          translation = this.lookup(usedScope, optionsWithoutDefault);
        } else if (isSet(translationOption.message)) {
          translation = lazyEvaluate(translationOption.message, scope);
        }

        if (translation !== undefined && translation !== null) {
          return true;
        }
      }, this);

    if (!translationFound) {
      return this.missingTranslation(scope, options);
    }

    if (typeof(translation) === "string") {
      translation = this.interpolate(translation, options);
    } else if (isArray(translation)) {
      translation = translation.map(function(t) {
        return (typeof(t) === "string" ? this.interpolate(t, options) : t);
      }, this);
    } else if (isObject(translation) && isSet(options.count)) {
      translation = this.pluralize(options.count, usedScope, options);
    }

    return translation;
  };

  // This function interpolates the all variables in the given message.
  I18n.interpolate = function(message, options) {
    if (message == null) {
      return message;
    }

    options = options || {};
    var matches = message.match(this.placeholder)
      , placeholder
      , value
      , name
      , regex
    ;

    if (!matches) {
      return message;
    }

    while (matches.length) {
      placeholder = matches.shift();
      name = placeholder.replace(this.placeholder, "$1");

      if (isSet(options[name])) {
        value = options[name].toString().replace(/\$/gm, "_#$#_");
      } else if (name in options) {
        value = this.nullPlaceholder(placeholder, message, options);
      } else {
        value = this.missingPlaceholder(placeholder, message, options);
      }

      regex = new RegExp(placeholder.replace(/{/gm, "\\{").replace(/}/gm, "\\}"));
      message = message.replace(regex, value);
    }

    return message.replace(/_#\$#_/g, "$");
  };

  // Pluralize the given scope using the `count` value.
  // The pluralized translation may have other placeholders,
  // which will be retrieved from `options`.
  I18n.pluralize = function(count, scope, options) {
    options = this.prepareOptions({count: String(count)}, options)
    var pluralizer, result;

    result = this.pluralizationLookup(count, scope, options);
    if (typeof result.translations === "undefined" || result.translations == null) {
      return this.missingTranslation(scope, options);
    }

    if (typeof result.message !== "undefined" && result.message != null) {
      return this.interpolate(result.message, options);
    }
    else {
      pluralizer = this.pluralization.get(options.locale);
      return this.missingTranslation(scope + '.' + pluralizer(count)[0], options);
    }
  };

  // Return a missing translation message for the given parameters.
  I18n.missingTranslation = function(scope, options) {
    //guess intended string
    if(this.missingBehaviour === 'guess'){
      //get only the last portion of the scope
      var s = scope.split('.').slice(-1)[0];
      //replace underscore with space && camelcase with space and lowercase letter
      return (this.missingTranslationPrefix.length > 0 ? this.missingTranslationPrefix : '') +
          s.replace(/_/g,' ').replace(/([a-z])([A-Z])/g,
          function(match, p1, p2) {return p1 + ' ' + p2.toLowerCase()} );
    }

    var localeForTranslation = (options != null && options.locale != null) ? options.locale : this.currentLocale();
    var fullScope           = this.getFullScope(scope, options);
    var fullScopeWithLocale = [localeForTranslation, fullScope].join(options.separator || this.defaultSeparator);

    return '[missing "' + fullScopeWithLocale + '" translation]';
  };

  // Return a missing placeholder message for given parameters
  I18n.missingPlaceholder = function(placeholder, message, options) {
    return "[missing " + placeholder + " value]";
  };

  I18n.nullPlaceholder = function() {
    return I18n.missingPlaceholder.apply(I18n, arguments);
  };

  // Format number using localization rules.
  // The options will be retrieved from the `number.format` scope.
  // If this isn't present, then the following options will be used:
  //
  // - `precision`: `3`
  // - `separator`: `"."`
  // - `delimiter`: `","`
  // - `strip_insignificant_zeros`: `false`
  //
  // You can also override these options by providing the `options` argument.
  //
  I18n.toNumber = function(number, options) {
    options = this.prepareOptions(
        options
      , this.lookup("number.format")
      , NUMBER_FORMAT
    );

    var negative = number < 0
      , string = toFixed(Math.abs(number), options.precision).toString()
      , parts = string.split(".")
      , precision
      , buffer = []
      , formattedNumber
      , format = options.format || "%n"
      , sign = negative ? "-" : ""
    ;

    number = parts[0];
    precision = parts[1];

    while (number.length > 0) {
      buffer.unshift(number.substr(Math.max(0, number.length - 3), 3));
      number = number.substr(0, number.length -3);
    }

    formattedNumber = buffer.join(options.delimiter);

    if (options.strip_insignificant_zeros && precision) {
      precision = precision.replace(/0+$/, "");
    }

    if (options.precision > 0 && precision) {
      formattedNumber += options.separator + precision;
    }

    if (options.sign_first) {
      format = "%s" + format;
    }
    else {
      format = format.replace("%n", "%s%n");
    }

    formattedNumber = format
      .replace("%u", options.unit)
      .replace("%n", formattedNumber)
      .replace("%s", sign)
    ;

    return formattedNumber;
  };

  // Format currency with localization rules.
  // The options will be retrieved from the `number.currency.format` and
  // `number.format` scopes, in that order.
  //
  // Any missing option will be retrieved from the `I18n.toNumber` defaults and
  // the following options:
  //
  // - `unit`: `"$"`
  // - `precision`: `2`
  // - `format`: `"%u%n"`
  // - `delimiter`: `","`
  // - `separator`: `"."`
  //
  // You can also override these options by providing the `options` argument.
  //
  I18n.toCurrency = function(number, options) {
    options = this.prepareOptions(
        options
      , this.lookup("number.currency.format", options)
      , this.lookup("number.format", options)
      , CURRENCY_FORMAT
    );

    return this.toNumber(number, options);
  };

  // Localize several values.
  // You can provide the following scopes: `currency`, `number`, or `percentage`.
  // If you provide a scope that matches the `/^(date|time)/` regular expression
  // then the `value` will be converted by using the `I18n.toTime` function.
  //
  // It will default to the value's `toString` function.
  //
  I18n.localize = function(scope, value, options) {
    options || (options = {});

    switch (scope) {
      case "currency":
        return this.toCurrency(value, options);
      case "number":
        scope = this.lookup("number.format", options);
        return this.toNumber(value, scope);
      case "percentage":
        return this.toPercentage(value, options);
      default:
        var localizedValue;

        if (scope.match(/^(date|time)/)) {
          localizedValue = this.toTime(scope, value, options);
        } else {
          localizedValue = value.toString();
        }

        return this.interpolate(localizedValue, options);
    }
  };

  // Parse a given `date` string into a JavaScript Date object.
  // This function is time zone aware.
  //
  // The following string formats are recognized:
  //
  //    yyyy-mm-dd
  //    yyyy-mm-dd[ T]hh:mm::ss
  //    yyyy-mm-dd[ T]hh:mm::ss
  //    yyyy-mm-dd[ T]hh:mm::ssZ
  //    yyyy-mm-dd[ T]hh:mm::ss+0000
  //    yyyy-mm-dd[ T]hh:mm::ss+00:00
  //    yyyy-mm-dd[ T]hh:mm::ss.123Z
  //
  I18n.parseDate = function(date) {
    var matches, convertedDate, fraction;
    // A date input of `null` or `undefined` will be returned as-is
    if (date == null) {
      return date;
    }
    // we have a date, so just return it.
    if (typeof(date) === "object") {
      return date;
    }

    matches = date.toString().match(/(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}):(\d{2})([\.,]\d{1,3})?)?(Z|\+00:?00)?/);

    if (matches) {
      for (var i = 1; i <= 6; i++) {
        matches[i] = parseInt(matches[i], 10) || 0;
      }

      // month starts on 0
      matches[2] -= 1;

      fraction = matches[7] ? 1000 * ("0" + matches[7]) : null;

      if (matches[8]) {
        convertedDate = new Date(Date.UTC(matches[1], matches[2], matches[3], matches[4], matches[5], matches[6], fraction));
      } else {
        convertedDate = new Date(matches[1], matches[2], matches[3], matches[4], matches[5], matches[6], fraction);
      }
    } else if (typeof(date) == "number") {
      // UNIX timestamp
      convertedDate = new Date();
      convertedDate.setTime(date);
    } else if (date.match(/([A-Z][a-z]{2}) ([A-Z][a-z]{2}) (\d+) (\d+:\d+:\d+) ([+-]\d+) (\d+)/)) {
      // This format `Wed Jul 20 13:03:39 +0000 2011` is parsed by
      // webkit/firefox, but not by IE, so we must parse it manually.
      convertedDate = new Date();
      convertedDate.setTime(Date.parse([
        RegExp.$1, RegExp.$2, RegExp.$3, RegExp.$6, RegExp.$4, RegExp.$5
      ].join(" ")));
    } else if (date.match(/\d+ \d+:\d+:\d+ [+-]\d+ \d+/)) {
      // a valid javascript format with timezone info
      convertedDate = new Date();
      convertedDate.setTime(Date.parse(date));
    } else {
      // an arbitrary javascript string
      convertedDate = new Date();
      convertedDate.setTime(Date.parse(date));
    }

    return convertedDate;
  };

  // Formats time according to the directives in the given format string.
  // The directives begins with a percent (%) character. Any text not listed as a
  // directive will be passed through to the output string.
  //
  // The accepted formats are:
  //
  //     %a     - The abbreviated weekday name (Sun)
  //     %A     - The full weekday name (Sunday)
  //     %b     - The abbreviated month name (Jan)
  //     %B     - The full month name (January)
  //     %c     - The preferred local date and time representation
  //     %d     - Day of the month (01..31)
  //     %-d    - Day of the month (1..31)
  //     %H     - Hour of the day, 24-hour clock (00..23)
  //     %-H/%k - Hour of the day, 24-hour clock (0..23)
  //     %I     - Hour of the day, 12-hour clock (01..12)
  //     %-I/%l - Hour of the day, 12-hour clock (1..12)
  //     %m     - Month of the year (01..12)
  //     %-m    - Month of the year (1..12)
  //     %M     - Minute of the hour (00..59)
  //     %-M    - Minute of the hour (0..59)
  //     %p     - Meridian indicator (AM  or  PM)
  //     %P     - Meridian indicator (am  or  pm)
  //     %S     - Second of the minute (00..60)
  //     %-S    - Second of the minute (0..60)
  //     %w     - Day of the week (Sunday is 0, 0..6)
  //     %y     - Year without a century (00..99)
  //     %-y    - Year without a century (0..99)
  //     %Y     - Year with century
  //     %z/%Z  - Timezone offset (+0545)
  //
  I18n.strftime = function(date, format, options) {
    var options = this.lookup("date", options)
      , meridianOptions = I18n.meridian()
    ;

    if (!options) {
      options = {};
    }

    options = this.prepareOptions(options, DATE);

    if (isNaN(date.getTime())) {
      throw new Error('I18n.strftime() requires a valid date object, but received an invalid date.');
    }

    var weekDay = date.getDay()
      , day = date.getDate()
      , year = date.getFullYear()
      , month = date.getMonth() + 1
      , hour = date.getHours()
      , hour12 = hour
      , meridian = hour > 11 ? 1 : 0
      , secs = date.getSeconds()
      , mins = date.getMinutes()
      , offset = date.getTimezoneOffset()
      , absOffsetHours = Math.floor(Math.abs(offset / 60))
      , absOffsetMinutes = Math.abs(offset) - (absOffsetHours * 60)
      , timezoneoffset = (offset > 0 ? "-" : "+") +
          (absOffsetHours.toString().length < 2 ? "0" + absOffsetHours : absOffsetHours) +
          (absOffsetMinutes.toString().length < 2 ? "0" + absOffsetMinutes : absOffsetMinutes)
    ;

    if (hour12 > 12) {
      hour12 = hour12 - 12;
    } else if (hour12 === 0) {
      hour12 = 12;
    }

    format = format.replace("%a", options.abbr_day_names[weekDay]);
    format = format.replace("%A", options.day_names[weekDay]);
    format = format.replace("%b", options.abbr_month_names[month]);
    format = format.replace("%B", options.month_names[month]);
    format = format.replace("%d", padding(day));
    format = format.replace("%e", day);
    format = format.replace("%-d", day);
    format = format.replace("%H", padding(hour));
    format = format.replace("%-H", hour);
    format = format.replace("%k", hour);
    format = format.replace("%I", padding(hour12));
    format = format.replace("%-I", hour12);
    format = format.replace("%l", hour12);
    format = format.replace("%m", padding(month));
    format = format.replace("%-m", month);
    format = format.replace("%M", padding(mins));
    format = format.replace("%-M", mins);
    format = format.replace("%p", meridianOptions[meridian]);
    format = format.replace("%P", meridianOptions[meridian].toLowerCase());
    format = format.replace("%S", padding(secs));
    format = format.replace("%-S", secs);
    format = format.replace("%w", weekDay);
    format = format.replace("%y", padding(year));
    format = format.replace("%-y", padding(year).replace(/^0+/, ""));
    format = format.replace("%Y", year);
    format = format.replace("%z", timezoneoffset);
    format = format.replace("%Z", timezoneoffset);

    return format;
  };

  // Convert the given dateString into a formatted date.
  I18n.toTime = function(scope, dateString, options) {
    var date = this.parseDate(dateString)
      , format = this.lookup(scope, options)
    ;

    // A date input of `null` or `undefined` will be returned as-is
    if (date == null) {
      return date;
    }

    var date_string = date.toString()
    if (date_string.match(/invalid/i)) {
      return date_string;
    }

    if (!format) {
      return date_string;
    }

    return this.strftime(date, format, options);
  };

  // Convert a number into a formatted percentage value.
  I18n.toPercentage = function(number, options) {
    options = this.prepareOptions(
        options
      , this.lookup("number.percentage.format", options)
      , this.lookup("number.format", options)
      , PERCENTAGE_FORMAT
    );

    return this.toNumber(number, options);
  };

  // Convert a number into a readable size representation.
  I18n.toHumanSize = function(number, options) {
    var kb = 1024
      , size = number
      , iterations = 0
      , unit
      , precision
      , fullScope
    ;

    while (size >= kb && iterations < 4) {
      size = size / kb;
      iterations += 1;
    }

    if (iterations === 0) {
      fullScope = this.getFullScope("number.human.storage_units.units.byte", options);
      unit = this.t(fullScope, {count: size});
      precision = 0;
    } else {
      fullScope = this.getFullScope("number.human.storage_units.units." + SIZE_UNITS[iterations], options);
      unit = this.t(fullScope);
      precision = (size - Math.floor(size) === 0) ? 0 : 1;
    }

    options = this.prepareOptions(
        options
      , {unit: unit, precision: precision, format: "%n%u", delimiter: ""}
    );

    return this.toNumber(size, options);
  };

  I18n.getFullScope = function(scope, options) {
    options = options || {};

    // Deal with the scope as an array.
    if (isArray(scope)) {
      scope = scope.join(options.separator || this.defaultSeparator);
    }

    // Deal with the scope option provided through the second argument.
    //
    //    I18n.t('hello', {scope: 'greetings'});
    //
    if (options.scope) {
      scope = [options.scope, scope].join(options.separator || this.defaultSeparator);
    }

    return scope;
  };
  /**
   * Merge obj1 with obj2 (shallow merge), without modifying inputs
   * @param {Object} obj1
   * @param {Object} obj2
   * @returns {Object} Merged values of obj1 and obj2
   *
   * In order to support ES3, `Object.prototype.hasOwnProperty.call` is used
   * Idea is from:
   * https://stackoverflow.com/questions/8157700/object-has-no-hasownproperty-method-i-e-its-undefined-ie8
   */
  I18n.extend = function ( obj1, obj2 ) {
    if (typeof(obj1) === "undefined" && typeof(obj2) === "undefined") {
      return {};
    }
    return merge(obj1, obj2);
  };

  // Set aliases, so we can save some typing.
  I18n.t = I18n.translate.bind(I18n);
  I18n.l = I18n.localize.bind(I18n);
  I18n.p = I18n.pluralize.bind(I18n);

  return I18n;
}));
// https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Array/indexOf
if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (searchElement /*, fromIndex */ ) {
        "use strict";
        if (this == null) {
            throw new TypeError();
        }
        var t = Object(this);
        var len = t.length >>> 0;
        if (len === 0) {
            return -1;
        }
        var n = 0;
        if (arguments.length > 1) {
            n = Number(arguments[1]);
            if (n != n) { // shortcut for verifying if it's NaN
                n = 0;
            } else if (n != 0 && n != Infinity && n != -Infinity) {
                n = (n > 0 || -1) * Math.floor(Math.abs(n));
            }
        }
        if (n >= len) {
            return -1;
        }
        var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
        for (; k < len; k++) {
            if (k in t && t[k] === searchElement) {
                return k;
            }
        }
        return -1;
    }
}

// Production steps of ECMA-262, Edition 5, 15.4.4.18
// Reference: https://es5.github.com/#x15.4.4.18
// https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Array/forEach
if ( !Array.prototype.forEach ) {

  Array.prototype.forEach = function forEach( callback, thisArg ) {

    var T, k;

    if ( this == null ) {
      throw new TypeError( "this is null or not defined" );
    }

    // 1. Let O be the result of calling ToObject passing the |this| value as the argument.
    var O = Object(this);

    // 2. Let lenValue be the result of calling the Get internal method of O with the argument "length".
    // 3. Let len be ToUint32(lenValue).
    var len = O.length >>> 0; // Hack to convert O.length to a UInt32

    // 4. If IsCallable(callback) is false, throw a TypeError exception.
    // See: https://es5.github.com/#x9.11
    if ( {}.toString.call(callback) !== "[object Function]" ) {
      throw new TypeError( callback + " is not a function" );
    }

    // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
    if ( thisArg ) {
      T = thisArg;
    }

    // 6. Let k be 0
    k = 0;

    // 7. Repeat, while k < len
    while( k < len ) {

      var kValue;

      // a. Let Pk be ToString(k).
      //   This is implicit for LHS operands of the in operator
      // b. Let kPresent be the result of calling the HasProperty internal method of O with argument Pk.
      //   This step can be combined with c
      // c. If kPresent is true, then
      if ( Object.prototype.hasOwnProperty.call(O, k) ) {

        // i. Let kValue be the result of calling the Get internal method of O with argument Pk.
        kValue = O[ k ];

        // ii. Call the Call internal method of callback with T as the this value and
        // argument list containing kValue, k, and O.
        callback.call( T, kValue, k, O );
      }
      // d. Increase k by 1.
      k++;
    }
    // 8. return undefined
  };
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/some
if (!Array.prototype.some)
{
  Array.prototype.some = function(fun /*, thisArg */)
  {
    'use strict';

    if (this === void 0 || this === null)
      throw new TypeError();

    var t = Object(this);
    var len = t.length >>> 0;
    if (typeof fun !== 'function')
      throw new TypeError();

    var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
    for (var i = 0; i < len; i++)
    {
      if (i in t && fun.call(thisArg, t[i], i, t))
        return true;
    }

    return false;
  };
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map
if (!Array.prototype.map) {

  Array.prototype.map = function(callback/*, thisArg*/) {

    var T, A, k;

    if (this == null) {
      throw new TypeError('this is null or not defined');
    }

    // 1. Let O be the result of calling ToObject passing the |this| 
    //    value as the argument.
    var O = Object(this);

    // 2. Let lenValue be the result of calling the Get internal 
    //    method of O with the argument "length".
    // 3. Let len be ToUint32(lenValue).
    var len = O.length >>> 0;

    // 4. If IsCallable(callback) is false, throw a TypeError exception.
    // See: https://es5.github.com/#x9.11
    if (typeof callback !== 'function') {
      throw new TypeError(callback + ' is not a function');
    }

    // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
    if (arguments.length > 1) {
      T = arguments[1];
    }

    // 6. Let A be a new array created as if by the expression new Array(len) 
    //    where Array is the standard built-in constructor with that name and 
    //    len is the value of len.
    A = new Array(len);

    // 7. Let k be 0
    k = 0;

    // 8. Repeat, while k < len
    while (k < len) {

      var kValue, mappedValue;

      // a. Let Pk be ToString(k).
      //   This is implicit for LHS operands of the in operator
      // b. Let kPresent be the result of calling the HasProperty internal 
      //    method of O with argument Pk.
      //   This step can be combined with c
      // c. If kPresent is true, then
      if (k in O) {

        // i. Let kValue be the result of calling the Get internal 
        //    method of O with argument Pk.
        kValue = O[k];

        // ii. Let mappedValue be the result of calling the Call internal 
        //     method of callback with T as the this value and argument 
        //     list containing kValue, k, and O.
        mappedValue = callback.call(T, kValue, k, O);

        // iii. Call the DefineOwnProperty internal method of A with arguments
        // Pk, Property Descriptor
        // { Value: mappedValue,
        //   Writable: true,
        //   Enumerable: true,
        //   Configurable: true },
        // and false.

        // In browsers that support Object.defineProperty, use the following:
        // Object.defineProperty(A, k, {
        //   value: mappedValue,
        //   writable: true,
        //   enumerable: true,
        //   configurable: true
        // });

        // For best browser support, use the following:
        A[k] = mappedValue;
      }
      // d. Increase k by 1.
      k++;
    }

    // 9. return A
    return A;
  };
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_objects/Function/bind
if (!Function.prototype.bind) (function(){
  var ArrayPrototypeSlice = Array.prototype.slice;
  Function.prototype.bind = function(otherThis) {
    if (typeof this !== 'function') {
      // closest thing possible to the ECMAScript 5
      // internal IsCallable function
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }

    var baseArgs= ArrayPrototypeSlice .call(arguments, 1),
        baseArgsLength = baseArgs.length,
        fToBind = this,
        fNOP    = function() {},
        fBound  = function() {
          baseArgs.length = baseArgsLength; // reset to default base arguments
          baseArgs.push.apply(baseArgs, arguments);
          return fToBind.apply(
                 fNOP.prototype.isPrototypeOf(this) ? this : otherThis, baseArgs
          );
        };

    if (this.prototype) {
      // Function.prototype doesn't have a prototype property
      fNOP.prototype = this.prototype; 
    }
    fBound.prototype = new fNOP();

    return fBound;
  };
})();

// Using UMD pattern from
// https://github.com/umdjs/umd#regular-module
// `returnExports.js` version
;(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(["i18n"], factory);
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    factory(require("i18n"));
  } else {
    // Browser globals (root is window)
    factory(root.I18n);
  }
}(this, function(I18n) {
  "use strict";

  I18n.translations = {"de":{"js":{"browser":{"not_supported":"Dieser Browser wird nicht unterstützt. Bitte verwenden Sie die aktuelle Version von Chrome, Firefox oder Safari."}}},"de-AT":{"js":{"browser":{"not_supported":"Dieser Browser wird nicht unterstützt. Bitte verwenden Sie die aktuelle Version von Chrome, Firefox oder Safari."}}},"de-BE":{"js":{"browser":{"not_supported":"Dieser Browser wird nicht unterstützt. Bitte verwenden Sie die aktuelle Version von Chrome, Firefox oder Safari."}}},"de-CH":{"js":{"browser":{"not_supported":"Dieser Browser wird nicht unterstützt. Bitte verwenden Sie die aktuelle Version von Chrome, Firefox oder Safari."}}},"de-LU":{"js":{"browser":{"not_supported":"Dieser Browser wird nicht unterstützt. Bitte verwenden Sie die aktuelle Version von Chrome, Firefox oder Safari."}}},"de-NL":{"js":{"browser":{"not_supported":"Dieser Browser wird nicht unterstützt. Bitte verwenden Sie die aktuelle Version von Chrome, Firefox oder Safari."}}},"en":{"js":{"browser":{"not_supported":"This browser is not supported. Please use the latest version of Chrome, Firefox or Safari."}}},"en-CA":{"js":{"browser":{"not_supported":"This browser is not supported. Please use the latest version of Chrome, Firefox or Safari."}}},"en-GB":{"js":{"browser":{"not_supported":"This browser is not supported. Please use the latest version of Chrome, Firefox or Safari."}}},"en-IE":{"js":{"browser":{"not_supported":"This browser is not supported. Please use the latest version of Chrome, Firefox or Safari."}}},"en-QA":{"js":{"browser":{"not_supported":"This browser is not supported. Please use the latest version of Chrome, Firefox or Safari."}}},"en-US":{"js":{"browser":{"not_supported":"This browser is not supported. Please use the latest version of Chrome, Firefox or Safari."}}},"es":{"js":{"browser":{"not_supported":"Este navegador no es compatible. Utiliza la última versión de Chrome, Firefox o Safari."}}},"es-MX":{"js":{"browser":{"not_supported":"Este navegador no es compatible. Utiliza la última versión de Chrome, Firefox o Safari."}}},"es-QA":{"js":{"browser":{"not_supported":"Este navegador no es compatible. Utiliza la última versión de Chrome, Firefox o Safari."}}},"es-US":{"js":{"browser":{"not_supported":"Este navegador no es compatible. Utiliza la última versión de Chrome, Firefox o Safari."}}},"fr":{"js":{"browser":{"not_supported":"Ce navigateur n’est pas pris en charge. Veuillez utiliser la dernière version de Chrome, Firefox ou Safari."}}},"fr-BE":{"js":{"browser":{"not_supported":"Ce navigateur n’est pas pris en charge. Veuillez utiliser la dernière version de Chrome, Firefox ou Safari."}}},"fr-LU":{"js":{"browser":{"not_supported":"Ce navigateur n’est pas pris en charge. Veuillez utiliser la dernière version de Chrome, Firefox ou Safari."}}},"fr-NL":{"js":{"browser":{"not_supported":"Ce navigateur n’est pas pris en charge. Veuillez utiliser la dernière version de Chrome, Firefox ou Safari."}}},"nl":{"js":{"browser":{"not_supported":"Deze browser wordt niet ondersteund. Gebruik de nieuwste versie van Chrome, Firefox of Safari."}}},"nl-BE":{"js":{"browser":{"not_supported":"Deze browser wordt niet ondersteund. Gebruik de nieuwste versie van Chrome, Firefox of Safari."}}},"nl-NL":{"js":{"browser":{"not_supported":"Deze browser wordt niet ondersteund. Gebruik de nieuwste versie van Chrome, Firefox of Safari."}}},"qa":{"js":{"browser":{"not_supported":"This browser is not supported. Please use the latest version of Chrome, Firefox or Safari."}}}};
}));



/*!
 * GSAP 3.13.0
 * https://gsap.com
 * 
 * @license Copyright 2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license.
 * @author: Jack Doyle, jack@greensock.com
 */


!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e((t=t||self).window=t.window||{})}(this,function(e){"use strict";function _inheritsLoose(t,e){t.prototype=Object.create(e.prototype),(t.prototype.constructor=t).__proto__=e}function _assertThisInitialized(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function r(t){return"string"==typeof t}function s(t){return"function"==typeof t}function t(t){return"number"==typeof t}function u(t){return void 0===t}function v(t){return"object"==typeof t}function w(t){return!1!==t}function x(){return"undefined"!=typeof window}function y(t){return s(t)||r(t)}function P(t){return(i=yt(t,ot))&&ze}function Q(t,e){return console.warn("Invalid property",t,"set to",e,"Missing plugin? gsap.registerPlugin()")}function R(t,e){return!e&&console.warn(t)}function S(t,e){return t&&(ot[t]=e)&&i&&(i[t]=e)||ot}function T(){return 0}function ea(t){var e,r,i=t[0];if(v(i)||s(i)||(t=[t]),!(e=(i._gsap||{}).harness)){for(r=gt.length;r--&&!gt[r].targetTest(i););e=gt[r]}for(r=t.length;r--;)t[r]&&(t[r]._gsap||(t[r]._gsap=new Zt(t[r],e)))||t.splice(r,1);return t}function fa(t){return t._gsap||ea(Ot(t))[0]._gsap}function ga(t,e,r){return(r=t[e])&&s(r)?t[e]():u(r)&&t.getAttribute&&t.getAttribute(e)||r}function ha(t,e){return(t=t.split(",")).forEach(e)||t}function ia(t){return Math.round(1e5*t)/1e5||0}function ja(t){return Math.round(1e7*t)/1e7||0}function ka(t,e){var r=e.charAt(0),i=parseFloat(e.substr(2));return t=parseFloat(t),"+"===r?t+i:"-"===r?t-i:"*"===r?t*i:t/i}function la(t,e){for(var r=e.length,i=0;t.indexOf(e[i])<0&&++i<r;);return i<r}function ma(){var t,e,r=dt.length,i=dt.slice(0);for(ct={},t=dt.length=0;t<r;t++)(e=i[t])&&e._lazy&&(e.render(e._lazy[0],e._lazy[1],!0)._lazy=0)}function na(t){return!!(t._initted||t._startAt||t.add)}function oa(t,e,r,i){dt.length&&!L&&ma(),t.render(e,r,i||!!(L&&e<0&&na(t))),dt.length&&!L&&ma()}function pa(t){var e=parseFloat(t);return(e||0===e)&&(t+"").match(at).length<2?e:r(t)?t.trim():t}function qa(t){return t}function ra(t,e){for(var r in e)r in t||(t[r]=e[r]);return t}function ua(t,e){for(var r in e)"__proto__"!==r&&"constructor"!==r&&"prototype"!==r&&(t[r]=v(e[r])?ua(t[r]||(t[r]={}),e[r]):e[r]);return t}function va(t,e){var r,i={};for(r in t)r in e||(i[r]=t[r]);return i}function wa(t){var e=t.parent||I,r=t.keyframes?function _setKeyframeDefaults(i){return function(t,e){for(var r in e)r in t||"duration"===r&&i||"ease"===r||(t[r]=e[r])}}($(t.keyframes)):ra;if(w(t.inherit))for(;e;)r(t,e.vars.defaults),e=e.parent||e._dp;return t}function ya(t,e,r,i,n){void 0===r&&(r="_first"),void 0===i&&(i="_last");var a,s=t[i];if(n)for(a=e[n];s&&s[n]>a;)s=s._prev;return s?(e._next=s._next,s._next=e):(e._next=t[r],t[r]=e),e._next?e._next._prev=e:t[i]=e,e._prev=s,e.parent=e._dp=t,e}function za(t,e,r,i){void 0===r&&(r="_first"),void 0===i&&(i="_last");var n=e._prev,a=e._next;n?n._next=a:t[r]===e&&(t[r]=a),a?a._prev=n:t[i]===e&&(t[i]=n),e._next=e._prev=e.parent=null}function Aa(t,e){t.parent&&(!e||t.parent.autoRemoveChildren)&&t.parent.remove&&t.parent.remove(t),t._act=0}function Ba(t,e){if(t&&(!e||e._end>t._dur||e._start<0))for(var r=t;r;)r._dirty=1,r=r.parent;return t}function Da(t,e,r,i){return t._startAt&&(L?t._startAt.revert(ht):t.vars.immediateRender&&!t.vars.autoRevert||t._startAt.render(e,!0,i))}function Fa(t){return t._repeat?Tt(t._tTime,t=t.duration()+t._rDelay)*t:0}function Ha(t,e){return(t-e._start)*e._ts+(0<=e._ts?0:e._dirty?e.totalDuration():e._tDur)}function Ia(t){return t._end=ja(t._start+(t._tDur/Math.abs(t._ts||t._rts||U)||0))}function Ja(t,e){var r=t._dp;return r&&r.smoothChildTiming&&t._ts&&(t._start=ja(r._time-(0<t._ts?e/t._ts:((t._dirty?t.totalDuration():t._tDur)-e)/-t._ts)),Ia(t),r._dirty||Ba(r,t)),t}function Ka(t,e){var r;if((e._time||!e._dur&&e._initted||e._start<t._time&&(e._dur||!e.add))&&(r=Ha(t.rawTime(),e),(!e._dur||Mt(0,e.totalDuration(),r)-e._tTime>U)&&e.render(r,!0)),Ba(t,e)._dp&&t._initted&&t._time>=t._dur&&t._ts){if(t._dur<t.duration())for(r=t;r._dp;)0<=r.rawTime()&&r.totalTime(r._tTime),r=r._dp;t._zTime=-U}}function La(e,r,i,n){return r.parent&&Aa(r),r._start=ja((t(i)?i:i||e!==I?xt(e,i,r):e._time)+r._delay),r._end=ja(r._start+(r.totalDuration()/Math.abs(r.timeScale())||0)),ya(e,r,"_first","_last",e._sort?"_start":0),bt(r)||(e._recent=r),n||Ka(e,r),e._ts<0&&Ja(e,e._tTime),e}function Ma(t,e){return(ot.ScrollTrigger||Q("scrollTrigger",e))&&ot.ScrollTrigger.create(e,t)}function Na(t,e,r,i,n){return Wt(t,e,n),t._initted?!r&&t._pt&&!L&&(t._dur&&!1!==t.vars.lazy||!t._dur&&t.vars.lazy)&&f!==Rt.frame?(dt.push(t),t._lazy=[n,i],1):void 0:1}function Sa(t,e,r,i){var n=t._repeat,a=ja(e)||0,s=t._tTime/t._tDur;return s&&!i&&(t._time*=a/t._dur),t._dur=a,t._tDur=n?n<0?1e10:ja(a*(n+1)+t._rDelay*n):a,0<s&&!i&&Ja(t,t._tTime=t._tDur*s),t.parent&&Ia(t),r||Ba(t.parent,t),t}function Ta(t){return t instanceof Qt?Ba(t):Sa(t,t._dur)}function Wa(e,r,i){var n,a,s=t(r[1]),o=(s?2:1)+(e<2?0:1),u=r[o];if(s&&(u.duration=r[1]),u.parent=i,e){for(n=u,a=i;a&&!("immediateRender"in n);)n=a.vars.defaults||{},a=w(a.vars.inherit)&&a.parent;u.immediateRender=w(n.immediateRender),e<2?u.runBackwards=1:u.startAt=r[o-1]}return new Jt(r[0],u,r[1+o])}function Xa(t,e){return t||0===t?e(t):e}function Za(t,e){return r(t)&&(e=st.exec(t))?e[1]:""}function ab(t,e){return t&&v(t)&&"length"in t&&(!e&&!t.length||t.length-1 in t&&v(t[0]))&&!t.nodeType&&t!==h}function db(r){return r=Ot(r)[0]||R("Invalid scope")||{},function(t){var e=r.current||r.nativeElement||r;return Ot(t,e.querySelectorAll?e:e===r?R("Invalid scope")||a.createElement("div"):r)}}function eb(t){return t.sort(function(){return.5-Math.random()})}function fb(t){if(s(t))return t;var p=v(t)?t:{each:t},_=Yt(p.ease),m=p.from||0,g=parseFloat(p.base)||0,y={},e=0<m&&m<1,T=isNaN(m)||e,b=p.axis,w=m,x=m;return r(m)?w=x={center:.5,edges:.5,end:1}[m]||0:!e&&T&&(w=m[0],x=m[1]),function(t,e,r){var i,n,a,s,o,u,h,l,f,d=(r||p).length,c=y[d];if(!c){if(!(f="auto"===p.grid?0:(p.grid||[1,N])[1])){for(h=-N;h<(h=r[f++].getBoundingClientRect().left)&&f<d;);f<d&&f--}for(c=y[d]=[],i=T?Math.min(f,d)*w-.5:m%f,n=f===N?0:T?d*x/f-.5:m/f|0,l=N,u=h=0;u<d;u++)a=u%f-i,s=n-(u/f|0),c[u]=o=b?Math.abs("y"===b?s:a):G(a*a+s*s),h<o&&(h=o),o<l&&(l=o);"random"===m&&eb(c),c.max=h-l,c.min=l,c.v=d=(parseFloat(p.amount)||parseFloat(p.each)*(d<f?d-1:b?"y"===b?d/f:f:Math.max(f,d/f))||0)*("edges"===m?-1:1),c.b=d<0?g-d:g,c.u=Za(p.amount||p.each)||0,_=_&&d<0?jt(_):_}return d=(c[t]-c.min)/c.max||0,ja(c.b+(_?_(d):d)*c.v)+c.u}}function gb(i){var n=Math.pow(10,((i+"").split(".")[1]||"").length);return function(e){var r=ja(Math.round(parseFloat(e)/i)*i*n);return(r-r%1)/n+(t(e)?0:Za(e))}}function hb(h,e){var l,f,r=$(h);return!r&&v(h)&&(l=r=h.radius||N,h.values?(h=Ot(h.values),(f=!t(h[0]))&&(l*=l)):h=gb(h.increment)),Xa(e,r?s(h)?function(t){return f=h(t),Math.abs(f-t)<=l?f:t}:function(e){for(var r,i,n=parseFloat(f?e.x:e),a=parseFloat(f?e.y:0),s=N,o=0,u=h.length;u--;)(r=f?(r=h[u].x-n)*r+(i=h[u].y-a)*i:Math.abs(h[u]-n))<s&&(s=r,o=u);return o=!l||s<=l?h[o]:e,f||o===e||t(e)?o:o+Za(e)}:gb(h))}function ib(t,e,r,i){return Xa($(t)?!e:!0===r?!!(r=0):!i,function(){return $(t)?t[~~(Math.random()*t.length)]:(r=r||1e-5)&&(i=r<1?Math.pow(10,(r+"").length-2):1)&&Math.floor(Math.round((t-r/2+Math.random()*(e-t+.99*r))/r)*r*i)/i})}function mb(e,r,t){return Xa(t,function(t){return e[~~r(t)]})}function pb(t){for(var e,r,i,n,a=0,s="";~(e=t.indexOf("random(",a));)i=t.indexOf(")",e),n="["===t.charAt(e+7),r=t.substr(e+7,i-e-7).match(n?at:tt),s+=t.substr(a,e-a)+ib(n?r:+r[0],n?0:+r[1],+r[2]||1e-5),a=i+1;return s+t.substr(a,t.length-a)}function sb(t,e,r){var i,n,a,s=t.labels,o=N;for(i in s)(n=s[i]-e)<0==!!r&&n&&o>(n=Math.abs(n))&&(a=i,o=n);return a}function ub(t){return Aa(t),t.scrollTrigger&&t.scrollTrigger.kill(!!L),t.progress()<1&&Pt(t,"onInterrupt"),t}function xb(t){if(t)if(t=!t.name&&t.default||t,x()||t.headless){var e=t.name,r=s(t),i=e&&!r&&t.init?function(){this._props=[]}:t,n={init:T,render:ue,add:Vt,kill:de,modifier:he,rawVars:0},a={targetTest:0,get:0,getSetter:ie,aliases:{},register:0};if(Ft(),t!==i){if(pt[e])return;ra(i,ra(va(t,n),a)),yt(i.prototype,yt(n,va(t,a))),pt[i.prop=e]=i,t.targetTest&&(gt.push(i),ft[e]=1),e=("css"===e?"CSS":e.charAt(0).toUpperCase()+e.substr(1))+"Plugin"}S(e,i),t.register&&t.register(ze,i,ge)}else Ct.push(t)}function Ab(t,e,r){return(6*(t+=t<0?1:1<t?-1:0)<1?e+(r-e)*t*6:t<.5?r:3*t<2?e+(r-e)*(2/3-t)*6:e)*St+.5|0}function Bb(e,r,i){var n,a,s,o,u,h,l,f,d,c,p=e?t(e)?[e>>16,e>>8&St,e&St]:0:Dt.black;if(!p){if(","===e.substr(-1)&&(e=e.substr(0,e.length-1)),Dt[e])p=Dt[e];else if("#"===e.charAt(0)){if(e.length<6&&(e="#"+(n=e.charAt(1))+n+(a=e.charAt(2))+a+(s=e.charAt(3))+s+(5===e.length?e.charAt(4)+e.charAt(4):"")),9===e.length)return[(p=parseInt(e.substr(1,6),16))>>16,p>>8&St,p&St,parseInt(e.substr(7),16)/255];p=[(e=parseInt(e.substr(1),16))>>16,e>>8&St,e&St]}else if("hsl"===e.substr(0,3))if(p=c=e.match(tt),r){if(~e.indexOf("="))return p=e.match(et),i&&p.length<4&&(p[3]=1),p}else o=+p[0]%360/360,u=p[1]/100,n=2*(h=p[2]/100)-(a=h<=.5?h*(u+1):h+u-h*u),3<p.length&&(p[3]*=1),p[0]=Ab(o+1/3,n,a),p[1]=Ab(o,n,a),p[2]=Ab(o-1/3,n,a);else p=e.match(tt)||Dt.transparent;p=p.map(Number)}return r&&!c&&(n=p[0]/St,a=p[1]/St,s=p[2]/St,h=((l=Math.max(n,a,s))+(f=Math.min(n,a,s)))/2,l===f?o=u=0:(d=l-f,u=.5<h?d/(2-l-f):d/(l+f),o=l===n?(a-s)/d+(a<s?6:0):l===a?(s-n)/d+2:(n-a)/d+4,o*=60),p[0]=~~(o+.5),p[1]=~~(100*u+.5),p[2]=~~(100*h+.5)),i&&p.length<4&&(p[3]=1),p}function Cb(t){var r=[],i=[],n=-1;return t.split(zt).forEach(function(t){var e=t.match(rt)||[];r.push.apply(r,e),i.push(n+=e.length+1)}),r.c=i,r}function Db(t,e,r){var i,n,a,s,o="",u=(t+o).match(zt),h=e?"hsla(":"rgba(",l=0;if(!u)return t;if(u=u.map(function(t){return(t=Bb(t,e,1))&&h+(e?t[0]+","+t[1]+"%,"+t[2]+"%,"+t[3]:t.join(","))+")"}),r&&(a=Cb(t),(i=r.c).join(o)!==a.c.join(o)))for(s=(n=t.replace(zt,"1").split(rt)).length-1;l<s;l++)o+=n[l]+(~i.indexOf(l)?u.shift()||h+"0,0,0,0)":(a.length?a:u.length?u:r).shift());if(!n)for(s=(n=t.split(zt)).length-1;l<s;l++)o+=n[l]+u[l];return o+n[s]}function Gb(t){var e,r=t.join(" ");if(zt.lastIndex=0,zt.test(r))return e=Et.test(r),t[1]=Db(t[1],e),t[0]=Db(t[0],e,Cb(t[1])),!0}function Pb(t){var e=(t+"").split("("),r=Lt[e[0]];return r&&1<e.length&&r.config?r.config.apply(null,~t.indexOf("{")?[function _parseObjectInString(t){for(var e,r,i,n={},a=t.substr(1,t.length-3).split(":"),s=a[0],o=1,u=a.length;o<u;o++)r=a[o],e=o!==u-1?r.lastIndexOf(","):r.length,i=r.substr(0,e),n[s]=isNaN(i)?i.replace(Bt,"").trim():+i,s=r.substr(e+1).trim();return n}(e[1])]:function _valueInParentheses(t){var e=t.indexOf("(")+1,r=t.indexOf(")"),i=t.indexOf("(",e);return t.substring(e,~i&&i<r?t.indexOf(")",r+1):r)}(t).split(",").map(pa)):Lt._CE&&It.test(t)?Lt._CE("",t):r}function Rb(t,e){for(var r,i=t._first;i;)i instanceof Qt?Rb(i,e):!i.vars.yoyoEase||i._yoyo&&i._repeat||i._yoyo===e||(i.timeline?Rb(i.timeline,e):(r=i._ease,i._ease=i._yEase,i._yEase=r,i._yoyo=e)),i=i._next}function Tb(t,e,r,i){void 0===r&&(r=function easeOut(t){return 1-e(1-t)}),void 0===i&&(i=function easeInOut(t){return t<.5?e(2*t)/2:1-e(2*(1-t))/2});var n,a={easeIn:e,easeOut:r,easeInOut:i};return ha(t,function(t){for(var e in Lt[t]=ot[t]=a,Lt[n=t.toLowerCase()]=r,a)Lt[n+("easeIn"===e?".in":"easeOut"===e?".out":".inOut")]=Lt[t+"."+e]=a[e]}),a}function Ub(e){return function(t){return t<.5?(1-e(1-2*t))/2:.5+e(2*(t-.5))/2}}function Vb(r,t,e){function Lm(t){return 1===t?1:i*Math.pow(2,-10*t)*K((t-a)*n)+1}var i=1<=t?t:1,n=(e||(r?.3:.45))/(t<1?t:1),a=n/q*(Math.asin(1/i)||0),s="out"===r?Lm:"in"===r?function(t){return 1-Lm(1-t)}:Ub(Lm);return n=q/n,s.config=function(t,e){return Vb(r,t,e)},s}function Wb(e,r){function Tm(t){return t?--t*t*((r+1)*t+r)+1:0}void 0===r&&(r=1.70158);var t="out"===e?Tm:"in"===e?function(t){return 1-Tm(1-t)}:Ub(Tm);return t.config=function(t){return Wb(e,t)},t}var F,L,l,I,h,n,a,i,o,f,d,c,p,_,m,g,b,M,k,O,A,C,D,z,E,B,j,Y,X={autoSleep:120,force3D:"auto",nullTargetWarn:1,units:{lineHeight:""}},Z={duration:.5,overwrite:!1,delay:0},N=1e8,U=1/N,q=2*Math.PI,V=q/4,W=0,G=Math.sqrt,H=Math.cos,K=Math.sin,J="function"==typeof ArrayBuffer&&ArrayBuffer.isView||function(){},$=Array.isArray,tt=/(?:-?\.?\d|\.)+/gi,et=/[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,rt=/[-+=.]*\d+[.e-]*\d*[a-z%]*/g,it=/[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,nt=/[+-]=-?[.\d]+/,at=/[^,'"\[\]\s]+/gi,st=/^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,ot={},ut={suppressEvents:!0,isStart:!0,kill:!1},ht={suppressEvents:!0,kill:!1},lt={suppressEvents:!0},ft={},dt=[],ct={},pt={},_t={},mt=30,gt=[],vt="",yt=function _merge(t,e){for(var r in e)t[r]=e[r];return t},Tt=function _animationCycle(t,e){var r=Math.floor(t=ja(t/e));return t&&r===t?r-1:r},bt=function _isFromOrFromStart(t){var e=t.data;return"isFromStart"===e||"isStart"===e},wt={_start:0,endTime:T,totalDuration:T},xt=function _parsePosition(t,e,i){var n,a,s,o=t.labels,u=t._recent||wt,h=t.duration()>=N?u.endTime(!1):t._dur;return r(e)&&(isNaN(e)||e in o)?(a=e.charAt(0),s="%"===e.substr(-1),n=e.indexOf("="),"<"===a||">"===a?(0<=n&&(e=e.replace(/=/,"")),("<"===a?u._start:u.endTime(0<=u._repeat))+(parseFloat(e.substr(1))||0)*(s?(n<0?u:i).totalDuration()/100:1)):n<0?(e in o||(o[e]=h),o[e]):(a=parseFloat(e.charAt(n-1)+e.substr(n+1)),s&&i&&(a=a/100*($(i)?i[0]:i).totalDuration()),1<n?_parsePosition(t,e.substr(0,n-1),i)+a:h+a)):null==e?h:+e},Mt=function _clamp(t,e,r){return r<t?t:e<r?e:r},kt=[].slice,Ot=function toArray(t,e,i){return l&&!e&&l.selector?l.selector(t):!r(t)||i||!n&&Ft()?$(t)?function _flatten(t,e,i){return void 0===i&&(i=[]),t.forEach(function(t){return r(t)&&!e||ab(t,1)?i.push.apply(i,Ot(t)):i.push(t)})||i}(t,i):ab(t)?kt.call(t,0):t?[t]:[]:kt.call((e||a).querySelectorAll(t),0)},At=function mapRange(e,t,r,i,n){var a=t-e,s=i-r;return Xa(n,function(t){return r+((t-e)/a*s||0)})},Pt=function _callback(t,e,r){var i,n,a,s=t.vars,o=s[e],u=l,h=t._ctx;if(o)return i=s[e+"Params"],n=s.callbackScope||t,r&&dt.length&&ma(),h&&(l=h),a=i?o.apply(n,i):o.call(n),l=u,a},Ct=[],St=255,Dt={aqua:[0,St,St],lime:[0,St,0],silver:[192,192,192],black:[0,0,0],maroon:[128,0,0],teal:[0,128,128],blue:[0,0,St],navy:[0,0,128],white:[St,St,St],olive:[128,128,0],yellow:[St,St,0],orange:[St,165,0],gray:[128,128,128],purple:[128,0,128],green:[0,128,0],red:[St,0,0],pink:[St,192,203],cyan:[0,St,St],transparent:[St,St,St,0]},zt=function(){var t,e="(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";for(t in Dt)e+="|"+t+"\\b";return new RegExp(e+")","gi")}(),Et=/hsl[a]?\(/,Rt=(k=Date.now,O=500,A=33,C=k(),D=C,E=z=1e3/240,g={time:0,frame:0,tick:function tick(){Al(!0)},deltaRatio:function deltaRatio(t){return b/(1e3/(t||60))},wake:function wake(){o&&(!n&&x()&&(h=n=window,a=h.document||{},ot.gsap=ze,(h.gsapVersions||(h.gsapVersions=[])).push(ze.version),P(i||h.GreenSockGlobals||!h.gsap&&h||{}),Ct.forEach(xb)),m="undefined"!=typeof requestAnimationFrame&&requestAnimationFrame,p&&g.sleep(),_=m||function(t){return setTimeout(t,E-1e3*g.time+1|0)},c=1,Al(2))},sleep:function sleep(){(m?cancelAnimationFrame:clearTimeout)(p),c=0,_=T},lagSmoothing:function lagSmoothing(t,e){O=t||1/0,A=Math.min(e||33,O)},fps:function fps(t){z=1e3/(t||240),E=1e3*g.time+z},add:function add(n,t,e){var a=t?function(t,e,r,i){n(t,e,r,i),g.remove(a)}:n;return g.remove(n),B[e?"unshift":"push"](a),Ft(),a},remove:function remove(t,e){~(e=B.indexOf(t))&&B.splice(e,1)&&e<=M&&M--},_listeners:B=[]}),Ft=function _wake(){return!c&&Rt.wake()},Lt={},It=/^[\d.\-M][\d.\-,\s]/,Bt=/["']/g,jt=function _invertEase(e){return function(t){return 1-e(1-t)}},Yt=function _parseEase(t,e){return t&&(s(t)?t:Lt[t]||Pb(t))||e};function Al(t){var e,r,i,n,a=k()-D,s=!0===t;if((O<a||a<0)&&(C+=a-A),(0<(e=(i=(D+=a)-C)-E)||s)&&(n=++g.frame,b=i-1e3*g.time,g.time=i/=1e3,E+=e+(z<=e?4:z-e),r=1),s||(p=_(Al)),r)for(M=0;M<B.length;M++)B[M](i,b,n,t)}function jn(t){return t<Y?j*t*t:t<.7272727272727273?j*Math.pow(t-1.5/2.75,2)+.75:t<.9090909090909092?j*(t-=2.25/2.75)*t+.9375:j*Math.pow(t-2.625/2.75,2)+.984375}ha("Linear,Quad,Cubic,Quart,Quint,Strong",function(t,e){var r=e<5?e+1:e;Tb(t+",Power"+(r-1),e?function(t){return Math.pow(t,r)}:function(t){return t},function(t){return 1-Math.pow(1-t,r)},function(t){return t<.5?Math.pow(2*t,r)/2:1-Math.pow(2*(1-t),r)/2})}),Lt.Linear.easeNone=Lt.none=Lt.Linear.easeIn,Tb("Elastic",Vb("in"),Vb("out"),Vb()),j=7.5625,Y=1/2.75,Tb("Bounce",function(t){return 1-jn(1-t)},jn),Tb("Expo",function(t){return Math.pow(2,10*(t-1))*t+t*t*t*t*t*t*(1-t)}),Tb("Circ",function(t){return-(G(1-t*t)-1)}),Tb("Sine",function(t){return 1===t?1:1-H(t*V)}),Tb("Back",Wb("in"),Wb("out"),Wb()),Lt.SteppedEase=Lt.steps=ot.SteppedEase={config:function config(t,e){void 0===t&&(t=1);var r=1/t,i=t+(e?0:1),n=e?1:0;return function(t){return((i*Mt(0,.99999999,t)|0)+n)*r}}},Z.ease=Lt["quad.out"],ha("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt",function(t){return vt+=t+","+t+"Params,"});var Xt,Zt=function GSCache(t,e){this.id=W++,(t._gsap=this).target=t,this.harness=e,this.get=e?e.get:ga,this.set=e?e.getSetter:ie},Nt=((Xt=Animation.prototype).delay=function delay(t){return t||0===t?(this.parent&&this.parent.smoothChildTiming&&this.startTime(this._start+t-this._delay),this._delay=t,this):this._delay},Xt.duration=function duration(t){return arguments.length?this.totalDuration(0<this._repeat?t+(t+this._rDelay)*this._repeat:t):this.totalDuration()&&this._dur},Xt.totalDuration=function totalDuration(t){return arguments.length?(this._dirty=0,Sa(this,this._repeat<0?t:(t-this._repeat*this._rDelay)/(this._repeat+1))):this._tDur},Xt.totalTime=function totalTime(t,e){if(Ft(),!arguments.length)return this._tTime;var r=this._dp;if(r&&r.smoothChildTiming&&this._ts){for(Ja(this,t),!r._dp||r.parent||Ka(r,this);r&&r.parent;)r.parent._time!==r._start+(0<=r._ts?r._tTime/r._ts:(r.totalDuration()-r._tTime)/-r._ts)&&r.totalTime(r._tTime,!0),r=r.parent;!this.parent&&this._dp.autoRemoveChildren&&(0<this._ts&&t<this._tDur||this._ts<0&&0<t||!this._tDur&&!t)&&La(this._dp,this,this._start-this._delay)}return(this._tTime!==t||!this._dur&&!e||this._initted&&Math.abs(this._zTime)===U||!t&&!this._initted&&(this.add||this._ptLookup))&&(this._ts||(this._pTime=t),oa(this,t,e)),this},Xt.time=function time(t,e){return arguments.length?this.totalTime(Math.min(this.totalDuration(),t+Fa(this))%(this._dur+this._rDelay)||(t?this._dur:0),e):this._time},Xt.totalProgress=function totalProgress(t,e){return arguments.length?this.totalTime(this.totalDuration()*t,e):this.totalDuration()?Math.min(1,this._tTime/this._tDur):0<=this.rawTime()&&this._initted?1:0},Xt.progress=function progress(t,e){return arguments.length?this.totalTime(this.duration()*(!this._yoyo||1&this.iteration()?t:1-t)+Fa(this),e):this.duration()?Math.min(1,this._time/this._dur):0<this.rawTime()?1:0},Xt.iteration=function iteration(t,e){var r=this.duration()+this._rDelay;return arguments.length?this.totalTime(this._time+(t-1)*r,e):this._repeat?Tt(this._tTime,r)+1:1},Xt.timeScale=function timeScale(t,e){if(!arguments.length)return this._rts===-U?0:this._rts;if(this._rts===t)return this;var r=this.parent&&this._ts?Ha(this.parent._time,this):this._tTime;return this._rts=+t||0,this._ts=this._ps||t===-U?0:this._rts,this.totalTime(Mt(-Math.abs(this._delay),this.totalDuration(),r),!1!==e),Ia(this),function _recacheAncestors(t){for(var e=t.parent;e&&e.parent;)e._dirty=1,e.totalDuration(),e=e.parent;return t}(this)},Xt.paused=function paused(t){return arguments.length?(this._ps!==t&&((this._ps=t)?(this._pTime=this._tTime||Math.max(-this._delay,this.rawTime()),this._ts=this._act=0):(Ft(),this._ts=this._rts,this.totalTime(this.parent&&!this.parent.smoothChildTiming?this.rawTime():this._tTime||this._pTime,1===this.progress()&&Math.abs(this._zTime)!==U&&(this._tTime-=U)))),this):this._ps},Xt.startTime=function startTime(t){if(arguments.length){this._start=t;var e=this.parent||this._dp;return!e||!e._sort&&this.parent||La(e,this,t-this._delay),this}return this._start},Xt.endTime=function endTime(t){return this._start+(w(t)?this.totalDuration():this.duration())/Math.abs(this._ts||1)},Xt.rawTime=function rawTime(t){var e=this.parent||this._dp;return e?t&&(!this._ts||this._repeat&&this._time&&this.totalProgress()<1)?this._tTime%(this._dur+this._rDelay):this._ts?Ha(e.rawTime(t),this):this._tTime:this._tTime},Xt.revert=function revert(t){void 0===t&&(t=lt);var e=L;return L=t,na(this)&&(this.timeline&&this.timeline.revert(t),this.totalTime(-.01,t.suppressEvents)),"nested"!==this.data&&!1!==t.kill&&this.kill(),L=e,this},Xt.globalTime=function globalTime(t){for(var e=this,r=arguments.length?t:e.rawTime();e;)r=e._start+r/(Math.abs(e._ts)||1),e=e._dp;return!this.parent&&this._sat?this._sat.globalTime(t):r},Xt.repeat=function repeat(t){return arguments.length?(this._repeat=t===1/0?-2:t,Ta(this)):-2===this._repeat?1/0:this._repeat},Xt.repeatDelay=function repeatDelay(t){if(arguments.length){var e=this._time;return this._rDelay=t,Ta(this),e?this.time(e):this}return this._rDelay},Xt.yoyo=function yoyo(t){return arguments.length?(this._yoyo=t,this):this._yoyo},Xt.seek=function seek(t,e){return this.totalTime(xt(this,t),w(e))},Xt.restart=function restart(t,e){return this.play().totalTime(t?-this._delay:0,w(e)),this._dur||(this._zTime=-U),this},Xt.play=function play(t,e){return null!=t&&this.seek(t,e),this.reversed(!1).paused(!1)},Xt.reverse=function reverse(t,e){return null!=t&&this.seek(t||this.totalDuration(),e),this.reversed(!0).paused(!1)},Xt.pause=function pause(t,e){return null!=t&&this.seek(t,e),this.paused(!0)},Xt.resume=function resume(){return this.paused(!1)},Xt.reversed=function reversed(t){return arguments.length?(!!t!==this.reversed()&&this.timeScale(-this._rts||(t?-U:0)),this):this._rts<0},Xt.invalidate=function invalidate(){return this._initted=this._act=0,this._zTime=-U,this},Xt.isActive=function isActive(){var t,e=this.parent||this._dp,r=this._start;return!(e&&!(this._ts&&this._initted&&e.isActive()&&(t=e.rawTime(!0))>=r&&t<this.endTime(!0)-U))},Xt.eventCallback=function eventCallback(t,e,r){var i=this.vars;return 1<arguments.length?(e?(i[t]=e,r&&(i[t+"Params"]=r),"onUpdate"===t&&(this._onUpdate=e)):delete i[t],this):i[t]},Xt.then=function then(t){var i=this;return new Promise(function(e){function Eo(){var t=i.then;i.then=null,s(r)&&(r=r(i))&&(r.then||r===i)&&(i.then=t),e(r),i.then=t}var r=s(t)?t:qa;i._initted&&1===i.totalProgress()&&0<=i._ts||!i._tTime&&i._ts<0?Eo():i._prom=Eo})},Xt.kill=function kill(){ub(this)},Animation);function Animation(t){this.vars=t,this._delay=+t.delay||0,(this._repeat=t.repeat===1/0?-2:t.repeat||0)&&(this._rDelay=t.repeatDelay||0,this._yoyo=!!t.yoyo||!!t.yoyoEase),this._ts=1,Sa(this,+t.duration,1,1),this.data=t.data,l&&(this._ctx=l).data.push(this),c||Rt.wake()}ra(Nt.prototype,{_time:0,_start:0,_end:0,_tTime:0,_tDur:0,_dirty:0,_repeat:0,_yoyo:!1,parent:null,_initted:!1,_rDelay:0,_ts:1,_dp:0,ratio:0,_zTime:-U,_prom:0,_ps:!1,_rts:1});var Qt=function(i){function Timeline(t,e){var r;return void 0===t&&(t={}),(r=i.call(this,t)||this).labels={},r.smoothChildTiming=!!t.smoothChildTiming,r.autoRemoveChildren=!!t.autoRemoveChildren,r._sort=w(t.sortChildren),I&&La(t.parent||I,_assertThisInitialized(r),e),t.reversed&&r.reverse(),t.paused&&r.paused(!0),t.scrollTrigger&&Ma(_assertThisInitialized(r),t.scrollTrigger),r}_inheritsLoose(Timeline,i);var e=Timeline.prototype;return e.to=function to(t,e,r){return Wa(0,arguments,this),this},e.from=function from(t,e,r){return Wa(1,arguments,this),this},e.fromTo=function fromTo(t,e,r,i){return Wa(2,arguments,this),this},e.set=function set(t,e,r){return e.duration=0,e.parent=this,wa(e).repeatDelay||(e.repeat=0),e.immediateRender=!!e.immediateRender,new Jt(t,e,xt(this,r),1),this},e.call=function call(t,e,r){return La(this,Jt.delayedCall(0,t,e),r)},e.staggerTo=function staggerTo(t,e,r,i,n,a,s){return r.duration=e,r.stagger=r.stagger||i,r.onComplete=a,r.onCompleteParams=s,r.parent=this,new Jt(t,r,xt(this,n)),this},e.staggerFrom=function staggerFrom(t,e,r,i,n,a,s){return r.runBackwards=1,wa(r).immediateRender=w(r.immediateRender),this.staggerTo(t,e,r,i,n,a,s)},e.staggerFromTo=function staggerFromTo(t,e,r,i,n,a,s,o){return i.startAt=r,wa(i).immediateRender=w(i.immediateRender),this.staggerTo(t,e,i,n,a,s,o)},e.render=function render(t,e,r){var i,n,a,s,o,u,h,l,f,d,c,p,_=this._time,m=this._dirty?this.totalDuration():this._tDur,g=this._dur,v=t<=0?0:ja(t),y=this._zTime<0!=t<0&&(this._initted||!g);if(this!==I&&m<v&&0<=t&&(v=m),v!==this._tTime||r||y){if(_!==this._time&&g&&(v+=this._time-_,t+=this._time-_),i=v,f=this._start,u=!(l=this._ts),y&&(g||(_=this._zTime),!t&&e||(this._zTime=t)),this._repeat){if(c=this._yoyo,o=g+this._rDelay,this._repeat<-1&&t<0)return this.totalTime(100*o+t,e,r);if(i=ja(v%o),v===m?(s=this._repeat,i=g):((s=~~(d=ja(v/o)))&&s===d&&(i=g,s--),g<i&&(i=g)),d=Tt(this._tTime,o),!_&&this._tTime&&d!==s&&this._tTime-d*o-this._dur<=0&&(d=s),c&&1&s&&(i=g-i,p=1),s!==d&&!this._lock){var T=c&&1&d,b=T===(c&&1&s);if(s<d&&(T=!T),_=T?0:v%g?g:v,this._lock=1,this.render(_||(p?0:ja(s*o)),e,!g)._lock=0,this._tTime=v,!e&&this.parent&&Pt(this,"onRepeat"),this.vars.repeatRefresh&&!p&&(this.invalidate()._lock=1),_&&_!==this._time||u!=!this._ts||this.vars.onRepeat&&!this.parent&&!this._act)return this;if(g=this._dur,m=this._tDur,b&&(this._lock=2,_=T?g:-1e-4,this.render(_,!0),this.vars.repeatRefresh&&!p&&this.invalidate()),this._lock=0,!this._ts&&!u)return this;Rb(this,p)}}if(this._hasPause&&!this._forcing&&this._lock<2&&(h=function _findNextPauseTween(t,e,r){var i;if(e<r)for(i=t._first;i&&i._start<=r;){if("isPause"===i.data&&i._start>e)return i;i=i._next}else for(i=t._last;i&&i._start>=r;){if("isPause"===i.data&&i._start<e)return i;i=i._prev}}(this,ja(_),ja(i)))&&(v-=i-(i=h._start)),this._tTime=v,this._time=i,this._act=!l,this._initted||(this._onUpdate=this.vars.onUpdate,this._initted=1,this._zTime=t,_=0),!_&&v&&!e&&!d&&(Pt(this,"onStart"),this._tTime!==v))return this;if(_<=i&&0<=t)for(n=this._first;n;){if(a=n._next,(n._act||i>=n._start)&&n._ts&&h!==n){if(n.parent!==this)return this.render(t,e,r);if(n.render(0<n._ts?(i-n._start)*n._ts:(n._dirty?n.totalDuration():n._tDur)+(i-n._start)*n._ts,e,r),i!==this._time||!this._ts&&!u){h=0,a&&(v+=this._zTime=-U);break}}n=a}else{n=this._last;for(var w=t<0?t:i;n;){if(a=n._prev,(n._act||w<=n._end)&&n._ts&&h!==n){if(n.parent!==this)return this.render(t,e,r);if(n.render(0<n._ts?(w-n._start)*n._ts:(n._dirty?n.totalDuration():n._tDur)+(w-n._start)*n._ts,e,r||L&&na(n)),i!==this._time||!this._ts&&!u){h=0,a&&(v+=this._zTime=w?-U:U);break}}n=a}}if(h&&!e&&(this.pause(),h.render(_<=i?0:-U)._zTime=_<=i?1:-1,this._ts))return this._start=f,Ia(this),this.render(t,e,r);this._onUpdate&&!e&&Pt(this,"onUpdate",!0),(v===m&&this._tTime>=this.totalDuration()||!v&&_)&&(f!==this._start&&Math.abs(l)===Math.abs(this._ts)||this._lock||(!t&&g||!(v===m&&0<this._ts||!v&&this._ts<0)||Aa(this,1),e||t<0&&!_||!v&&!_&&m||(Pt(this,v===m&&0<=t?"onComplete":"onReverseComplete",!0),!this._prom||v<m&&0<this.timeScale()||this._prom())))}return this},e.add=function add(e,i){var n=this;if(t(i)||(i=xt(this,i,e)),!(e instanceof Nt)){if($(e))return e.forEach(function(t){return n.add(t,i)}),this;if(r(e))return this.addLabel(e,i);if(!s(e))return this;e=Jt.delayedCall(0,e)}return this!==e?La(this,e,i):this},e.getChildren=function getChildren(t,e,r,i){void 0===t&&(t=!0),void 0===e&&(e=!0),void 0===r&&(r=!0),void 0===i&&(i=-N);for(var n=[],a=this._first;a;)a._start>=i&&(a instanceof Jt?e&&n.push(a):(r&&n.push(a),t&&n.push.apply(n,a.getChildren(!0,e,r)))),a=a._next;return n},e.getById=function getById(t){for(var e=this.getChildren(1,1,1),r=e.length;r--;)if(e[r].vars.id===t)return e[r]},e.remove=function remove(t){return r(t)?this.removeLabel(t):s(t)?this.killTweensOf(t):(t.parent===this&&za(this,t),t===this._recent&&(this._recent=this._last),Ba(this))},e.totalTime=function totalTime(t,e){return arguments.length?(this._forcing=1,!this._dp&&this._ts&&(this._start=ja(Rt.time-(0<this._ts?t/this._ts:(this.totalDuration()-t)/-this._ts))),i.prototype.totalTime.call(this,t,e),this._forcing=0,this):this._tTime},e.addLabel=function addLabel(t,e){return this.labels[t]=xt(this,e),this},e.removeLabel=function removeLabel(t){return delete this.labels[t],this},e.addPause=function addPause(t,e,r){var i=Jt.delayedCall(0,e||T,r);return i.data="isPause",this._hasPause=1,La(this,i,xt(this,t))},e.removePause=function removePause(t){var e=this._first;for(t=xt(this,t);e;)e._start===t&&"isPause"===e.data&&Aa(e),e=e._next},e.killTweensOf=function killTweensOf(t,e,r){for(var i=this.getTweensOf(t,r),n=i.length;n--;)Ut!==i[n]&&i[n].kill(t,e);return this},e.getTweensOf=function getTweensOf(e,r){for(var i,n=[],a=Ot(e),s=this._first,o=t(r);s;)s instanceof Jt?la(s._targets,a)&&(o?(!Ut||s._initted&&s._ts)&&s.globalTime(0)<=r&&s.globalTime(s.totalDuration())>r:!r||s.isActive())&&n.push(s):(i=s.getTweensOf(a,r)).length&&n.push.apply(n,i),s=s._next;return n},e.tweenTo=function tweenTo(t,e){e=e||{};var r,i=this,n=xt(i,t),a=e.startAt,s=e.onStart,o=e.onStartParams,u=e.immediateRender,h=Jt.to(i,ra({ease:e.ease||"none",lazy:!1,immediateRender:!1,time:n,overwrite:"auto",duration:e.duration||Math.abs((n-(a&&"time"in a?a.time:i._time))/i.timeScale())||U,onStart:function onStart(){if(i.pause(),!r){var t=e.duration||Math.abs((n-(a&&"time"in a?a.time:i._time))/i.timeScale());h._dur!==t&&Sa(h,t,0,1).render(h._time,!0,!0),r=1}s&&s.apply(h,o||[])}},e));return u?h.render(0):h},e.tweenFromTo=function tweenFromTo(t,e,r){return this.tweenTo(e,ra({startAt:{time:xt(this,t)}},r))},e.recent=function recent(){return this._recent},e.nextLabel=function nextLabel(t){return void 0===t&&(t=this._time),sb(this,xt(this,t))},e.previousLabel=function previousLabel(t){return void 0===t&&(t=this._time),sb(this,xt(this,t),1)},e.currentLabel=function currentLabel(t){return arguments.length?this.seek(t,!0):this.previousLabel(this._time+U)},e.shiftChildren=function shiftChildren(t,e,r){void 0===r&&(r=0);for(var i,n=this._first,a=this.labels;n;)n._start>=r&&(n._start+=t,n._end+=t),n=n._next;if(e)for(i in a)a[i]>=r&&(a[i]+=t);return Ba(this)},e.invalidate=function invalidate(t){var e=this._first;for(this._lock=0;e;)e.invalidate(t),e=e._next;return i.prototype.invalidate.call(this,t)},e.clear=function clear(t){void 0===t&&(t=!0);for(var e,r=this._first;r;)e=r._next,this.remove(r),r=e;return this._dp&&(this._time=this._tTime=this._pTime=0),t&&(this.labels={}),Ba(this)},e.totalDuration=function totalDuration(t){var e,r,i,n=0,a=this,s=a._last,o=N;if(arguments.length)return a.timeScale((a._repeat<0?a.duration():a.totalDuration())/(a.reversed()?-t:t));if(a._dirty){for(i=a.parent;s;)e=s._prev,s._dirty&&s.totalDuration(),o<(r=s._start)&&a._sort&&s._ts&&!a._lock?(a._lock=1,La(a,s,r-s._delay,1)._lock=0):o=r,r<0&&s._ts&&(n-=r,(!i&&!a._dp||i&&i.smoothChildTiming)&&(a._start+=r/a._ts,a._time-=r,a._tTime-=r),a.shiftChildren(-r,!1,-Infinity),o=0),s._end>n&&s._ts&&(n=s._end),s=e;Sa(a,a===I&&a._time>n?a._time:n,1,1),a._dirty=0}return a._tDur},Timeline.updateRoot=function updateRoot(t){if(I._ts&&(oa(I,Ha(t,I)),f=Rt.frame),Rt.frame>=mt){mt+=X.autoSleep||120;var e=I._first;if((!e||!e._ts)&&X.autoSleep&&Rt._listeners.length<2){for(;e&&!e._ts;)e=e._next;e||Rt.sleep()}}},Timeline}(Nt);ra(Qt.prototype,{_lock:0,_hasPause:0,_forcing:0});function bc(t,e,i,n,a,o){var u,h,l,f;if(pt[t]&&!1!==(u=new pt[t]).init(a,u.rawVars?e[t]:function _processVars(t,e,i,n,a){if(s(t)&&(t=Gt(t,a,e,i,n)),!v(t)||t.style&&t.nodeType||$(t)||J(t))return r(t)?Gt(t,a,e,i,n):t;var o,u={};for(o in t)u[o]=Gt(t[o],a,e,i,n);return u}(e[t],n,a,o,i),i,n,o)&&(i._pt=h=new ge(i._pt,a,t,0,1,u.render,u,0,u.priority),i!==d))for(l=i._ptLookup[i._targets.indexOf(a)],f=u._props.length;f--;)l[u._props[f]]=h;return u}function hc(t,r,e,i){var n,a,s=r.ease||i||"power1.inOut";if($(r))a=e[t]||(e[t]=[]),r.forEach(function(t,e){return a.push({t:e/(r.length-1)*100,v:t,e:s})});else for(n in r)a=e[n]||(e[n]=[]),"ease"===n||a.push({t:parseFloat(t),v:r[n],e:s})}var Ut,qt,Vt=function _addPropTween(t,e,i,n,a,o,u,h,l,f){s(n)&&(n=n(a||0,t,o));var d,c=t[e],p="get"!==i?i:s(c)?l?t[e.indexOf("set")||!s(t["get"+e.substr(3)])?e:"get"+e.substr(3)](l):t[e]():c,_=s(c)?l?re:te:$t;if(r(n)&&(~n.indexOf("random(")&&(n=pb(n)),"="===n.charAt(1)&&(!(d=ka(p,n)+(Za(p)||0))&&0!==d||(n=d))),!f||p!==n||qt)return isNaN(p*n)||""===n?(c||e in t||Q(e,n),function _addComplexStringPropTween(t,e,r,i,n,a,s){var o,u,h,l,f,d,c,p,_=new ge(this._pt,t,e,0,1,oe,null,n),m=0,g=0;for(_.b=r,_.e=i,r+="",(c=~(i+="").indexOf("random("))&&(i=pb(i)),a&&(a(p=[r,i],t,e),r=p[0],i=p[1]),u=r.match(it)||[];o=it.exec(i);)l=o[0],f=i.substring(m,o.index),h?h=(h+1)%5:"rgba("===f.substr(-5)&&(h=1),l!==u[g++]&&(d=parseFloat(u[g-1])||0,_._pt={_next:_._pt,p:f||1===g?f:",",s:d,c:"="===l.charAt(1)?ka(d,l)-d:parseFloat(l)-d,m:h&&h<4?Math.round:0},m=it.lastIndex);return _.c=m<i.length?i.substring(m,i.length):"",_.fp=s,(nt.test(i)||c)&&(_.e=0),this._pt=_}.call(this,t,e,p,n,_,h||X.stringFilter,l)):(d=new ge(this._pt,t,e,+p||0,n-(p||0),"boolean"==typeof c?se:ne,0,_),l&&(d.fp=l),u&&d.modifier(u,this,t),this._pt=d)},Wt=function _initTween(t,e,r){var i,n,a,s,o,u,h,l,f,d,c,p,_,m=t.vars,g=m.ease,v=m.startAt,y=m.immediateRender,T=m.lazy,b=m.onUpdate,x=m.runBackwards,M=m.yoyoEase,k=m.keyframes,O=m.autoRevert,A=t._dur,P=t._startAt,C=t._targets,S=t.parent,D=S&&"nested"===S.data?S.vars.targets:C,z="auto"===t._overwrite&&!F,E=t.timeline;if(!E||k&&g||(g="none"),t._ease=Yt(g,Z.ease),t._yEase=M?jt(Yt(!0===M?g:M,Z.ease)):0,M&&t._yoyo&&!t._repeat&&(M=t._yEase,t._yEase=t._ease,t._ease=M),t._from=!E&&!!m.runBackwards,!E||k&&!m.stagger){if(p=(l=C[0]?fa(C[0]).harness:0)&&m[l.prop],i=va(m,ft),P&&(P._zTime<0&&P.progress(1),e<0&&x&&y&&!O?P.render(-1,!0):P.revert(x&&A?ht:ut),P._lazy=0),v){if(Aa(t._startAt=Jt.set(C,ra({data:"isStart",overwrite:!1,parent:S,immediateRender:!0,lazy:!P&&w(T),startAt:null,delay:0,onUpdate:b&&function(){return Pt(t,"onUpdate")},stagger:0},v))),t._startAt._dp=0,t._startAt._sat=t,e<0&&(L||!y&&!O)&&t._startAt.revert(ht),y&&A&&e<=0&&r<=0)return void(e&&(t._zTime=e))}else if(x&&A&&!P)if(e&&(y=!1),a=ra({overwrite:!1,data:"isFromStart",lazy:y&&!P&&w(T),immediateRender:y,stagger:0,parent:S},i),p&&(a[l.prop]=p),Aa(t._startAt=Jt.set(C,a)),t._startAt._dp=0,t._startAt._sat=t,e<0&&(L?t._startAt.revert(ht):t._startAt.render(-1,!0)),t._zTime=e,y){if(!e)return}else _initTween(t._startAt,U,U);for(t._pt=t._ptCache=0,T=A&&w(T)||T&&!A,n=0;n<C.length;n++){if(h=(o=C[n])._gsap||ea(C)[n]._gsap,t._ptLookup[n]=d={},ct[h.id]&&dt.length&&ma(),c=D===C?n:D.indexOf(o),l&&!1!==(f=new l).init(o,p||i,t,c,D)&&(t._pt=s=new ge(t._pt,o,f.name,0,1,f.render,f,0,f.priority),f._props.forEach(function(t){d[t]=s}),f.priority&&(u=1)),!l||p)for(a in i)pt[a]&&(f=bc(a,i,t,c,o,D))?f.priority&&(u=1):d[a]=s=Vt.call(t,o,a,"get",i[a],c,D,0,m.stringFilter);t._op&&t._op[n]&&t.kill(o,t._op[n]),z&&t._pt&&(Ut=t,I.killTweensOf(o,d,t.globalTime(e)),_=!t.parent,Ut=0),t._pt&&T&&(ct[h.id]=1)}u&&_e(t),t._onInit&&t._onInit(t)}t._onUpdate=b,t._initted=(!t._op||t._pt)&&!_,k&&e<=0&&E.render(N,!0,!0)},Gt=function _parseFuncOrString(t,e,i,n,a){return s(t)?t.call(e,i,n,a):r(t)&&~t.indexOf("random(")?pb(t):t},Ht=vt+"repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert",Kt={};ha(Ht+",id,stagger,delay,duration,paused,scrollTrigger",function(t){return Kt[t]=1});var Jt=function(E){function Tween(e,r,i,n){var a;"number"==typeof r&&(i.duration=r,r=i,i=null);var s,o,u,h,l,f,d,c,p=(a=E.call(this,n?r:wa(r))||this).vars,_=p.duration,m=p.delay,g=p.immediateRender,T=p.stagger,b=p.overwrite,x=p.keyframes,M=p.defaults,k=p.scrollTrigger,O=p.yoyoEase,A=r.parent||I,P=($(e)||J(e)?t(e[0]):"length"in r)?[e]:Ot(e);if(a._targets=P.length?ea(P):R("GSAP target "+e+" not found. https://gsap.com",!X.nullTargetWarn)||[],a._ptLookup=[],a._overwrite=b,x||T||y(_)||y(m)){if(r=a.vars,(s=a.timeline=new Qt({data:"nested",defaults:M||{},targets:A&&"nested"===A.data?A.vars.targets:P})).kill(),s.parent=s._dp=_assertThisInitialized(a),s._start=0,T||y(_)||y(m)){if(h=P.length,d=T&&fb(T),v(T))for(l in T)~Ht.indexOf(l)&&((c=c||{})[l]=T[l]);for(o=0;o<h;o++)(u=va(r,Kt)).stagger=0,O&&(u.yoyoEase=O),c&&yt(u,c),f=P[o],u.duration=+Gt(_,_assertThisInitialized(a),o,f,P),u.delay=(+Gt(m,_assertThisInitialized(a),o,f,P)||0)-a._delay,!T&&1===h&&u.delay&&(a._delay=m=u.delay,a._start+=m,u.delay=0),s.to(f,u,d?d(o,f,P):0),s._ease=Lt.none;s.duration()?_=m=0:a.timeline=0}else if(x){wa(ra(s.vars.defaults,{ease:"none"})),s._ease=Yt(x.ease||r.ease||"none");var C,S,D,z=0;if($(x))x.forEach(function(t){return s.to(P,t,">")}),s.duration();else{for(l in u={},x)"ease"===l||"easeEach"===l||hc(l,x[l],u,x.easeEach);for(l in u)for(C=u[l].sort(function(t,e){return t.t-e.t}),o=z=0;o<C.length;o++)(D={ease:(S=C[o]).e,duration:(S.t-(o?C[o-1].t:0))/100*_})[l]=S.v,s.to(P,D,z),z+=D.duration;s.duration()<_&&s.to({},{duration:_-s.duration()})}}_||a.duration(_=s.duration())}else a.timeline=0;return!0!==b||F||(Ut=_assertThisInitialized(a),I.killTweensOf(P),Ut=0),La(A,_assertThisInitialized(a),i),r.reversed&&a.reverse(),r.paused&&a.paused(!0),(g||!_&&!x&&a._start===ja(A._time)&&w(g)&&function _hasNoPausedAncestors(t){return!t||t._ts&&_hasNoPausedAncestors(t.parent)}(_assertThisInitialized(a))&&"nested"!==A.data)&&(a._tTime=-U,a.render(Math.max(0,-m)||0)),k&&Ma(_assertThisInitialized(a),k),a}_inheritsLoose(Tween,E);var e=Tween.prototype;return e.render=function render(t,e,r){var i,n,a,s,o,u,h,l,f,d=this._time,c=this._tDur,p=this._dur,_=t<0,m=c-U<t&&!_?c:t<U?0:t;if(p){if(m!==this._tTime||!t||r||!this._initted&&this._tTime||this._startAt&&this._zTime<0!=_||this._lazy){if(i=m,l=this.timeline,this._repeat){if(s=p+this._rDelay,this._repeat<-1&&_)return this.totalTime(100*s+t,e,r);if(i=ja(m%s),m===c?(a=this._repeat,i=p):(a=~~(o=ja(m/s)))&&a===o?(i=p,a--):p<i&&(i=p),(u=this._yoyo&&1&a)&&(f=this._yEase,i=p-i),o=Tt(this._tTime,s),i===d&&!r&&this._initted&&a===o)return this._tTime=m,this;a!==o&&(l&&this._yEase&&Rb(l,u),this.vars.repeatRefresh&&!u&&!this._lock&&i!==s&&this._initted&&(this._lock=r=1,this.render(ja(s*a),!0).invalidate()._lock=0))}if(!this._initted){if(Na(this,_?t:i,r,e,m))return this._tTime=0,this;if(!(d===this._time||r&&this.vars.repeatRefresh&&a!==o))return this;if(p!==this._dur)return this.render(t,e,r)}if(this._tTime=m,this._time=i,!this._act&&this._ts&&(this._act=1,this._lazy=0),this.ratio=h=(f||this._ease)(i/p),this._from&&(this.ratio=h=1-h),!d&&m&&!e&&!o&&(Pt(this,"onStart"),this._tTime!==m))return this;for(n=this._pt;n;)n.r(h,n.d),n=n._next;l&&l.render(t<0?t:l._dur*l._ease(i/this._dur),e,r)||this._startAt&&(this._zTime=t),this._onUpdate&&!e&&(_&&Da(this,t,0,r),Pt(this,"onUpdate")),this._repeat&&a!==o&&this.vars.onRepeat&&!e&&this.parent&&Pt(this,"onRepeat"),m!==this._tDur&&m||this._tTime!==m||(_&&!this._onUpdate&&Da(this,t,0,!0),!t&&p||!(m===this._tDur&&0<this._ts||!m&&this._ts<0)||Aa(this,1),e||_&&!d||!(m||d||u)||(Pt(this,m===c?"onComplete":"onReverseComplete",!0),!this._prom||m<c&&0<this.timeScale()||this._prom()))}}else!function _renderZeroDurationTween(t,e,r,i){var n,a,s,o=t.ratio,u=e<0||!e&&(!t._start&&function _parentPlayheadIsBeforeStart(t){var e=t.parent;return e&&e._ts&&e._initted&&!e._lock&&(e.rawTime()<0||_parentPlayheadIsBeforeStart(e))}(t)&&(t._initted||!bt(t))||(t._ts<0||t._dp._ts<0)&&!bt(t))?0:1,h=t._rDelay,l=0;if(h&&t._repeat&&(l=Mt(0,t._tDur,e),a=Tt(l,h),t._yoyo&&1&a&&(u=1-u),a!==Tt(t._tTime,h)&&(o=1-u,t.vars.repeatRefresh&&t._initted&&t.invalidate())),u!==o||L||i||t._zTime===U||!e&&t._zTime){if(!t._initted&&Na(t,e,i,r,l))return;for(s=t._zTime,t._zTime=e||(r?U:0),r=r||e&&!s,t.ratio=u,t._from&&(u=1-u),t._time=0,t._tTime=l,n=t._pt;n;)n.r(u,n.d),n=n._next;e<0&&Da(t,e,0,!0),t._onUpdate&&!r&&Pt(t,"onUpdate"),l&&t._repeat&&!r&&t.parent&&Pt(t,"onRepeat"),(e>=t._tDur||e<0)&&t.ratio===u&&(u&&Aa(t,1),r||L||(Pt(t,u?"onComplete":"onReverseComplete",!0),t._prom&&t._prom()))}else t._zTime||(t._zTime=e)}(this,t,e,r);return this},e.targets=function targets(){return this._targets},e.invalidate=function invalidate(t){return t&&this.vars.runBackwards||(this._startAt=0),this._pt=this._op=this._onUpdate=this._lazy=this.ratio=0,this._ptLookup=[],this.timeline&&this.timeline.invalidate(t),E.prototype.invalidate.call(this,t)},e.resetTo=function resetTo(t,e,r,i,n){c||Rt.wake(),this._ts||this.play();var a,s=Math.min(this._dur,(this._dp._time-this._start)*this._ts);return this._initted||Wt(this,s),a=this._ease(s/this._dur),function _updatePropTweens(t,e,r,i,n,a,s,o){var u,h,l,f,d=(t._pt&&t._ptCache||(t._ptCache={}))[e];if(!d)for(d=t._ptCache[e]=[],l=t._ptLookup,f=t._targets.length;f--;){if((u=l[f][e])&&u.d&&u.d._pt)for(u=u.d._pt;u&&u.p!==e&&u.fp!==e;)u=u._next;if(!u)return qt=1,t.vars[e]="+=0",Wt(t,s),qt=0,o?R(e+" not eligible for reset"):1;d.push(u)}for(f=d.length;f--;)(u=(h=d[f])._pt||h).s=!i&&0!==i||n?u.s+(i||0)+a*u.c:i,u.c=r-u.s,h.e&&(h.e=ia(r)+Za(h.e)),h.b&&(h.b=u.s+Za(h.b))}(this,t,e,r,i,a,s,n)?this.resetTo(t,e,r,i,1):(Ja(this,0),this.parent||ya(this._dp,this,"_first","_last",this._dp._sort?"_start":0),this.render(0))},e.kill=function kill(t,e){if(void 0===e&&(e="all"),!(t||e&&"all"!==e))return this._lazy=this._pt=0,this.parent?ub(this):this.scrollTrigger&&this.scrollTrigger.kill(!!L),this;if(this.timeline){var i=this.timeline.totalDuration();return this.timeline.killTweensOf(t,e,Ut&&!0!==Ut.vars.overwrite)._first||ub(this),this.parent&&i!==this.timeline.totalDuration()&&Sa(this,this._dur*this.timeline._tDur/i,0,1),this}var n,a,s,o,u,h,l,f=this._targets,d=t?Ot(t):f,c=this._ptLookup,p=this._pt;if((!e||"all"===e)&&function _arraysMatch(t,e){for(var r=t.length,i=r===e.length;i&&r--&&t[r]===e[r];);return r<0}(f,d))return"all"===e&&(this._pt=0),ub(this);for(n=this._op=this._op||[],"all"!==e&&(r(e)&&(u={},ha(e,function(t){return u[t]=1}),e=u),e=function _addAliasesToVars(t,e){var r,i,n,a,s=t[0]?fa(t[0]).harness:0,o=s&&s.aliases;if(!o)return e;for(i in r=yt({},e),o)if(i in r)for(n=(a=o[i].split(",")).length;n--;)r[a[n]]=r[i];return r}(f,e)),l=f.length;l--;)if(~d.indexOf(f[l]))for(u in a=c[l],"all"===e?(n[l]=e,o=a,s={}):(s=n[l]=n[l]||{},o=e),o)(h=a&&a[u])&&("kill"in h.d&&!0!==h.d.kill(u)||za(this,h,"_pt"),delete a[u]),"all"!==s&&(s[u]=1);return this._initted&&!this._pt&&p&&ub(this),this},Tween.to=function to(t,e,r){return new Tween(t,e,r)},Tween.from=function from(t,e){return Wa(1,arguments)},Tween.delayedCall=function delayedCall(t,e,r,i){return new Tween(e,0,{immediateRender:!1,lazy:!1,overwrite:!1,delay:t,onComplete:e,onReverseComplete:e,onCompleteParams:r,onReverseCompleteParams:r,callbackScope:i})},Tween.fromTo=function fromTo(t,e,r){return Wa(2,arguments)},Tween.set=function set(t,e){return e.duration=0,e.repeatDelay||(e.repeat=0),new Tween(t,e)},Tween.killTweensOf=function killTweensOf(t,e,r){return I.killTweensOf(t,e,r)},Tween}(Nt);ra(Jt.prototype,{_targets:[],_lazy:0,_startAt:0,_op:0,_onInit:0}),ha("staggerTo,staggerFrom,staggerFromTo",function(r){Jt[r]=function(){var t=new Qt,e=kt.call(arguments,0);return e.splice("staggerFromTo"===r?5:4,0,0),t[r].apply(t,e)}});function pc(t,e,r){return t.setAttribute(e,r)}function xc(t,e,r,i){i.mSet(t,e,i.m.call(i.tween,r,i.mt),i)}var $t=function _setterPlain(t,e,r){return t[e]=r},te=function _setterFunc(t,e,r){return t[e](r)},re=function _setterFuncWithParam(t,e,r,i){return t[e](i.fp,r)},ie=function _getSetter(t,e){return s(t[e])?te:u(t[e])&&t.setAttribute?pc:$t},ne=function _renderPlain(t,e){return e.set(e.t,e.p,Math.round(1e6*(e.s+e.c*t))/1e6,e)},se=function _renderBoolean(t,e){return e.set(e.t,e.p,!!(e.s+e.c*t),e)},oe=function _renderComplexString(t,e){var r=e._pt,i="";if(!t&&e.b)i=e.b;else if(1===t&&e.e)i=e.e;else{for(;r;)i=r.p+(r.m?r.m(r.s+r.c*t):Math.round(1e4*(r.s+r.c*t))/1e4)+i,r=r._next;i+=e.c}e.set(e.t,e.p,i,e)},ue=function _renderPropTweens(t,e){for(var r=e._pt;r;)r.r(t,r.d),r=r._next},he=function _addPluginModifier(t,e,r,i){for(var n,a=this._pt;a;)n=a._next,a.p===i&&a.modifier(t,e,r),a=n},de=function _killPropTweensOf(t){for(var e,r,i=this._pt;i;)r=i._next,i.p===t&&!i.op||i.op===t?za(this,i,"_pt"):i.dep||(e=1),i=r;return!e},_e=function _sortPropTweensByPriority(t){for(var e,r,i,n,a=t._pt;a;){for(e=a._next,r=i;r&&r.pr>a.pr;)r=r._next;(a._prev=r?r._prev:n)?a._prev._next=a:i=a,(a._next=r)?r._prev=a:n=a,a=e}t._pt=i},ge=(PropTween.prototype.modifier=function modifier(t,e,r){this.mSet=this.mSet||this.set,this.set=xc,this.m=t,this.mt=r,this.tween=e},PropTween);function PropTween(t,e,r,i,n,a,s,o,u){this.t=e,this.s=i,this.c=n,this.p=r,this.r=a||ne,this.d=s||this,this.set=o||$t,this.pr=u||0,(this._next=t)&&(t._prev=this)}ha(vt+"parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger",function(t){return ft[t]=1}),ot.TweenMax=ot.TweenLite=Jt,ot.TimelineLite=ot.TimelineMax=Qt,I=new Qt({sortChildren:!1,defaults:Z,autoRemoveChildren:!0,id:"root",smoothChildTiming:!0}),X.stringFilter=Gb;function Fc(t){return(be[t]||Me).map(function(t){return t()})}function Gc(){var t=Date.now(),o=[];2<t-Oe&&(Fc("matchMediaInit"),Te.forEach(function(t){var e,r,i,n,a=t.queries,s=t.conditions;for(r in a)(e=h.matchMedia(a[r]).matches)&&(i=1),e!==s[r]&&(s[r]=e,n=1);n&&(t.revert(),i&&o.push(t))}),Fc("matchMediaRevert"),o.forEach(function(e){return e.onMatch(e,function(t){return e.add(null,t)})}),Oe=t,Fc("matchMedia"))}var ve,Te=[],be={},Me=[],Oe=0,Ae=0,Pe=((ve=Context.prototype).add=function add(t,i,n){function Iw(){var t,e=l,r=a.selector;return e&&e!==a&&e.data.push(a),n&&(a.selector=db(n)),l=a,t=i.apply(a,arguments),s(t)&&a._r.push(t),l=e,a.selector=r,a.isReverted=!1,t}s(t)&&(n=i,i=t,t=s);var a=this;return a.last=Iw,t===s?Iw(a,function(t){return a.add(null,t)}):t?a[t]=Iw:Iw},ve.ignore=function ignore(t){var e=l;l=null,t(this),l=e},ve.getTweens=function getTweens(){var e=[];return this.data.forEach(function(t){return t instanceof Context?e.push.apply(e,t.getTweens()):t instanceof Jt&&!(t.parent&&"nested"===t.parent.data)&&e.push(t)}),e},ve.clear=function clear(){this._r.length=this.data.length=0},ve.kill=function kill(i,t){var n=this;if(i?function(){for(var t,e=n.getTweens(),r=n.data.length;r--;)"isFlip"===(t=n.data[r]).data&&(t.revert(),t.getChildren(!0,!0,!1).forEach(function(t){return e.splice(e.indexOf(t),1)}));for(e.map(function(t){return{g:t._dur||t._delay||t._sat&&!t._sat.vars.immediateRender?t.globalTime(0):-1/0,t:t}}).sort(function(t,e){return e.g-t.g||-1/0}).forEach(function(t){return t.t.revert(i)}),r=n.data.length;r--;)(t=n.data[r])instanceof Qt?"nested"!==t.data&&(t.scrollTrigger&&t.scrollTrigger.revert(),t.kill()):t instanceof Jt||!t.revert||t.revert(i);n._r.forEach(function(t){return t(i,n)}),n.isReverted=!0}():this.data.forEach(function(t){return t.kill&&t.kill()}),this.clear(),t)for(var e=Te.length;e--;)Te[e].id===this.id&&Te.splice(e,1)},ve.revert=function revert(t){this.kill(t||{})},Context);function Context(t,e){this.selector=e&&db(e),this.data=[],this._r=[],this.isReverted=!1,this.id=Ae++,t&&this.add(t)}var Ce,Se=((Ce=MatchMedia.prototype).add=function add(t,e,r){v(t)||(t={matches:t});var i,n,a,s=new Pe(0,r||this.scope),o=s.conditions={};for(n in l&&!s.selector&&(s.selector=l.selector),this.contexts.push(s),e=s.add("onMatch",e),s.queries=t)"all"===n?a=1:(i=h.matchMedia(t[n]))&&(Te.indexOf(s)<0&&Te.push(s),(o[n]=i.matches)&&(a=1),i.addListener?i.addListener(Gc):i.addEventListener("change",Gc));return a&&e(s,function(t){return s.add(null,t)}),this},Ce.revert=function revert(t){this.kill(t||{})},Ce.kill=function kill(e){this.contexts.forEach(function(t){return t.kill(e,!0)})},MatchMedia);function MatchMedia(t){this.contexts=[],this.scope=t,l&&l.data.push(this)}var De={registerPlugin:function registerPlugin(){for(var t=arguments.length,e=new Array(t),r=0;r<t;r++)e[r]=arguments[r];e.forEach(function(t){return xb(t)})},timeline:function timeline(t){return new Qt(t)},getTweensOf:function getTweensOf(t,e){return I.getTweensOf(t,e)},getProperty:function getProperty(i,t,e,n){r(i)&&(i=Ot(i)[0]);var a=fa(i||{}).get,s=e?qa:pa;return"native"===e&&(e=""),i?t?s((pt[t]&&pt[t].get||a)(i,t,e,n)):function(t,e,r){return s((pt[t]&&pt[t].get||a)(i,t,e,r))}:i},quickSetter:function quickSetter(r,e,i){if(1<(r=Ot(r)).length){var n=r.map(function(t){return ze.quickSetter(t,e,i)}),a=n.length;return function(t){for(var e=a;e--;)n[e](t)}}r=r[0]||{};var s=pt[e],o=fa(r),u=o.harness&&(o.harness.aliases||{})[e]||e,h=s?function(t){var e=new s;d._pt=0,e.init(r,i?t+i:t,d,0,[r]),e.render(1,e),d._pt&&ue(1,d)}:o.set(r,u);return s?h:function(t){return h(r,u,i?t+i:t,o,1)}},quickTo:function quickTo(t,i,e){function ay(t,e,r){return n.resetTo(i,t,e,r)}var r,n=ze.to(t,ra(((r={})[i]="+=0.1",r.paused=!0,r.stagger=0,r),e||{}));return ay.tween=n,ay},isTweening:function isTweening(t){return 0<I.getTweensOf(t,!0).length},defaults:function defaults(t){return t&&t.ease&&(t.ease=Yt(t.ease,Z.ease)),ua(Z,t||{})},config:function config(t){return ua(X,t||{})},registerEffect:function registerEffect(t){var i=t.name,n=t.effect,e=t.plugins,a=t.defaults,r=t.extendTimeline;(e||"").split(",").forEach(function(t){return t&&!pt[t]&&!ot[t]&&R(i+" effect requires "+t+" plugin.")}),_t[i]=function(t,e,r){return n(Ot(t),ra(e||{},a),r)},r&&(Qt.prototype[i]=function(t,e,r){return this.add(_t[i](t,v(e)?e:(r=e)&&{},this),r)})},registerEase:function registerEase(t,e){Lt[t]=Yt(e)},parseEase:function parseEase(t,e){return arguments.length?Yt(t,e):Lt},getById:function getById(t){return I.getById(t)},exportRoot:function exportRoot(t,e){void 0===t&&(t={});var r,i,n=new Qt(t);for(n.smoothChildTiming=w(t.smoothChildTiming),I.remove(n),n._dp=0,n._time=n._tTime=I._time,r=I._first;r;)i=r._next,!e&&!r._dur&&r instanceof Jt&&r.vars.onComplete===r._targets[0]||La(n,r,r._start-r._delay),r=i;return La(I,n,0),n},context:function context(t,e){return t?new Pe(t,e):l},matchMedia:function matchMedia(t){return new Se(t)},matchMediaRefresh:function matchMediaRefresh(){return Te.forEach(function(t){var e,r,i=t.conditions;for(r in i)i[r]&&(i[r]=!1,e=1);e&&t.revert()})||Gc()},addEventListener:function addEventListener(t,e){var r=be[t]||(be[t]=[]);~r.indexOf(e)||r.push(e)},removeEventListener:function removeEventListener(t,e){var r=be[t],i=r&&r.indexOf(e);0<=i&&r.splice(i,1)},utils:{wrap:function wrap(e,t,r){var i=t-e;return $(e)?mb(e,wrap(0,e.length),t):Xa(r,function(t){return(i+(t-e)%i)%i+e})},wrapYoyo:function wrapYoyo(e,t,r){var i=t-e,n=2*i;return $(e)?mb(e,wrapYoyo(0,e.length-1),t):Xa(r,function(t){return e+(i<(t=(n+(t-e)%n)%n||0)?n-t:t)})},distribute:fb,random:ib,snap:hb,normalize:function normalize(t,e,r){return At(t,e,0,1,r)},getUnit:Za,clamp:function clamp(e,r,t){return Xa(t,function(t){return Mt(e,r,t)})},splitColor:Bb,toArray:Ot,selector:db,mapRange:At,pipe:function pipe(){for(var t=arguments.length,e=new Array(t),r=0;r<t;r++)e[r]=arguments[r];return function(t){return e.reduce(function(t,e){return e(t)},t)}},unitize:function unitize(e,r){return function(t){return e(parseFloat(t))+(r||Za(t))}},interpolate:function interpolate(e,i,t,n){var a=isNaN(e+i)?0:function(t){return(1-t)*e+t*i};if(!a){var s,o,u,h,l,f=r(e),d={};if(!0===t&&(n=1)&&(t=null),f)e={p:e},i={p:i};else if($(e)&&!$(i)){for(u=[],h=e.length,l=h-2,o=1;o<h;o++)u.push(interpolate(e[o-1],e[o]));h--,a=function func(t){t*=h;var e=Math.min(l,~~t);return u[e](t-e)},t=i}else n||(e=yt($(e)?[]:{},e));if(!u){for(s in i)Vt.call(d,e,s,"get",i[s]);a=function func(t){return ue(t,d)||(f?e.p:e)}}}return Xa(t,a)},shuffle:eb},install:P,effects:_t,ticker:Rt,updateRoot:Qt.updateRoot,plugins:pt,globalTimeline:I,core:{PropTween:ge,globals:S,Tween:Jt,Timeline:Qt,Animation:Nt,getCache:fa,_removeLinkedListItem:za,reverting:function reverting(){return L},context:function context(t){return t&&l&&(l.data.push(t),t._ctx=l),l},suppressOverwrites:function suppressOverwrites(t){return F=t}}};ha("to,from,fromTo,delayedCall,set,killTweensOf",function(t){return De[t]=Jt[t]}),Rt.add(Qt.updateRoot),d=De.to({},{duration:0});function Kc(t,e){for(var r=t._pt;r&&r.p!==e&&r.op!==e&&r.fp!==e;)r=r._next;return r}function Mc(t,a){return{name:t,headless:1,rawVars:1,init:function init(t,n,e){e._onInit=function(t){var e,i;if(r(n)&&(e={},ha(n,function(t){return e[t]=1}),n=e),a){for(i in e={},n)e[i]=a(n[i]);n=e}!function _addModifiers(t,e){var r,i,n,a=t._targets;for(r in e)for(i=a.length;i--;)(n=(n=t._ptLookup[i][r])&&n.d)&&(n._pt&&(n=Kc(n,r)),n&&n.modifier&&n.modifier(e[r],t,a[i],r))}(t,n)}}}}var ze=De.registerPlugin({name:"attr",init:function init(t,e,r,i,n){var a,s,o;for(a in this.tween=r,e)o=t.getAttribute(a)||"",(s=this.add(t,"setAttribute",(o||0)+"",e[a],i,n,0,0,a)).op=a,s.b=o,this._props.push(a)},render:function render(t,e){for(var r=e._pt;r;)L?r.set(r.t,r.p,r.b,r):r.r(t,r.d),r=r._next}},{name:"endArray",headless:1,init:function init(t,e){for(var r=e.length;r--;)this.add(t,r,t[r]||0,e[r],0,0,0,0,0,1)}},Mc("roundProps",gb),Mc("modifiers"),Mc("snap",hb))||De;Jt.version=Qt.version=ze.version="3.13.0",o=1,x()&&Ft();function wd(t,e){return e.set(e.t,e.p,Math.round(1e4*(e.s+e.c*t))/1e4+e.u,e)}function xd(t,e){return e.set(e.t,e.p,1===t?e.e:Math.round(1e4*(e.s+e.c*t))/1e4+e.u,e)}function yd(t,e){return e.set(e.t,e.p,t?Math.round(1e4*(e.s+e.c*t))/1e4+e.u:e.b,e)}function zd(t,e){var r=e.s+e.c*t;e.set(e.t,e.p,~~(r+(r<0?-.5:.5))+e.u,e)}function Ad(t,e){return e.set(e.t,e.p,t?e.e:e.b,e)}function Bd(t,e){return e.set(e.t,e.p,1!==t?e.b:e.e,e)}function Cd(t,e,r){return t.style[e]=r}function Dd(t,e,r){return t.style.setProperty(e,r)}function Ed(t,e,r){return t._gsap[e]=r}function Fd(t,e,r){return t._gsap.scaleX=t._gsap.scaleY=r}function Gd(t,e,r,i,n){var a=t._gsap;a.scaleX=a.scaleY=r,a.renderTransform(n,a)}function Hd(t,e,r,i,n){var a=t._gsap;a[e]=r,a.renderTransform(n,a)}function Kd(t,e){var r=this,i=this.target,n=i.style,a=i._gsap;if(t in sr&&n){if(this.tfm=this.tfm||{},"transform"===t)return cr.transform.split(",").forEach(function(t){return Kd.call(r,t,e)});if(~(t=cr[t]||t).indexOf(",")?t.split(",").forEach(function(t){return r.tfm[t]=Tr(i,t)}):this.tfm[t]=a.x?a[t]:Tr(i,t),t===_r&&(this.tfm.zOrigin=a.zOrigin),0<=this.props.indexOf(pr))return;a.svg&&(this.svgo=i.getAttribute("data-svg-origin"),this.props.push(_r,e,"")),t=pr}(n||e)&&this.props.push(t,e,n[t])}function Ld(t){t.translate&&(t.removeProperty("translate"),t.removeProperty("scale"),t.removeProperty("rotate"))}function Md(){var t,e,r=this.props,i=this.target,n=i.style,a=i._gsap;for(t=0;t<r.length;t+=3)r[t+1]?2===r[t+1]?i[r[t]](r[t+2]):i[r[t]]=r[t+2]:r[t+2]?n[r[t]]=r[t+2]:n.removeProperty("--"===r[t].substr(0,2)?r[t]:r[t].replace(lr,"-$1").toLowerCase());if(this.tfm){for(e in this.tfm)a[e]=this.tfm[e];a.svg&&(a.renderTransform(),i.setAttribute("data-svg-origin",this.svgo||"")),(t=Ye())&&t.isStart||n[pr]||(Ld(n),a.zOrigin&&n[_r]&&(n[_r]+=" "+a.zOrigin+"px",a.zOrigin=0,a.renderTransform()),a.uncache=1)}}function Nd(t,e){var r={target:t,props:[],revert:Md,save:Kd};return t._gsap||ze.core.getCache(t),e&&t.style&&t.nodeType&&e.split(",").forEach(function(t){return r.save(t)}),r}function Pd(t,e){var r=Re.createElementNS?Re.createElementNS((e||"http://www.w3.org/1999/xhtml").replace(/^https/,"http"),t):Re.createElement(t);return r&&r.style?r:Re.createElement(t)}function Qd(t,e,r){var i=getComputedStyle(t);return i[e]||i.getPropertyValue(e.replace(lr,"-$1").toLowerCase())||i.getPropertyValue(e)||!r&&Qd(t,gr(e)||e,1)||""}function Td(){(function _windowExists(){return"undefined"!=typeof window})()&&window.document&&(Ee=window,Re=Ee.document,Fe=Re.documentElement,Ie=Pd("div")||{style:{}},Pd("div"),pr=gr(pr),_r=pr+"Origin",Ie.style.cssText="border-width:0;line-height:0;position:absolute;padding:0",Xe=!!gr("perspective"),Ye=ze.core.reverting,Le=1)}function Ud(t){var e,r=t.ownerSVGElement,i=Pd("svg",r&&r.getAttribute("xmlns")||"http://www.w3.org/2000/svg"),n=t.cloneNode(!0);n.style.display="block",i.appendChild(n),Fe.appendChild(i);try{e=n.getBBox()}catch(t){}return i.removeChild(n),Fe.removeChild(i),e}function Vd(t,e){for(var r=e.length;r--;)if(t.hasAttribute(e[r]))return t.getAttribute(e[r])}function Wd(e){var r,i;try{r=e.getBBox()}catch(t){r=Ud(e),i=1}return r&&(r.width||r.height)||i||(r=Ud(e)),!r||r.width||r.x||r.y?r:{x:+Vd(e,["x","cx","x1"])||0,y:+Vd(e,["y","cy","y1"])||0,width:0,height:0}}function Xd(t){return!(!t.getCTM||t.parentNode&&!t.ownerSVGElement||!Wd(t))}function Yd(t,e){if(e){var r,i=t.style;e in sr&&e!==_r&&(e=pr),i.removeProperty?("ms"!==(r=e.substr(0,2))&&"webkit"!==e.substr(0,6)||(e="-"+e),i.removeProperty("--"===r?e:e.replace(lr,"-$1").toLowerCase())):i.removeAttribute(e)}}function Zd(t,e,r,i,n,a){var s=new ge(t._pt,e,r,0,1,a?Bd:Ad);return(t._pt=s).b=i,s.e=n,t._props.push(r),s}function ae(t,e,r,i){var n,a,s,o,u=parseFloat(r)||0,h=(r+"").trim().substr((u+"").length)||"px",l=Ie.style,f=fr.test(e),d="svg"===t.tagName.toLowerCase(),c=(d?"client":"offset")+(f?"Width":"Height"),p="px"===i,_="%"===i;if(i===h||!u||vr[i]||vr[h])return u;if("px"===h||p||(u=ae(t,e,r,"px")),o=t.getCTM&&Xd(t),(_||"%"===h)&&(sr[e]||~e.indexOf("adius")))return n=o?t.getBBox()[f?"width":"height"]:t[c],ia(_?u/n*100:u/100*n);if(l[f?"width":"height"]=100+(p?h:i),a="rem"!==i&&~e.indexOf("adius")||"em"===i&&t.appendChild&&!d?t:t.parentNode,o&&(a=(t.ownerSVGElement||{}).parentNode),a&&a!==Re&&a.appendChild||(a=Re.body),(s=a._gsap)&&_&&s.width&&f&&s.time===Rt.time&&!s.uncache)return ia(u/s.width*100);if(!_||"height"!==e&&"width"!==e)!_&&"%"!==h||yr[Qd(a,"display")]||(l.position=Qd(t,"position")),a===t&&(l.position="static"),a.appendChild(Ie),n=Ie[c],a.removeChild(Ie),l.position="absolute";else{var m=t.style[e];t.style[e]=100+i,n=t[c],m?t.style[e]=m:Yd(t,e)}return f&&_&&((s=fa(a)).time=Rt.time,s.width=a[c]),ia(p?n*u/100:n&&u?100/n*u:0)}function ce(t,e,r,i){if(!r||"none"===r){var n=gr(e,t,1),a=n&&Qd(t,n,1);a&&a!==r?(e=n,r=a):"borderColor"===e&&(r=Qd(t,"borderTopColor"))}var s,o,u,h,l,f,d,c,p,_,m,g=new ge(this._pt,t.style,e,0,1,oe),v=0,y=0;if(g.b=r,g.e=i,r+="","var(--"===(i+="").substring(0,6)&&(i=Qd(t,i.substring(4,i.indexOf(")")))),"auto"===i&&(f=t.style[e],t.style[e]=i,i=Qd(t,e)||i,f?t.style[e]=f:Yd(t,e)),Gb(s=[r,i]),i=s[1],u=(r=s[0]).match(rt)||[],(i.match(rt)||[]).length){for(;o=rt.exec(i);)d=o[0],p=i.substring(v,o.index),l?l=(l+1)%5:"rgba("!==p.substr(-5)&&"hsla("!==p.substr(-5)||(l=1),d!==(f=u[y++]||"")&&(h=parseFloat(f)||0,m=f.substr((h+"").length),"="===d.charAt(1)&&(d=ka(h,d)+m),c=parseFloat(d),_=d.substr((c+"").length),v=rt.lastIndex-_.length,_||(_=_||X.units[e]||m,v===i.length&&(i+=_,g.e+=_)),m!==_&&(h=ae(t,e,f,_)||0),g._pt={_next:g._pt,p:p||1===y?p:",",s:h,c:c-h,m:l&&l<4||"zIndex"===e?Math.round:0});g.c=v<i.length?i.substring(v,i.length):""}else g.r="display"===e&&"none"===i?Bd:Ad;return nt.test(i)&&(g.e=0),this._pt=g}function ee(t){var e=t.split(" "),r=e[0],i=e[1]||"50%";return"top"!==r&&"bottom"!==r&&"left"!==i&&"right"!==i||(t=r,r=i,i=t),e[0]=br[r]||r,e[1]=br[i]||i,e.join(" ")}function fe(t,e){if(e.tween&&e.tween._time===e.tween._dur){var r,i,n,a=e.t,s=a.style,o=e.u,u=a._gsap;if("all"===o||!0===o)s.cssText="",i=1;else for(n=(o=o.split(",")).length;-1<--n;)r=o[n],sr[r]&&(i=1,r="transformOrigin"===r?_r:pr),Yd(a,r);i&&(Yd(a,pr),u&&(u.svg&&a.removeAttribute("transform"),s.scale=s.rotate=s.translate="none",kr(a,1),u.uncache=1,Ld(s)))}}function je(t){return"matrix(1, 0, 0, 1, 0, 0)"===t||"none"===t||!t}function ke(t){var e=Qd(t,pr);return je(e)?xr:e.substr(7).match(et).map(ia)}function le(t,e){var r,i,n,a,s=t._gsap||fa(t),o=t.style,u=ke(t);return s.svg&&t.getAttribute("transform")?"1,0,0,1,0,0"===(u=[(n=t.transform.baseVal.consolidate().matrix).a,n.b,n.c,n.d,n.e,n.f]).join(",")?xr:u:(u!==xr||t.offsetParent||t===Fe||s.svg||(n=o.display,o.display="block",(r=t.parentNode)&&(t.offsetParent||t.getBoundingClientRect().width)||(a=1,i=t.nextElementSibling,Fe.appendChild(t)),u=ke(t),n?o.display=n:Yd(t,"display"),a&&(i?r.insertBefore(t,i):r?r.appendChild(t):Fe.removeChild(t))),e&&6<u.length?[u[0],u[1],u[4],u[5],u[12],u[13]]:u)}function me(t,e,r,i,n,a){var s,o,u,h=t._gsap,l=n||le(t,!0),f=h.xOrigin||0,d=h.yOrigin||0,c=h.xOffset||0,p=h.yOffset||0,_=l[0],m=l[1],g=l[2],v=l[3],y=l[4],T=l[5],b=e.split(" "),w=parseFloat(b[0])||0,x=parseFloat(b[1])||0;r?l!==xr&&(o=_*v-m*g)&&(u=w*(-m/o)+x*(_/o)-(_*T-m*y)/o,w=w*(v/o)+x*(-g/o)+(g*T-v*y)/o,x=u):(w=(s=Wd(t)).x+(~b[0].indexOf("%")?w/100*s.width:w),x=s.y+(~(b[1]||b[0]).indexOf("%")?x/100*s.height:x)),i||!1!==i&&h.smooth?(y=w-f,T=x-d,h.xOffset=c+(y*_+T*g)-y,h.yOffset=p+(y*m+T*v)-T):h.xOffset=h.yOffset=0,h.xOrigin=w,h.yOrigin=x,h.smooth=!!i,h.origin=e,h.originIsAbsolute=!!r,t.style[_r]="0px 0px",a&&(Zd(a,h,"xOrigin",f,w),Zd(a,h,"yOrigin",d,x),Zd(a,h,"xOffset",c,h.xOffset),Zd(a,h,"yOffset",p,h.yOffset)),t.setAttribute("data-svg-origin",w+" "+x)}function pe(t,e,r){var i=Za(e);return ia(parseFloat(e)+parseFloat(ae(t,"x",r+"px",i)))+i}function we(t,e,i,n,a){var s,o,u=360,h=r(a),l=parseFloat(a)*(h&&~a.indexOf("rad")?or:1)-n,f=n+l+"deg";return h&&("short"===(s=a.split("_")[1])&&(l%=u)!==l%180&&(l+=l<0?u:-u),"cw"===s&&l<0?l=(l+36e9)%u-~~(l/u)*u:"ccw"===s&&0<l&&(l=(l-36e9)%u-~~(l/u)*u)),t._pt=o=new ge(t._pt,e,i,n,l,xd),o.e=f,o.u="deg",t._props.push(i),o}function xe(t,e){for(var r in e)t[r]=e[r];return t}function ye(t,e,r){var i,n,a,s,o,u,h,l=xe({},r._gsap),f=r.style;for(n in l.svg?(a=r.getAttribute("transform"),r.setAttribute("transform",""),f[pr]=e,i=kr(r,1),Yd(r,pr),r.setAttribute("transform",a)):(a=getComputedStyle(r)[pr],f[pr]=e,i=kr(r,1),f[pr]=a),sr)(a=l[n])!==(s=i[n])&&"perspective,force3D,transformOrigin,svgOrigin".indexOf(n)<0&&(o=Za(a)!==(h=Za(s))?ae(r,n,a,h):parseFloat(a),u=parseFloat(s),t._pt=new ge(t._pt,i,n,o,u-o,wd),t._pt.u=h||0,t._props.push(n));xe(i,l)}var Ee,Re,Fe,Le,Ie,Be,Ye,Xe,Ze=Lt.Power0,Ne=Lt.Power1,Qe=Lt.Power2,Ue=Lt.Power3,qe=Lt.Power4,Ve=Lt.Linear,We=Lt.Quad,Ge=Lt.Cubic,He=Lt.Quart,Ke=Lt.Quint,Je=Lt.Strong,$e=Lt.Elastic,tr=Lt.Back,er=Lt.SteppedEase,rr=Lt.Bounce,ir=Lt.Sine,nr=Lt.Expo,ar=Lt.Circ,sr={},or=180/Math.PI,ur=Math.PI/180,hr=Math.atan2,lr=/([A-Z])/g,fr=/(left|right|width|margin|padding|x)/i,dr=/[\s,\(]\S/,cr={autoAlpha:"opacity,visibility",scale:"scaleX,scaleY",alpha:"opacity"},pr="transform",_r=pr+"Origin",mr="O,Moz,ms,Ms,Webkit".split(","),gr=function _checkPropPrefix(t,e,r){var i=(e||Ie).style,n=5;if(t in i&&!r)return t;for(t=t.charAt(0).toUpperCase()+t.substr(1);n--&&!(mr[n]+t in i););return n<0?null:(3===n?"ms":0<=n?mr[n]:"")+t},vr={deg:1,rad:1,turn:1},yr={grid:1,flex:1},Tr=function _get(t,e,r,i){var n;return Le||Td(),e in cr&&"transform"!==e&&~(e=cr[e]).indexOf(",")&&(e=e.split(",")[0]),sr[e]&&"transform"!==e?(n=kr(t,i),n="transformOrigin"!==e?n[e]:n.svg?n.origin:Or(Qd(t,_r))+" "+n.zOrigin+"px"):(n=t.style[e])&&"auto"!==n&&!i&&!~(n+"").indexOf("calc(")||(n=wr[e]&&wr[e](t,e,r)||Qd(t,e)||ga(t,e)||("opacity"===e?1:0)),r&&!~(n+"").trim().indexOf(" ")?ae(t,e,n,r)+r:n},br={top:"0%",bottom:"100%",left:"0%",right:"100%",center:"50%"},wr={clearProps:function clearProps(t,e,r,i,n){if("isFromStart"!==n.data){var a=t._pt=new ge(t._pt,e,r,0,0,fe);return a.u=i,a.pr=-10,a.tween=n,t._props.push(r),1}}},xr=[1,0,0,1,0,0],Mr={},kr=function _parseTransform(t,e){var r=t._gsap||new Zt(t);if("x"in r&&!e&&!r.uncache)return r;var i,n,a,s,o,u,h,l,f,d,c,p,_,m,g,v,y,T,b,w,x,M,k,O,A,P,C,S,D,z,E,R,F=t.style,L=r.scaleX<0,I="deg",B=getComputedStyle(t),j=Qd(t,_r)||"0";return i=n=a=u=h=l=f=d=c=0,s=o=1,r.svg=!(!t.getCTM||!Xd(t)),B.translate&&("none"===B.translate&&"none"===B.scale&&"none"===B.rotate||(F[pr]=("none"!==B.translate?"translate3d("+(B.translate+" 0 0").split(" ").slice(0,3).join(", ")+") ":"")+("none"!==B.rotate?"rotate("+B.rotate+") ":"")+("none"!==B.scale?"scale("+B.scale.split(" ").join(",")+") ":"")+("none"!==B[pr]?B[pr]:"")),F.scale=F.rotate=F.translate="none"),m=le(t,r.svg),r.svg&&(O=r.uncache?(A=t.getBBox(),j=r.xOrigin-A.x+"px "+(r.yOrigin-A.y)+"px",""):!e&&t.getAttribute("data-svg-origin"),me(t,O||j,!!O||r.originIsAbsolute,!1!==r.smooth,m)),p=r.xOrigin||0,_=r.yOrigin||0,m!==xr&&(T=m[0],b=m[1],w=m[2],x=m[3],i=M=m[4],n=k=m[5],6===m.length?(s=Math.sqrt(T*T+b*b),o=Math.sqrt(x*x+w*w),u=T||b?hr(b,T)*or:0,(f=w||x?hr(w,x)*or+u:0)&&(o*=Math.abs(Math.cos(f*ur))),r.svg&&(i-=p-(p*T+_*w),n-=_-(p*b+_*x))):(R=m[6],z=m[7],C=m[8],S=m[9],D=m[10],E=m[11],i=m[12],n=m[13],a=m[14],h=(g=hr(R,D))*or,g&&(O=M*(v=Math.cos(-g))+C*(y=Math.sin(-g)),A=k*v+S*y,P=R*v+D*y,C=M*-y+C*v,S=k*-y+S*v,D=R*-y+D*v,E=z*-y+E*v,M=O,k=A,R=P),l=(g=hr(-w,D))*or,g&&(v=Math.cos(-g),E=x*(y=Math.sin(-g))+E*v,T=O=T*v-C*y,b=A=b*v-S*y,w=P=w*v-D*y),u=(g=hr(b,T))*or,g&&(O=T*(v=Math.cos(g))+b*(y=Math.sin(g)),A=M*v+k*y,b=b*v-T*y,k=k*v-M*y,T=O,M=A),h&&359.9<Math.abs(h)+Math.abs(u)&&(h=u=0,l=180-l),s=ia(Math.sqrt(T*T+b*b+w*w)),o=ia(Math.sqrt(k*k+R*R)),g=hr(M,k),f=2e-4<Math.abs(g)?g*or:0,c=E?1/(E<0?-E:E):0),r.svg&&(O=t.getAttribute("transform"),r.forceCSS=t.setAttribute("transform","")||!je(Qd(t,pr)),O&&t.setAttribute("transform",O))),90<Math.abs(f)&&Math.abs(f)<270&&(L?(s*=-1,f+=u<=0?180:-180,u+=u<=0?180:-180):(o*=-1,f+=f<=0?180:-180)),e=e||r.uncache,r.x=i-((r.xPercent=i&&(!e&&r.xPercent||(Math.round(t.offsetWidth/2)===Math.round(-i)?-50:0)))?t.offsetWidth*r.xPercent/100:0)+"px",r.y=n-((r.yPercent=n&&(!e&&r.yPercent||(Math.round(t.offsetHeight/2)===Math.round(-n)?-50:0)))?t.offsetHeight*r.yPercent/100:0)+"px",r.z=a+"px",r.scaleX=ia(s),r.scaleY=ia(o),r.rotation=ia(u)+I,r.rotationX=ia(h)+I,r.rotationY=ia(l)+I,r.skewX=f+I,r.skewY=d+I,r.transformPerspective=c+"px",(r.zOrigin=parseFloat(j.split(" ")[2])||!e&&r.zOrigin||0)&&(F[_r]=Or(j)),r.xOffset=r.yOffset=0,r.force3D=X.force3D,r.renderTransform=r.svg?zr:Xe?Dr:Ar,r.uncache=0,r},Or=function _firstTwoOnly(t){return(t=t.split(" "))[0]+" "+t[1]},Ar=function _renderNon3DTransforms(t,e){e.z="0px",e.rotationY=e.rotationX="0deg",e.force3D=0,Dr(t,e)},Pr="0deg",Cr="0px",Sr=") ",Dr=function _renderCSSTransforms(t,e){var r=e||this,i=r.xPercent,n=r.yPercent,a=r.x,s=r.y,o=r.z,u=r.rotation,h=r.rotationY,l=r.rotationX,f=r.skewX,d=r.skewY,c=r.scaleX,p=r.scaleY,_=r.transformPerspective,m=r.force3D,g=r.target,v=r.zOrigin,y="",T="auto"===m&&t&&1!==t||!0===m;if(v&&(l!==Pr||h!==Pr)){var b,w=parseFloat(h)*ur,x=Math.sin(w),M=Math.cos(w);w=parseFloat(l)*ur,b=Math.cos(w),a=pe(g,a,x*b*-v),s=pe(g,s,-Math.sin(w)*-v),o=pe(g,o,M*b*-v+v)}_!==Cr&&(y+="perspective("+_+Sr),(i||n)&&(y+="translate("+i+"%, "+n+"%) "),!T&&a===Cr&&s===Cr&&o===Cr||(y+=o!==Cr||T?"translate3d("+a+", "+s+", "+o+") ":"translate("+a+", "+s+Sr),u!==Pr&&(y+="rotate("+u+Sr),h!==Pr&&(y+="rotateY("+h+Sr),l!==Pr&&(y+="rotateX("+l+Sr),f===Pr&&d===Pr||(y+="skew("+f+", "+d+Sr),1===c&&1===p||(y+="scale("+c+", "+p+Sr),g.style[pr]=y||"translate(0, 0)"},zr=function _renderSVGTransforms(t,e){var r,i,n,a,s,o=e||this,u=o.xPercent,h=o.yPercent,l=o.x,f=o.y,d=o.rotation,c=o.skewX,p=o.skewY,_=o.scaleX,m=o.scaleY,g=o.target,v=o.xOrigin,y=o.yOrigin,T=o.xOffset,b=o.yOffset,w=o.forceCSS,x=parseFloat(l),M=parseFloat(f);d=parseFloat(d),c=parseFloat(c),(p=parseFloat(p))&&(c+=p=parseFloat(p),d+=p),d||c?(d*=ur,c*=ur,r=Math.cos(d)*_,i=Math.sin(d)*_,n=Math.sin(d-c)*-m,a=Math.cos(d-c)*m,c&&(p*=ur,s=Math.tan(c-p),n*=s=Math.sqrt(1+s*s),a*=s,p&&(s=Math.tan(p),r*=s=Math.sqrt(1+s*s),i*=s)),r=ia(r),i=ia(i),n=ia(n),a=ia(a)):(r=_,a=m,i=n=0),(x&&!~(l+"").indexOf("px")||M&&!~(f+"").indexOf("px"))&&(x=ae(g,"x",l,"px"),M=ae(g,"y",f,"px")),(v||y||T||b)&&(x=ia(x+v-(v*r+y*n)+T),M=ia(M+y-(v*i+y*a)+b)),(u||h)&&(s=g.getBBox(),x=ia(x+u/100*s.width),M=ia(M+h/100*s.height)),s="matrix("+r+","+i+","+n+","+a+","+x+","+M+")",g.setAttribute("transform",s),w&&(g.style[pr]=s)};ha("padding,margin,Width,Radius",function(e,r){var t="Right",i="Bottom",n="Left",o=(r<3?["Top",t,i,n]:["Top"+n,"Top"+t,i+t,i+n]).map(function(t){return r<2?e+t:"border"+t+e});wr[1<r?"border"+e:e]=function(e,t,r,i,n){var a,s;if(arguments.length<4)return a=o.map(function(t){return Tr(e,t,r)}),5===(s=a.join(" ")).split(a[0]).length?a[0]:s;a=(i+"").split(" "),s={},o.forEach(function(t,e){return s[t]=a[e]=a[e]||a[(e-1)/2|0]}),e.init(t,s,n)}});var Er,Rr,Fr,Lr={name:"css",register:Td,targetTest:function targetTest(t){return t.style&&t.nodeType},init:function init(t,e,i,n,a){var s,o,u,h,l,f,d,c,p,_,m,g,v,y,T,b,w=this._props,x=t.style,M=i.vars.startAt;for(d in Le||Td(),this.styles=this.styles||Nd(t),b=this.styles.props,this.tween=i,e)if("autoRound"!==d&&(o=e[d],!pt[d]||!bc(d,e,i,n,t,a)))if(l=typeof o,f=wr[d],"function"===l&&(l=typeof(o=o.call(i,n,t,a))),"string"===l&&~o.indexOf("random(")&&(o=pb(o)),f)f(this,t,d,o,i)&&(T=1);else if("--"===d.substr(0,2))s=(getComputedStyle(t).getPropertyValue(d)+"").trim(),o+="",zt.lastIndex=0,zt.test(s)||(c=Za(s),p=Za(o)),p?c!==p&&(s=ae(t,d,s,p)+p):c&&(o+=c),this.add(x,"setProperty",s,o,n,a,0,0,d),w.push(d),b.push(d,0,x[d]);else if("undefined"!==l){if(M&&d in M?(s="function"==typeof M[d]?M[d].call(i,n,t,a):M[d],r(s)&&~s.indexOf("random(")&&(s=pb(s)),Za(s+"")||"auto"===s||(s+=X.units[d]||Za(Tr(t,d))||""),"="===(s+"").charAt(1)&&(s=Tr(t,d))):s=Tr(t,d),h=parseFloat(s),(_="string"===l&&"="===o.charAt(1)&&o.substr(0,2))&&(o=o.substr(2)),u=parseFloat(o),d in cr&&("autoAlpha"===d&&(1===h&&"hidden"===Tr(t,"visibility")&&u&&(h=0),b.push("visibility",0,x.visibility),Zd(this,x,"visibility",h?"inherit":"hidden",u?"inherit":"hidden",!u)),"scale"!==d&&"transform"!==d&&~(d=cr[d]).indexOf(",")&&(d=d.split(",")[0])),m=d in sr)if(this.styles.save(d),"string"===l&&"var(--"===o.substring(0,6)&&(o=Qd(t,o.substring(4,o.indexOf(")"))),u=parseFloat(o)),g||((v=t._gsap).renderTransform&&!e.parseTransform||kr(t,e.parseTransform),y=!1!==e.smoothOrigin&&v.smooth,(g=this._pt=new ge(this._pt,x,pr,0,1,v.renderTransform,v,0,-1)).dep=1),"scale"===d)this._pt=new ge(this._pt,v,"scaleY",v.scaleY,(_?ka(v.scaleY,_+u):u)-v.scaleY||0,wd),this._pt.u=0,w.push("scaleY",d),d+="X";else{if("transformOrigin"===d){b.push(_r,0,x[_r]),o=ee(o),v.svg?me(t,o,0,y,0,this):((p=parseFloat(o.split(" ")[2])||0)!==v.zOrigin&&Zd(this,v,"zOrigin",v.zOrigin,p),Zd(this,x,d,Or(s),Or(o)));continue}if("svgOrigin"===d){me(t,o,1,y,0,this);continue}if(d in Mr){we(this,v,d,h,_?ka(h,_+o):o);continue}if("smoothOrigin"===d){Zd(this,v,"smooth",v.smooth,o);continue}if("force3D"===d){v[d]=o;continue}if("transform"===d){ye(this,o,t);continue}}else d in x||(d=gr(d)||d);if(m||(u||0===u)&&(h||0===h)&&!dr.test(o)&&d in x)u=u||0,(c=(s+"").substr((h+"").length))!==(p=Za(o)||(d in X.units?X.units[d]:c))&&(h=ae(t,d,s,p)),this._pt=new ge(this._pt,m?v:x,d,h,(_?ka(h,_+u):u)-h,m||"px"!==p&&"zIndex"!==d||!1===e.autoRound?wd:zd),this._pt.u=p||0,c!==p&&"%"!==p&&(this._pt.b=s,this._pt.r=yd);else if(d in x)ce.call(this,t,d,s,_?_+o:o);else if(d in t)this.add(t,d,s||t[d],_?_+o:o,n,a);else if("parseTransform"!==d){Q(d,o);continue}m||(d in x?b.push(d,0,x[d]):"function"==typeof t[d]?b.push(d,2,t[d]()):b.push(d,1,s||t[d])),w.push(d)}T&&_e(this)},render:function render(t,e){if(e.tween._time||!Ye())for(var r=e._pt;r;)r.r(t,r.d),r=r._next;else e.styles.revert()},get:Tr,aliases:cr,getSetter:function getSetter(t,e,r){var i=cr[e];return i&&i.indexOf(",")<0&&(e=i),e in sr&&e!==_r&&(t._gsap.x||Tr(t,"x"))?r&&Be===r?"scale"===e?Fd:Ed:(Be=r||{})&&("scale"===e?Gd:Hd):t.style&&!u(t.style[e])?Cd:~e.indexOf("-")?Dd:ie(t,e)},core:{_removeProperty:Yd,_getMatrix:le}};ze.utils.checkPrefix=gr,ze.core.getStyleSaver=Nd,Fr=ha((Er="x,y,z,scale,scaleX,scaleY,xPercent,yPercent")+","+(Rr="rotation,rotationX,rotationY,skewX,skewY")+",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective",function(t){sr[t]=1}),ha(Rr,function(t){X.units[t]="deg",Mr[t]=1}),cr[Fr[13]]=Er+","+Rr,ha("0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY",function(t){var e=t.split(":");cr[e[1]]=Fr[e[0]]}),ha("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective",function(t){X.units[t]="px"}),ze.registerPlugin(Lr);var Ir=ze.registerPlugin(Lr)||ze,Br=Ir.core.Tween;e.Back=tr,e.Bounce=rr,e.CSSPlugin=Lr,e.Circ=ar,e.Cubic=Ge,e.Elastic=$e,e.Expo=nr,e.Linear=Ve,e.Power0=Ze,e.Power1=Ne,e.Power2=Qe,e.Power3=Ue,e.Power4=qe,e.Quad=We,e.Quart=He,e.Quint=Ke,e.Sine=ir,e.SteppedEase=er,e.Strong=Je,e.TimelineLite=Qt,e.TimelineMax=Qt,e.TweenLite=Jt,e.TweenMax=Br,e.default=Ir,e.gsap=Ir;if (typeof(window)==="undefined"||window!==e){Object.defineProperty(e,"__esModule",{value:!0})} else {delete e.default}});

/*!
 * ScrollTrigger 3.13.0
 * https://gsap.com
 * 
 * @license Copyright 2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license.
 * @author: Jack Doyle, jack@greensock.com
 */


!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t((e=e||self).window=e.window||{})}(this,function(e){"use strict";function _defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function r(){return Se||"undefined"!=typeof window&&(Se=window.gsap)&&Se.registerPlugin&&Se}function z(e,t){return~Ye.indexOf(e)&&Ye[Ye.indexOf(e)+1][t]}function A(e){return!!~t.indexOf(e)}function B(e,t,r,n,i){return e.addEventListener(t,r,{passive:!1!==n,capture:!!i})}function C(e,t,r,n){return e.removeEventListener(t,r,!!n)}function F(){return Re&&Re.isPressed||ze.cache++}function G(r,n){function ed(e){if(e||0===e){i&&(Te.history.scrollRestoration="manual");var t=Re&&Re.isPressed;e=ed.v=Math.round(e)||(Re&&Re.iOS?1:0),r(e),ed.cacheID=ze.cache,t&&o("ss",e)}else(n||ze.cache!==ed.cacheID||o("ref"))&&(ed.cacheID=ze.cache,ed.v=r());return ed.v+ed.offset}return ed.offset=0,r&&ed}function J(e,t){return(t&&t._ctx&&t._ctx.selector||Se.utils.toArray)(e)[0]||("string"==typeof e&&!1!==Se.config().nullTargetWarn?console.warn("Element not found:",e):null)}function L(t,e){var r=e.s,n=e.sc;A(t)&&(t=Ce.scrollingElement||Me);var i=ze.indexOf(t),o=n===qe.sc?1:2;~i||(i=ze.push(t)-1),ze[i+o]||B(t,"scroll",F);var a=ze[i+o],s=a||(ze[i+o]=G(z(t,r),!0)||(A(t)?n:G(function(e){return arguments.length?t[r]=e:t[r]})));return s.target=t,a||(s.smooth="smooth"===Se.getProperty(t,"scrollBehavior")),s}function M(e,t,i){function Gd(e,t){var r=Le();t||n<r-s?(a=o,o=e,l=s,s=r):i?o+=e:o=a+(e-a)/(r-l)*(s-l)}var o=e,a=e,s=Le(),l=s,n=t||50,c=Math.max(500,3*n);return{update:Gd,reset:function reset(){a=o=i?0:o,l=s=0},getVelocity:function getVelocity(e){var t=l,r=a,n=Le();return!e&&0!==e||e===o||Gd(e),s===l||c<n-l?0:(o+(i?r:-r))/((i?n:s)-t)*1e3}}}function N(e,t){return t&&!e._gsapAllow&&e.preventDefault(),e.changedTouches?e.changedTouches[0]:e}function O(e){var t=Math.max.apply(Math,e),r=Math.min.apply(Math,e);return Math.abs(t)>=Math.abs(r)?t:r}function P(){(Ae=Se.core.globals().ScrollTrigger)&&Ae.core&&function _integrate(){var e=Ae.core,r=e.bridge||{},t=e._scrollers,n=e._proxies;t.push.apply(t,ze),n.push.apply(n,Ye),ze=t,Ye=n,o=function _bridge(e,t){return r[e](t)}}()}function Q(e){return Se=e||r(),!ke&&Se&&"undefined"!=typeof document&&document.body&&(Te=window,Me=(Ce=document).documentElement,Ee=Ce.body,t=[Te,Ce,Me,Ee],Se.utils.clamp,Be=Se.core.context||function(){},Oe="onpointerenter"in Ee?"pointer":"mouse",Pe=E.isTouch=Te.matchMedia&&Te.matchMedia("(hover: none), (pointer: coarse)").matches?1:"ontouchstart"in Te||0<navigator.maxTouchPoints||0<navigator.msMaxTouchPoints?2:0,De=E.eventTypes=("ontouchstart"in Me?"touchstart,touchmove,touchcancel,touchend":"onpointerdown"in Me?"pointerdown,pointermove,pointercancel,pointerup":"mousedown,mousemove,mouseup,mouseup").split(","),setTimeout(function(){return i=0},500),P(),ke=1),ke}var Se,ke,Te,Ce,Me,Ee,Pe,Oe,Ae,t,Re,De,Be,i=1,Ie=[],ze=[],Ye=[],Le=Date.now,o=function _bridge(e,t){return t},n="scrollLeft",a="scrollTop",He={s:n,p:"left",p2:"Left",os:"right",os2:"Right",d:"width",d2:"Width",a:"x",sc:G(function(e){return arguments.length?Te.scrollTo(e,qe.sc()):Te.pageXOffset||Ce[n]||Me[n]||Ee[n]||0})},qe={s:a,p:"top",p2:"Top",os:"bottom",os2:"Bottom",d:"height",d2:"Height",a:"y",op:He,sc:G(function(e){return arguments.length?Te.scrollTo(He.sc(),e):Te.pageYOffset||Ce[a]||Me[a]||Ee[a]||0})};He.op=qe,ze.cache=0;var E=(Observer.prototype.init=function init(e){ke||Q(Se)||console.warn("Please gsap.registerPlugin(Observer)"),Ae||P();var i=e.tolerance,a=e.dragMinimum,t=e.type,o=e.target,r=e.lineHeight,n=e.debounce,s=e.preventDefault,l=e.onStop,c=e.onStopDelay,u=e.ignore,f=e.wheelSpeed,d=e.event,p=e.onDragStart,g=e.onDragEnd,h=e.onDrag,v=e.onPress,b=e.onRelease,m=e.onRight,y=e.onLeft,x=e.onUp,_=e.onDown,w=e.onChangeX,S=e.onChangeY,k=e.onChange,T=e.onToggleX,E=e.onToggleY,R=e.onHover,D=e.onHoverEnd,I=e.onMove,z=e.ignoreCheck,Y=e.isNormalizer,H=e.onGestureStart,q=e.onGestureEnd,X=e.onWheel,U=e.onEnable,W=e.onDisable,G=e.onClick,V=e.scrollSpeed,K=e.capture,j=e.allowClicks,Z=e.lockAxis,$=e.onLockAxis;function gf(){return xe=Le()}function hf(e,t){return(se.event=e)&&u&&function _isWithin(e,t){for(var r=t.length;r--;)if(t[r]===e||t[r].contains(e))return!0;return!1}(e.target,u)||t&&he&&"touch"!==e.pointerType||z&&z(e,t)}function kf(){var e=se.deltaX=O(me),t=se.deltaY=O(ye),r=Math.abs(e)>=i,n=Math.abs(t)>=i;k&&(r||n)&&k(se,e,t,me,ye),r&&(m&&0<se.deltaX&&m(se),y&&se.deltaX<0&&y(se),w&&w(se),T&&se.deltaX<0!=le<0&&T(se),le=se.deltaX,me[0]=me[1]=me[2]=0),n&&(_&&0<se.deltaY&&_(se),x&&se.deltaY<0&&x(se),S&&S(se),E&&se.deltaY<0!=ce<0&&E(se),ce=se.deltaY,ye[0]=ye[1]=ye[2]=0),(ne||re)&&(I&&I(se),re&&(p&&1===re&&p(se),h&&h(se),re=0),ne=!1),oe&&!(oe=!1)&&$&&$(se),ie&&(X(se),ie=!1),ee=0}function lf(e,t,r){me[r]+=e,ye[r]+=t,se._vx.update(e),se._vy.update(t),n?ee=ee||requestAnimationFrame(kf):kf()}function mf(e,t){Z&&!ae&&(se.axis=ae=Math.abs(e)>Math.abs(t)?"x":"y",oe=!0),"y"!==ae&&(me[2]+=e,se._vx.update(e,!0)),"x"!==ae&&(ye[2]+=t,se._vy.update(t,!0)),n?ee=ee||requestAnimationFrame(kf):kf()}function nf(e){if(!hf(e,1)){var t=(e=N(e,s)).clientX,r=e.clientY,n=t-se.x,i=r-se.y,o=se.isDragging;se.x=t,se.y=r,(o||(n||i)&&(Math.abs(se.startX-t)>=a||Math.abs(se.startY-r)>=a))&&(re=o?2:1,o||(se.isDragging=!0),mf(n,i))}}function qf(e){return e.touches&&1<e.touches.length&&(se.isGesturing=!0)&&H(e,se.isDragging)}function rf(){return(se.isGesturing=!1)||q(se)}function sf(e){if(!hf(e)){var t=fe(),r=de();lf((t-pe)*V,(r-ge)*V,1),pe=t,ge=r,l&&te.restart(!0)}}function tf(e){if(!hf(e)){e=N(e,s),X&&(ie=!0);var t=(1===e.deltaMode?r:2===e.deltaMode?Te.innerHeight:1)*f;lf(e.deltaX*t,e.deltaY*t,0),l&&!Y&&te.restart(!0)}}function uf(e){if(!hf(e)){var t=e.clientX,r=e.clientY,n=t-se.x,i=r-se.y;se.x=t,se.y=r,ne=!0,l&&te.restart(!0),(n||i)&&mf(n,i)}}function vf(e){se.event=e,R(se)}function wf(e){se.event=e,D(se)}function xf(e){return hf(e)||N(e,s)&&G(se)}this.target=o=J(o)||Me,this.vars=e,u=u&&Se.utils.toArray(u),i=i||1e-9,a=a||0,f=f||1,V=V||1,t=t||"wheel,touch,pointer",n=!1!==n,r=r||parseFloat(Te.getComputedStyle(Ee).lineHeight)||22;var ee,te,re,ne,ie,oe,ae,se=this,le=0,ce=0,ue=e.passive||!s&&!1!==e.passive,fe=L(o,He),de=L(o,qe),pe=fe(),ge=de(),he=~t.indexOf("touch")&&!~t.indexOf("pointer")&&"pointerdown"===De[0],ve=A(o),be=o.ownerDocument||Ce,me=[0,0,0],ye=[0,0,0],xe=0,_e=se.onPress=function(e){hf(e,1)||e&&e.button||(se.axis=ae=null,te.pause(),se.isPressed=!0,e=N(e),le=ce=0,se.startX=se.x=e.clientX,se.startY=se.y=e.clientY,se._vx.reset(),se._vy.reset(),B(Y?o:be,De[1],nf,ue,!0),se.deltaX=se.deltaY=0,v&&v(se))},we=se.onRelease=function(t){if(!hf(t,1)){C(Y?o:be,De[1],nf,!0);var e=!isNaN(se.y-se.startY),r=se.isDragging,n=r&&(3<Math.abs(se.x-se.startX)||3<Math.abs(se.y-se.startY)),i=N(t);!n&&e&&(se._vx.reset(),se._vy.reset(),s&&j&&Se.delayedCall(.08,function(){if(300<Le()-xe&&!t.defaultPrevented)if(t.target.click)t.target.click();else if(be.createEvent){var e=be.createEvent("MouseEvents");e.initMouseEvent("click",!0,!0,Te,1,i.screenX,i.screenY,i.clientX,i.clientY,!1,!1,!1,!1,0,null),t.target.dispatchEvent(e)}})),se.isDragging=se.isGesturing=se.isPressed=!1,l&&r&&!Y&&te.restart(!0),re&&kf(),g&&r&&g(se),b&&b(se,n)}};te=se._dc=Se.delayedCall(c||.25,function onStopFunc(){se._vx.reset(),se._vy.reset(),te.pause(),l&&l(se)}).pause(),se.deltaX=se.deltaY=0,se._vx=M(0,50,!0),se._vy=M(0,50,!0),se.scrollX=fe,se.scrollY=de,se.isDragging=se.isGesturing=se.isPressed=!1,Be(this),se.enable=function(e){return se.isEnabled||(B(ve?be:o,"scroll",F),0<=t.indexOf("scroll")&&B(ve?be:o,"scroll",sf,ue,K),0<=t.indexOf("wheel")&&B(o,"wheel",tf,ue,K),(0<=t.indexOf("touch")&&Pe||0<=t.indexOf("pointer"))&&(B(o,De[0],_e,ue,K),B(be,De[2],we),B(be,De[3],we),j&&B(o,"click",gf,!0,!0),G&&B(o,"click",xf),H&&B(be,"gesturestart",qf),q&&B(be,"gestureend",rf),R&&B(o,Oe+"enter",vf),D&&B(o,Oe+"leave",wf),I&&B(o,Oe+"move",uf)),se.isEnabled=!0,se.isDragging=se.isGesturing=se.isPressed=ne=re=!1,se._vx.reset(),se._vy.reset(),pe=fe(),ge=de(),e&&e.type&&_e(e),U&&U(se)),se},se.disable=function(){se.isEnabled&&(Ie.filter(function(e){return e!==se&&A(e.target)}).length||C(ve?be:o,"scroll",F),se.isPressed&&(se._vx.reset(),se._vy.reset(),C(Y?o:be,De[1],nf,!0)),C(ve?be:o,"scroll",sf,K),C(o,"wheel",tf,K),C(o,De[0],_e,K),C(be,De[2],we),C(be,De[3],we),C(o,"click",gf,!0),C(o,"click",xf),C(be,"gesturestart",qf),C(be,"gestureend",rf),C(o,Oe+"enter",vf),C(o,Oe+"leave",wf),C(o,Oe+"move",uf),se.isEnabled=se.isPressed=se.isDragging=!1,W&&W(se))},se.kill=se.revert=function(){se.disable();var e=Ie.indexOf(se);0<=e&&Ie.splice(e,1),Re===se&&(Re=0)},Ie.push(se),Y&&A(o)&&(Re=se),se.enable(d)},function _createClass(e,t,r){return t&&_defineProperties(e.prototype,t),r&&_defineProperties(e,r),e}(Observer,[{key:"velocityX",get:function get(){return this._vx.getVelocity()}},{key:"velocityY",get:function get(){return this._vy.getVelocity()}}]),Observer);function Observer(e){this.init(e)}E.version="3.13.0",E.create=function(e){return new E(e)},E.register=Q,E.getAll=function(){return Ie.slice()},E.getById=function(t){return Ie.filter(function(e){return e.vars.id===t})[0]},r()&&Se.registerPlugin(E);function Da(e,t,r){var n=ct(e)&&("clamp("===e.substr(0,6)||-1<e.indexOf("max"));return(r["_"+t+"Clamp"]=n)?e.substr(6,e.length-7):e}function Ea(e,t){return!t||ct(e)&&"clamp("===e.substr(0,6)?e:"clamp("+e+")"}function Ga(){return Qe=1}function Ha(){return Qe=0}function Ia(e){return e}function Ja(e){return Math.round(1e5*e)/1e5||0}function Ka(){return"undefined"!=typeof window}function La(){return Ne||Ka()&&(Ne=window.gsap)&&Ne.registerPlugin&&Ne}function Ma(e){return!!~l.indexOf(e)}function Na(e){return("Height"===e?S:Xe["inner"+e])||Ue["client"+e]||We["client"+e]}function Oa(e){return z(e,"getBoundingClientRect")||(Ma(e)?function(){return Ot.width=Xe.innerWidth,Ot.height=S,Ot}:function(){return _t(e)})}function Ra(e,t){var r=t.s,n=t.d2,i=t.d,o=t.a;return Math.max(0,(r="scroll"+n)&&(o=z(e,r))?o()-Oa(e)()[i]:Ma(e)?(Ue[r]||We[r])-Na(n):e[r]-e["offset"+n])}function Sa(e,t){for(var r=0;r<g.length;r+=3)t&&!~t.indexOf(g[r+1])||e(g[r],g[r+1],g[r+2])}function Ua(e){return"function"==typeof e}function Va(e){return"number"==typeof e}function Wa(e){return"object"==typeof e}function Xa(e,t,r){return e&&e.progress(t?0:1)&&r&&e.pause()}function Ya(e,t){if(e.enabled){var r=e._ctx?e._ctx.add(function(){return t(e)}):t(e);r&&r.totalTime&&(e.callbackAnimation=r)}}function nb(e){return Xe.getComputedStyle(e)}function pb(e,t){for(var r in t)r in e||(e[r]=t[r]);return e}function rb(e,t){var r=t.d2;return e["offset"+r]||e["client"+r]||0}function sb(e){var t,r=[],n=e.labels,i=e.duration();for(t in n)r.push(n[t]/i);return r}function ub(i){var o=Ne.utils.snap(i),a=Array.isArray(i)&&i.slice(0).sort(function(e,t){return e-t});return a?function(e,t,r){var n;if(void 0===r&&(r=.001),!t)return o(e);if(0<t){for(e-=r,n=0;n<a.length;n++)if(a[n]>=e)return a[n];return a[n-1]}for(n=a.length,e+=r;n--;)if(a[n]<=e)return a[n];return a[0]}:function(e,t,r){void 0===r&&(r=.001);var n=o(e);return!t||Math.abs(n-e)<r||n-e<0==t<0?n:o(t<0?e-i:e+i)}}function wb(t,r,e,n){return e.split(",").forEach(function(e){return t(r,e,n)})}function xb(e,t,r,n,i){return e.addEventListener(t,r,{passive:!n,capture:!!i})}function yb(e,t,r,n){return e.removeEventListener(t,r,!!n)}function zb(e,t,r){(r=r&&r.wheelHandler)&&(e(t,"wheel",r),e(t,"touchmove",r))}function Db(e,t){if(ct(e)){var r=e.indexOf("="),n=~r?(e.charAt(r-1)+1)*parseFloat(e.substr(r+1)):0;~r&&(e.indexOf("%")>r&&(n*=t/100),e=e.substr(0,r-1)),e=n+(e in q?q[e]*t:~e.indexOf("%")?parseFloat(e)*t/100:parseFloat(e)||0)}return e}function Eb(e,t,r,n,i,o,a,s){var l=i.startColor,c=i.endColor,u=i.fontSize,f=i.indent,d=i.fontWeight,p=Fe.createElement("div"),g=Ma(r)||"fixed"===z(r,"pinType"),h=-1!==e.indexOf("scroller"),v=g?We:r,b=-1!==e.indexOf("start"),m=b?l:c,y="border-color:"+m+";font-size:"+u+";color:"+m+";font-weight:"+d+";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";return y+="position:"+((h||s)&&g?"fixed;":"absolute;"),!h&&!s&&g||(y+=(n===qe?I:Y)+":"+(o+parseFloat(f))+"px;"),a&&(y+="box-sizing:border-box;text-align:left;width:"+a.offsetWidth+"px;"),p._isStart=b,p.setAttribute("class","gsap-marker-"+e+(t?" marker-"+t:"")),p.style.cssText=y,p.innerText=t||0===t?e+"-"+t:e,v.children[0]?v.insertBefore(p,v.children[0]):v.appendChild(p),p._offset=p["offset"+n.op.d2],X(p,0,n,b),p}function Jb(){return 34<at()-st&&(T=T||requestAnimationFrame(Z))}function Kb(){v&&v.isPressed&&!(v.startX>We.clientWidth)||(ze.cache++,v?T=T||requestAnimationFrame(Z):Z(),st||V("scrollStart"),st=at())}function Lb(){y=Xe.innerWidth,m=Xe.innerHeight}function Mb(e){ze.cache++,!0!==e&&(Ke||h||Fe.fullscreenElement||Fe.webkitFullscreenElement||b&&y===Xe.innerWidth&&!(Math.abs(Xe.innerHeight-m)>.25*Xe.innerHeight))||c.restart(!0)}function Pb(){return yb(ne,"scrollEnd",Pb)||Mt(!0)}function Sb(e){for(var t=0;t<K.length;t+=5)(!e||K[t+4]&&K[t+4].query===e)&&(K[t].style.cssText=K[t+1],K[t].getBBox&&K[t].setAttribute("transform",K[t+2]||""),K[t+3].uncache=1)}function Tb(e,t){var r;for(je=0;je<kt.length;je++)!(r=kt[je])||t&&r._ctx!==t||(e?r.kill(1):r.revert(!0,!0));k=!0,t&&Sb(t),t||V("revert")}function Ub(e,t){ze.cache++,!t&&rt||ze.forEach(function(e){return Ua(e)&&e.cacheID++&&(e.rec=0)}),ct(e)&&(Xe.history.scrollRestoration=_=e)}function Zb(){We.appendChild(w),S=!v&&w.offsetHeight||Xe.innerHeight,We.removeChild(w)}function $b(t){return Je(".gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end").forEach(function(e){return e.style.display=t?"none":"block"})}function hc(e,t,r,n){if(!e._gsap.swappedIn){for(var i,o=$.length,a=t.style,s=e.style;o--;)a[i=$[o]]=r[i];a.position="absolute"===r.position?"absolute":"relative","inline"===r.display&&(a.display="inline-block"),s[Y]=s[I]="auto",a.flexBasis=r.flexBasis||"auto",a.overflow="visible",a.boxSizing="border-box",a[ft]=rb(e,He)+xt,a[dt]=rb(e,qe)+xt,a[bt]=s[mt]=s.top=s.left="0",Pt(n),s[ft]=s.maxWidth=r[ft],s[dt]=s.maxHeight=r[dt],s[bt]=r[bt],e.parentNode!==t&&(e.parentNode.insertBefore(t,e),t.appendChild(e)),e._gsap.swappedIn=!0}}function kc(e){for(var t=ee.length,r=e.style,n=[],i=0;i<t;i++)n.push(ee[i],r[ee[i]]);return n.t=e,n}function nc(e,t,r,n,i,o,a,s,l,c,u,f,d,p){Ua(e)&&(e=e(s)),ct(e)&&"max"===e.substr(0,3)&&(e=f+("="===e.charAt(4)?Db("0"+e.substr(3),r):0));var g,h,v,b=d?d.time():0;if(d&&d.seek(0),isNaN(e)||(e=+e),Va(e))d&&(e=Ne.utils.mapRange(d.scrollTrigger.start,d.scrollTrigger.end,0,f,e)),a&&X(a,r,n,!0);else{Ua(t)&&(t=t(s));var m,y,x,_,w=(e||"0").split(" ");v=J(t,s)||We,(m=_t(v)||{})&&(m.left||m.top)||"none"!==nb(v).display||(_=v.style.display,v.style.display="block",m=_t(v),_?v.style.display=_:v.style.removeProperty("display")),y=Db(w[0],m[n.d]),x=Db(w[1]||"0",r),e=m[n.p]-l[n.p]-c+y+i-x,a&&X(a,x,n,r-x<20||a._isStart&&20<x),r-=r-x}if(p&&(s[p]=e||-.001,e<0&&(e=0)),o){var S=e+r,k=o._isStart;g="scroll"+n.d2,X(o,S,n,k&&20<S||!k&&(u?Math.max(We[g],Ue[g]):o.parentNode[g])<=S+1),u&&(l=_t(a),u&&(o.style[n.op.p]=l[n.op.p]-n.op.m-o._offset+xt))}return d&&v&&(g=_t(v),d.seek(f),h=_t(v),d._caScrollDist=g[n.p]-h[n.p],e=e/d._caScrollDist*f),d&&d.seek(b),d?e:Math.round(e)}function pc(e,t,r,n){if(e.parentNode!==t){var i,o,a=e.style;if(t===We){for(i in e._stOrig=a.cssText,o=nb(e))+i||re.test(i)||!o[i]||"string"!=typeof a[i]||"0"===i||(a[i]=o[i]);a.top=r,a.left=n}else a.cssText=e._stOrig;Ne.core.getCache(e).uncache=1,t.appendChild(e)}}function qc(r,e,n){var i=e,o=i;return function(e){var t=Math.round(r());return t!==i&&t!==o&&3<Math.abs(t-i)&&3<Math.abs(t-o)&&(e=t,n&&n()),o=i,i=Math.round(e)}}function rc(e,t,r){var n={};n[t.p]="+="+r,Ne.set(e,n)}function sc(c,e){function Hk(e,t,r,n,i){var o=Hk.tween,a=t.onComplete,s={};r=r||u();var l=qc(u,r,function(){o.kill(),Hk.tween=0});return i=n&&i||0,n=n||e-r,o&&o.kill(),t[f]=e,t.inherit=!1,(t.modifiers=s)[f]=function(){return l(r+n*o.ratio+i*o.ratio*o.ratio)},t.onUpdate=function(){ze.cache++,Hk.tween&&Z()},t.onComplete=function(){Hk.tween=0,a&&a.call(o)},o=Hk.tween=Ne.to(c,t)}var u=L(c,e),f="_scroll"+e.p2;return(c[f]=u).wheelHandler=function(){return Hk.tween&&Hk.tween.kill()&&(Hk.tween=0)},xb(c,"wheel",u.wheelHandler),ne.isTouch&&xb(c,"touchmove",u.wheelHandler),Hk}var Ne,s,Xe,Fe,Ue,We,l,c,Je,Ge,Ve,u,Ke,Qe,f,je,d,p,g,Ze,$e,h,v,b,m,y,R,x,_,w,S,k,et,tt,T,rt,nt,it,ot=1,at=Date.now,D=at(),st=0,lt=0,ct=function _isString(e){return"string"==typeof e},ut=Math.abs,I="right",Y="bottom",ft="width",dt="height",pt="Right",gt="Left",ht="Top",vt="Bottom",bt="padding",mt="margin",yt="Width",H="Height",xt="px",_t=function _getBounds(e,t){var r=t&&"matrix(1, 0, 0, 1, 0, 0)"!==nb(e)[f]&&Ne.to(e,{x:0,y:0,xPercent:0,yPercent:0,rotation:0,rotationX:0,rotationY:0,scale:1,skewX:0,skewY:0}).progress(1),n=e.getBoundingClientRect();return r&&r.progress(0).kill(),n},wt={startColor:"green",endColor:"red",indent:0,fontSize:"16px",fontWeight:"normal"},St={toggleActions:"play",anticipatePin:0},q={top:0,left:0,center:.5,bottom:1,right:1},X=function _positionMarker(e,t,r,n){var i={display:"block"},o=r[n?"os2":"p2"],a=r[n?"p2":"os2"];e._isFlipped=n,i[r.a+"Percent"]=n?-100:0,i[r.a]=n?"1px":0,i["border"+o+yt]=1,i["border"+a+yt]=0,i[r.p]=t+"px",Ne.set(e,i)},kt=[],Tt={},U={},W=[],V=function _dispatch(e){return U[e]&&U[e].map(function(e){return e()})||W},K=[],Ct=0,Mt=function _refreshAll(e,t){if(Ue=Fe.documentElement,We=Fe.body,l=[Xe,Fe,Ue,We],!st||e||k){Zb(),rt=ne.isRefreshing=!0,ze.forEach(function(e){return Ua(e)&&++e.cacheID&&(e.rec=e())});var r=V("refreshInit");Ze&&ne.sort(),t||Tb(),ze.forEach(function(e){Ua(e)&&(e.smooth&&(e.target.style.scrollBehavior="auto"),e(0))}),kt.slice(0).forEach(function(e){return e.refresh()}),k=!1,kt.forEach(function(e){if(e._subPinOffset&&e.pin){var t=e.vars.horizontal?"offsetWidth":"offsetHeight",r=e.pin[t];e.revert(!0,1),e.adjustPinSpacing(e.pin[t]-r),e.refresh()}}),et=1,$b(!0),kt.forEach(function(e){var t=Ra(e.scroller,e._dir),r="max"===e.vars.end||e._endClamp&&e.end>t,n=e._startClamp&&e.start>=t;(r||n)&&e.setPositions(n?t-1:e.start,r?Math.max(n?t:e.start+1,t):e.end,!0)}),$b(!1),et=0,r.forEach(function(e){return e&&e.render&&e.render(-1)}),ze.forEach(function(e){Ua(e)&&(e.smooth&&requestAnimationFrame(function(){return e.target.style.scrollBehavior="smooth"}),e.rec&&e(e.rec))}),Ub(_,1),c.pause(),Ct++,Z(rt=2),kt.forEach(function(e){return Ua(e.vars.onRefresh)&&e.vars.onRefresh(e)}),rt=ne.isRefreshing=!1,V("refresh")}else xb(ne,"scrollEnd",Pb)},j=0,Et=1,Z=function _updateAll(e){if(2===e||!rt&&!k){ne.isUpdating=!0,it&&it.update(0);var t=kt.length,r=at(),n=50<=r-D,i=t&&kt[0].scroll();if(Et=i<j?-1:1,rt||(j=i),n&&(st&&!Qe&&200<r-st&&(st=0,V("scrollEnd")),Ve=D,D=r),Et<0){for(je=t;0<je--;)kt[je]&&kt[je].update(0,n);Et=1}else for(je=0;je<t;je++)kt[je]&&kt[je].update(0,n);ne.isUpdating=!1}T=0},$=["left","top",Y,I,mt+vt,mt+pt,mt+ht,mt+gt,"display","flexShrink","float","zIndex","gridColumnStart","gridColumnEnd","gridRowStart","gridRowEnd","gridArea","justifySelf","alignSelf","placeSelf","order"],ee=$.concat([ft,dt,"boxSizing","max"+yt,"max"+H,"position",mt,bt,bt+ht,bt+pt,bt+vt,bt+gt]),te=/([A-Z])/g,Pt=function _setState(e){if(e){var t,r,n=e.t.style,i=e.length,o=0;for((e.t._gsap||Ne.core.getCache(e.t)).uncache=1;o<i;o+=2)r=e[o+1],t=e[o],r?n[t]=r:n[t]&&n.removeProperty(t.replace(te,"-$1").toLowerCase())}},Ot={left:0,top:0},re=/(webkit|moz|length|cssText|inset)/i,ne=(ScrollTrigger.prototype.init=function init(P,O){if(this.progress=this.start=0,this.vars&&this.kill(!0,!0),lt){var A,n,p,R,D,B,I,Y,H,q,N,e,X,F,U,W,G,V,t,K,b,Q,j,m,Z,y,$,x,r,_,w,ee,i,g,te,re,ne,S,o,k=(P=pb(ct(P)||Va(P)||P.nodeType?{trigger:P}:P,St)).onUpdate,T=P.toggleClass,a=P.id,C=P.onToggle,ie=P.onRefresh,M=P.scrub,oe=P.trigger,ae=P.pin,se=P.pinSpacing,le=P.invalidateOnRefresh,E=P.anticipatePin,s=P.onScrubComplete,h=P.onSnapComplete,ce=P.once,ue=P.snap,fe=P.pinReparent,l=P.pinSpacer,de=P.containerAnimation,pe=P.fastScrollEnd,ge=P.preventOverlaps,he=P.horizontal||P.containerAnimation&&!1!==P.horizontal?He:qe,ve=!M&&0!==M,be=J(P.scroller||Xe),c=Ne.core.getCache(be),me=Ma(be),ye="fixed"===("pinType"in P?P.pinType:z(be,"pinType")||me&&"fixed"),xe=[P.onEnter,P.onLeave,P.onEnterBack,P.onLeaveBack],_e=ve&&P.toggleActions.split(" "),we="markers"in P?P.markers:St.markers,Se=me?0:parseFloat(nb(be)["border"+he.p2+yt])||0,ke=this,Te=P.onRefreshInit&&function(){return P.onRefreshInit(ke)},Ce=function _getSizeFunc(e,t,r){var n=r.d,i=r.d2,o=r.a;return(o=z(e,"getBoundingClientRect"))?function(){return o()[n]}:function(){return(t?Na(i):e["client"+i])||0}}(be,me,he),Me=function _getOffsetsFunc(e,t){return!t||~Ye.indexOf(e)?Oa(e):function(){return Ot}}(be,me),Ee=0,Pe=0,Oe=0,Ae=L(be,he);if(ke._startClamp=ke._endClamp=!1,ke._dir=he,E*=45,ke.scroller=be,ke.scroll=de?de.time.bind(de):Ae,R=Ae(),ke.vars=P,O=O||P.animation,"refreshPriority"in P&&(Ze=1,-9999===P.refreshPriority&&(it=ke)),c.tweenScroll=c.tweenScroll||{top:sc(be,qe),left:sc(be,He)},ke.tweenTo=A=c.tweenScroll[he.p],ke.scrubDuration=function(e){(i=Va(e)&&e)?ee?ee.duration(e):ee=Ne.to(O,{ease:"expo",totalProgress:"+=0",inherit:!1,duration:i,paused:!0,onComplete:function onComplete(){return s&&s(ke)}}):(ee&&ee.progress(1).kill(),ee=0)},O&&(O.vars.lazy=!1,O._initted&&!ke.isReverted||!1!==O.vars.immediateRender&&!1!==P.immediateRender&&O.duration()&&O.render(0,!0,!0),ke.animation=O.pause(),(O.scrollTrigger=ke).scrubDuration(M),_=0,a=a||O.vars.id),ue&&(Wa(ue)&&!ue.push||(ue={snapTo:ue}),"scrollBehavior"in We.style&&Ne.set(me?[We,Ue]:be,{scrollBehavior:"auto"}),ze.forEach(function(e){return Ua(e)&&e.target===(me?Fe.scrollingElement||Ue:be)&&(e.smooth=!1)}),p=Ua(ue.snapTo)?ue.snapTo:"labels"===ue.snapTo?function _getClosestLabel(t){return function(e){return Ne.utils.snap(sb(t),e)}}(O):"labelsDirectional"===ue.snapTo?function _getLabelAtDirection(r){return function(e,t){return ub(sb(r))(e,t.direction)}}(O):!1!==ue.directional?function(e,t){return ub(ue.snapTo)(e,at()-Pe<500?0:t.direction)}:Ne.utils.snap(ue.snapTo),g=ue.duration||{min:.1,max:2},g=Wa(g)?Ge(g.min,g.max):Ge(g,g),te=Ne.delayedCall(ue.delay||i/2||.1,function(){var e=Ae(),t=at()-Pe<500,r=A.tween;if(!(t||Math.abs(ke.getVelocity())<10)||r||Qe||Ee===e)ke.isActive&&Ee!==e&&te.restart(!0);else{var n,i,o=(e-B)/F,a=O&&!ve?O.totalProgress():o,s=t?0:(a-w)/(at()-Ve)*1e3||0,l=Ne.utils.clamp(-o,1-o,ut(s/2)*s/.185),c=o+(!1===ue.inertia?0:l),u=ue.onStart,f=ue.onInterrupt,d=ue.onComplete;if(n=p(c,ke),Va(n)||(n=c),i=Math.max(0,Math.round(B+n*F)),e<=I&&B<=e&&i!==e){if(r&&!r._initted&&r.data<=ut(i-e))return;!1===ue.inertia&&(l=n-o),A(i,{duration:g(ut(.185*Math.max(ut(c-a),ut(n-a))/s/.05||0)),ease:ue.ease||"power3",data:ut(i-e),onInterrupt:function onInterrupt(){return te.restart(!0)&&f&&f(ke)},onComplete:function onComplete(){ke.update(),Ee=Ae(),O&&!ve&&(ee?ee.resetTo("totalProgress",n,O._tTime/O._tDur):O.progress(n)),_=w=O&&!ve?O.totalProgress():ke.progress,h&&h(ke),d&&d(ke)}},e,l*F,i-e-l*F),u&&u(ke,A.tween)}}}).pause()),a&&(Tt[a]=ke),o=(o=(oe=ke.trigger=J(oe||!0!==ae&&ae))&&oe._gsap&&oe._gsap.stRevert)&&o(ke),ae=!0===ae?oe:J(ae),ct(T)&&(T={targets:oe,className:T}),ae&&(!1===se||se===mt||(se=!(!se&&ae.parentNode&&ae.parentNode.style&&"flex"===nb(ae.parentNode).display)&&bt),ke.pin=ae,(n=Ne.core.getCache(ae)).spacer?U=n.pinState:(l&&((l=J(l))&&!l.nodeType&&(l=l.current||l.nativeElement),n.spacerIsNative=!!l,l&&(n.spacerState=kc(l))),n.spacer=V=l||Fe.createElement("div"),V.classList.add("pin-spacer"),a&&V.classList.add("pin-spacer-"+a),n.pinState=U=kc(ae)),!1!==P.force3D&&Ne.set(ae,{force3D:!0}),ke.spacer=V=n.spacer,r=nb(ae),m=r[se+he.os2],K=Ne.getProperty(ae),b=Ne.quickSetter(ae,he.a,xt),hc(ae,V,r),G=kc(ae)),we){e=Wa(we)?pb(we,wt):wt,q=Eb("scroller-start",a,be,he,e,0),N=Eb("scroller-end",a,be,he,e,0,q),t=q["offset"+he.op.d2];var u=J(z(be,"content")||be);Y=this.markerStart=Eb("start",a,u,he,e,t,0,de),H=this.markerEnd=Eb("end",a,u,he,e,t,0,de),de&&(S=Ne.quickSetter([Y,H],he.a,xt)),ye||Ye.length&&!0===z(be,"fixedMarkers")||(function _makePositionable(e){var t=nb(e).position;e.style.position="absolute"===t||"fixed"===t?t:"relative"}(me?We:be),Ne.set([q,N],{force3D:!0}),y=Ne.quickSetter(q,he.a,xt),x=Ne.quickSetter(N,he.a,xt))}if(de){var f=de.vars.onUpdate,d=de.vars.onUpdateParams;de.eventCallback("onUpdate",function(){ke.update(0,0,1),f&&f.apply(de,d||[])})}if(ke.previous=function(){return kt[kt.indexOf(ke)-1]},ke.next=function(){return kt[kt.indexOf(ke)+1]},ke.revert=function(e,t){if(!t)return ke.kill(!0);var r=!1!==e||!ke.enabled,n=Ke;r!==ke.isReverted&&(r&&(re=Math.max(Ae(),ke.scroll.rec||0),Oe=ke.progress,ne=O&&O.progress()),Y&&[Y,H,q,N].forEach(function(e){return e.style.display=r?"none":"block"}),r&&(Ke=ke).update(r),!ae||fe&&ke.isActive||(r?function _swapPinOut(e,t,r){Pt(r);var n=e._gsap;if(n.spacerIsNative)Pt(n.spacerState);else if(e._gsap.swappedIn){var i=t.parentNode;i&&(i.insertBefore(e,t),i.removeChild(t))}e._gsap.swappedIn=!1}(ae,V,U):hc(ae,V,nb(ae),Z)),r||ke.update(r),Ke=n,ke.isReverted=r)},ke.refresh=function(e,t,r,n){if(!Ke&&ke.enabled||t)if(ae&&e&&st)xb(ScrollTrigger,"scrollEnd",Pb);else{!rt&&Te&&Te(ke),Ke=ke,A.tween&&!r&&(A.tween.kill(),A.tween=0),ee&&ee.pause(),le&&O&&(O.revert({kill:!1}).invalidate(),O.getChildren&&O.getChildren(!0,!0,!1).forEach(function(e){return e.vars.immediateRender&&e.render(0,!0,!0)})),ke.isReverted||ke.revert(!0,!0),ke._subPinOffset=!1;var i,o,a,s,l,c,u,f,d,p,g,h,v,b=Ce(),m=Me(),y=de?de.duration():Ra(be,he),x=F<=.01||!F,_=0,w=n||0,S=Wa(r)?r.end:P.end,k=P.endTrigger||oe,T=Wa(r)?r.start:P.start||(0!==P.start&&oe?ae?"0 0":"0 100%":0),C=ke.pinnedContainer=P.pinnedContainer&&J(P.pinnedContainer,ke),M=oe&&Math.max(0,kt.indexOf(ke))||0,E=M;for(we&&Wa(r)&&(h=Ne.getProperty(q,he.p),v=Ne.getProperty(N,he.p));0<E--;)(c=kt[E]).end||c.refresh(0,1)||(Ke=ke),!(u=c.pin)||u!==oe&&u!==ae&&u!==C||c.isReverted||((p=p||[]).unshift(c),c.revert(!0,!0)),c!==kt[E]&&(M--,E--);for(Ua(T)&&(T=T(ke)),T=Da(T,"start",ke),B=nc(T,oe,b,he,Ae(),Y,q,ke,m,Se,ye,y,de,ke._startClamp&&"_startClamp")||(ae?-.001:0),Ua(S)&&(S=S(ke)),ct(S)&&!S.indexOf("+=")&&(~S.indexOf(" ")?S=(ct(T)?T.split(" ")[0]:"")+S:(_=Db(S.substr(2),b),S=ct(T)?T:(de?Ne.utils.mapRange(0,de.duration(),de.scrollTrigger.start,de.scrollTrigger.end,B):B)+_,k=oe)),S=Da(S,"end",ke),I=Math.max(B,nc(S||(k?"100% 0":y),k,b,he,Ae()+_,H,N,ke,m,Se,ye,y,de,ke._endClamp&&"_endClamp"))||-.001,_=0,E=M;E--;)(u=(c=kt[E]).pin)&&c.start-c._pinPush<=B&&!de&&0<c.end&&(i=c.end-(ke._startClamp?Math.max(0,c.start):c.start),(u===oe&&c.start-c._pinPush<B||u===C)&&isNaN(T)&&(_+=i*(1-c.progress)),u===ae&&(w+=i));if(B+=_,I+=_,ke._startClamp&&(ke._startClamp+=_),ke._endClamp&&!rt&&(ke._endClamp=I||-.001,I=Math.min(I,Ra(be,he))),F=I-B||(B-=.01)&&.001,x&&(Oe=Ne.utils.clamp(0,1,Ne.utils.normalize(B,I,re))),ke._pinPush=w,Y&&_&&((i={})[he.a]="+="+_,C&&(i[he.p]="-="+Ae()),Ne.set([Y,H],i)),!ae||et&&ke.end>=Ra(be,he)){if(oe&&Ae()&&!de)for(o=oe.parentNode;o&&o!==We;)o._pinOffset&&(B-=o._pinOffset,I-=o._pinOffset),o=o.parentNode}else i=nb(ae),s=he===qe,a=Ae(),Q=parseFloat(K(he.a))+w,!y&&1<I&&(g={style:g=(me?Fe.scrollingElement||Ue:be).style,value:g["overflow"+he.a.toUpperCase()]},me&&"scroll"!==nb(We)["overflow"+he.a.toUpperCase()]&&(g.style["overflow"+he.a.toUpperCase()]="scroll")),hc(ae,V,i),G=kc(ae),o=_t(ae,!0),f=ye&&L(be,s?He:qe)(),se?((Z=[se+he.os2,F+w+xt]).t=V,(E=se===bt?rb(ae,he)+F+w:0)&&(Z.push(he.d,E+xt),"auto"!==V.style.flexBasis&&(V.style.flexBasis=E+xt)),Pt(Z),C&&kt.forEach(function(e){e.pin===C&&!1!==e.vars.pinSpacing&&(e._subPinOffset=!0)}),ye&&Ae(re)):(E=rb(ae,he))&&"auto"!==V.style.flexBasis&&(V.style.flexBasis=E+xt),ye&&((l={top:o.top+(s?a-B:f)+xt,left:o.left+(s?f:a-B)+xt,boxSizing:"border-box",position:"fixed"})[ft]=l.maxWidth=Math.ceil(o.width)+xt,l[dt]=l.maxHeight=Math.ceil(o.height)+xt,l[mt]=l[mt+ht]=l[mt+pt]=l[mt+vt]=l[mt+gt]="0",l[bt]=i[bt],l[bt+ht]=i[bt+ht],l[bt+pt]=i[bt+pt],l[bt+vt]=i[bt+vt],l[bt+gt]=i[bt+gt],W=function _copyState(e,t,r){for(var n,i=[],o=e.length,a=r?8:0;a<o;a+=2)n=e[a],i.push(n,n in t?t[n]:e[a+1]);return i.t=e.t,i}(U,l,fe),rt&&Ae(0)),O?(d=O._initted,$e(1),O.render(O.duration(),!0,!0),j=K(he.a)-Q+F+w,$=1<Math.abs(F-j),ye&&$&&W.splice(W.length-2,2),O.render(0,!0,!0),d||O.invalidate(!0),O.parent||O.totalTime(O.totalTime()),$e(0)):j=F,g&&(g.value?g.style["overflow"+he.a.toUpperCase()]=g.value:g.style.removeProperty("overflow-"+he.a));p&&p.forEach(function(e){return e.revert(!1,!0)}),ke.start=B,ke.end=I,R=D=rt?re:Ae(),de||rt||(R<re&&Ae(re),ke.scroll.rec=0),ke.revert(!1,!0),Pe=at(),te&&(Ee=-1,te.restart(!0)),Ke=0,O&&ve&&(O._initted||ne)&&O.progress()!==ne&&O.progress(ne||0,!0).render(O.time(),!0,!0),(x||Oe!==ke.progress||de||le||O&&!O._initted)&&(O&&!ve&&(O._initted||Oe||!1!==O.vars.immediateRender)&&O.totalProgress(de&&B<-.001&&!Oe?Ne.utils.normalize(B,I,0):Oe,!0),ke.progress=x||(R-B)/F===Oe?0:Oe),ae&&se&&(V._pinOffset=Math.round(ke.progress*j)),ee&&ee.invalidate(),isNaN(h)||(h-=Ne.getProperty(q,he.p),v-=Ne.getProperty(N,he.p),rc(q,he,h),rc(Y,he,h-(n||0)),rc(N,he,v),rc(H,he,v-(n||0))),x&&!rt&&ke.update(),!ie||rt||X||(X=!0,ie(ke),X=!1)}},ke.getVelocity=function(){return(Ae()-D)/(at()-Ve)*1e3||0},ke.endAnimation=function(){Xa(ke.callbackAnimation),O&&(ee?ee.progress(1):O.paused()?ve||Xa(O,ke.direction<0,1):Xa(O,O.reversed()))},ke.labelToScroll=function(e){return O&&O.labels&&(B||ke.refresh()||B)+O.labels[e]/O.duration()*F||0},ke.getTrailing=function(t){var e=kt.indexOf(ke),r=0<ke.direction?kt.slice(0,e).reverse():kt.slice(e+1);return(ct(t)?r.filter(function(e){return e.vars.preventOverlaps===t}):r).filter(function(e){return 0<ke.direction?e.end<=B:e.start>=I})},ke.update=function(e,t,r){if(!de||r||e){var n,i,o,a,s,l,c,u=!0===rt?re:ke.scroll(),f=e?0:(u-B)/F,d=f<0?0:1<f?1:f||0,p=ke.progress;if(t&&(D=R,R=de?Ae():u,ue&&(w=_,_=O&&!ve?O.totalProgress():d)),E&&ae&&!Ke&&!ot&&st&&(!d&&B<u+(u-D)/(at()-Ve)*E?d=1e-4:1===d&&I>u+(u-D)/(at()-Ve)*E&&(d=.9999)),d!==p&&ke.enabled){if(a=(s=(n=ke.isActive=!!d&&d<1)!=(!!p&&p<1))||!!d!=!!p,ke.direction=p<d?1:-1,ke.progress=d,a&&!Ke&&(i=d&&!p?0:1===d?1:1===p?2:3,ve&&(o=!s&&"none"!==_e[i+1]&&_e[i+1]||_e[i],c=O&&("complete"===o||"reset"===o||o in O))),ge&&(s||c)&&(c||M||!O)&&(Ua(ge)?ge(ke):ke.getTrailing(ge).forEach(function(e){return e.endAnimation()})),ve||(!ee||Ke||ot?O&&O.totalProgress(d,!(!Ke||!Pe&&!e)):(ee._dp._time-ee._start!==ee._time&&ee.render(ee._dp._time-ee._start),ee.resetTo?ee.resetTo("totalProgress",d,O._tTime/O._tDur):(ee.vars.totalProgress=d,ee.invalidate().restart()))),ae)if(e&&se&&(V.style[se+he.os2]=m),ye){if(a){if(l=!e&&p<d&&u<I+1&&u+1>=Ra(be,he),fe)if(e||!n&&!l)pc(ae,V);else{var g=_t(ae,!0),h=u-B;pc(ae,We,g.top+(he===qe?h:0)+xt,g.left+(he===qe?0:h)+xt)}Pt(n||l?W:G),$&&d<1&&n||b(Q+(1!==d||l?0:j))}}else b(Ja(Q+j*d));!ue||A.tween||Ke||ot||te.restart(!0),T&&(s||ce&&d&&(d<1||!tt))&&Je(T.targets).forEach(function(e){return e.classList[n||ce?"add":"remove"](T.className)}),!k||ve||e||k(ke),a&&!Ke?(ve&&(c&&("complete"===o?O.pause().totalProgress(1):"reset"===o?O.restart(!0).pause():"restart"===o?O.restart(!0):O[o]()),k&&k(ke)),!s&&tt||(C&&s&&Ya(ke,C),xe[i]&&Ya(ke,xe[i]),ce&&(1===d?ke.kill(!1,1):xe[i]=0),s||xe[i=1===d?1:3]&&Ya(ke,xe[i])),pe&&!n&&Math.abs(ke.getVelocity())>(Va(pe)?pe:2500)&&(Xa(ke.callbackAnimation),ee?ee.progress(1):Xa(O,"reverse"===o?1:!d,1))):ve&&k&&!Ke&&k(ke)}if(x){var v=de?u/de.duration()*(de._caScrollDist||0):u;y(v+(q._isFlipped?1:0)),x(v)}S&&S(-u/de.duration()*(de._caScrollDist||0))}},ke.enable=function(e,t){ke.enabled||(ke.enabled=!0,xb(be,"resize",Mb),me||xb(be,"scroll",Kb),Te&&xb(ScrollTrigger,"refreshInit",Te),!1!==e&&(ke.progress=Oe=0,R=D=Ee=Ae()),!1!==t&&ke.refresh())},ke.getTween=function(e){return e&&A?A.tween:ee},ke.setPositions=function(e,t,r,n){if(de){var i=de.scrollTrigger,o=de.duration(),a=i.end-i.start;e=i.start+a*e/o,t=i.start+a*t/o}ke.refresh(!1,!1,{start:Ea(e,r&&!!ke._startClamp),end:Ea(t,r&&!!ke._endClamp)},n),ke.update()},ke.adjustPinSpacing=function(e){if(Z&&e){var t=Z.indexOf(he.d)+1;Z[t]=parseFloat(Z[t])+e+xt,Z[1]=parseFloat(Z[1])+e+xt,Pt(Z)}},ke.disable=function(e,t){if(ke.enabled&&(!1!==e&&ke.revert(!0,!0),ke.enabled=ke.isActive=!1,t||ee&&ee.pause(),re=0,n&&(n.uncache=1),Te&&yb(ScrollTrigger,"refreshInit",Te),te&&(te.pause(),A.tween&&A.tween.kill()&&(A.tween=0)),!me)){for(var r=kt.length;r--;)if(kt[r].scroller===be&&kt[r]!==ke)return;yb(be,"resize",Mb),me||yb(be,"scroll",Kb)}},ke.kill=function(e,t){ke.disable(e,t),ee&&!t&&ee.kill(),a&&delete Tt[a];var r=kt.indexOf(ke);0<=r&&kt.splice(r,1),r===je&&0<Et&&je--,r=0,kt.forEach(function(e){return e.scroller===ke.scroller&&(r=1)}),r||rt||(ke.scroll.rec=0),O&&(O.scrollTrigger=null,e&&O.revert({kill:!1}),t||O.kill()),Y&&[Y,H,q,N].forEach(function(e){return e.parentNode&&e.parentNode.removeChild(e)}),it===ke&&(it=0),ae&&(n&&(n.uncache=1),r=0,kt.forEach(function(e){return e.pin===ae&&r++}),r||(n.spacer=0)),P.onKill&&P.onKill(ke)},kt.push(ke),ke.enable(!1,!1),o&&o(ke),O&&O.add&&!F){var v=ke.update;ke.update=function(){ke.update=v,ze.cache++,B||I||ke.refresh()},Ne.delayedCall(.01,ke.update),F=.01,B=I=0}else ke.refresh();ae&&function _queueRefreshAll(){if(nt!==Ct){var e=nt=Ct;requestAnimationFrame(function(){return e===Ct&&Mt(!0)})}}()}else this.update=this.refresh=this.kill=Ia},ScrollTrigger.register=function register(e){return s||(Ne=e||La(),Ka()&&window.document&&ScrollTrigger.enable(),s=lt),s},ScrollTrigger.defaults=function defaults(e){if(e)for(var t in e)St[t]=e[t];return St},ScrollTrigger.disable=function disable(t,r){lt=0,kt.forEach(function(e){return e[r?"kill":"disable"](t)}),yb(Xe,"wheel",Kb),yb(Fe,"scroll",Kb),clearInterval(u),yb(Fe,"touchcancel",Ia),yb(We,"touchstart",Ia),wb(yb,Fe,"pointerdown,touchstart,mousedown",Ga),wb(yb,Fe,"pointerup,touchend,mouseup",Ha),c.kill(),Sa(yb);for(var e=0;e<ze.length;e+=3)zb(yb,ze[e],ze[e+1]),zb(yb,ze[e],ze[e+2])},ScrollTrigger.enable=function enable(){if(Xe=window,Fe=document,Ue=Fe.documentElement,We=Fe.body,Ne&&(Je=Ne.utils.toArray,Ge=Ne.utils.clamp,x=Ne.core.context||Ia,$e=Ne.core.suppressOverwrites||Ia,_=Xe.history.scrollRestoration||"auto",j=Xe.pageYOffset||0,Ne.core.globals("ScrollTrigger",ScrollTrigger),We)){lt=1,(w=document.createElement("div")).style.height="100vh",w.style.position="absolute",Zb(),function _rafBugFix(){return lt&&requestAnimationFrame(_rafBugFix)}(),E.register(Ne),ScrollTrigger.isTouch=E.isTouch,R=E.isTouch&&/(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent),b=1===E.isTouch,xb(Xe,"wheel",Kb),l=[Xe,Fe,Ue,We],Ne.matchMedia?(ScrollTrigger.matchMedia=function(e){var t,r=Ne.matchMedia();for(t in e)r.add(t,e[t]);return r},Ne.addEventListener("matchMediaInit",function(){return Tb()}),Ne.addEventListener("matchMediaRevert",function(){return Sb()}),Ne.addEventListener("matchMedia",function(){Mt(0,1),V("matchMedia")}),Ne.matchMedia().add("(orientation: portrait)",function(){return Lb(),Lb})):console.warn("Requires GSAP 3.11.0 or later"),Lb(),xb(Fe,"scroll",Kb);var e,t,r=We.hasAttribute("style"),n=We.style,i=n.borderTopStyle,o=Ne.core.Animation.prototype;for(o.revert||Object.defineProperty(o,"revert",{value:function value(){return this.time(-.01,!0)}}),n.borderTopStyle="solid",e=_t(We),qe.m=Math.round(e.top+qe.sc())||0,He.m=Math.round(e.left+He.sc())||0,i?n.borderTopStyle=i:n.removeProperty("border-top-style"),r||(We.setAttribute("style",""),We.removeAttribute("style")),u=setInterval(Jb,250),Ne.delayedCall(.5,function(){return ot=0}),xb(Fe,"touchcancel",Ia),xb(We,"touchstart",Ia),wb(xb,Fe,"pointerdown,touchstart,mousedown",Ga),wb(xb,Fe,"pointerup,touchend,mouseup",Ha),f=Ne.utils.checkPrefix("transform"),ee.push(f),s=at(),c=Ne.delayedCall(.2,Mt).pause(),g=[Fe,"visibilitychange",function(){var e=Xe.innerWidth,t=Xe.innerHeight;Fe.hidden?(d=e,p=t):d===e&&p===t||Mb()},Fe,"DOMContentLoaded",Mt,Xe,"load",Mt,Xe,"resize",Mb],Sa(xb),kt.forEach(function(e){return e.enable(0,1)}),t=0;t<ze.length;t+=3)zb(yb,ze[t],ze[t+1]),zb(yb,ze[t],ze[t+2])}},ScrollTrigger.config=function config(e){"limitCallbacks"in e&&(tt=!!e.limitCallbacks);var t=e.syncInterval;t&&clearInterval(u)||(u=t)&&setInterval(Jb,t),"ignoreMobileResize"in e&&(b=1===ScrollTrigger.isTouch&&e.ignoreMobileResize),"autoRefreshEvents"in e&&(Sa(yb)||Sa(xb,e.autoRefreshEvents||"none"),h=-1===(e.autoRefreshEvents+"").indexOf("resize"))},ScrollTrigger.scrollerProxy=function scrollerProxy(e,t){var r=J(e),n=ze.indexOf(r),i=Ma(r);~n&&ze.splice(n,i?6:2),t&&(i?Ye.unshift(Xe,t,We,t,Ue,t):Ye.unshift(r,t))},ScrollTrigger.clearMatchMedia=function clearMatchMedia(t){kt.forEach(function(e){return e._ctx&&e._ctx.query===t&&e._ctx.kill(!0,!0)})},ScrollTrigger.isInViewport=function isInViewport(e,t,r){var n=(ct(e)?J(e):e).getBoundingClientRect(),i=n[r?ft:dt]*t||0;return r?0<n.right-i&&n.left+i<Xe.innerWidth:0<n.bottom-i&&n.top+i<Xe.innerHeight},ScrollTrigger.positionInViewport=function positionInViewport(e,t,r){ct(e)&&(e=J(e));var n=e.getBoundingClientRect(),i=n[r?ft:dt],o=null==t?i/2:t in q?q[t]*i:~t.indexOf("%")?parseFloat(t)*i/100:parseFloat(t)||0;return r?(n.left+o)/Xe.innerWidth:(n.top+o)/Xe.innerHeight},ScrollTrigger.killAll=function killAll(e){if(kt.slice(0).forEach(function(e){return"ScrollSmoother"!==e.vars.id&&e.kill()}),!0!==e){var t=U.killAll||[];U={},t.forEach(function(e){return e()})}},ScrollTrigger);function ScrollTrigger(e,t){s||ScrollTrigger.register(Ne)||console.warn("Please gsap.registerPlugin(ScrollTrigger)"),x(this),this.init(e,t)}ne.version="3.13.0",ne.saveStyles=function(e){return e?Je(e).forEach(function(e){if(e&&e.style){var t=K.indexOf(e);0<=t&&K.splice(t,5),K.push(e,e.style.cssText,e.getBBox&&e.getAttribute("transform"),Ne.core.getCache(e),x())}}):K},ne.revert=function(e,t){return Tb(!e,t)},ne.create=function(e,t){return new ne(e,t)},ne.refresh=function(e){return e?Mb(!0):(s||ne.register())&&Mt(!0)},ne.update=function(e){return++ze.cache&&Z(!0===e?2:0)},ne.clearScrollMemory=Ub,ne.maxScroll=function(e,t){return Ra(e,t?He:qe)},ne.getScrollFunc=function(e,t){return L(J(e),t?He:qe)},ne.getById=function(e){return Tt[e]},ne.getAll=function(){return kt.filter(function(e){return"ScrollSmoother"!==e.vars.id})},ne.isScrolling=function(){return!!st},ne.snapDirectional=ub,ne.addEventListener=function(e,t){var r=U[e]||(U[e]=[]);~r.indexOf(t)||r.push(t)},ne.removeEventListener=function(e,t){var r=U[e],n=r&&r.indexOf(t);0<=n&&r.splice(n,1)},ne.batch=function(e,t){function Jp(e,t){var r=[],n=[],i=Ne.delayedCall(o,function(){t(r,n),r=[],n=[]}).pause();return function(e){r.length||i.restart(!0),r.push(e.trigger),n.push(e),a<=r.length&&i.progress(1)}}var r,n=[],i={},o=t.interval||.016,a=t.batchMax||1e9;for(r in t)i[r]="on"===r.substr(0,2)&&Ua(t[r])&&"onRefreshInit"!==r?Jp(0,t[r]):t[r];return Ua(a)&&(a=a(),xb(ne,"refresh",function(){return a=t.batchMax()})),Je(e).forEach(function(e){var t={};for(r in i)t[r]=i[r];t.trigger=e,n.push(ne.create(t))}),n};function uc(e,t,r,n){return n<t?e(n):t<0&&e(0),n<r?(n-t)/(r-t):r<0?t/(t-r):1}function vc(e,t){!0===t?e.style.removeProperty("touch-action"):e.style.touchAction=!0===t?"auto":t?"pan-"+t+(E.isTouch?" pinch-zoom":""):"none",e===Ue&&vc(We,t)}function xc(e){var t,r=e.event,n=e.target,i=e.axis,o=(r.changedTouches?r.changedTouches[0]:r).target,a=o._gsap||Ne.core.getCache(o),s=at();if(!a._isScrollT||2e3<s-a._isScrollT){for(;o&&o!==We&&(o.scrollHeight<=o.clientHeight&&o.scrollWidth<=o.clientWidth||!oe[(t=nb(o)).overflowY]&&!oe[t.overflowX]);)o=o.parentNode;a._isScroll=o&&o!==n&&!Ma(o)&&(oe[(t=nb(o)).overflowY]||oe[t.overflowX]),a._isScrollT=s}!a._isScroll&&"x"!==i||(r.stopPropagation(),r._gsapAllow=!0)}function yc(e,t,r,n){return E.create({target:e,capture:!0,debounce:!1,lockAxis:!0,type:t,onWheel:n=n&&xc,onPress:n,onDrag:n,onScroll:n,onEnable:function onEnable(){return r&&xb(Fe,E.eventTypes[0],se,!1,!0)},onDisable:function onDisable(){return yb(Fe,E.eventTypes[0],se,!0)}})}function Cc(e){function Gq(){return i=!1}function Jq(){o=Ra(p,qe),T=Ge(R?1:0,o),f&&(k=Ge(0,Ra(p,He))),l=Ct}function Kq(){v._gsap.y=Ja(parseFloat(v._gsap.y)+b.offset)+"px",v.style.transform="matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, "+parseFloat(v._gsap.y)+", 0, 1)",b.offset=b.cacheID=0}function Qq(){Jq(),a.isActive()&&a.vars.scrollY>o&&(b()>o?a.progress(1)&&b(o):a.resetTo("scrollY",o))}Wa(e)||(e={}),e.preventDefault=e.isNormalizer=e.allowClicks=!0,e.type||(e.type="wheel,touch"),e.debounce=!!e.debounce,e.id=e.id||"normalizer";var n,o,l,i,a,c,u,s,f=e.normalizeScrollX,t=e.momentum,r=e.allowNestedScroll,d=e.onRelease,p=J(e.target)||Ue,g=Ne.core.globals().ScrollSmoother,h=g&&g.get(),v=R&&(e.content&&J(e.content)||h&&!1!==e.content&&!h.smooth()&&h.content()),b=L(p,qe),m=L(p,He),y=1,x=(E.isTouch&&Xe.visualViewport?Xe.visualViewport.scale*Xe.visualViewport.width:Xe.outerWidth)/Xe.innerWidth,_=0,w=Ua(t)?function(){return t(n)}:function(){return t||2.8},S=yc(p,e.type,!0,r),k=Ia,T=Ia;return v&&Ne.set(v,{y:"+=0"}),e.ignoreCheck=function(e){return R&&"touchmove"===e.type&&function ignoreDrag(){if(i){requestAnimationFrame(Gq);var e=Ja(n.deltaY/2),t=T(b.v-e);if(v&&t!==b.v+b.offset){b.offset=t-b.v;var r=Ja((parseFloat(v&&v._gsap.y)||0)-b.offset);v.style.transform="matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, "+r+", 0, 1)",v._gsap.y=r+"px",b.cacheID=ze.cache,Z()}return!0}b.offset&&Kq(),i=!0}()||1.05<y&&"touchstart"!==e.type||n.isGesturing||e.touches&&1<e.touches.length},e.onPress=function(){i=!1;var e=y;y=Ja((Xe.visualViewport&&Xe.visualViewport.scale||1)/x),a.pause(),e!==y&&vc(p,1.01<y||!f&&"x"),c=m(),u=b(),Jq(),l=Ct},e.onRelease=e.onGestureStart=function(e,t){if(b.offset&&Kq(),t){ze.cache++;var r,n,i=w();f&&(n=(r=m())+.05*i*-e.velocityX/.227,i*=uc(m,r,n,Ra(p,He)),a.vars.scrollX=k(n)),n=(r=b())+.05*i*-e.velocityY/.227,i*=uc(b,r,n,Ra(p,qe)),a.vars.scrollY=T(n),a.invalidate().duration(i).play(.01),(R&&a.vars.scrollY>=o||o-1<=r)&&Ne.to({},{onUpdate:Qq,duration:i})}else s.restart(!0);d&&d(e)},e.onWheel=function(){a._ts&&a.pause(),1e3<at()-_&&(l=0,_=at())},e.onChange=function(e,t,r,n,i){if(Ct!==l&&Jq(),t&&f&&m(k(n[2]===t?c+(e.startX-e.x):m()+t-n[1])),r){b.offset&&Kq();var o=i[2]===r,a=o?u+e.startY-e.y:b()+r-i[1],s=T(a);o&&a!==s&&(u+=s-a),b(s)}(r||t)&&Z()},e.onEnable=function(){vc(p,!f&&"x"),ne.addEventListener("refresh",Qq),xb(Xe,"resize",Qq),b.smooth&&(b.target.style.scrollBehavior="auto",b.smooth=m.smooth=!1),S.enable()},e.onDisable=function(){vc(p,!0),yb(Xe,"resize",Qq),ne.removeEventListener("refresh",Qq),S.kill()},e.lockAxis=!1!==e.lockAxis,((n=new E(e)).iOS=R)&&!b()&&b(1),R&&Ne.ticker.add(Ia),s=n._dc,a=Ne.to(n,{ease:"power4",paused:!0,inherit:!1,scrollX:f?"+=0.1":"+=0",scrollY:"+=0.1",modifiers:{scrollY:qc(b,b(),function(){return a.pause()})},onUpdate:Z,onComplete:s.vars.onComplete}),n}var ie,oe={auto:1,scroll:1},ae=/(input|label|select|textarea)/i,se=function _captureInputs(e){var t=ae.test(e.target.tagName);(t||ie)&&(e._gsapAllow=!0,ie=t)};ne.sort=function(e){if(Ua(e))return kt.sort(e);var t=Xe.pageYOffset||0;return ne.getAll().forEach(function(e){return e._sortY=e.trigger?t+e.trigger.getBoundingClientRect().top:e.start+Xe.innerHeight}),kt.sort(e||function(e,t){return-1e6*(e.vars.refreshPriority||0)+(e.vars.containerAnimation?1e6:e._sortY)-((t.vars.containerAnimation?1e6:t._sortY)+-1e6*(t.vars.refreshPriority||0))})},ne.observe=function(e){return new E(e)},ne.normalizeScroll=function(e){if(void 0===e)return v;if(!0===e&&v)return v.enable();if(!1===e)return v&&v.kill(),void(v=e);var t=e instanceof E?e:Cc(e);return v&&v.target===t.target&&v.kill(),Ma(t.target)&&(v=t),t},ne.core={_getVelocityProp:M,_inputObserver:yc,_scrollers:ze,_proxies:Ye,bridge:{ss:function ss(){st||V("scrollStart"),st=at()},ref:function ref(){return Ke}}},La()&&Ne.registerPlugin(ne),e.ScrollTrigger=ne,e.default=ne;if (typeof(window)==="undefined"||window!==e){Object.defineProperty(e,"__esModule",{value:!0})} else {delete e.default}});

// Bucketed via an externally-set cookie (e.g. VWO). variantIdB is a plain numeric Shopify variant id, not a gid:// string.
// One shared cookie covers all 4 Carver colors; each has its own hidden variantIdB, so priceB is hardcoded (not auto-derivable).
// FIXME: remove after test
window.MERCHANDISING_TESTS = [
  { cookieName: '_merchandising_test', colorClass: 'carver-gravel', variantIdB: 45291746394247, priceB: 169 },
  { cookieName: '_merchandising_test', colorClass: 'carver-sea-salt', variantIdB: 45291868684423, priceB: 169 },
  { cookieName: '_merchandising_test', colorClass: 'carver-mat', variantIdB: 45291874877575, priceB: 199 },
  { cookieName: '_merchandising_test', colorClass: 'carver-clay-mat', variantIdB: 45291876319367, priceB: 199 },
];

// Airbrake itself can be unavailable (e.g. blocked by an ad-blocker) - never let reporting an
// error be the thing that throws inside code whose whole job is to never throw.
function safeAirbrakeNotify(notice) {
  try {
    if (typeof airbrake !== 'undefined' && airbrake) airbrake.notify(notice);
  } catch (e) {
    // Nothing more we can safely do here.
  }
}

// US-only: variantIdB values are Shopify variant ids from the US store and don't exist on other regions' stores.
// (localhost/staging.pushd.com carved out for local testing, matching locale.js's own LOCAL_HOSTS handling)
// Self-contained cookie parsing (not frame-selector.js's getCookie) because this runs during
// frame-selector.js's own await window.fetchAllFrameDetails(), before it's exposed to window.
// Called many times per page load (per test entry x multiple call sites), so dedupe Airbrake
// reports per cookie name - a persistently-malformed value shouldn't fire on every call.
var reportedMalformedCookies = {};
function getPricingTestCookie(name) {
  var host = window.location.hostname;
  var isLocalHost = host === 'localhost' || host === 'staging.pushd.com';
  if (!isLocalHost && !host.endsWith(window.Locale.COUNTRY_LOCALE_CONFIG.US.domain)) return null;

  const cookies = document.cookie.split('; ');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].split('=');
    if (cookie[0] === name) {
      try {
        return decodeURIComponent(cookie[1]);
      } catch (e) {
        if (!reportedMalformedCookies[name]) {
          reportedMalformedCookies[name] = true;
          safeAirbrakeNotify({ error: 'Malformed merchandising test cookie value', params: { name: name, message: e.message } });
        }
        return null;
      }
    }
  }
  return null;
}

function getMerchandisingTests() {
  return window.MERCHANDISING_TESTS || [];
}

// Only one of these is ever set at a time.
var VWO_EXP_265_COMBI_COOKIE_NAMES = ['_vis_opt_exp_265_combi', 'debug_vis_opt_exp_265_combi'];
var VWO_EXP_265_CONTROL_VARIANT = '1';
var VWO_EXP_265_TARGET_VARIANT = '2';

// Explicit control check - wins if live/debug cookies disagree.
function isVwoExp265Variant2() {
  // Paused 2026-08-17 - remove this line to resume the test.
  return false;

  var combiValues = VWO_EXP_265_COMBI_COOKIE_NAMES.map(function (name) {
    return getPricingTestCookie(name);
  });
  if (combiValues.includes(VWO_EXP_265_CONTROL_VARIANT)) return false;
  return combiValues.includes(VWO_EXP_265_TARGET_VARIANT);
}

// Passed in to avoid re-parsing cookies per test entry.
function isMerchandisingTestActive(test, vwoVariantMatches) {
  return !!getPricingTestCookie(test.cookieName) && vwoVariantMatches;
}

// Captures original ids before override; frame-selector.js reads this for cart checks.
window.MERCHANDISING_TEST_ORIGINAL_VARIANT_IDS = window.MERCHANDISING_TEST_ORIGINAL_VARIANT_IDS || {};
function captureOriginalVariantIds() {
  getMerchandisingTests().forEach(function (test) {
    var frame = window.frameDetailsByColor && window.frameDetailsByColor[test.colorClass];
    if (frame && window.MERCHANDISING_TEST_ORIGINAL_VARIANT_IDS[test.colorClass] === undefined) {
      window.MERCHANDISING_TEST_ORIGINAL_VARIANT_IDS[test.colorClass] = frame.shopifyId;
    }
  });
}

function applyPricingTestOverrides() {
  captureOriginalVariantIds();
  var vwoVariantMatches = isVwoExp265Variant2();
  getMerchandisingTests().forEach(function (test) {
    if (!isMerchandisingTestActive(test, vwoVariantMatches)) return;
    var frame = window.frameDetailsByColor[test.colorClass];
    if (!frame) return;

    var priceB = test.priceB;
    var originalPriceB = test.originalPriceB;
    if (priceB == null) {
      var sourceFrame = (window.frameDetailsCache || []).find(function (f) {
        return f && parseInt(f.shopifyId) === parseInt(test.variantIdB);
      });
      if (sourceFrame) {
        priceB = sourceFrame.price;
        originalPriceB = sourceFrame.originalPrice;
      }
    }
    if (priceB == null) return;

    frame.shopifyId = test.variantIdB;
    frame.price = priceB;
    if (originalPriceB) frame.originalPrice = originalPriceB;
  });
}

// VWO writes its cookie async and could bucket the visitor at any point during the visit, not just
// shortly after load - nothing else re-checks after the initial page-load pass. Uses the CookieStore
// API (event-driven, no polling) where available, falling back to polling on older browsers.
function retryPricingTestForLateCookie() {
  try {
    setUpRetryPricingTestForLateCookie();
  } catch (e) {
    safeAirbrakeNotify({ error: 'Error setting up merchandising test retry', params: { message: e.message } });
  }
}

function setUpRetryPricingTestForLateCookie() {
  var isActive = getMerchandisingTests().some(function (test) {
    return isMerchandisingTestActive(test, isVwoExp265Variant2());
  });
  if (isActive) return;

  // Report at most once per page load per path - avoids spamming Airbrake once per tick/event
  // if something's actually broken, while still surfacing that it happened at all.
  var hasReportedError = false;
  function reportErrorOnce(context, e) {
    if (hasReportedError) return;
    hasReportedError = true;
    safeAirbrakeNotify({ error: 'Error in merchandising test retry (' + context + ')', params: { message: e.message } });
  }

  function applyIfNowActive() {
    var nowActive = getMerchandisingTests().some(function (test) {
      return isMerchandisingTestActive(test, isVwoExp265Variant2());
    });
    if (!nowActive) return false;
    applyPricingTestOverrides();
    refreshPricingTestPriceIfActive();
    refreshPricingTestGridPrices();
    if (window.clearCartIfHoldingPricingTestVariant) {
      window.clearCartIfHoldingPricingTestVariant().catch(function (e) {
        reportErrorOnce('clearing cart for merchandising test', e);
      });
    }
    return true;
  }

  if (window.cookieStore !== undefined) {
    var cookieNames = getMerchandisingTests().map(function (test) { return test.cookieName; })
      .concat(VWO_EXP_265_COMBI_COOKIE_NAMES);
    var onChange = function (event) {
      try {
        var isRelevant = (event.changed || []).concat(event.deleted || []).some(function (c) {
          return cookieNames.includes(c.name);
        });
        if (isRelevant && applyIfNowActive()) {
          window.cookieStore.removeEventListener('change', onChange);
        }
      } catch (e) {
        reportErrorOnce('cookieStore change handler', e);
        window.cookieStore.removeEventListener('change', onChange);
      }
    };
    window.cookieStore.addEventListener('change', onChange);
  } else {
    // No CookieStore support (older Safari/Firefox) - poll instead, capped at 10s so a visitor
    // who never gets bucketed doesn't leave a timer running for their whole time on page.
    var pollStart = Date.now();
    var maxPollMs = 10000;
    var interval = setInterval(function () {
      try {
        if (applyIfNowActive() || Date.now() - pollStart >= maxPollMs) {
          clearInterval(interval);
        }
      } catch (e) {
        reportErrorOnce('fallback poll', e);
        clearInterval(interval);
      }
    }, 300);
  }
}

// Grid tiles, cart upsell items, and the mobile hamburger nav's color list, where price text needs swapping for a tested color.
var PRICE_DISPLAY_SELECTORS = [
  { price: '.action--shop-frames-price', strike: '.action--shop-frames-price-strike', strikeWrapper: '.action--shop-frames-price-strike-wrapper' },
  { price: '.action--cart-upsell-price', strike: null, strikeWrapper: null },
  { price: '.action--nav-shop-frames-price', strike: '.action--nav-shop-frames-price-strike', strikeWrapper: '.action--nav-shop-frames-price-strike-wrapper' },
];

var ALL_PRICE_SELECTORS = ['.frameInfo-price-value'].concat(PRICE_DISPLAY_SELECTORS.map(function (s) { return s.price; }));

// Every price display always gets a skeleton, tested or not - reveal them all together after any real swap.
function revealPriceSkeletons() {
  ALL_PRICE_SELECTORS.forEach(function (selector) {
    document.querySelectorAll(selector + '[data-skeleton]').forEach(function (el) {
      el.setAttribute('data-skeleton', 'loaded');
    });
  });
}

// Forces a PDP price re-render, since nothing else does this on load.
function refreshPricingTestPriceIfActive() {
  var vwoVariantMatches = isVwoExp265Variant2();
  var isTestActive = getMerchandisingTests().some(function (test) {
    return test.colorClass === window.getActiveFrame() && isMerchandisingTestActive(test, vwoVariantMatches);
  });
  if (isTestActive) {
    window.renderPricingLogic();
  }
  revealPriceSkeletons();
}

function refreshPricingTestGridPrices() {
  var vwoVariantMatches = isVwoExp265Variant2();
  getMerchandisingTests().forEach(function (test) {
    if (!isMerchandisingTestActive(test, vwoVariantMatches)) return;

    var frameDetails = window.getFrameDetailsByColor(test.colorClass);
    if (frameDetails && frameDetails.price != null) {
      var currencySymbol = window.getCurrencySymbol();
      PRICE_DISPLAY_SELECTORS.forEach(function (selectors) {
        window.replaceInnerHTML(selectors.price + '[data-color="' + test.colorClass + '"]', currencySymbol + frameDetails.price, false);
        if (frameDetails.originalPrice && selectors.strike) {
          window.removeHide(selectors.strikeWrapper);
          window.replaceInnerHTML(selectors.strike + '[data-color="' + test.colorClass + '"]', currencySymbol + frameDetails.originalPrice, false);
        }
      });
    }
  });
  revealPriceSkeletons();
}
;
// Free MCF shipping upgraded from Amazon Standard to Amazon Expedited for US orders, bucketed by VWO.
//
// The server half lives in lib/shipping_speed_test.rb. The two agree on the line item property name
// and on the literal 'amazon_expedited', so neither can be renamed without the other: the property
// is what Advanced Shipping Rules and the Shopify order carry, and it is the only thing that tells
// fulfillment to buy the speed we quoted.
//
// Bucketing lives entirely in VWO. The campaign's variations set the cookie below -- 'variant' in
// the treatment arm, 'control' in the other -- and nothing here knows the campaign id. That means
// starting, pausing and re-running the test are all VWO changes rather than deploys, and it keeps
// our cookie clear of `expireInactiveVWOCookies`, which sweeps VWO's own `_vis_opt_exp_<id>_*`
// cookies by id. Precedent: `_merchandising_test`, `_upsell_checkout_test` and
// `_fast_shipping_copy_test` are all read here and set from VWO the same way.
//
// FIXME: remove after test
window.SHIPPING_SPEED_TEST = {
  // set by the VWO campaign's variation JS. No cookie at all means the visitor isn't in the test.
  cookieName: '_expedited_shipping_test',
  variantValue: 'variant',
  controlValue: 'control',
  // must match ShippingSpeedTest::LINE_ITEM_PROPERTY
  lineItemProperty: '_shipping_speed_test',
  // must match ShippingSpeedTest::ASSIGNED_BUCKET_ATTRIBUTE
  bucketAttribute: '_shipping_speed_test_bucket',
  // must match a value in ShippingSpeedTest::FORCEABLE_SPEEDS
  speed: 'amazon_expedited'
};

// Airbrake can be unavailable (ad-blockers), so never let reporting an error be the thing that
// throws inside code whose job is to never throw.
function safeShippingSpeedTestNotify(notice) {
  try {
    if (typeof airbrake !== 'undefined' && airbrake) airbrake.notify(notice);
  } catch (e) {
    // nothing more we can safely do here
  }
}

// US only: the test forces a US Amazon fulfillment speed, and the server ignores the marker on
// orders shipping anywhere else. (localhost/staging carved out for local testing, matching how
// pricing-tests.js handles the same problem.)
var reportedShippingSpeedTestCookieProblems = {};
function reportShippingSpeedTestProblemOnce(key, notice) {
  if (reportedShippingSpeedTestCookieProblems[key]) return;
  reportedShippingSpeedTestCookieProblems[key] = true;
  safeShippingSpeedTestNotify(notice);
}

function shippingSpeedTestCookie() {
  var host = window.location.hostname;
  var isLocalHost = host === 'localhost' || host === 'staging.pushd.com';
  try {
    if (!isLocalHost && !host.endsWith(window.Locale.COUNTRY_LOCALE_CONFIG.US.domain)) return null;
  } catch (e) {
    return null;
  }

  var name = window.SHIPPING_SPEED_TEST.cookieName;
  var cookies = document.cookie.split('; ');
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].split('=');
    if (cookie[0] === name) {
      try {
        return decodeURIComponent(cookie[1]);
      } catch (e) {
        reportShippingSpeedTestProblemOnce('malformed', {
          error: 'Malformed shipping speed test cookie value',
          params: { name: name, message: e.message }
        });
        return null;
      }
    }
  }
  return null;
}

// 'variant', 'control', or null for a visitor who isn't in the campaign. An unrecognised value is
// treated as control, but reported: that shape means the VWO variation JS is setting something we
// don't expect, which would otherwise disable the test silently.
function shippingSpeedTestBucket() {
  var value = shippingSpeedTestCookie();
  if (!value) return null;

  value = value.trim();
  if (value === window.SHIPPING_SPEED_TEST.variantValue) return window.SHIPPING_SPEED_TEST.variantValue;
  if (value === window.SHIPPING_SPEED_TEST.controlValue) return window.SHIPPING_SPEED_TEST.controlValue;

  reportShippingSpeedTestProblemOnce('unrecognised', {
    error: 'Unrecognised shipping speed test cookie value',
    params: { name: window.SHIPPING_SPEED_TEST.cookieName, value: value }
  });
  return window.SHIPPING_SPEED_TEST.controlValue;
}
window.shippingSpeedTestBucket = shippingSpeedTestBucket;

function isShippingSpeedTestVariant() {
  return shippingSpeedTestBucket() === window.SHIPPING_SPEED_TEST.variantValue;
}
window.isShippingSpeedTestVariant = isShippingSpeedTestVariant;

// The speed the variant should quote, or null for control and for every non-US visitor.
window.shippingSpeedTestSpeedKey = function () {
  return isShippingSpeedTestVariant() ? window.SHIPPING_SPEED_TEST.speed : null;
};

// Stamped on every cart line. Prefixed with _ so it stays hidden in checkout.
window.shippingSpeedTestLineAttributes = function () {
  if (!isShippingSpeedTestVariant()) return [];
  return [{ key: window.SHIPPING_SPEED_TEST.lineItemProperty, value: window.SHIPPING_SPEED_TEST.speed }];
};

// Recorded on the order for analysis. Unlike the line property this is written for both arms:
// the control rows are what the variant gets compared against.
window.shippingSpeedTestCartAttributes = function () {
  var bucket = shippingSpeedTestBucket();
  if (!bucket) return [];
  return [{ key: window.SHIPPING_SPEED_TEST.bucketAttribute, value: bucket }];
};

// VWO applies its campaigns async and can bucket a visitor at any point in the visit, so a page
// that rendered as control may need to re-render once the cookie lands. Uses CookieStore where
// available (event driven), polling elsewhere, capped so a never-bucketed visitor doesn't leave a
// timer running for their whole session.
window.onShippingSpeedTestBucketed = function (callback) {
  try {
    if (isShippingSpeedTestVariant()) return;

    var name = window.SHIPPING_SPEED_TEST.cookieName;

    function applyIfNowVariant() {
      if (!isShippingSpeedTestVariant()) return false;
      callback();
      return true;
    }

    if (window.cookieStore !== undefined) {
      var onChange = function (event) {
        try {
          var isRelevant = (event.changed || []).concat(event.deleted || []).some(function (c) {
            return c.name === name;
          });
          if (isRelevant && applyIfNowVariant()) {
            window.cookieStore.removeEventListener('change', onChange);
          }
        } catch (e) {
          reportShippingSpeedTestProblemOnce('retry', { error: 'Error in shipping speed test retry (cookieStore change handler)', params: { message: e.message } });
          window.cookieStore.removeEventListener('change', onChange);
        }
      };
      window.cookieStore.addEventListener('change', onChange);
    } else {
      var pollStart = Date.now();
      var maxPollMs = 10000;
      var interval = setInterval(function () {
        try {
          if (applyIfNowVariant() || Date.now() - pollStart >= maxPollMs) {
            clearInterval(interval);
          }
        } catch (e) {
          reportShippingSpeedTestProblemOnce('retry', { error: 'Error in shipping speed test retry (fallback poll)', params: { message: e.message } });
          clearInterval(interval);
        }
      }, 300);
    }
  } catch (e) {
    safeShippingSpeedTestNotify({ error: 'Error setting up shipping speed test retry', params: { message: e.message } });
  }
};
// ===============================
// Frame details cache (page session)
// ===============================
window.frameDetailsCache = null;
window.frameDetailsPromise = null;
window.frameDetailsBySku = {};
window.frameDetailsByColor = {};

// ===============================
// Build lookup maps
// ===============================
function buildFrameLookups(frames = []) {
  window.frameDetailsBySku = {};
  window.frameDetailsByColor = {};

  for (const frame of frames) {
    if (frame && frame.sku) {
      window.frameDetailsBySku[frame.sku] = frame;
    }
    if (frame && frame.class) {
      window.frameDetailsByColor[frame.class] = frame;
    }
  }

  // Defined in pricing-tests.js, loaded before this file.
  // FIXME: remove after test
  applyPricingTestOverrides();
}

// ===============================
// Preload all frame details
// ===============================
window.fetchAllFrameDetails = async function () {
  // Already cached
  if (window.frameDetailsCache) {
    return window.frameDetailsCache;
  }

  // Request already in flight
  if (window.frameDetailsPromise) {
    return window.frameDetailsPromise;
  }

  let locale = document.documentElement.lang || I18n.locale || null;

  window.frameDetailsPromise = window.fetchFrameDetails(locale)
    .then(frames => {
      window.frameDetailsCache = Array.isArray(frames) ? frames : [];
      buildFrameLookups(window.frameDetailsCache);
      return window.frameDetailsCache;
    })
    .catch(error => {
      console.error('Error fetching frame details:', error);
      return [];
    })
    .finally(() => {
      window.frameDetailsPromise = null;
    });

  return window.frameDetailsPromise;
};

// ===============================
// Functions to get frame details
// ===============================
window.getFrameDetailsBySku = function (sku) {
  if (!sku || !window.frameDetailsBySku) return {};
  return window.frameDetailsBySku[sku] || {};
};

window.getFrameDetailsByColor = function (color) {
  if (!color || !window.frameDetailsByColor) return {};
  return window.frameDetailsByColor[color] || {};
};

window.getColorBySku = function (sku) {
  if (!sku || !window.frameDetailsBySku) return null;
  const frame = window.frameDetailsBySku[sku];
  return frame ? frame.color : null;
};

window.grabAllFramesData = function () {
  return window.frameDetailsCache || {};
};

// ===============================
// Fetch from API
// ===============================
window.fetchFrameDetails = async function (locale) {
  try {
    let url = new URL('get_current_colors.json', window.location.origin);
    if (locale) url.searchParams.set('site', locale);

    const response = await fetch(url.toString());
    
    if (!response.ok) {
      console.error('Fetch error:', response.statusText);
      airbrake.notify({
        error: 'Error fetching frame details',
        params: {
          status: response.status,
          statusText: response.statusText
        }
      });
      return null;
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching frame details:', error);
    airbrake.notify({
      error: 'Exception fetching frame details',
      params: {
        message: error.message,
        stack: error.stack
      }
    });
    return null;
  }
};
// ===============================
// Collective details cache (page session)
// ===============================
window.collectiveVariantsCache = null;
window.collectiveVariantsPromise = null;
window.collectiveVariantByColor = {};
window.collectiveVariantById = {};

// ===============================
// Build lookup maps
// ===============================
function buildCollectiveLookups(variants) {
  window.collectiveVariantByColor = {};
  window.collectiveVariantById = {};

  variants.forEach(v => {
    if (!v || !v.id) return;

    // by ID (string key for safety)
    window.collectiveVariantById[v.id.toString()] = v;

    // by color metafield
    const metafields = Array.isArray(v.metafields)
      ? v.metafields.filter(m => m && typeof m === 'object')
      : [];
    const colorMeta = metafields.find(m => m.key === 'color');
    if (colorMeta && colorMeta.value) {
      window.collectiveVariantByColor[colorMeta.value] = v;
    }
  });
}

// ===============================
// Preload all collective details
// ===============================
window.fetchAllCollectiveVariantDetails = async function () {
  if (window.collectiveVariantsCache) {
    return window.collectiveVariantsCache;
  }

  if (window.collectiveVariantsPromise) {
    return window.collectiveVariantsPromise;
  }

  let locale = document.documentElement.lang || I18n.locale || null;

  window.collectiveVariantsPromise = window.fetchCollectiveVariants(locale)
    .then(variants => {
      window.collectiveVariantsCache = Array.isArray(variants) ? variants : [];
      buildCollectiveLookups(window.collectiveVariantsCache);
      return window.collectiveVariantsCache;
    })
    .catch(err => {
      console.error('Error fetching collective variants', err);
      return [];
    })
    .finally(() => {
      window.collectiveVariantsPromise = null;
    });

  return window.collectiveVariantsPromise;
};

// ===============================
// Functions to get collective details
// ===============================
window.grabAllCollectiveVariants = function () {
  return window.collectiveVariantsCache || [];
};

window.isCollectiveVariant = function (shopifyId) {
  return !!(
    window.collectiveVariantById &&
    window.collectiveVariantById[shopifyId]
  );
};

// ===============================
// Fetch from API
// ===============================
window.fetchCollectiveVariants = async function (locale) {
  try {
      const baseUrl = "https://api.pushd.com/";
      const url = new URL( "v5/shopify/products/get_collective_variants.json", baseUrl);
      if (locale) url.searchParams.set("site", locale);
  
      const response = await fetch(url.toString());
      if (!response.ok) {
        console.error("Fetch error:", response.statusText);
        airbrake.notify({
          error: "Error fetching collective variants",
          params: {
            status: response.status,
            statusText: response.statusText,
          },
        });
        return null;
      }
      return await response.json();
  } catch (error) {
      console.error("Error fetching collective variants:", error);
      airbrake.notify({
        error: "Exception fetching collective variants",
        params: {
          message: error.message,
          stack: error.stack,
        },
      });
      return null;
  }
}
;
(function ($) {
  'use strict'

  $(document).ready(function () {
    var PARAMS_BY_COUNTRY = {
      'CA' : {
        'NAME': 'Please enter a NAME',
        'EMAIL': 'Please enter an EMAIL',
        'PHONE': 'Please enter a PHONE number',
        'ADDRESS': 'Please enter an ADDRESS',
        'CITY': 'Please enter a CITY',
        'STATE': 'Please select a STATE',
        'ZIP': 'Please enter a ZIP code',
        'RULES': {
          'name': true,
          'email': true,
          'address1': true,
          'city': true,
          'state': true,
          'postal_code': true,
        }
      },
      'DE' : {
        'NAME': 'Bitte geben Sie die VOR- UND NACHNAME',
        'EMAIL': 'Bitte geben Sie die E-MAIL',
        'PHONE': 'Bitte geben Sie die KONTAKTNUMMER',
        'ADDRESS': 'Bitte geben Sie die ADRESSE',
        'CITY': 'Bitte geben Sie die STADT',
        'STATE': 'Bitte geben Sie die BUNDESLAND / PROVINZ',
        'ZIP': 'Bitte geben Sie die CODE POSTAL',
        'RULES': {
          'name': true,
          'email': true,
          'address1': true,
          'city': true,
          'state': false,
          'postal_code': true,
        }
      },
      'FR' : {
        'NAME': 'Veuillez saisir le NOMS',
        'EMAIL': 'Veuillez saisir le EMAIL',
        'PHONE': 'Veuillez saisir le TÉLÉPHONE',
        'ADDRESS': 'Veuillez saisir le ADRESSE',
        'CITY': 'Veuillez saisir le VILLE',
        'STATE': 'Veuillez saisir le PROVINCE (OPTIONNEL)',
        'ZIP': 'Veuillez saisir le CODE POSTAL',
        'RULES': {
          'name': true,
          'email': true,
          'address1': true,
          'city': true,
          'state': false,
          'postal_code': true,
        }
      },
      'GB' : {
        'NAME': 'Please enter a NAME',
        'EMAIL': 'Please enter an EMAIL',
        'PHONE': 'Please enter a PHONE number',
        'ADDRESS': 'Please enter an ADDRESS',
        'CITY': 'Please enter a CITY',
        'STATE': 'Please select a STATE',
        'ZIP': 'Please enter a ZIP code',
        'RULES': {
          'name': true,
          'email': true,
          'address1': true,
          'city': true,
          'state': false,
          'postal_code': true,
        }
      },
      'US' : {
        'NAME': 'Please enter a NAME',
        'EMAIL': 'Please enter an EMAIL',
        'PHONE': 'Please enter a PHONE number',
        'ADDRESS': 'Please enter an ADDRESS',
        'CITY': 'Please enter a CITY',
        'STATE': 'Please select a STATE',
        'ZIP': 'Please enter a ZIP code',
        'RULES': {
          'name': true,
          'email': true,
          'address1': true,
          'city': true,
          'state': true,
          'postal_code': true,
        }
      }
    }
    var elem = $('#rma-form');
    var phone = $('#rma_phone');
    var country = $('#rma_country').val();
    if (elem.length) {
      elem.validate({
        errorContainer: '#error-wrapper',
        errorLabelContainer: '#error-wrapper ul',
        wrapper: 'li',
        onkeyup: false,
        rules: {
          'rma[name]': {
            required: PARAMS_BY_COUNTRY[country]['RULES']['name']
          },
          'rma[email]': {
            required: PARAMS_BY_COUNTRY[country]['RULES']['email'],
            email: true
          },
          'rma[address1]': {
            required: PARAMS_BY_COUNTRY[country]['RULES']['address1']
          },
          'rma[city]': {
            required: PARAMS_BY_COUNTRY[country]['RULES']['city']
          },
          'rma[state]': {
            required: PARAMS_BY_COUNTRY[country]['RULES']['state']
          },
          'rma[postal_code]': {
            required: PARAMS_BY_COUNTRY[country]['RULES']['postal_code']
          }
        },
        messages: {
          'rma[name]': {
            required: PARAMS_BY_COUNTRY[country]['NAME']
          },
          'rma[email]': {
            required: PARAMS_BY_COUNTRY[country]['EMAIL']
          },
          'rma[phone]': {
            required: PARAMS_BY_COUNTRY[country]['PHONE']
          },
          'rma[address1]': {
            required: PARAMS_BY_COUNTRY[country]['ADDRESS']
          },
          'rma[city]': {
            required: PARAMS_BY_COUNTRY[country]['CITY']
          },
          'rma[state]': {
            required: PARAMS_BY_COUNTRY[country]['STATE']
          },
          'rma[postal_code]': {
            required: PARAMS_BY_COUNTRY[country]['ZIP']
          }
        },
        invalidHandler: function(event, validator) {
          validator.errorList.forEach(function(error) {
            $(error.element).parent().removeClass('error')
            $(error.element).parent().addClass('error')
          })
        },
        errorPlacement: function(error, element) {
        },
        success: function(label) {
          $(label[0].control).parent().removeClass('error')
        }
      })
    }
    switch(country) {
      case 'DE':
      case 'FR':
      phone.rules('add', {
        required: true,
      });
      break;
      case 'GB':
      phone.rules('add', {
        required: true,
        phoneUK: true
      });
      break;
      default:
      phone.rules('add', {
        phoneUS: true
      });
    }
  })
})(jQuery);
window.Locale = (function () {
  // Mirrors server-side COUNTRY_LOCALE_CONFIG from config/application.rb
  var COUNTRY_LOCALE_CONFIG = {
    US: { domain: 'auraframes.com',    langs: ['en', 'es'] },
    MX: { domain: 'auraframes.mx',     langs: ['es'] },
    GB: { domain: 'auraframes.co.uk',  langs: ['en'] },
    CA: { domain: 'auraframes.ca',     langs: ['en'] },
    DE: { domain: 'auraframes.de',     langs: ['de'] },
    FR: { domain: 'auraframes.fr',     langs: ['fr'] },
    IE: { domain: 'auraframes.ie',     langs: ['en'] },
    CH: { domain: 'auraframes.ch',     langs: ['de'] },
    BE: { domain: 'auraframes.be',     langs: ['fr', 'de', 'nl'] },
    LU: { domain: 'auraframes.lu',     langs: ['fr', 'de', 'nl'] },
    NL: { domain: 'auraframes.nl',     langs: ['fr', 'de', 'nl'] },
    QA: { domain: null,                langs: ['en', 'es'] }
  };

  function readCookie(name) {
    var cookies = document.cookie.split('; ');
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      if (parts[0] === name) return decodeURIComponent(parts[1]);
    }
    return null;
  }

  var LOCAL_HOSTS = ['localhost', 'staging.pushd.com'];

  // Derives current country from the domain.
  // On local/staging, mirrors server logic by reading country_set param/cookie.
  function getCountry() {
    var host = window.location.hostname;

    if (LOCAL_HOSTS.includes(host)) {
      var htmlCountry = (document.documentElement.lang || '').toUpperCase().split('-')[1];
      if (htmlCountry && COUNTRY_LOCALE_CONFIG[htmlCountry]) return htmlCountry;
      return 'US';
    }

    for (var country in COUNTRY_LOCALE_CONFIG) {
      var domain = COUNTRY_LOCALE_CONFIG[country].domain;
      if (domain && host.endsWith(domain)) return country;
    }
    return 'US';
  }

  // Returns the validated lang from URL param or cookie for the current country,
  // or null if absent or not valid for this site.
  function getLang() {
    var params = new URLSearchParams(window.location.search);
    var raw = (params.get('lang') || readCookie('lang') || '').toLowerCase().trim();
    if (!raw) return null;
    var country = getCountry();
    var allowed = COUNTRY_LOCALE_CONFIG[country] ? COUNTRY_LOCALE_CONFIG[country].langs : [];
    return allowed.includes(raw) ? raw : null;
  }

  // Returns the Shopify @inContext argument string for the current locale.
  // Language comes from the lang param/cookie (validated per country);
  // country comes from the domain.
  function getShopifyInContext() {
    var country = getCountry();
    var langOverride = getLang();

    var htmlParts = (document.documentElement.lang || 'en').toUpperCase().split('-');
    var serverLang = htmlParts[0];

    var lang = langOverride ? langOverride.toUpperCase() : serverLang;

    if (country === 'QA' || lang === 'QA') return 'country: US, language: EN';

    return 'country: ' + country + ', language: ' + lang;
  }

  return {
    COUNTRY_LOCALE_CONFIG: COUNTRY_LOCALE_CONFIG,
    getCountry: getCountry,
    getLang: getLang,
    getShopifyInContext: getShopifyInContext
  };
})();
(async function ($) {
  'use strict'

  await window.fetchAllFrameDetails();

  if (!$('body').hasClass('has-checkout')) {
    return;
  }

  function localLocale(){
    let host = window.location.hostname;
    if ((host === "localhost" || host == "staging.pushd.com") && getUrlParameter('locale')) {
      document.querySelectorAll('a').forEach(function(link){
        let href = link.getAttribute('href');
        if (!href) return;
        href += href.includes('?') ? '&' : '?';
        href += 'locale=' + getUrlParameter('locale');
        link.setAttribute('href', href);
      });
    }
  }

  // Ensure country picker links work in staging/localhost
  function countryPickerLocale(){
    const host = window.location.hostname;
    if (host !== "localhost" && host !== "staging.pushd.com") return;

    const origin = window.location.origin;
    document.querySelectorAll('a.region-link').forEach(function(link){
      if (link.origin !== origin) {
        link.href = link.href.replace(link.origin, origin);
      }
    });
  }

  function initCountryPickerAnalytics() {
    const countrySelectors = document.querySelectorAll('.action--country-selector-container');
  
    countrySelectors.forEach((countrySelector) => {
      countrySelector.addEventListener('click', () => {
        const location = countrySelector.dataset.location;
  
        logGA4Event('country-selector-globe-click', {
          location: location
        });
      });
    });
  }
  var getShopifyInContext = Locale.getShopifyInContext;

  const isDeliveryEstimateRegion = ['en', 'en-US', 'es-US', 'qa', 'en-QA', 'es-QA', 'en-CA'].includes(document.documentElement.lang);

  const isCaLocale = document.documentElement.lang === 'en-CA';
  const PLACEHOLDER_ZIP_CODE = isCaLocale ? 'Postal code' : 'ZIP code';
  const CA_POSTAL_CODE_REGEX = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;

  const GIFT_BAG_SKU = 'AFGB2023'

  var BBY_SKUS = ['AF110-MBLK', 'AF113-MBLK', 'AF900-MBLK', 'AF903-MBLK', 'AF210-MBLK', 'AF213-MBLK', 'AFM110-MBLK', 'AFM210-MBLK', 'AFM900-MBLK'];

  var COLORS = {
    AURA_INK_GRAPHITE: "aura-ink-graphite",
    AURA_INK_GRAPHITE_10: "aura-ink-graphite-10",
    ASTRA_MOONSTONE: "astra-moonstone",
    ASPEN_INK_MAT: "aspen-ink-mat",
    ASPEN_CLAY_MAT: "aspen-clay-mat",
    WALDEN_INK_MAT: "walden-ink-mat",
    WALDEN_CLAY_MAT: "walden-clay-mat",
    ARAM_SILVER: "aram-silver",
    BLACK_ONYX: "black-onyx",
    CARVER_MAT: "carver-mat",
    CARVER_MAT_CLAY: "carver-mat",
    CARVER_MAT_CHESTNUT_BROWN: "carver-mat-chestnut-brown",
    CARVER_MAT_STEALTH_BLACK: "carver-mat-stealth-black",
    CARVER_MAT_FOREST_GREEN: "carver-mat-forest-green",
    CARVER_MAT_ARCTIC_WHITE: "carver-mat-arctic-white",
    CARVER_MAT_MIDNIGHT_BLUE: "carver-mat-midnight-blue",
    CARVER_CLAY_MAT_CHESTNUT_BROWN: "carver-clay-mat-chestnut-brown",
    CARVER_CLAY_MAT_STEALTH_BLACK: "carver-clay-mat-stealth-black",
    CARVER_CLAY_MAT_FOREST_GREEN: "carver-clay-mat-forest-green",
    CARVER_CLAY_MAT_ARCTIC_WHITE: "carver-clay-mat-arctic-white",
    CARVER_CLAY_MAT_MIDNIGHT_BLUE: "carver-clay-mat-midnight-blue",
    CARVER_GRAVEL: "carver-gravel",
    CARVER_SEA_SALT: "carver-sea-salt",
    CARVER_CLAY_MAT: "carver-clay-mat",
    STONE_BASALT: "stone-basalt",
    STONE_BOULDER: "stone-boulder",
    BRASS: "brass",
    MICA: "mica",
    SHALE: "shale",
    GRAPHITE: "graphite",
    RAILING: "railing",
    WHITE_QUARTZ: "white-quartz",
    WARM_STONE: "warm-stone",
    PLATINUM_ROSE: "platinum-rose",
    STARDUST: "stardust",
    WALNUT: "walnut",
    SLATE: "slate",
    STONE: "stone",
    IVORY: "ivory",
    CHARCOAL: "charcoal",
    CARVER_CHARCOAL: "carver-charcoal",
    GALLERIE_CHARCOAL: "gallerie-charcoal",
    GALLERIE_WHITE_CHALK: "gallerie-white-chalk",
    WHITE_CHALK: "white-chalk",
    CARVER_MAT_LIMITED: "carver-mat-limited",
    CARVER_LUXE_MAT: "carver-luxe-mat",
    BLUE_CHALK: "blue-chalk",
    QUARTZ: "quartz",
    COBALT: "cobalt",
    SEAGLASS: "seaglass",
    PEBBLE: "pebble",
    SANDSTONE: "sandstone",
    GRAVEL: "gravel",
    SEA_SALT: "sea-salt",
    GIFT_BAG: "39627841339527:1", // hardcoded to quantity 1 because we'll handle quantity on fulfillment
    PARKER_REEDED_LIMESTONE: 'parker-reeded-limestone',
    PARKER_REEDED_SLATE: 'parker-reeded-slate'
  };

  var GROUPS = {
    AURA_INK_GRAPHITE: "aura-ink",
    AURA_INK_GRAPHITE_10: "aura-ink",
    ASTRA_MOONSTONE: "astra-moonstone",
    ASPEN_INK_MAT: "aspen",
    ASPEN_CLAY_MAT: "aspen",
    WALDEN_INK_MAT: "walden",
    WALDEN_CLAY_MAT: "walden",
    ARAM_SILVER: "aram",
    BLACK_ONYX: "smith",
    PLATINUM_ROSE: "smith",
    CARVER_CHARCOAL: "carver_2020",
    GALLERIE_CHARCOAL: "gallerie",
    GALLERIE_WHITE_CHALK: "gallerie",
    CARVER_MAT: "carver-mat",
    CARVER_MAT_CLAY: "carver-mat",
    CARVER_MAT_CHESTNUT_BROWN: "carver-mat",
    CARVER_MAT_STEALTH_BLACK: "carver-mat",
    CARVER_MAT_FOREST_GREEN: "carver-mat",
    CARVER_MAT_ARCTIC_WHITE: "carver-mat",
    CARVER_MAT_MIDNIGHT_BLUE: "carver-mat",
    CARVER_CLAY_MAT_CHESTNUT_BROWN: "carver",
    CARVER_CLAY_MAT_STEALTH_BLACK: "carver",
    CARVER_CLAY_MAT_FOREST_GREEN: "carver",
    CARVER_CLAY_MAT_ARCTIC_WHITE: "carver",
    CARVER_CLAY_MAT_MIDNIGHT_BLUE: "carver",
    CARVER_GRAVEL: "carver",
    CARVER_SEA_SALT: "carver",
    CARVER_CLAY_MAT: "carver",
    CARVER_MAT_LIMITED: "carver_luxe",
    CARVER_LUXE_MAT: "carver_luxe",
    STONE_BASALT: "stone",
    STONE_BOULDER: "stone",
    WHITE_CHALK: "carver_2020",
    BLUE_CHALK: "mason",
    MICA: "sawyer",
    SHALE: "sawyer",
    WARM_STONE: "warm_stone",
    GRAPHITE: "mason",
    RAILING: "mason",
    WHITE_QUARTZ: "mason",
    WALNUT: "wood",
    STARDUST: "modern",
    STONE: "modern",
    SLATE: "modern",
    modern: "modern",
    classic: "classic",
    IVORY: "classic",
    CHARCOAL: "classic",
    QUARTZ: "classic",
    COBALT: "classic",
    SEAGLASS: "classic",
    PEBBLE: "mason_luxe",
    SANDSTONE: "mason_luxe",
    GRAVEL: "carver_luxe",
    SEA_SALT: "carver_luxe",
    PARKER_REEDED_LIMESTONE: 'parker',
    PARKER_REEDED_SLATE: 'parker'
  };

  var COLOR_TO_ENUM = {
    'aura-ink-graphite': 'AURA_INK_GRAPHITE',
    'aura-ink-graphite-10': 'AURA_INK_GRAPHITE_10',
    'astra-moonstone' : 'ASTRA_MOONSTONE',
    'aspen-ink-mat': 'ASPEN_INK_MAT',
    'aspen-clay-mat': 'ASPEN_CLAY_MAT',
    'walden-ink-mat': 'WALDEN_INK_MAT',
    'walden-clay-mat': 'WALDEN_CLAY_MAT',
    'aram-silver': 'ARAM_SILVER',
    'black-onyx': 'BLACK_ONYX',
    'platinum-rose': 'PLATINUM_ROSE',
    'carver-charcoal': 'CARVER_CHARCOAL',
    'gallerie-charcoal': 'GALLERIE_CHARCOAL',
    'white-chalk': 'WHITE_CHALK',
    'gallerie-white-chalk': 'GALLERIE_WHITE_CHALK',
    'blue-chalk': 'BLUE_CHALK',
    'carver-mat': 'CARVER_MAT',
    'carver-gravel': 'CARVER_GRAVEL',
    'carver-sea-salt': 'CARVER_SEA_SALT',
    'carver-clay-mat': 'CARVER_CLAY_MAT',
    'carver-mat-limited': 'CARVER_MAT_LIMITED',
    'carver-mat-chestnut-brown': 'CARVER_MAT_CHESTNUT_BROWN',
    'carver-mat-stealth-black': 'CARVER_MAT_STEALTH_BLACK',
    'carver-mat-forest-green': 'CARVER_MAT_FOREST_GREEN',
    'carver-mat-arctic-white': 'CARVER_MAT_ARCTIC_WHITE',
    'carver-mat-midnight-blue': 'CARVER_MAT_MIDNIGHT_BLUE',
    'carver-clay-mat-chestnut-brown': 'CARVER_CLAY_MAT_CHESTNUT_BROWN',
    'carver-clay-mat-stealth-black': 'CARVER_CLAY_MAT_STEALTH_BLACK',
    'carver-clay-mat-forest-green': 'CARVER_CLAY_MAT_FOREST_GREEN',
    'carver-clay-mat-arctic-white': 'CARVER_CLAY_MAT_ARCTIC_WHITE',
    'carver-clay-mat-midnight-blue': 'CARVER_CLAY_MAT_MIDNIGHT_BLUE',
    'carver-luxe-mat': 'CARVER_LUXE_MAT',
    'stone-basalt': 'STONE_BASALT',
    'stone-boulder': 'STONE_BOULDER',
    mica: 'MICA',
    shale: 'SHALE',
    'graphite': 'GRAPHITE',
    'white-quartz': 'WHITE_QUARTZ',
    'warm-stone': 'WARM_STONE',
    walnut: 'WALNUT',
    stardust: 'STARDUST',
    slate: 'SLATE',
    stone: 'STONE',
    ivory: 'IVORY',
    railing: "RAILING",
    charcoal: 'CHARCOAL',
    quartz: 'QUARTZ',
    cobalt: 'COBALT',
    seaglass: 'SEAGLASS',
    pebble: 'PEBBLE',
    sandstone: 'SANDSTONE',
    gravel: 'GRAVEL',
    'sea-salt': 'SEA_SALT',
    'parker-reeded-limestone': 'PARKER_REEDED_LIMESTONE',
    'parker-reeded-slate' : 'PARKER_REEDED_SLATE'
  };

  var SELECTORS = {
    BANNER: 'banner',
    FRAME_IMAGES: 'frame-images',
    LEFT_ARROW: 'imageSelector-arrow--left',
    RIGHT_ARROW: 'imageSelector-arrow--right',
    THUMBNAILS_CONTAINER: 'action--thumbnails-wrapper',
    THUMBNAIL_CONTAINER: 'action--thumbnail-container',
    THUMBNAIL: 'action--thumbnail',
    MAIN_IMAGE: 'action--pdp-image',
    MAIN_IMAGE_CONTAINER: 'action-image-selector--main-image--container',
    STORE_SECTION_IMAGE: 'action--hp-image',
    STORE_SECTION_IMAGE_HOVER: 'action--hp-image-hover',
    STORE_SECTION_IMAGE_HOVER_TEST: 'action--hp-image-hover-test',
    THUMBNAIL_IMAGE: 'action--pdp-image-thumb',
    IMAGE_CONTAINER: 'action--image-selector',
    QUICK_ADD: 'action--quick-add-btn',
    QUICK_ADD_TW: 'btn-addToCart--tw',
    HEADER_MOBILE: 'mobile--sectionHeader',
    SWATCHES_HP: 'action--hp--swatch',
    SWATCHES_PDP: 'pdp--swatch',
    AMAZON_Link: 'action--amazon-link',
    BUNDLE_OPTION: 'bundle--option',
    SWATCH_PRODUCT_TITLE: 'action--product--title',
    SELECTIONS: 'frameInfo-colorAndQuantityContainer',
    INCREMENT_QUANTITY: 'frameInfo-quantitySelector--increment',
    DECREMENT_QUANTITY: 'frameInfo-quantitySelector--decrement',
    INCREMENT_CART_ITEM_QUANTITY: 'cartItem-quantitySelector--increment',
    DECREMENT_CART_ITEM_QUANTITY: 'cartItem-quantitySelector--decrement',
    QUANTITY_CONTAINER: 'frameInfo-quantityContainer',
    CART_ITEM_QUANTITY_SELECTOR: 'cartItem-quantitySelector',
    GIFT_BAG: 'actions--giftBag',
    GIFT_BAG_LABEL: 'actions--giftBagLabel',
    GIFT_BAG_ICON: 'giftbag-icon',
    GIFT_BAG_COPY: 'giftbag-copy',
    GIFT_BAG_CART: 'action--giftbag-cart',
    BUNDLE_CONTAINER: 'actions--frame-info__bundle',
    BUNDLE: 'actions-bundle-checkbox',
    BUNDLE_OPTION_WRAPPER: 'actions--bundle--option-wrapper',
    COLLECTIVE_BUNDLE: 'actions--collective-bundle',
    COLLECTIVE_BUNDLE_OPTIONS_WRAPPER: 'actions--collective-bundle--options-wrapper',
    COLLECTIVE_BUNDLE_OPTION_WRAPPER: 'actions--collective-bundle--option-wrapper',
    COLLECTIVE_BUNDLE_OPTION: 'actions--collective-bundle--option',
    COLLECTIVE_BUNDLE_OPTION_IMAGE: 'actions--collective-bundle--option-image',
    COLLECTIVE_BUNDLE_CHECKBOX: 'actions--collective-bundle--checkbox',
    COLLECTIVE_MAIN_BUNDLE_IMAGE: 'actions--collective-bundle--main-image',
    COLLECTIVE_MAIN_BUNDLE_IMAGE_WRAPPER: 'actions--collective-bundle--main-image-wrapper',
    EXPLORE_FRAMES: 'frame--explore',
    QUANTITY: 'frameInfo-quantity',
    SITE_DETAILS: 'siteDetails',
    PRICE_ORIGINAL: 'frameInfo-price-original',
    LIMITED_EDITION_BADGE: 'frameInfo-price-carver-mat',
    CATEGORY_HEADER: 'frameInfo-header',
    PROMO_MESSAGE: 'frameInfo-promo',
    PROMO_PRICE: 'frameInfo-price-promo',
    PRICE_ORIGINAL_VALUE: 'frameInfo-price-original-value',
    BUNDLE_BOX: 'bundle-upsell',
    BUNDLE_APPLIED_TEXT: 'action--bundle-applied',
    DISCOUNT_CODE_HP: 'action--discount-code-hp',
    DISCOUNT_CODE_PDP: 'action--discount-code-pdp',
    PRICE_VALUE: 'frameInfo-price-value',
    ADD_TO_CART: 'frameInfo-addToCart',
    GO_TO_AMAZON: 'frameInfo-goToAmazon',
    GO_TO_AMAZON_CONTAINER: 'frameInfo-amazonContainer',
    ADD_TO_CART_CONTAINER: 'frameInfo-addToCartContainer',
    SOLD_OUT_CONTAINER: 'frameInfo-soldOutContainer',
    BACK_ORDER: 'frameInfo-backOrder',
    BACK_ORDER_WARNING: 'frameInfo-backOrder--swatch-Warning',
    SOLD_OUT: 'frameInfo-soldOut',
    SOLD_OUT_FORM: 'frameInfo-soldOutForm',
    NOTIFY_ME: 'frame-info__purchase-options--notify-me',
    CART_COUNT: 'cart-count',
    CART_TOP: 'action--cart-top',
    CART_OPENER: 'cart-toggle',
    CART_CLOSER: 'cart-exit',
    CART_POPUP: 'cart-popup',
    CART_ITEMS: 'cart-items',
    CART_ITEM: 'cartItem',
    CART_CHECKOUT: 'action--cart-checkout',
    CART_DELIVERY_DATE: 'cart-delivery-date',
    CART_ITEM_TEMPLATE: 'cartItem-template',
    CART_ACTIONS: 'cart-actions',
    CART_ITEM_COLLECTION: 'cartItem-collection',
    CART_ITEM_TITLE: 'cartItem-title',
    CART_ITEM_PRICE_CONTAINER: 'action--cartItem-price-container',
    CART_ITEM_PRICE: 'action--cartItem-price',
    CART_ITEM_SALE_PRICE: 'action--cartItem-sale-price',
    CART_ITEM_ORIGINAL_PRICE: 'action--cartItem-original-price',
    CART_ITEM_THUMBNAIL: 'cartItem-image',
    CART_ITEM_THUMBNAIL_CONTAINER: 'cartItem-imageContainer',
    CART_ITEM_FULFILLMENT: 'cartItem-fulfillment',
    CART_ITEM_FULFILLMENT_CONTAINER: 'cartItem-fulfillmentContainer',
    CART_ITEM_BUNDLE: 'cartItem-bundle',
    CART_GIFT_CONTAINER: 'cart-gift-container',
    CART_BOTTOM: 'cart-bottom',
    CART_GIFT: 'cart-gift',
    CART_ITEM_QUANTITY: 'cartItem-quantity',
    CART_ITEM_REMOVE: 'cartItem-remove',
    CART_ITEM_PROMO: 'cart-promo-container',
    CART_ITEM_PROMO_COPY: 'cart-promo-copy',
    CART_SUBTOTAL: 'action--cart-subtotal',
    CART_SUBTOTAL_AMOUNT: 'action--cart-subtotalAmount',
    CART_DISCOUNT_CONTAINER: 'action--cart-discountContainer',
    CART_DISCOUNTS: 'action--cart-discounts',
    CART_DISCOUNTS_AMOUNT: 'action--cart-discountsAmount',
    CART_INFO: 'action--cart-info',
    CART_SAVING_AMOUNT: 'action--cart-savingAmount',
    CART_ESTIMATE_TOTAL: 'action--cart-estimate-total',
    CART_ESTIMATE_TOTAL_AMOUNT: 'action--cart-estimate-totalAmount',
    CART_RECYCLING_FEE: 'action--cart-recycling-fee',
    CART_RECYCLING_FEE_AMOUNT: 'action--cart-recycling-feeAmount',
    CART_ITEMIZED_COSTS: 'action--cart-itemized-costs',
    CART_DISCOUNT_CODE_CONTAINER: 'action--cart-discount-code-container',
    CART_DISCOUNT_CODE_TOGGLE: 'action--cart-discount-code-toggle',
    CART_DISCOUNT_CODE_TOGGLE_ICON: 'action--cart-discount-code-toggle-icon',
    CART_DISCOUNT_CODE_FORM: 'action--cart-discount-code-form',
    CART_DISCOUNT_CODE_INPUT: 'action--cart-discount-code-input',
    CART_DISCOUNT_CODE_APPLY: 'action--cart-discount-code-apply',
    CART_DISCOUNT_CODE_ERROR: 'action--cart-discount-code-error',
    CART_DISCOUNT_CODES: 'action--cart-discount-codes',
    CART_DISCOUNT_BUNDLE: 'action--cart-discount-bundle',
    CART_EMPTY_MESSAGE: 'action--cart-emptyMessage',
    CART_UPSELL_EMPTY_MESSAGE: 'action--cart-upsell-empty-message',
    CART_UPSELL_CART_MESSAGE: 'action--cart-upsell-cart-message',
    CART_SHIPPING_ESTIMATE: 'cart-shipping-estimate',
    CART_SHIPPING_AMOUNT: 'cart-shipping-amount',
    CART_SHIPPING: 'action--cart-shipping',
    CART_SHIPPING_PRICE: 'cart-shipping-promise',
    OVERLAY: 'overlay',
    SOLD_OUT_MESSAGE: 'frameInfo-unavailable',
    NAVBAR: 'navbar',
    NAVBAR_PRIMARY_BUTTON: 'navbar__link--primary',
    NAVBAR_LIST: 'navbar__hover-list',
    ORDER_SWATCHES: 'colorSwatch',
    TOOLTIP_INFO: 'tooltip-info',
    DELIVERY_ESTIMATE_WRAPPER: 'action--delivery-estimate-wrapper',
    ZIP_VALUE: 'action--shipping-estimate-zip-value',
    ZIP_BUTTON: 'action--shipping-estimate-zip-btn',
    ZIP_INPUT: 'action--shipping-estimate-zip-input',
    ZIP_INPUT_WRAPPER: 'action--shipping-estimate-zip-input-wrapper',
    DELIVERY_WRAPPER: 'action--shipping-delivery-wrapper',
    DELIVERY_PROMISE_WRAPPER: 'action--shipping-delivery-promise-wrapper',
    DELIVERY_PROMISE_DATE: 'action--shipping-estimate-promise-date',
    DELIVERY_PROMISE_TEXT: 'action--shipping-estimate-promise-text',
    PRODUCT_ESTIMATE_MESSAGE: 'action--product-estimate-message',
    SHOP_SECTION_PRODUCT: 'action--shop-section-product',
    PRODUCT_PAGE: 'product-page',
    MULTISHIP_CONTAINER: 'section--multiship',
    MULTISHIP_CART_ITEMS: 'multiship-cartItems',
    MULTISHIP_CART_ITEM: 'action--multiship-cartItem',
    MULTISHIP_CART_ITEM_TEMPLATE: 'action--multiship-cartItem-template',
    MULTISHIP_CART_ITEM_SHIPPING_ADDRESS: 'multiship-cartItem-shipping-address',
    MULTISHIP_SHIPPING_ADDRESS_MODAL: 'action--multiship-shipping-address-modal',
    MULTISHIP_SHIPPING_ADDRESS_CLOSE: 'multiship-shipping-address-close',
    MULTISHIP_SHIPPING_ADDRESS_FORM: 'action--multiship-shipping-address-form',
    MULTISHIP_SHIPPING_ADDRESS_FORM_SUBMIT: 'action--multiship-shipping-address-form-submit',
    MULTISHIP_NEW_SHIPPING_ADDRESS_BUTTON: 'action--multiship-new-shipping-address-button',
    MULTISHIP_DELETE_SHIPPING_ADDRESSES_BUTTON: 'action--multiship-delete-shipping-addresses-button',
    MULTISHIP_SHIPPING_ADDRESSES_EDIT_CLOSE: 'action--multiship-shipping-addresses-edit-close',
    MULTISHIP_SHIPPING_ADDRESSES_EDIT_MODAL: 'action--multiship-shipping-addresses-edit-modal',
    MULTISHIP_SHIPPING_ADDRESSES_EDIT_MODAL_CONTENT: 'action--multiship-shipping-addresses-edit-modal-content',
    MULTISHIP_SHIPPING_ADDRESSES_DELETE_BUTTON: 'action--multiship-delete-addresses-button',
    MULTISHIP_SHIPPING_ADDRESS_ERROR: 'action--multiship-shipping-address-error',
    MULTISHIP_CHECKOUT_ADDRESS: 'action--multiship-checkout-address',
    MULTISHIP_SHIPPING_METHODS_CONTAINER: 'section--multiship-shipping-methods',
    MULTISHIP_BILLING_ADDRESS_CONTAINER: 'action--section--multiship-billing',
    MULTISHIP_CART_ITEM_SELECTED_SHIPPING_ADDRESS: 'action--multiship-cartItem-selected-shipping-address',
    MULTISHIP_CART_ITEM_SHIPPING_ADDRESS_EDIT: 'action--multiship-cartItem-shipping-address-edit',
    MULTISHIP_SHIPPING_OPTIONS_CART_ITEMS: 'action--section--shipping-options-cart-items',
    MULTISHIP_SHIPPING_OPTIONS_ITEMS_GROUPING_TEMPLATE: 'shipping-options-items-grouping-template',
    MULTISHIP_SHIPPING_OPTIONS_ITEMS_GROUPING: 'shipping-options-items-grouping',
    MULTISHIP_SHIPPING_OPTIONS_ITEM_TEMPLATE: 'shipping-options-item-template',
    MULTISHIP_SHIPPING_OPTIONS_LINEITEMS: 'shipping-options-lineitems',
    MULTISHIP_SHIPPING_METHODS: 'action--multiship-cartItem-shipping-methods',
    MULTISHIP_SHIPPING_METHOD: 'action--multiship-cartItem-shipping-method',
    MULTISHIP_SHIPPING_METHOD_SELECT: 'action--multiship-cartItem-shipping-method-select',
    MULTISHIP_GIFTNOTE: 'multiship-cartItem-giftnote',
    MULTISHIP_CHECKOUT_SHIPPING_OPTIONS: 'action--multiship-checkout-shipping-options',
    MULTISHIP_CARTITEM_SHIPPING_SECTION: 'multiship-cartItem-shipping-selection',
    MULTISHIP_BILLING_INFO: 'action--multiship-billing-info',
    MULTISHIP_SHIPPING_ADDRESS_TITLE: 'action--multiship-shipping-address-title',
    MULTISHIP_ADDRESS_COUNTRY: 'action--multiship-address-country',
    MULTISHIP_ADDRESS_ZIP: 'action--multiship-address-zip',
    MULTISHIP_ADDRESS_PROVINCE: 'action--multiship-address-province',
    MULTISHIP_ADDRESS_PROVINCE_INPUT: 'action--multiship-address-province-input',
    MULTISHIP_BILLING_FORM: 'action--multiship-billing-form',
    MULTISHIP_BILLING_EMAIL: 'action--multiship-billing-email',
    MULTISHIP_PHONE_INPUT: 'action--multiship-phone-input',
    ORDER_SUMMARY_CARTITEM_TEMPLATE: 'action--order-summary-cartItem-template',
    ORDER_SUMMARY_CARTITEM: 'order-summary-cartItem',
    ORDER_SUMMARY_CARTITEMS: 'action--order-summary-cartItems',
    ORDER_SUMMARY_CARTITEMS_SHIPPING_ADDRESS: 'cartItem-address',
    ORDER_SUMMARY_CARTITEMS_GIFTNOTE: 'cartItem-giftnote',
    ORDER_SUMMARY_SHIPPING_METHODS: 'action--order-summary-shipping-methods',
    ORDER_SUMMARY_SHIPPING_COST: 'action--order-summary-shipping-cost',
    ORDER_SUMMARY_SHIPPING_ADDRESS: 'action--order-summary-shipping-address',
    ORDER_SUMMARY: 'action--order-summary',
    ORDER_SUMMARY_CARTITEM_DISCOUNT_TAG: 'cartItem-discount-tag',
    CART_TAXES: 'action--cart-taxes',
    TAX_ADJUSTMENT_WARNING: 'action--tax-adjustment-warning',
    CART_BOPIS_MERCHANDISING: 'action--cart-bopis-merchandising',
    BOPIS_MERCHANDISING_STORE_SELECTOR_LINK: 'action--bopis-merchandising__store-selector-link',
    BOPIS_MERCHANDISING_STORE_SELECTOR: 'action--bopis-merchandising__store-selector',
    BOPIS_MERCHANDISING_STORE_SELECTOR_LOCATION: 'action--bopis-merchandising__store-selector-location',
    BOPIS_MERCHANDISING_STORE_SELECTOR_LOCATION_CONTAINER: 'action--bopis-merchandising__store-selector-location-container',
    BOPIS_MERCHANDISING_STORE_SELECTOR_LOCATION_TEMPLATE: 'action--bopis-merchandising__store-selector-location-template',
    BOPIS_MERCHANDISING: 'action--bopis-merchandising',
    BOPIS_MERCHANDISING_MAIN_STORE_CONTAINER: 'action--bopis-merchandising-main-store-container',
    BOPIS_MERCHANDISING_STORE: 'action--bopis-merchandising__store',
    BOPIS_MERCHANDISING_STORE_NAME: 'action--bopis-merchandising__store-name',
    BOPIS_MERCHANDISING_STORE_ADDRESS: 'action--bopis-merchandising__store-address',
    BOPIS_MERCHANDISING_STORE_CITY: 'action--bopis-merchandising__store-city',
    BOPIS_MERCHANDISING_STORE_DISTANCE: 'action--bopis-merchandising__store-distance',
    BOPIS_MERCHANDISING_STORE_PICKUP_IN: 'action--bopis-merchandising__store-pickup-in',
    IN_STORE_PICKUP_STORE_SELECTOR_CONTAINER: 'action--in-store-pickup__store-selector-container',
    IN_STORE_PICKUP_STORE_SELECTOR_TEMPLATE: 'action--in-store-pickup__store-selector-template',
    IN_STORE_PICKUP_STORE_NAME: 'action--in-store-pickup__store-name',
    IN_STORE_PICKUP_STORE_SELECTOR_LOCATION: 'action--in-store-pickup__store-selector-location',
    IN_STORE_PICKUP_STORE_DISTANCE: 'action--in-store-pickup__store-distance',
    IN_STORE_PICKUP_STORE_ADDRESS: 'action--in-store-pickup__store-address',
    IN_STORE_PICKUP_STORE_CITY: 'action--in-store-pickup__store-city',
    IN_STORE_PICKUP_STORE_PICKUP_IN: 'action--in-store-pickup__store-pickup-in',
    IN_STORE_PICKUP_STORE_LIMITED_STOCK: 'action--in-store-pickup__store-limited-stock',
    IN_STORE_PICKUP_NO_STORES: 'action--in-store-pickup__no-stores',
    PRODUCT_INFO_TAB: 'action--product-info-tab',
    PRODUCT_INFO_TAB_PANEL: 'action--product-info-tab-panel',
    VIEW_CART: 'action--view-cart'
  };

  var CLASSES = {
    ACTIVE_IMAGE: 'frame-image--active',
    ACTIVE: 'is-active',
    DISABLED: 'is-disabled',
    EMPTY: 'is-empty',
    OPEN: 'is-open',
    SHOWING: 'is-showing',
    OVERLAY_ENTER: 'overlay-enter',
    OVERLAY_ENTER_ACTIVE: 'overlay-enter-active',
    OVERLAY_LEAVE: 'overlay-leave',
    OVERLAY_LEAVE_ACTIVE: 'overlay-leave-active',
    OVERLAY_HIDE: 'is-hidden',
    SHOW_LIST: 'show-List',
  }

  var activeImageIndex = 0;
  const galleryImages = document.querySelectorAll(getClassSelector(SELECTORS.MAIN_IMAGE_CONTAINER));
  let maxIndex = galleryImages.length - 1;
  let minIndex = 0;
  var activeFrame, activeFrameGroup;
  setActiveFrameFromUrl();
  var $thumbnailContainers = document.querySelectorAll(getClassSelector(SELECTORS.THUMBNAILS_CONTAINER));

  function galleryButtonsClasses() {
    const mainImage = document.querySelector('.action--carousel-pdp--section');
    if (!mainImage) return;
    const leftArrow = mainImage.querySelector('.action--image-gallery--arrow-left');
    const rightArrow = mainImage.querySelector('.action--image-gallery--arrow-right');

    if (!leftArrow || !rightArrow) return;
    leftArrow.classList.toggle('disabled', activeImageIndex <= minIndex);
    leftArrow.classList.toggle('active', activeImageIndex > minIndex);
    rightArrow.classList.toggle('disabled', activeImageIndex >= maxIndex);
    rightArrow.classList.toggle('active', activeImageIndex < maxIndex);
  }

  function galleryButtons() {
    const mainImage = document.querySelector('.action--carousel-pdp--section');
    if (!mainImage) return;
    const leftArrow = mainImage.querySelector('.action--image-gallery--arrow-left');
    const rightArrow = mainImage.querySelector('.action--image-gallery--arrow-right');

    if (!leftArrow || !rightArrow) {
      return;
    }
    galleryButtonsClasses();
    leftArrow.addEventListener('click', function () {
      if (activeImageIndex > minIndex) {
        handleDecrementImage();
      }
      galleryButtonsClasses();
    });

    rightArrow.addEventListener('click', function () {
      if (activeImageIndex < maxIndex) {
        handleIncrementImage();
      }
      galleryButtonsClasses();
    });
  }

  function thumbnailBar($thumbnailBar){
    $thumbnailBar.each(function (barIndex, bar) {
      $(bar).on('click', function () {
        setImageIndex(barIndex);
        renderMainActiveImage();
        renderActiveThumbnailImage();
        thumbnailAnalytics();
        galleryButtonsClasses();
      })
    });
  };

  Array.from($thumbnailContainers).forEach(function(thumbnailContainer) {
    var $thumbnailContainer = $(thumbnailContainer);
    var $thumbnailBar = $thumbnailContainer.find(getClassSelector(SELECTORS.THUMBNAIL_CONTAINER));
    thumbnailBar($thumbnailBar);
  });

  var $swatches = $(getClassSelector(SELECTORS.ORDER_SWATCHES));
  var currencySymbol = getCurrencySymbol();
  $swatches.each(function(swatch) {
    var $swatch = $(swatch);
    $swatch.click(function(e) {
      var swatchCollection = e.target.getAttribute("data-collection");
      var swatchColor = e.target.getAttribute("data-color");
      var framesData = window.grabAllFramesData();
      var frameData = framesData[(COLOR_TO_ENUM[swatchColor])];
      var frameTitle = frameData.title;
      var frameImage = frameData.lifestyleImageUrl;
      var frameImageHover = frameData.lifestyleImageHoverUrl;
      var $productImageContainer = $(getClassSelector(swatchCollection + ".product-image--link"));
      var $addToCartBtn = $(getClassSelector(swatchCollection + ".action--quick-add-btn"));
      if(frameData.isSoldOut){
        $addToCartBtn.removeClass('btn-primary');
        $addToCartBtn.addClass('btn-secondary--black disabled');
        $addToCartBtn.attr('disabled', true);
        $addToCartBtn.text('Sold out');
      } else {
        $addToCartBtn.removeClass('btn-secondary--black disabled');
        $addToCartBtn.addClass('btn-primary');
        $addToCartBtn.attr('disabled', false);
        $addToCartBtn.text('Add to Cart');
      }
      var productImages = $productImageContainer.children('img');
      var $productTitle = $(getClassSelector('frameInfo-title-'+ swatchCollection));
      $addToCartBtn.attr('data-color', swatchColor)
      $(productImages[0]).attr('src', frameImage);
      $(productImages[1]).attr('src', frameImageHover);
      $productTitle.text(frameTitle)
      var productSwatch = $(getClassSelector(swatchCollection + ".div-product"));
      var productColor = $(getClassSelector(swatchColor + ".div-product"));
      var orderProductButtons = $(getClassSelector("order-btn-" + swatchCollection));
      $(productSwatch).removeClass("active");
      $(productColor).addClass("active");
      $(orderProductButtons).each(function(orderButton){
        $(orderButton).removeClass('active')
      });
    })
  });
  var cartDeliveryEstimateExpiry;
  var cartDeliveryEstimateText;
  var cartDeliveryEstimateZip;

  function isMobile() {
    const checkMobileState = () => {
        const mobileState = window.innerWidth < 640;
        return mobileState;
    };

    const initialState = checkMobileState();

    window.addEventListener("resize", checkMobileState);

    return initialState;
  }

  function observeElementInView(className, callback) {
    const element = document.querySelector(`.${className}`);
    if (!element) return false;

    const observer = new IntersectionObserver((entries) => {
      if (entries.some(entry => entry.isIntersecting)) {
        observer.disconnect();
        callback();
      }
    });

    observer.observe(element);
  }

  function getLocaleCurrency() {
    var locale = I18n.locale;
    switch(locale){
      case 'de':
      case 'de-LU':
      case 'de-NL':
      case 'de-BE':
      case 'fr':
      case 'fr-LU':
      case 'fr-NL':
      case 'fr-BE':
      case 'nl-NL':
      case 'nl-BE':
        return 'EUR';
      case 'en-GB':
        return 'GBP';
      case 'en-CA':
        return 'CAD';
      case 'es-MX':
        return 'MXN';
      default:
        return 'USD';
    }
  }

  function getCurrencySymbol() {
    var locale = I18n.locale;
    switch(locale){
      case 'de':
      case 'de-LU':
      case 'de-NL':
      case 'de-BE':
      case 'fr':
      case 'fr-LU':
      case 'fr-NL':
      case 'fr-BE':
      case 'nl-NL':
      case 'nl-BE':
        return '€';
      case 'en-GB':
        return '£';
      default:
        return '$';
    }
  }

  function getPriceOrientation(amount, currencySymbol){
    if(currencySymbol == '€') {
      return amount + " " +  currencySymbol;
    } else if(currencySymbol == 'USD' || currencySymbol == 'CAD' || currencySymbol == 'MXN') {
      return "$" + amount;
    } else if(currencySymbol == 'EUR') {
      return amount + "€";
    } else if(currencySymbol == 'GBP') {
      return "£" + amount;
    } else {
      return currencySymbol + amount;
    }
  }

  function getPriceOrientated(amount){
    var currencySymbol = getCurrencySymbol(I18n.locale);
    return getPriceOrientation(amount, currencySymbol);
  }

  var viewingCart = {
    AURA_INK_GRAPHITE: 0,
    AURA_INK_GRAPHITE_10: 0,
    ASTRA_MOONSTONE: 0,
    ASPEN_INK_MAT: 0,
    ASPEN_CLAY_MAT: 0,
    WALDEN_INK_MAT: 0,
    WALDEN_CLAY_MAT: 0,
    ARAM_SILVER: 0,
    IVORY: 0,
    SLATE: 0,
    STARDUST: 0,
    CHARCOAL: 0,
    QUARTZ: 0,
    WALNUT: 0,
    STONE: 0,
    GRAPHITE: 0,
    WHITE_QUARTZ: 0,
    WARM_STONE: 0,
    PEBBLE: 0,
    SANDSTONE: 0,
    GRAVEL: 0,
    SEA_SALT: 0,
    BLUE_CHALK: 0,
    CARVER_MAT: 0,
    CARVER_MAT_CLAY: 0,
    CARVER_MAT_CHESTNUT_BROWN: 0,
    CARVER_MAT_STEALTH_BLACK: 0,
    CARVER_MAT_FOREST_GREEN: 0,
    CARVER_MAT_ARCTIC_WHITE: 0,
    CARVER_MAT_MIDNIGHT_BLUE: 0,
    CARVER_CLAY_MAT_CHESTNUT_BROWN: 0,
    CARVER_CLAY_MAT_STEALTH_BLACK: 0,
    CARVER_CLAY_MAT_FOREST_GREEN: 0,
    CARVER_CLAY_MAT_ARCTIC_WHITE: 0,
    CARVER_CLAY_MAT_MIDNIGHT_BLUE: 0,
    CARVER_GRAVEL: 0,
    CARVER_SEA_SALT: 0,
    CARVER_CLAY_MAT: 0,
    CARVER_CHARCOAL: 0,
    STONE_BASALT: 0,
    STONE_BOULDER: 0,
    WHITE_CHALK: 0,
    MICA: 0,
    SHALE: 0,
    BLACK_ONYX: 0,
    PLATINUM_ROSE: 0,
    PARKER_REEDED_LIMESTONE: 0,
    PARKER_REEDED_SLATE: 0
  }

  var isCartOpen = false;
  var isOverlayShowing = false;
  var toggleTimeout;
  var overlayEnterTimeout;
  var overlayLeaveTimeout;
  var $quickAddButtons = $(getClassSelector(SELECTORS.QUICK_ADD));

  var $promoButtons = $(getClassSelector(SELECTORS.QUICK_ADD_TW));

  function getDefaultColor() {
    var activeColor;
    $('body').attr('class').split(' ').forEach(function (className) {
      if (className.match(/active-color-/)) {
        var split = className.split('active-color-');
        activeColor = COLOR_TO_ENUM[split[split.length - 1]];
      }
    });

    return COLORS[activeColor] || COLORS.CARVER_MAT;
  }

  function getDefaultFrameGroup(color) {
    return GROUPS[color]
  }

  function showOverlay() {
    isOverlayShowing = true;
    clearTimeout(overlayLeaveTimeout)
    var $overlay = $(getClassSelector(SELECTORS.OVERLAY));
    $overlay.removeClass(CLASSES.OVERLAY_LEAVE);
    $overlay.removeClass(CLASSES.OVERLAY_HIDE);
    $overlay.addClass(CLASSES.OVERLAY_ENTER);
    overlayEnterTimeout = setTimeout(function () {
      $overlay.addClass(CLASSES.OVERLAY_ENTER_ACTIVE)
    }, 1);
  }
  window.showOverlay = showOverlay;

  function hideOverlay() {
    isOverlayShowing = false;
    var $overlay = $(getClassSelector(SELECTORS.OVERLAY));
    clearTimeout(overlayEnterTimeout);
    $overlay.removeClass(CLASSES.OVERLAY_ENTER);
    $overlay.removeClass(CLASSES.OVERLAY_ENTER_ACTIVE);
    $overlay.addClass(CLASSES.OVERLAY_LEAVE);
    $overlay.addClass(CLASSES.OVERLAY_LEAVE_ACTIVE);
    overlayLeaveTimeout = setTimeout(function () {
      $overlay.addClass(CLASSES.OVERLAY_HIDE)
    }, 300);
  }
  window.hideOverlay = hideOverlay;

  function numberWithCommas(n) {
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  function numberWithSpaces(n) {
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  }

  function formatPriceWithLocaleDelimiter(amount) {
    var numericValue = parseFloat(amount);

    if (isNaN(numericValue)) {
      return amount;
    }
  
    // Remove floating precision issues
    numericValue = Math.round(numericValue * 100) / 100;
  
    // Determine if it has cents
    var hasCents = numericValue % 1 !== 0;
  
    // Force proper decimal formatting BEFORE delimiters
    var formattedNumber = hasCents
      ? numericValue.toFixed(2)
      : numericValue.toFixed(0);
  
    switch (I18n.locale) {
      case 'fr':
      case 'fr-LU':
      case 'fr-NL':
      case 'fr-BE':
        return numberWithSpaces(formattedNumber);
      default:
        return numberWithCommas(formattedNumber);
    }
  }

  function getClassSelector(value) {
    return '.' + value;
  }

  function setActiveFrameGroup(color) {
    activeFrameGroup = getDefaultFrameGroup(color);
  }

  function isGiftingPage() {
    return $('body').hasClass("gifting-page");
  }

  function isOrderPage() {
    return $('body').hasClass("order-page");
  }

  function isHomePage() {
    return $('body').hasClass("home-page");
  }

  function isShopFramesPage() {
    return $('body').hasClass("shop-frames");
  }

  function isFeaturedFramesPage() {
    return $('body').hasClass("featured-frames");
  }

  function isCartPage() {
    return $('body').hasClass("cart-page");
  }

  function isInStorePickupPage() {
    return $('body').hasClass("in-store-pickup");
  }

  function isCorporateGifting() {
    return document.body.classList.contains("corporate-gifting");
  }

  function isGiftGuide() {
    return document.body.classList.contains("gift-guide");
  }

  function isShopAllPage() {
    return $('body').hasClass("shop-all");
  }

  function getFrameColorFromUrl() {
    var params = window.location.pathname.split('/')
    for (var i = 0; i < params.length; i++) {
      if (params.length == 4 && params[i] == 'color') {
        return params[i+1]
      }
    }
    return null;
  }

  function setActiveFrameFromUrl() {
    var color = getFrameColorFromUrl();
    if (COLOR_TO_ENUM[color]) {
      setActiveFrame(COLOR_TO_ENUM[color]);
    } else {
      setActiveFrame(COLOR_TO_ENUM[getDefaultColor()]);
    }
    setActiveFrameGroup(activeFrame);
  }

  function setActiveFrame(color) {
    activeFrame = COLORS[color] || getDefaultColor();
  }

  function setElementImageAttributes($element, imagePath, imagePathWebp) {

    // Check if the parent of the element is a <picture> tag
    if ($element.parent().is('picture')) {
        // Find the <source> elements within the <picture> tag
        var $sources = $element.parent().find('source');

        // Modify attributes for <source> elements based on image type
        $sources.each(function() {
            var $source = $(this);
            var type = $source.attr('type');
            if (type === 'image/webp') {
                $source.attr('srcset', imagePathWebp);
                $source.attr('data-srcset', imagePathWebp);
            } else if (type === 'image/jpeg') {
                $source.attr('srcset', imagePath);
                $source.attr('data-srcset', imagePath);
            }
        });

        // Modify attributes for the <img> element
        $element.attr('src', imagePath);
        $element.attr('data-src', imagePath);
    } else {
        // Modify attributes for other cases
        $element.attr('src', imagePath);
        $element.attr('data-src', imagePath);
    }
  }

  function setElementAlt($element, alt) {
    $element.attr('alt', alt);
  }

  function setElementClass($element, className) {
    $element.attr('class', className);
  }

  function setImageGalleryAttributes($selector, imageGallery, imageGalleryWebp, details, skipFirst = false) {
    $selector.each(function (index, element) {
        var $element = $(element);
        var imagePath = imageGallery[index];
        var imagePathWebp = imageGalleryWebp[index];
        if (skipFirst && index === 0 || details.hasVideo && (index === 2 || index === 4)) {
            return;
        }
        setElementImageAttributes($element, imagePath, imagePathWebp);
    });
  }

  function toggleActiveImage($selector, ariaAttr) {
    var activeAttr = ariaAttr || 'aria-selected';

    $selector.each(function (index, element) {
      var $element = $(element); // Convert DOM element to jQuery object
      if (activeImageIndex === index) {
        $element.addClass('is-active');
        $element.parent().addClass('is-active');
        $element.parent().parent().find('*').addClass('is-active');
        $element.parent().parent().attr(activeAttr, 'true');
      } else {
        $element.removeClass('is-active');
        $element.parent().removeClass('is-active');
        $element.parent().parent().find('*').removeClass('is-active');
        $element.parent().parent().attr(activeAttr, 'false');
      }
    });
  }

  function renderActiveThumbnailImage() {
    var $containers = $('.action--thumbnails-wrapper');
    $containers.each(function (index, container) {
      var $container = $(container);
      var $thumbnails = $container.find("img." +  SELECTORS.THUMBNAIL);
      toggleActiveImage($thumbnails, 'aria-pressed');
    });
  }

  function renderThumbnailImages(details) {
    if (!details) return;
    var imgthumbPath = details.galleryThumbImgs;
    var imgthumbPathWebp = details.galleryThumbImgsWebp;
    if (!imgthumbPath) return;
    var imageThumbGallery = imgthumbPath.split(',');
    if (!imgthumbPathWebp) return;
    var imageThumbGalleryWebp = imgthumbPathWebp.split(',');

    Array.from($thumbnailContainers).forEach(function(thumbnailContainer) {
      var $thumbnailContainer = $(thumbnailContainer);
      var $thumbnailImages = $thumbnailContainer.find("img." + SELECTORS.THUMBNAIL_IMAGE);
      setImageGalleryAttributes($thumbnailImages, imageThumbGallery, imageThumbGalleryWebp, details, false);
    });
  }

  function renderMainActiveImage() {
    var $mainImage = $("img." + SELECTORS.MAIN_IMAGE);
    toggleActiveImage($mainImage);
  }

  function renderMainImages(details) {
    if (!details) return;
    var imgPath = details.galleryImgs;
    var imgPathWebp = details.galleryImgsWebp;
    if (!imgPath) return;
    var imageGallery = imgPath.split(',');
    if (!imgPathWebp) return;
    var imageGalleryWebp = imgPathWebp.split(',');
    var $mainImages = $("img." + SELECTORS.MAIN_IMAGE);

    setImageGalleryAttributes($mainImages, imageGallery, imageGalleryWebp, details, false);
  }

  function renderHPCollectionImages($selection, imgPath, imgPathWebp, details) {
    setElementImageAttributes($selection, imgPath, imgPathWebp);
    setElementAlt($selection, details.collectionAlt);
    setElementClass($selection, `product-image product-image--${details.class} ${details.class} ${details.collection} action--hp-image absolute top-0 left-0`);
  }

  function renderHPCollectionHoverImages($selection, imgPath, imgPathWebp, details) {
    setElementImageAttributes($selection, imgPath, imgPathWebp);
    setElementAlt($selection, details.collectionAlt);
    setElementClass($selection, `product-image product-image-hover product-image--${details.class}-hover ${details.class} ${details.collection} action--hp-image-hover absolute top-0 left-0`);
  }

  function slateCheck(){
    return $('body').hasClass('active-color-slate')
  }

  function incrementIndex() {
    setImageIndex(activeImageIndex + 1);
    if(slateCheck()){
      if (activeImageIndex > maxIndex) {
        setImageIndex(minIndex)
      }
    } else {
      if (activeImageIndex > maxIndex) {
        setImageIndex(minIndex)
      }
    }
  }

  function decrementIndex() {
    setImageIndex(activeImageIndex - 1)
    if (activeImageIndex < minIndex) {
      setImageIndex(maxIndex)
    }
  }

  function setImageIndex(value) {
    activeImageIndex = value;
    sendSwitchImageAnalytics(value);
  }

  function renderQuantity(color) {
    var setColor = color || COLOR_TO_ENUM[activeFrame];
    var quantity = viewingCart[setColor] || 1;
    viewingCart[setColor] = quantity;
    $(getClassSelector(SELECTORS.QUANTITY)).val(Number(quantity));

    if (quantity < 2) {
      renderDisableDecrementQuantity();
    } else {
      renderEnableDecrementQuantity();
    }

    if (quantity >= 999) {
      renderDisableIncrementQuantity();
    } else {
      renderEnableIncrementQuantity();
    }
  }

  function setQuantity(color, quantity) {
    viewingCart[color || COLOR_TO_ENUM[activeFrame]] = quantity;
  }

  function incrementQuantity() {
    var quantity = viewingCart[COLOR_TO_ENUM[activeFrame]];
    if (quantity === 0) {
      viewingCart[COLOR_TO_ENUM[activeFrame]] = 2;
    } else {
      viewingCart[COLOR_TO_ENUM[activeFrame]] += 1;
    }

    if (viewingCart[COLOR_TO_ENUM[activeFrame]] >= 999) {
      viewingCart[COLOR_TO_ENUM[activeFrame]] = 999;
    }

    sendUpdateCartItemIncrementAnalytics(activeFrame, 1)
  }

  function decrementQuantity() {
    viewingCart[COLOR_TO_ENUM[activeFrame]] -= 1;
    if (viewingCart[COLOR_TO_ENUM[activeFrame]] < 0) {
      viewingCart[COLOR_TO_ENUM[activeFrame]] = 0;
    }

    sendUpdateCartItemDecrementAnalytics(activeFrame, 1)
  }

  function updateViewingQuantity(newQuantity) {
    if (!$.isNumeric(newQuantity)) return;
    if (newQuantity < 1) newQuantity = 1;
    if (newQuantity > 999) newQuantity = 999;
    if (newQuantity) {
      viewingCart[COLOR_TO_ENUM[activeFrame]] = newQuantity;
    }
  }

  function clearCart() {
    window.localStorage && window.localStorage.removeItem('shopify_cart');
  }

  function renderDisableDecrementQuantity() {
    $(getClassSelector(SELECTORS.DECREMENT_QUANTITY)).addClass(CLASSES.DISABLED)
  }

  function renderEnableDecrementQuantity() {
    $(getClassSelector(SELECTORS.DECREMENT_QUANTITY)).removeClass(CLASSES.DISABLED)
  }

  function renderDisableIncrementQuantity() {
    $(getClassSelector(SELECTORS.INCREMENT_QUANTITY)).addClass(CLASSES.DISABLED)
  }

  function renderEnableIncrementQuantity() {
    $(getClassSelector(SELECTORS.INCREMENT_QUANTITY)).removeClass(CLASSES.DISABLED)
  }

  function renderSelectedColor() {
    var $body = $('body');
    $('body').attr('class').split(' ').forEach(function (className) {
      if (className.match(/active-(color|collection)-/)) {
        $body.removeClass(className);
      }
    });
    $body.addClass('active-color-' + activeFrame);
  }

  function setPriceElements(originalFramePrice, framePrice, discountData) {
    var originalFramePriceCurrency = getPriceOrientation(originalFramePrice, getCurrencySymbol(I18n.locale));
    var framePriceCurrency = getPriceOrientation(framePrice, getCurrencySymbol(I18n.locale));
    var $priceVal = $(getClassSelector(SELECTORS.PRICE_VALUE));
    var $originalVal = $(getClassSelector(SELECTORS.PRICE_ORIGINAL_VALUE));
    var $original = $(getClassSelector(SELECTORS.PRICE_ORIGINAL));

    $priceVal.text(framePriceCurrency);
    displayKlarnaPdpMessage(framePrice);

    if (originalFramePrice && originalFramePriceCurrency != framePriceCurrency) {
      $original.removeClass('hide');
      $originalVal.text(originalFramePriceCurrency);
    } else {
      $original.addClass('hide');
    }

    if (discountData) {
      $originalVal.attr('data-discount-code-type', discount_code_type());
      $originalVal.attr('data-discount-code', discountCodeTitleFromCookie());
      $priceVal.attr('data-discount-code-type', discount_code_type());
      $priceVal.attr('data-discount-code', discountCodeTitleFromCookie());
    } else {
      $originalVal.removeAttr('data-discount-code-type');
      $originalVal.removeAttr('data-discount-code');
      $priceVal.removeAttr('data-discount-code-type');
      $priceVal.removeAttr('data-discount-code');
    }
  }

  function displayKlarnaPdpMessage(framePrice) {
    var $klarnaMessage = $(getClassSelector('klarna-message'));
    if (!$klarnaMessage.length) return;
    var framePrice = (framePrice * 100);
    $klarnaMessage.find('klarna-placement').attr('data-purchase-amount', framePrice);
  }

  // Price includes automatic discounts (promo)
  function calculateFramePrice(frameDetails) {
    if (!frameDetails || !frameDetails.price) {
      return 0;
    }
    const price = Number(frameDetails.price);
    if (Number.isNaN(price)) {
      return 0;
    }
    if (Number.isInteger(price)) {
      return price;
    }

    return price;
  }

  // Strike price is the price before any discounts if discount is applied
  function calculateStrikePrice(frameDetails, bundled = false) {
    if (!frameDetails) {
      return 0;
    }
  
    var originalPrice = Number(frameDetails.originalPrice);
    var price = Number(frameDetails.price);

    if (Number.isNaN(originalPrice)) {
      originalPrice = 0;
    }
    if (Number.isNaN(price)) {
      price = 0;
    }
  
    if (bundled) {
      return originalPrice > 0 ? originalPrice : price;
    }
    return originalPrice;
  }

  function renderPricing(mainFrame, frames, bundled) {
    var framePriceSum = 0 // total of all the actual prices
    var bundlePriceSum = 0 // the original undiscounted total of all frames
    if (bundled && (bundleChecked() || collectiveBundleUpsellChecked())  && frames) { // a bundled or collective item has been selected
      frames.forEach(function (frameDetails) {
        framePriceSum += calculateFramePrice(frameDetails);
        bundlePriceSum += calculateStrikePrice(frameDetails, true);
      })
      let bundleDiscount = getBundleDiscount();
      framePriceSum = framePriceSum - bundleDiscount;
    }  else { // display just the main frame price
      framePriceSum = calculateFramePrice(mainFrame);
      bundlePriceSum = calculateStrikePrice(mainFrame);
    }
    setPriceElements(bundlePriceSum, framePriceSum, false);
    if (bundlePriceSum > 0 && framePriceSum > 0) {
      var amountOff = bundlePriceSum - framePriceSum;
      if (!isNaN(amountOff) && amountOff) {
        updatePriceInText(".action--shop-frames-price-badge", mainFrame.collection, amountOff) ;
      }
    }
  }

  function renderPrice() {
    var mainFrameDetails = window.getFrameDetailsByColor(activeFrame);
    renderPricing(mainFrameDetails, null, false);
  }

  function renderBundlePricing(bundleFrameDetails) {
    var mainFrameDetails = window.getFrameDetailsByColor(activeFrame);
    var frames = [mainFrameDetails, bundleFrameDetails]
    renderPricing(mainFrameDetails, frames, true);
  }

  function renderCollectiveBundlePricing() {
    let allCollectiveVariants = window.grabAllCollectiveVariants();
    let activeCollectiveVariantColor = document.querySelector('#action--collective-bundle-cta').dataset.value;
    let activeCollectiveVariantDetails = allCollectiveVariants.find(item =>
      item.title.toLowerCase() === activeCollectiveVariantColor.toLowerCase()
    );
    const mainFrame = getFrameColorFromUrl();
    let mainFrameDetails = window.getFrameDetailsByColor(mainFrame);
    let frames = [mainFrameDetails, activeCollectiveVariantDetails];
    renderPricing(mainFrameDetails, frames, true)
  }

  function getSiteDetails() {
    return $(getClassSelector(SELECTORS.SITE_DETAILS)).data() || {};
  }

  function findShopFeaturedProducts() {
    return Array.from(document.querySelectorAll('.action--featured-carousel-shop--section .action--featured-shop-section-product'));
  }

  function findShopFramesFeaturedProduct() {
    return Array.from(
      document.querySelectorAll('.shop-frames-featured-image.action--shop-frames-featured')
    ).map(el => el.dataset.sku);
  }

  function findShopAllProducts() {
    return Array.from(document.querySelectorAll('.action--shop-section-product'));
  }

  function getMCFProductsByShopSection() {
    var shopAllProducts = findShopAllProducts();

    if (!shopAllProducts.length) return null;

    const foundFrames = shopAllProducts.filter(element => element.dataset.mcf === "true")

    if (!foundFrames.length) return null;
    return foundFrames.map((element) => element.dataset.sku);
  }

  function getProductsByFeaturedSection() {
    var featuredShopProducts = findShopFeaturedProducts();

    if (!featuredShopProducts.length) return null;

    if (!featuredShopProducts.length) return null;
    return featuredShopProducts.map((element) => element.dataset.sku);
  }

  function getProductsByShopFramesFeaturedSection() {
    var featuredShopProducts = findShopFramesFeaturedProduct();

    if (!featuredShopProducts.length) return null;

    if (!featuredShopProducts.length) return null;
    return featuredShopProducts;
  }

  async function updateCartItem(color, newQuantity) {
    if (!color || newQuantity == null) return null;
    const cartId = getShopifyCartId();
    if (cartId && cartId.length > 0) {
      const updatedCart = await updateLineShopifyCart(color, newQuantity, cartId);
      if (updatedCart) {
        return updatedCart;
      }
    }
  }

  function setBundlingCopy($item, bundle) {
    if (showBundlingMiniCart()) {
      if (enableDiscountInput()) {
        if (bundle) {
          $(getClassSelector(SELECTORS.CART_DISCOUNT_CODE_CONTAINER)).removeClass('hide');
          $(getClassSelector(SELECTORS.CART_DISCOUNT_BUNDLE)).removeClass('hide');
        } else {
          $(getClassSelector(SELECTORS.CART_DISCOUNT_BUNDLE)).addClass('hide');
        }
      } else {
        var $bundleInfo = $item.find(getClassSelector(SELECTORS.CART_ITEM_BUNDLE));
        $bundleInfo.text(getBundleText(I18n.locale, bundle)).removeClass('hide');
      }
    }
  }

  function findCartItemByDataType(dataType) {
    var $cartItems = $(getClassSelector(SELECTORS.CART_POPUP))
      .find(getClassSelector(SELECTORS.CART_ITEM));

    var matchingItems = $cartItems.filter(function (index, item) {
      var dataValue = $(item).data(dataType);
      return dataValue !== false && dataValue !== undefined && dataValue !== "";
    }).map(function (index, item) {
      return {
        index: index,
        item: item
      };
    }).get();

    return matchingItems;
  }

  function findCartItemIndex() {
    var totalQuantity = getCartItemCount();
    var itemsWithQuantity = findCartItemByDataType('quantity');
    var itemsNotEligibleForBundleDiscount = findCartItemByDataType('iscollective');
    itemsWithQuantity = removeCollectiveItemsFromBundleDiscountItems(itemsWithQuantity, itemsNotEligibleForBundleDiscount)
    itemsWithQuantity.forEach(function (quantityItem, index) {
      var $item = $(quantityItem.item);
      var quantity = $item.data('quantity');

      if (itemsWithQuantity.length <= 1) {
        if (index === 0) {
          if (quantity <= 1) {
            setBundlingCopy($item, false);
          } else {
            setBundlingCopy($item, true);
          }
        }
      } else {
        if (index != 0) {
          if (quantity > 1 || totalQuantity > 1) {
            setBundlingCopy($item, true);
          } else {
            setBundlingCopy($item, false);
          }
        }
      }
    });
  }

  function removeCollectiveItemsFromBundleDiscountItems(itemsWithQuantity, collectiveItems) {
    var collectiveElements = collectiveItems.map(i => i.item);
  
    return itemsWithQuantity.filter(function (item) {
      return !collectiveElements.includes(item.item);
    });
  }

  async function updateCart(color) {
    var cart = getSavedShopifyCart() || {};
    var cartId = getShopifyCartId();
    var currentQuantity = 0;
    var value = 0;
    var hasMatchingLineItem = false;
    if (cartHasLineItems(cart)) {
      cart.lines.edges.some((line) => {
        if (line.node.merchandise.id == `gid://shopify/ProductVariant/${colorToShopifyId(color)}`) {
          currentQuantity = line.node.quantity;
          value = parseInt(line.node.cost.totalAmount.amount);
          hasMatchingLineItem = true;
        }
      });
    }
    var quantityToAdd = viewingCart[color] || 1;
    var updatedCart;
    if (cart && Object.keys(cart).length > 0 && cartId && cartId.length > 0) {
      if (hasMatchingLineItem) {
        updatedCart = await updateLineShopifyCart(color, currentQuantity + quantityToAdd, cartId);
      } else {
        updatedCart = await addLinesShopifyCart({[color]: {quantity: quantityToAdd}}, cartId);
      }
    } else {
      updatedCart = await createShopifyCart({[color]: {quantity: quantityToAdd}});
    }
    if (updatedCart) {
      updatedCart.lines.edges.forEach(function (line) {
        if (line.node.merchandise.id == `gid://shopify/ProductVariant/${colorToShopifyId(color)}`) {
          currentQuantity = line.node.quantity;
          var currentTotal = parseInt(line.node.cost.totalAmount.amount);
          value = currentTotal - value;
        }
      });
      sendAddToCartAnalytics(color, quantityToAdd, value);
    }
    return updatedCart;
  }

  async function removeColorFromCart(color) {
    var cartId = getShopifyCartId();
    var cart = getSavedShopifyCart();
    var currentAmount;
    var lineItemSubtotal;

    if (cartId && cartId.length > 0) {
      if (cartHasLineItems(cart)) {
        cart.lines.edges.some((line) => {
          if (line.node.merchandise.id == `gid://shopify/ProductVariant/${colorToShopifyId(color)}`) {
            currentAmount = line.node.quantity;
            if (line.node.cost && line.node.cost.totalAmount && line.node.cost.totalAmount.amount) {
              lineItemSubtotal = parseInt(line.node.cost.totalAmount.amount);
            }
          }
        });
      }
      const updatedCart = await removeLinesShopifyCart([color], cartId);
      if (updatedCart) {
        viewingCart[color] = 0;
        sendRemoveFromCartAnalytics(color, currentAmount, lineItemSubtotal);
        return updatedCart;
      }
    }
  }

  function getCartItemCount() {
    const cart = getSavedShopifyCart() || {};
    if (cartHasLineItems(cart)) {
      return cart.lines.edges.reduce((sum, item) => sum + item.node.quantity, 0);
    } else {
      return 0;
    }
  }

  function renderCartCount() {
    var $cart = $(getClassSelector(SELECTORS.CART_COUNT))
    var $cartButton = $(getClassSelector(SELECTORS.CART_OPENER));
    if ($cart.length > 0 && $cartButton.length > 0) {
      var count = getCartItemCount();
      var currentCount = Number($cart.text());

      if (count === 0) {
        $cart.addClass(CLASSES.EMPTY);
      } else {
        $cart.removeClass(CLASSES.EMPTY);
      }
      if (count !== currentCount) {
        $cart.text(count);
        animateCartAddition();
      }

      $cartButton.attr(
        'aria-description',
        $cartButton.attr('aria-description').replace(/\d+/, count)
      );
      $cartButton.attr(
        'aria-label',
        $cartButton.attr('aria-label').replace(/\d+/, count)
      );
    }
  }

  function replaceHref(querySelector, link) {
    if (!querySelector || !link || typeof querySelector !== 'string' || typeof link !== 'string' || link.trim() === '') {
      return null;
    }

    const elements = document.querySelectorAll(querySelector);

    if (elements.length === 0) {
      return null;
    }

    elements.forEach((element) => {
      element.setAttribute('href', link);
    });
  }


  function replaceInnerHTML(querySelector, newText, removeHide) {
    if (!querySelector || !newText || typeof querySelector !== 'string' || typeof newText !== 'string' || newText.trim() === '') {
      return null;
    }

    const elements = document.querySelectorAll(querySelector);

    if (elements.length === 0) {
      return null;
    }

    if (typeof removeHide !== 'boolean') {
      return null;
    }

    elements.forEach((element) => {
      element.innerHTML = newText;

      element.setAttribute('data-discount-code-type', discount_code_type());
      element.setAttribute('data-discount-code', discountCodeTitleFromCookie());

      if (removeHide) {
        element.classList.remove('hide');
      }
    });
  }

  function removeHide(querySelector) {
    const elements = document.querySelectorAll(querySelector);
    elements.forEach((element) => {
      element.classList.remove('hide');
    });
  }

  function deleteCookie(name) {
    const domain = `.${location.hostname}`; // Adjust as needed for subdomain access
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain}`;
  }

  function getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].split('=');
      if (cookie[0] === name) {
        return decodeURIComponent(cookie[1]);
      }
    }
    return null;
  }

  // Delete VWO inactive cookies (campaign ids 266 or less)
  function expireInactiveVWOCookies(maxCampaignId = 266) {
    document.cookie.split(";").forEach(cookie => {
      const name = cookie.split("=")[0].trim();
      const match = name.match(/^_vis_opt_exp_(\d+)_/);

      if (!match) return;

      const campaignId = Number(match[1]);

      if (campaignId <= maxCampaignId) {
        deleteCookie(name);
      }
    });
  }

  function discount_code_type() {
    const discountCookie = getCookie('discount');
    if (discountCookie) {
      const discountObj = JSON.parse(discountCookie);
      return discountObj['type'];
    }
    return null;
  }

  function discountTitleFromUrl() {
    let uri = window.location.pathname.toLowerCase();
    let codeBasedCookie = getCookie('discount');
    let mainFrameDetails = window.getFrameDetailsByColor(activeFrame);
    if(uri.includes('/prime')) {
      let siteDetails = getSiteDetails();
      let discountCode = siteDetails['discountCode'];
      let pricerule = siteDetails['pricerule'];
      if(discountCode && pricerule) {
        let cookieValue = JSON.stringify({ title: discountCode, type: 'promo_code' })
        setCookie('discount', cookieValue, new Date(pricerule['content']['ends_at']));
      }
      return discountCode;
    } else if (codeBasedCookie) {
      return codeBasedCookie;
    } else if (mainFrameDetails.discountCodeProduct) {
      // FIXME: This is brittle and should be refactored
      return mainFrameDetails.discountMessagePromo.split(/ /).pop();
    } else {
      return false
    }
  }

  function discount_code_data_by_type(frameDetails, data) {
    if (!frameDetails || !data) {
      return null;
    }
    var discountCodeData;

    switch (discount_code_type()) {
      case "promo_code":
        discountCodeData = frameDetails[data + "promo_code"];
        break;
      case "email_code":
        discountCodeData = frameDetails[data + "email_code"];
        break;
      case "podcast_code":
        discountCodeData = frameDetails[data + "podcast_code"];
        break;
        default:
          discountCodeData = frameDetails[data + "promo"];
        break;
    }

    return  discountCodeData;
  }

  function renderDiscountCodeCopy() {
    var discountCode = discountTitleFromUrl() || discountCodeTitleFromCookie() || false;

    if (!discountCode) {
      return;
    }
    var frameDetails = window.getFrameDetailsByColor(activeFrame);
    var siteDetails = getSiteDetails();

    if (renderEyebrowDiscountCode(siteDetails) != null) {
      renderEyebrowDiscountCode(siteDetails);
    }

    if (frameDetails.discountCodeProduct == true) {
      renderDiscountCodePDP(frameDetails);
    }

    findRenderDiscountCodeProduct(".action--has-discount-code-product");

    function findRenderDiscountCodeProduct(selector) {
      var elements = document.querySelectorAll(selector);

      elements.forEach((element) => {
        let dataColor = element.getAttribute('data-color');
        var discountProductDetails = window.getFrameDetailsByColor(dataColor);

        renderDiscountCodeHP(discountProductDetails);
        renderDiscountCodePriceNav(discountProductDetails);
      });
    }
    renderDiscountCodeShipping();
  }

  function renderDiscountCodeShipping() {
    var activeFrameDetails = window.getFrameDetailsByColor(activeFrame);
    var discountCodeMessage = discount_code_data_by_type(activeFrameDetails, 'discount_message');
    var discountTitle = discountCodeTitleFromCookie();
    var hasDiscountTitle = discountTitle !== undefined && discountTitle !== null;
    var match = /Code\s+([A-Z0-9]+)/i.exec(discountCodeMessage);

    if (activeFrameDetails.discountCodeProduct) {
      var elements = document.querySelectorAll(".shipping-estimate__message");

      elements.forEach((element) => {
        var discountCodeSpan = element.querySelector(".discount_code");

        if (discountCodeSpan) {
          var codeValue = hasDiscountTitle ? discountTitle : (match ? match[1] : "");

          discountCodeSpan.innerText = codeValue;
        }
      });
    }
  }

  function replaceDiscountCode(selection) {
    const discountCode = discountCodeTitleFromCookie();
    const discountSelection = `${selection} .discount_code`;
    replaceInnerHTML(discountSelection, discountCode, true);
  }

  function replaceDiscountMessage(selection, frameDetails, data) {
    const discountMessage = discount_code_data_by_type(frameDetails, data);

    replaceInnerHTML(selection, discountMessage, true);
    replaceDiscountCode(selection);
  }

  function renderDiscountCodeMessage(selection, frameDetails) {
    replaceDiscountMessage(selection, frameDetails, 'discount_message');
  }

  function renderDiscountCodeHP(frameDetails) {
    renderDiscountCodeMessageHP(frameDetails)
    renderDiscountCodePriceHP(frameDetails)
  }

  function renderDiscountCodeMessageHP(frameDetails) {
    renderDiscountCodeMessage((".action--discount-code-hp." + frameDetails.collection), frameDetails);
    renderDiscountCodeMessage((".action--shop-frames-discount-code-hp." + frameDetails.collection), frameDetails);
  }

  function findFrameSetProduct(frameDetails) {
    const selector = `.frame-set-product[data-color="${frameDetails.class}"]`;
    const product = document.querySelector(selector);
    return !!(product && product.getAttribute('data-frame-set') === 'true');
  }

  function bundleFrameSetPrice(frame_set_bundle, price) {
    if (frame_set_bundle) {
      return price * 2;
    } else {
      return price;
    }
  }

  function renderDiscountCodePriceHP(frameDetails) {
    const is_frame_set = findFrameSetProduct(frameDetails);
    const discountPrice = discount_code_data_by_type(frameDetails, 'discount_price');
    replaceInnerHTML(((is_frame_set ? ".frame-set-product .action--price" : ".action--price") + `[data-color="${frameDetails.class}"]`), bundleFrameSetPrice(is_frame_set, discountPrice), true);
    removeHide('.action--price-strike-wrapper');
    replaceInnerHTML(((is_frame_set ? ".frame-set-product .action--price-strike" : ".action--price-strike") + `[data-color="${frameDetails.class}"]`), currencySymbol + (frameDetails.originalPrice ? bundleFrameSetPrice(is_frame_set, frameDetails.originalPrice) : bundleFrameSetPrice(is_frame_set, frameDetails.price)), true);
    replaceInnerHTML(((is_frame_set ? ".frame-set-product .action--shop-frames-price" : ".action--shop-frames-price") + `[data-color="${frameDetails.class}"]`), bundleFrameSetPrice(is_frame_set, discountPrice), true);
    removeHide('.action--shop-frames-price-strike-wrapper');
    replaceInnerHTML(((is_frame_set ? ".frame-set-product .action--shop-frames-price-strike" : ".action--shop-frames-price-strike") + `[data-color="${frameDetails.class}"]`), currencySymbol + (frameDetails.originalPrice ? bundleFrameSetPrice(is_frame_set, frameDetails.originalPrice) : bundleFrameSetPrice(is_frame_set, frameDetails.price)), true);
    renderDiscountCodeBadgePrice(".action--sale-badge", frameDetails)
  }

  function renderDiscountCodePriceNav(frameDetails) {
    const discountPrice = discount_code_data_by_type(frameDetails, 'discount_price');
    replaceInnerHTML((".action---nav-price." + frameDetails.collection), discountPrice && currencySymbol + discountPrice, true);
    removeHide('.action--nav-price-strike-wrapper');
    replaceInnerHTML((".action--nav-price-strike." + frameDetails.collection), currencySymbol + (frameDetails.originalPrice ? frameDetails.originalPrice : frameDetails.price), true);
    replaceInnerHTML((".action--nav-shop-frames-price." + frameDetails.collection), discountPrice && currencySymbol + discountPrice, true);
    removeHide('.action--nav-shop-frames-price-strike-wrapper');
    replaceInnerHTML((".action--nav-shop-frames-price-strike." + frameDetails.collection), currencySymbol + (frameDetails.originalPrice ? frameDetails.originalPrice : frameDetails.price), true);
  }

  function renderDiscountCodePDP(frameDetails){
    renderDiscountCodeMessagePDP(frameDetails);
    renderDiscountCodeBadgePricePDP(frameDetails);
    renderDiscountCodePriceStrikePDP(frameDetails);
  }

  function renderDiscountCodeBadgePricePDP(frameDetails){
    renderDiscountCodeBadgePrice(".action--image-selector .action--sale-badge", frameDetails)
  }
  function renderDiscountBadgePricePDP(frameDetails){
    renderDiscountCodeBadgePrice(".action--image-selector .action--sale-badge", frameDetails)
  }

  function renderDiscountCodePriceStrikePDP(frameDetails){
    removeHide('.action--price-value-strike-wrapper')
    replaceInnerHTML('.action--price-value-strike', bundleFrameSetPrice(bundleChecked(), frameDetails.originalPrice ? frameDetails.originalPrice : frameDetails.price), true)
  }

  function renderDiscountCodeMessagePDP(frameDetails){
    renderDiscountCodeMessage((".action--discount-code-pdp"), frameDetails);
  }

  function renderDiscountCodeBadgePrice(saleBadgeSelector, swatchFrameDetails) {
    let discountCodePrice = discount_code_data_by_type(swatchFrameDetails, 'discount_price')
    let updatedPrice;
    if (discountCodePrice === undefined || discountCodePrice === null || discountCodePrice == "") {
      discountCodePrice = swatchFrameDetails.discountAmount
      updatedPrice = discountCodePrice
    } else {
      updatedPrice = swatchFrameDetails.price - discountCodePrice
    }
    const saleBadges = document.querySelectorAll(saleBadgeSelector);
    const is_frame_set = findFrameSetProduct(swatchFrameDetails);

    var showDiscountBadge = swatchFrameDetails.showDiscountBadge
    saleBadges.forEach(function(badge){
      const collectionMatch = badge.getAttribute('data-collection') == swatchFrameDetails.collection
      if(collectionMatch && showDiscountBadge !== false && swatchFrameDetails.discountAmount > 0 || bundleChecked()){
        badge.classList.add('active');
        badge.classList.remove('hide');
        badge.setAttribute('data-collection', swatchFrameDetails.collection);
        badge.setAttribute('data-color', swatchFrameDetails.class);
      } else {
        badge.classList.remove('active');
        badge.classList.add('hide');
      }
    })
    const updatedPricing = bundleFrameSetPrice(is_frame_set || bundleChecked(), updatedPrice);
    const updatedFrameSetPricing = is_frame_set || bundleChecked() ? updatedPricing + getBundleDiscount() : updatedPricing;
    updatePriceInText(is_frame_set && !bundleChecked() ? ".frame-set-product .action--shop-frames-price-badge" : ".action--shop-frames-price-badge", swatchFrameDetails.collection, updatedFrameSetPricing) ;
  }

  function renderBadgeMessage(swatchFrameDetails) {
    const badgeMessage = document.querySelectorAll('.action--badge-message');

    badgeMessage.forEach(function(badge){
      const collectionMatch = badge.getAttribute('data-collection') == swatchFrameDetails.collection
      if(collectionMatch && swatchFrameDetails.badgeMessage){
        badge.classList.add('active')
        badge.setAttribute('data-collection', swatchFrameDetails.collection);
        badge.setAttribute('data-color', swatchFrameDetails.class);
        badge.querySelector('span').innerHTML = swatchFrameDetails.badgeMessage
      } else {
        badge.classList.remove('active')
      }
    })
  }

  function renderBarMessage(swatchFrameDetails) {
    const badgeMessage = document.querySelectorAll('.action--bar-message');

    var showDiscountBadge = swatchFrameDetails.showDiscountBadge
    badgeMessage.forEach(function(badge){
      const collectionMatch = badge.getAttribute('data-collection') == swatchFrameDetails.collection
      if(collectionMatch && showDiscountBadge !== false && swatchFrameDetails.barMessage){
        badge.classList.add('active')
        badge.setAttribute('data-collection', swatchFrameDetails.collection);
        badge.setAttribute('data-color', swatchFrameDetails.class);
        badge.textContent = swatchFrameDetails.barMessage
      } else {
        badge.classList.remove('active')
      }
    })
  }

  function updatePriceInText(classSelector, collectionData, discountPrice) {
    var priceBadges = document.querySelectorAll(classSelector);

    priceBadges.forEach(function (priceBadge) {
      const collectionMatch = priceBadge.getAttribute('data-collection') == collectionData
      const currentNumber = parseFloat(priceBadge.textContent.match(/\d+(\.\d+)?/));

      if (collectionMatch && !isNaN(currentNumber)) {
        priceBadge.innerHTML = priceBadge.innerHTML.replace(/\d+(\.\d+)?/, discountPrice);
      }
    });
  }

  function renderEyebrowDiscountCode(siteDetails){
    replaceDiscountMessage('.promo-banner-first', siteDetails, 'discountEyebrowMessage');
    replaceDiscountMessage('.promo-banner-secondary', siteDetails, 'discountEyebrowSecondary');
    const linkHome = discount_code_data_by_type(siteDetails, 'discountEyebrowLinkHome');
    const linkPDP = discount_code_data_by_type(siteDetails, 'discountEyebrowLinkPdp');
    replaceHref('#eyebrowPromoNav', isHomePage() ? linkHome : linkPDP);
  }

  function renderOpenCart(eventLabel) {
    if (eventLabel) {
      logGA4Event('open_cart', {
        input: eventLabel
      });
      logPavedEvent('open_cart', {
        input: eventLabel
      });
    }

    isCartOpen = true;
    var cartTitle = document.querySelector('.cart-title');
    var footer = document.querySelector('.footer');
    var navbar = document.querySelector('.navbar');
    var main = document.querySelector('main');
    var cartPopup = $(getClassSelector(SELECTORS.CART_POPUP));

    // Calculate scrollbar width and set as padding to prevent content shift
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = scrollbarWidth + 'px';
    var header = document.querySelector('header');
    if (header) {
      header.style.paddingRight = scrollbarWidth + 'px';
    }
    if (cartPopup.length) {
      // Make non-cart elements inert (for accessibility)
      if (footer) {
        footer.setAttribute('inert', '');
      }

      navbar.setAttribute('inert', '');
      main.setAttribute('inert', '');

      cartPopup.addClass(CLASSES.OPEN);
      cartPopup.removeAttr('inert');

      $('body').addClass(CLASSES.OPEN);
      hasDiscount();
      $(getClassSelector(SELECTORS.NAVBAR_LIST)).removeClass(CLASSES.SHOW_LIST);
      $(getClassSelector(SELECTORS.NAVBAR)).removeClass(CLASSES.SHOW_LIST);

        if (!isOverlayShowing) {
          showOverlay();
        }
      }
    // Refresh cart from Shopify so checkoutUrl reflects current @inContext (language/country)
    var cartId = getShopifyCartId();
    if (cartId) {
      getShopifyCart(cartId).then(function(cart) {
        if (cart) updateCartUrl();
      }).catch(function(error) {
        console.error('Failed to refresh cart on open:', error);
      });
    }

    // Focus on the cart title for screen readers
    setTimeout(() => {
      cartTitle.focus();

      // Remove focus after screen reader has announced it
      setTimeout(() => {
        cartTitle.blur();
      }, 1200);
    }, 100);
  }

  function stopAutoCloseCountdown() {
    if (toggleTimeout) {
      window.clearTimeout(toggleTimeout);
    }

    toggleTimeout = null;
  }

  function renderCloseCart(eventLabel) {
    if (eventLabel) {
      logGA4Event('close_cart', {
        input: eventLabel
      });
      logPavedEvent('close_cart', {
        input: eventLabel
      });
    }
    isCartOpen = false;
    var footer = document.querySelector('.footer');
    var navbar = document.querySelector('.navbar');
    var main = document.querySelector('main');
    footer.removeAttribute('inert');
    navbar.removeAttribute('inert');
    main.removeAttribute('inert');

    resetChangeBopisStore();

    $(getClassSelector(SELECTORS.CART_POPUP)).removeClass(CLASSES.OPEN);
    $('body').removeClass(CLASSES.OPEN);

    // Remove the padding that was added to compensate for hidden scrollbar
    document.body.style.paddingRight = '';
    var header = document.querySelector('header');
    if (header) {
      header.style.paddingRight = '';
    }
    stopAutoCloseCountdown();
  }

  function clearCartItems() {
    const cartItems = $(getClassSelector(SELECTORS.CART_ITEMS));
    cartItems.attr({ 'inert': '', 'tabindex': '-1' }).empty();
  }

  function showCartItems() {
    const cartItems = $(getClassSelector(SELECTORS.CART_ITEMS));
    cartItems.removeAttr('inert tabindex');
  }

  function animateCartAddition() {
    var $cart = $(getClassSelector(SELECTORS.CART_OPENER))
    $cart.addClass('is-shaking');
    var cartShakeTimeout = window.setTimeout(function () {
      $cart.removeClass('is-shaking')
    }, 500);
  }

  function hideEmptyCartMessage() {
    $(getClassSelector(SELECTORS.CART_EMPTY_MESSAGE)).each(function() {
      $(this).removeClass(CLASSES.SHOWING);
      $(this).attr('inert', '');
      $(this).attr('tabindex', '-1');
    });
    $(getClassSelector(SELECTORS.CART_CHECKOUT)).removeClass(CLASSES.DISABLED);
    $(getClassSelector(SELECTORS.CART_CHECKOUT)).attr('disabled', false);
    $(getClassSelector(SELECTORS.VIEW_CART)).removeClass(CLASSES.DISABLED);
    $(getClassSelector(SELECTORS.VIEW_CART)).attr('disabled', false);
    $(getClassSelector(SELECTORS.CART_GIFT_CONTAINER)).removeClass(CLASSES.EMPTY);
    $(getClassSelector(SELECTORS.CART_ITEM_PROMO)).removeClass(CLASSES.EMPTY);
    $(getClassSelector(SELECTORS.CART_UPSELL_EMPTY_MESSAGE)).each(function() {
      $(this).addClass('hide');
      $(this).attr('inert', '');
    });
    $(getClassSelector(SELECTORS.CART_UPSELL_CART_MESSAGE)).removeClass('hide');
    $(getClassSelector(SELECTORS.CART_UPSELL_CART_MESSAGE)).each(function() {
      $(this).removeClass('hide');
      $(this).removeAttr('inert');
    });
    if (enableDiscountInput()) {
      $(getClassSelector(SELECTORS.CART_DISCOUNT_CODE_CONTAINER)).removeClass('hide').removeAttr('inert');
    }
  }

  function showEmptyCartMessage() {
    $(getClassSelector(SELECTORS.CART_EMPTY_MESSAGE)).each(function() {
      $(this).addClass(CLASSES.SHOWING);
      $(this).removeAttr('inert');
      $(this).attr('tabindex', '0');
    });
    $(getClassSelector(SELECTORS.CART_CHECKOUT)).addClass(CLASSES.DISABLED);
    $(getClassSelector(SELECTORS.CART_CHECKOUT)).attr('disabled', true);
    $(getClassSelector(SELECTORS.VIEW_CART)).addClass(CLASSES.DISABLED);
    $(getClassSelector(SELECTORS.VIEW_CART)).attr('disabled', true);
    $(getClassSelector(SELECTORS.CART_ITEM_PROMO)).addClass(CLASSES.EMPTY);
    $(getClassSelector(SELECTORS.CART_GIFT_CONTAINER)).addClass(CLASSES.EMPTY);
    $(getClassSelector(SELECTORS.CART_UPSELL_EMPTY_MESSAGE)).each(function() {
      $(this).removeClass('hide');
      $(this).removeAttr('inert');
    });
    $(getClassSelector(SELECTORS.CART_UPSELL_CART_MESSAGE)).each(function() {
      $(this).addClass('hide');
      $(this).attr('inert', '');
    });
    if (enableDiscountInput()) {
      $(getClassSelector(SELECTORS.CART_DISCOUNT_CODE_CONTAINER)).addClass('hide').attr('inert', '');
      $(getClassSelector(SELECTORS.CART_DISCOUNT_CODE_ERROR)).empty();
    }
  }

  function getUrlParameter(name) {
    if ("URLSearchParams" in window) {
      var params = new URLSearchParams(window.location.search.substring(1));
      return params.get(name);
    } else {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(window.location.href);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
  }

  function hasDiscount() {
    if (getUrlParameter("discount") || discountCodeTitleFromCookie() || discountTitleFromUrl()) {
      return true;
    } else {
      return false;
    }
  }

  function discountCookieMatch(){
    var cookieMatch = document.cookie.match(/(^| )discount=([^;]+)/);
    return cookieMatch
  }

  function discountCodeCookieObject() {
    var cookieMatch = discountCookieMatch();
    if (cookieMatch && cookieMatch[2]) {
      var cookieValue = decodeURIComponent(cookieMatch[2]);
      var discountObj = JSON.parse(cookieValue);
      return discountObj;
    } else {
      return null;
    }
  }

  function discountCodeTitleFromSessionStorage() {
    if (sessionStorage.getItem('discount_code')) {
      return sessionStorage.getItem('discount_code');
    }
    return null; // Return null if title value is not found
  }

  function discountCodeTitleFromCookie() {
    if (discountCookieMatch() !== null || discountCodeCookieObject() !== null) {
      if (discountCodeCookieObject().hasOwnProperty('title')) {
        return discountCodeCookieObject().title;
      }
    }
    return null; // Return null if title value is not found
  }

  function setCookie(name, value, expires = null, domain = null) {
    const cookieParts = [
      `${name}=${encodeURIComponent(value)}`,
      'path=/',
      expires && `expires=${expires}`,
      domain && `domain=${domain}`
    ]
    document.cookie = cookieParts.join(';')
  }

  function getDiscountCode(){
    let discountCode;
    if(getUrlParameter("discount")){
      discountCode = getUrlParameter("discount");
    } else if (discountCodeTitleFromSessionStorage()) {
      discountCode = discountCodeTitleFromSessionStorage()
    } else if (discountCodeTitleFromCookie()) {
      discountCode = discountCodeTitleFromCookie()
    } else if (discountTitleFromUrl()) {
      discountCode = discountTitleFromUrl();
    }
    setDiscountCode(discountCode);
    return discountCode
  }

  function setDiscountCode(discountCode){
    if (discountCode) {
      var discountObj = sessionStorage.setItem("discount_code", discountCode);
      return discountObj;
    }
  }

  function hideCartItemizedCost(){
    var $itemizedCost = $(getClassSelector(SELECTORS.CART_ITEMIZED_COSTS));
    $itemizedCost.addClass('hide');
    $itemizedCost.attr('inert', '');
  }
  function showCartItemizedCost(){
    var $itemizedCost = $(getClassSelector(SELECTORS.CART_ITEMIZED_COSTS));
    $itemizedCost.removeClass('hide');
    $itemizedCost.removeAttr('inert');
  }

  function hideCartShipping(){
    $(getClassSelector(SELECTORS.CART_SHIPPING)).addClass('hide');
  }
  function showCartShipping(){
    if (!enableDiscountInput()) {
      $(getClassSelector(SELECTORS.CART_SHIPPING)).removeClass('hide');
    }
  }

  function showCartItemFulfillmentMessage($template, fulfillmentMessage){
    if (fulfillmentMessage === undefined || fulfillmentMessage === null || fulfillmentMessage === "") {
      return;
    }
     $template.find(getClassSelector(SELECTORS.CART_ITEM_FULFILLMENT)).removeClass('hide').html(fulfillmentMessage);
  }

  function bundleFrameColor() {
    return document.querySelector('.bundle--option:checked').getAttribute('data-color')
  }

  function bundleUpsell(){
    return (
      document.getElementById(SELECTORS.BUNDLE_BOX)
    );
  }

  function bundleChecked(){
    if (bundleUpsell()) {
      return bundleUpsell().checked
    } else if(collectiveBundleUpsellChecked()) {
      return false
    }
  }
  
  function bundleUnchecked() {
    if (bundleChecked()) {
      bundleUpsell().checked = false;
    }
  }

  function findCollectiveBundleUpsellCheckboxes(){
    return document.querySelectorAll(getClassSelector(SELECTORS.COLLECTIVE_BUNDLE_CHECKBOX));
  }

  function isCollectiveBundleChecked(){
    const collectiveBundleCheckboxs = findCollectiveBundleUpsellCheckboxes();
    if (collectiveBundleCheckboxs) {
      return Array.from(collectiveBundleCheckboxs).some(checkbox => checkbox.checked === true);
    }
    return false;
  }

  function quantityBundleHide(){
    var $quantityContainer = $(getClassSelector(SELECTORS.QUANTITY_CONTAINER));
    if (bundleChecked()) {
      $quantityContainer.addClass('bundleSelected');
    } else {
      $quantityContainer.removeClass('bundleSelected');
    }
  }

  function renderPricingLogic(){
    if (bundleChecked()) {
      bundlePricing()
    } else {
      if (isCollectiveBundleChecked()) {
        renderCollectiveBundlePricing()
      } else {
        renderPrice()
      }
    }
  }

  function bundlePricing(){
    var bundleFrameDetails = bundleFrameColorData();
    renderBundlePricing(bundleFrameDetails)
  }

  async function addToCartFlow(color, quantity, giftNote = '') {
    if (giftNote) {
      await updateShopifyCartGiftNote(giftNote, getShopifyCartId());
    }
    setQuantity(color, quantity);
    const updatedCart = await updateCart(color);
    if (updatedCart) {
      renderCart();
      renderCartCount();
      findCartItemIndex();
      return updatedCart;
    } else {
      console.error('Failed add to cart flow for: ' + color + ' with quantity: ' + quantity + ' to cartId: ' + getShopifyCartId());
    }
  }

  function bundleFrameColorData() {
    var bundleColor = bundleFrameColor();
    var bundleFrameData =  window.getFrameDetailsByColor(bundleColor);
    return bundleFrameData
  }

  function subtotal(cart) {
    var cartToUse = cart || getSavedShopifyCart();
    var subtotal = 0;
    if (cartToUse && cartToUse.cost && cartToUse.cost.totalAmount && cartToUse.cost.totalAmount.amount) {
      subtotal = Number(cartToUse.cost.totalAmount.amount);
      if(cartToUse.cost.totalTaxAmount && cartToUse.cost.totalTaxAmount.amount) {
        subtotal -= Number(cartToUse.cost.totalTaxAmount.amount); // exclude taxes
      }
    }
    // Show decimals only if not .00
    if (Number.isInteger(subtotal)) {
      return subtotal.toString();
    }

    return subtotal.toFixed(2);
  }

  function getOldCookieEstimatesKeys(postalCodeFirstThree) {
    const cookieKeys = [];
    const cookies = document.cookie.split('; ');

    cookies.forEach(cookie => {
      const [key] = cookie.split('=');

      if (key.startsWith('delivery_estimates_') && !key.startsWith(`delivery_estimates_${postalCodeFirstThree}`)) {
        cookieKeys.push(key);
      }
    });

    return cookieKeys;
  }

  function getSkusFromCart() {
    const cart = getSavedShopifyCart();
    const framesData = window.grabAllFramesData();
    const skus = [];
    if (cartHasLineItems(cart)) {
      cart.lines.edges.forEach((line) => {
        if (line.node.quantity > 0) {
          var shopifyId = lineItemShopifyId(line);
          Object.keys(framesData).forEach(function (frameData) {
            if (framesData[frameData].shopifyId) {
              if ((framesData[frameData].shopifyId).toString() == shopifyId) {
                var frameData = framesData[frameData];
                skus.push(frameData.sku);
              }
            }
          });
        }
      });
    }
    return skus;
  }

 function setSkeletonLoaded(element) {
    element.querySelectorAll('[data-skeleton]').forEach(child => {
      child.setAttribute('data-skeleton', 'loaded');
      child.remove();
      setTimeout(() => {
        child.remove();
      }, 250);
    });
    
    if (element.hasAttribute('data-skeleton')) {
      element.setAttribute('data-skeleton', 'loaded');
    }
  }

  /* Helpful for testing & needed for v1 */
  function getDeliveryPostalCode() {
    return getCookie('delivery_postal_code')
  }

  function getActiveSkus() {
    if (isOrderPage()) {
      const activeFrameDetails = window.getFrameDetailsByColor(activeFrame);
      if (activeFrameDetails && activeFrameDetails.sku) {
        return [activeFrameDetails.sku];
      }
      return [];
    }

    if (isHomePage() || isFeaturedFramesPage()) {
      return getProductsByFeaturedSection();
    }

    if (isShopFramesPage()) {
      return getMCFProductsByShopSection();
    }

    return [];
  }

  async function getCityInfoData(zip) {
    const cacheKey = `city_info_${zip || getDeliveryPostalCode()}`;
    const cachedData = window.localStorage && window.localStorage.getItem(cacheKey);

    if (cachedData) {
      try {
        const parsedData = JSON.parse(cachedData);
        if (parsedData.timestamp && Date.now() - parsedData.timestamp < 5 * 60 * 1000) { // Cache valid for 5 minutes
          return parsedData.data;
        }
      } catch (error) {
        console.error('Error parsing cached data:', error);
      }
    }

    const url = new URL(`v5/delivery_estimate/recipient_info`, `https://api.pushd.com`);
    const postalCode = zip || getDeliveryPostalCode();
    if (postalCode) {
      url.searchParams.set('postal_code', postalCode);
    }

    let response;
    try {
      response = await fetch(url);
    } catch (error) {
      console.error('Fetch error:', error);
      return null;
    }
    if (!response) {
      return null;
    }

    const data = await response.json();
    if (window.localStorage) {
      window.localStorage.setItem(cacheKey, JSON.stringify({ data, timestamp: Date.now() }));
    }
    return data;
  }

  async function deliveryPerformanceTracking(name, skus, asyncFn) {
    const startTime = performance.now();

    try {
      const result = await asyncFn();
      return result;
    } finally {
      const endTime = performance.now();
      const duration = endTime - startTime;

      if (Array.isArray(skus)) {
        logGA4Event(name, {
          duration: duration.toFixed(2),
          skus: skus.join(',')
        });
      } else {
        logGA4Event(name, {
          duration: duration.toFixed(2),
          sku: skus
        });
      }
    }
  }

  class DeliveryEstimateHandler {
    constructor({
      enableLogging = false,
      afterPageLoadTimeout = 60000,    // 60 seconds when page is loaded
      beforePageLoadTimeout = 10000    // 10 second when page is still loading
    } = {}) {
      this.cache = new Map();
      this.pending = new Map();
      this.CACHE_TTL = 5 * 60 * 1000;
      this.endpointSingle = 'https://api.pushd.com/v5/delivery_estimate';
      this.endpointBatch = 'https://api.pushd.com/v5/delivery_estimate/list';
      this.enableLogging = enableLogging || getCookie('enable_logging') === 'true';
      this.afterPageLoadTimeout = afterPageLoadTimeout;
      this.beforePageLoadTimeout = beforePageLoadTimeout;

      // Initialize pageLoaded based on current state
      this._pageLoaded = document.readyState === 'complete';

      // Add load event listener if page isn't already loaded
      if (!this._pageLoaded) {
        window.addEventListener('load', () => {
          this._pageLoaded = true;
          this.log('Page load complete');
        });

        // Also listen for readystatechange as a backup
        document.addEventListener('readystatechange', () => {
          if (document.readyState === 'complete') {
            this._pageLoaded = true;
            this.log('Page load complete (readystatechange)');
          }
        });
      }

      this.log('DeliveryEstimateHandler initialized');
    }

    // Getter to ensure we always check the current state
    get pageLoaded() {
      if (!this._pageLoaded) {
        this._pageLoaded = document.readyState === 'complete';
      }
      return this._pageLoaded;
    }

    log(...args) {
      if (this.enableLogging) {
        console.log('[DeliveryEstimateHandler]', ...args);
      }
    }

    getCacheKey(postalCode, sku) {
      const normalizedPostalCode = postalCode || 'empty';
      return `${normalizedPostalCode.slice(0, 3)}_${sku}`;
    }

    getListCacheKey(postalCode, skus) {
      const normalizedPostalCode = postalCode || 'empty';
      const sortedSkus = skus.slice().sort().join(',');
      return `list_${normalizedPostalCode.slice(0, 3)}_${sortedSkus}`;
    }

    isCacheValid(cacheKey) {
      const cached = this.cache.get(cacheKey);
      const isValid = cached && Date.now() - cached.timestamp < this.CACHE_TTL;
      this.log(`Cache ${isValid ? 'valid' : 'invalid'} for key: ${cacheKey}`);
      return isValid;
    }

    getCacheData(cacheKey) {
      if (this.isCacheValid(cacheKey)) {
        const cachedData = this.cache.get(cacheKey).data;
        this.log('Returning cached data for key:', cacheKey, cachedData);
        return structuredClone(cachedData); // Return a deep copy
      }
      this.log('No valid cache found for key:', cacheKey);
      return null;
    }

    setCacheData(cacheKey, data) {
      this.cache.set(cacheKey, { data, timestamp: Date.now() });
      this.log('Cached data set for key:', cacheKey, data);
    }

    // Add helper to remove from pending map
    removePending(controller, cacheKey) {
      controller.cleanup = () => {
        this.pending.delete(cacheKey);
        this.log(`Removed pending request for key: ${cacheKey}`);
      };
    }

    async fetchWithTimeout(url, cacheKey, options = {}) {
      const timeoutDuration = !this.pageLoaded ? this.beforePageLoadTimeout : this.afterPageLoadTimeout;

      const controller = new AbortController();
      this.removePending(controller, cacheKey);

      const timeoutId = setTimeout(() => {
        controller.abort();
        controller.cleanup();
        this.log(`Request aborted - page loaded: ${this.pageLoaded}, timeout: ${timeoutDuration}ms`);
      }, timeoutDuration);

      try {
        const response = await fetch(url, {
          ...options,
          signal: controller.signal
        });
        clearTimeout(timeoutId);
        return response;
      } catch (error) {
        clearTimeout(timeoutId);
        if (error.name === 'AbortError') {
          controller.cleanup();
          this.log(`Request timed out after ${timeoutDuration}ms`);
          return null;
        }
        throw error;
      }
    }

    async fetchDeliveryEstimate(sku) {
      if (!sku) {
        this.log('No SKU provided.');
        return null;
      }

      const postalCode = getDeliveryPostalCode();
      const cacheKey = this.getCacheKey(postalCode, sku);

      const cachedData = this.getCacheData(cacheKey);
      if (cachedData) return cachedData;

      if (this.pending.has(cacheKey)) {
        this.log(`Pending request for SKU: ${sku}`);
        return this.pending.get(cacheKey);
      }

      const url = new URL(this.endpointSingle);
      url.searchParams.set('sku', sku);
      if (postalCode) {
        url.searchParams.set('postal_code', postalCode);
      }

      const promise = deliveryPerformanceTracking('delivery_estimate_performance', sku, async () => {
        const response = await this.fetchWithTimeout(url, cacheKey);
        if (!response || !response.ok) {
          this.log(`Invalid response for SKU: ${sku}`, response);
          return Promise.reject(response);
        }
        const data = await response.json();
        if (data && data.sku) {
          this.setCacheData(cacheKey, data);
          return structuredClone(data);
        }
        this.log(`Invalid response format for SKU: ${sku}`, data);
        return null;
      }).catch((err) => {
        this.log(`Error fetching delivery estimate for SKU: ${sku}`, err);
        return null;
      }).finally(() => {
        this.pending.delete(cacheKey);
      });

      this.pending.set(cacheKey, promise);
      return promise;
    }

    async fetchDeliveryEstimates(skus) {
      if (!Array.isArray(skus) || skus.length === 0) {
        this.log('No SKUs provided for fetching delivery estimates.');
        return [];
      }

      const postalCode = getDeliveryPostalCode();
      const listCacheKey = this.getListCacheKey(postalCode, skus);

      const cachedData = this.getCacheData(listCacheKey);
      if (cachedData) return cachedData;

      if (this.pending.has(listCacheKey)) {
        this.log('Pending request for SKU list.');
        return this.pending.get(listCacheKey);
      }

      const url = new URL(this.endpointBatch);
      url.searchParams.set('skus', skus.join(','));
      if (postalCode) {
        url.searchParams.set('postal_code', postalCode);
      }

      const promise = deliveryPerformanceTracking('delivery_estimates_performance', skus, async () => {
        const response = await this.fetchWithTimeout(url, listCacheKey);
        if (!response || !response.ok) {
          this.log(`Invalid response for SKUs: ${skus.join(',')}`, response);
          return Promise.reject(response);
        }
        const data = await response.json();
        if (data && Array.isArray(data.estimates)) {
          this.setCacheData(listCacheKey, data);

          // Cache individual estimates
          data.estimates.forEach((estimate) => {
            if (estimate && estimate.sku) {
              const recipientPostalCode =
                estimate.postal_code || (data.recipient && data.recipient.postal_code) || 'empty';
              const skuCacheKey = this.getCacheKey(recipientPostalCode, estimate.sku);
              this.setCacheData(skuCacheKey, estimate);
            }
          });

          return structuredClone(data);
        }
        this.log('Invalid list response format', data);
        return [];
      }).catch((err) => {
        this.log('Batch fetch error:', err);
        return [];
      }).finally(() => this.pending.delete(listCacheKey));

      this.pending.set(listCacheKey, promise);
      return promise;
    }

    prefetch(skus) {
      if (!Array.isArray(skus) || skus.length === 0) {
        this.log('No SKUs provided for prefetch.');
        return Promise.resolve([]);
      }

      return skus.length === 1
        ? this.fetchDeliveryEstimate(skus[0])
        : this.fetchDeliveryEstimates(skus);
    }
  }

  // Register as a singleton on the window object
  if (!window.DeliveryEstimateHandlerInstance) {
    window.DeliveryEstimateHandlerInstance = new DeliveryEstimateHandler();
  }
  const deliveryHandler = window.DeliveryEstimateHandlerInstance;

  function initiatePrefetch() {
    const skus = getActiveSkus();
    const enable_logging = getCookie('enable_logging') === 'true';

    if (!Array.isArray(skus) || skus.length === 0) {
      if (enable_logging) {
        console.warn('[DeliveryEstimateHandler] No SKUs to prefetch.');
      }
      return;
    }

    deliveryHandler
      .prefetch(skus)
      .then((data) => {
        if (enable_logging) {
          console.log('[DeliveryEstimateHandler] Prefetched delivery data:', data);
        }
      })
      .catch((error) => {
        console.error('[DeliveryEstimateHandler] Error during prefetch:', error);
      });
  }
  // Initiate prefetch
  if (isDeliveryEstimateRegion) {
    initiatePrefetch();
  }

  function updateCountdown(deliveryEstimateWrapper, countdownDisplay, expiryDate) {
    const orderWithinTextElement = deliveryEstimateWrapper.querySelector('.action--order-within-text');
    const zipInputText = deliveryEstimateWrapper.querySelector('.action--render-zip-input-text');

    const now = new Date().getTime();
    const expiryTime = new Date(expiryDate).getTime();
    const timeDifference = expiryTime - now;

    if (timeDifference <= 0) {
      orderWithinTextElement.classList.add('hide');
      return;
    }

    orderWithinTextElement.classList.remove('hide');
    orderWithinTextElement.classList.add('active');

    if (zipInputText) {
      zipInputText.classList.add('hide');
    }

    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));

    let remainingTime = '';
    if (days > 0) {
      remainingTime += `${days} day${days > 1 ? 's' : ''} `;
      if (hours > 0) {
        remainingTime += `${hours} hour${hours > 1 ? 's' : ''}`;
      }
      if (minutes > 0) {
        remainingTime += ` ${minutes} minute${minutes > 1 ? 's' : ''}`;
      }
    } else if (hours > 0) {
      remainingTime += `${hours} hour${hours > 1 ? 's' : ''}`;
      if (minutes > 0) {
        remainingTime += ` ${minutes} minute${minutes > 1 ? 's' : ''}`;
      }
    } else {
      remainingTime += `${minutes} minute${minutes > 1 ? 's' : ''}`;
    }
    remainingTime += '.';

    countdownDisplay.textContent = remainingTime.trim();
  }

  function shippingEstimateCountdown(deliveryEstimateWrapper, expiryDate) {
    const countdownDisplay = deliveryEstimateWrapper.querySelector('.action--shipping-estimate-countdown');
    const orderWithinTextElement = deliveryEstimateWrapper.querySelector('.action--order-within-text');

    if (!countdownDisplay || !orderWithinTextElement) {
      return;
    }

    if (!expiryDate || isNaN(new Date(expiryDate).getTime())) {
      return;
    }

    countdownDisplay.classList.remove('hide')

    updateCountdown(deliveryEstimateWrapper, countdownDisplay, expiryDate);
    const interval = setInterval(() => updateCountdown(deliveryEstimateWrapper, countdownDisplay, expiryDate), 60000); // Update every minute
    countdownDisplay.dataset.interval = 'true'; // Mark as 'true' to prevent multiple intervals

    const timeUntilExpiry = new Date(expiryDate).getTime() - Date.now();
    if (timeUntilExpiry > 0) {
      // Set timeout to clear interval if expiry date is in the past
      setTimeout(() => {
        clearInterval(interval);
        countdownDisplay.dataset.interval = 'false';
      }, timeUntilExpiry);
    }
  }

  function renderCityText(deliveryEstimateWrapper, city) {
    const cityElement = deliveryEstimateWrapper.querySelector('.action--shipping-estimate-city-state');
    if (!cityElement) {
        return;
    }
    cityElement.textContent = ` ${city || ''}`; // hacky way to not render undefined
  }

  function renderOrderWithinText(deliveryEstimateWrapper, expiry) {
    if (!expiry) {
      return;
    }
    shippingEstimateCountdown(deliveryEstimateWrapper, expiry);
  }

  function handleZipButtonClick(deliveryEstimateWrapper, location) {
    if (isCartOpen) {
      resetChangeBopisStore();
    }

    const {zipValue, zipButton, zipInput} = getZipElements(deliveryEstimateWrapper);
    if (zipValue.textContent === PLACEHOLDER_ZIP_CODE) {
      zipValue.textContent = '';
    }

    zipInput.addEventListener("blur", () => {
      if ((zipInput.value.trim() === '' || zipInput.value.trim().length < 5) && zipValue.textContent === '') {
        zipValue.textContent = getDeliveryPostalCode() || PLACEHOLDER_ZIP_CODE;
        zipValue.addEventListener('click', () => {
          zipValue.textContent = '';
        }, { once: true });
      }
    });

    zipInput.value = zipValue.textContent;
    zipValue.value = zipValue.textContent
    zipButton.classList.add('hide');
    zipInput.classList.remove('hide');
    zipInput.focus()

    logGA4Event('delivery_estimate_zip_btn_click', {
      info: "click on delivery estimate zip btn",
      location: location,
      zipInput: zipInput.value,
    });
    logPavedEvent('delivery_estimate_zip_btn_click', {
      info: "click on delivery estimate zip btn",
      location: location,
      zipInput: zipInput.value,
    });
  }

  function isStandardKey(key, ctrlKey, metaKey) {
    const standardKeys = ['Backspace', 'Tab', 'Enter', 'Escape', 'Delete', 'Home', 'End', 'ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown'];

    return standardKeys.includes(key) ||
      (key === 'a' && (ctrlKey || metaKey)) || // Allow: Ctrl+A or Command+A (Select All)
      (key === 'v' && (ctrlKey || metaKey)) ||   // Allow: Ctrl+V or Command+V (Paste)
      (key === 'v' && (ctrlKey || metaKey));   // Allow: Ctrl+C or Command+C (Copy)
  }

  function isDigitKey(key) {
    return key >= '0' && key <= '9' || key >= 'Digit0' && key <= 'Digit9' || key >= 'Numpad0' && key <= 'Numpad9';
  }

  function isAlphaKey(key) {
    return /^[A-Za-z]$/.test(key);
  }

  function handleZipInputInput(deliveryEstimateWrapper) {
    const { zipValue, zipInput } = getZipElements(deliveryEstimateWrapper);

    const value = zipInput.value.trim();
    const valueElement = zipValue;

    const validPostalCode = isCaLocale ? CA_POSTAL_CODE_REGEX.test(value) : /^\d{5}$/.test(value);
    if (validPostalCode) {
      valueElement.textContent = value;
      zipInput.blur();
      setCookie('delivery_postal_code', value, null, `.${location.hostname}`);

      const frameDetails = window.getFrameDetailsByColor(activeFrame);
      if (I18n.locale == 'en' || I18n.locale == 'qa' || I18n.locale == 'en-US' || I18n.locale == 'es-US' || I18n.locale == 'en-QA' || I18n.locale == 'es-QA' || I18n.locale == 'en-CA') {
        resetToSkeletonLoading(deliveryEstimateWrapper);
        updateDeliveryEstimateMessageBasedOnLocation(deliveryEstimateWrapper);
        // Update BOPIS message based on location (US only)
        if (!isCaLocale) {
          updateBopisMerchandisingCart();
        }
      }

      if (frameDetails && Object.keys(frameDetails).length !== 0) {
        logGA4Event('delivery_estimate_zip_input', {
          info: "input on delivery estimate zip field",
          location: "PDP",
          zip: value,
        });
        logPavedEvent('delivery_estimate_zip_input', {
          info: "input on delivery estimate zip field",
          location: "PDP",
          zip: value,
        });
      } else {
        logGA4Event('delivery_estimate_zip_input', {
          info: "input on delivery estimate zip field",
          location: "HP",
          zip: value,
        });
        logPavedEvent('delivery_estimate_zip_input', {
          info: "input on delivery estimate zip field",
          location: "HP",
          zip: value,
        });
      }
    }
  }

  function handleZipInputBlur(deliveryEstimateWrapper) {
    const {zipButton, zipInput} = getZipElements(deliveryEstimateWrapper);
    zipInput.classList.add('hide');
    zipButton.classList.remove('hide');
  }

  function handleZipInputKeyPress(event, deliveryEstimateWrapper, location) {
    const { zipInput } = getZipElements(deliveryEstimateWrapper);
    if (["Enter", "Escape"].includes(event.key)) {
      zipInput.blur();
      logGA4Event('delivery_estimate_zip_input_keypress', {
        info: "keypress on delivery estimate zip field",
        location: location,
        zip: zipInput.value,
      });
      logPavedEvent('delivery_estimate_zip_input_keypress', {
        info: "keypress on delivery estimate zip field",
        location: location,
        zip: zipInput.value,
      });
      return;
    }

    if (!isStandardKey(event.key, event.ctrlKey, event.metaKey)) {
      if (isCaLocale) {
        if (!isDigitKey(event.key) && !isAlphaKey(event.key) && event.key !== ' ') {
          event.preventDefault();
        }
      } else {
        if (!isDigitKey(event.key)) {
          event.preventDefault();
        }
      }
    }
  }

  function getZipElements(deliveryEstimateWrapper) {
    const zipButton = deliveryEstimateWrapper.querySelector(getClassSelector(SELECTORS.ZIP_BUTTON));
    const zipValue = deliveryEstimateWrapper.querySelector(getClassSelector(SELECTORS.ZIP_VALUE));
    const zipInput = deliveryEstimateWrapper.querySelector(getClassSelector(SELECTORS.ZIP_INPUT));
    const deliveryWrapper = deliveryEstimateWrapper.querySelector(getClassSelector(SELECTORS.DELIVERY_WRAPPER));

    return {deliveryEstimateWrapper, zipButton, zipValue, zipInput, deliveryWrapper};
  }

  // Quick Debounce; maybe avoid the call in the future
  function createZipListeners(deliveryEstimateWrapper, location) {
    if (deliveryEstimateWrapper.dataset.listening === 'true') {
      return;
    }
    const {zipButton, zipInput} = getZipElements(deliveryEstimateWrapper);
      zipButton.addEventListener("click", () => handleZipButtonClick(deliveryEstimateWrapper, location));
      zipInput.addEventListener("blur", () => handleZipInputBlur(deliveryEstimateWrapper));
      zipInput.addEventListener("keypress", (event) => handleZipInputKeyPress(event, deliveryEstimateWrapper, location));
      zipInput.addEventListener("input", () => handleZipInputInput(deliveryEstimateWrapper));
      deliveryEstimateWrapper.dataset.listening = 'true';
  }

  function renderZipInputText(deliveryEstimateWrapper) {
    const zipInputText = deliveryEstimateWrapper.querySelector('.action--render-zip-input-text');
    const orderWithinTextElement = deliveryEstimateWrapper.querySelector('.action--order-within-text');
    if (zipInputText) {
      zipInputText.classList.remove('hide');
      zipInputText.removeAttribute('inert');
      orderWithinTextElement.classList.add('hide');
      orderWithinTextElement.setAttribute('inert', '');
    }
  }

  function renderBlankZipInput(deliveryEstimateWrapper, zipValue) {
    renderZipInputText(deliveryEstimateWrapper);
    zipValue.textContent = PLACEHOLDER_ZIP_CODE;
  }

  function renderEstimateZipcode(deliveryEstimateWrapper, postalCode, location){
    const {zipButton, zipValue, deliveryWrapper} = getZipElements(deliveryEstimateWrapper);

    if (postalCode === undefined || postalCode === null || postalCode === '') {
      renderBlankZipInput(deliveryEstimateWrapper, zipValue);
      deliveryWrapper.classList.remove('hide');
      deliveryWrapper.removeAttribute('inert');
      createZipListeners(deliveryEstimateWrapper, location);
      return;
    } else if (!zipButton || !zipValue || !postalCode || !deliveryWrapper) {
      return;
    }

    zipValue.textContent = postalCode;
    deliveryWrapper.classList.remove('hide');
    deliveryWrapper.classList.add('active');
    deliveryWrapper.removeAttribute('inert');
    createZipListeners(deliveryEstimateWrapper, location);
  }

  function renderDeliveryEstimate(deliveryEstimateWrapper){
    deliveryEstimateWrapper.classList.remove('hide');
    deliveryEstimateWrapper.classList.add('active');
    deliveryEstimateWrapper.setAttribute('tabindex', '0');
    deliveryEstimateWrapper.removeAttribute('inert');
  }

  function hideDeliveryEstimate(deliveryEstimateWrapper){
    deliveryEstimateWrapper.classList.remove('active');
    deliveryEstimateWrapper.classList.add('hide');
    deliveryEstimateWrapper.setAttribute('tabindex', '-1');
    deliveryEstimateWrapper.setAttribute('inert', '');
  }

  function resetToSkeletonLoading(deliveryEstimateWrapper) {
    const promiseWrapper = deliveryEstimateWrapper.querySelector(getClassSelector(SELECTORS.DELIVERY_PROMISE_WRAPPER));
    const deliveryWrapper = deliveryEstimateWrapper.querySelector('.action--shipping-delivery-wrapper');
    const orderWithinText = deliveryEstimateWrapper.querySelector('.action--order-within-text');
    const cityState = deliveryEstimateWrapper.querySelector('.action--shipping-estimate-city-state');

    const skeletonPromise = deliveryEstimateWrapper.dataset.skeletonPromise;
    const skeletonLocation = deliveryEstimateWrapper.dataset.skeletonLocation;
    const skeletonCountdown = deliveryEstimateWrapper.dataset.skeletonCountdown;

    if (cityState) cityState.textContent = '';

    [
      [promiseWrapper, skeletonPromise],
      [deliveryWrapper, skeletonLocation],
      [orderWithinText, skeletonCountdown]
    ].forEach(([el, style]) => {
      if (!el) return;
      el.classList.add('hide');
      el.classList.remove('active');
      if (style) {
        const skeleton = document.createElement('div');
        skeleton.setAttribute('data-skeleton', 'loading');
        skeleton.setAttribute('style', style);
        el.parentElement.insertBefore(skeleton, el);
      }
    });
  }

  function getDeliveryEstimateWrappers(location) {
    const deliveryEstimateWrappers = document.querySelectorAll(getClassSelector(SELECTORS.DELIVERY_ESTIMATE_WRAPPER + '.action--estimate-location-' + location));

    return deliveryEstimateWrappers;
  }

  function getCollectiiveShippingDisclaimers(location) {
    const collectiveShippingDisclaimers = document.querySelectorAll('.action--collective-bundle--shipping-disclaimer' + '.action--disclaimer-location-' + location)
    return collectiveShippingDisclaimers;
  }

  function renderDeliveryPromiseEstimateDate(dateText, deliveryEstimateWrapper, sku = null) {
    const deliveryPromiseWrapper = deliveryEstimateWrapper.querySelector(getClassSelector(SELECTORS.DELIVERY_PROMISE_WRAPPER));

    if (!deliveryPromiseWrapper || !dateText) {
      return;
    }

    deliveryPromiseWrapper.classList.remove('hide');
    deliveryPromiseWrapper.classList.add('active');
    const deliveryPromiseDates = deliveryPromiseWrapper.querySelectorAll(getClassSelector(SELECTORS.DELIVERY_PROMISE_DATE));
    const deliveryPromiseTexts = deliveryPromiseWrapper.querySelectorAll(getClassSelector(SELECTORS.DELIVERY_PROMISE_TEXT));

    if (deliveryPromiseDates) {
      deliveryPromiseDates.forEach(deliveryPromiseDate => {
        deliveryPromiseDate.textContent = dateText;
      });
      deliveryPromiseTexts.forEach(deliveryPromiseText => {
        var deliveryTextPromise = deliveryPromiseText.querySelector('.action--delivery-text-promise');
        var deliveryTextPromiseRange = deliveryPromiseText.querySelector('.action--delivery-text-promise-range');
        if (deliveryTextPromise) {
          deliveryTextPromise.classList.remove('hide');
          deliveryTextPromise.removeAttribute('inert');
        }
        if (deliveryTextPromiseRange) {
          deliveryTextPromiseRange.classList.add('hide');
          deliveryTextPromiseRange.setAttribute('inert', '');
        }
      })
    }
    if (sku) {
      const deliveryPromiseTexts = deliveryPromiseWrapper.querySelectorAll(getClassSelector(SELECTORS.DELIVERY_PROMISE_TEXT));
      if (deliveryPromiseTexts) {
        deliveryPromiseTexts.forEach(deliveryPromiseText => {
          const fastestFrameElement = deliveryPromiseText.querySelector('.fastest-frame');
          if (fastestFrameElement) {
            fastestFrameElement.textContent = sku;
            fastestFrameElement.classList.add('capitalize');
          }
        });
      }
    }
  }

  function renderDynamicShippingElement(postalCode, expiry, city, deliveryEstimateWrapper, location) {
    renderCityText(deliveryEstimateWrapper, city)
    renderEstimateZipcode(deliveryEstimateWrapper, postalCode, location)
    renderOrderWithinText(deliveryEstimateWrapper, expiry)
    renderDeliveryEstimate(deliveryEstimateWrapper)
    setSkeletonLoaded(deliveryEstimateWrapper);
  }

  // The estimates API returns every shipping speed, so the variant only changes which one we
  // render -- no request parameter, which keeps the CDN cache shared between both arms.
  // Only override where the server already picked an Amazon speed: a warehouse pick means the SKU,
  // region or address can't go through MCF at all, and the variant doesn't change that.
  function shippingSpeedTestSpeedFor(serverSpeed) {
    if (typeof window.shippingSpeedTestSpeedKey !== 'function') return null;
    const speed = window.shippingSpeedTestSpeedKey();
    if (!speed || !serverSpeed || String(serverSpeed).indexOf('amazon') !== 0) return null;
    return speed;
  }

  // Mirrors calculate_max_min_delivery_date_and_min_expiry_for_checkout in
  // delivery_estimates_helper.rb: we quote the latest date across the cart and count down to the
  // earliest cutoff. Returns null if any SKU is missing the speed, so a cart we can't ship that
  // way falls back to the server's choice instead of us quoting a date we never got from Amazon.
  function aggregateEstimateForSpeed(estimates, speed) {
    if (!estimates || estimates.length === 0) return null;

    let latest = null;
    let minExpiry = null;
    for (let i = 0; i < estimates.length; i++) {
      const estimate = estimates[i] && estimates[i][speed];
      if (!estimate || !estimate.date) return null;
      if (!latest || new Date(estimate.date) > new Date(latest.date)) latest = estimate;
      if (estimate.expiry && (!minExpiry || new Date(estimate.expiry) < new Date(minExpiry))) minExpiry = estimate.expiry;
    }

    return latest ? { text: latest.text, expiry: minExpiry || latest.expiry, date: latest.date } : null;
  }

  // example estimateText value: 'Sunday, Sep 22' OR 'Sep 22'
  function padAmazonStandardEstimate(estimateText, numPaddingDays, includeDayOfWeek = false) {
    let monthDay = estimateText;
    if (estimateText.includes(',')) {
      monthDay = estimateText.split(',')[1].trim();
    }

    const currentDate = new Date();
    const yearToUse = monthDay.toLowerCase().includes('jan') && currentDate.getUTCMonth() === 11 ? currentDate.getUTCFullYear() + 1 : currentDate.getUTCFullYear();
    const dateObject = new Date(`${monthDay} ${yearToUse}`);
    const paddedDate = dateObject.setDate(dateObject.getDate() + numPaddingDays);
    const options = { month: 'short', day: 'numeric', timeZone: 'UTC' };
    if (includeDayOfWeek) {
      options.weekday = 'long';
    }
    return new Date(paddedDate).toLocaleDateString('en-US', options);
  }

  function renderFeaturedProductDeliveryEstimate(estimateText, estimateSku) {
    const featuredFramesProducts = findShopFeaturedProducts();

    const matchingProducts = featuredFramesProducts.filter(product => product.getAttribute('data-sku') === estimateSku);

    if (matchingProducts.length > 0) {
      matchingProducts.forEach(product => {
        const productEstimate = product.querySelector('.action--product_delivery-estimate')
        if (!productEstimate) {
          return;
        }
        const productEstimateDate = productEstimate.querySelector('.action--product_delivery-estimate--date');
        if (!productEstimateDate) {
          return;
        }
        productEstimateDate.textContent = 'Delivers by ' + estimateText;
        productEstimate.classList.add('visible');
        productEstimate.style.display = 'flex';
        setSkeletonLoaded(productEstimate.parentElement);
      });
    }
  }

  function updateShippingEstimateAfterInactivity() {
    updateDeliveryEstimateMessageBasedOnSkus();

    document.removeEventListener('mousemove', updateShippingEstimateAfterInactivity);
    document.removeEventListener('scroll', updateShippingEstimateAfterInactivity);
    triggerTimeoutForRefetchingShippingEstimate();
  }

  function addEventListenersForRefetchingShippingEstimate() {
    document.addEventListener('mousemove', updateShippingEstimateAfterInactivity, {passive: true});
    document.addEventListener('scroll', updateShippingEstimateAfterInactivity, {passive: true});
  }

  function triggerTimeoutForRefetchingShippingEstimate() {
    setTimeout(addEventListenersForRefetchingShippingEstimate, 1000 * 60 * 30); // 30 minutes
  }

  function hideAllShippingElements(location) {
    getDeliveryEstimateWrappers(location).forEach(deliveryEstimateWrapper => {
      hideDeliveryEstimate(deliveryEstimateWrapper)
    });
  }

  function addCollectiveShippingDisclaimer(location) {
    const currentDisclaimer = getCollectiiveShippingDisclaimers(location);
    if (!currentDisclaimer.length) {
      getDeliveryEstimateWrappers(location).forEach(deliveryEstimateWrapper => {
        appendCollectiveShippingDisclaimer(deliveryEstimateWrapper, location);
      });
    }
  }

  function removeCollectiveShippingDisclaimer(location) {
    getCollectiiveShippingDisclaimers(location).forEach(disclaimer => {
      disclaimer.remove();
    });
  }

  function appendCollectiveShippingDisclaimer(deliveryEstimateWrapper, location) {
    const disclaimerDiv = document.createElement('div');
    disclaimerDiv.className = 'action--collective-bundle--shipping-disclaimer ' + 'action--disclaimer-location-' + location;

    const disclaimerText = document.createElement('p');
    disclaimerText.className = 'sans-medium-italic mt2 flex justify-center'
    disclaimerText.textContent = 'Please note that each product ships separately.';
    disclaimerDiv.appendChild(disclaimerText);

    deliveryEstimateWrapper.after(disclaimerDiv);
  }


  async function updateDeliveryEstimateMessage(options = {}) {
    const { location, skus } = options;

    if (!Array.isArray(skus) || skus.length === 0 || skus.some(sku => sku === undefined || sku === null)) {
      return;
    }

    if (!isDeliveryEstimateRegion || !skus || skus.length === 0) {
      getDeliveryEstimateWrappers(location).forEach(deliveryEstimateWrapper => {
        setSkeletonLoaded(deliveryEstimateWrapper);
        const deliveryPromiseWrapper = deliveryEstimateWrapper.querySelector(getClassSelector(SELECTORS.DELIVERY_PROMISE_WRAPPER));
        deliveryPromiseWrapper.classList.remove('hide');
        deliveryPromiseWrapper.classList.add('active');
      });
      return
    } 

    let foundEstimates, shippingMethod, deliveryData, siteFreeShipping, estimateExpiry, estimateText, recipientPostalCode, recipientCity, fastestShippedSku;

    if (skus.length > 1) {
      // Fetch city for zip code
      var zipCode = getDeliveryPostalCode();
      const cityInfoData = await getCityInfoData(zipCode);
      if (!cityInfoData || (cityInfoData && cityInfoData.error) && !zipCode) {
        // Render empty zip input
        getDeliveryEstimateWrappers(location).forEach(deliveryEstimateWrapper => {
          renderEstimateZipcode(deliveryEstimateWrapper, null, location);
        });
        return;
      } else {
        const { postal_code, city } = cityInfoData;
        recipientPostalCode = postal_code || getDeliveryPostalCode();
        recipientCity = city;
        if (postal_code && !getDeliveryPostalCode()) {
          setCookie('delivery_postal_code', postal_code, null, `.${window.location.hostname}`);
        }
      }

      if (!recipientPostalCode) {
        getDeliveryEstimateWrappers(location).forEach(deliveryEstimateWrapper => {
          renderEstimateZipcode(deliveryEstimateWrapper, null, location);
        });
        return;
      }

      deliveryData = await deliveryHandler.fetchDeliveryEstimates(skus);
      if (!deliveryData) {
        return;
      }
      let viewerRegion = deliveryData.viewer !== undefined ? deliveryData.viewer.region : null;
      let recipientRegion = deliveryData.recipient !== undefined ? deliveryData.recipient.region : null;
      logDeliveryEstimatesAnalytics({
          location: location,
          zip: zipCode,
          recipient_region: recipientRegion,
          viewer_region: viewerRegion,
          estimate_method: deliveryData['shipping_method'],
          sku: skus.join(","),
          estimate_date: deliveryData['max_delivery_date']
        })

      const {
        min_expiry,
        text,
        site_free_shipping,
        shipping_method,
        estimates,
        fastest_shipped_sku,
        amazon_standard_num_days_to_add_to_estimate,
      } = deliveryData;

      estimateExpiry = location === 'featured-frames' ? fastest_shipped_sku.expiry : min_expiry;
      estimateText = location === 'featured-frames' ? fastest_shipped_sku.text : text;
      foundEstimates = estimates;
      siteFreeShipping = site_free_shipping;

      // `shipping_method` and not `site_free_shipping`: the latter is the best Amazon speed for the
      // cart in isolation and stays an amazon_* value even when something in the cart has to ship
      // from the warehouse. `shipping_method` is the option we'd actually quote, so it is the one
      // that goes to :warehouse for a mixed cart -- which is also what checkout does, since
      // `determine_free_checkout_shipping_method` returns the warehouse rate if any line is
      // warehouse-only. Guarding on the wrong one quotes Expedited against a Ground checkout.
      const siteSpeedOverride = shippingSpeedTestSpeedFor(shipping_method);
      const overriddenAggregate = siteSpeedOverride ? aggregateEstimateForSpeed(estimates, siteSpeedOverride) : null;
      if (overriddenAggregate) {
        siteFreeShipping = siteSpeedOverride;
        if (location !== 'featured-frames') {
          estimateText = overriddenAggregate.text;
          estimateExpiry = overriddenAggregate.expiry;
        }
      }

      if (siteFreeShipping === 'amazon_standard' && amazon_standard_num_days_to_add_to_estimate) {
        estimateText = padAmazonStandardEstimate(estimateText, amazon_standard_num_days_to_add_to_estimate, true);
      }

      if (location === 'featured-frames') {
        foundEstimates.forEach(estimate => {
          const estimateSpeed = shippingSpeedTestSpeedFor(estimate.free_shipping) || estimate.free_shipping;
          const estimateByFreeShipping = estimate[estimateSpeed] || estimate[estimate.free_shipping];
          estimateText = estimateByFreeShipping.text.split(',')[1].trim();
          if (estimateSpeed == 'amazon_standard' && amazon_standard_num_days_to_add_to_estimate) {
            estimateText = padAmazonStandardEstimate(estimateText, amazon_standard_num_days_to_add_to_estimate);
          }
          const estimateSku = estimateByFreeShipping.sku

          renderFeaturedProductDeliveryEstimate(estimateText, estimateSku);
        });

        let { fastest_shipped_sku: { sku, expiry, text} } = deliveryData;
        // we keep the SKU the server picked (its tiebreak reads an SSM priority list we don't have
        // here) and only swap which speed's date we show for it
        if (siteSpeedOverride) {
          const fastestEstimate = estimates.find(estimate => estimate.sku === sku);
          const overridden = fastestEstimate && fastestEstimate[siteSpeedOverride];
          if (overridden && overridden.date) {
            expiry = overridden.expiry;
            text = overridden.text;
          }
        }
        const skuFrameDetails = window.getFrameDetailsBySku(sku);
        if (skuFrameDetails && skuFrameDetails.category) {
          fastestShippedSku = {
            sku: skuFrameDetails.category,
            expiry,
            text,
          };
        }
      }
      if (location === 'cart') {
        updateCartDeliveryEstimate(estimateText, estimateExpiry, recipientPostalCode);
      }
    } else {
      var skuFrameDetails = window.getFrameDetailsBySku(skus[0]);

      if (skuFrameDetails.isSoldOut || skuFrameDetails.isBackOrder) {
        hideAllShippingElements(location);
        return;
      }

      // Fetch city for zip code
      var zipCode = getDeliveryPostalCode();
      const cityInfoData = await getCityInfoData(zipCode);
      if (!cityInfoData || (cityInfoData && cityInfoData.error) && !zipCode) {
        // Render empty zip input

        getDeliveryEstimateWrappers(location).forEach(deliveryEstimateWrapper => {
          setSkeletonLoaded(deliveryEstimateWrapper);
          renderEstimateZipcode(deliveryEstimateWrapper, null, location);
          const deliveryPromiseWrapper = deliveryEstimateWrapper.querySelector(getClassSelector(SELECTORS.DELIVERY_PROMISE_WRAPPER));
          deliveryPromiseWrapper.classList.remove('hide');
          deliveryPromiseWrapper.classList.add('active');
        });
        return;
      } else {
        const { postal_code, city } = cityInfoData;
        recipientPostalCode = postal_code || getDeliveryPostalCode();
        recipientCity = city;
        if (postal_code && !getDeliveryPostalCode()) {
          setCookie('delivery_postal_code', postal_code, null, `.${window.location.hostname}`);
        }
      }

      if (!recipientPostalCode) {
        getDeliveryEstimateWrappers(location).forEach(deliveryEstimateWrapper => {
          setSkeletonLoaded(deliveryEstimateWrapper);
          renderEstimateZipcode(deliveryEstimateWrapper, null, location);
          const deliveryPromiseWrapper = deliveryEstimateWrapper.querySelector(getClassSelector(SELECTORS.DELIVERY_PROMISE_WRAPPER));
          deliveryPromiseWrapper.classList.remove('hide');
          deliveryPromiseWrapper.classList.add('active');
        });
        return;
      }

      deliveryData = await deliveryHandler.fetchDeliveryEstimate(skus);

      if (!deliveryData) {
        return;
      }
      const {
        free_shipping,
        expiry,
        sku,
        amazon_standard_num_days_to_add_to_estimate,
      } = deliveryData;

      shippingMethod = free_shipping;
      estimateExpiry = expiry;

      const speedOverride = shippingSpeedTestSpeedFor(free_shipping);
      if (speedOverride && deliveryData[speedOverride] && deliveryData[speedOverride].date) {
        shippingMethod = speedOverride;
        estimateExpiry = deliveryData[speedOverride].expiry || expiry;
      }

      const estimateForShippingMethod = deliveryData[shippingMethod];
      estimateText = estimateForShippingMethod.text;
      let viewerRegion = deliveryData.viewer !== undefined ? deliveryData.viewer.region : null;
      let recipientRegion = deliveryData.recipient !== undefined ? deliveryData.recipient.region : null;
      logDeliveryEstimatesAnalytics({
        location: location,
        zip: recipientPostalCode,
        recipient_region: recipientRegion,
        viewer_region: viewerRegion,
        estimate_method: shippingMethod,
        sku: estimateForShippingMethod['sku'],
        estimate_date: estimateForShippingMethod['date']
      })
      if (shippingMethod === 'amazon_standard' && amazon_standard_num_days_to_add_to_estimate) {
        estimateText = padAmazonStandardEstimate(estimateText, amazon_standard_num_days_to_add_to_estimate, true);
      }

      if (location === 'featured-frames') {
        renderFeaturedProductDeliveryEstimate(estimateText, sku);
      }
      if (location === 'cart') {
        updateCartDeliveryEstimate(estimateText, estimateExpiry, recipientPostalCode);
      }
    }

    getDeliveryEstimateWrappers(location).forEach(deliveryEstimateWrapper => {
      if (fastestShippedSku) {
        renderDeliveryPromiseEstimateDate(fastestShippedSku.text, deliveryEstimateWrapper, fastestShippedSku.sku);
        renderDynamicShippingElement(recipientPostalCode, fastestShippedSku.expiry, recipientCity, deliveryEstimateWrapper);
      } else {
        renderDeliveryPromiseEstimateDate(estimateText, deliveryEstimateWrapper);
        renderDynamicShippingElement(recipientPostalCode, estimateExpiry, recipientCity, deliveryEstimateWrapper);
      }
    });
  }

  async function updateDeliveryEstimateMessagePDP(sku = null) {

    if (!showDeliveryEstimate()) {
      return;
    }

    let skus;

    if (!sku) {
      skus = getActiveSkus();
    } else {
      skus = [sku];
    }

    await updateDeliveryEstimateMessage({
      setEstimateDate: true,
      location: 'pdp',
      skus: skus
    });
  }

  function logDeliveryEstimatesAnalytics(
    options = {location: null,
    zip: null,
    recipient_region: null,
    viewer_region: null,
    estimate_method: null,
    sku: null,
    estimate_date: null}){
    logGA4Event('delivery_estimate_shown', options);
  }

  async function updateDeliveryEstimateMessageFeaturedFrames() {
    if (isCaLocale) return;

    const siteDetails = getSiteDetails();

    if (siteDetails && siteDetails.featuredFramesStage == 'off-promo') {
      return;
    }

    const skus = getProductsByFeaturedSection();

    await updateDeliveryEstimateMessage({
      setEstimateDate: false,
      location: 'featured-frames',
      skus: skus
    });
  }

  async function updateDeliveryEstimateMessageShopAllFeatured() {
    if (isCaLocale) return;

    const skus = getProductsByShopFramesFeaturedSection();

    await updateDeliveryEstimateMessage({
      setEstimateDate: false,
      location: 'shop-all',
      skus: skus
    });
  }

  async function updateDeliveryEstimateMessageShopFrames() {
    if (isCaLocale) return;

    const skus = getMCFProductsByShopSection();

    await updateDeliveryEstimateMessage({
      setEstimateDate: false,
      location: 'shop-frames',
      skus: skus
    });
  }

  function findDeliverEstimateLocationBasedOnLocation(deliveryEstimateWrapper) {
    const classNames = Array.from(deliveryEstimateWrapper.classList);

    const location = classNames.find(className => {
        return ['action--estimate-location-cart', 'action--estimate-location-pdp', 'action--estimate-location-shop-frames', 'action--estimate-location-featured-frames', 'action--estimate-location-shop-all'].includes(className);
    });
    return location || 'unknown';
  }

  function updateDeliveryEstimateMessageBasedOnLocation(deliveryEstimateWrapper) {
    const location = findDeliverEstimateLocationBasedOnLocation(deliveryEstimateWrapper)
    if (location === 'action--estimate-location-cart') {
      updateDeliveryEstimateMessageCart();
    } else if (location === 'action--estimate-location-pdp') {
      updateDeliveryEstimateMessagePDP();
    } else if (location === 'action--estimate-location-featured-frames') {
      updateDeliveryEstimateMessageFeaturedFrames();
    } else if (location === 'action--estimate-location-shop-frames') {
      updateDeliveryEstimateMessageShopFrames();
    } else if (location === 'action--estimate-location-shop-all') {
      updateDeliveryEstimateMessageShopAllFeatured();
    }
  }

  function updateDeliveryEstimateMessageBasedOnSkus() {
    if (isOrderPage()) {
      updateDeliveryEstimateMessagePDP();
    } else if (isHomePage()){
      updateDeliveryEstimateMessageFeaturedFrames();
    } else if (isShopFramesPage()) {
      updateDeliveryEstimateMessageShopFrames();
    } else if (isFeaturedFramesPage()) {
      updateDeliveryEstimateMessageFeaturedFrames();
    } else if (isShopAllPage()) {
      updateDeliveryEstimateMessageShopAllFeatured();
    }
  }

  async function updateDeliveryEstimateMessageCart() {
    const skus = getSkusFromCart();

    if (giftBagChecked()) {
      skus.push(GIFT_BAG_SKU);
    }

    await updateDeliveryEstimateMessage({
      setEstimateDate: false,
      location: 'cart',
      skus: skus
    });
  }

  function updateDeliveryEstimateMessageBasedOnCart() {
    updateDeliveryEstimateMessageCart();
  }

  function updateBopisMerchandisingPDP(sku) {
    if (!$(getClassSelector(SELECTORS.BOPIS_MERCHANDISING)).hasClass('bopis-test')) return;
    const showBopisMerchandising = BBY_SKUS.includes(sku);
    if (showBopisMerchandising) {
      showBopisMerchandisingOnPages();
    } else {
      hideBopisMerchandisingOnPages();
    }
  }

  // lineItems = [{"sku":"AF900-MBLK","quantity":1}, {"sku":"AF110-MBLK","quantity":1}]
  async function fetchBopisAvailability(lineItems, zip) {
    const url = new URL(`v5/bopis/cart_pickup_multiple_availabilities`, `https://api.pushd.com`);

    const postalCode = zip || getDeliveryPostalCode();
    if (postalCode) {
      url.searchParams.set('postal_code', postalCode);
    }
    url.searchParams.set('line_items', JSON.stringify(lineItems));

    let response;
    try {
      response = await fetch(url);
    } catch (error) {
      console.error('Fetch error:', error);
      return null;
    }
    if (!response) {
      return null;
    }
    return response.json();
  }

  function changeBopisStore() {
    const bopisStoreSelector = $(getClassSelector(SELECTORS.BOPIS_MERCHANDISING_STORE_SELECTOR));
    const bopisStoreSelectorLink = $(getClassSelector(SELECTORS.BOPIS_MERCHANDISING_STORE_SELECTOR_LINK));
    if (bopisStoreSelector) {
      bopisStoreSelector.removeClass('hide');
      bopisStoreSelector.removeAttr('inert');
      bopisStoreSelectorLink.addClass('hide');
      bopisStoreSelectorLink.removeAttr('inert');
    }

    const bopisStoreSelectorLocations = $(getClassSelector(SELECTORS.BOPIS_MERCHANDISING_STORE_SELECTOR_LOCATION));
    const locationIds = [];
    bopisStoreSelectorLocations.each(function(index, location) {
      const locationId = location.value;
      if (locationId !== '') {
        locationIds.push(locationId);
      }
    });
    bopisStoreSelectorLink.on('click', sendBopisAnalytics('cart_bopis_select_store', { locationIds: locationIds }));

    bopisStoreSelectorLocations.each(function() {
      $(this).on('click', function(event) {
        selectBopisStore(event);
        resetChangeBopisStore();
      });
    });
  }

  function resetChangeBopisStore() {
    const bopisStoreSelector = $(getClassSelector(SELECTORS.BOPIS_MERCHANDISING_STORE_SELECTOR));
    const bopisStoreSelectorLink = $(getClassSelector(SELECTORS.BOPIS_MERCHANDISING_STORE_SELECTOR_LINK));
    if (bopisStoreSelector) {
      bopisStoreSelector.addClass('hide');
      bopisStoreSelectorLink.removeClass('hide');
    }
  }

  function getBopisDeliveryAddress(locationId) {
    const bopisLocationData = findBopisLocationDataById(locationId);
    if (bopisLocationData) {
      const { address, city, region, postalCode, locationId } = bopisLocationData.location_data;

      const deliveryAddresses = [{
        deliveryAddress: {
          address1: address,
          city: city,
          province: region,
          zip: postalCode,
          country: 'US',
          company: 'Best Buy Store #' + locationId,
        }
      }];
      return deliveryAddresses;
    }
  }

  async function selectBopisStoreById(locationId) {
    const cartId = getShopifyCartId();
    const attributes = setBopisAttributes('true', locationId);
    if (cartId && attributes && attributes.length > 0) {
      // Add _bopis_lp attributes to cart
      attributes.push({ key: 'bopis_lp', value: 'true' });
      const resp = await updateShopifyCartAttributes(attributes, cartId);
      if (resp) {
        const deliveryAddresses = getBopisDeliveryAddress(locationId);
        if (deliveryAddresses) {
          const updatedCart = await updateBuyerIdentityShopifyCart(deliveryAddresses, cartId, '', "COUNTRY_CODE_ONLY");
          return updatedCart;
        }
      }
    }
  }

  async function selectBopisStore(event) {
    event.preventDefault();
    const locationId = $(event.currentTarget).val();
    const cartId = getShopifyCartId();
    const attributes = setBopisAttributes('true', locationId);
    if (cartId && attributes && attributes.length > 0) {
      const resp = await updateShopifyCartAttributes(attributes, cartId);
      if (resp) {
        const deliveryAddresses = getBopisDeliveryAddress(locationId);
        if (deliveryAddresses) {
          updateBuyerIdentityShopifyCart(deliveryAddresses, cartId, '', "COUNTRY_CODE_ONLY");
        }
      }
    }
    const bopisLocationData = findBopisLocationDataById(locationId);
    if (bopisLocationData) {
      renderBopisMainStore(bopisLocationData);
    } else if (locationId === '0') {
      hideBopisMerchandisingCart();
    } else {
      hideBopisMerchandisingCart();
    }
    const bopisStoreSelectorLocations = $(getClassSelector(SELECTORS.BOPIS_MERCHANDISING_STORE_SELECTOR_LOCATION));
    bopisStoreSelectorLocations.each(function() {
      if ($(this).val() === locationId && locationId !== '0') {
        $(this).prop('checked', true);
      } else {
        $(this).prop('checked', false);
      }
    });

    sendBopisAnalytics('cart_bopis_select_store_option', { locationId: locationId });
  }

  function pickupAvailabilityDate(availabilityDate, pickUpInMins, timeZoneId) {
    const storePickUpIn = pickUpInMins >= 60 ? `${Math.floor(pickUpInMins / 60)} hrs` : `1 hr`;
    const today = new Date().toLocaleDateString('en-CA', { timeZone: timeZoneId });
    if (availabilityDate === today) {
      return 'Ready for pickup in ' + storePickUpIn;
    } else if (availabilityDate !== today && availabilityDate >= today) {
      return 'Available tomorrow';
    }
    return '';
  }

  function renderBopisMainStore(store) {
    const bopisMainStoreContainer = $(getClassSelector(SELECTORS.BOPIS_MERCHANDISING_MAIN_STORE_CONTAINER));
    const { displayName: storeName, address: storeAddress, city: storeCity, region: storeRegion, postalCode: storePostalCode, timeZoneId: storeTimeZoneId } = store.location_data;
    const { availabilityDate: storeAvailabilityDate, distanceInMiles: storeDistance, pickupReadyInMinutes: storePickUpInMins } = store.delivery_details;

    const storeCityString = `${storeCity}, ${storeRegion}, ${storePostalCode}`;

    if (storeName && storeAddress && storeCityString) {
      bopisMainStoreContainer.find(getClassSelector(SELECTORS.BOPIS_MERCHANDISING_STORE_NAME)).text(storeName);
      bopisMainStoreContainer.find(getClassSelector(SELECTORS.BOPIS_MERCHANDISING_STORE_ADDRESS)).text(storeAddress);
      bopisMainStoreContainer.find(getClassSelector(SELECTORS.BOPIS_MERCHANDISING_STORE_CITY)).text(storeCityString);
      bopisMainStoreContainer.find(getClassSelector(SELECTORS.BOPIS_MERCHANDISING_STORE_DISTANCE)).html(storeDistance + '&nbsp;');
      const pickupAvailability = pickupAvailabilityDate(storeAvailabilityDate, storePickUpInMins, storeTimeZoneId);
      bopisMainStoreContainer.find(getClassSelector(SELECTORS.BOPIS_MERCHANDISING_STORE_PICKUP_IN)).html(pickupAvailability);
      showBopisMerchandisingCart();
    } else {
      hideBopisMerchandisingCart();
    }

    // show the selected store if cart select_location_id is not 0
    const bopisStore = $(getClassSelector(SELECTORS.BOPIS_MERCHANDISING_STORE));
    const getCartBopisIdValue = getCartBopisStoreId();
    if (getCartBopisIdValue && getCartBopisIdValue !== '0') {
      bopisStore.removeClass('hide');
    } else {
      bopisStore.addClass('hide');
    }
  }

  // FIXME: We can refactor this since mostly a duplicate of renderBopisMainStore
  function renderBopisStoreOption(selection, location, classSelectorPrefix){
    const { locationId: locationId, displayName: storeName, address: storeAddress, city: storeCity, region: storeRegion, postalCode: storePostalCode, timeZoneId: storeTimeZoneId } = location.location_data;
    const { availabilityDate: storeAvailabilityDate, distanceInMiles: storeDistance, pickupReadyInMinutes: storePickUpInMins, hasLimitedQuantity: hasLimitedQuantity } = location.delivery_details;
    const storeCityString = `${storeCity}, ${storeRegion}, ${storePostalCode}`;
    if (storeName && storeAddress && storeCityString) {
      const label = selection.find("label");
      const input = selection.find("input");
      if (label.length) {
        label.attr("for", locationId);
      }
      if (input.length) {
        input.addClass('action--in-store-pickup__store-selector-new-location');
      }

      selection.find(getClassSelector(SELECTORS[`${classSelectorPrefix}_STORE_SELECTOR_LOCATION`])).val(locationId);
      selection.find(getClassSelector(SELECTORS[`${classSelectorPrefix}_STORE_SELECTOR_LOCATION`])).attr('id', locationId);
      selection.find(getClassSelector(SELECTORS[`${classSelectorPrefix}_STORE_NAME`])).text(storeName);
      selection.find(getClassSelector(SELECTORS[`${classSelectorPrefix}_STORE_ADDRESS`])).html(storeAddress);
      selection.find(getClassSelector(SELECTORS[`${classSelectorPrefix}_STORE_CITY`])).text(storeCityString);
      selection.find(getClassSelector(SELECTORS[`${classSelectorPrefix}_STORE_DISTANCE`])).html(storeDistance + '&nbsp;');

      const pickupAvailability = pickupAvailabilityDate(storeAvailabilityDate, storePickUpInMins, storeTimeZoneId);
      selection.find(getClassSelector(SELECTORS[`${classSelectorPrefix}_STORE_PICKUP_IN`])).html(pickupAvailability);

      if (hasLimitedQuantity) {
        selection.find(getClassSelector(SELECTORS[`${classSelectorPrefix}_STORE_LIMITED_STOCK`])).text('Limited quantities available');
      }
    }

  }

  function renderBopisStoreSelectorStores(stores) {
    const bopisStoreSelector = $(getClassSelector(SELECTORS.BOPIS_MERCHANDISING_STORE_SELECTOR));
    const bopisStoreSelectorLocationTemplate = $(getClassSelector(SELECTORS.BOPIS_MERCHANDISING_STORE_SELECTOR_LOCATION_TEMPLATE));

    if (stores) {
      const bopisStoreSelectorLocationContainers = $(getClassSelector(SELECTORS.BOPIS_MERCHANDISING_STORE_SELECTOR_LOCATION_CONTAINER));
      bopisStoreSelectorLocationContainers.remove();
      stores.forEach(location => {
        const newLocation = bopisStoreSelectorLocationTemplate.clone();
        renderBopisStoreOption(newLocation, location, 'BOPIS_MERCHANDISING');
        newLocation.removeClass('hide');
        newLocation.removeAttr('inert');
        newLocation.removeClass('action--bopis-merchandising__store-selector-location-template');
        newLocation.addClass('action--bopis-merchandising__store-selector-location-container');
        checkIfBopisStoreSelected(newLocation, location);
        bopisStoreSelector.append(newLocation);
      });

      addShipDirectlyOption(bopisStoreSelector, bopisStoreSelectorLocationTemplate);
    }
  }

  function renderInStorePickupStoreOptions(stores, inStorePickupStoreSelector, checkoutButton) {
    //creates store cards for in store pickup page
    const inStorePickupStoreSelectorTemplate = $(getClassSelector(SELECTORS.IN_STORE_PICKUP_STORE_SELECTOR_TEMPLATE));
    const inStorePickupNoStoresMsg = $(getClassSelector(SELECTORS.IN_STORE_PICKUP_NO_STORES));

    inStorePickupStoreSelector.find('.action--in-store-pickup__store-selector-new-location').parent().parent().remove();

    if (!inStorePickupNoStoresMsg.hasClass('hide')) {
      inStorePickupNoStoresMsg.addClass('hide');
    }
    checkoutButton.classList.remove('hide', 'display-none');

    stores.forEach(location => {
      const newLocation = inStorePickupStoreSelectorTemplate.clone();
      renderBopisStoreOption(newLocation, location, 'IN_STORE_PICKUP')
      newLocation.removeClass('hide');
      newLocation.removeAttr('inert');
      newLocation.removeClass('action--in-store-pickup__store-selector-template');
      inStorePickupStoreSelector.append(newLocation)
    })
  }

  function checkIfBopisStoreSelected(newLocation, location) {
    const getCartBopisIdValue = getCartBopisStoreId();
    if (getCartBopisIdValue && getCartBopisIdValue === location.location_data.locationId) {
      newLocation.find(getClassSelector(SELECTORS.BOPIS_MERCHANDISING_STORE_SELECTOR_LOCATION)).prop('checked', true);
    }
  }

  function getCartBopisStoreId() {
    const cart = getSavedShopifyCart();
    const getCartBopisId = cart.attributes.find(attribute => attribute.key === '_selected_location_id');
    return getCartBopisId && getCartBopisId.value;
  }

  function addShipDirectlyOption(bopisStoreSelector, bopisStoreSelectorLocationTemplate) {
    const shipDirectly = bopisStoreSelectorLocationTemplate.clone();
    shipDirectly.find(getClassSelector(SELECTORS.BOPIS_MERCHANDISING_STORE_SELECTOR_LOCATION)).val('0');
    shipDirectly.find(getClassSelector(SELECTORS.BOPIS_MERCHANDISING_STORE_SELECTOR_LOCATION)).attr('id', 'ship_directly');
    shipDirectly.find(getClassSelector(SELECTORS.BOPIS_MERCHANDISING_STORE_NAME)).text('Ship directly');
    shipDirectly.removeClass('hide');
    shipDirectly.removeAttr('inert');
    shipDirectly.removeClass('action--bopis-merchandising__store-selector-location-template');
    shipDirectly.addClass('action--bopis-merchandising__store-selector-location-container');
    shipDirectly.find(getClassSelector(SELECTORS.BOPIS_MERCHANDISING_STORE_DISTANCE)).parent().addClass('hide');
    bopisStoreSelector.append(shipDirectly);
  }

  function updateBopisMerchandisingCart() {
    const cart = getSavedShopifyCart();
    const lineItems = cartHasLineItems(cart) ? cart.lines.edges
      .filter(line => line.node.quantity > 0)
      .map(line => ({ sku: line.node.merchandise.sku, quantity: line.node.quantity })) : [];
    const showBopisMerchandising = lineItems.every(lineItem => BBY_SKUS.includes(lineItem.sku));
    const bopisStoreSelectorLink = $(getClassSelector(SELECTORS.BOPIS_MERCHANDISING_STORE_SELECTOR_LINK));

    if (showBopisMerchandising && lineItems.length > 0) {
      fetchBopisAvailability(lineItems).then(async (response) => {
        if (response && response.stores) {
          updateLocalBopisStores(response.stores);

          const stores = response.stores
          const store = stores[0];
          const getCartBopisIdValue = getCartBopisStoreId();
          const exsistingStoreInArea = getCartBopisIdValue && stores.find(store => store.location_data.locationId === getCartBopisIdValue);

          if (exsistingStoreInArea == undefined) {
            const cartId = getShopifyCartId();
            const attributes = setBopisAttributes('true', '0')
            if (cartId && attributes && attributes.length > 0) {
              const resp = await updateShopifyCartAttributes(attributes, cartId);
              if (resp) {
                removeDeliveryAddressesShopifyCart([], cartId);
              }
            }
          }

          if (store && store.location_data) {
            renderBopisMainStore(exsistingStoreInArea ? exsistingStoreInArea : store);
            if (!exsistingStoreInArea) {
              const bopisStore = $(getClassSelector(SELECTORS.BOPIS_MERCHANDISING_STORE));
              bopisStore.addClass('hide');
            }
            renderBopisStoreSelectorStores(response.stores);
            if (bopisStoreSelectorLink) {
              bopisStoreSelectorLink.on('click', changeBopisStore);
            }
          }
        }
      });
    } else {
      hideBopisMerchandisingCart();
      hideBopisCartInvalidWarning(false);
    }
  }

  function updateLocalBopisStores(location_data) {
    window.localStorage && window.localStorage.setItem('bopis_stores', JSON.stringify(location_data));
  }

  function getLocalBopisStores() {
    return window.localStorage && window.localStorage.getItem('bopis_stores');
  }

  function findBopisLocationDataById(id) {
    const localBopisStores = JSON.parse(getLocalBopisStores() || '[]');

    if (localBopisStores) {

      const locationMatch = localBopisStores.find(location => location.location_data.locationId === id);
      if (locationMatch) {
        return locationMatch;
      }

    }
    return null;
  }

  function showBopisMerchandisingCart() {
    const cartBopis = $(getClassSelector(SELECTORS.CART_BOPIS_MERCHANDISING));
    cartBopis.removeClass('hide');
    cartBopis.removeAttr('inert');
    const cartId = getShopifyCartId();
    const attributes = setBopisAttributes('true', '')
    if (cartId && attributes && attributes.length > 0) {
      updateShopifyCartAttributes(attributes, cartId);
      sendBopisAnalytics('cart_bopis', { value: true });
      hideBopisCartInvalidWarning(true);
    }

  }

  async function hideBopisMerchandisingCart() {
    $(getClassSelector(SELECTORS.CART_BOPIS_MERCHANDISING)).addClass('hide');
    const cartId = getShopifyCartId();
    // also reset bopis_lp so a stale pickup flag can't block shipping at checkout
    const attributes = [
      ...setBopisAttributes('false', '0'),
      { key: 'bopis_lp', value: 'false' }
    ];

    if (cartId && attributes && attributes.length > 0) {
      // update the cart with the bopis attribute
      const resp = await updateShopifyCartAttributes(attributes, cartId);
      if (resp) {
        // clear the delivery address if present
        const cart = getSavedShopifyCart();
        if (cart && cart.buyerIdentity && cart.buyerIdentity.deliveryAddressPreferences && cart.buyerIdentity.deliveryAddressPreferences.length > 0) {
          await removeDeliveryAddressesShopifyCart([], cartId);
        }
      }
      sendBopisAnalytics('cart_bopis', { value: false });
    }
  }

  async function clearBopisLp(currentCart) {
    const cartId = getShopifyCartId();
    const bopisLpAttribute = currentCart.attributes.find(attribute => attribute.key === 'bopis_lp');

    if (!bopisLpAttribute || bopisLpAttribute.value !== 'true') return;

    const lineItems = currentCart.lines.edges
      .filter(line => line.node.quantity > 0)
      .map(line => ({ sku: line.node.merchandise.sku, quantity: line.node.quantity }));

    const isBopisValid = lineItems.every(lineItem => BBY_SKUS.includes(lineItem.sku));
    if (isBopisValid) return;

    const attributes = [
      ...setBopisAttributes('false', '0'),
      { key: 'bopis_lp', value: 'false' }
    ];

    if (!cartId || attributes.length === 0) return;

    const updatedCart = await updateShopifyCartAttributes(attributes, cartId);
    if (!updatedCart) return;

    const cart = getSavedShopifyCart() || {};
    if (cart && cart.buyerIdentity && cart.buyerIdentity.deliveryAddressPreferences && cart.buyerIdentity.deliveryAddressPreferences.length > 0) {
      sendBopisAnalytics('cart_bopis', { value: false });
      const invalidBopisCartWarning = document.querySelector('.action--bopis-cart-not-valid');
      invalidBopisCartWarning.classList.add('shown')
      hideBopisCartInvalidWarning(false);
      return await removeDeliveryAddressesShopifyCart([], cartId);
    }
  }

  function hideBopisCartInvalidWarning(hide) {
    const invalidBopisCartWarning = document.querySelector('.action--bopis-cart-not-valid');
    if (!invalidBopisCartWarning) return;
    if (invalidBopisCartWarning.classList.contains('shown')) {
      invalidBopisCartWarning.classList.toggle('hide', hide);
    }
  }

  function showBopisMerchandisingOnPages() {
    $(getClassSelector(SELECTORS.BOPIS_MERCHANDISING)).removeClass('hide');
  }

  function hideBopisMerchandisingOnPages() {
    $(getClassSelector(SELECTORS.BOPIS_MERCHANDISING)).addClass('hide');
  }

  function disableDeliveryEstimates() {
    return (document.querySelector('body').classList.contains('disable-delivery-estimates'));
  }

  async function setDeliveryEstimatesDisabledForCart() {
    await setCartAttributes([{ key: '_disable_delivery_estimates', value: 'true' }]);
  }

  function cartHasCollectiveBundle(cart) {
    if (!cartHasLineItems(cart)) return false;
  
    let collectiveVariantsData = window.grabAllCollectiveVariants();
  
    if (!Array.isArray(collectiveVariantsData) || collectiveVariantsData.length === 0) {
      return false;
    }
  
    return cart.lines.edges.some(line => {
      if (line.node.quantity <= 0) return false;
  
      const shopifyId = lineItemShopifyId(line);
  
      return collectiveVariantsData.some(variant =>
        variant.id.toString() === shopifyId
      );
    });
  }

  function clearUpsellLinesFromCart() {
    const cart = getSavedShopifyCart();
    if (
      !cart ||  !cart.attributes || !cart.attributes.some(attr => attr.key === '_upsell_checkout_test')
    ) {
      return;
    }

    if (cartHasLineItems(cart)) {
      const upsellLineIds = cart.lines.edges
        .filter(line => line.node.attributes && line.node.attributes.some(attr => attr.key === '_upsell_added'))
        .map(line => line.node.id);

      if (upsellLineIds.length > 0) {
        removeCartLinesById(upsellLineIds, getShopifyCartId());
        return;
      }
    }
    renderCartCount();
  }

  function renderCart() {
    clearUpsellLinesFromCart();
    var cart = getSavedShopifyCart();
    var $cartInfo = $(getClassSelector(SELECTORS.CART_INFO));
    var $discountContainer = $(getClassSelector(SELECTORS.CART_DISCOUNT_CONTAINER));
    var $discountCodeContainer = $(getClassSelector(SELECTORS.CART_DISCOUNT_CODE_CONTAINER));
    var $viewCartButton = $(getClassSelector(SELECTORS.VIEW_CART));
    var subtotal = 0;
    var totalQuantity = 0;
    var hasBackOrder = false;
    var adWordsItems = [];
    var skus = [];
    var variants = [];

    clearCartItems();
    var framesData = window.grabAllFramesData();
    if (cartHasLineItems(cart)) {
      cart.lines.edges.forEach(function(line) {
        var lineItem = line.node;
        var shopifyId = lineItemShopifyId(line);
        var quantity = lineItem.quantity;
        totalQuantity += quantity;
        subtotal += parseInt(line.node.cost.totalAmount.amount);

        let itemData = null;
        let thumbnail = null;
        let isBackOrder = false;

        const isCollective = window.isCollectiveVariant(shopifyId);

        if (isCollective) {
          const collectiveVariantsData = window.grabAllCollectiveVariants();

          itemData = collectiveVariantsData.find(
            v => v.id.toString() === shopifyId
          )
          if (!itemData) return;
          
          thumbnail = itemData.image.jpg;
          isBackOrder = false;
        } else {
          Object.keys(framesData).forEach(function (key) {
            const frame = framesData[key];
            if (frame.shopifyId.toString() !== shopifyId) return;
            itemData = frame;
            thumbnail = frame.cartImage;
            isBackOrder = frame.isBackOrder;
          })
        }

        if (!itemData || !quantity) return;
        const bundle = showBundlingMiniCart() ? totalQuantity > 1 : false ;
        renderCartItem({
          quantity,
          data: itemData,
          thumbnail,
          bundle,
          totalQuantity
        });

        const cartHasDiscountMessage = cartDiscountCodeProductMessage() !== null;
        if (cartHasDiscountMessage) {
          hideCartShipping();
        } else {
          showCartShipping();
        }
        if (isBackOrder || itemData.class == 'carver-charcoal'){
          hasBackOrder = true
        }
        skus.push(itemData.shopifyProductId);
        variants.push(itemData.shopifyId);
        adWordsItems.push({
          'name': itemData.adwordsTitle,
          'id': itemData.shopifyProductId,
          'quantity': quantity,
          'category': itemData.category,
          'price': itemData.price
        });
        showCartItems();
      });
    }

    if (totalQuantity > 0) {
      if (enableDiscountInput()) {
        $discountCodeContainer.removeClass('hide');
        $cartInfo.addClass('hide');
      }
      if (cartCheckoutUrl(cart)) {
        checkIfGiftBagInCart();
        renderCartItemizedCosts(cart);
        updateCartItemPrices(cart);
        renderShopifyDiscountCodeMessage(cart);
      }
      hideEmptyCartMessage();
      showCartItemizedCost();
      $discountContainer.hide();
      showCartShipping();
    } else {
      hideCartShipping();
      showEmptyCartMessage();
      hideCartItemizedCost();
      $discountContainer.hide();
    }

    handleViewCartClickAnalytics($viewCartButton);
    sendCartGtagAnalytics(skus, adWordsItems, subtotal)
    showGiftBag();
    showSavings();

    if (cartHasCollectiveBundle(cart)) {
      hideAllShippingElements('cart');
      setDeliveryEstimatesDisabledForCart();
      addCollectiveShippingDisclaimer('cart');
    } else if (disableDeliveryEstimates()) {
      hideAllShippingElements('cart');
      setDeliveryEstimatesDisabledForCart();
    } else {
      showCartDeliveryEstimate();
      updateDeliveryEstimateMessageBasedOnCart();
      removeCollectiveShippingDisclaimer('cart');
    }

    updateBopisMerchandisingCart();
    updateCartUrl();
    toggleMultiShipCheckoutLink()
  }

  // Single-product cart for the PDP "Buy with Shop Pay" button.
  async function createGoToCheckoutCart(variantId, quantity, attributes = []) {
    const mutation = `
      mutation CreateCart($cartInput: CartInput) @inContext(${getShopifyInContext()}) {
        cartCreate(input: $cartInput) {
          cart { 
            ...CartFragment
            lines(first: 25) {
              edges {
                node {
                  ...CartLineFragment
                }
              }
            }
          }
          userErrors { 
            field 
            message 
          }
        }
      }
      ${lineFragment}
      ${cartQueryFragment}
    `;

    const variables = {
      cartInput: {
        lines: [{ merchandiseId: `gid://shopify/ProductVariant/${variantId}`, quantity, attributes: shippingSpeedTestLineAttributes() }],
        attributes
      }
    };

    const query = { query: mutation, variables };
    const response = await shopifyStorefrontApiCall(query);

    if (response.data.cartCreate.userErrors.length > 0) {
      console.error('Shop Pay buy-now cart create error(s):', response.data.cartCreate.userErrors);
      return null;
    }
    if (response.data.cartCreate.cart) {
      return response.data.cartCreate.cart;
    }
    console.error('Shop Pay buy-now cart create error:', response);
    airbrake.notify({
      error: 'Shop Pay buy-now cart create error',
      context: { component: 'StoreFront API' },
      params: { variables, response }
    });
    return null;
  }

  function checkoutWithShopPay() {
    const shopPayButton = document.querySelector('.action--checkout-with-shop-pay');
    if (!shopPayButton) return;

    shopPayButton.addEventListener('click', async function () {
      shopPayButton.disabled = true;
      showLoadingDots('.action--checkout-with-shop-pay-text','.action--checkout-with-shop-pay-loader')

      try {
        const color = COLOR_TO_ENUM[activeFrame];
        const variantId = colorToShopifyId(color);
        const quantity = 1;

        if (!variantId) {
          console.error('checkoutWithShopPay: no variant for active frame:', activeFrame);
          return;
        }

        const attributes = setDeliveryEstimatesAttributes();
        const giftNoteAttributes = setGiftNoteAttribute();
        if (giftNoteAttributes && giftNoteAttributes.length > 0) {
          attributes.push(...giftNoteAttributes);
        }
        const testAttributeCookies = [
          '_upsell_checkout_test',
          '_upsell_collective_checkout_test',
          '_multiship_link_test',
          '_cancel_item_test',
          '_fast_shipping_copy_test'
        ];
        // FIXME: remove after test
        const pricingTestCookieNames = (window.MERCHANDISING_TESTS || []).reduce(function (names, test) {
          if (names.indexOf(test.cookieName) === -1) names.push(test.cookieName);
          return names;
        }, []);
        
        const testAttributes = testAttributeCookies
          .concat(pricingTestCookieNames)
          .map(cookieCartAttribute)
          .filter(Boolean);
        
        attributes.push(...testAttributes);
        attributes.push(...shippingSpeedTestCartAttributes());

        const cart = await createGoToCheckoutCart(variantId, quantity, attributes);

        if (!cart || !cart.checkoutUrl) {
          console.error('checkoutWithShopPay: no checkoutUrl for variant', variantId);
          return;
        }
        sendCartCheckoutAnalytics(cart);
        logGA4Event('buy_with_shop_click',{
          product: color
        })
        const separator = cart.checkoutUrl.includes('?') ? '&' : '?';
        window.location.href = `${cart.checkoutUrl}${separator}payment=shop_pay`;
      } catch (error) {
        console.error('checkoutWithShopPay failed:', error);
        airbrake.notify({ error: 'checkoutWithShopPay failed', context: { component: 'StoreFront API' }, params: { message: error.message } });
      } finally {
        shopPayButton.disabled = false;
      }
    });
  }

  function cookieCartAttribute(experimentCookie) {
    const cookieValue = getCookie(experimentCookie);
    return cookieValue ? { key: experimentCookie, value: 'true' } : null;
  }

  function handleViewCartClickAnalytics($viewCartBtn) {
    $viewCartBtn.on('click', () => {
      logGA4Event('view_cart_click', {});
    });
  }

  function giftBagChecked(){
    return $(getClassSelector(SELECTORS.GIFT_BAG)).is(':checked');
  }

  async function giftBagToggle(){
    const cartId = getShopifyCartId();
    if (giftBagChecked()) {
      if (cartId && cartId.length > 0) {
        const updatedCart = await addLinesShopifyCart({[colorToShopifyId("GIFT_BAG")]: { quantity: 1 }}, cartId);
        if (updatedCart) {
          logGA4Event('add_gift_bag', {
            info: "add gift bag"
          });
          $(getClassSelector(SELECTORS.CART_ACTIONS)).addClass("active");
          $(getClassSelector(SELECTORS.CART_TOP)).addClass("giftbag-active");
        } else {
          console.error('Failed to add gift bag to cart for cartId: ' + cartId);
        }
      }
    } else {
      if (cartId && cartId.length > 0) {
        const updatedCart = await removeLinesShopifyCart([colorToShopifyId("GIFT_BAG")], cartId);
        if (updatedCart) {
          logGA4Event('remove_gift_bag', {
            info: "remove gift bag"
          });
          $(getClassSelector(SELECTORS.CART_ACTIONS)).removeClass("active")
          $(getClassSelector(SELECTORS.CART_TOP)).removeClass("giftbag-active");
        }  else {
          console.error('Failed to remove gift bag from cart for cartId: ' + cartId);
        }
      }
    }
  }

  function updateCartDeliveryEstimate(text, expiry, zip) {
    cartDeliveryEstimateText = text;
    cartDeliveryEstimateExpiry = expiry;
    cartDeliveryEstimateZip = zip;
    updateCartUrl();
  }

  function updateCartUrl() {
    var cart = getSavedShopifyCart();
    var $checkoutButton = $(getClassSelector(SELECTORS.CART_CHECKOUT));
    var $viewCartButton = $(getClassSelector(SELECTORS.VIEW_CART));
    const siteDetails = getSiteDetails();
    const customCheckoutUrlParam = siteDetails.customCheckoutUrlParam.trim() || '';
    if (cartHasLineItems(cart) && cartCheckoutUrl(cart)) {
      var checkoutUrl = cartCheckoutUrl(cart);
      if (customCheckoutUrlParam && customCheckoutUrlParam !== '' && customCheckoutUrlParam !== null) {
        checkoutUrl += '?' + customCheckoutUrlParam;
      }
      $checkoutButton.attr('href', checkoutUrl);
    } else {
      $checkoutButton.addClass('btn--secondary--black-disabled')
      $viewCartButton.addClass('btn--secondary--black-disabled')
      $checkoutButton.attr('href', 'javascript: void(0)');
      return false
    }
    getCookieSetCartAttribute('_upsell_checkout_test');
    getCookieSetCartAttribute('_upsell_collective_checkout_test');
    getCookieSetCartAttribute('_multiship_link_test');
    getCookieSetCartAttribute('_cancel_item_test');
    getCookieSetCartAttribute('_fast_shipping_copy_test');
    // FIXME: remove after test
    // Dedupe cookieNames first - firing the same attribute update concurrently causes cart API CONFLICT errors.
    var pricingTestCookieNames = (window.MERCHANDISING_TESTS || []).reduce(function (names, test) {
      if (names.indexOf(test.cookieName) === -1) names.push(test.cookieName);
      return names;
    }, []);
    pricingTestCookieNames.forEach(function (cookieName) {
      getCookieSetCartAttribute(cookieName);
    });
  }

  function renderCartSubtotal(cart) {
    var subtotal = 0;
    if (cartHasLineItems(cart)) {
      cart.lines.edges.forEach(function(line) {
        const amount = Number(line.node.cost.subtotalAmount.amount);
        if (!Number.isNaN(amount)) {
          subtotal += amount;
        }
      });
    }

    subtotal = Number.isInteger(subtotal)
    ? subtotal.toString()
    : subtotal.toFixed(2);

    if (subtotal > 0) {
      var $subtotalSelector = $(getClassSelector(SELECTORS.CART_SUBTOTAL));
      var $subtotalAmount = $(getClassSelector(SELECTORS.CART_SUBTOTAL_AMOUNT));
      var subtotalDisplay = formatPriceWithLocaleDelimiter(subtotal);
      $subtotalAmount.text(getPriceOrientated(subtotalDisplay));
      $subtotalSelector.removeClass('hide');
      $subtotalSelector.attr('aria-description', getPriceOrientated(subtotalDisplay));
    }
  }

  function renderCartEstimateTotal(estimateTotal) {
    var $estimateTotalSelector = $(getClassSelector(SELECTORS.CART_ESTIMATE_TOTAL));
    var $estimateTotalAmount = $(getClassSelector(SELECTORS.CART_ESTIMATE_TOTAL_AMOUNT));
    var estimateDisplay = formatPriceWithLocaleDelimiter(Number(estimateTotal));
    $estimateTotalAmount.text(getPriceOrientated(estimateDisplay));
    if (I18n.locale == 'de-LU' || I18n.locale == 'fr-LU') {
      var $recyclingFeeSelector = $(getClassSelector(SELECTORS.CART_RECYCLING_FEE));
      var $recyclingFeeAmount = $(getClassSelector(SELECTORS.CART_RECYCLING_FEE_AMOUNT));
      var recyclingFee = getCartItemCount() * 0.7;
      $recyclingFeeAmount.text(getPriceOrientated(formatPriceWithLocaleDelimiter(recyclingFee)));
      $recyclingFeeSelector.removeClass('hide');
    }
    $estimateTotalSelector.removeClass('hide');
  }

  function renderSavings(discount, locale, discountCodeProduct, discountCodeMessage) {
    var $saving = $(getClassSelector(SELECTORS.CART_SAVING_AMOUNT))
    var text = getDiscountText(locale, discount, discountCodeProduct, discountCodeMessage);
    $saving.text(text);
  }

  function renderCartItemizedCosts(cart) {
    var cartDiscountTotalAmount = calculateTotalDiscount(cart);
    renderCartSubtotal(cart)
    renderCartDiscounts(cartDiscountTotalAmount);
    renderCartEstimateTotal(subtotal());
    renderSavings(cartDiscountTotalAmount, I18n.locale, cartContainsDiscountCodeProduct(), cartDiscountCodeProductMessage());
  }

  function renderCartDiscounts(finalDiscount) {
    var $discountsAmountElement = $(getClassSelector(SELECTORS.CART_DISCOUNTS_AMOUNT));
    var discounted = finalDiscount > 0;
    if (discounted) {
      $(getClassSelector(SELECTORS.CART_DISCOUNTS)).removeClass('hide');
      $(getClassSelector(SELECTORS.CART_DISCOUNTS)).attr('tabindex', '0');
    } else {
      $(getClassSelector(SELECTORS.CART_DISCOUNTS)).addClass('hide');
      $(getClassSelector(SELECTORS.CART_DISCOUNTS)).attr('tabindex', '-1');
    }
    $discountsAmountElement.text((discounted ? '-' : '') + getPriceOrientated(Math.floor(finalDiscount)));
    $discountsAmountElement.toggleClass('discounted', discounted);
  }

  function getBundleDiscount() {
    if(isCollectiveBundleChecked()) {
      return 0;
    } else {
      const siteDetails = getSiteDetails();
      return siteDetails.bundle || 0;        
    }
  }

  function getDiscountText(locale, discountAmount, discountCodeProduct, discountCodeMessage) {
    var discountTitle = discountCodeTitleFromCookie() != null ? discountCodeTitleFromCookie() : false;
    var match = /Code\s+([A-Z0-9]+)/i.exec(discountCodeMessage);

    if (discountTitle) {
      var codeValue = discountTitle;
    } else {
      var tempElement = document.createElement('div');
      tempElement.innerHTML = discountCodeMessage;

      var discountCodeElement = tempElement.querySelector('.discount_code');

      if (discountCodeElement) {
        var codeValue = discountCodeElement.textContent;
      } else if (match) {
        codeValue = match[1];
      }
    }

    switch(locale) {
      case 'de':
      case 'de-LU':
      case 'de-NL':
      case 'de-BE':
        var discountText = "Heute sparen Sie " + getPriceOrientation(formatPriceWithLocaleDelimiter(discountAmount.toFixed(0)), getCurrencySymbol(locale)) + " !";
      break;
      case 'fr':
      case 'fr-LU':
      case 'fr-NL':
      case 'fr-BE':
        var discountText = "Vous économisez " + getPriceOrientation(formatPriceWithLocaleDelimiter(discountAmount.toFixed(0)), getCurrencySymbol(locale)) + " aujourd'hui !";
      break;
      case 'nl-NL':
      case 'nl-BE':
        var discountText = "U bespaart vandaag " + getPriceOrientation(formatPriceWithLocaleDelimiter(discountAmount.toFixed(0)), getCurrencySymbol(locale)) + " !";
      break;
      default:
        var discountText = "You're saving " + getPriceOrientation(formatPriceWithLocaleDelimiter(discountAmount.toFixed(0)), getCurrencySymbol(locale)) + " today!";
        var discountCodeText = "Save " + getPriceOrientation(formatPriceWithLocaleDelimiter(discountAmount.toFixed(0)), getCurrencySymbol(locale)) + " with code " + codeValue;
        break;
    }
    return discountAmount > 0 ? discountCodeProduct ? discountCodeText : discountText: null;
  }

  function getBundleText(locale, bundle) {
    switch(locale) {
      case 'de':
      case 'de-LU':
      case 'de-NL':
      case 'de-BE':
        var bundleText = "2 Kaufen, "+ getPriceOrientation(getBundleDiscount(), getCurrencySymbol(locale)) + " Sparen!";
        var bundledAppliedText = "Jetzt von unserem Bündelrabatt profitieren!";
      break;
      case 'fr':
      case 'fr-LU':
      case 'fr-NL':
      case 'fr-BE':
        var bundleText = "Achetez-en 2, Économisez "+ getPriceOrientation(getBundleDiscount(), getCurrencySymbol(locale)) + "!";
        var bundledAppliedText = "Remise groupée appliquée!";
      break;
      case 'nl-NL':
      case 'nl-BE':
        var bundleText = "Koop 2, Bespaar "+ getPriceOrientation(getBundleDiscount(), getCurrencySymbol(locale)) + "!";
        var bundledAppliedText = "Bundelkorting toegepast!";
      break;
      default:
        var bundleText = "Buy any 2 frames, Save "+ getPriceOrientation(getBundleDiscount(), getCurrencySymbol(locale)) + "!";
        var bundledAppliedText = "Bundle discount applied!";
      break;
    }
    if (enableDiscountInput()) {
      bundleText = '';
    }
    return bundle ? bundledAppliedText : bundleText;
  }

  function cartContainsDiscountCodeProduct() {
    return findCartItemByDataType('discountcodeproduct').some(item => $(item).data('discountcodeproduct') !== false);
  }

  function cartDiscountCodeProductMessage() {
    const discountCodeMessageItem = findCartItemByDataType('discountcodemessage')[0];

    if (discountCodeMessageItem) {
      const discountCodeMessage = $(discountCodeMessageItem.item).data('discountcodemessage');
      return discountCodeMessage || null;
    }

    return null;
  }

  function renderCartLineItemPricing($item, strikePrice, price, currencySymbol) {
    var cartItemPrice = $item.find(getClassSelector(SELECTORS.CART_ITEM_PRICE));
    var cartItemdiscountedPrice = $item.find(getClassSelector(SELECTORS.CART_ITEM_SALE_PRICE));
    var cartItemOriginalPrice = $item.find(getClassSelector(SELECTORS.CART_ITEM_ORIGINAL_PRICE));

    function updatePriceElement($element, value) {
      var $displayValue = getPriceOrientation(formatPriceWithLocaleDelimiter(value), currencySymbol);
      $element.text($displayValue);
      $element.attr('aria-hidden', 'false');
    }
    if (strikePrice) {
      updatePriceElement(cartItemdiscountedPrice, price);
      updatePriceElement(cartItemOriginalPrice, strikePrice);
    } else {
      updatePriceElement(cartItemPrice, price);
    }
  }

  function updateCartItemPrices(cart) {
    if (cart.lines && cart.lines.edges && cart.lines.edges.length > 0) {
      const collectiveVariantsData = window.grabAllCollectiveVariants();
      cart.lines.edges.forEach(function(line) {
        var item = line.node;
        var shopifyId = lineItemShopifyId(line);
        const isCollective = window.isCollectiveVariant(shopifyId);

        var frameDetails = isCollective 
        ? collectiveVariantsData.find(v => v.id.toString() === shopifyId)
        : grabFrameData(shopifyId);

        if (!frameDetails) return;

        var price = calculateFramePrice(frameDetails);
        var strikePrice = calculateStrikePrice(frameDetails);
        var currencySymbol = item.cost.amountPerQuantity.currencyCode;
        var $item = $(getClassSelector(SELECTORS.CART_ITEM + '[data-shopify-id="' + shopifyId + '"]'));
        renderCartLineItemPricing($item, strikePrice, price, currencySymbol);
      });
    }
  }

  function renderCartItem(params) {
    var bundle = params.bundle;
    var discountCodePrice = discount_code_data_by_type(params.data, 'discount_price');
    var discountCodeMessage = discount_code_data_by_type(params.data, 'discount_message')
    var quantity = params.quantity;
    var data = params.data;
    var thumbnail = params.thumbnail;
    var isMinQuantity = quantity === 1;
    var isMaxQuantity = quantity >= 999;
    var $template = $(getClassSelector(SELECTORS.CART_ITEM_TEMPLATE)).clone();
    var discountCodeProduct = data.discountCodeProduct;
    const isCollective = window.isCollectiveVariant(data.id);

    const dataAttributes = {
      'data-shopify-id': isCollective ? data.id : data.shopifyId,
      'data-class': data.class,
      'data-quantity': quantity,
      'data-bundle': bundle,
      'data-discountCodeProduct': discountCodeProduct,
      'data-discountCodeMessage': discountCodeMessage,
      'data-price': data.price,
      'data-originalPrice': data.originalPrice,
      'data-discountCodePrice': discountCodePrice,
      'data-isCollective': isCollective ? true : false
    };

    $template
      .removeClass(SELECTORS.CART_ITEM_TEMPLATE)
      .addClass(SELECTORS.CART_ITEM);

    for (const [attribute, value] of Object.entries(dataAttributes)) {
      if (value !== null && value !== undefined && value !== "") {
        $template.attr(attribute, value);
      }
    }

    // set image source
    $template.find(getClassSelector(SELECTORS.CART_ITEM_THUMBNAIL)).attr("src", thumbnail);
    $template.find(getClassSelector(SELECTORS.CART_ITEM_THUMBNAIL_CONTAINER)).attr("href", data.productUrl);

    // set title
    let cartTitleText = '';

    if (data.product && data.product.vendor) {
      cartTitleText = data.product.vendor;
    } else if (data.categoryWithDisplaySize) {
      cartTitleText = data.categoryWithDisplaySize;
    }

    $template.find(getClassSelector(SELECTORS.CART_ITEM_COLLECTION)).text(cartTitleText);

    $template.find(getClassSelector(SELECTORS.CART_ITEM_TITLE)).text(data.title);

    // set qty
    var $cartQuantity = $template.find(getClassSelector(SELECTORS.CART_ITEM_QUANTITY));
    $cartQuantity.text(quantity);

    // set fulfillment cart message
    if (data.fulfillmentCartMessage !== null) {
      showCartItemFulfillmentMessage($template, data.fulfillmentCartMessage);
    }

    // disable decrement quantity
    var $decrementQuantity = $template.find(getClassSelector(SELECTORS.DECREMENT_CART_ITEM_QUANTITY))
    $decrementQuantity.attr('aria-description', data.category + ' ' + data.title);

    if (isMinQuantity) {
      $decrementQuantity.addClass(CLASSES.DISABLED);
    } else {
      $decrementQuantity.on("click", async function () {
        $(this).addClass(CLASSES.DISABLED);     
        if (isCollective) {
          const variantColor = getMetafieldValue(data.metafields, 'color');
          if (variantColor) data.color = variantColor;
        }
        const updatedCart = await updateCartItem(data.color, quantity - 1);
        if (updatedCart) {
          sendUpdateCartItemDecrementAnalytics(data, 1)
          renderCart();
          renderCartCount();
          renderQuantity();
          findCartItemIndex();
          updateCartUrl();
        } else {
          console.error('Failed to decrement cart item quantity for color: ' + data.color + ' and total quantity: ' + (quantity - 1) + ' for cartId: ' + getShopifyCartId());
        }
        $(this).removeClass(CLASSES.DISABLED);
      })
    }

    var $incrementQuantity = $template.find(getClassSelector(SELECTORS.INCREMENT_CART_ITEM_QUANTITY))
    $incrementQuantity.attr('aria-description', data.category + ' ' + data.title);

    // disable incrememnt quantity
    if (isMaxQuantity) {
      $incrementQuantity.addClass(CLASSES.DISABLED);
    } else {
      $incrementQuantity.on("click", async function () {
        $(this).addClass(CLASSES.DISABLED);
        if (isCollective) {
          const variantColor = getMetafieldValue(data.metafields, 'color');
          if (variantColor) data.color = variantColor;
        }
        const updatedCart = await updateCartItem(data.color, quantity + 1);
        if (updatedCart) {
          sendUpdateCartItemIncrementAnalytics(data, 1)
          renderCart();
          renderCartCount();
          renderQuantity();
          findCartItemIndex();
          updateCartUrl();
        } else {
          console.error('Failed to increment cart item quantity for color: ' + data.color + ' and total quantity: ' + (quantity + 1) + ' for cartId: ' + getShopifyCartId());
        }
        $(this).removeClass(CLASSES.DISABLED);
      })
    }

    // add remove listener
    $template.find(getClassSelector(SELECTORS.CART_ITEM_REMOVE)).on("click", async function () {
      if (isCollective) {
        const variantColor = getMetafieldValue(data.metafields, 'color');
        if (variantColor) data.color = variantColor;
      }
      const updatedCart = await removeColorFromCart(data.color);
      if (updatedCart) {
        $template.remove();
        renderCartCount();
        renderQuantity();
        renderCart();
        findCartItemIndex();
        if (isGiftingPage()) {
          clearGiftingPageSelections(isCollective);
        }
      } else {
        console.error('Failed to remove color from cart: ' + data.color + ' for cartId: ' + getShopifyCartId());
      }
    })

    $template.attr('tabindex', 0);

    $(getClassSelector(SELECTORS.CART_ITEMS)).append($template);
  }

  function bindEscapeCartCloseListener(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      renderCloseCart('Escape Key');
      if (isOverlayShowing) {
        hideOverlay();
      }
      unbindCartToggleListeners()
    }
  }

  function bindCartOutsideClickCloseListener(e) {
    var isCartPopup = $(e.target).closest(getClassSelector(SELECTORS.CART_POPUP)).length;
    var isCartItemQuantitySelector = $(e.target).hasClass(SELECTORS.CART_ITEM_QUANTITY_SELECTOR)
    var isCartToggle = $(e.target).closest(getClassSelector(SELECTORS.CART_OPENER)).length;
    var isRemoveFromCartClick = $(e.target).hasClass(SELECTORS.CART_ITEM_REMOVE);
    var isAddToCart = $(e.target).closest(getClassSelector(SELECTORS.ADD_TO_CART)).length;
    if (!isRemoveFromCartClick && !isCartPopup && !isCartToggle && !isAddToCart && !isCartItemQuantitySelector) {
      renderCloseCart('Click Outside');
      if (isOverlayShowing) {
        hideOverlay();
      }
      unbindCartToggleListeners();
    }
  }

  function flashCartOpen() {
    renderOpenCart();
    sendOpenCartAnalytics();
    window.setTimeout(bindCartToggleListeners, 100)
  }

  function bindCartToggleListeners() {
    $(document).on("keydown", bindEscapeCartCloseListener)
    $(document).on("click", bindCartOutsideClickCloseListener)
  }

  function unbindCartToggleListeners() {
    $(document).off("keydown", bindEscapeCartCloseListener)
    $(document).off("click", bindCartOutsideClickCloseListener)
  }

  function getActiveFrameDetailsAnalytics(params){
    var $activeFrame = window.getFrameDetailsByColor(activeFrame);
    var frameDetails = {
      'id': $activeFrame.sku,
      'name': $activeFrame.name,
      'price': $activeFrame.price,
      'category': $activeFrame.category,
      'brand': $activeFrame.brand,
      'productId': $activeFrame.shopifyProductId
    }

    if(hasDiscount()) {
      frameDetails.coupon = getDiscountCode();
    }

    if (params) {
      $.extend(frameDetails, params);
    }
    return frameDetails
  }

  function sendSwitchImageAnalytics(index) {
    logGA4Event('switch_image', {
      color: activeFrame,
      index: index
    });
    logPavedEvent('switch_image', {
      color: activeFrame,
      index: index
    });
  }

  function sendCartCheckoutAnalytics(cart) {
    const value = subtotal(cart);
    const items = renderAnalyticsCartItems(cart);
  
    logPinterestEvent('InitiateCheckout', {
      currency: getLocaleCurrency(),
      value,
      items: JSON.stringify(items)
    });
  
    logGA4Event('begin_checkout', {
      currency: getLocaleCurrency(),
      value,
      items
    });
  
    logPavedEvent('begin_checkout', {
      currency: getLocaleCurrency(),
      value,
      items: JSON.stringify(items)
    });
  
    logNextDoorPixelEvent('INITIATE_CHECKOUT', {
      currency: getLocaleCurrency(),
      value,
      items: JSON.stringify(items)
    });

    sendTatariEvent('checkoutStarted', {
      total: parseFloat(value),
      currency: getLocaleCurrency(),
      items: items.map(function(item) {
        return {
          name: item.item_name,
          price: item.price,
          quantity: item.quantity,
          productId: item.item_id,
          category: item.item_category
        };
      })
    });
  }

  function sendBopisAnalytics(eventName, params) {
    const eventParams = {
      currency: getLocaleCurrency(),
      value: subtotal(),
      items: renderAnalyticsCartItems()
    };
    if (params) {
      $.extend(eventParams, params);
    }
    logGA4Event(eventName, eventParams);
    logPavedEvent(eventName, eventParams);
  }

  function buildAnalyticsCartItem(item, quantity) {
    if (!item || !quantity) {
      return null;
    }

    var itemColor = window.getFrameDetailsByColor(item);

    if (!itemColor) {
      return null;
    }

    var cartItem = {
      item_id: itemColor.sku,
      item_name: itemColor.name,
      item_variant: itemColor.title,
      item_brand: itemColor.brand,
      item_category: itemColor.category,
      quantity: quantity,
      price: itemColor.price
    };

    var hasDiscountCode = discountCodeTitleFromCookie() ? true : false;

    if (hasDiscountCode && itemColor.discountCodeProduct == true) {
      cartItem.coupon = discountCodeTitleFromCookie();
      cartItem.discount = itemColor.discountCodePrice;
    } else if (itemColor.discountAmount) {
      cartItem.coupon = 'PROMO';
      cartItem.discount = itemColor.discountAmount;
    }

    return cartItem;
  }

  function buildKlaviyoCartItem(item, quantity) {
    if (!item || !quantity) {
      return null;
    }

    var cartItem = {
      "ProductID": item.shopifyId,
      "SKU": item.sku,
      "ProductName": item.name,
      "Quantity": quantity,
      "ItemPrice": item.price,
      "RowTotal": item.price * quantity,
      "ImageURL": item.schemaImage,
      "ProductURL": `${window.location.host}/digital-frames/color/${item.class}`,
      "ProductCategories": [item.category]
    };

    var hasDiscountCode = discountCodeTitleFromCookie() ? true : false;

    if (hasDiscountCode && item.discountCodeProduct == true) {
      cartItem.coupon = discountCodeTitleFromCookie();
      cartItem.discount = item.discountCodePrice;
    } else if (item.discountAmount) {
      cartItem.coupon = 'PROMO';
      cartItem.discount = item.discountAmount;
    }

    return cartItem;
  }

  function buildPinterestCartItems(frameData, quantity) {
    if (!frameData || !quantity) {
      return null;
    }
    const pinterestItems = [{
      'product_id': frameData.shopifyProductId,
      'product_variant_id': frameData.shopifyId,
      'product_category': frameData.category,
      'product_variant': frameData.adwordsTitle,
      'product_price': frameData.price,
      'product_quantity': quantity,
    }];
    return pinterestItems;
  }

  function buildAxonCartItems(frameData, quantity) {
    if (!frameData || !quantity) {
      return null;
    }
    let item_id = frameData.shopifyProductId;
    let item_variant_id = frameData.shopifyId;
    let item_name = frameData.name;
    let price = frameData.price;
    if (item_id && item_variant_id && item_name && price){
      let axonItem = {
        'item_id': item_id,
        'item_variant_id': item_variant_id,
        'item_name': item_name,
        'item_category_id': 597,
        'price': price,
        'quantity': quantity
      };
      return [axonItem]
    }
  }

  function buildKlaviyoAnalytics(frameData, quantity, value) {
    if (!frameData || !quantity || !value) {
      return null;
    }
    var cart = getSavedShopifyCart();
    var checkoutUrl = cartCheckoutUrl(cart);
    return {
      "$value": value,
      "AddedItemProductName": `${frameData.category} ${frameData.title}`,
      "AddedItemProductID": frameData.shopifyId,
      "AddedItemSKU": frameData.sku,
      "AddedItemCategories": [frameData.category],
      "AddedItemImageURL": frameData.schemaImage,
      "AddedItemURL": `${window.location.host}/digital-frames/color/${frameData.class}`,
      "AddedItemPrice": frameData.price,
      "AddedItemQuantity": quantity,
      "ItemNames": renderCartItemNames(),
      "CheckoutURL": checkoutUrl,
      "Items": renderKlaviyoCartItems()
    }
  }

  function renderAnalyticsCartItems(cart) {
    var cartToUse = cart || getSavedShopifyCart();
    var framesData = window.grabAllFramesData();
    var cartItems = [];
    if (!cartToUse || !framesData) return null;
    if (cartHasLineItems(cartToUse)) {
      cartToUse.lines.edges.forEach(function (line) {
        var lineItem = line.node;
        var shopifyId = lineItemShopifyId(line);
        var quantity = lineItem.quantity;
        Object.keys(framesData).forEach(function (frameData) {
          if (framesData[frameData].shopifyId && framesData[frameData].shopifyId.toString() == shopifyId) {
            var matchedFrame = framesData[frameData];
            if (quantity > 0) cartItems.push(buildAnalyticsCartItem(matchedFrame.class, quantity));
          }
        });
      });
    }
    return cartItems;
  }

  function renderKlaviyoCartItems() {
    const cart = getSavedShopifyCart();
    const framesData = window.grabAllFramesData();
    const cartItems = [];

    if (!cart || !framesData) {
      return null;
    }
    if (cartHasLineItems(cart)) {
      cart.lines.edges.forEach(function(line) {
        var lineItem = line.node;
        var shopifyId = lineItemShopifyId(line);
        var quantity = lineItem.quantity;
        Object.keys(framesData).forEach(function (frameData) {
          if (framesData[frameData].shopifyId) {
            if ((framesData[frameData].shopifyId).toString() == shopifyId) {
              var frameData = framesData[frameData];
              if (quantity > 0) {
                cartItems.push(buildKlaviyoCartItem(frameData, quantity));
              }
            }
          }
        });
      });
      return cartItems;
    }
  }

  function renderCartItemNames() {
    const cart = getSavedShopifyCart();
    const framesData = window.grabAllFramesData();
    const cartItemNames = [];

    if (!cart || !framesData) {
      return null;
    }
    if (cartHasLineItems(cart)) {
      cart.lines.edges.forEach(function(line) {
        var lineItem = line.node;
        var shopifyId = lineItemShopifyId(line);
        var quantity = lineItem.quantity;
        Object.keys(framesData).forEach(function (frameData) {
          if (framesData[frameData].shopifyId) {
            if ((framesData[frameData].shopifyId).toString() == shopifyId) {
              var frameData = framesData[frameData];
              if (quantity > 0) {
                cartItemNames.push(`${frameData.category} ${frameData.title}`);
              }
            }
          }
        });
      });
    }
    return cartItemNames;
  }

  function sendAddToCartAnalytics(color, quantity, value) {
    if (!color || !quantity || !value) {
      return null;
    }
    var frameData = window.getFrameDetailsByColor(COLORS[color])
    if (!frameData) {
      return null;
    }

    logGA4Event('add_to_cart', {
      currency: getLocaleCurrency(),
      value: value,
      items: [buildAnalyticsCartItem(COLORS[color], quantity)]
    });
    logPavedEvent('add_to_cart', {
      currency: getLocaleCurrency(),
      value: value,
      items: [JSON.stringify(buildAnalyticsCartItem(COLORS[color], quantity))]
    });
    logFBEvent('AddToCart', {
      content_ids: frameData.shopifyProductId,
      content_type: 'product',
      value: value,
      currency: getLocaleCurrency()
    });

    logTikTokEvent('AddToCart', {
      contents: [
        {
          content_id: frameData.shopifyProductId,
          content_name: frameData.name,
          quantity: quantity,
          price: frameData.price,
        }
      ],
      content_type: 'product',
      value: value,
      currency: getLocaleCurrency()
    });

    logSnapEvent('ADD_CART', {
      'price': frameData.price,
      'currency': getLocaleCurrency(),
      'item_ids': [frameData.shopifyProductId],
      'number_items': quantity
    });

    var pinterestItems = buildPinterestCartItems(frameData, quantity);
    if (pinterestItems) {
      sendCartPinterestAnalytics(pinterestItems, value, 'AddToCart');
    }

    var klaviyoData = buildKlaviyoAnalytics(frameData, quantity, value);
    if (klaviyoData) {
      klaviyo.push(["track", "Added to Cart", klaviyoData]);
    }

    // PodSights tracking pixel
    if (typeof pdst != 'undefined'){
      pdst('addtocart', {
        value: value, // price
        currency: "USD",
        // optional product information for advanced analytics.
        quantity: quantity,
        product_id: frameData.sku,
        product_name: frameData.name,
        product_type: frameData.category,
        product_vendor: frameData.brand,
        variant_name: frameData.class,
      })
    }

    logNextDoorPixelEvent('ADD_TO_CART', {
      content_ids: frameData.shopifyProductId,
      content_type: 'product',
      value: value,
      currency: getLocaleCurrency()
    })
    let axonItems =  buildAxonCartItems(frameData, quantity)
    logAxonEvent('add_to_cart', {
      currency: getLocaleCurrency(),
      items: axonItems,
      value: subtotal(),
    })

    sendTatariEvent('addToCart', {
      productId: frameData.sku,
      name: frameData.name,
      price: frameData.price,
      quantity: quantity,
      category: frameData.category
    });
  }

  function sendRemoveFromCartAnalytics(frame, quantity, lineItemSubtotal) {
    if (!frame || !quantity || !lineItemSubtotal) {
      return null;
    }
    var frameData = window.getFrameDetailsByColor(frame)
    if (!frameData) {
      return null;
    }

    logGA4Event('remove_from_cart', {
      currency: getLocaleCurrency(),
      value: lineItemSubtotal,
      items: [buildAnalyticsCartItem(COLORS[frame] || frame, quantity)]
    });

    logPavedEvent('remove_from_cart', {
      currency: getLocaleCurrency(),
      value: lineItemSubtotal,
      items: [JSON.stringify(buildAnalyticsCartItem(COLORS[frame] || frame, quantity))]
    });

    logFBCustomEvent('RemoveFromCart', {
      content_ids: frameData.shopifyProductId,
      content_type: 'product',
      value: lineItemSubtotal,
      currency: getLocaleCurrency()
    });

    var pinterestItems = buildPinterestCartItems(frameData, quantity);
    if (pinterestItems) {
      sendCartPinterestAnalytics(pinterestItems, lineItemSubtotal, 'removefromcart');
    }

    var klaviyoData = buildKlaviyoAnalytics(frameData, quantity, lineItemSubtotal);
    if (klaviyoData) {
      klaviyo.push(["track", "Removed from Cart", klaviyoData]);
    }
  }

  function sendUpdateCartItemDecrementAnalytics(frameData, quantity) {
    if (!frameData || !quantity) {
      return null;
    }

    logGA4Event('remove_from_cart', {
      currency: getLocaleCurrency(),
      value: frameData.price,
      items: [buildAnalyticsCartItem(frameData.class, quantity)]
    });

    logPavedEvent('remove_from_cart', {
      currency: getLocaleCurrency(),
      value: frameData.price,
      items: [JSON.stringify(buildAnalyticsCartItem(frameData.class, quantity))]
    });

    logFBCustomEvent('RemoveFromCart', {
      content_ids: frameData.shopifyProductId,
      content_type: 'product',
      value: frameData.price,
      currency: getLocaleCurrency()
    });

    var pinterestItems = buildPinterestCartItems(frameData, quantity);
    if (pinterestItems) {
      sendCartPinterestAnalytics(pinterestItems, frameData.price, 'removefromcart');
    }

    var klaviyoData = buildKlaviyoAnalytics(frameData, quantity, frameData.price);
    if (klaviyoData) {
      klaviyo.push(["track", "Removed from Cart", klaviyoData]);
    }
  }

  function sendUpdateCartItemIncrementAnalytics(frameData, quantity) {
    if (!frameData || !quantity) {
      return null;
    }

    logGA4Event('add_to_cart', {
      currency: getLocaleCurrency(),
      value: frameData.price,
      items: [buildAnalyticsCartItem(frameData.class, quantity)]
    });

    logPavedEvent('add_to_cart', {
      currency: getLocaleCurrency(),
      value: frameData.price,
      items: [JSON.stringify(buildAnalyticsCartItem(frameData.class, quantity))]
    });

    logFBEvent('AddToCart', {
      content_ids: frameData.shopifyProductId,
      content_type: 'product',
      value: frameData.price,
      currency: getLocaleCurrency()
    });

    logTikTokEvent('AddToCart', {
      contents: [
        {
          content_id: frameData.shopifyProductId,
          content_name: frameData.name,
          quantity: quantity,
          price: frameData.price,
        }
      ],
      content_type: 'product',
      value: frameData.price,
      currency: getLocaleCurrency()
    });

    var pinterestItems = buildPinterestCartItems(frameData, quantity);
    if (pinterestItems) {
      sendCartPinterestAnalytics(pinterestItems, frameData.price, 'addtocart');
    }

    var klaviyoData = buildKlaviyoAnalytics(frameData, quantity, frameData.price);
    if (klaviyoData) {
      klaviyo.push(["track", "Added to Cart", klaviyoData]);
    }

    sendTatariEvent('addToCart', {
      productId: frameData.sku,
      name: frameData.name,
      price: frameData.price,
      quantity: quantity,
      category: frameData.category
    });
  }

  function sendCartGtagAnalytics(skus, items, totalPrice) {
    logAdWordsGtagPageView({
      'ecomm_pagetype': 'cart',
      'ecomm_prodid': skus,
      'items': items,
      'ecomm_totalvalue': totalPrice
    });
  }

  function sendCartPinterestAnalytics(items, totalPrice, event) {
    logPinterestEvent(event, {
      value: totalPrice,
      order_quantity: items.length,
      line_items: items,
      currency: getLocaleCurrency()
    });
  }

  function sendSwitchFrameColorAnalytics() {
    logGA4Event('select_item', {
      item_list_id: "swatches_pdp",
      item_list_name: "Swatches PDP",
      items: [buildAnalyticsCartItem(activeFrame, 1)]
    });

    logPavedEvent('select_item', {
      item_list_id: "swatches_pdp",
      item_list_name: "Swatches PDP",
      items: [JSON.stringify(buildAnalyticsCartItem(activeFrame, 1))]
    });
  }

  function thumbnailAnalytics() {
    logGA4Event('thumbnail_click', {
      color: activeFrame
    });
    logPavedEvent('thumbnail_click', {
      color: activeFrame
    });
  }

  function sendOpenCartAnalytics() {
    logGA4Event('view_cart', {
      currency: getLocaleCurrency(),
      value: subtotal(),
      items: renderAnalyticsCartItems()
    });
    logPavedEvent('view_cart', {
      currency: getLocaleCurrency(),
      value: subtotal(),
      items: JSON.stringify(renderAnalyticsCartItems())
    });
  }


  function handleDecrementImage() {
    decrementIndex();
    renderMainActiveImage();
    renderActiveThumbnailImage();
  }

  function handleIncrementImage() {
    incrementIndex();
    renderMainActiveImage();
    renderActiveThumbnailImage();
  }

  function useAmazonCTA() {
    var $addToCart = $(getClassSelector(SELECTORS.ADD_TO_CART));
    var $soldOutContainer = $(getClassSelector(SELECTORS.SOLD_OUT_CONTAINER));
    var $bundleContainer = $(getClassSelector(SELECTORS.BUNDLE_CONTAINER));
    var $addToCartContainer = $(getClassSelector(SELECTORS.ADD_TO_CART_CONTAINER));
    var $quantityPicker = $(getClassSelector(SELECTORS.QUANTITY_CONTAINER));
    var $swatches = $(getClassSelector(SELECTORS.SWATCHES_PDP));
    var $selections = $(getClassSelector(SELECTORS.SELECTIONS));
    var $goToAmazonContainer = $(getClassSelector(SELECTORS.GO_TO_AMAZON_CONTAINER));
    $addToCartContainer.hide();
    $selections.addClass('xs-column-12')
    $swatches.hide();
    $quantityPicker.hide();
    $addToCart.hide();
    $soldOutContainer.hide();
    $bundleContainer.hide();
    $goToAmazonContainer.removeClass('hide');
  }

  function renderPurchaseOption() {
    var activeFrameDetails = window.getFrameDetailsByColor(activeFrame);
    var isSoldOut = activeFrameDetails.isSoldOut;
    var hasAmazonCTA = activeFrameDetails.hasAmazonCTA || false;
    var $addToCart = $(getClassSelector(SELECTORS.ADD_TO_CART));
    var $addToCartContainer = $(getClassSelector(SELECTORS.ADD_TO_CART_CONTAINER));
    var $soldOutContainer = $(getClassSelector(SELECTORS.SOLD_OUT_CONTAINER));
    var $soldOut = $(getClassSelector(SELECTORS.SOLD_OUT));
    var $soldOutForm = $(getClassSelector(SELECTORS.SOLD_OUT_FORM));
    var $notifyMe = $(getClassSelector(SELECTORS.NOTIFY_ME));
    var $goToAmazon = $(getClassSelector(SELECTORS.GO_TO_AMAZON));
    var $goToAmazonContainer = $(getClassSelector(SELECTORS.GO_TO_AMAZON_CONTAINER));
    var $bundleContainer = $(getClassSelector(SELECTORS.BUNDLE_CONTAINER));

    if (activeFrameDetails.is_international){
      $addToCartContainer.hide();
      $soldOutContainer.hide();
      $soldOut.hide();
      $soldOutForm.hide();
      $goToAmazon.attr('href', activeFrameDetails.amazonLink);
      $goToAmazon.show();
      $goToAmazonContainer.show();
    } else if (isSoldOut && hasAmazonCTA == false) {
      $addToCart.hide();
      $goToAmazonContainer.hide();
      $goToAmazon.hide();
      $addToCartContainer.hide();
      $soldOutContainer.show();
      $soldOut.show();
      $soldOutForm.show();
      $notifyMe.show();
      $soldOutForm.show();
      if(activeFrameDetails.fulfillmentStatus == 'normal'){
        $soldOutContainer.show();
        $soldOutContainer.show();
        $soldOut.show();
        $soldOutForm.show();
        $notifyMe.show();
      }
      $bundleContainer.hide();
    } else if (hasAmazonCTA) {
      $goToAmazon.show();
      $goToAmazon.attr('href', activeFrameDetails.amazonLink);
      // useAmazonCTA();
      $notifyMe.hide();
      $soldOutContainer.hide();
      $soldOut.hide();
      $soldOutForm.hide()
      $bundleContainer.hide();
      $addToCart.hide();
    } else {
      $soldOutContainer.hide();
      $soldOut.hide();
      $soldOutForm.hide()
      $goToAmazonContainer.hide();
      $goToAmazon.hide();
      $notifyMe.hide();
      $addToCart.show();
      $addToCartContainer.show();
      $addToCart.attr('aria-description', activeFrameDetails.category + ' ' + activeFrameDetails.title);
      $bundleContainer.show();
    }
  }

  function moveBrowseStyles(){
    var activeFrameDetails = window.getFrameDetailsByColor(activeFrame);
    if(activeFrameDetails.isSoldOut){
      $('.frameInfo-browse-styles').removeClass('order-1')
      $('.frameInfo-browse-styles').addClass('order-0')
    } else {
      $('.frameInfo-browse-styles').removeClass('order-0')
      $('.frameInfo-browse-styles').addClass('order-1')
    }
  }

  function syncSeoTagsWithCurrentUrl() {
    var absoluteUrl = window.location.origin + window.location.pathname;

    var canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', absoluteUrl);
    }

    var ogUrlMeta = document.querySelector('meta[property="og:url"]');
    if (ogUrlMeta) {
      ogUrlMeta.setAttribute('content', absoluteUrl);
    }

    var twitterUrlMeta = document.querySelector('meta[name="twitter:url"]');
    if (twitterUrlMeta) {
      twitterUrlMeta.setAttribute('content', absoluteUrl);
    }
  }

  function onChangeFrame() {
    sendSwitchFrameColorAnalytics();
    syncSeoTagsWithCurrentUrl();
    renderSelectedColor();
    renderPricingLogic();
    renderQuantity();
    renderPurchaseOption();
    moveBrowseStyles();
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
      $("html, body").scrollTop(0);
    }
  }

  // Exposed so pricing-tests.js can reach these otherwise-private internals.
  // FIXME: remove after test
  window.getActiveFrame = function () { return activeFrame; };
  window.renderPricingLogic = renderPricingLogic;
  window.replaceInnerHTML = replaceInnerHTML;
  window.removeHide = removeHide;
  window.getCurrencySymbol = getCurrencySymbol;
  window.clearCartIfHoldingPricingTestVariant = clearCartIfHoldingPricingTestVariant;

  async function addPromoFrameToCart(e) {
    var frame = e.target;
    var currentFrame = frame.getAttribute('data-color');
    const updatedCart = await updateCart(COLOR_TO_ENUM[currentFrame]);
    if (updatedCart) {
      setQuantity(1);
      renderCart();
      renderCartCount();
      renderQuantity();
      findCartItemIndex();
      return updatedCart;
    } else {
      console.error('Failed to add promo frame to cart for color: ' + currentFrame + ' and cartId: ' + getShopifyCartId());
    }
  }

  function showBundlingMiniCart(){
    return document.body.classList.contains("bundling-minicart");
  }

  function showDeliveryEstimate(){
    if (disableDeliveryEstimates()) {
      hideAllShippingElements('pdp');
      return false;
    }

    const siteDetails = getSiteDetails();
    if (siteDetails.showDeliveryEstimate) {
      return true;
    }
  }

  function giftBagsAvailable(){
    return document.body.classList.contains("gift-bags-available");
  }

  function validGiftBagCart() {
    if(!giftBagsAvailable()) {
      return false
    }
    var cart = getSavedShopifyCart();
    var isValid = false;
    var invalidGiftBagFrames = [
      "WARM_STONE"
    ]
    if (cartHasLineItems(cart)) {
      cart.lines.edges.forEach((line) => {
        invalidGiftBagFrames.forEach((color) => {
          if (line.node.merchandise.id == `gid://shopify/ProductVariant/${colorToShopifyId(color)}`) {
            return false;
          } else {
            isValid = true;
          }
        });
      });
    }
    return isValid
  }

  function showGiftBag() {
    if (validGiftBagCart() && getCartItemCount() > 0) {
      $(getClassSelector(SELECTORS.CART_ACTIONS)).removeClass("hide");
      $(getClassSelector(SELECTORS.GIFT_BAG_ICON)).removeClass("hide");
      $(getClassSelector(SELECTORS.GIFT_BAG_CART)).removeClass("hide");
    } else {
      $(getClassSelector(SELECTORS.CART_ACTIONS)).addClass("hide");
      $(getClassSelector(SELECTORS.GIFT_BAG_ICON)).addClass("hide");
      $(getClassSelector(SELECTORS.GIFT_BAG_CART)).addClass("hide");
    }
  }

  function showSavings()  {
    var $saving = $(getClassSelector(SELECTORS.CART_SAVING_AMOUNT))

    if (!$saving) {
      return;
    }
    if (getCartItemCount() > 0) {
      $saving.removeClass("hide");
    } else {
      $saving.addClass("hide");
    }
  }

  function showCartDeliveryEstimate()  {
    var cartDeliveryEstimates = document.querySelectorAll('.action--estimate-location-cart');
    if (!cartDeliveryEstimates) {
      return;
    }
    cartDeliveryEstimates.forEach((cartDeliveryEstimate) => {
      if (getCartItemCount() > 0) {
        cartDeliveryEstimate.classList.remove("hide");
      } else {
        cartDeliveryEstimate.classList.add("hide");
      }
    } )

  }

  async function addQuickFrameToCart(color, quantity, giftNote = '') {
    setQuantity(color, quantity);
    if (giftNote) {
      await updateShopifyCartGiftNote(giftNote, getShopifyCartId());
    }

    const updatedCart = await updateCart(color);
    if (updatedCart) {
      renderCart();
      renderCartCount();
      renderQuantity(color);
      findCartItemIndex();
    } else {
      console.error('Failed to add quick frame to cart for color: ' + color + ' and cartId: ' + getShopifyCartId());
      return;
    }
  }

  function markLazyAsLoaded(image, observer) {
    image.setAttribute('lazy-loaded', 'true');
    observer.unobserve(image);
  }

  function logCookieCollision(eventName, cookie1, cookie2) {
    const isCookie1Active = getCookie(cookie1) === 'true';
    const isCookie2Active = getCookie(cookie2) === 'true';

    if (isCookie1Active && isCookie2Active) {
      logGA4Event(eventName, { cookies: [cookie1, cookie2] });
      logPavedEvent(eventName, { cookies: [cookie1, cookie2] });
    }
  }

  function loadingLazy() {
    const lazyImages = document.querySelectorAll('[data-lazy-loading="true"][lazy-loaded="false"][lazy-display-none="false"]');

    function handleIntersection(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const image = entry.target;
          image.setAttribute('lazy-loaded', 'loading');

          function loaded() {
            image.setAttribute('lazy-loaded', 'true');
          }

          if (image.complete) {
            loaded();
          } else {
            image.addEventListener('load', loaded);
          }
          observer.unobserve(image);
        }
      });
    }

    const observer = new IntersectionObserver(handleIntersection);

    lazyImages.forEach(image => {
      observer.observe(image);
    });
  }

  function loadingHiddenLazy() {
    const hiddenLazyImages = document.querySelectorAll('[data-lazy-loading="true"][lazy-loaded="false"][lazy-hover="false"][lazy-display-none="true"]');

    const hiddenObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
      const lazyImage = entry.target;
        lazyImage.src = lazyImage.dataset.src;
        lazyImage.setAttribute('lazy-display-none', 'false');

        lazyImage.onload = () => {
          markLazyAsLoaded(lazyImage, observer);
        };
      });
    }, {
      threshold: 0
    });

    hiddenLazyImages.forEach(image => {
      hiddenObserver.observe(image);
    });
  }

  function shopSectionGa4Tracking(item_list_id, item_list_name, items) {
    logGA4Event('view_item_list', {
      item_list_id: item_list_id,
      item_list_name: item_list_name,
      items: items
    });
    logPavedEvent('view_item_list', {
      item_list_id: item_list_id,
      item_list_name: item_list_name,
      items: JSON.stringify(items)
    });
  }

  function shopSections() {
    var mainShopSection = document.querySelector('.action--main-shop-section');
    return mainShopSection ? mainShopSection.querySelectorAll('.action--shop-section') : null;
  }

  function shopSectionInfo(shopSection) {
    if (!shopSection) return;

    var sectionName = shopSection.getAttribute('data-shop-section');
    var stripedSectionName = sectionName ? sectionName.replace(/-/g, ' ').toLowerCase() : null;
    var kababCaseSectionName = sectionName ? sectionName.replace(/-/g, '_').toLowerCase() : null;

    var items = [];
    var products = shopSection.querySelectorAll('.action--shop-section-product');
    if (!products) return;

    for (var i = 0; i < products.length; i++) {
      var product = products[i];
      var color = product.getAttribute('data-color');
      items.push(buildAnalyticsCartItem(color, 1));
    }

    return {
      sectionName: sectionName,
      stripedSectionName: stripedSectionName,
      kababCaseSectionName: kababCaseSectionName,
      items: items,
    };
  }

  function renderShopSectionTracking(shopSection) {
    if (!shopSection) return;
    var sectionInfo = shopSectionInfo(shopSection);
    if (!sectionInfo) return;

    shopSectionGa4Tracking(
      sectionInfo.kababCaseSectionName,
      sectionInfo.stripedSectionName,
      sectionInfo.items
    );
  }

  function observeShopSection(shopSection, callback) {
    if (!shopSection) return;

    const sectionInfo = shopSectionInfo(shopSection);
    if (!sectionInfo) return;

    const observerClass = `shop-section--${sectionInfo.sectionName}-frames`;

    observeElementInView(observerClass, () => {
      if (callback) callback();
    });
  }

  // Shopify StoreFront API Cart Functions
  // ------------------------------------
  function enableDiscountInput(){
    const siteDetails = getSiteDetails();
    if (siteDetails.showPromoItemizedCart) {
      return true;
    }
  }

  function colorToShopifyId(color) {
    if (color && color === "GIFT_BAG") {
      return parseInt(COLORS.GIFT_BAG.split(':')[0]);
    } 
    else if (typeof color === 'string' && color.toUpperCase().startsWith('CAMP_SNAP_')) {
      const collectiveVariants = window.grabAllCollectiveVariants();
      const match = collectiveVariants.find(v => {
        const metafields = Array.isArray(v && v.metafields) ? v.metafields : [];
        return metafields.some(m => m && typeof m === 'object' && m.key === 'color' && m.value === color);
      });
      if (match) {
        return parseInt(match.id);
      }
    }
    else {
      const framesData = window.grabAllFramesData();
      for (const frame in framesData) {
        if (framesData[frame].color === color) {
          return parseInt(framesData[frame].shopifyId);
        }
      }
    }
  }

  // A visitor VWO buckets partway through a session has lines that were added before the cookie
  // landed. The whole order ships at one speed either way, so bring the earlier lines up to match
  // rather than handing checkout a half marked cart. We never unstamp: dropping a marker after we
  // already quoted Expedited is the one direction that breaks a promise we made to the customer.
  async function stampShippingSpeedTestOnCartLines() {
    const lineAttributes = shippingSpeedTestLineAttributes();
    if (lineAttributes.length === 0) return;

    const cartId = getShopifyCartId();
    const cart = getSavedShopifyCart();
    if (!cartId || !cartHasLineItems(cart)) return;

    const key = window.SHIPPING_SPEED_TEST.lineItemProperty;
    const speed = window.SHIPPING_SPEED_TEST.speed;
    const unmarkedLines = cart.lines.edges.filter((line) => {
      const attributes = line.node.attributes || [];
      return !attributes.some((attribute) => attribute.key === key && attribute.value === speed);
    }).map((line) => {
      return { id: line.node.id, attributes: lineAttributes };
    });

    if (unmarkedLines.length === 0) return;
    await updateLineItemsAttributesShopifyCart(unmarkedLines, cartId);
  }

  function setDeliveryEstimatesAttributes() {
    const vwoDeliveryEstimateTestCookie = getCookie('_vis_opt_exp_86_combi');
    const deliveryEstimatesAttributes = [];
    if (vwoDeliveryEstimateTestCookie === '2') {
      deliveryEstimatesAttributes.push({
        key: 'dont_fetch_estimates',
        value: 'true'
      });
    } else if (cartDeliveryEstimateText && cartDeliveryEstimateExpiry && cartDeliveryEstimateZip) {
      deliveryEstimatesAttributes.push(
      {
        key: 'fuzzy_delivery_estimate_text',
        value: cartDeliveryEstimateText
      },
      {
        key: 'fuzzy_delivery_estimate_expiry',
        value: cartDeliveryEstimateExpiry
      },
      {
        key: 'fuzzy_delivery_estimate_zip',
        value: cartDeliveryEstimateZip
      }
      );
    }
    return deliveryEstimatesAttributes;
  }

  // switch to turn on Multiship in checkout
  function setMsAuraAttributes() {
    let showMsLink = 'false';
    const cart = getSavedShopifyCart();
    if (cart && cartHasLineItems(cart)) {
      const totalQuantity = cart.lines.edges.reduce((sum, line) => sum + line.node.quantity, 0);
      if (totalQuantity > 1) {
        showMsLink = 'true';
      }
    }
    const cartId = getShopifyCartId();
    return [
      {
        key: '_ms_aura',
        value: showMsLink
      },
      {
        key: '_cart_id',
        value: cartId
      }
    ];
  }

  function setGiftNoteAttribute() {
    if (!isGiftingPage()) return;
    const giftNoteEl = document.querySelector(".action--gifting-page-gift-note-checkout");
    let giftNote;
    if (giftNoteEl) {
      if (giftNoteEl.textContent) {
        giftNote = giftNoteEl.textContent;
      }
    }
    const cart = getSavedShopifyCart();
    if (cart && cartHasLineItems(cart)) {

    }
    return [
      {
        key: 'gift_note',
        value: giftNote
      }
    ];
  }

  function setBopisAttributes(available, locationId) {
    return [
      {
        key: '_bopis_available',
        value: available
      },
      {
        key: '_selected_location_id',
        value: locationId
      }
    ];
  }

  function setBopisAvailable(value) {
    return [
      {
        key: '_bopis_available',
        value: value
      }
    ];
  }

  function setBopisLocationId(value) {
    return [
      {
        key: '_selected_location_id',
        value: value
      }
    ];
  }

  const lineFragment = `
    fragment CartLineFragment on BaseCartLine {
      id
      quantity
      merchandise {
        ... on ProductVariant {
          id
          sku
          title
          product {
            title
          }
          image {
            url(transform: { maxWidth: 300, maxHeight: 300 })
          }
        }
      }
      attributes {
        key
        value
      }
      discountAllocations {
        discountedAmount {
          amount
          currencyCode
        }
      }
      cost {
        amountPerQuantity {
          amount
          currencyCode
        }
        compareAtAmountPerQuantity {
          amount
          currencyCode
        }
        subtotalAmount {
          amount
          currencyCode
        }
        totalAmount {
          amount
          currencyCode
        }
      }
    }
  `;

  const cartQueryFragment = `
    fragment CartFragment on Cart {
      id
      createdAt
      updatedAt
      checkoutUrl
      attributes {
        key
        value
      }
      note
      cost {
        totalAmount {
          amount
          currencyCode
        }
        subtotalAmount {
          amount
          currencyCode
        }
        totalTaxAmount {
          amount
          currencyCode
        }
        totalDutyAmount {
          amount
          currencyCode
        }
      }
      discountAllocations {
        discountedAmount {
          amount
          currencyCode
        }
      }
      discountCodes {
        applicable
        code
      }
      buyerIdentity {
        email
        phone
        customer {
          id
        }
        countryCode
        deliveryAddressPreferences {
          ... on MailingAddress {
            address1
            address2
            city
            province
            country
            zip
            firstName
            lastName
            phone
          }
        }
        preferences {
          delivery {
            deliveryMethod
          }
        }
      }
    }
  `;

  // Query a cart by ID and update locally stored cart
  async function getShopifyCart(cartId) {
    const mutation = `
      query getCart($cartId: ID!) @inContext(${getShopifyInContext()}) {
        cart(id: $cartId) {
          ...CartFragment
          lines(first: 25) {
            edges {
              node {
                ...CartLineFragment
              }
            }
          }
        }
      }
      ${lineFragment}
      ${cartQueryFragment}
    `;
    const variables = {
      cartId: `gid://shopify/Cart/${cartId}`,
    }
    const query = { query: mutation, variables };
    const response = await shopifyStorefrontApiCall(query);
    if (response && response.data && response.data.cart) {
      const cart = response.data.cart;
      updateLocalShopifyCart(cart);
      return cart;
    } else {
      return false;
    }
  }

  // Validate discount code by creating a new cart with color/discount code and check if applied
  function validateDiscountCodeForColor(discountCode, color) {
    const mutation = `
      mutation CreateCart($cartInput: CartInput) {
        cartCreate(input: $cartInput) {
          cart {
            ...CartFragment
            lines(first: 25) {
              edges {
                node {
                  ...CartLineFragment
                }
              }
            }
          }
          userErrors {
            field
            message
          }
        }
      }
      ${lineFragment}
      ${cartQueryFragment}
    `;

    const variables = {
      cartInput: {
        lines: [
          {
            merchandiseId: `gid://shopify/ProductVariant/${colorToShopifyId(color)}`,
            quantity: 1
          }
        ],
        discountCodes: [discountCode]
      }
    }

    const query = { query: mutation, variables };
    const response = shopifyStorefrontApiCall(query);
    response.then((json) => {
      if (json.data.cartCreate.userErrors.length > 0) {
        console.error('Shopify cart create error(s):', json.data.cartCreate.userErrors);
        return null;
      }
    });
  }

  // Create a new Shopify cart with the given items
  async function createShopifyCart(items) {
    const mutation = `
      mutation CreateCart($cartInput: CartInput) @inContext(${getShopifyInContext()}) {
        cartCreate(input: $cartInput) {
          cart {
            ...CartFragment
            lines(first: 25) {
              edges {
                node {
                  ...CartLineFragment
                }
              }
            }
          }
          userErrors {
            field
            message
          }
        }
      }
      ${lineFragment}
      ${cartQueryFragment}
    `;
    if (items.length === 0) return;

    const speedTestAttributes = shippingSpeedTestLineAttributes();
    const lines = Object.keys(items).filter((color) => {
      return !!items[color].quantity && items[color].quantity > 0}
    ).map((color) => {
      return {
        merchandiseId: `gid://shopify/ProductVariant/${colorToShopifyId(color)}`,
        quantity: items[color].quantity,
        attributes: speedTestAttributes
      }
    });
    if (giftBagChecked()) {
      lines.push({
        merchandiseId: `gid://shopify/ProductVariant/${colorToShopifyId("GIFT_BAG")}`,
        quantity: 1,
        attributes: speedTestAttributes
      });
    }

    if (lines.length === 0) return;

    const discountCodes = getDiscountCode() ? [getDiscountCode().toUpperCase()] : [];

    const variables = {
      cartInput: {
        lines,
        discountCodes
      }
    }

    const query = { query: mutation, variables };
    const response = await shopifyStorefrontApiCall(query);
    if (response && response.data && response.data.cartCreate && response.data.cartCreate.cart) {
      const cart = response.data.cartCreate.cart;
      updateLocalShopifyCart(cart);
      renderCartItemizedCosts(cart);
      updateCartItemPrices(cart);
      if(discountCodes.length > 0) {
        renderShopifyDiscountCodeMessage(cart, discountCodes.pop());
      }
      updateCartUrl();
      return cart;
    } else {
      console.error('Shopify cart create error:', response);
      airbrake.notify({
        error: `Shopify cart create error: ${getShopifyCartId()}`,
        context: { component: 'StoreFront API' },
        params: { variables: variables, response: response, items: items }
      });
      return null;
    }
  }

  // Add additional new lines to the Shopify cart: colors = {color: {quantity: quantity}}, cartId = cartId
  // If line item exists, it will be added again. To update quantity, use updateLineShopifyCart instead.
  async function addLinesShopifyCart(colors, cartId) {
    const mutation = `
      mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) @inContext(${getShopifyInContext()}) {
        cartLinesAdd(cartId: $cartId, lines: $lines) {
          cart {
            ...CartFragment
            lines(first: 25) {
              edges {
                node {
                  ...CartLineFragment
                }
              }
            }
          }
          userErrors {
            field
            message
          }
        }
      }
      ${lineFragment}
      ${cartQueryFragment}
    `;
    const speedTestAttributes = shippingSpeedTestLineAttributes();
    const lines = Object.keys(colors).filter((color) => {
      return !!colors[color].quantity && colors[color].quantity > 0}
    ).map((color) => {
      const giftBag = colorToShopifyId("GIFT_BAG");

      if (color == giftBag && colors[giftBag].quantity > 0) {
        const cart = getSavedShopifyCart();
        var giftbagCount = 0;
        if (cartHasLineItems(cart)) {
          cart.lines.edges.forEach((line) => {
            if (line.node.merchandise.id == `gid://shopify/ProductVariant/${giftBag}`) {
              giftbagCount += line.node.quantity;
            }
          });
        }
        if (giftbagCount < 1) {
          return {
            merchandiseId: `gid://shopify/ProductVariant/${giftBag}`,
            quantity: colors[giftBag].quantity,
            attributes: speedTestAttributes
          }
        }
      } else {
        return {
          merchandiseId: `gid://shopify/ProductVariant/${colorToShopifyId(color)}`,
          quantity: colors[color].quantity,
          attributes: speedTestAttributes
        }
      }
    }).filter(line => line !== undefined);

    if (lines && lines.length > 0) {
      const variables = {
        cartId: `gid://shopify/Cart/${cartId}`,
        lines: lines
      }
      const query = { query: mutation, variables };
      const response = await shopifyStorefrontApiCall(query);
      if (response && response.data && response.data.cartLinesAdd && response.data.cartLinesAdd.cart) {
        let cart = response.data.cartLinesAdd.cart;
        const updatedCart = await clearBopisLp(cart);
        cart = updatedCart ? updatedCart : cart;
        updateLocalShopifyCart(cart);
        renderCartItemizedCosts(cart);
        updateCartItemPrices(cart);
        return cart;
      } else {
        console.error('Shopify cart add error for cartId:', cartId);
        airbrake.notify({
          error: `Shopify cart add error for cartId: ${cartId}`,
          context: { component: 'StoreFront API' },
          params: { variables: variables, response: response, colors: colors }
        });
        return false;
      }
    }
  }

  // Remove lines from the Shopify cart based on line IDs
  async function removeCartLinesById(lineIds, cartId) {
    const mutation = `
      mutation removeCartLines($cartId: ID!, $lineIds: [ID!]!) @inContext(${getShopifyInContext()}) {
        cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
          cart {
            ...CartFragment
            lines(first: 25) {
              edges {
                node {
                  ...CartLineFragment
                }
              }
            }
          }
          userErrors {
            field
            message
          }
        }
      }
      ${lineFragment}
      ${cartQueryFragment}
    `;
    const variables = {
      cartId: `gid://shopify/Cart/${cartId}`,
      lineIds
    };
    const query = { query: mutation, variables };
    const response = await shopifyStorefrontApiCall(query);
    if (response && response.data && response.data.cartLinesRemove) {
      const cart = response.data.cartLinesRemove.cart;
      updateLocalShopifyCart(cart);
      renderCartItemizedCosts(cart);
      return cart;
    } else {
      console.error('Shopify cart remove error for cartId:', cartId);
      airbrake.notify({
        error: `Shopify cart remove error for cartId: ${cartId}`,
        context: { component: 'StoreFront API' },
        params: { variables: variables, response: response, lineIds: lineIds }
      });
      return false;
    }
  }

  // Remove lines from the Shopify cart based on colors 
  async function removeLinesShopifyCart(colors, cartId) {
    const cart = getSavedShopifyCart();
    const lineIds = [];
    if (cartHasLineItems(cart)) {
      cart.lines.edges.forEach((line) => {
        colors.forEach((color) => {
          if (colorToShopifyId("GIFT_BAG") == colors) {
            if (line.node.merchandise.id == `gid://shopify/ProductVariant/${color}`) {
              lineIds.push(line.node.id);
            }
          } else {
            if (line.node.merchandise.id == `gid://shopify/ProductVariant/${colorToShopifyId(color)}`) {
              lineIds.push(line.node.id);
            }
          }
        });
      });
    }
    return await removeCartLinesById(lineIds, cartId);
  }

  // FIXME: remove after test - wipes cart if it holds a pre-test variant.
  async function clearCartIfHoldingPricingTestVariant() {
    var vwoVariantMatches = isVwoExp265Variant2();
    var activeTests = getMerchandisingTests().filter(function (test) {
      return isMerchandisingTestActive(test, vwoVariantMatches);
    });
    if (activeTests.length === 0) return;

    var originalVariantIds = window.MERCHANDISING_TEST_ORIGINAL_VARIANT_IDS || {};
    var cart = getSavedShopifyCart();
    if (!cartHasLineItems(cart)) return;

    var hasOriginalVariantInCart = cart.lines.edges.some(function (line) {
      return activeTests.some(function (test) {
        var originalId = originalVariantIds[test.colorClass];
        return originalId != null && line.node.merchandise.id === `gid://shopify/ProductVariant/${originalId}`;
      });
    });
    if (!hasOriginalVariantInCart) return;

    var cartId = getShopifyCartId();
    if (!cartId) return;
    var allLineIds = cart.lines.edges.map(function (line) { return line.node.id; });
    await removeCartLinesById(allLineIds, cartId);
    // init()'s renderCartCount() already ran before this resolved.
    renderCartCount();
  }

  // Update the quantity of a line in the Shopify cart
  async function updateLineShopifyCart(color, quantity, cartId) {
    const mutation = `
      mutation updateCartLines($cartId: ID!, $lines: [CartLineUpdateInput!]!) @inContext(${getShopifyInContext()}) {
        cartLinesUpdate(cartId: $cartId, lines: $lines) {
          cart {
            ...CartFragment
            lines(first: 25) {
              edges {
                node {
                  ...CartLineFragment
                }
              }
            }
          }
          userErrors {
            field
            message
          }
        }
      }
      ${lineFragment}
      ${cartQueryFragment}
    `;
    const cart = getSavedShopifyCart();
    const lines = [];
    if (cartHasLineItems(cart)) {
      cart.lines.edges.forEach((line) => {
        if (line.node.merchandise.id == `gid://shopify/ProductVariant/${colorToShopifyId(color)}`) {
          lines.push({
            id: line.node.id,
            quantity: quantity
          });
        }
      });
    }

    const variables = {
      cartId: `gid://shopify/Cart/${cartId}`,
      lines: lines
    }
    const query = { query: mutation, variables };
    const response = await shopifyStorefrontApiCall(query);
    if (response && response.data && response.data.cartLinesUpdate) {
      const cart = response.data.cartLinesUpdate.cart;
      updateLocalShopifyCart(cart);
      renderCartItemizedCosts(cart);
      return cart;
    } else {
      console.error('Shopify cart update error for cartId:', cartId);
      airbrake.notify({
        error: `Shopify cart update error for cartId: ${cartId}`,
        context: { component: 'StoreFront API' },
        params: { variables: variables, response: response, color: color, quantity: quantity }
      });
      return false
    }
  }

  // Update attributes of a given Shopify cart
  // attributes = [{key: key, value: value}]
  async function updateShopifyCartAttributes(attributes, cartId) {
    const mutation = `
      mutation updateCartAttributes($attributes: [AttributeInput!]!, $cartId: ID!) @inContext(${getShopifyInContext()}) {
        cartAttributesUpdate(attributes: $attributes, cartId: $cartId) {
          cart {
            ...CartFragment
            lines(first: 25) {
              edges {
                node {
                  ...CartLineFragment
                }
              }
            }
          }
          userErrors {
            field
            message
          }
        }
      }
      ${lineFragment}
      ${cartQueryFragment}
    `;

    // Add existing attributes to the new attributes
    var cart = getSavedShopifyCart();
    if (cart.attributes && cart.attributes.length > 0) {
      cart.attributes.forEach((attribute) => {
        attributes.push(attribute);
        var found = false;
        attributes.forEach((newAttribute) => {
          if (attribute.key == newAttribute.key) {
            found = true;
          }
        });
        if (!found) {
          attributes.push(attribute);
        } else {
          attributes.forEach((newAttribute) => {
            if (attribute.key == newAttribute.key) {
              attribute.value = newAttribute.value;
            }
          });
        }
      });
    }

    const variables = {
      cartId: `gid://shopify/Cart/${cartId}`,
      attributes: attributes
    }
    const query = { query: mutation, variables };
    const response = await shopifyStorefrontApiCall(query);
    if (response && response.data && response.data.cartAttributesUpdate) {
      const cart = response.data.cartAttributesUpdate.cart;
      updateLocalShopifyCart(cart);
      return cart;
    } else {
      console.error('Shopify cart attributes update error for cartId:', cartId);
      airbrake.notify({
        error: `Shopify cart attributes update error for cartId: ${cartId}`,
        context: { component: 'StoreFront API' },
        params: { variables: variables, response: response, attributes: attributes }
      });
      return false;
    }
  }

  // Apply discount codes to the Shopify cart
  async function updateDiscountCodeShopifyCart(discountCodes, cartId) {
    const mutation = `
      mutation updateCartDiscountCodes($cartId: ID!, $discountCodes: [String!]! ) @inContext(${getShopifyInContext()}) {
        cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
          cart {
            ...CartFragment
            lines(first: 25) {
              edges {
                node {
                  ...CartLineFragment
                }
              }
            }
          }
          userErrors {
            field
            message
          }
        }
      }
      ${lineFragment}
      ${cartQueryFragment}
    `;

    const variables = {
      cartId: `gid://shopify/Cart/${cartId}`,
      discountCodes: discountCodes || []
    }

    const query = { query: mutation, variables };
    const response = await shopifyStorefrontApiCall(query);
    if (response && response.data && response.data.cartDiscountCodesUpdate) {
      const cart = response.data.cartDiscountCodesUpdate.cart;
      if (cart && cart.discountCodes) {
        updateLocalShopifyCart(cart);
        renderShopifyDiscountCodeMessage(cart, discountCodes.pop());
        renderCartItemizedCosts(cart);
        updateOrderSummaryLineItemPrice(cart);
        renderShippingCosts(cart);
        logMSDiscountCode(cart);
      }
      return cart;
    } else {
      console.error('Shopify cart discount code update error for cartId:', cartId);
      airbrake.notify({
        error: `Shopify cart discount code update error for cartId: ${cartId}`,
        context: { component: 'StoreFront API' },
        params: { variables: variables, response: response, discountCodes: discountCodes }
      });
      return false;
    }
  }

  // Delete delivery addresses from deliveryAddressPreferences in the Shopify cart
  async function removeDeliveryAddressesShopifyCart(addressesToDelete, cartId) {
    const mutation = `
      mutation cartBuyerIdentityUpdate($buyerIdentity: CartBuyerIdentityInput!, $cartId: ID!) @inContext(${getShopifyInContext()}) {
        cartBuyerIdentityUpdate(buyerIdentity: $buyerIdentity, cartId: $cartId) {
          cart {
            ...CartFragment
            lines(first: 25) {
              edges {
                node {
                  ...CartLineFragment
                }
              }
            }
          }
          userErrors {
            field
            message
          }
        }
      }
      ${lineFragment}
      ${cartQueryFragment}
    `;
    var cart = getSavedShopifyCart();
    var addresses = [];

    if (cart.buyerIdentity && cart.buyerIdentity.deliveryAddressPreferences) {
      // if addressesToDelete is empty, remove all addresses
      if (addressesToDelete.length === 0) {
        addresses.push({ deliveryAddress: null, deliveryAddressValidationStrategy: "STRICT" });
      } else {
        cart.buyerIdentity.deliveryAddressPreferences.forEach((existingAddress) => {
        const isDuplicate = addressesToDelete.some((address) => isEqual(existingAddress, address));
        if (!isDuplicate) {
          const found = addresses.some((newAddress) => isEqual(existingAddress, newAddress));
          if (!found) {
            addresses.push({ deliveryAddress: existingAddress, deliveryAddressValidationStrategy: "STRICT" });
            }
          }
        });
      }
    }

    const variables = {
      buyerIdentity: {
        deliveryAddressPreferences: addresses
      },
      cartId: `gid://shopify/Cart/${cartId}`
    }

    const query = { query: mutation, variables };
    const response = await shopifyStorefrontApiCall(query);
    if (response && response.data && response.data.cartBuyerIdentityUpdate) {
      if (response.data.cartBuyerIdentityUpdate.userErrors.length > 0) {
        const errors = {};
        response.data.cartBuyerIdentityUpdate.userErrors.forEach((error) => {
          errors[error.field.pop()] = error.message;
        });
        return { errors: errors };
      } else {
        const cart = response.data.cartBuyerIdentityUpdate.cart;
        updateLocalShopifyCart(cart);
        return cart;
      }
    } else {
      console.error('Shopify cart buyer identity update error for cartId:', cartId);
      airbrake.notify({
        error: `Shopify cart buyer identity update error for cartId: ${cartId}`,
        context: { component: 'StoreFront API' },
        params: { variables: variables, response: response, address: address }
      });
      return false;
    }
  }

  // Update buyer identity of the Shopify cart
  // attributes = [{deliveryAddress: address, email: email}]
  async function updateBuyerIdentityShopifyCart(attributes, cartId, addressToRemove, addressValidationStrategy) {
    const mutation = `
      mutation cartBuyerIdentityUpdate($buyerIdentity: CartBuyerIdentityInput!, $cartId: ID!) @inContext(${getShopifyInContext()}) {
        cartBuyerIdentityUpdate(buyerIdentity: $buyerIdentity, cartId: $cartId) {
          cart {
            ...CartFragment
            lines(first: 25) {
              edges {
                node {
                  ...CartLineFragment
                }
              }
            }
          }
          userErrors {
            field
            message
          }
        }
      }
      ${lineFragment}
      ${cartQueryFragment}
    `;

    var addresses = [];
    var email;
    addressValidationStrategy = addressValidationStrategy || "STRICT";
    attributes.forEach((attribute) => {
      if(attribute.deliveryAddress) {
        if (!addressToRemove || !isEqual(attribute.deliveryAddress, addressToRemove)) {
          if (addressValidationStrategy === "STRICT" && (attribute.deliveryAddress.firstName && attribute.deliveryAddress.lastName && attribute.deliveryAddress.phone)) {
            addresses.push({deliveryAddress: attribute.deliveryAddress, deliveryAddressValidationStrategy: addressValidationStrategy});
          } else if (addressValidationStrategy === "COUNTRY_CODE_ONLY") {
            addresses.push({deliveryAddress: attribute.deliveryAddress, deliveryAddressValidationStrategy: addressValidationStrategy});
          }
        }
      } else if (attribute.email) {
        email = attribute.email;
      }
    });

    if (addresses.length > 0) {
      var cart = getSavedShopifyCart();
      if (cart.buyerIdentity && cart.buyerIdentity.deliveryAddressPreferences) {
        var existingAddresses = cart.buyerIdentity.deliveryAddressPreferences;
        existingAddresses.forEach(function(address) {
          if (!addressToRemove || !isEqual(address, addressToRemove)) {
            addresses.push({deliveryAddress: address, deliveryAddressValidationStrategy: addressValidationStrategy});
          }
        });
      }
    }

    var buyerIdentity = {};
    if (addresses.length > 0) {
      buyerIdentity.deliveryAddressPreferences = addresses;
    }
    if (email) {
      buyerIdentity.email = email;
    }

    const variables = {
      buyerIdentity: buyerIdentity,
      cartId: `gid://shopify/Cart/${cartId}`
    }

    const query = { query: mutation, variables };
    const response = await shopifyStorefrontApiCall(query);
    if (response && response.data && response.data.cartBuyerIdentityUpdate) {
      if (response.data.cartBuyerIdentityUpdate.userErrors.length > 0) {
        const errors = {};
        response.data.cartBuyerIdentityUpdate.userErrors.forEach((error) => {
          errors[error.field.pop()] = error.message;
        });
        return { errors: errors };
      } else {
        const cart = response.data.cartBuyerIdentityUpdate.cart;
        updateLocalShopifyCart(cart);
        return cart;
      }
    } else {
      console.error('Shopify cart buyer identity update error for cartId:', cartId);
      airbrake.notify({
        error: `Shopify cart buyer identity update error for cartId: ${cartId}`,
        context: { component: 'StoreFront API' },
        params: { variables: variables, response: response, attributes: attributes }
      });
      return false;
    }
  }

  // Update cart line attributes (use _ before key to prevent attribute from displaying in checkout)
  // attributes = [{id: lineItemId, attributes: [{key: _key, value: value}]}]
  async function updateLineItemsAttributesShopifyCart(attributes, cartId) {
    const mutation = `
      mutation updateCartLines($cartId: ID!, $lines: [CartLineUpdateInput!]!) @inContext(${getShopifyInContext()}) {
        cartLinesUpdate(cartId: $cartId, lines: $lines) {
          cart {
            ...CartFragment
            lines(first: 25) {
              edges {
                node {
                  ...CartLineFragment
                }
              }
            }
          }
          userErrors {
            field
            message
          }
        }
      }
      ${lineFragment}
      ${cartQueryFragment}
    `;

    if (!attributes || !cartId) return;
    let lines = [];

    // get current attributes
    let cart = getSavedShopifyCart();
    if (cartHasLineItems(cart)) {
      cart.lines.edges.forEach((line) => {
        let lineAttributes = [];
        if (line.node.attributes && line.node.attributes.length > 0) {
          line.node.attributes.forEach((attribute) => {
            lineAttributes.push({
              key: attribute.key,
              value: attribute.value
            });
          });
        }
        lines.push({
          id: line.node.id,
          attributes: lineAttributes
        });
      });

      // add new attributes
      attributes.forEach((line) => {
        let lineAttributes = [];
        if (line.attributes && line.attributes.length > 0) {
          line.attributes.forEach((attribute) => {
            lineAttributes.push({
              key: attribute.key,
              value: attribute.value
            });
          });
        }
        let lineIndex = lines.findIndex((existingLine) => {
          return existingLine.id === line.id;
        });
        if (lineIndex !== -1) {
          lineAttributes.forEach((attribute) => {
            let attributeIndex = lines[lineIndex].attributes.findIndex((existingAttribute) => {
              return existingAttribute.key === attribute.key;
            });
            if (attributeIndex !== -1) {
              lines[lineIndex].attributes[attributeIndex].value = attribute.value;
            } else {
              lines[lineIndex].attributes.push(attribute);
            }
          });
        }
      });
    }

    // if attributes have value of empty string, remove the attribute to delete it
    lines.forEach((line) => {
      line.attributes = line.attributes.filter((attribute) => {
        return attribute.value !== '';
      });
    });

    const variables = {
      cartId: `gid://shopify/Cart/${cartId}`,
      lines: lines
    }
    const query = { query: mutation, variables };
    const response = await shopifyStorefrontApiCall(query);
    if (response && response.data && response.data.cartLinesUpdate) {
      const cart = response.data.cartLinesUpdate.cart;
      updateLocalShopifyCart(cart);
      return cart;
    } else {
      console.error('Shopify cart update error for cartId:', cartId);
      airbrake.notify({
        error: `Shopify update LineItems attributes error for cartId: ${cartId}`,
        context: { component: 'StoreFront API' },
        params: { variables: variables, response: response, attributes: attributes }
      });
      return false
    }
  }

  // Updates gift note field on the cart
  async function updateShopifyCartGiftNote(note, cartId) {
    const mutation = `
      mutation cartNoteUpdate($cartId: ID!, $note: String!) @inContext(${getShopifyInContext()}) {
        cartNoteUpdate(cartId: $cartId, note: $note) {
          cart {
            note
            ...CartFragment
            lines(first: 25) {
              edges {
                node {
                  ...CartLineFragment
                }
              }
            }
          }
          userErrors {
            field
            message
          }
        }
      }
      ${lineFragment}
      ${cartQueryFragment}
    `;
    const variables = {
      cartId: `gid://shopify/Cart/${cartId}`,
      note: note
    }
    const query = { query: mutation, variables };
    const response = await shopifyStorefrontApiCall(query);
    if (response && response.data && response.data.cartNoteUpdate) {
      const cart = response.data.cartNoteUpdate.cart;
      updateLocalShopifyCart(cart);
      return cart;
    } else {
      console.error('Shopify cart gift note update error for cartId:', cartId);
      airbrake.notify({
        error: `Shopify cart gift note update error for cartId: ${cartId}`,
        context: { component: 'StoreFront API' },
        params: { variables: variables, response: response, note: note }
      });
      return false;
    }
  }

  // Api call to Shopify Storefront API
  async function shopifyStorefrontApiCall(query) {
    const siteDetails = getSiteDetails();
    const shopName = siteDetails.shopName || "aura-2";
    const url = "https://"+shopName+".myshopify.com/api/2024-04/graphql.json";
    const token = siteDetails.storefrontToken || "aa3dd3964fac60a49e2d57ab6e58007c";

    const fetchOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": token
      },
      body: JSON.stringify(query)
    }

    let response;
    let json;
    let retries = 0;

    while (retries < 3) {
      try {
        response = await fetch(url, fetchOptions);
        json = await response.json();
        break;
      } catch (error) {
        retries++;
        // Apply exponential backoff
        if (retries < 3) {
          const backoff = 500 * Math.pow(2, retries - 1);
          await new Promise(resolve => setTimeout(resolve, backoff));
          continue;
        }

        if (retries === 3) {
          console.error('Failed to fetch from Shopify Storefront API:', error);
          airbrake.notify({
            error: 'Failed to fetch from Shopify Storefront API',
            context: { component: 'StoreFront API' },
            params: { error: error, fetchOptions: fetchOptions, response: response }
          });
          throw new Error('Failed to fetch from Shopify Storefront API');
        }
      }
    }
    if (!response.ok || json.error) {
      console.error('Shopify fetch error:', json.error || `HTTP error ${response.status}`);
      throw new Error(json.error || `HTTP error ${response.status}`);
    }
    if (json.errors && json.errors.length > 0 || json.error && json.error.length > 0) {
      console.error('Shopify cart fetch error(s):', json.errors || json.error);
      throw new Error(JSON.stringify(json.errors || json.error));
    }
    return json;
  }

  // Update the Shopify cart in local storage, make sure cart includes lines
  function updateLocalShopifyCart(cart) {
    window.localStorage && window.localStorage.setItem('shopify_cart', JSON.stringify(cart));
    // Set SplitShip cookie if cart has 2 or more items
    if (cartHasLineItems(cart)) {
      const totalQuantity = cart.lines.edges.reduce((sum, line) => sum + line.node.quantity, 0);
      if (totalQuantity > 1 && !document.cookie.includes('splitship=true')) {
        setCookie('splitship', true, null, `.${location.hostname}`);
      }
      if (totalQuantity > 1 && !document.cookie.includes('splitship_checkout_link_audience=true')) {
        setCookie('splitship_checkout_link_audience', true, null, `.${location.hostname}`);
      }
      if (totalQuantity >= 1 && !document.cookie.includes('upsell_audience=true')) {
        setCookie('upsell_audience', true, null, `.${location.hostname}`);
      }
      if (totalQuantity >= 1 && !document.cookie.includes('cancel_item_audience=true')) {
        setCookie('cancel_item_audience', true, null, `.${location.hostname}`);
      }
    }
  }

  // Get Shopify cart id from saved cart in local storage
  function getShopifyCartId() {
    let shopifyCartId;
    const cart = getSavedShopifyCart();
    if (cart && cart.id) {
      shopifyCartId = cart.id.split("Cart/").pop();
    }
    return shopifyCartId;
  }

  // Get saved Shopify cart from local storage
  function getSavedShopifyCart() {
    if (document.cookie.match(/pushd\-clearcart=1/)) {
      document.cookie.split(';').forEach(function(cookie) {
        if(cookie.includes('pushd-clearcart')) {
          let cookieName = cookie.split('=')[0].trim();
          deleteCookie(cookieName);
        }
      })
      clearCart();
    }
    var cart = window.localStorage && window.localStorage.getItem('shopify_cart') || {};
    if (cart && cart.length > 0) {
      return JSON.parse(cart);
    }
    return {};
  }

  // Check the gift bag checkbox if gift bag is in the shopify cart
  function checkIfGiftBagInCart() {
    const cart = getSavedShopifyCart();
    const giftBag = colorToShopifyId('GIFT_BAG');
    if (cartHasLineItems(cart)) {
      cart.lines.edges.forEach((line) => {
        if (line.node.merchandise.id == `gid://shopify/ProductVariant/${giftBag}`) {
          $(getClassSelector(SELECTORS.GIFT_BAG)).prop('checked', true);
          $(getClassSelector(SELECTORS.CART_ACTIONS)).addClass("active");
          $(getClassSelector(SELECTORS.CART_TOP)).addClass("giftbag-active");
          return true;
        }
      });
    }
  }

  // Get applied discount codes
  function getAppliedDiscountCode() {
    const cart = getSavedShopifyCart();
    if (cart && cart.discountCodes) {
      return cart.discountCodes;
    }
    return [];
  }

  function updateCartDiscountCodeToggleMsg(status) {
    const cartDiscountCodeToggleMsgs = document.querySelectorAll('.action--cart-discount-code-toggle-msg');
    if (!cartDiscountCodeToggleMsgs.length) return;

    function isApplyPromoCodeShowing() {
      return Array.from(cartDiscountCodeToggleMsgs).some(msg => 
        msg.textContent.trim() === 'Add a Promo Code'
      );
    }

    if (status === 'showAddPromo') {
      if (!isApplyPromoCodeShowing()) {
        cartDiscountCodeToggleMsgs.forEach(cartDiscountCodeToggleMsg => {
          cartDiscountCodeToggleMsg.textContent = 'Add a Promo Code';  
        })
        
      }
    } else if (status === 'showPromoApplied') {
      let cartDiscountCodeToggles = document.querySelectorAll('.action--cart-discount-code-form');
      cartDiscountCodeToggles.forEach(cartDiscountCodeToggle => {
        if (cartDiscountCodeToggle.classList.contains('active') && isApplyPromoCodeShowing()) {
          cartDiscountCodeToggleMsgs.forEach(cartDiscountCodeToggleMsg => {
            cartDiscountCodeToggleMsg.textContent = 'Discount Code Applied!';
          })
        }        
      })
    }
  }

  // Display discount code message in cart
  function renderShopifyDiscountCodeMessage(cart, discountCode) {
    const discountCodeInputs = $(getClassSelector(SELECTORS.CART_DISCOUNT_CODES));
    const discountCodeError = $(getClassSelector(SELECTORS.CART_DISCOUNT_CODE_ERROR));
    discountCodeInputs.find('.discount-code').remove();
    discountCodeError.addClass('hide');

    cart.discountCodes.forEach((code) => {
      if (code.applicable == true && code.code !== "BUNDLE") {
        updateCartDiscountCodeToggleMsg('showPromoApplied');
        const discountCodeInputs = $(getClassSelector(SELECTORS.CART_DISCOUNT_CODES));
        discountCodeInputs.append(
          buildDiscountCodeTag(code.code)
        );

      } else {
        if ((code && code.code == discountCode)) {
          updateCartDiscountCodeToggleMsg('showAddPromo');
          discountCodeError.removeClass('hide').addClass('active').html(
            buildInvalidDiscountCodeMessage(discountCode)
          );
          if (!cartContainsColor(cart, "CARVER_MAT")) {
            validateDiscountCodeForColor(discountCode, 'CARVER_MAT');
          }
        }
      }
    });

    $('.remove-discount').on('click', async function(e) {
      const discountCode = e.target.parentNode.getAttribute('data-discount-code');
      const discountCodes = getAppliedDiscountCode().map(({ code }) => code);
      const updatedDiscountCodes = discountCodes.filter((code) => code !== discountCode);
      const cartId = getShopifyCartId();
      if (cartId && discountCode) {
        const updatedCart = await updateDiscountCodeShopifyCart(updatedDiscountCodes, cartId);
        if (updatedCart) {
          updateCartDiscountCodeToggleMsg('showAddPromo');
          $(getClassSelector(SELECTORS.CART_DISCOUNT_CODE_INPUT)).val('');
        } else {
          console.error('Failed to remove discount code from cart:', discountCode + ' and cartId: ' + cartId);
        }
      }
    });
  }

  function buildDiscountCodeTag(discountCode) {
    const span = document.createElement('span');
    const closeBtn = document.createElement('span');
    span.className = 'discount-code';
    span.setAttribute('data-discount-code', discountCode);
    span.textContent = discountCode;
    closeBtn.className = 'remove-discount';
    closeBtn.textContent = 'X';
    span.appendChild(closeBtn);
    return span;
  }

  function buildInvalidDiscountCodeMessage(discountCode) {
    const span = document.createElement('span');
    const locale = I18n.locale;
    switch(locale){
      case 'de':
      case 'de-LU':
      case 'de-NL':
      case 'de-BE':
        return span.textContent = 'Ungültiger Promo-Code';
      case 'fr':
      case 'fr-LU':
      case 'fr-NL':
      case 'fr-BE':
        return span.textContent = 'Code promo non valide';
      case 'nl-NL':
      case 'nl-BE':
        return span.textContent = 'Ongeldige promotiecode';
      case 'en-GB':
        return span.textContent = `The code ${discountCode} is invalid.`;
      case 'en-CA':
        return span.textContent = `The code ${discountCode} is invalid.`;
      default:
        return span.textContent = `The code ${discountCode} is invalid.`;
    }
  }

  function cartContainsColor(cart, color) {
    if (cartHasLineItems(cart)) {
      return cart.lines.edges.some((line) => {
        if (line.node.merchandise.id == `gid://shopify/ProductVariant/${colorToShopifyId(color)}`) {
          return true;
        }
      });
    }
    return false;
  }

  function calculateTotalDiscount(cart) {
    var totalDiscount = 0;
    if (cartHasLineItems(cart)) {
      cart.lines.edges.forEach(function (line) {
        line.node.discountAllocations.forEach(function (discount) {
          totalDiscount += Number.parseFloat(discount.discountedAmount.amount)
        });
      });
    }
    if (cart && cart.discountAllocations) {
      cart.discountAllocations.forEach(function (discount) {
        totalDiscount += Number.parseFloat(discount.discountedAmount.amount)
      });
    }
    return totalDiscount;
  }

  function cartHasLineItems(cart) {
    return cart && cart.lines && cart.lines.edges && cart.lines.edges.length > 0;
  }

  function cartCheckoutUrl(cart) {
    if (cart && cart.checkoutUrl && cart.checkoutUrl.length > 0) {
      return cart.checkoutUrl;
    }
  }

  function lineItemShopifyId(line) {
    return line.node.merchandise.id.split("/").pop();
  }

  function isProductPage() {
    return $('main').hasClass(SELECTORS.PRODUCT_PAGE);
  }

  function isAboutAuraPage() {
    return $('main').hasClass('about-aura');
  }

  // Multiship Cart Functions
  function isMultishipPage() {
    return $('main').hasClass(SELECTORS.MULTISHIP_CONTAINER);
  }

  function isMultishipShippingMethodPage() {
    return $('main').hasClass(SELECTORS.MULTISHIP_SHIPPING_METHODS_CONTAINER);
  }

  function isMultiShipBillingPage() {
    return $('main').hasClass(SELECTORS.MULTISHIP_BILLING_ADDRESS_CONTAINER);
  }

  function isMultiShipPages() {
    return isMultishipPage() || isMultishipShippingMethodPage() || isMultiShipBillingPage();
  }

  function msEventParams(cart) {
    var eventParams = {
      items_count: getTotalQuantity(cart),
      subtotal: subtotal(),
      total_discount: calculateTotalDiscount(cart),
    };
    var deliveryGroups = getDeliveryGroups(cart);
    if (deliveryGroups.length > 0) {
      deliveryGroups.forEach(function(group) {
        eventParams[group.address.zip] = true;
      });
      eventParams['shipping_addresses'] = deliveryGroups.length;
    }
    var giftNotes = cartContainsGiftNotes();
    if (giftNotes) {
      eventParams['gift_notes'] = giftNotes;
    }
    var shippingMethods = cartShippingMethods();
    if (shippingMethods.length > 0) {
      shippingMethods.forEach(function(method) {
        eventParams[method] = true;
      });
    }
    return eventParams;
  }

  function logMSDiscountCode(cart) {
    if (!isMultiShipPages()) return;
    var eventParams = msEventParams(cart);
    var discountCodes = getAppliedDiscountCode().filter(code => code.applicable).map(code => code.code);
    if (discountCodes.length > 0) {
      discountCodes.forEach(function(discount) {
        eventParams[discount] = true;
      });
      logGA4Event('ms_discount_codes', eventParams);
      logPavedEvent('ms_discount_codes', eventParams);
    }
  }

  function logMSEvent(event, cart, params) {
    var eventParams = msEventParams(cart);
    if (params) {
      Object.keys(params).forEach(function(key) {
        eventParams[key] = params[key];
      });
    }
    logGA4Event(event, eventParams);
    logPavedEvent(event, eventParams);
  }

  function cartShippingMethods() {
    var shippingMethods = [];
    var cart = getSavedShopifyCart();
    var deliveryGroups = getDeliveryGroups(cart);
    deliveryGroups.forEach(function(group) {
      if (group && group.shippingMethod) {
        shippingMethods.push(group.shippingMethod);
      }
    });
    return shippingMethods;
  }

  function cartContainsGiftNotes() {
    var cart = getSavedShopifyCart();
    var deliveryGroups = getDeliveryGroups(cart);
    var giftNotes = [];
    deliveryGroups.forEach(function(group) {
      if (group.giftNote) {
        giftNotes.push(group.giftNote);
      }
    });
    return giftNotes.length > 0;
  }

  async function loadMultishipCartInfo() {
    const newCartId = $(getClassSelector(SELECTORS.MULTISHIP_CONTAINER)).attr('data-shopify-id');
    const newCart = await getShopifyCart(newCartId);
    if (newCart) {
      logMSEvent('ms_page_view', newCart, { location: 'shipping_addresses' });
      loadMSOrderSummary(newCart);
      renderMSCart(newCart);
      var msCheckout = $(getClassSelector(SELECTORS.MULTISHIP_CHECKOUT_ADDRESS));
      msCheckout.on('click', async function(e) {
        e.preventDefault();
        var cartLineAddresses = setCartLineAddresses(newCart);
        if (cartLineAddresses.length > 0) {
          // check if cartLineAddresses have same ids and same attributes, combine them
          cartLineAddresses = cartLineAddresses.reduce((acc, line) => {
            var existingLine = acc.find((l) => l.id === line.id);
            if (existingLine) {
              existingLine.attributes = existingLine.attributes.concat(line.attributes);
            } else {
              acc.push(line);
            }
            return acc;
          }
          , []);
          var updated = await updateLineItemsAttributesShopifyCart(cartLineAddresses, newCartId);
          if (updated) {
            var deliveryGroups = getDeliveryGroups(updated);
            if (deliveryGroups.length === 1) {
              logMSEvent('ms_click_continue_to_shipping_options', updated, {return_to_checkout: true});
              window.location.href = cartCheckoutUrl(updated);
            } else {
              logMSEvent('ms_click_continue_to_shipping_options', updated);
              window.location.href = '/cart/ms/shipping-methods/' + newCartId;
            }
          }
        }
      });
    } else {
      window.location.href = '/cart';
    }
  }

  function setCartLineAddresses(cart) {
    $(getClassSelector(SELECTORS.MULTISHIP_CART_ITEM_SHIPPING_ADDRESS)).next('.text-error').remove();
    var cartLineAddresses = [];
    var errors = false;

    if (cartHasLineItems(cart)) {
      cart.lines.edges.forEach(function(line) {
        var quantity = line.node.quantity;
        if (quantity > 0) {
          for (var i = 0; i < quantity; i++) {
            var shopifyId = lineItemShopifyId(line);
            var address = $(`#${"shipping-address-" + i + "-" + shopifyId}`);
            var addressValue = address ? address.val() : null;
            if (addressValue) {
              var lineAddress = { id: line.node.id, attributes: [{ key: '_deliveryAddress_' + i, value: addressValue }] };
              cartLineAddresses.push(lineAddress);
            } else {
              addFormFieldError('Enter an address', address);
              errors = true;
            }
          }
        }
      });
    }
    return errors ? [] : cartLineAddresses;
  }

  function addFormFieldError(message, formField) {
    var error = $('<span>', {
      class: 'text-error',
      text: message
    });
    formField.next('.text-error').remove();
    formField.after(error);
  }

  function renderMSCart(cart) {
    var framesData = window.grabAllFramesData();
    var totalQuantity = 0;
    if (cartHasLineItems(cart)) {
      cart.lines.edges.forEach(function(line) {
        var lineItem = line.node;
        var shopifyId = lineItemShopifyId(line);
        var quantity = lineItem.quantity;
        totalQuantity += quantity;

        Object.keys(framesData).forEach(function (frameData) {
          if (framesData[frameData].shopifyId) {
            if ((framesData[frameData].shopifyId).toString() == shopifyId) {
              var frameData = framesData[frameData]
              if (!quantity || !frameData) return;
              // split the quantity of the line item into individual items
              for (var i = 0; i < quantity; i++) {
                renderMSCartItem({
                  data: frameData,
                  thumbnail: frameData.cartImage,
                  itemIndex: i
                });
              }
            }
          }
        });
      });
    }
  }

  function renderMSCartShippingOptions(cart) {
    var deliveryGroups = getDeliveryGroups(cart);
    deliveryGroups.forEach(function(group) {
      renderMSCartShippingOptionsItem({
        address: group.address,
        shippingMethod: group.shippingMethod,
        giftNote: group.giftNote,
        lineItems: group.lineItems,
        index: deliveryGroups.indexOf(group)
      });
    });
  }

  // check if two address objects are equal
  function isEqual(obj1, obj2) {
    const normalize = (obj) => {
      if (obj && obj.country && obj.country === 'United States') {
        obj.country = 'US';
      }
      if (obj && obj.address2 === "") {
        obj.address2 = null;
      }
    };
    normalize(obj1);
    normalize(obj2);
    return obj1.address1 == obj2.address1 &&
      obj1.address2 == obj2.address2 &&
      obj1.city == obj2.city &&
      obj1.country == obj2.country &&
      obj1.firstName == obj2.firstName &&
      obj1.lastName == obj2.lastName &&
      obj1.phone == obj2.phone &&
      obj1.province == obj2.province &&
      obj1.zip == obj2.zip;
  }

  function getDeliveryGroups(cart) {
    var deliveryGroups = [];
    if (cartHasLineItems(cart)) {
      cart.lines.edges.forEach(function(line) {
        groupLineItemsByAddress(line, deliveryGroups);
      });
    }
    return deliveryGroups;
  }

  function groupLineItemsByAddress(line, deliveryGroups) {
    line.node.attributes.forEach(function(attribute) {
      if (attribute.key.includes('_deliveryAddress_')) {
        var index = attribute.key.split('_deliveryAddress_')[1];
        var address = JSON.parse(attribute.value);
        var isDuplicate = deliveryGroups.some(function(group) {
          return isEqual(group.address, address);
        });
        if (!isDuplicate) {
          var lineItemAddress = { address: address, lineItems: [line] };
          line.node.attributes.forEach(function(attr) {
            if (attr.key == '_shippingMethod_' + index) {
              lineItemAddress.shippingMethod = attr.value;
            }
            if (attr.key == '_shippingRate_' + index) {
              lineItemAddress.shippingRate = attr.value;
            }
            if (attr.key == '_giftNote_' + index) {
              lineItemAddress.giftNote = attr.value;
            }
          });
          deliveryGroups.push(lineItemAddress);
        } else {
          for (var i = 0; i < deliveryGroups.length; i++) {
            if (isEqual(deliveryGroups[i].address, address)) {
              deliveryGroups[i].lineItems.push(line);
            }
          }
        }
      }
    });
  }

  function grabFrameData(shopifyId) {
    var framesData = window.grabAllFramesData();
    var frameData = null;
    Object.keys(framesData).forEach(function (frame) {
      if (framesData[frame].shopifyId) {
        if ((framesData[frame].shopifyId).toString() == shopifyId) {
          frameData = framesData[frame];
        }
      }
    });
    return frameData;
  }

  function renderMSCartShippingOptionsItem(params) {
    var lineItems = params.lineItems;
    var index = params.index;

    var $template = $(getClassSelector(SELECTORS.MULTISHIP_SHIPPING_OPTIONS_ITEMS_GROUPING_TEMPLATE)).clone();
    $template
      .removeClass(SELECTORS.MULTISHIP_SHIPPING_OPTIONS_ITEMS_GROUPING_TEMPLATE)
      .addClass(SELECTORS.MULTISHIP_SHIPPING_OPTIONS_ITEMS_GROUPING);

    lineItems.forEach(function (line, index) {
      var shopifyId = lineItemShopifyId(line);
      var data = grabFrameData(shopifyId);

      var $item_template = $template.find(getClassSelector(SELECTORS.MULTISHIP_SHIPPING_OPTIONS_ITEM_TEMPLATE)).clone();
      $item_template
        .removeClass(SELECTORS.MULTISHIP_SHIPPING_OPTIONS_ITEM_TEMPLATE)
        .attr("data-shopify-id", shopifyId);

      // set image source
      $item_template.find(getClassSelector(SELECTORS.CART_ITEM_THUMBNAIL)).attr("src", data.cartImage);
      $item_template.find(getClassSelector(SELECTORS.CART_ITEM_THUMBNAIL_CONTAINER)).attr("href", data.productUrl);

      // set title
      $item_template.find(getClassSelector(SELECTORS.CART_ITEM_COLLECTION)).text(data.categoryWithDisplaySize);
      $item_template.find(getClassSelector(SELECTORS.CART_ITEM_TITLE)).text(data.title);

      $template.find(getClassSelector(SELECTORS.MULTISHIP_SHIPPING_OPTIONS_LINEITEMS)).append($item_template);

      line.node.attributes.forEach(function(attribute) {
        if (attribute.key.includes('_giftNote_')) {
          var giftNote = attribute.value;
          $template.find(getClassSelector(SELECTORS.MULTISHIP_GIFTNOTE)).val(giftNote);
        }
        if (attribute.key.includes('_shippingMethod_')) {
          var shippingMethod = attribute.value;
          var shippingOptions = $template.find(getClassSelector(SELECTORS.MULTISHIP_SHIPPING_METHOD));

          shippingOptions.each(function(i, option) {
            if ($(option).val() == shippingMethod) {
              $(option).prop('checked', true);
              option.parentElement.classList.add('active');
            }
          });
        }
      });
    });

    // set address
    var addressText = formatMSDeliveryAddressNew(params.address);
    var addressContainer = $template.find(getClassSelector(SELECTORS.MULTISHIP_CART_ITEM_SELECTED_SHIPPING_ADDRESS));
    addressContainer.append(addressText);
    addressContainer.attr("delivery-group-index", index);

    $template.find(getClassSelector(SELECTORS.MULTISHIP_CART_ITEM_SHIPPING_ADDRESS_EDIT)).attr("delivery-group-index", index);

    // gift note
    var giftNote = $template.find(getClassSelector(SELECTORS.MULTISHIP_GIFTNOTE));
    giftNote.attr("id", "giftnote_" + index);
    if (params.giftNote) {
      giftNote.val(params.giftNote);
    }

    // shipping method
    getShippingMethods(params.address, params.lineItems)
      .then(function(shippingMethods) {
      if (shippingMethods && shippingMethods.length > 0) {
        shippingMethods.forEach(function(method, i) {
          var checked = i === 0;

          var $shippingMethod = $('<div>', {
            class: 'flex py1 px2 xs-px1 items-start ms-border-item multiship-cartItem-shipping-method-select action--multiship-cartItem-shipping-method-select border-box' + (checked ? ' active' : '')
          });

          var $radioButton = $('<input>', {
            type: 'radio',
            name: `shipping_method_${index}`,
            id: `shipping_method_${method.service_code}_${index}`,
            class: 'action--multiship-cartItem-shipping-method multiship-cartItem-shipping-method mr1 border-box',
            value: method.service_code,
            'data-rate': method.total_price,
            checked: checked
          });

          var $label = $('<label>', {
            class: 'body-copy--demibold--1 border-box mb1',
            text: method.service_name
          });

          var $description = $('<p>', {
            class: 'body-copy--medium--1 mt0 mb1',
            text: method.description
          });

          var $price = $('<span>', {
            class: 'shipping-method-price body-copy--demibold--1 border-box',
            text: method.total_price === 0 ? 'FREE' : `$${(method.total_price / 100).toFixed(2)}`
          });

          var $details = $('<div>', {
            class: 'xs-ml1--5 sm-ml2 flex justify-between width-100 border-box items-start'
          }).append(
            $('<div>', { class: 'flex-column' }).append($label, $description),
            $price
          );

          $shippingMethod.append(
            $('<div>', { class: 'block' }).append($radioButton),
            $details
          );

          $template.find(getClassSelector(SELECTORS.MULTISHIP_SHIPPING_METHODS)).append($shippingMethod);
          updatedShippingCosts();

        });
      }
    });
    $(getClassSelector(SELECTORS.MULTISHIP_SHIPPING_OPTIONS_CART_ITEMS)).append($template);
  }

  function formatMSAddressForDeliveryEstimates(address) {
    return {
      "address": address.address1,
      "address2": address.address2,
      "city": address.city,
      "country": address.country,
      "name": `${address.firstName} ${address.lastName}`,
      "phone": address.phone,
      "state": address.province,
      "zip": address.zip
    };
  }

  function formatMSLineItemsForDeliveryEstimates(lineItems) {
    return lineItems.map(line => {
      return {
        "sku": line.node.merchandise.sku,
        "quantity": line.node.quantity,
      }
    });
  }

  async function getShippingMethods(address, lineItems) {
    var deliveryEstimatesAddress = formatMSAddressForDeliveryEstimates(address);
    var deliveryEstimatesLineItems = formatMSLineItemsForDeliveryEstimates(lineItems);

    let response;
    let json;
    let url = new URL('cart/ms/fetch-shipping-methods', window.location.origin);
    const fetchOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ address: deliveryEstimatesAddress, line_items: deliveryEstimatesLineItems })
    }
    try {
      response = await fetch(url, fetchOptions);
      json = await response.json();
    } catch (error) {
      airbrake.notify({
        error: 'Error fetching shipping methods',
        context: { component: 'Multiship' },
        params: { error: error, fetchOptions: fetchOptions, response: response }
      });
      // Add fall back for when the fetch fails
      return [{
        service_code: 'amazon_standard',
        service_name: 'Ground',
        description: 'Orders placed by 11:30AM PT / 2:30PM ET M-F will be processed same day.',
        total_price: 0
      }]
    }
    return json|| [];
  }

  function updatedShippingCosts() {
    let shippingCost = 0;
    const shippingSelections = document.querySelectorAll('.multiship-cartItem-shipping-selection');

    shippingSelections.forEach(selection => {
      const shippingOptions = selection.querySelectorAll('.action--multiship-cartItem-shipping-method');
      const updateShippingCostAndActiveClass = (option, parentElement) => {
        // Update shipping cost based on selected method
        const selectedRate = getSelectedShippingMethodRate(option);
        if (selectedRate > 0) {
          shippingCost += selectedRate;
        } else if (selectedRate === 0 && shippingOptions && shippingOptions.length > 1) {
          const paidOption = Array.from(shippingOptions).find(opt => getSelectedShippingMethodRate(opt) > 0);
          const paidRate = getSelectedShippingMethodRate(paidOption);
          shippingCost -= paidRate;
        }

        // Remove 'active' class from all parent elements within this selection group
        shippingOptions.forEach(otherOption => otherOption.closest('.action--multiship-cartItem-shipping-method-select').classList.remove('active'));

        // Add 'active' class to the current parent
        parentElement.classList.add('active');

        renderTotalShippingCost(shippingCost);
        updateOrderSummaryTotal(shippingCost);
      };

      shippingOptions.forEach(option => {
        const parentElement = option.closest('.action--multiship-cartItem-shipping-method-select');

        // Initial check for paid shipping
        if (option.checked) {
          const selectedRate = getSelectedShippingMethodRate(option);
          if (selectedRate > 0) {
            shippingCost += selectedRate;
          }
        }

        // Initial option active class
        if (option.checked) {
          parentElement.classList.add('active');
        }

        // Listen for 'change' event on each radio button
        option.addEventListener('change', function() {
          updateShippingCostAndActiveClass(option, parentElement);
        });

        // Listen for 'click' event on each radio button's parent element
        parentElement.addEventListener('click', function() {
          if (!option.checked) {
            option.checked = true; // Programmatically check the radio button
            option.dispatchEvent(new Event('change')); // Trigger the 'change' event manually
          }
        });
      });
    });

    return shippingCost;
  }

  function getSelectedShippingMethodRate(option) {
    return parseFloat(option.getAttribute('data-rate') || 0) / 100;
  }

  function renderMSCartItem(params) {
    var data = params.data;
    var price = calculateFramePrice(data);
    var strikePrice = calculateStrikePrice(data);
    var $template = $(getClassSelector(SELECTORS.MULTISHIP_CART_ITEM_TEMPLATE)).clone();
    var itemIndex = params.itemIndex;
    $template.removeClass(SELECTORS.MULTISHIP_CART_ITEM_TEMPLATE);

    // set image source
    $template.find(getClassSelector(SELECTORS.CART_ITEM_THUMBNAIL)).attr("src", params.thumbnail);
    $template.find(getClassSelector(SELECTORS.CART_ITEM_THUMBNAIL_CONTAINER)).attr("href", data.productUrl);

    // set title
    $template.find(getClassSelector(SELECTORS.CART_ITEM_COLLECTION)).text(data.categoryWithDisplaySize);
    $template.find(getClassSelector(SELECTORS.CART_ITEM_TITLE)).text(data.title);

    // set price
    renderCartLineItemPricing($template, strikePrice, price, currencySymbol);

    // shipping address
    var shippingAddressInput = $template.find(getClassSelector(SELECTORS.MULTISHIP_CART_ITEM_SHIPPING_ADDRESS));
    if (shippingAddressInput.length > 0) {
      shippingAddressInput.attr("id", "shipping-address-" + itemIndex + "-" + data.shopifyId);
      renderShippingAddressOptions(shippingAddressInput);
      var newAddressButton = $template.find(getClassSelector(SELECTORS.MULTISHIP_NEW_SHIPPING_ADDRESS_BUTTON));
      newAddressButton.attr("data-shopify-id", itemIndex + "-" + data.shopifyId);
      newAddressButton.on('click', function (e) {
        e.target.classList.add('active');
        renderShippingAddressModal();
      });
    }

    $(getClassSelector(SELECTORS.MULTISHIP_CART_ITEMS)).append($template);
  }

  function handleShippingAddressEditClick() {
    var editButton = $(getClassSelector(SELECTORS.MULTISHIP_DELETE_SHIPPING_ADDRESSES_BUTTON));
    editButton.on('click', function(e) {
      e.preventDefault();
      renderShippingAddressesEditModal();
    });

  }

  function renderShippingAddressesEditModal() {
    var cart = getSavedShopifyCart();
    var addresses = [];
    if (cart && cart.buyerIdentity && cart.buyerIdentity.deliveryAddressPreferences) {
      addresses = cart.buyerIdentity.deliveryAddressPreferences;

      var $modal = $(getClassSelector(SELECTORS.MULTISHIP_SHIPPING_ADDRESSES_EDIT_MODAL));
      $modal.addClass(CLASSES.OPEN);
      $('body').addClass(CLASSES.OPEN);
      if (!isOverlayShowing) {
        showOverlay();
      }

      $modal.find(getClassSelector(SELECTORS.MULTISHIP_SHIPPING_ADDRESSES_EDIT_CLOSE)).click(function() {
        $modal.removeClass(CLASSES.OPEN);
        $('body').removeClass(CLASSES.OPEN);
        if (isOverlayShowing) {
          hideOverlay();
        }
      });

      var modalContent = $modal.find(getClassSelector(SELECTORS.MULTISHIP_SHIPPING_ADDRESSES_EDIT_MODAL_CONTENT));
      document.querySelectorAll('.multiship-shipping-addresses-edit-checkbox').forEach(element => element.remove());

      addresses.forEach(function(address, index) {
        var addressText = formatMSDeliveryAddressNew(address);
        var addressOption = $(modalContent).find('form').prepend(
          $('<div class="multiship-shipping-addresses-edit-checkbox"></div>').append(
            $('<input type="checkbox">').val(JSON.stringify(address)),
            $('<label></label>').html(addressText)
          )
        );
        modalContent.append(addressOption);

        var deleteButton = $(modalContent).find(getClassSelector(SELECTORS.MULTISHIP_SHIPPING_ADDRESSES_DELETE_BUTTON));
        deleteButton.on('click', async function(e) {
          e.preventDefault();
          var addressesToDelete = Array.from(document.querySelectorAll('.multiship-shipping-addresses-edit-checkbox input:checked')).map(input => JSON.parse(input.value));
          if (addressesToDelete.length > 0) {
            var updatedCart = await removeDeliveryAddressesShopifyCart(addressesToDelete, getShopifyCartId());
            if (updatedCart) {
              window.location.reload();
            } else {
              console.error('Error removing delivery addresses from cart');
            }
          }
        });
      });
    }
  }

  async function loadMultiShipCartShippingMethods() {
    var cart = getSavedShopifyCart();
    var cartId = getShopifyCartId();
    if (cartHasLineItems(cart)) {
      logMSEvent('ms_page_view', cart, { location: 'Shipping Methods' });
      loadMSOrderSummary(cart);
      renderMSCartShippingOptions(cart);
      renderShippingCosts(cart);
      updatedShippingCosts();
      handleShippingAddressClickEdit();

      var msCheckoutShippingOptions = $(getClassSelector(SELECTORS.MULTISHIP_CHECKOUT_SHIPPING_OPTIONS));
      msCheckoutShippingOptions.on('click', async function(e) {
        e.preventDefault();
        // get gift note and shipping method selections for delivery addresses
        var cartLineShippingInfo = setCartLineShippingInfo(cart);
        if (cartLineShippingInfo.length > 0) {
          cartLineShippingInfo = cartLineShippingInfo.reduce((acc, line) => {
            var existingLine = acc.find((l) => l.id === line.id);
            if (existingLine) {
              existingLine.attributes = existingLine.attributes.concat(line.attributes);
            } else {
              acc.push(line);
            }
            return acc;
          }
          , []);
          var updated = await updateLineItemsAttributesShopifyCart(cartLineShippingInfo, getShopifyCartId());
          if (updated) {
            logMSEvent('ms_click_continue_to_billing_info', updated);
            var msCart = await saveMSCartTaxes(updated);
            if (msCart) {
              window.location.href = '/cart/ms/billing-info/' + cartId;
            }
          }
        } else {
          console.error('Error updating cart line shipping info for cartId: ' + cartId);
        }
      });
    }
  }

  function toggleMultiShipCheckoutLink() {
    let msCheckoutCopy = document.querySelector('.cart-ms-copy');
    if (msCheckoutCopy) {
      const cartQuantity = getCartItemCount();
      const collectiveQuantity = findCartItemByDataType('iscollective');
      //toggle ms copy - only show if two or more items in cart & no collective items
      const showMsCheckoutCopy = cartQuantity >= 2 && !collectiveQuantity.length;
      msCheckoutCopy.classList.toggle('display-none', !showMsCheckoutCopy);
      handleCartPageMultiShipLinkClick()
    }
  }

  function handleCartPageMultiShipLinkClick() {
    let msCartLink = document.querySelector('.cart-ms-link');
    if (msCartLink) {
      msCartLink.addEventListener('click', (e) => {
        e.preventDefault();
        createMultiShipCheckoutUrl(msCartLink);
      })
    }
  }

  function createMultiShipCheckoutUrl(msCartLink) {
    let cartId = getShopifyCartId();
    let multiShipCheckoutUrl = `${window.location.origin}/cart/ms/${cartId}`;
    msCartLink.setAttribute('href', multiShipCheckoutUrl);
    //go to ms checkout
    window.location.href = multiShipCheckoutUrl;
  }

  function handleShippingAddressClickEdit() {
    var editButtons = document.querySelectorAll(getClassSelector(SELECTORS.MULTISHIP_CART_ITEM_SHIPPING_ADDRESS_EDIT));
    editButtons.forEach(editButton => {
      editButton.addEventListener('click', function(e) {
        e.preventDefault();
        const deliveryGroupIndex = e.target.getAttribute('delivery-group-index');
        renderShippingAddressModal(deliveryGroupIndex);
      });
    });
  }

  async function handleUpdateShippingAddress(new_delivery_addresses, current_address, deliveryGroupIndex) {
    const response = await updateBuyerIdentityShopifyCart(new_delivery_addresses, getShopifyCartId(), current_address);

    if (response.errors) {
      console.error('Buyer identity update error:', response);
      $(getClassSelector(SELECTORS.MULTISHIP_SHIPPING_ADDRESS_FORM)).find('.text-error').remove();
      $.each( response.errors, function( key, value ) {
        var error = $('<span class="text-error"></span>').text(value);
        $('#ms-' + key).after(error);
      });
    } else if (response && response.buyerIdentity && response.buyerIdentity.deliveryAddressPreferences) {
      var cart = getSavedShopifyCart();
      var deliveryGroups = getDeliveryGroups(cart);
      var lineItems = deliveryGroups[deliveryGroupIndex].lineItems;
      var attributes = [];
      lineItems.forEach((line) => {
        var lineAttributes = line.node.attributes.map(attr => {
          if (attr.key.includes('_deliveryAddress_') && isEqual(JSON.parse(attr.value), current_address)) {
            return { key: attr.key, value: JSON.stringify(new_delivery_addresses[0].deliveryAddress) };
          }
          return attr;
        });
        attributes.push({
          id: line.node.id,
          attributes: lineAttributes
        });
      });

      var updated = await updateLineItemsAttributesShopifyCart(attributes, getShopifyCartId());
      if (updated) {
        closeShippingAddressModal();
        var addressText = formatMSDeliveryAddressNew(new_delivery_addresses[0].deliveryAddress);
        var addressContainer = $(getClassSelector(SELECTORS.MULTISHIP_CART_ITEM_SELECTED_SHIPPING_ADDRESS));
        addressContainer = addressContainer.filter(function() {
          return $(this).attr('delivery-group-index') == deliveryGroupIndex;
        });
        var oldText = formatMSDeliveryAddressNew(current_address);
        if (addressContainer.length > 0) {
          if (addressContainer[0].innerHTML.includes(oldText)) {
            addressContainer[0].innerHTML = addressText;
          }
        }
      } else {
        console.error('Error updating cart with new delivery addresses for cartId: ' + getShopifyCartId());
      }
    } else {
      console.error('Error updating buyer identity for cartId: ' + getShopifyCartId());
    }
  }

  async function loadMultiShipCartBilling() {
    var cart = getSavedShopifyCart();
    var cartId = getShopifyCartId();
    if (cartHasLineItems(cart)) {
      logMSEvent('ms_page_view', cart, { location: 'Billing Info' });
      loadMSOrderSummary(cart);
      renderShippingCosts(cart);
      loadMSOrderSummaryCartItems(cart);
    }

    handleInternationalBillingAddress();

    var msBillingInfo = $(getClassSelector(SELECTORS.MULTISHIP_BILLING_INFO));
    msBillingInfo.on('click', async function(e) {
      e.preventDefault();
      $(getClassSelector(SELECTORS.MULTISHIP_BILLING_FORM)).find('.text-error').remove();
      var $form = $(getClassSelector(SELECTORS.MULTISHIP_BILLING_FORM));
      var msCountry = $form.find('#ms-country').val();
      var msProvince = msCountry === 'US'
        ? $form.find('#ms-province').val()
        : $form.find('#ms-province-input').val();

      var billingAddress = {
        address1: $form.find('#ms-address1').val(),
        address2: $form.find('#ms-address2').val(),
        city: $form.find('#ms-city').val(),
        countryCode: msCountry,
        firstName: $form.find('#ms-firstName').val(),
        lastName: $form.find('#ms-lastName').val(),
        phone: $form.find('#ms-phone').val(),
        provinceCode: msProvince,
        zip: $form.find('#ms-zip').val()
      }
      var errors = validateFormFields($form);
      if (!errors) {
        const errorField = $form.find('.action--error-message');
        errorField.text('');
        const validatedAddress = await checkIfValidAddress(billingAddress, errorField);
        if (validatedAddress && validatedAddress.isValid === true) {
          billingAddress = setConfirmedAddress(validatedAddress.confirmedAddress, billingAddress);
        } else {
          errors = true;
        }
      }
      var emailInput = $(getClassSelector(SELECTORS.MULTISHIP_BILLING_EMAIL) + ' #ms-email');
      var email = emailInput ? emailInput.val() : null;
      if (errors || !validEmail(email, emailInput)) return;
      var attributes = [
        { key: '_billing_address', value: JSON.stringify(billingAddress) }
      ];
      var updated = await updateShopifyCartAttributes(attributes, cartId);
      if (updated && email) {
        var emailUpdate = await updateBuyerIdentityShopifyCart([{ email: email }], cartId);
        // check if email update was successful
        if (emailUpdate && emailUpdate.errors && emailUpdate.errors.email) {
          addFormFieldError(emailUpdate.errors.email, emailInput);
          return;
        } else if (emailUpdate && emailUpdate.errors && emailUpdate.errors.addresses) {
          addFormFieldError(emailUpdate.errors.addresses, $form.find('#ms-address1'));
          return;
        }
        if (emailUpdate) {
          // update taxes to catch any changes in address or discount input
          var msCart = await saveMSCartTaxes(emailUpdate);
        }

        if (msCart) {
          let draftOrder = await renderDraftOrder(JSON.stringify(msCart));
          if (draftOrder) {
            logMSEvent('ms_click_continue_to_checkout', updated, { draft_order_created: true });
            if (draftOrder['tax_difference'] && draftOrder['tax_difference'] > 0) {
              renderTaxAdjustmentWarningModal(draftOrder);
            } else {
              window.location.href = draftOrder['checkout_url'];
            }
          } else {
            errors = true;
          }
        } else {
          errors = true;
        }
      } else {
        errors = true;
      }

      // catch-all error message
      if (errors) {
        var errorField = $form.find('.action--error-message');
        var msg = 'There was an error updating your billing information. Please make sure all fields are filled out correctly.';
        var error = $('<span class="text-error"></span>').text(msg);
        errorField.append(error);
      }
    });
  }

  function renderTaxAdjustmentWarningModal(draftOrder) {
    var $modal = $(getClassSelector(SELECTORS.TAX_ADJUSTMENT_WARNING));
    $modal.addClass(CLASSES.OPEN);
    $('body').addClass(CLASSES.OPEN);
    if (!isOverlayShowing) {
      showOverlay();
    }

    $modal.find('.action--multiship-tax-adjustment-close').on('click', function() {
      $modal.removeClass(CLASSES.OPEN);
      $('body').removeClass(CLASSES.OPEN);
      hideOverlay();
    });

    $modal.find('.action--multiship-tax-adjustment-continue').on('click', function() {
      $modal.removeClass(CLASSES.OPEN);
      $('body').removeClass(CLASSES.OPEN);
      hideOverlay();
      window.location.href = draftOrder['checkout_url'];
    });
  }

  function handleInternationalBillingAddress() {
    const msCountry = $(getClassSelector(SELECTORS.MULTISHIP_ADDRESS_COUNTRY));
    const msZip = $(getClassSelector(SELECTORS.MULTISHIP_ADDRESS_ZIP));
    const msProvince = $(getClassSelector(SELECTORS.MULTISHIP_ADDRESS_PROVINCE));
    const msProvinceInput = $(getClassSelector(SELECTORS.MULTISHIP_ADDRESS_PROVINCE_INPUT));

    msCountry.on('change', function(e) {
      $(getClassSelector(SELECTORS.MULTISHIP_BILLING_FORM)).find('.text-error').remove();
      const isUS = e.target.value === 'US';
      msProvince.toggleClass('hide', !isUS);
      msProvinceInput.toggleClass('hide', isUS);
      msProvince.toggleClass('required', isUS);
      msZip.toggleClass('required', isUS);
    });
  }

  async function checkIfValidAddress(address, formField) {
    // check if address is valid using Google Maps API
    const validateAddress = await isValidAddress(address);
    if (validateAddress.isValid === false) {
      if (validateAddress.invalidFields && validateAddress.invalidFields.length > 0) {
        formField.text('');
        var invalidFields = validateAddress.invalidFields.join(', ');
        addFormFieldError('The address appears to be invalid, please review the following fields: ' + invalidFields, formField);
      } else {
        formField.text('');
        addFormFieldError('Please review the address, it appears to be invalid.', formField);
      }
    }
    return validateAddress;
  }

  function isSameAddress(address1, address2) {
    if (!address1 || !address2) return false;

    address1 = Object.keys(address1).reduce((acc, key) => {
      acc[key] = address1[key].toUpperCase();
      return acc;
    }, {});

    address2 = Object.keys(address2).reduce((acc, key) => {
      acc[key] = address2[key].toUpperCase();
      return acc;
    }, {});

    if (address1.address1 === address2.address1 &&
      address1.city === address2.city &&
      address1.province === address2.province &&
      address1.zip === address2.zip) {
      return true;
    } else {
      return false;
    }
  }

  function validateFormFields(form) {
    var errors = false;
    var requiredFields = form.find('.required');
    requiredFields.each(function(i, field) {
      if (!field.value) {
        addFormFieldError('This field is required', $(field));
        errors = true;
      }
    });

    var address1 = form.find('#ms-address1').val();
    if (isPOBox(address1)) {
      addFormFieldError('We cannot deliver to a PO Box', form.find('#ms-address1'));
      errors = true;
    }
    return errors;
  }

  function isPOBox(address) {
    var poBoxRegex = /p\.?o\.?\s?box/i;
    return poBoxRegex.test(address);
  }

  function validEmail(email, emailInput) {
    emailInput.next('.text-error').remove();
    if (!email) {
      addFormFieldError('This field is required', emailInput);
      return false;
    } else if (!validateEmail(email)) {
      addFormFieldError('Enter a valid email address', emailInput);
      return false;
    } else {
      return true;
    }
  }

  function validateEmail(email) {
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  function formatPhoneInput() {
    var phoneInput = $(getClassSelector(SELECTORS.MULTISHIP_PHONE_INPUT));
    phoneInput.on('keyup', function() {
      phoneInput.val(phoneFormat(phoneInput.val()));
    });
  }

  function phoneFormat(input){
    input = input.replace(/\D/g,'');
    input = input.substring(0,10);
    var size = input.length;
    if(size == 0){
      input = input;
    }else if(size < 4){
      input = '('+input;
    }else if(size < 7){
      input = '('+input.substring(0,3)+') '+input.substring(3,6);
    }else{
      input = '('+input.substring(0,3)+') '+input.substring(3,6) + '-' + input.substring(6,10);
    }
    return input;
  }

  function showEstimatedTaxes() {
    var taxItemizedLine = $(getClassSelector(SELECTORS.CART_TAXES));
    taxItemizedLine.removeClass('hide');
  }

  function loadMSOrderSummary(cart) {
    showCartItemizedCost();
    renderCartItemizedCosts(cart);
    renderShopifyDiscountCodeMessage(cart);
    updateCartUrl();
    showBundleTag(cart);
    showEstimatedTaxes();
  }

  function loadMSOrderSummaryCartItems(cart) {
    var deliveryGroups = getDeliveryGroups(cart);
    deliveryGroups.forEach(function(group) {
      group.lineItems.forEach(function(line) {
        var shopifyId = lineItemShopifyId(line);
        var data = grabFrameData(shopifyId);
        renderMSOrderSummaryCartItem({
          data: data,
          address: group.address,
          giftNote: group.giftNote
        });
      });
    });
    renderMSOrderShippingMethods(deliveryGroups);
    updateOrderSummaryLineItemPrice(cart);
  }

  function renderMSOrderShippingMethods(deliveryGroups) {
    var shippingMethods = $(getClassSelector(SELECTORS.ORDER_SUMMARY_SHIPPING_METHODS));
    shippingMethods.removeClass('hide');
    var totalShippingCost = 0;
    deliveryGroups.forEach(function(group) {
      var address = group.address;
      var shippingMethod = group.shippingMethod;
      if (shippingMethod) {
        var formattedAddress = address.address1 + ', ' + address.city + ', ' + address.province;
        var shippingCost = parseInt(group.shippingRate, 10);
        totalShippingCost += shippingCost;
        var shippingMethodText = '<div>Shipping rate for: ' + formattedAddress + ': $' + shippingCost + '</div>';
        $(getClassSelector(SELECTORS.ORDER_SUMMARY_SHIPPING_ADDRESS)).append(shippingMethodText);
      }
    });
    totalShippingCost = totalShippingCost.toFixed(2);
    totalShippingCost = getPriceOrientation(totalShippingCost, currencySymbol);
    $(getClassSelector(SELECTORS.ORDER_SUMMARY_SHIPPING_COST)).text(totalShippingCost);
  }

  function renderMSOrderSummaryCartItem(params) {
    var data = params.data;
    var cartitems = $(getClassSelector(SELECTORS.ORDER_SUMMARY_CARTITEMS));
    cartitems.removeClass('hide');

    cartitems.each(function(i, item) {
      var $template = $(item).find(getClassSelector(SELECTORS.ORDER_SUMMARY_CARTITEM_TEMPLATE)).clone();
       $template.removeClass(SELECTORS.ORDER_SUMMARY_CARTITEM_TEMPLATE);
       $template.addClass(SELECTORS.ORDER_SUMMARY_CARTITEM);
       $template.attr('data-shopify-id', data.shopifyId + '-' + i);

      // set image link
      $template.find(getClassSelector(SELECTORS.CART_ITEM_THUMBNAIL_CONTAINER)).attr("href", data.productUrl);

      // set title
      $template.find(getClassSelector(SELECTORS.CART_ITEM_COLLECTION)).text(data.categoryWithDisplaySize + ' - ' + data.title);

      // set address
      var address = params.address;
      var addressText = '<div>Address: ' + formatMSOrderSummaryAddress(address) + '</div>';
      $template.find(getClassSelector(SELECTORS.ORDER_SUMMARY_CARTITEMS_SHIPPING_ADDRESS)).append(addressText);

      // set gift note
      var giftNote = params.giftNote;
      if (giftNote) {
        var giftNoteText = '<div>Gift note: ' + giftNote + '</div>';
        $template.find(getClassSelector(SELECTORS.ORDER_SUMMARY_CARTITEMS_GIFTNOTE)).append(giftNoteText);
      }

      $(item).append($template);
    });
  }

  function updateOrderSummaryLineItemPrice(cart) {
    if (!isMultiShipPages()) return;
    var cartitems = $(getClassSelector(SELECTORS.ORDER_SUMMARY_CARTITEMS));
    var deliveryGroups = getDeliveryGroups(cart);
    deliveryGroups.forEach(function(group) {
      group.lineItems.forEach(function(line) {
        var shopifyId = lineItemShopifyId(line);
        cartitems.each(function(i, item) {
          var $template = $(item).find(getClassSelector(SELECTORS.ORDER_SUMMARY_CARTITEM + '[data-shopify-id="' + shopifyId + '-' + i + '"]'));
          var lineItem = line.node;
          var prices = setLineItemPrice(line, $template);
          var originalPrice = prices.originalPrice;
          var price = prices.price;
          var lineQuantity = lineItem.quantity;

          $template.find(getClassSelector(SELECTORS.ORDER_SUMMARY_CARTITEM_BUNDLE_TAG)).addClass('hide');
          $template.find(getClassSelector(SELECTORS.ORDER_SUMMARY_CARTITEM_DISCOUNT_TAG)).addClass('hide');
          var discountTags = getDiscountTags(cart, getTotalQuantity(cart));
          if (originalPrice !== price) {
            var discountAllocation = [];
            lineItem.discountAllocations.forEach(function(discount) {
              discountAllocation.push(Number.parseFloat(discount.discountedAmount.amount));
            });
            var totalDiscount = discountAllocation.reduce((acc, amount) => acc + amount, 0);
            totalDiscount = totalDiscount / lineQuantity;
            renderLineItemDiscountTag($template, totalDiscount, discountTags);
          }
        });
      });
    });
  }

  function getTotalQuantity(cart) {
    var totalQuantity = 0;
    cart.lines.edges.forEach(function(line) {
      var quantity = line.node.quantity;
      totalQuantity += quantity;
    });
    return totalQuantity;
  }

  function setLineItemPrice(line, $template) {
    var shopifyId = lineItemShopifyId(line);
    var frameDetails = grabFrameData(shopifyId);
    var price = calculateFramePrice(frameDetails);
    var strikePrice = calculateStrikePrice(frameDetails);
    renderCartLineItemPricing($template, strikePrice, price, currencySymbol);
    return { price: price, originalPrice: strikePrice};
  }

  function getDiscountTags(cart, totalQuantity) {
    var discountTags = [];
    if (cart.discountCodes && cart.discountCodes.length > 0 ) {
      cart.discountCodes.forEach(function(discount) {
        if (discount.applicable == true) {
          discountTags.push(discount.code);
        }
      });
    }
    if (discountTags.length === 0) {
      if (totalQuantity > 1) {
        discountTags.push('BUNDLE');
      } else {
        discountTags.push('DISCOUNT');
      }
    }
    return discountTags;
  }

  function renderLineItemDiscountTag($template, totalDiscount, discountTags) {
    if (totalDiscount > 0) {
      var discountTag = $template.find(getClassSelector(SELECTORS.ORDER_SUMMARY_CARTITEM_DISCOUNT_TAG));
      discountTags.forEach(function(tag) {
        discountTag.removeClass('hide');
        discountTag.text(tag + ' (-' + getPriceOrientation((totalDiscount).toFixed(2), currencySymbol) + ')');
      });
    }
  }

  function renderShippingCosts(cart) {
    let totalShippingCost = 0;
    if (isMultiShipBillingPage()) {
      const deliveryGroups = getDeliveryGroups(cart);
      deliveryGroups.forEach(group => {
        totalShippingCost += parseInt(group.shippingRate, 10);
      });
    } else {
      totalShippingCost = updatedShippingCosts();
    }
    if (totalShippingCost > 0) {
      renderTotalShippingCost(totalShippingCost);
    }
    updateOrderSummaryTotal(totalShippingCost);
  }

  function renderTotalShippingCost(totalShippingCost) {
    var shippingCost = getPriceOrientation(totalShippingCost, currencySymbol);
    $(getClassSelector(SELECTORS.CART_SHIPPING_PRICE)).text(shippingCost);
  }

  function updateOrderSummaryTotal(totalShippingCost) {
    var total = Number(subtotal());
    total += totalShippingCost;
    var $estimateTotalAmount = $(getClassSelector(SELECTORS.CART_ESTIMATE_TOTAL_AMOUNT));
    var estimateDisplay = formatPriceWithLocaleDelimiter(total.toFixed(0));
    $estimateTotalAmount.text(getPriceOrientated(estimateDisplay));
  }

  function renderDraftOrder(shopifyCart){
    async function createDraftOrder(cart) {
      let response;
      let json;
      let url = new URL('cart/ms/go-to-checkout', window.location.origin);
      try {
        response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ cart: cart }),
        });
        json = response.json();
        return json;
      } catch (error) {
        console.error('Fetch error:', error);
        airbrake.notify({
          error: `Error creating draft order for cartId: ${getShopifyCartId()}`,
          context: { component: 'Multiship' },
          params: { cart: cart, error: error }
        });
        return null;
      }
    }
    let draftOrder = createDraftOrder(shopifyCart);
    return draftOrder;
  }

  async function saveMSCartTaxes(cart) {
    var deliveryGroups = getDeliveryGroups(cart);
    var addresses = [];
    deliveryGroups.forEach(function(group) {
      addresses.push(group.address);
    });

    var taxRates = await fetchTaxRates(addresses);
    if (taxRates) {
      // check if there are cart level discounts
      var cartDiscounts = cart.discountAllocations;
      if (cartDiscounts && cartDiscounts.length > 0) {
        // Add the corresponding lineItem to cartDiscounts
        cart.lines.edges.forEach(function(line, index) {
          var lineDiscount = cartDiscounts[index];
          if (lineDiscount) {
            lineDiscount.lineItemId = line.node.id;
          }
        });
        var taxAttributes = calculateTaxesPerDeliveryGroup(deliveryGroups, taxRates, cartDiscounts);
      } else {
        var taxAttributes = calculateTaxesPerDeliveryGroup(deliveryGroups, taxRates);
      }

      var attributes = [
        { key: '_multiship_fields', value: JSON.stringify(taxAttributes) },
        { key: '_tax_rates', value: JSON.stringify(taxRates) }
      ];
      return await updateShopifyCartAttributes(attributes, getShopifyCartId());
    }
  }

  function calculateTaxesPerDeliveryGroup(deliveryGroups, taxRates, cartDiscounts) {
    var attributes = [];
    deliveryGroups.forEach(function(group, index) {
      var taxRate = 0;
      taxRates.tax_rates.forEach(function(rate) {
        if (isEqual(rate.address, group.address)) {
          taxRate = rate.totalRate;
          attributes.push({
            key: '_deliveryAddress_' + index,
            value: group.address
          });
          attributes.push({
            key: '_shippingMethod_' + index,
            value: group.shippingMethod
          });
          attributes.push({
            key: '_shippingRate_' + index,
            value: group.shippingRate
          });
          attributes.push({
            key: '_giftNote_' + index,
            value: group.giftNote
          });
          attributes.push({
            key: '_taxRate_' + index,
            value: taxRate
          });
        }
      });
      if (taxRate) {
        var taxAmounts = [];
        group.lineItems.forEach(function(line) {
          var totalAmount = Number.parseFloat(line.node.cost.totalAmount.amount);
          var quantity = line.node.quantity;
          var unitPrice = totalAmount / quantity;
          var taxAmountForLineItem = 0;

          // if there are cart line discounts, apply the tax rate to the discounted price
          if (cartDiscounts && cartDiscounts.length > 0) {
            var lineDiscount = cartDiscounts.find(discount => discount.lineItemId === line.node.id);
            var discountedAmt = lineDiscount ? lineDiscount.discountedAmount.amount : 0;
            var discountedUnitPrice = unitPrice - (unitPrice * discountedAmt / totalAmount);
            taxAmountForLineItem = discountedUnitPrice * taxRate;
          } else {
            taxAmountForLineItem = unitPrice * taxRate;
          }

          taxAmounts.push(taxAmountForLineItem);
          attributes.push({
            key: '_taxAmount_' + line.node.id + '_' + index,
            value: taxAmountForLineItem
          });
        });
        var totalGroupTaxAmount = taxAmounts.reduce((acc, amount) => acc + amount, 0);
        attributes.push({
          key: '_totalGroupTaxAmount_' + index,
          value: totalGroupTaxAmount
        });
      }
    });
    return attributes;
  }

  async function fetchTaxRates(addresses) {
    let response;
    let json;
    let url = new URL('cart/ms/fetch-tax-rates', window.location.origin);
    const fetchOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ addresses: addresses })
    }

    try {
      response = await fetch(url, fetchOptions);
      json = await response.json();
    } catch (error) {
      console.error('Fetch error:', error);
      airbrake.notify({
        error: `Error fetching tax rates for shopify cart: ${getShopifyCartId()}`,
        context: { component: 'Multiship' },
        params: { addresses: addresses, response: response, error: error }
      });
      return null;
    }
    if (!response.ok || json.error) {
      $('.text-error').remove();
      if (json && json.error_message) {
        var error_message = json.error_message;
        var parent = $(getClassSelector(SELECTORS.MULTISHIP_CHECKOUT_SHIPPING_OPTIONS)).parent();
        parent.before('<div class="text-error mb4">' + error_message + '</div>');
      }
      return null;
    }
    return json;
  }

  function setCartLineShippingInfo(cart) {
    $(getClassSelector(SELECTORS.MULTISHIP_CARTITEM_SHIPPING_SECTION)).next('.text-error').remove();
    var cartLineShippingMethods = [];
    var errors = false;
    var deliveryGroups = getDeliveryGroups(cart);

    // get shipping method and giftnote for deliveryGroups
    deliveryGroups.forEach(function(lineItem, index) {
      var shippingMethod = $(`input[name="shipping_method_${index}"]:checked`).val();
      var shippingRate = $(`input[name="shipping_method_${index}"]:checked`).data('rate');
      if (shippingMethod) {
        lineItem['shippingMethod'] = shippingMethod;
        lineItem['shippingRate'] = (shippingRate / 100).toString();
      } else {
        var input = $(`input[name="shipping_method_${index}"]`).closest($(getClassSelector(SELECTORS.MULTISHIP_CARTITEM_SHIPPING_SECTION)));
        addFormFieldError('Select a shipping method', input);
        errors = true;
      }
      var giftnote = $(`#giftnote_${index}`).val();
      if (giftnote || giftnote == '') {
        lineItem['giftnote'] = giftnote;
      }
    });

    // set shipping method and giftnote for lineItems
    deliveryGroups.forEach(function(lineItem) {
      lineItem.lineItems.forEach(function(line) {
        // check if delivery address is the same as the lineItem address
        line.node.attributes.forEach(function(attribute) {
          if (attribute.key.includes('_deliveryAddress_')) {
            var address = JSON.parse(attribute.value);
            if (isEqual(address, lineItem.address)) {
              // use index from deliveryAddress key to set shipping method and giftnote
              var index = attribute.key.match(/\d+/)[0];
              if (lineItem.shippingMethod) {
                var lineShippingMethod = {
                  id: line.node.id,
                  attributes: [
                    { key: '_shippingMethod_' + index, value: lineItem.shippingMethod },
                    { key: '_shippingRate_' + index, value: lineItem.shippingRate },
                  ]
                };
                cartLineShippingMethods.push(lineShippingMethod);
              }
              if (lineItem.giftnote || lineItem.giftnote == '') {
                var lineGiftNote = { id: line.node.id, attributes: [{ key: '_giftNote_' + index, value: lineItem.giftnote }] };
                cartLineShippingMethods.push(lineGiftNote);
              }
            }
          }
        });
      });
    });
    return errors ? [] : cartLineShippingMethods;
  }

  function showBundleTag(cart) {
    var totalQuantity = getTotalQuantity(cart);
    if (totalQuantity > 1 && cart.discountAllocations.length === 0 && cart.discountCodes.length === 0) {
      $(getClassSelector(SELECTORS.CART_DISCOUNT_CODES)).removeClass('hide');
      $(getClassSelector(SELECTORS.CART_DISCOUNT_BUNDLE)).removeClass('hide');
    } else {
      $(getClassSelector(SELECTORS.CART_DISCOUNT_CODES)).removeClass('hide');
      $(getClassSelector(SELECTORS.CART_DISCOUNT_BUNDLE)).addClass('hide');
    }
  }

  function formatVerifiedAddress(address) {
    return address.address1 + (address.address2 ? ', ' + address.address2 : '') + ' <br> ' + address.city + ', ' + address.province + ', ' + address.zip;
  }

  function formatMSDeliveryAddress(address) {
    return address.firstName + ' ' + address.lastName + ': ' + address.address1 + (address.address2 ? ', ' + address.address2 : '') + ', ' + address.city + ', ' + address.province + ', ' + address.zip;
  }

  function formatMSDeliveryAddressNew(address) {
    return address.firstName + ' ' + address.lastName + ' <br> ' + address.address1 + (address.address2 ? ', ' + address.address2 + '<br>' : '<br>') + address.city + ', ' + address.province + ', ' + address.zip + '<br>' + address.phone;
  }

  function formatMSOrderSummaryAddress(address) {
    var addressText = address.address1;
    if (address.address2) {
      addressText += ', ' + address.address2;
    }
    addressText += ', ' + address.city + ', ' + address.province + ', ' + address.country + ', ' + address.zip + ', ' + address.firstName + ' ' + address.lastName + ', ' + address.phone;
    return addressText;
  }

  function renderShippingAddressOptions(shippingAddressInput) {
    var cart = getSavedShopifyCart();
    var addresses = [];
    if (cart && cart.buyerIdentity && cart.buyerIdentity.deliveryAddressPreferences) {
      var shippingAddresses = cart.buyerIdentity.deliveryAddressPreferences;
      if (shippingAddresses && shippingAddresses.length > 0) {
        shippingAddresses.forEach(function(address) {
          if (address.firstName && address.lastName && address.phone) {
            addresses.push(address);
          } else {
            removeDeliveryAddressesShopifyCart([], getShopifyCartId());
          }
        });
      }
      addressOptions(addresses, shippingAddressInput);
    }
    if (addresses.length == 0) {
      shippingAddressInput.prop('disabled', true);
    }
  }

  function addressOptions(addresses, shippingAddressInput) {
    addresses.forEach(function(address) {
      addressOption(address, shippingAddressInput);
    });
  }

  function addressOption(address, shippingAddressInput, selected) {
    var addressText = formatMSDeliveryAddress(address);
    if (!shippingAddressInput.find('option').filter(function() {
      return $(this).val() === JSON.stringify(address);
    }).length) {
      shippingAddressInput.append($('<option>', {
        value: JSON.stringify(address),
        text: addressText,
        selected: selected ? selected : checkIfAddressSelected(address, shippingAddressInput)
      }));
    }
  }

  function checkIfAddressSelected(address, shippingAddressInput) {
    var input = $(shippingAddressInput).attr('id');
    var lineItemId = input.split('-').pop();
    var lineItemIndex = input.split('-')[2];
    var selected = false;
    var cart = getSavedShopifyCart();
    if (cartHasLineItems(cart)) {
      cart.lines.edges.forEach(function(line) {
        var shopifyId = lineItemShopifyId(line);
        if (shopifyId == lineItemId) {
          var attributes = line.node.attributes;
          attributes.forEach(function(attribute) {
            if (attribute.key.includes('_deliveryAddress_' + lineItemIndex) && isEqual(JSON.parse(attribute.value), address)) {
              selected = true;
            }
          });
        }
      });
    }
    return selected;
  }

  function closeShippingAddressModal() {
    var $modal = $(getClassSelector(SELECTORS.MULTISHIP_SHIPPING_ADDRESS_MODAL));
    $modal.removeClass(CLASSES.OPEN);
    $('body').removeClass(CLASSES.OPEN);
    $(getClassSelector(SELECTORS.MULTISHIP_NEW_SHIPPING_ADDRESS_BUTTON) + '.active').removeClass('active');
    if (isOverlayShowing) {
      hideOverlay();
    }
  }

  function renderShippingAddressModal(deliveryGroupIndex) {
    var $modal = $(getClassSelector(SELECTORS.MULTISHIP_SHIPPING_ADDRESS_MODAL));
    $modal.addClass(CLASSES.OPEN);
    $modal.find('input').not(':submit, :hidden').val('');
    $modal.find('.text-error').remove();
    $modal.find(getClassSelector(SELECTORS.MULTISHIP_SHIPPING_ADDRESS_FORM_SUBMIT)).removeClass('ms-confirm-original-address');
    const existingConfirmAddress = document.querySelector('.ms-confirm-address');
    if (existingConfirmAddress) {
      existingConfirmAddress.remove();
    }
    $('body').addClass(CLASSES.OPEN);
    if (!isOverlayShowing) {
      showOverlay();
    }
    $modal.find(getClassSelector(SELECTORS.MULTISHIP_SHIPPING_ADDRESS_CLOSE)).click(function() {
      closeShippingAddressModal();
    });

    if (deliveryGroupIndex) {
      var title = $modal.find(getClassSelector(SELECTORS.MULTISHIP_SHIPPING_ADDRESS_TITLE));
      title.text('Edit Shipping Address');

      // prefill form fields with saved address
      var deliveryGroups = getDeliveryGroups(getSavedShopifyCart());
      var address = deliveryGroups[deliveryGroupIndex].address;
      $modal.find('#ms-address1').val(address.address1);
      $modal.find('#ms-address2').val(address.address2);
      $modal.find('#ms-city').val(address.city);
      $modal.find('#ms-firstName').val(address.firstName);
      $modal.find('#ms-lastName').val(address.lastName);
      $modal.find('#ms-phone').val(address.phone);
      $modal.find('#ms-province').val(address.province);
      $modal.find('#ms-zip').val(address.zip);
    }

    $modal.find(getClassSelector(SELECTORS.MULTISHIP_SHIPPING_ADDRESS_FORM)).submit(async function(e) {
      $(getClassSelector(SELECTORS.MULTISHIP_SHIPPING_ADDRESS_FORM)).find('.text-error').remove();
      e.preventDefault();
      var zip = $modal.find('#ms-zip').val();
      var deliveryAddresses = [
        {
          deliveryAddress: {
            address1: $modal.find('#ms-address1').val(),
            address2: $modal.find('#ms-address2').val(),
            city: $modal.find('#ms-city').val(),
            country: $modal.find('#ms-country').val(),
            firstName: $modal.find('#ms-firstName').val(),
            lastName: $modal.find('#ms-lastName').val(),
            phone: $modal.find('#ms-phone').val(),
            province: $modal.find('#ms-province').val(),
            zip: zip
          }
        }
      ];
      var errors = validateFormFields($modal);
      if (!errors) {
        logGA4Event('ms_add_new_shipping_address', { zip: zip });
        logPavedEvent('ms_add_new_shipping_address', { zip: zip });
        const errorField = $modal.find('.action--error-message');
        errorField.text('');
        var deliveryAddress = deliveryAddresses[0].deliveryAddress;
        const validatedAddress = await checkIfValidAddress(deliveryAddress, errorField);
        if (validatedAddress && validatedAddress.isValid === true) {
          // check if confirmed address is different from original address
          if (!isSameAddress(validatedAddress.confirmedAddress, deliveryAddress)) {
            suggestNewAddress(validatedAddress.confirmedAddress);
            handleSuggestedAddress(deliveryGroupIndex, deliveryAddresses, deliveryGroups, validatedAddress.confirmedAddress, deliveryAddress);
            return;
          } else {
            deliveryAddresses[0].deliveryAddress = setConfirmedAddress(validatedAddress.confirmedAddress, deliveryAddresses[0].deliveryAddress);
          }
        } else {
          errors = true;
          suggestNewAddress(validatedAddress.confirmedAddress);
          handleSuggestedAddress(deliveryGroupIndex, deliveryAddresses, deliveryGroups, validatedAddress.confirmedAddress, deliveryAddress);
          return;
        }
      }
      if (!errors) {
        handleShippingAddressModalActions(deliveryAddresses, deliveryGroupIndex, deliveryGroups);
      }
    });
  }

  async function handleShippingAddressModalActions(deliveryAddresses, deliveryGroupIndex, deliveryGroups) {
    if (deliveryGroupIndex) {
      handleUpdateShippingAddress(deliveryAddresses, deliveryGroups[deliveryGroupIndex].address, deliveryGroupIndex);
    } else {
      const response = await updateBuyerIdentityShopifyCart(deliveryAddresses, getShopifyCartId());
      if (response.errors) {
        $(getClassSelector(SELECTORS.MULTISHIP_SHIPPING_ADDRESS_FORM)).find('.text-error').remove();
        $.each( response.errors, function( key, value ) {
          var error = $('<span class="text-error"></span>').text(value);
          var field = $('#ms-' + key);
          if (field.length) {
            field.after(error);
          } else {
            $(getClassSelector(SELECTORS.MULTISHIP_SHIPPING_ADDRESS_FORM)).prepend(error);
          }
        });
      } else if (response && response.buyerIdentity && response.buyerIdentity.deliveryAddressPreferences) {
        var addresses = response.buyerIdentity.deliveryAddressPreferences;
        var address = addresses[0];
        var target = $(getClassSelector(SELECTORS.MULTISHIP_NEW_SHIPPING_ADDRESS_BUTTON) + '.active');
        closeShippingAddressModal();
        var targetId = $(target).attr('data-shopify-id');
        $(getClassSelector(SELECTORS.MULTISHIP_CART_ITEM_SHIPPING_ADDRESS)).each(function(index, shippingAddressInput) {
          if ($(shippingAddressInput).attr('id').includes('shipping-address-')) {
            var skip = $(shippingAddressInput).find('option').filter(function() {
              return $(this).val() === JSON.stringify(address);
            }).length > 0;
            if (skip) return;
            const selected = $(shippingAddressInput).attr('id').includes('shipping-address-' + targetId);
            addressOption(address, $(shippingAddressInput), selected);
            $(shippingAddressInput).prop('disabled', false);
          }
        });
      } else {
        console.error('Failed to update buyer identity for multiship cart');
      }
    }
  }

  async function suggestNewAddress(confirmedAddress) {
    var existingConfirmAddress = document.querySelector('.ms-confirm-address');
    if (existingConfirmAddress) {
      existingConfirmAddress.remove();
    }

    var error = document.createElement('div');
    error.className = 'ms-confirm-address';

    var message = document.createElement('p');
    message.textContent = 'We have modified your address to ensure prompt and accurate delivery. Please review the address below.';
    error.appendChild(message);

    var form = document.querySelector('.multiship-shipping-address-modal .multiship-modal-header');
    form.insertAdjacentElement('afterend', error);

    var address = formatVerifiedAddress(confirmedAddress);
    var addressElement = document.createElement('div');
    addressElement.innerHTML = address;
    error.appendChild(addressElement);

    var acceptConfirmedButton = document.createElement('button');
    acceptConfirmedButton.className = 'ms-confirm-address-button';
    acceptConfirmedButton.textContent = 'Accept Changes';
    error.appendChild(acceptConfirmedButton);

    var submitButton = $(getClassSelector(SELECTORS.MULTISHIP_SHIPPING_ADDRESS_FORM_SUBMIT));
    submitButton.addClass('ms-confirm-original-address');
  }

  function handleSuggestedAddress(deliveryGroupIndex, deliveryAddresses, deliveryGroups, confirmedAddress, deliveryAddress) {
    var acceptConfirmedButton = document.querySelector('.ms-confirm-address-button');
    if (!acceptConfirmedButton) return;

    acceptConfirmedButton.addEventListener('click', function() {
      deliveryAddresses[0].deliveryAddress = setConfirmedAddress(confirmedAddress, deliveryAddress);
      handleShippingAddressModalActions(deliveryAddresses, deliveryGroupIndex, deliveryGroups);
    });

    var submitButton = $(getClassSelector(SELECTORS.MULTISHIP_SHIPPING_ADDRESS_FORM_SUBMIT));
    submitButton.on('click', function(e) {
      if (submitButton.hasClass('ms-confirm-original-address')) {
        e.preventDefault();
        // use current input values incase user has made changes
        var $modal = $(getClassSelector(SELECTORS.MULTISHIP_SHIPPING_ADDRESS_MODAL));
        var deliveryAddresses = [
          {
            deliveryAddress: {
              address1: $modal.find('#ms-address1').val(),
              address2: $modal.find('#ms-address2').val(),
              city: $modal.find('#ms-city').val(),
              country: $modal.find('#ms-country').val(),
              firstName: $modal.find('#ms-firstName').val(),
              lastName: $modal.find('#ms-lastName').val(),
              phone: $modal.find('#ms-phone').val(),
              province: $modal.find('#ms-province').val(),
              zip: $modal.find('#ms-zip').val()
            }
          }
        ];
        handleShippingAddressModalActions(deliveryAddresses, deliveryGroupIndex, deliveryGroups);
      }
    });
  }

  function setConfirmedAddress(confirmedAddress, originalAddress) {
    if (confirmedAddress) {
      originalAddress.address1 = (confirmedAddress.address1 || originalAddress.address1).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      originalAddress.address2 = confirmedAddress.address2 || originalAddress.address2;
      originalAddress.city = confirmedAddress.city || originalAddress.city;
      originalAddress.province = confirmedAddress.province || originalAddress.province;
      originalAddress.zip = confirmedAddress.zip || originalAddress.zip;
    }
    return originalAddress;
  }

  function removeDiacritics(input) {
    if (input) {
      return input
        .normalize("NFD") // Normalize to decompose characters
        .replace(/[\u0300-\u036f]/g, ""); // Remove diacritical marks      
    }
  }

  function removeNonAlphanumeric(input) {
    return input
      .replace(/[^0-9A-Za-z.!?,()' ]+/g, "") // Allow specified punctuation characters
      .replace(/\s+/g, " ") // Replace multiple spaces with a single space
      .trim(); // Remove leading and trailing spaces
  }

  function giftNoteValidation() {
    const textAreas = document.querySelectorAll('[id^="giftnote_"].multiship-cartItem-giftnote'); // Select elements with IDs starting with "giftnote_" and the class

    if (textAreas.length > 0) {
      textAreas.forEach((textArea) => {
        textArea.addEventListener("blur", (event) => {
          const currentTextArea = event.target; // Target the specific textarea
          const unclean = currentTextArea.value;
          if (unclean) {
            // Use helper functions to clean the input
            const cleaned = removeNonAlphanumeric(removeDiacritics(unclean));  
            // Update the textarea value
            currentTextArea.value = cleaned;
            // Dispatch a custom event to update the character count
            currentTextArea.dispatchEvent(new Event("updateCharCount"));
          }
        });
      });
    }
  }

  function giftNoteCharCount() {
    const textAreas = document.querySelectorAll('[id^="giftnote_"].multiship-cartItem-giftnote'); // Select elements with IDs starting with "giftnote_" and the class

    if (textAreas.length > 0) {
      textAreas.forEach((textArea) => {
        const maxLength = parseInt(textArea.getAttribute("maxlength"), 10) || 150; // Default to 150 if maxlength is not set

        // Ensure the .action--multiship--charcount element exists and is correctly selected
        const nextSibling = textArea.nextElementSibling;
        const charCount = nextSibling && nextSibling.classList.contains("action--multiship--charcount")
          ? nextSibling
          : null;

        if (!charCount) {
          return; // Skip this textarea if no .charCount exists
        }

        // Helper function to update the character counter
        const updateCharCount = () => {
          const remaining = maxLength - textArea.value.length;
          charCount.textContent = `${remaining} characters remaining`;
        };

        // Initialize the counter with the initial value of the textarea
        updateCharCount();

        // Update character counter on input and custom 'updateCharCount' event
        textArea.addEventListener("input", updateCharCount);
        textArea.addEventListener("updateCharCount", updateCharCount);
      });
    }
  }

  function createTestObserver(selector, testClass, callback) {
    const targetElement = document.querySelector(selector);

    if (!targetElement) {
      callback(false);
      return false;
    }

    if (targetElement.classList.contains(testClass)) {
      callback(true);
      return true;
    } else {
      const observer = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (mutation.target.classList.contains(testClass)) {
              observer.disconnect();
              callback(true);
            }
          }
        });
      });

      observer.observe(targetElement, { attributes: true }); // Observe attribute changes
    }

    callback(false);
    return false;
  }

  function renderPDPVideo() {
    const frameDetails = window.getFrameDetailsByColor(activeFrame);
    var hasVideo = frameDetails.hasVideo;

    if (hasVideo) {
      displayVideoPDPThumbs(frameDetails);
      displayVideoPDP(frameDetails);
    }
  }

  function updateMediaElements(elements, videoSources, settings, pictureIndex = 0) {
    if (!elements || !settings || !Array.isArray(settings)) return;

    settings.forEach(index => {
      const element = elements[index];
      if (!element) return;

      const elementPictures = element.querySelectorAll('picture');
      const elementVideo = element.querySelector('video');

      if (elementPictures[pictureIndex]) {
        elementPictures[pictureIndex].style.display = 'none';
      }

      if (elementVideo) {
        const { sources, poster } = videoSources[index];
        videoDataSrc(elementVideo, sources, poster);
      }
    });
  }


  function updateMediaElementsHP(element, elToUpdate, videoSources, pictureIndex = 0) {
    if (!element) return;

    //get picture and video elements
    const elementPictures = element.querySelectorAll('picture');
    const elementVideo = element.querySelector('video');

    if (elToUpdate === 'video'){
      if (elementVideo) {
        const { sources, poster } = videoSources;
        //check if the video already has sources, if so just change display
        const currentVideoSources = Array.from(elementVideo.querySelectorAll('source'));
        if (currentVideoSources.length === 0){
          //if no video sources, create them
          videoDataSrc(elementVideo, sources, poster);
        } else {
          elementVideo.classList.add('video-loaded');
        }
        if (isMobile()){
          elementVideo.classList.add('mobile-visible');
          elementVideo.classList.remove('mobile-hidden');
        }
      }

      if (elementPictures) {
        //when showing videos, hide image unless in the frameset category
        elementPictures.forEach((pictureElement, index) => {
          let sources = Array.from(pictureElement.querySelectorAll('source[srcset], img[src]'));
          let isFrameSet = sources.some((source) => {
            return source.src.includes('frame_set') || source.srcset.includes('frame_set');
          });
          if (!isFrameSet && index == pictureIndex) {
            pictureElement.classList.add('hide-image')
          }
        })
      }
    }
    //toggling back to still images
    if (elToUpdate === 'image'){
      //hide video elements
      if (elementVideo) {
        elementVideo.classList.remove('mobile-visible', 'video-loaded')
        elementVideo.classList.add('mobile-hidden');
      }
      //unhide image elements
      if (elementPictures) {
        elementPictures[0].classList.add('show-image');
        elementPictures[0].classList.remove('hide-image');
      }
    }
  }

  function displayVideoPDPThumbs(frameDetails) {

    const videoSources = {
      2: {
        sources: [
          { src: frameDetails.pdpVideoThumbFirstMp4, type: 'video/mp4' }
        ],
        poster: frameDetails.pdpVideoThumbPosterFirst
      },
      4: {
        sources: [
          { src: frameDetails.pdpVideoThumbSecondMp4, type: 'video/mp4' }
        ],
        poster: frameDetails.pdpVideoThumbPosterSecond
      }
    };

    Array.from($thumbnailContainers).forEach(function(thumbnailContainer) {
      var thumbnailImagesContainers = thumbnailContainer.querySelectorAll('.action--thumbnail-container')
      updateMediaElements(thumbnailImagesContainers, videoSources, [2, 4], 0);
    });
  }

  function displayVideoPDP(frameDetails) {

    const images = document.querySelectorAll('.action-image-selector--main-image--container');
    const videoSources = {
      2: {
        sources: [
          { src: frameDetails.pdpVideoFirstMp4, type: 'video/mp4' }
        ],
        poster: frameDetails.pdpVideoPosterFirst
      },
      4: {
        sources: [
          { src: frameDetails.pdpVideoSecondMp4, type: 'video/mp4' }
        ],
        poster: frameDetails.pdpVideoPosterSecond
      }
    };

    updateMediaElements(images, videoSources, [2, 4], 0);
  }

  function videoDataSrc(video, sources, posterImage) {
    // Clear current video sources
    video.innerHTML = '';
    //set poster image
    video.setAttribute('poster', posterImage);
    //create each source and append to video element
    sources.forEach(({ src, type }) => {
      const videoSource = document.createElement('source');
      videoSource.setAttribute('src', src);
      videoSource.setAttribute('type', type);
      video.appendChild(videoSource);
    });
    video.load()
    //add video-loaded class to unhide video
    video.classList.add('video-loaded')
  }

  function hpVideoBanner(product) {
    const videoElement = document.querySelector(`.action--${product}-video-banner`);

    // Ensure videoElement exists
    if (!videoElement) return;

    const isMobile = window.matchMedia('(max-width: 40em)').matches;
    const mp4Src = isMobile && videoElement.dataset.mp4MobileSrc
      ? videoElement.dataset.mp4MobileSrc
    : videoElement.dataset.mp4Src;

    const videoSources = [
      { src: mp4Src, type: 'video/mp4' }
    ];

    const renderVideoBanner = () => {
      // Set video source elements
      videoSources.forEach(source => {
        const sourceElement = document.createElement('source');
        sourceElement.src = source.src;
        sourceElement.type = source.type;
        videoElement.appendChild(sourceElement);
      });

      videoElement.load(); // Load the video after setting the sources
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          renderVideoBanner();
          observer.unobserve(videoElement);  // Stop observing after video is loaded
        }
      });
    });

    observer.observe(videoElement);
  }

  function hideBopisBannerOnClay(color) {
    const bopisBanner = document.querySelector('.product-section__bopis');
    if (bopisBanner) {
      if (color === 'carver-clay-mat' || color === 'walden-clay-mat') {
        bopisBanner.classList.add('hide');
      }
      else if ((color === 'carver-mat' || color === 'walden-ink-mat') && bopisBanner.classList.contains('hide')) {
        bopisBanner.classList.remove('hide');
      }
    }
  }

  function renderProductInfoTabs () {
    var product_info_tabs = $(getClassSelector(SELECTORS.PRODUCT_INFO_TAB))
    var product_info_tab_panels = $(getClassSelector(SELECTORS.PRODUCT_INFO_TAB_PANEL))

    product_info_tabs.each(function (index, tab) {
      tab.addEventListener('click', function () {
        var tabValue = tab.getAttribute('data-tab-value');

        product_info_tabs.each(function (i, t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');

        product_info_tab_panels.each(function (i, panel) {
          var panelValue = panel.getAttribute('data-tab-value');
          if (panelValue === tabValue) {
            panel.classList.remove('hide');
            panel.setAttribute('tabindex', '0');
            panel.removeAttribute('inert');
            const firstFocusableElement = panel.querySelector('li, p');
            if (firstFocusableElement) {
              firstFocusableElement.focus();
            } else {
              panel.focus();
            }

          } else {
            panel.classList.add('hide');
            panel.setAttribute('tabindex', '-1');
            panel.setAttribute('inert', '');
          }
        });
      });
    });
  }

  function toggleAccordion() {
    var acc = document.getElementsByClassName("action--product-page__faq--accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        this.classList.toggle("active");

        var isExpanded = this.getAttribute("aria-expanded") === "true";
        this.setAttribute("aria-expanded", !isExpanded);
        this.setAttribute("aria-hidden", isExpanded);

        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    }
  }

  function showLoadingDots(textToHideClass, loaderClass) {
    const  textToHide = document.querySelectorAll(textToHideClass);
    if (textToHide.length) {
      textToHide.forEach(text => {
        text.classList.add('hide')
      })
    }
    const loader = document.querySelector(loaderClass)
    if (loader) {
      loader.classList.remove('hide')
    }
  }

  async function renderInStorePickupPage(){
    let selectedFrame = document.querySelector('.in-store-pickup__radio').value;

    let selectedStore = null
    let postalCodeInput = document.querySelector('.action--in-store-pickup-postal-code').value;
    const checkoutButton = document.querySelector('.action--in-store-pickup-checkout');

    const selectedFrameRadios = document.querySelectorAll('input[name="inStorePickUp_product"]');
    //add event listener to frames, and update if new frame is selected
    selectedFrameRadios.forEach(radioBtn => {
      radioBtn.addEventListener('change', (event) => updateSelectedFrame(event, selectedStore))
    })

    const zipInput = document.querySelector('.action--in-store-pickup-postal-code');
    zipInput.addEventListener('keydown', function(event) {
      if (event.key === 'Enter') {
        showLoadingDots('.action--check-availability-text','.action--in-store-pickup-availability-loader')
        postalCodeInput = document.querySelector('.action--in-store-pickup-postal-code').value;
        // set cookie for postal code if it has changed
        setNewPostalCodeCookie(postalCodeInput);
        sendBopisAnalytics('bopis_lp_zip_submit', { zip_input: postalCodeInput });
      }
    })
    zipInput.addEventListener("input", function () {
      //allow only numbers on input
      this.value = this.value.replace(/\D/g, '');
    });

    // Check for the delivery_postal_code cookie and populate the input if it exists
    const deliveryPostalCode = getCookie('delivery_postal_code');
    if (deliveryPostalCode) {
      document.querySelector('.action--in-store-pickup-postal-code').value = deliveryPostalCode;
      //populate inital stores if we have a zipcode
      updateInStorePickupOptions([{"sku":selectedFrame,"quantity":1}], deliveryPostalCode);
    }

    // fetch BOPIS stores based on zip input
    document.querySelector('.action--in-store-pickup-postal-code-btn').addEventListener('click', function() {
      showLoadingDots('.action--check-availability-text','.action--in-store-pickup-availability-loader')
      postalCodeInput = document.querySelector('.action--in-store-pickup-postal-code').value;
      // set cookie for postal code if it has changed
      setNewPostalCodeCookie(postalCodeInput);
      sendBopisAnalytics('bopis_lp_zip_submit', { zip_input: postalCodeInput });
    });

    function showLoadingDots(textToHideClass, loaderClass) {
      const  textToHide = document.querySelector(textToHideClass);
      if (textToHide) {
        textToHide.classList.add('hide')
      }
      const loader = document.querySelector(loaderClass)
      if (loader) {
        loader.classList.remove('hide')
      }
      hideBopisResults();
    }

    function hideLoadingDots(textToShowClass, loaderClass) {
      const  textToShow = document.querySelector(textToShowClass);
      if (textToShow) {
        textToShow.classList.remove('hide')
      }
      const loader = document.querySelector(loaderClass)
      if (loader) {
        loader.classList.add('hide')
      }
      showBopisResults();
    }

    function showBopisResults() {
      const results = document.querySelector('.action--in-store-pickup-results');
      if (results) {
        results.style.opacity = '1';   
      }
    }

    function hideBopisResults() {
      const results = document.querySelector('.action--in-store-pickup-results');
      if (results) {
        results.style.opacity = '0';   
      }
    }

    function updateInStorePickupOptions(lineItems, postalCodeInput) {
      const inStorePickupStoreSelector = $(getClassSelector(SELECTORS.IN_STORE_PICKUP_STORE_SELECTOR_CONTAINER));
      //reset selected store to null so checkout button becomes disabled
      selectedStore = null
      updateBopisCheckoutButton(selectedStore);
      fetchBopisAvailability(lineItems, postalCodeInput).then(async (response) => {
        if (response && response.stores) {
          updateLocalBopisStores(response.stores);
          renderInStorePickupStoreOptions(response.stores, inStorePickupStoreSelector, checkoutButton)
          //update selected store based on store selection
          const selectedStoreRadios = document.querySelectorAll('.action--in-store-pickup__store-selector-location');
          selectedStoreRadios.forEach(radioBtn => {
            radioBtn.addEventListener('change', (event) => updateSelectedStore(event))
          });
        } else {
          // show no stores found msg, hide checkout button
          inStorePickupStoreSelector.find('.action--in-store-pickup__store-selector-new-location').parent().parent().remove();
          document.querySelector('.action--in-store-pickup__no-stores').classList.remove('hide');
          if (!checkoutButton.classList.contains('hide')) {
            checkoutButton.classList.add('hide');
          }
        }
        hideLoadingDots('.action--check-availability-text', '.action--in-store-pickup-availability-loader');
      }).catch((error) => {
        console.error('Error fetching BOPIS availability:', error);
        airbrake.notify({
          error: `Error fetching BOPIS availability: ${selectedFrame} with quantity: ${quantity}`,
          context: { component: 'BOPIS' },
          params: { color: selectedFrame, quantity: 1 }
        });
      });
    }
    function setNewPostalCodeCookie(postalCodeInput) {
      if (postalCodeInput !== deliveryPostalCode) {
        setCookie('delivery_postal_code', postalCodeInput, null, `.${window.location.hostname}`);
      }
      if (postalCodeInput) {
        const lineItems = [{"sku":selectedFrame,"quantity":1}]
        updateInStorePickupOptions(lineItems, postalCodeInput)
      }
    }

    function updateSelectedStore(event){
      //gets value on selected store on in store pickup page
      selectedStore = event.target.value;
      updateBopisCheckoutButton(selectedStore);
      inStorePickUpCheckoutButtonListener(selectedStore);
      sendBopisAnalytics('bopis_lp_selected_store', { locationIds: selectedStore })
    }

    //when user selects a new frame, render new store options
    function updateSelectedFrame(event){
      showLoadingDots('.action--check-availability-text','.action--in-store-pickup-availability-loader');
      selectedFrame = event.target.value;
      updateInStorePickupOptions([{"sku":selectedFrame,"quantity":1}], postalCodeInput);
      sendBopisAnalytics('bopis_lp_selected_frame', { frameSku: selectedFrame })
    }

    function inStorePickUpCheckoutButtonListener(selectedStore){
      checkoutButton.addEventListener('click', async function(event){
        event.preventDefault();
        const checkoutText = document.querySelector('.action--in-store-pickup-checkout-text')
        checkoutText.classList.add('hide')
        const checkoutLoader = document.querySelector('.action--in-store-pickup-checkout-loader')
        checkoutLoader.classList.remove('hide')
        let skuToColor = window.getColorBySku(selectedFrame);
        if (skuToColor) {
          const updatedCart = await addToCartPickupInStore(skuToColor, 1);
          if (updatedCart) {
            const bopisUpdate = await selectBopisStoreById(selectedStore);
            if (bopisUpdate) {
              updateBopisCheckoutButton(selectedStore);
              sendBopisAnalytics('bopis_lp_checkout', { value: true });
              logGA4Event('add_to_cart', {
                currency: getLocaleCurrency(),
                value: parseInt(updatedCart.cost.subtotalAmount.amount),
                items: [buildAnalyticsCartItem(COLORS[skuToColor], 1)]
              });
              logPavedEvent('add_to_cart', {
                currency: getLocaleCurrency(),
                value: parseInt(updatedCart.cost.subtotalAmount.amount),
                items: [JSON.stringify(buildAnalyticsCartItem(COLORS[skuToColor], 1))]
              });
              window.location.href = cartCheckoutUrl(bopisUpdate);
            }
          }
        }
      })
    }

    function updateBopisCheckoutButton(selectedStore){
      const checkoutButton = document.querySelector('.action--in-store-pickup-checkout');

      checkoutButton.toggleAttribute('disabled', !(selectedStore && selectedFrame));
      checkoutButton.classList.toggle('disabled', !(selectedStore && selectedFrame));

      var cart = getSavedShopifyCart();
      if (cart) {
      var checkoutUrl = cartCheckoutUrl(cart);
        checkoutButton.href = checkoutUrl;
      }
    }

    async function addToCartPickupInStore(color, quantity) {
      // delete existing cart from local storage
      clearCart();

      // create a new cart
      setQuantity(color, quantity);
      const updatedCart = await createShopifyCart({[color]: {quantity: quantity}});
      if (updatedCart) {
        return updatedCart;
      } else {
        console.error('Failed to create cart for: ' + color + ' with quantity: ' + quantity);
        airbrake.notify({
          error: `Error creating cart on BOPIS LP for: ${color} with quantity: ${quantity}`,
          context: { component: 'BOPIS' },
          params: { color: color, quantity: quantity }
        });
      }
    }
  }

  async function getCookieSetCartAttribute(experimentCookie) {
    const cookieValue = getCookie(experimentCookie);
    if (cookieValue) {
      await setCartAttributes([{ key: experimentCookie, value: 'true' }]);
    }
  }

  async function setCartAttributes(attributes) {
    const cartId = getShopifyCartId();
    if (cartId && attributes && attributes.length > 0) {
      await updateShopifyCartAttributes(attributes, cartId);
    }
  }

  function openAccordion(element) {
    element.classList.add('active');

    const fullHeight = element.scrollHeight;
    element.style.height = fullHeight + 'px';

    element.addEventListener('transitionend', function handleTransitionEnd(e) {
      if (e.propertyName === 'height') {
        element.style.height = 'auto';
        element.removeEventListener('transitionend', handleTransitionEnd);
      }
    });
  }

  function closeAccordion(element) {
    const currentHeight = element.scrollHeight;
    element.style.height = currentHeight + 'px';

    element.offsetHeight; // force reflow

    element.style.height = '0px';
    element.addEventListener('transitionend', function handleTransitionEnd(e) {
      if (e.propertyName === 'height') {
        element.classList.remove('active');
        element.removeEventListener('transitionend', handleTransitionEnd);
      }
    });
  }

  function toggleHowItWorksAccordion(event) {
    const header = event.currentTarget;
    const targetId = header.dataset.target;
    const target = document.getElementById(targetId);

    if (!target) return;

    const isAlreadyOpen = target.classList.contains('active');

    // Open if it wasn't already open
    if (!isAlreadyOpen) {
      // Close all
      document.querySelectorAll('.how-it-works__accordion-content.active').forEach(el => {
        closeAccordion(el);
      });
      openAccordion(target);
    }

    // Load new media on desktop
    if (!isMobile()){
      updateHowItWorksMedia(header);
    }
  }

  function updateHowItWorksMedia(header) {
    const mediaWrapper = document.querySelector('.action--how-it-works__image-wrapper');
    mediaWrapper.innerHTML = '';

    const imagePathDesktop = header.dataset.imagedesktop;
    const imagePathDesktopWebp = header.dataset.imagedesktopwebp;
    const videoPathDesktop = header.dataset.videodesktop;
    const videoPathPoster = header.dataset.videoposter;
    const mediaType = header.dataset.mediatype;

    if (mediaType === 'video') {
      const video = document.createElement('video');
      video.setAttribute('autoplay', 'true');
      video.setAttribute('muted', 'true');
      video.setAttribute('playsinline', 'true');
      video.setAttribute('loop', 'true');
      video.setAttribute('poster', videoPathPoster);
      video.setAttribute('id', 'how-it-works-video');
      video.classList.add('how-it-works__image');

      const sourceDesktop = document.createElement('source');
      sourceDesktop.src = videoPathDesktop;
      sourceDesktop.media = '(min-width: 40.1rem)';
      sourceDesktop.type = 'video/mp4';

      video.appendChild(sourceDesktop);
      mediaWrapper.appendChild(video);
      let ariaButton = document.createElement('button')
      ariaButton.setAttribute("aria-controls", "how-it-works-video")
      ariaButton.setAttribute("aria-pressed", "false")
      ariaButton.setAttribute("aria-label", "Pause background video")
      ariaButton.classList.add('a11y-pause-button', 'video-pause-toggle', 'action--video-pause-toggle', 'absolute', 'z1')
      let ariaPauseIcon = document.createElement('span')
      ariaPauseIcon.ariaHidden="true"
      ariaPauseIcon.classList.add('video-pause-icon')
      ariaButton.appendChild(ariaPauseIcon);
      mediaWrapper.appendChild(ariaButton);
      ariaButton.addEventListener('click', function() {
        if (video.paused) {
          video.play();
          ariaButton.setAttribute('aria-pressed', 'false');
          ariaButton.setAttribute('aria-label', 'Pause background video');
          ariaButton.classList.remove('is-paused');
        } else {
          video.pause();
          ariaButton.setAttribute('aria-pressed', 'true');
          ariaButton.setAttribute('aria-label', 'Play background video');
          ariaButton.classList.add('is-paused');
        }
      });

    } else {
      const picture = document.createElement('picture');
      picture.classList.add('how-it-works__image');

      const sourceDesktopWebp = document.createElement('source');
      sourceDesktopWebp.srcset = imagePathDesktopWebp;
      sourceDesktopWebp.media = '(min-width: 40.1rem)';
      sourceDesktopWebp.type = 'image/webp';
      picture.appendChild(sourceDesktopWebp);

      const sourceDesktop = document.createElement('source');
      sourceDesktop.srcset = imagePathDesktop;
      sourceDesktop.media = '(min-width: 40.1rem)';
      sourceDesktop.type = 'image/jpeg';
      picture.appendChild(sourceDesktop);

      const img = document.createElement('img');
      img.src = imagePathDesktop;
      img.alt = 'How it works image';
      picture.appendChild(img);

      mediaWrapper.appendChild(picture);
    }
  }

  function renderHowItWorksSection() {
    const headers = document.querySelectorAll('.action--how-it-works__accordion-header');
    headers.forEach(header => {
      header.addEventListener('click', toggleHowItWorksAccordion);
    });
  }

  function toggleMobileSwiperDots() {
    const wrappers = document.querySelectorAll("[data-scroll-wrapper]");

    wrappers.forEach(wrapper => {
      const container = wrapper.querySelector("[data-scroll-container]");
      const imgs = wrapper.querySelectorAll(".scroll-item");
      const dots = wrapper.querySelectorAll(".dot");
      let hasInteracted = false;

      if (container) {
        container.addEventListener('scroll', () => {
          hasInteracted = true;
        });
      }

      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const index = Array.from(imgs).indexOf(entry.target);
              dots.forEach((dot, i) => {
                dot.classList.toggle("active", i === index);
              });
              if (hasInteracted) {
                logGA4Event('pdp_mobile_swipe', {});
              }
            }
          });
        },
        {
          root: container,
          threshold: 0.6
        }
      );

      imgs.forEach(item => observer.observe(item));
    });
  }

  function hideAddToCartAtFooter() {
    //hides sticky add to cart on PDP so footer links aren't blocked
    const footer = document.querySelector(".footer");
    const addToCartBtn = document.querySelector(".action--purchase-options--add-to-cart");

    if (footer && addToCartBtn) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              addToCartBtn.classList.add("hidden");
            } else {
              addToCartBtn.classList.remove("hidden");
            }
          });
        },
        { threshold: 0 }
      );

      observer.observe(footer);
    }
  };

  function logFrameLineupClickEvent() {
    let frameLineupBanner = document.querySelector('.action--frame-lineup');
    if (!frameLineupBanner) {
      return;
    } else {
      let bubbles = frameLineupBanner.querySelectorAll('.action--bubble');
      bubbles.forEach(bubble => {
        bubble.addEventListener("click", () => {
          const selectedProduct = bubble.dataset.product;
          logGA4Event('frame-lineup-banner-click', { product: selectedProduct });
        });
      });
    }
  }

  function renderGiftingPageShopping() {
    let scrollContainer = document.querySelector(".action--gifting-page--cards.active");
    const proxyBar = document.querySelector(".action--gifting-page--scroll-bar-proxy");
    const cards = document.querySelectorAll(".action--gifting-page--card");
    const giftNoteCheckoutBox = document.querySelector(".action--gifting-page-gift-note-checkout");
    const addGiftBtn = document.querySelector(".action--gifting-page-add-gift-to-cart-btn");
    const giftNoteInput = document.querySelector('.action--gifting-page-note-input');
    const cartSection = document.querySelector(".action--gifting-page-cart-section");
    const giftPageCtas = document.querySelector('#gifting-ctas');
    let collectiveCards = null;
    if (!cards || !scrollContainer || !proxyBar || !cartSection || !giftNoteInput) {
      return;
    }
    let gift = {};
    const cartQuantity = getCartItemCount();
      if (cartQuantity == 1) {
        applySelectionFromCart();
      } else {
        clearAllSelections();
      }
    function buildCollectiveSectionCards(data) {
      const collectiveSection = document.getElementById('gift-builder--collective');
      if (!collectiveSection) return;
      collectiveSection.classList.remove('display-none');

      const cardWrapper = document.querySelector('.action--gifting-collective-cards');
      if (!cardWrapper) return;
      cardWrapper.innerHTML = ''

      data.forEach((variant, index) => {

        const variantClass = getMetafieldValue(variant.metafields, 'class');
        const color = getMetafieldValue(variant.metafields, 'color');
        const title = variant.title;
        const price = variant.price;
        const collectivePartner = getMetafieldValue(variant.metafields, 'category');


        const cardContainer = document.createElement('div');
        cardContainer.className = 'gift-shopping__card-container action--gifting-page--bundle-cards';

        const label = document.createElement('label');
        label.className = 'm2 xs-m2 height-100 border-box flex flex-column bundle__card box-shadow-border relative';
        label.setAttribute('for', variantClass);

        const input = document.createElement('input');
        input.type = 'checkbox';
        input.id = variantClass;
        input.className = 'gift-shopping__radio action--collective-card-checkbox';
        input.name = 'collective';
        input.value = color;
        input.disabled = true;

        const imageContainer = document.createElement('div');
        imageContainer.className = 'gift-shopping__card-image-container relative border-box';
      
        const quickViewWrapper = document.createElement('div');
        quickViewWrapper.className = 'product-quick-view-btn--wrapper action--collective-quickview-wrapper width-100 p2 border-box height-auto justify-center absolute bottom-0 left-0 right-0';
        const quickViewBtn = document.createElement('button');
        quickViewBtn.className = 'product-quick-view-btn-overlay width-100 px1 py1 border-box justify-center flex sans-pro-medium aura-black action--collective-quick-view-btn';
        quickViewBtn.textContent = cardWrapper.dataset.learnMoreButton;;
        quickViewBtn.dataset.color = color;
        quickViewBtn.dataset.atc = 'false';
        quickViewBtn.dataset.location = 'gifting-page';
        quickViewBtn.disabled = true;
        quickViewBtn.addEventListener('click', function (event) {
          event.stopPropagation();
          event.preventDefault();
          openCollectiveProductPreview(collectivePartner, variant);
        });
        
        quickViewWrapper.appendChild(quickViewBtn);

        const picture = document.createElement('picture');
        picture.appendChild(quickViewWrapper);

        if (variant.image && variant.image.webp) {
          const webpSource = document.createElement('source');
          webpSource.srcset = variant.image.webp;
          webpSource.type = 'image/webp';
          picture.appendChild(webpSource);
        }

        const img = document.createElement('img');
        img.src = variant.image && variant.image.jpg ? variant.image.jpg : '';
        img.width = 200;
        img.height = 200;
        img.alt = title || '';
        img.className =
          'action--gift-shopping-card-image card-image product-image product-image--';

        picture.appendChild(img);
        imageContainer.appendChild(picture);

        const details = document.createElement('div');
        details.className = 'gift-shopping__product-details justify-between height-100';

        const detailsInner = document.createElement('div');
        detailsInner.className = 'flex flex-column';

        const titleEl = document.createElement('p');
        titleEl.className = 'header--4 my0 collective-card-title';
        titleEl.textContent = title;

        const priceEl = document.createElement('p');
        priceEl.className = 'body-copy--medium--3 m0 collective-card-price';
        priceEl.textContent = `$${price}`;
    
        const description = document.createElement('span');
        description.className = 'body-copy--1';
        description.textContent = cardWrapper.dataset.oneliner;

        detailsInner.appendChild(titleEl);
        detailsInner.appendChild(priceEl);
        detailsInner.appendChild(description);
        details.appendChild(detailsInner);

        label.appendChild(input);
        label.appendChild(imageContainer);
        label.appendChild(details);

        cardContainer.appendChild(label);
        cardWrapper.appendChild(cardContainer);
      })

      collectiveCards = document.querySelectorAll('.action--gifting-page--bundle-cards');
      const collectiveSpecsContainer = document.getElementById('collective-specs-gallery');
      renderCollectiveSpecs({
        container: collectiveSpecsContainer,
        variant: data[0]
      })
    }

    function handleCollectiveProductSelect(collectiveCards) {
      gift.selectedCollectives = gift.selectedCollectives || [];

      collectiveCards.forEach(card => {
        const checkboxInput = card.querySelector('.action--collective-card-checkbox');
        if (!checkboxInput) return;

        checkboxInput.addEventListener("change", (event) => {
          const selectedValue = event.target.value;

          if (event.target.checked) {
            if (gift.selectedCollectives.indexOf(selectedValue) === -1) {
              gift.selectedCollectives.push(selectedValue);
            }
            
            logGA4Event('gifting-page--collective-product-selected', {
              'product': selectedValue
            });
            // Scroll to note section
            const noteSection = document.querySelector(".action--gifting-page-add-note-section");
            if (noteSection) {
              scrollToNextSection(noteSection);  
            }
          } else {
            gift.selectedCollectives = gift.selectedCollectives.filter(function(value) {
              return value !== selectedValue;
            });
          }
        })
      })
    }
    function enableGiftNoteSection(selectedValue){
      gift.selectedColor = selectedValue;
      addGiftBtn.readOnly = false;
      giftNoteInput.readOnly = false;
    }
    function enableUpsellSection(){
      const upsellSection = document.querySelector('.action--collective-upsell-section-section');
      if (upsellSection) {
        upsellSection.style.opacity = 1;
        const collectiveCheckboxes = upsellSection.querySelectorAll('.action--collective-card-checkbox');
        collectiveCheckboxes.forEach(input => {
          input.disabled = false;
        })
        const quickViewBtns = document.querySelectorAll('.action--collective-quick-view-btn');
        quickViewBtns.forEach(btn => {
          btn.disabled = false;
        })
      }
    }
    function handleGiftProductSelect(card) {
      const radioInput = card.querySelector('.action--gift-shopping-product-option');
      if (!radioInput) return;

      radioInput.addEventListener("change", (event) => {
        if (event.target.checked) {
          event.preventDefault();
          const selectedValue = event.target.value;
          const selectedFrameCollection = event.target.dataset.collection;
          const previouslySelected = gift.selectedColor;
          const frameSpecsContainer = document.querySelector('.aura-frame--specs-gallery');

          if (previouslySelected){
            addGiftBtn.textContent = giftPageCtas.dataset.atc;
          }

          // Sync all matching radios across sections
          const allMatchingRadios = document.querySelectorAll(
            `.action--gift-shopping-product-option[value='${selectedValue}']`
          );
          allMatchingRadios.forEach((radio) => {
            radio.checked = true;
          });

          logGA4Event('gifting-page--product-selected', {
            'product': selectedValue
          })
          enableUpsellSection();
          
          renderFrameSpecs({
            container: frameSpecsContainer,
            frame: selectedFrameCollection
          })
          enableGiftNoteSection(selectedValue);
          handleGiftNoteInput();
          // Scroll to next section - for testing scroll to upsell if exists, otherwise scroll to notes
          let noteSection = document.querySelector(".action--gifting-page-add-note-section");
          let upsellSection = document.querySelector("#gift-builder--collective");

          if (
            upsellSection &&
            !upsellSection.classList.contains("display-none")
          ) {
            scrollToNextSection(upsellSection);
          } else if (noteSection) {
            scrollToNextSection(noteSection);
          }
          handleAddToCartClick();
        }
      });

      card.addEventListener("click", (event) => {
        if (event.target === radioInput) return;
        if (!radioInput.checked) {
          radioInput.checked = true;
          radioInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
    function handleGiftNoteInput() {
      const textarea = document.getElementById("gift-note-message");
      if (!textarea) return;

      textarea.addEventListener("input", (e) => {
        gift.note = e.target.value;
      });

      textarea.addEventListener("blur", (e) => {
        const unclean = gift.note;
        if (unclean) {
          const cleaned = removeNonAlphanumeric(removeDiacritics(unclean));  
          e.target.value = cleaned;
          gift.note = cleaned
          logGA4Event('gifting-page--gift-note-added', {})
        }
      })
    }
    function handleAddToCartClick() {
      if (!addGiftBtn) return;
      addGiftBtn.addEventListener("click", () => {
        clearCart();
        addGiftToCart(gift)
        if (gift.note != undefined) {
          setGiftNoteInCart(gift.note);
        }
        logGA4Event('gifting-page--add-to-cart', {
          'product': gift.selectedColor
        })
        cartSection.style.opacity = 1;
        cartSection.setAttribute('aria-hidden', 'false');
        cartSection.setAttribute('tabindex', '0');
        cartSection.removeAttribute('inert');
        scrollToNextSection(cartSection);

        setTimeout(() => {
          addGiftBtn.textContent = giftPageCtas.dataset.updateGift;
        }, 550)
      })
    }
    function setGiftNoteInCart(note){
      if (!giftNoteCheckoutBox || !giftNoteInput) return;
      giftNoteCheckoutBox.textContent = note;
      giftNoteInput.textContent = note;
    }
    async function addGiftToCart(gift) {
      await addQuickFrameToCart(gift.selectedColor, 1, gift.note);
    }
    function giftingCheckoutBtnListener() {
      let giftingCheckoutBtn = document.querySelector('.action--cart-checkout-gifting-page');
      if (!giftingCheckoutBtn) return;

      giftingCheckoutBtn.addEventListener("click", () => {
        logGA4Event('gifting-page--checkout', {
          product: gift.selectedColor
        })
      })
    }
    function renderFrameSpecs({container, frame}) {
      if (!container || !frame) return;

      let frameSpecDetails = document.getElementById('frame-specs');

      const translations = {
        dualOrientation: frameSpecDetails.dataset.dualOrientation,
        displayTemplate: frameSpecDetails.dataset.displayTemplate,
        storage: frameSpecDetails.dataset.storage,
        autoOnOff: frameSpecDetails.dataset.autoOnOff,
        cordless: frameSpecDetails.dataset.cordless,
        photoPairing: frameSpecDetails.dataset.photoPairing,
        wallMount: frameSpecDetails.dataset.tableWall,
        csCamera: frameSpecDetails.dataset.csCamera,
        csMemory: frameSpecDetails.dataset.csMemory,
        csFlash: frameSpecDetails.dataset.csFlash,
        csSize: frameSpecDetails.dataset.csSize,
      };

      function interpolate(template, vars) {
        return template.replace(/%\{(\w+)\}/g, (_, key) => vars[key] || '');
      }
  
      const frameSpecsOrder = {
        "carver": ['display-horizontal', 'free-storage', 'photo-pairing', 'auto-on-off'],
        "carver-mat": ['display-horizontal', 'free-storage', 'photo-pairing', 'auto-on-off'],
        "aspen": ['display-vertical', 'free-storage', 'dual-orientation', 'auto-on-off'],
        "walden": ['display-vertical', 'free-storage', 'dual-orientation', 'auto-on-off'],
        "aura-ink":  ['display-vertical', 'dual-orientation', 'table-wall', 'cordless']
      }

      const frameDetails = {
        "carver" : {
          "size": '10"',
          "display": "LCD"
        },
        "carver-mat" : {
          "size": '10"',
          "display": "LCD"
        },
        "aspen" : {
          "size": '12"',
          "display": "LCD"
        },
        "walden" : {
          "size": '15"',
          "display": "LCD"
        },
        "aura-ink" : {
          "size": '13"',
          "display": "e-paper"
        },
      }
  
      const frameSpecs = {
        'display-horizontal': {
          icon: `<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M21.9425 18.3346L21.9425 7.44569C21.9425 6.58703 21.3222 5.89014 20.5578 5.89014L5.32707 5.89014C4.56277 5.89014 3.94246 6.58703 3.94246 7.44569L3.94246 18.3346C3.94246 19.1932 4.56277 19.8901 5.32707 19.8901L20.5578 19.8901C21.3222 19.8901 21.9425 19.1932 21.9425 18.3346Z" stroke="#131C27" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M14.363 17.176L17.593 17.176L17.593 13.946" stroke="#131C27" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8.29302 8.68541L17.593 17.1763" stroke="#131C27" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8.29206 11.8342L8.29206 8.60425L11.5221 8.60425" stroke="#131C27" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>`,
          text: (details) => {
            if (!details) return null;
            return interpolate(translations.displayTemplate, {
              size: details.size || 'Unknown size',
              display_type: details.display || 'HD'
            });
          }
        },
        'display-vertical': {
          icon: `<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.0432 14.0652L17.0432 17.2915L13.8132 17.2915" stroke="#131C27" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8.84187 8.48874L17.0431 17.2915" stroke="#131C27" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12.0719 8.48882L8.84193 8.48882L8.84193 11.7151" stroke="#131C27" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.49812 21.8901L18.387 21.8901C19.2457 21.8901 19.9426 21.2698 19.9426 20.5055L19.9426 5.27475C19.9426 4.51044 19.2457 3.89014 18.387 3.89014L7.49812 3.89014C6.63945 3.89014 5.94256 4.51044 5.94256 5.27475L5.94257 20.5055C5.94257 21.2698 6.63945 21.8901 7.49812 21.8901Z" stroke="#131C27" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          `,
          text: (details) => {
            if (!details) return null;
            return interpolate(translations.displayTemplate, {
              size: details.size || 'Unknown size',
              display_type: details.display || 'HD'
            });
          }
        },
        'free-storage': {
          icon: `<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_526_1283)">
          <path d="M12.9426 20.5436V14.2202" stroke="#131C27" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M15.5804 16.8505L12.95 14.2202L10.3197 16.8505" stroke="#131C27" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M18.2108 19.4887H18.7383C21.2707 19.4887 23.3584 17.5065 23.4714 14.9817C23.592 12.4569 21.6928 10.2788 19.1755 10.0527C18.6856 6.99275 16.0402 4.73926 12.9426 4.73926C9.84495 4.73926 7.19955 6.99275 6.70966 10.0527C4.19238 10.2788 2.29311 12.4569 2.4137 14.9817C2.53429 17.5065 4.62197 19.4962 7.14679 19.4887H7.67437" stroke="#131C27" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
          <defs>
          <clipPath id="clip0_526_1283">
          <rect width="24" height="24" fill="white" transform="translate(0.942566 0.890137)"/>
          </clipPath>
          </defs>
          </svg>`,
          text: () => translations.storage
        },
        'photo-pairing': {
          icon: `<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.9425 21.8901L12.9426 3.89014" stroke="#131C27" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <rect x="3.94257" y="3.89014" width="18" height="18" rx="2" stroke="#131C27" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>`,
          text: () => translations.photoPairing
        },
        'auto-on-off': {
          icon: `<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5736 4.5408C10.9687 4.42127 11.3973 4.54074 11.6736 4.84741C11.9499 5.15409 12.0241 5.59277 11.8641 5.97328C10.8446 8.26365 11.3418 10.9454 13.1145 12.7181C14.8873 14.4909 17.5691 14.9879 19.8594 13.9684C20.2399 13.8084 20.6786 13.8826 20.9853 14.1589C21.292 14.4352 21.4114 14.8637 21.2919 15.2588C20.085 19.1479 16.3064 21.6495 12.2548 21.2417C8.20311 20.834 4.99879 17.6297 4.59094 13.5781C4.1831 9.52645 6.68453 5.74786 10.5736 4.5408Z" stroke="#131C27" stroke-width="1.507" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          `,
          text: () => translations.autoOnOff
        },
        'dual-orientation': {
          icon: `<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.05368 9.89014H14.8315C15.4448 9.89014 15.9426 10.3037 15.9426 10.8132V20.9671C15.9426 21.4766 15.4448 21.8901 14.8315 21.8901H7.05368C6.44034 21.8901 5.94257 21.4766 5.94257 20.9671V10.8132C5.94257 10.3037 6.44034 9.89014 7.05368 9.89014Z" stroke="#131C27" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9.37676 5.58994L9.21675 5.42891L10.8111 7.03346L8.94256 5.15298L10.8238 3.28369" stroke="#131C27" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9.376 5.58924C12.4369 4.30565 16.0999 4.91054 18.5832 7.40957C20.8643 9.70522 21.5378 12.9833 20.6211 15.8669" stroke="#131C27" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          `,
          text: () => translations.dualOrientation
        },
        'table-wall': {
          icon: `<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.0425 4.86011C12.7025 4.86011 12.4225 5.14011 12.4225 5.48011C12.4225 5.82011 12.7025 6.10011 13.0425 6.10011C13.3825 6.10011 13.6625 5.82011 13.6625 5.48011C13.6625 5.14011 13.3825 4.86011 13.0425 4.86011Z" fill="#131C27"/>
          <rect x="6.97046" y="10.9236" width="11.9442" height="8.76294" rx="0.5" stroke="#131C27" stroke-width="1.5"/>
          <rect x="4.60193" y="8.47998" width="16.8813" height="13.6501" rx="1" stroke="#131C27" stroke-width="1.5"/>
          <path d="M7.94928 8.30688L12.2996 3.47801C12.6968 3.03712 13.3884 3.03712 13.7856 3.47801L18.1359 8.30688" stroke="#131C27" stroke-width="1.5" stroke-linecap="round"/>
          </svg>`,
          text: () => translations.wallMount
        },
        'cordless': {
          icon: `<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M23.0351 10.1989C24.0178 15.846 20.2953 21.2312 14.7223 22.2268C9.14826 23.2224 3.83268 19.4523 2.84995 13.8052C1.86723 8.15815 5.5886 2.77296 11.1627 1.77737C16.7367 0.781779 22.0523 4.55187 23.0351 10.1989" stroke="#131C27" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M7.29933 3.3457L8.94653 5.87309" stroke="#131C27" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M18.5848 20.6597L16.9376 18.1323" stroke="#131C27" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M16.9376 10.6125C16.9376 9.98325 16.4274 9.47314 15.7982 9.47314H10.1014C9.47217 9.47314 8.96207 9.98325 8.96207 10.6125V13.4609C8.96207 14.7194 9.98228 15.7396 11.2408 15.7396H14.6588C15.9173 15.7396 16.9376 14.7194 16.9376 13.4609V10.6125Z" stroke="#131C27" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.0603 9.13449V7.02866" stroke="#131C27" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M14.8393 9.13449V7.02866" stroke="#131C27" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M12.8397 15.7397V21.9758" stroke="#131C27" stroke-width="1.5" stroke-linecap="round"/>
          </svg>`,
          text: () => translations.cordless
        },
      }
  
      const order = frameSpecsOrder[frame] || [];
      const details = frameDetails[frame];

      container.innerHTML = '';
  
      for (const key of order) {
        const spec = frameSpecs[key];
        if (!spec) continue;
    
        const text = spec.text(details);
        if (!text) continue;
    
        const item = document.createElement('div');
        item.className = 'collective-bundle--specs-gallery--item';
        item.setAttribute('role', 'listitem');
    
        const iconWrap = document.createElement('div');
        iconWrap.className = 'collective-bundle--specs-gallery--item-icon';
  
        iconWrap.innerHTML = spec.icon;
    
        const span = document.createElement('span');
        span.className = 'collective-bundle--specs-gallery--item-text';
        span.textContent = text;
    
        item.appendChild(iconWrap);
        item.appendChild(span);
        container.appendChild(item);
      }
    }
    cards.forEach(card => {
      handleGiftProductSelect(card);
    });

    scrollContainer.addEventListener("scroll", () => {
      updateProxyScrollBar();
    });

    function clearAllSelections() {
      gift.selectedColor =  undefined;
      gift.note = undefined;

      //clear selected product
      let selectedProducts = document.querySelectorAll('.action--gift-shopping-product-option:checked')

      if (selectedProducts) {
        selectedProducts.forEach(product => (product.checked = false))
      }

      //clear giftnote
      if (giftNoteInput) {
        giftNoteInput.value = '';
        giftNoteInput.readOnly = true;
      }
      addGiftBtn.readOnly = true;
      addGiftBtn.textContent = giftPageCtas.dataset.atc;;


      //clear cart giftnote
      setGiftNoteInCart(gift.note);

      //disable view cart section
      cartSection.style.opacity = 0.5;
      cartSection.setAttribute('aria-hidden', 'true');
      cartSection.setAttribute('tabindex', '-1');
      cartSection.setAttribute('inert', '');
    }

    function applySelectionFromCart(){
      let cart = getSavedShopifyCart()
      if (cartHasLineItems(cart)) {
        let skus = getSkusFromCart()
        if (skus) {
          skus.forEach((sku) => {
            let color = window.getColorBySku(sku);
            // select all radios matching cart item
            const allMatchingRadios = document.querySelectorAll(
              `.action--gift-shopping-product-option[value='${color}']`
            );
            allMatchingRadios.forEach((radio) => {
              radio.checked = true;
            });
            enableUpsellSection();
            //check for gift note and enable gift note section
            enableGiftNoteSection(color);
            //scroll to how to section
            let howToSection = document.querySelector('gifting--how-to-section');
            let giftNoteSection = document.querySelector('#gift-builder--gift-note')
            // const giftPageCtas = document.querySelector('#gifting-ctas');
            if (cart.note) {
              setGiftNoteInCart(cart.note)
              addGiftBtn.textContent = giftPageCtas.dataset.updateGiftNote;
              if (howToSection) {
                scrollToNextSection(howToSection);
              }
            } else {
              addGiftBtn.textContent = giftPageCtas.dataset.addGiftNote;
              if (giftNoteSection) {
                scrollToNextSection(giftNoteSection);
              }
            }
            handleGiftNoteInput();
            handleAddToCartClick();
            cartSection.style.opacity = 1;
            cartSection.setAttribute('aria-hidden', 'false');
            cartSection.setAttribute('tabindex', '0');
            cartSection.removeAttribute('inert')
          })
        }
      }
    }

    updateProxyScrollBar();
    observeNavAnchors('.action--gifting-nav-link');
    toggleNavigationOnSteps('.action--gift-page-navigation','.action--gifting-section--steps', '.gifting--how-to');
    giftingCheckoutBtnListener();
  }

  function scrollToNextSection(nextSection) {
    if (nextSection) {
      const navbar = document.querySelector(".navbar");
      const navbarHeight = navbar ? navbar.offsetHeight : 0;

      setTimeout(() => {
        const top = nextSection.getBoundingClientRect().top + window.scrollY - navbarHeight;
        window.scrollTo({
          top,
          behavior: "smooth"
        });
      }, 500);
    }
  }

  function updateScrollbarOnCategorySwitch() {
    //update scroll container to new active container
    let scrollContainer = document.querySelector(".action--gifting-page--cards.active");
    scrollContainer.addEventListener("scroll", () => {
      updateProxyScrollBar();
    });
    updateProxyScrollBar();
  }

  function updateProxyScrollBar() {
    let scrollContainer = document.querySelector(".action--gifting-page--cards.active");
    let proxyContainer = document.querySelector(".action--scroll-bar-proxy-container");
    const proxyBar = document.querySelector(".action--gifting-page--scroll-bar-proxy");
    if (!proxyBar || !scrollContainer) return;
    const scrollWidth = scrollContainer.scrollWidth;
    const containerWidth = scrollContainer.offsetWidth;
    const scrollLeft = scrollContainer.scrollLeft;
    const barWidth = (containerWidth / scrollWidth) * 100;
    const barLeft = (scrollLeft / scrollWidth) * 100;

    if ( (scrollWidth === containerWidth) && barWidth === 100) {
      proxyContainer.style.opacity = '0';
    } else {
      proxyContainer.style.opacity = '1';
      proxyBar.style.width = `${barWidth}%`;
      proxyBar.style.left = `${barLeft}%`;
    }
  }

  function observeNavAnchors(navAnchorsClass) {
    const navLinks = document.querySelectorAll(navAnchorsClass);
    if (!navLinks.length) return;

    let isScrollingToNavLink = false;
    let scrollTimeout = null;

    // Map nav links to their target sections
    const linkSectionPairs = Array.from(navLinks).map(link => {
      const href = link.getAttribute('href');
      if (!href || !href.startsWith('#')) return null;
      const section = document.querySelector(href);
      return section ? { link, section } : null;
    }).filter(Boolean);

    // Use IntersectionObserver to watch each section
    const observer = new IntersectionObserver((entries) => {
      if (isScrollingToNavLink) return; // Don't update while scrolling to nav link

      // Update visibility state for each section
      entries.forEach(entry => {
        const pair = linkSectionPairs.find(p => p.section === entry.target);
        if (pair) {
          pair.isVisible = entry.isIntersecting && entry.intersectionRatio > 0.3;
        }
      });

      // Find the last visible section in DOM order
      const lastVisible = [...linkSectionPairs].reverse().find(p => p.isVisible);

      navLinks.forEach(l => l.classList.remove('active'));
      if (lastVisible) {
        lastVisible.link.classList.add('active');
      }
    }, {
      threshold: Array.from({ length: 101 }, (_, i) => i / 100) // 0.00 to 1.00
    });

    // Smooth scroll on click
    navLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        const href = link.getAttribute('href');
        if (href && href.startsWith('#')) {
          const section = document.querySelector(href);
          if (section) {
            e.preventDefault();
            isScrollingToNavLink = true;
            navLinks.forEach(l => l.classList.remove('active'));
            link.classList.add('active');
            const navbar = document.getElementById('navbar');
            const offset = navbar ? navbar.offsetHeight : 0;
            const sectionTop = section.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({ top: sectionTop, behavior: 'smooth' });

            // Wait for scroll to finish
            if (scrollTimeout) clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
              isScrollingToNavLink = false;
            }, 700);
          }
        }
      });
    });

    linkSectionPairs.forEach(pair => observer.observe(pair.section));
  }

  function toggleNavigationOnSteps(navClass, startNavClass, endNavClass) {
    //uses stepClass to determine when do display navbar
    const nav = document.querySelector(navClass);
    const startNavSection = document.querySelector(startNavClass);
    const endNavSection = endNavClass ? document.querySelector(endNavClass) : null;
    if (!nav || !startNavSection) return;

    // Hide nav by default
    nav.style.opacity = '0';

    function updateNavVisibility() {
      const stepsTop = startNavSection.getBoundingClientRect().top + window.scrollY;
      const endTop = endNavSection
        ? endNavSection.getBoundingClientRect().top + window.scrollY
        : Infinity;

      if (window.scrollY + window.innerHeight > stepsTop && window.scrollY < endTop - 150) {
        nav.style.opacity = '1';
      } else {
        nav.style.opacity = '0';
      }
    }

    window.addEventListener('scroll', updateNavVisibility);
    window.addEventListener('resize', updateNavVisibility);
    updateNavVisibility(); // Initial check
  }

  function clearGiftingPageSelections(isCollective) {
    if (!isCollective) {
      renderGiftingPageShopping();

      let selectProductSection = document.querySelector('.action--gifting-page-select-product');
      if (selectProductSection) {
        scrollToNextSection(selectProductSection);
      }      
    } else {
      uncheckCollectiveCheckboxes()
    }
  }

  function uncheckCollectiveCheckboxes() {
    var checkboxes = document.querySelectorAll(
      '.action--collective-card-checkbox'
    );
  
    checkboxes.forEach(function(checkbox) {
      if (checkbox.checked) {
        checkbox.checked = false;
      }
    });
  }

  function ExitIntentCloseEventListeners() {
    const exitIntentModalOverlay = document.getElementById("exit-intent--modal-overlay");
    if (exitIntentModalOverlay) {
      exitIntentModalOverlay.addEventListener("click", (e) => {
        if (e.target === exitIntentModalOverlay) {
          exitIntentCloseModal(exitIntentModalOverlay);
          logGA4Event('exit-intent--closed-modal');
        }
      })
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
          exitIntentCloseModal(exitIntentModalOverlay);
          logGA4Event('exit-intent--closed-modal');
        }
      });
      const closeBtn = document.getElementById('exit-intent--close-btn');
      if (closeBtn) {
        closeBtn.addEventListener("click", () => {
          exitIntentCloseModal(exitIntentModalOverlay);
          logGA4Event('exit-intent--closed-modal');
        })
      }
    }
  }
  function exitIntentCloseModal(overlay) {
    overlay.classList.remove("active");
  }

  function openExitIntentPopup() {
    let exitIntentPopup = document.getElementById('exit-intent--modal-overlay');
    exitIntentPopup.classList.add('active');
  }

  function trackExitIntent() {
    ExitIntentCloseEventListeners();
    document.addEventListener('mouseleave', event => {
      let cookieSet = getCookie('exitIntent');
      if(cookieSet) { return }
      setCookie('exitIntent', 'true', Date.now() + 3600);
      openExitIntentPopup();

    })

    let allExitIntentCheckBoxes = document.querySelectorAll('.exit-intent--checkbox');
    let exitIntentSubmitButton = document.getElementById('exit-intent--submit-btn');
    let exitIntentModalOverlay = document.getElementById('exit-intent--modal-overlay');

    allExitIntentCheckBoxes.forEach(checkbox => {
        checkbox.addEventListener('click', (e) => {
          let checkBoxName = e.target.value;
          logGA4Event('exit-intent--checkbox-clicked', {
            label: checkBoxName
          })
        });
    });

    exitIntentSubmitButton.addEventListener('click', () => {
      let checkedBoxes = Array.from(allExitIntentCheckBoxes)
        .filter(checkbox => checkbox.checked)
        .map(checkbox => checkbox.value);

      logGA4Event('exit-intent--submit', { label: checkedBoxes.join(', ')})
      exitIntentCloseModal(exitIntentModalOverlay);
    })
  }


  function getAddingToCartTranslation() {
    switch (I18n.locale) {
      case 'de':
      case 'de-LU':
      case 'de-NL':
      case 'de-BE':
        return 'Hinzufügen...';
      case 'fr':
      case 'fr-LU':
      case 'fr-NL':
      case 'fr-BE':
        return 'Ajout en cours...';
      case 'nl-NL':
      case 'nl-BE':
        return 'Toevoegen...';
      default:
        return 'Adding...';
    }
  }

  async function initCollectiveDetails() {
    const bundleBoxes = document.querySelectorAll('.actions--collective-bundle');
    if (!bundleBoxes.length) return;
    
    window.fetchAllCollectiveVariantDetails()
    .then((variants) => {
      if (!variants || variants.length === 0) {
        hideCollectiveBundleBox(bundleBoxes);
        return;
      }
      initCollectiveBundleBox(variants, bundleBoxes);
    });
  }

  function hideCollectiveBundleBox(bundleBoxes){
    bundleBoxes.forEach((bbox) => {
      bbox.classList.add('hide');
      bbox.setAttribute('aria-hidden', true)
    })
  }

  function initCollectiveBundleBox(data, bundleBoxes) {
    const activeFrame = getFrameColorFromUrl();
    const activeCollectiveVariantDetails = data[0];
    const collectivePartner = getMetafieldValue(activeCollectiveVariantDetails.metafields, 'category');
    const activeFrameDetails = window.getFrameDetailsByColor(activeFrame);
    const specsContainer = document.getElementById('collective-specs-gallery');
  
    if (bundleBoxes) {
      bundleBoxes.forEach((bundleBox) => {
        setSkeletonLoaded(bundleBox)
        displayCollectiveBundleBox(bundleBox)
        setInitialBundleBoxDataAttributes(bundleBox, data)
        updateCollectiveTooltip(bundleBox, data)
        renderCollectiveMainImage(bundleBox, data)
        renderVariantThumbnails(bundleBox, data)
        collectiveBundleBoxCheckboxListener(bundleBox, data, collectivePartner);
        renderCollectiveBundlePrice({
          collectivePartner: collectivePartner,
          frame: activeFrameDetails,
          collectiveVariant: activeCollectiveVariantDetails
        });
        initCollectiveProductPreview(bundleBox, collectivePartner);
        renderCollectiveSpecs({
          container: specsContainer,
          variant: data[0]
        })
      })
    }
  }

  function getActiveCollectiveVariant() {
    const color = getSelectedCollectiveBundleOption();
    const variants = window.grabAllCollectiveVariants();
  
    if (!variants) return null;
  
    return variants.find(v =>
      getMetafieldValue(v.metafields, 'color') === color
    );
  }

  function openCollectiveProductPreview(collectivePartner, variant = '') {
    const popup = document.querySelector('.action--product-preview-popup');
    const track = popup.querySelector('.action--quick-view--carousel-track');
    
    const closeBtn = popup.querySelector('.action--product-preview-close');
    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (!variant) {
      variant = getActiveCollectiveVariant();  
    }
    
    if (!track || !variant) return;
  
    renderCollectiveQuickView(track, variant, collectivePartner);
  
    if (!isOverlayShowing) showOverlay();
  
    setTimeout(() => {
      popup.classList.add('is-open');
      document.body.classList.add(CLASSES.OPEN);
  
      document.addEventListener('click', handleOutsideClick);
      document.addEventListener('keydown', handleEscapeKey);
  
      logGA4Event('collective_product_preview', {
        color: getMetafieldValue(variant.metafields, 'color')
      });
    }, 50);
  
    function handleOutsideClick(event) {
      if (!popup.contains(event.target)) closePopup();
    }
    
    function closePopup() {
      // Reset all carousels back to image 1 on popup close
      const carousels = popup.querySelectorAll(".action--quick-view--main-image--wrapper");
      carousels.forEach(c => {
        if (c.resetQuickView) c.resetQuickView();
      });
    
      popup.classList.remove('is-open');
      document.body.classList.remove(CLASSES.OPEN);
      if (isOverlayShowing) hideOverlay();
    
      document.removeEventListener('click', handleOutsideClick);
      document.removeEventListener('keydown', handleEscapeKey);
    }
    
    function handleEscapeKey(event) {
      if (event.key === 'Escape') closePopup();
    }
  }

  function renderCollectiveQuickView(track, variant, collectivePartner) {
    track.innerHTML = '';
  
    const popUpTitle = document.querySelector('.action-preview--title')
    popUpTitle.innerHTML = `Aura x ${collectivePartner} Set`
  
    const images = [
      variant.image.jpg
    ];
  
    images.forEach((img, i) => {
      const slide = document.createElement('div');
      slide.className =
        'quick-view--carousel-slide column-12 action--quick-view--carousel-slide active';
  
      const picture = document.createElement('picture');
  
      if (variant.image.webp) {
        const source = document.createElement('source');
        source.srcset = variant.image.webp;
        source.type = 'image/webp';
        picture.appendChild(source);
      }
  
      const image = document.createElement('img');
      image.src = img;
      image.alt = variant.title;
      image.className = 'flex width-100 height-auto border-box';
  
      picture.appendChild(image);
      slide.appendChild(picture);
      track.appendChild(slide);
    });
  }

  function renderCollectiveSpecs({
    container,
    variant
  }) {
    if (!container || !variant) return;

    let frameSpecDetails = document.getElementById('frame-specs');

    const translations = {
      csCamera: frameSpecDetails.dataset.csCamera,
      csMemory: frameSpecDetails.dataset.csMemory,
      csFlash: frameSpecDetails.dataset.csFlash,
      csSize: frameSpecDetails.dataset.csSize,
    };

    const COLLECTIVE_SPECS_ORDER = {
      'camp-snap': [
        'cs-camera',
        'cs-memory',
        'cs-flash',
        'cs-rechargeable'
      ]
    };
    
    const COLLECTIVE_SPECS = {
      'cs-camera': {
        icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5858 4.58579L15.7071 5.70711C15.8946 5.89464 16.149 6 16.4142 6H19C20.1046 6 21 6.89543 21 8V17C21 18.1046 20.1046 19 19 19H5C3.89543 19 3 18.1046 3 17V8C3 6.89543 3.89543 6 5 6H7.58579C7.851 6 8.10535 5.89464 8.29289 5.70711L9.41421 4.58579C9.78928 4.21071 10.298 4 10.8284 4H13.1716C13.702 4 14.2107 4.21071 14.5858 4.58579Z" stroke="#131E29" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="12" cy="12" r="4" stroke="#131E29" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`,
        text: () => translations.csCamera
      },
    
      'cs-memory': {
        icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5207 6.14596L6.14597 4.5207C6.47937 4.1873 6.93155 4 7.40305 4H18.2222C19.2041 4 20 4.79594 20 5.77778V18.2222C20 19.2041 19.2041 20 18.2222 20H5.77778C4.79594 20 4 19.2041 4 18.2222V7.40305C4 6.93155 4.1873 6.47936 4.5207 6.14596Z" stroke="#323232" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M15.5554 4V9.33333C15.5554 9.82425 15.1575 10.2222 14.6666 10.2222H9.33322C8.84231 10.2222 8.44434 9.82425 8.44434 9.33333V4" stroke="#323232" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`,
        text: () => translations.csMemory
      },
    
      'cs-flash': {
        icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8231 11.5748L12.8121 20.2578C12.2611 21.0528 11.0141 20.6638 11.0141 19.6958V13.9728H5.9891C5.1931 13.9728 4.7241 13.0788 5.1781 12.4238L11.1891 3.74079C11.7401 2.94579 12.9871 3.33479 12.9871 4.30279V10.0258H18.0121C18.8071 10.0258 19.2761 10.9198 18.8231 11.5748Z" stroke="#323232" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`,
        text: () => translations.csFlash
      },
    
      'cs-rechargeable': {
        icon: `<svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.2109 7.52968C17.2109 6.73448 16.5579 6.08984 15.7522 6.08984H8.45871C7.65308 6.08984 7 6.73448 7 7.52968V11.1293C7 12.7197 8.30617 14.009 9.91741 14.009H14.2935C15.9048 14.009 17.2109 12.7197 17.2109 11.1293V7.52968Z" stroke="#131C27" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9.68628 5.66133V3.00012" stroke="#131C27" stroke-width="1.25" stroke-linecap="round"/>
        <path d="M14.5244 5.66133V3.00012" stroke="#131C27" stroke-width="1.25" stroke-linecap="round"/>
        <path d="M12.1096 14.1167L12.1096 20.1" stroke="#131C27" stroke-width="1.25" stroke-linecap="round"/>
        </svg>
        `,
        text: () => translations.csSize
      }
    };
  
    const collection = getMetafieldValue(variant.metafields, 'collection');
    const order = COLLECTIVE_SPECS_ORDER[collection] || [];
  
    container.innerHTML = '';
  
    for (const key of order) {
      const spec = COLLECTIVE_SPECS[key];
      if (!spec) continue;
  
      const text = spec.text(variant);
      if (!text) continue;
  
      const item = document.createElement('div');
      item.className = 'collective-bundle--specs-gallery--item';
      item.setAttribute('role', 'listitem');
  
      const iconWrap = document.createElement('div');
      iconWrap.className = 'collective-bundle--specs-gallery--item-icon';

      iconWrap.innerHTML = spec.icon;
  
      const span = document.createElement('span');
      span.className = 'collective-bundle--specs-gallery--item-text';
      span.textContent = text;
  
      item.appendChild(iconWrap);
      item.appendChild(span);
      container.appendChild(item);
    }
  }
  
  function initCollectiveProductPreview(bundleBox, collectivePartner) {
    if (!bundleBox) return;
  
    bundleBox.addEventListener('click', (e) => {
      const btn = e.target.closest('.action--product-preview-btn');
      if (!btn) return;
  
      e.preventDefault();
      openCollectiveProductPreview(collectivePartner);
    });
  }

  function collectiveBundleBoxCheckboxListener(bundleBox, data, collectivePartner) {
    let cta = bundleBox.querySelector('#action--collective-bundle-cta');
    cta.addEventListener('change', (e) => {
      const activeFrame = getFrameColorFromUrl();
      const activeFrameDetails = window.getFrameDetailsByColor(activeFrame);
      if (e.target.checked) {
  
        let activeCollectiveVariant = e.target.dataset.value;
        const activeCollectiveVariantDetails = data.find(item =>
          item.title.toLowerCase() === activeCollectiveVariant.toLowerCase()
        );
  
        const frames = [activeFrameDetails, activeCollectiveVariantDetails]
        // get current frame price
        renderPricing(activeFrameDetails, frames, true)
  
        renderCollectiveBundlePrice({
          collectivePartner: collectivePartner,
          frame: activeFrameDetails,
          collectiveVariant: activeCollectiveVariantDetails
        });
        
      } else {
  
        renderPricing(activeFrameDetails, null, false)
      }
    });
  }

  function renderCollectiveBundlePrice({
    collectivePartner,
    frame,
    collectiveVariant,
    currencySymbol = '$'
  }) {
    const container = document.getElementById('collective-bundle-price');
    if (!container || !frame || !collectiveVariant || !collectivePartner) return;
  
    const framePrice = calculateFramePrice(frame);
    const frameStrike = calculateStrikePrice(frame);
  
    const collectivePrice = Number(collectiveVariant.price);
  
    const currentTotal = framePrice + collectivePrice;
    const strikeTotal =
      frameStrike > framePrice
        ? frameStrike + collectivePrice
        : null;
  
    container.innerHTML = `
      Aura x ${collectivePartner} Set
      <span class="collective-bundle__price">
        ${currencySymbol}${currentTotal}
      </span>
      <span class="collective-bundle__strike-price ${strikeTotal ? '' : 'hide'}">
        ${strikeTotal ? currencySymbol + strikeTotal : ''}
      </span>
    `;
  }

  function renderVariantThumbnails(bundleBox, data) {
    if (!bundleBox || !Array.isArray(data)) return;
  
    const bundleOptionsWrapper = bundleBox.querySelector('.actions--collective-bundle--options-wrapper');
    bundleOptionsWrapper.innerHTML = '';
  
    data.forEach((variant, index) => {
      const colorClass = getMetafieldValue(variant.metafields, 'class');
      const collection = getMetafieldValue(variant.metafields, 'collection');
      const title = variant.title;
      const isActive = index === 0;
  
      // wrapper
      const wrapper = document.createElement('div');
      wrapper.className = `
        actions--collective-bundle--option-wrapper
        ${colorClass}
        collective-bundle__option-item
      `.trim();
  
      wrapper.dataset.color = colorClass;
      wrapper.dataset.collection = collection;
  
      // input
      const input = document.createElement('input');
      input.type = 'radio';
      input.name = 'radio-bundle';
      input.value = colorClass;
      input.id = `radio-selection-${colorClass}`;
      input.checked = isActive;
  
      input.className = `
        collective-bundle--option
        actions--collective-bundle--option
        collective-bundle__option
        ${colorClass}
        mr2
        ${isActive ? 'active' : ''}
      `.trim();
  
      input.dataset.color = colorClass;
      input.dataset.collection = collection;
  
      // label
      const label = document.createElement('label');
      label.htmlFor = input.id;
      label.className =
        'collective-bundle--option-label action--collective-bundle--option-label';
      label.tabIndex = 0;
      label.setAttribute(
        'aria-description',
        'Select color'
      );
  
      // image
      const picture = document.createElement('picture');
      if (variant.image.webp) {
        const source = document.createElement('source');
        source.srcset = variant.image.webp;
        source.type = 'image/webp';
        picture.appendChild(source)
      }
  
      const img = document.createElement('img');
      img.width = 46;
      img.height = 46;
      img.alt = title;
      img.loading = 'lazy';
  
      img.className = `
        actions--collective-bundle--option-image
        collective-bundle--option-image
        ${colorClass}
        ${collection}
        ${isActive ? 'active' : ''}
      `.trim();
  
      img.src = variant.image.jpg;
      img.dataset.color = colorClass;
      picture.appendChild(img);
  
      // assemble
      label.appendChild(picture);
      wrapper.appendChild(input);
      wrapper.appendChild(label);
      bundleOptionsWrapper.appendChild(wrapper);
  
      input.addEventListener('change', () => {
        updateActiveCollectiveVariant({
          bundleBox,
          variants: data,
          activeColor: colorClass
        });
      });
    });
  }

  function updateActiveCollectiveVariant({
    bundleBox,
    variants,
    activeColor
  }) {
    if (!bundleBox || !Array.isArray(variants)) return;
    // 1. Get new active variant
    const activeVariant = variants.find(variant => {
      return getMetafieldValue(variant.metafields, 'class') === activeColor;
    });
  
    if (!activeVariant) return;
  
    // 2. Update bundleBox data attributes
    bundleBox.dataset.color = activeColor;
    bundleBox.dataset.collection = activeVariant.product.vendor || '';
  
    // 3. Update checkbox data
    const checkbox = bundleBox.querySelector('#action--collective-bundle-cta');
    if (checkbox) {
      checkbox.dataset.color = getMetafieldValue(activeVariant.metafields, 'color');
      checkbox.dataset.value = activeVariant.title;
    }
  
    // 4. Update active thumbnail styles
    bundleBox
      .querySelectorAll('.collective-bundle--option-image, .collective-bundle--option')
      .forEach(el => el.classList.remove('active'));
  
    bundleBox
      .querySelectorAll(`[data-color="${activeColor}"]`)
      .forEach(el => el.classList.add('active'));
  
    // 5. Update main image
    renderCollectiveMainImage(bundleBox, [activeVariant]);
  
  }

  function collectiveBundleUpsellChecked(){
    var bundleBoxCheck = document.getElementById('action--collective-bundle-cta');
    return bundleBoxCheck ? bundleBoxCheck.checked : false;
  }

  function getSelectedCollectiveBundleOption() {
    const selectedOption = document.querySelector('#action--collective-bundle-cta').dataset.color;
    return selectedOption;
  }

  function renderCollectiveMainImage(bundleBox, data) {
    if (!bundleBox || !Array.isArray(data)) return;
  
    const variant = data[0];
    const image = variant.image;
  
    if (!image.jpg) return;
  
    const container = bundleBox.querySelector('#collective-main-image');
    if (!container) return;
  
    const picture = document.createElement('picture');
  
    if (image.webp) {
      const source = document.createElement('source');
      source.srcset = image.webp;
      source.type = 'image/webp';
      picture.appendChild(source);
    }
  
    const img = document.createElement('img');
    img.src = image.jpg;
    img.width = 100;
    img.height = 100;
    img.alt = image.alt || variant.title || '';
    img.className =
      'collective-bundle--main-image actions--collective-bundle--main-image flex width-100 height-auto border-box active';
  
    img.dataset.color = getMetafieldValue(variant, 'color') || '';
  
    picture.appendChild(img);
  
    const wrapper = document.createElement('div');
    wrapper.className =
      'collective-bundle--main-image-wrapper actions--collective-bundle--main-image-wrapper active';
  
    wrapper.appendChild(picture);
  
    container.innerHTML = '';
    container.appendChild(wrapper);
  }

  function updateCollectiveTooltip(bundleBox, data) {
    if (!data[0]) return;
  
    const tooltipSections = bundleBox.querySelectorAll('.tooltip-info');
    if (tooltipSections) {
      tooltipSections.forEach((tooltip) => {
        tooltip.classList.remove('hide');
        tooltip.setAttribute('aria-hidden', "false")
        const toolTipText = getMetafieldValue(data[0].metafields, 'tool_tip');
        if (!toolTipText) return;
  
        const tooltipTextEl = tooltip.querySelector('.action--js-tooltip-text');
        if (!tooltipTextEl) return;
        tooltipTextEl.textContent = toolTipText;
      })
    }
  }

  function setInitialBundleBoxDataAttributes(bundleBox, data) {
    if (!Array.isArray(data) || !data[0]) return;
    if (!bundleBox) return;
    const currentVariantTitle = data[0].title
    const currentVariantClass = data[0].class
  
    bundleBox.dataset.color = currentVariantClass;
    bundleBox.dataset.collection = data[0].product.vendor;
  
    let bundleCTA = bundleBox.querySelector('#action--collective-bundle-cta');
    if (bundleCTA) {
      
      bundleCTA.dataset.color = getMetafieldValue(data[0].metafields, 'color');
      bundleCTA.dataset.value = currentVariantTitle
    }
  }

  function displayCollectiveBundleBox(element){
    //reveal hidden elements from skelton loader
    element.querySelectorAll('.action--reveal-section').forEach(section => {
      section.classList.remove('hide');
      section.setAttribute('aria-hidden', false)
    })
  }
  

  function getMetafieldValue(metafields, key) {
    if (!Array.isArray(metafields)) return null;
  
    const field = metafields.find(m => m && typeof m === 'object' && m.key === key);
    return field && field.value ? field.value : null;
  }

  function initNavAnalytics(){
    let accountIcons = document.querySelectorAll('.action--customer-account-icon');
    if (accountIcons) {
      accountIcons.forEach(icon => {
        icon.addEventListener('click', () => {
          logGA4Event('customer-account-icon-click', {})
        })
      })      
    }
  }

  function initStickyATC() {
    var atc = document.querySelector(".atc-default");
    var sticky = document.querySelector(".sticky-atc");
    var footer = document.querySelector(".background-footer");
    var imageSelector = document.querySelector(".image-selector");
    if (!atc || !sticky) return;
    sticky.addEventListener("click", function (e) {
      e.preventDefault();
      var realButton = atc.querySelector("button");
      if (realButton) {
        realButton.click();
      }
    });
    var isATCVisible = false;
    var isFooterVisible = false;
    var isImageSelectorVisible = false;
    function updateSticky() {
      if (!isATCVisible && !isFooterVisible && !isImageSelectorVisible) {
        sticky.classList.add("show");
      } else {
        sticky.classList.remove("show");
      }
    }
    // Observe ATC
    var atcObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        isATCVisible = entry.isIntersecting;
        updateSticky();
      });
    });
    atcObserver.observe(atc);
    // Observe footer
    if (footer) {
      var footerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          isFooterVisible = entry.isIntersecting;
          updateSticky();
        });
      });
      footerObserver.observe(footer);
    }
    // Observe image selector
    if (imageSelector) {
      var imageObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          isImageSelectorVisible = entry.isIntersecting;
          updateSticky();
        });
      });
      imageObserver.observe(imageSelector);
    }
  }

  // Show the Bazaarvoice UGC section once its script is allowed to load
  function showUgcSection() {
    const sections = document.querySelectorAll('.product-section__bazaar-voice');
    if (!sections.length) return;

    const show = () => sections.forEach((el) => el.classList.add('is-ugc-ready'));

    if (window.onCookieCategoryConsent) {
      window.onCookieCategoryConsent(['marketing'], show);
    } else {
      show(); // no consent helper on this page: just show it
    }
  }

  async function init() {
    
    if (I18n.locale == 'en' || I18n.locale == 'qa' || I18n.locale == 'en-US' || I18n.locale == 'es-US' || I18n.locale == 'en-QA' || I18n.locale == 'es-QA') {
      updateDeliveryEstimateMessageBasedOnSkus();
      triggerTimeoutForRefetchingShippingEstimate();
    }
    loadingLazy();
    loadingHiddenLazy();
    expireInactiveVWOCookies();
    getDefaultColor();
    getDefaultFrameGroup(activeFrame);
    renderSelectedColor();
    renderQuantity();
    renderCartCount();
    renderPurchaseOption();
    // FIXME: remove after test
    refreshPricingTestPriceIfActive();
    refreshPricingTestGridPrices();
    retryPricingTestForLateCookie();
    clearCartIfHoldingPricingTestVariant().catch(function (e) {
      airbrake.notify({ error: 'Error clearing cart for merchandising test', context: { component: 'StoreFront API' }, params: { message: e.message } });
    });
    // FIXME: remove after test -- VWO can bucket this visitor after the page has already rendered
    // control estimates, so re-render them and bring the cart's existing lines up to the variant
    window.onShippingSpeedTestBucketed(function () {
      updateDeliveryEstimateMessageBasedOnSkus();
      stampShippingSpeedTestOnCartLines().catch(function (e) {
        airbrake.notify({ error: 'Error stamping cart for shipping speed test', context: { component: 'StoreFront API' }, params: { message: e.message } });
      });
    });
    renderDiscountCodeCopy();
    renderShopSectionNav();
    initNavAnalytics();
    initCountryPickerAnalytics();
    if (isHomePage()) {
      renderHowItWorksSection();
      hpVideoBanner('walden');
      hpVideoBanner('carver');
      hpVideoBanner('aspen');

      createTestObserver('.action--bopis-merchandising', 'bopis-test', (isActive) => {
        if (isActive) {
          showBopisMerchandisingOnPages();
        } else {
          hideBopisMerchandisingOnPages();
        }
      });
      logFrameLineupClickEvent();
    }

    if (isProductPage()) {
      galleryButtons();
      createTestObserver('.action--bopis-merchandising', 'bopis-test', (isActive) => {
        if (isActive) {
          showBopisMerchandisingOnPages();
        } else {
          hideBopisMerchandisingOnPages();
        }
      });
      renderProductInfoTabs();
      logCookieCollision("pdp_experiments_collision", "pdp_experiment_gallery", "pdp_experiment_specs");
      toggleAccordion();
      hpVideoBanner('pdp-highlight-1');
      hpVideoBanner('pdp-highlight-4');
      hpVideoBanner('fwf-1');
      hpVideoBanner('astra-lifestyle');
      hideAddToCartAtFooter();
      initCollectiveBundleCheckboxListeners();
      await initCollectiveDetails();
      initStickyATC();
      checkoutWithShopPay();
      showUgcSection();
    }

    if (isAboutAuraPage()){
      hpVideoBanner('fwf-1');
    }

    if (isShopAllPage()) {
      toggleAccordion();
      toggleMobileSwiperDots();
    }

    if (isInStorePickupPage()){
      renderInStorePickupPage();
    }

    if (isMultishipPage()) {
      loadMultishipCartInfo();
      formatPhoneInput();
      handleShippingAddressEditClick();
    } else if (isMultishipShippingMethodPage()) {
      loadMultiShipCartShippingMethods();
    } else if (isMultiShipBillingPage()) {
      loadMultiShipCartBilling();
      formatPhoneInput();
    }

    if (isFeaturedFramesPage()) {
      renderHowItWorksSection();
    }

    if (isGiftingPage()) {
      renderGiftingPageShopping();
      renderCart();
      toggleAccordion();
    }

    if (isCartPage()) {
      toggleMultiShipCheckoutLink();
    }

    $(getClassSelector(SELECTORS.CART_DISCOUNT_CODE_TOGGLE)).on('click', function () {
      const $form = $(getClassSelector(SELECTORS.CART_DISCOUNT_CODE_FORM));
      const $icon = $(getClassSelector(SELECTORS.CART_DISCOUNT_CODE_TOGGLE_ICON));
      const $input = $(getClassSelector(SELECTORS.CART_DISCOUNT_CODE_INPUT));
      const $apply = $(getClassSelector(SELECTORS.CART_DISCOUNT_CODE_APPLY));
      const $error = $(getClassSelector(SELECTORS.CART_DISCOUNT_CODE_ERROR));
      $form.toggleClass('active');
      $form.attr('tabindex', $form.hasClass('hide') ? -1 : 0);
      $icon.toggleClass('active');
      $icon.attr('tabindex', $icon.hasClass('hide') ? -1 : 0);
      $input.attr('tabindex', $form.hasClass('hide') ? -1 : 0);
      $apply.attr('tabindex', $form.hasClass('hide') ? -1 : 0);
      $error.addClass('hide');
      $input.val('');

      if ($form.hasClass('active')) {
        // Form is open - check if we have have a discount code or not
        const discountCodeInputsContainer = $(getClassSelector(SELECTORS.CART_DISCOUNT_CODES));
        const discountCodeInputs = discountCodeInputsContainer.find('.discount-code');
        if (discountCodeInputs.length) {
          updateCartDiscountCodeToggleMsg('showPromoApplied');
        } else {
          updateCartDiscountCodeToggleMsg('showAddPromo');
        }
      } else {
        // Form is closed, show add promo
        updateCartDiscountCodeToggleMsg('showAddPromo');
      }

    });

    $(getClassSelector(SELECTORS.CART_DISCOUNT_CODE_INPUT)).on('input', function () {
      const $error = $(getClassSelector(SELECTORS.CART_DISCOUNT_CODE_ERROR));
      const $apply = $(getClassSelector(SELECTORS.CART_DISCOUNT_CODE_APPLY));
      const discountCodeInput = $(this).val().trim();

      if (discountCodeInput.length > 1) {
        $apply.removeClass('disabled');
        $apply.removeAttr('disabled');
        $apply.addClass('active');
      } else {
        $apply.addClass('disabled');
        $apply.attr('disabled', 'disabled');
        $apply.removeClass('active');
      }

      if (discountCodeInput.length === 0) {
        $error.addClass('hide');
      }

    });

    const discountCodeInput = getDiscountCode();
    if (discountCodeInput) {
      const cartId = getShopifyCartId();
      if (cartId) {
        updateDiscountCodeShopifyCart([discountCodeInput.toUpperCase()], cartId);
      }
    }

    $(getClassSelector(SELECTORS.CART_DISCOUNT_CODE_FORM)).on('submit', function (e) {
      e.preventDefault();
      const discountCodes = getAppliedDiscountCode().filter(code => code.applicable).map(code => code.code);
      const discountCodeInput = $(e.target).find(getClassSelector(SELECTORS.CART_DISCOUNT_CODE_INPUT)).val().trim();
      const cartId = getShopifyCartId();
      if (discountCodeInput && cartId) {
        discountCodes.push(discountCodeInput.toUpperCase());
        updateDiscountCodeShopifyCart(discountCodes, cartId);
      }
    });

    $(getClassSelector(SELECTORS.CART_CHECKOUT)).on('click', async function () {
      const cartId = getShopifyCartId();
      await stampShippingSpeedTestOnCartLines();
      const attributes = setDeliveryEstimatesAttributes();
      attributes.push(...shippingSpeedTestCartAttributes());
      const msAuraAttributes = setMsAuraAttributes();
      const giftNoteAttributes = setGiftNoteAttribute();
      if (msAuraAttributes && msAuraAttributes.length > 0) {
        attributes.push(...msAuraAttributes);
      }
      if (giftNoteAttributes && giftNoteAttributes.length > 0) {
        attributes.push(...giftNoteAttributes);
      }
      if (cartId && attributes && attributes.length > 0) {
        await updateShopifyCartAttributes(attributes, cartId);
      }
    });

    if (window.location.pathname.includes('cart') && !window.location.pathname.includes('/ms/')) {
      renderCart();
      renderOpenCart('cart_page');
      checkIfGiftBagInCart();
    };

    if (!frameDetails.discountCodeProduct && frameDetails.discountAmount != '') {
      renderDiscountBadgePricePDP(frameDetails);
    };

    $(".action--frame-selector").swipe({
      swipeLeft: function () {
        handleIncrementImage();
      },
      swipeRight: function () {
        handleDecrementImage();
      }
    });

    $(getClassSelector(SELECTORS.LEFT_ARROW)).on('click', function () {
      handleDecrementImage();
    });

    $(getClassSelector(SELECTORS.RIGHT_ARROW)).on('click', function () {
      handleIncrementImage();
    });

    $quickAddButtons.each(function (index, button) {
      $(button).on('click', async function (e) {
        const frame = e.target;
        if (!frame) return;
        const color = COLOR_TO_ENUM[frame.getAttribute('data-color')];
        const quantity = Number(frame.getAttribute('data-quantity')) || 1;

        if (!color && !quantity) {
          return
        }
        const updatedCart = await addQuickFrameToCart(color, quantity);

        var currentFrame = frame.getAttribute('data-color');

        if (!isCartOpen) {
          flashCartOpen();

        }
        if (updatedCart) {
          if (button.classList.contains('action--cart-upsell__add-to-cart')) {
            logGA4Event('cart_upsell_quick_add', {
              info: "cart upsell quick add",
              color: COLOR_TO_ENUM[currentFrame]
            });
            logPavedEvent('cart_upsell_quick_add', {
              info: "cart upsell quick add",
              color: COLOR_TO_ENUM[currentFrame]
            });
          }
          if (button.classList.contains('action--quick-add-test-button')) {
            logGA4Event('quick_add_shop_all', {
              info: "shop all quick add",
              color: COLOR_TO_ENUM[currentFrame]
            });
            logPavedEvent('quick_add_shop_all', {
              info: "shop all quick add",
              color: COLOR_TO_ENUM[currentFrame]
            });
          }
          var cartItems = document.querySelector('.cart-items');
          if (cartItems) {
            var lastItem = cartItems.querySelector('.cartItem:last-child');
            if (lastItem) {
              lastItem.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }
          }
        }
      });
    });

    $promoButtons.each(function (index, button) {
      $(button).on('click', async function (e) {
        await addPromoFrameToCart(e);
        if (!isCartOpen) {
          flashCartOpen();
        }
      })
    })

    function renderShopSectionNav() {
      //get url category param and set active nav button
      const urlParams = new URLSearchParams(window.location.search);
      let category = urlParams.get('category');

      var $shopSectionNavs = document.querySelectorAll('.action--shop-section--nav');

      if (!$shopSectionNavs) {
        return;
      }

      function setActiveButton(button, shouldFocus = false) {
        var $shopSectionNavBtns = Array.from($shopSectionNavs)
        .flatMap(nav => Array.from(nav.querySelectorAll('.action--shop-section--nav-btn')));


        if (!$shopSectionNavBtns.length) {
          return;
        }

        $shopSectionNavBtns.forEach(function(btn) {
          btn.classList.remove('active');
          btn.setAttribute('aria-selected', 'false');
        });
        button.classList.add('active');
        button.setAttribute('aria-selected', 'true');
        if (shouldFocus) button.focus();
      }

      function toggleShopSections(selectedShopSection) {
        const shopSections = document.querySelectorAll('.action--shop-section');
        if (!shopSections.length) return;

        const sectionExists = Array.from(shopSections).some(
          section => section.dataset.shopSection === selectedShopSection
        );
        if (!sectionExists) return;

        shopSections.forEach(section => {
          const isActive = section.dataset.shopSection === selectedShopSection;

          isActive ? section.removeAttribute('inert') : section.setAttribute('inert', '');
          isActive ? section.setAttribute('tabindex', '-0') : section.setAttribute('tabindex', '0');

          const elementsToUpdate = [
            section,
            ...section.querySelectorAll('.scroll-carousel>.shop-section__products>.shop-section__product'),
            ...section.querySelectorAll('.scroll-carousel>.shop-section__products>.shop-section__product>a.product__link-wrapper')
          ];

          updateShopSectionAttributes(elementsToUpdate, isActive);

          if (isActive) renderShopSectionTracking(section);
        });
      }

      function updateShopSectionAttributes(elements, isActive) {
        (elements.length ? elements : [elements]).forEach(el => {
          el.classList.toggle('active', isActive);
          el.setAttribute('aria-expanded', isActive ? 'true' : 'false');
          if (el.tagName !== 'SECTION') {
            el.setAttribute('tabindex', isActive ? '0' : '-1');
          }
        });
      }

      function updateUrlParam(value) {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('category', value);
        window.history.replaceState({}, '', currentUrl);
      }

      //if no category param, default back to shop all section
      let shopSectionNavBtns = [];

      $shopSectionNavs.forEach(nav => {
        shopSectionNavBtns.push(...nav.querySelectorAll('.action--shop-section--nav-btn'));
      });

      const exists = shopSectionNavBtns.some(btn => btn.dataset.shopSection === category);

      if (!exists) {
        category = 'shop-all'
      }

      const selectedCategory = category;
      const targetBtn = document.querySelector(`.action--shop-section--nav-btn[data-shop-section="${selectedCategory}"]`);

      if (targetBtn) {
        setActiveButton(targetBtn);
        toggleShopSections(selectedCategory);
      }

      $shopSectionNavs.forEach(nav => {
        nav.addEventListener('click', function(e) {
          var targetBtn = e.target.closest('.action--shop-section--nav-btn');

          if (targetBtn) {
            var $shopSection = targetBtn.dataset.shopSection;
            updateUrlParam($shopSection);
            setActiveButton(targetBtn, true);
            toggleShopSections($shopSection);
            targetBtn.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'center'
            });
            if (isGiftingPage()) {
              updateScrollbarOnCategorySwitch();
            }
          }
        });
      })
    }

    $(getClassSelector(SELECTORS.NAVBAR_PRIMARY_BUTTON)).each(function (buttonIndex, button) {
      if ($('body').hasClass('order-page')) {
        var $activeFrame = getActiveFrameDetailsAnalytics();
        logFBCustomEvent("viewOrderPage");
        logFBEvent('ViewContent', {
          content_ids: $activeFrame.productId,
          content_type: 'product'
        })
        logTikTokEvent('ViewContent', {
          contents: [
            {
              content_id: $activeFrame.productId,
              content_name: $activeFrame.name,
              quantity: 1,
              price: $activeFrame.price,
            }
          ],
          content_type: 'product',
          value: $activeFrame.price,
          currency: getLocaleCurrency()
        });
      }
    });

    function goToAmazonClick(frameDetails) {
      var $foundAmazonLink = $(getClassSelector(SELECTORS.AMAZON_Link));

      if (!$foundAmazonLink.length) {
          return;
      }

      $foundAmazonLink.on('click', function(event) {
          event.preventDefault();
          logGA4Event('click_amazon_affiliate_link', {
              info: 'Click Amazon Affiliate Link',
              value: frameDetails.amazonLink
          });
          logPavedEvent('click_amazon_affiliate_link', {
            info: 'Click Amazon Affiliate Link',
            value: frameDetails.amazonLink
        });
          window.location.href = frameDetails.amazonLink;
      });
    }

    goToAmazonClick(window.getFrameDetailsByColor(activeFrame));

    function renderActivePDPColor(swatchFrameDetails, swatchColor) {
      const hasBuyWithPrime = swatchFrameDetails.buyWithPrime;
      const buyWithPrime = document.querySelector(".action--buy-with-prime");
      const hasGoToAmazon = swatchFrameDetails.hasAmazonCTA || false;
      const goToAmazon = document.querySelector(".action--go-to-amazon-cta");
      const hasVideo = swatchFrameDetails.hasVideo;

      if (hasVideo) {
        displayVideoPDPThumbs(swatchFrameDetails);
        displayVideoPDP(swatchFrameDetails);
      }

      if (I18n.locale === 'en' || I18n.locale === 'qa' || I18n.locale === 'en-US' || I18n.locale === 'es-US' || I18n.locale === 'en-QA' || I18n.locale === 'es-QA') {
        let hasCollectiveBundles = findCollectiveBundleWrappers();
        if (hasCollectiveBundles.length) {
          const isChecked = isCollectiveBundleChecked();
          if (isChecked) {
            hideAllShippingElements('pdp');
            addCollectiveShippingDisclaimer('pdp');
            renderCollectiveBundlePricing();
          } else {
            removeCollectiveShippingDisclaimer ('pdp');
            updateDeliveryEstimateMessagePDP(swatchFrameDetails.sku);
            updateBopisMerchandisingPDP(swatchFrameDetails.sku);
            renderPrice();
          }
        } else {
          updateDeliveryEstimateMessagePDP(swatchFrameDetails.sku);
          updateBopisMerchandisingPDP(swatchFrameDetails.sku);
        }
      }
      renderMainImages(swatchFrameDetails);
      renderThumbnailImages(swatchFrameDetails);
      renderBadgeMessage(swatchFrameDetails);
      renderBarMessage(swatchFrameDetails);

      if (window.bwp !== undefined) {
        window.bwp.updateWidget(swatchFrameDetails.sku, 1, []);
      }

      const $bundleBox = $(getClassSelector(SELECTORS.BUNDLE_CONTAINER));
      if ($bundleBox) {
        hasBuyWithPrime ? $bundleBox.addClass('hide') : $bundleBox.removeClass('hide');
      }

      if (goToAmazon) {
        hasGoToAmazon ? goToAmazon.classList.remove('hide') : goToAmazon.classList.add('hide');
      }

      goToAmazonClick(swatchFrameDetails);

      if (buyWithPrime) {
        hasBuyWithPrime ? buyWithPrime.classList.remove('hide') : buyWithPrime.classList.add('hide');
      }

      if (bundleChecked() && hasGoToAmazon) {
        bundleUnchecked();
      }

      const swatches = document.querySelectorAll(getClassSelector(SELECTORS.SWATCHES_PDP));
      swatches.forEach(color => {
        if (color.getAttribute('data-color') === swatchColor) {
          color.classList.add('is-active');
        } else {
          color.classList.remove('is-active');
        }
      });

      const colorNames = document.querySelectorAll(".color-swatches__color-name");
      colorNames.forEach(color => {
        if (color.getAttribute('data-color') === swatchColor) {
          //update tooltip
          let toolTipInfo = color.querySelector(getClassSelector(SELECTORS.TOOLTIP_INFO));
          if (swatchFrameDetails.toolTip) {
            // if we have a tooltip, update text if element already exists
            if (toolTipInfo) {
              const toolTipText = toolTipInfo.querySelector('.action--js-tooltip-text');
              if (toolTipText) {
                toolTipText.textContent = swatchFrameDetails.toolTip;
                toolTipInfo.classList.remove('hide');
              } 
            } else {
              //create the tool tip element
              toolTipInfo = buildTooltipInfo(swatchFrameDetails.toolTip);
              color.appendChild(toolTipInfo);
            }
          }
          // hide if tooltip element exists but newly selected color does not have a tooltip
          else if (toolTipInfo) {
            toolTipInfo.classList.add('hide');
          }       
          color.classList.add('is-active');
        } else {
          color.classList.remove('is-active');
        }
      });

      if (swatchFrameDetails.discountCodeProduct) {
        renderDiscountCodeBadgePricePDP(swatchFrameDetails);
        renderDiscountCodeMessagePDP(swatchFrameDetails);
      }

      if (swatchFrameDetails.discountAmount !== '') {
        renderDiscountBadgePricePDP(swatchFrameDetails);
      }

      if(swatchFrameDetails.collection === 'carver-mat' || 'walden'){
        hideBopisBannerOnClay(swatchColor);
      }
    }

    $(getClassSelector(SELECTORS.SWATCHES_PDP)).each(function (i, swatch) {
      swatch.addEventListener('click', function (e) {
        const activeFrameDetails = window.getFrameDetailsByColor(activeFrame);
        const swatch = e.currentTarget;
        const swatchColor = swatch.getAttribute('data-color');
        const swatchFrameDetails = window.getFrameDetailsByColor(swatchColor) || {};

        const isColorDifferent = activeFrameDetails.color !== swatchFrameDetails.color

        if (isColorDifferent) {
          renderActivePDPColor(swatchFrameDetails, swatchColor);
        }
      });
    });

    $(getClassSelector(SELECTORS.BUNDLE_OPTION_WRAPPER)).each(function(index, color){
      const wrapper = document.querySelector(getClassSelector(SELECTORS.BUNDLE_CONTAINER));
      if (!wrapper) return;
      color.addEventListener('click', function(event){
        var bundleOptions = wrapper.querySelectorAll(getClassSelector(SELECTORS.BUNDLE_OPTION));
        if (bundleOptions) {
          bundleOptions.forEach(option => option.checked = false);
        }
        var selectedBundleColor = event.currentTarget.getAttribute('data-color');
        logGA4Event('select_bundle_option', {
          color: selectedBundleColor
        });
        logPavedEvent('select_bundle_option', {
          color: selectedBundleColor
        });
        color.querySelector('.bundle--option').classList.add('active');
        color.querySelector('.bundle--option').checked = true;
        $('.actions-frameInfo-bundle-currentColor').addClass('hide');
        $('.actions-frameInfo-bundle-currentColor').attr('aria-hidden', 'true');
        var currentColorClass = 'actions-frameInfo-bundle-currentColor.' + selectedBundleColor;
        $(getClassSelector(currentColorClass)).removeClass('hide')
        $(getClassSelector(currentColorClass)).attr('aria-hidden', 'false');
        $('.bundle--option').removeClass('active');
        quantityBundleHide();
        bundlePricing();
      })
    })

    if (isHomePage() || isShopFramesPage() || isFeaturedFramesPage() || isCorporateGifting()) {
      let allShopSections = shopSections();
      if (allShopSections) {
        let firstShopSection = allShopSections[0];
        if (firstShopSection) {
          observeShopSection(firstShopSection, () => {
            renderShopSectionTracking(firstShopSection);
          });
        }
      }
    }

    if (isCorporateGifting()) {
      renderHowItWorksSection();
      toggleAccordion();
    }

    if (isGiftGuide()) {
      toggleAccordion();
    }

    $(getClassSelector(SELECTORS.SWATCHES_HP)).each(function(i, swatch){
      swatch.addEventListener('click', function(e){
        var currencySymbol = getCurrencySymbol();
        var swatch = e.currentTarget;
        var swatchCollection = swatch.getAttribute('data-collection');
        var swatchColor = swatch.getAttribute('data-color');
        var swatchFrameDetails = window.getFrameDetailsByColor(swatchColor) || {};
        var hpOriginalPrices = document.querySelectorAll('.action--price-strike.action--frameInfo-price.' + swatchCollection)
        var hpPrices = document.querySelectorAll('.action--price.' + swatchCollection)
        var collectionLinks = document.querySelectorAll(".action--hp--link." + swatchCollection);
        var collectionImagesLinks = document.querySelectorAll(".action--hp--image-link." + swatchCollection);
        var collectionButtonTargets = document.querySelectorAll(".action--hp--btn." + swatchCollection) || document.querySelectorAll(".action--hp--link-btn." + swatchCollection);
        var collectionButtons = document.querySelectorAll(".action--hp--btn." + swatchCollection);
        var quickAddButtons = document.querySelectorAll(".action--quick-add-btn." + swatchCollection);
        var $storeSectionImage = $(getClassSelector(SELECTORS.STORE_SECTION_IMAGE + '.' + swatchCollection));
        var $storeSectionImageHover = $(getClassSelector(SELECTORS.STORE_SECTION_IMAGE_HOVER + '.' + swatchCollection));

        renderHPCollectionImages($storeSectionImage, swatchFrameDetails.collectionImageUrl, swatchFrameDetails.collectionImageUrlWebp, swatchFrameDetails);
        renderHPCollectionHoverImages($storeSectionImageHover, swatchFrameDetails.collectionHoverImageUrl, swatchFrameDetails.collectionHoverImageUrlWebp, swatchFrameDetails);

        logGA4Event('select_item', {
          item_list_id: "swatches_hp",
          item_list_name: "Swatches HP",
          items: [buildAnalyticsCartItem(swatchFrameDetails.class, 1)]
        });
        logPavedEvent('select_item', {
          item_list_id: "swatches_hp",
          item_list_name: "Swatches HP",
          items: [JSON.stringify(buildAnalyticsCartItem(swatchFrameDetails.class, 1))]
        });

        collectionButtonTargets.forEach(function(target){
          target.setAttribute('data-color', swatchFrameDetails.class);
        });

        quickAddButtons.forEach(function(target){
          target.setAttribute('data-color', swatchFrameDetails.class);
          target.setAttribute('class', 'action--quick-add-btn ' + swatchFrameDetails.class + ' ' + swatchFrameDetails.collection)
        });

        collectionLinks.forEach(function(elem) {
          elem.setAttribute('href', "/digital-frames/color/" + swatchFrameDetails.class)
        })
        collectionImagesLinks.forEach(function(elem) {
          elem.setAttribute('href', "/digital-frames/color/" + swatchFrameDetails.class)
          elem.setAttribute('data-color', swatchFrameDetails.color)
          elem.setAttribute('alt', swatchFrameDetails.collectionAlt)
          elem.setAttribute('class', 'product__link-wrapper action--hp--image-link ' + swatchFrameDetails.class + ' ' + swatchFrameDetails.collection)
        })
        collectionButtons.forEach(function(elem) {
          elem.setAttribute('data-is-sold-out', swatchFrameDetails.isSoldOut)
        })

        var $swatches = $('.hp--swatch.' + swatchCollection);
        $swatches.removeClass('active');
        $(swatch).addClass('active');

        const hasDiscountCode = swatchFrameDetails.discountCodeProduct === true
        const hasOriginalPrice = swatchFrameDetails.originalPrice !== '' && swatchFrameDetails.originalPrice !== undefined;

        hpPrices.forEach(hpPrice => {

          const discountPrice = discount_code_data_by_type(swatchFrameDetails, 'discountPrice');

          if (hasDiscountCode) {
            if (hpPrice.getAttribute('data-frame-set') === 'false') {
              hpPrice.innerText = getPriceOrientation(discountPrice, currencySymbol);
            }
          } else {
            if (hpPrice.getAttribute('data-frame-set') === 'false') {
              hpPrice.innerText = getPriceOrientation(swatchFrameDetails.price, currencySymbol);
            }
          }
          hpPrice.setAttribute('data-color', swatchFrameDetails.class);
        });

        hpOriginalPrices.forEach(hpOriginalPrice => {
          if (hasDiscountCode) {
            hpOriginalPrice.classList.remove('opacity-0');
            if (hpOriginalPrice.getAttribute('data-frame-set') === 'false') {
              hpOriginalPrice.innerText = getPriceOrientation(swatchFrameDetails.price, currencySymbol);
            }
          } else if (hasOriginalPrice) {
            const selectorOriginalPrice = getPriceOrientation(swatchFrameDetails.originalPrice, currencySymbol);
            hpOriginalPrice.innerText = selectorOriginalPrice;
            hpOriginalPrice.classList.remove('opacity-0')
          } else if (hpOriginalPrices.length > 0) {
            hpOriginalPrices.forEach(function(hpOriginalPrice){
              if (hpOriginalPrice.getAttribute('data-frame-set') === 'false') {
                hpOriginalPrice.classList.add('opacity-0')
              }
            })
          }
          hpOriginalPrice.setAttribute('data-color', swatchFrameDetails.class);
        });

        if (swatchFrameDetails.discountCodeProduct == true) {
          renderDiscountCodeMessageHP(swatchFrameDetails)
          renderDiscountCodePriceHP(swatchFrameDetails)
        }
      })
    })

    $(getClassSelector(SELECTORS.QUANTITY)).on('click', function() {
      $(this).select();
    });

    $(getClassSelector(SELECTORS.GIFT_BAG)).on('click', function () {
        updateDeliveryEstimateMessageCart();
        giftBagToggle();
        updateCartUrl();
    });

    $(getClassSelector(SELECTORS.QUANTITY)).on('change', function (e) {
      updateViewingQuantity(Number(e.target.value));
      renderQuantity();
    })

    $(getClassSelector(SELECTORS.INCREMENT_QUANTITY)).on('click', function () {
      if (!bundleChecked()) {
        incrementQuantity();
        renderQuantity();
      }
    });

    $(getClassSelector(SELECTORS.DECREMENT_QUANTITY)).on('click', function () {
      if (!bundleChecked()) {
        decrementQuantity();
        renderQuantity();
      }
    })

    $(getClassSelector(SELECTORS.BUNDLE)).on('click', function () {
      const activeFrame = window.getFrameDetailsByColor(activeFrame);
      quantityBundleHide();
      renderDisableDecrementQuantity();
      renderDisableIncrementQuantity();
      bundlePricing();
      renderDiscountBadgePricePDP(activeFrame);
    });

    function buildTooltipInfo(toolTipText) {
      // Outer wrapper
      const tooltipInfo = document.createElement('div');
      tooltipInfo.className = 'tooltip-info';
    
      // Symbol
      const tooltipSymbol = document.createElement('div');
      tooltipSymbol.className = 'tooltip-info__symbol';
      tooltipSymbol.textContent = 'i';
    
      // Text container
      const tooltipText = document.createElement('div');
      tooltipText.className = 'tooltip-info__text action--js-tooltip-text';
      tooltipText.textContent = toolTipText;
    
      // Append children
      tooltipInfo.appendChild(tooltipSymbol);
      tooltipInfo.appendChild(tooltipText);
    
      return tooltipInfo;
    }

    function renderCollectiveBundleBox(color) {
      document.querySelectorAll(getClassSelector(SELECTORS.COLLECTIVE_BUNDLE))
      .forEach(wrapper => {
        wrapper.classList.toggle('hide', wrapper.getAttribute('data-color') !== color);
        wrapper.setAttribute('data-active', wrapper.getAttribute('data-color') == color ? 'true' : 'false');
        wrapper.setAttribute('aria-hidden', wrapper.getAttribute('data-color') == color ? 'false' : 'true');
      });
    }

    function collectiveBundleCheckboxToggle() {
      const isChecked = isCollectiveBundleChecked();
      const collectiveBundleWrappers = document.querySelectorAll(getClassSelector(SELECTORS.COLLECTIVE_BUNDLE));

      if (collectiveBundleWrappers) {
        collectiveBundleWrappers.forEach(collectiveBundleWrapper => {
          collectiveBundleWrapper.classList.toggle('active', isChecked);
        })
      }

      if (isChecked) {
        renderCollectiveBundlePricing();
        hideAllShippingElements('pdp');
        addCollectiveShippingDisclaimer('pdp');
      } else {
        renderPrice();
        updateDeliveryEstimateMessagePDP();
        removeCollectiveShippingDisclaimer('pdp');
      }
    }

    function findCollectiveBundleWrappers() {
      const wrappers = document.querySelectorAll(getClassSelector(SELECTORS.COLLECTIVE_BUNDLE));
      return wrappers;
    }

    function setFirstAvailableBundle() {
      const wrappers = document.querySelectorAll(getClassSelector(SELECTORS.COLLECTIVE_BUNDLE));
      if (!wrappers) return;
      wrappers.forEach(wrapper => {
        //get first available color option
        const availableColors = wrapper.querySelectorAll(getClassSelector(SELECTORS.COLLECTIVE_BUNDLE_OPTION));
        if (!availableColors || availableColors.length === 0) return;
        const color = availableColors[0].dataset.color
        toggleActiveCollectiveImg(wrapper, color)
        toggleActiveBundleOption(wrapper, color)
      });
    }

    function initCollectiveBundleCheckboxListeners() {
      document.addEventListener('click', function(event) {
        const selector = getClassSelector(SELECTORS.COLLECTIVE_BUNDLE_CHECKBOX);
        const clickedCheckbox = event.target.closest(selector);

        if (!clickedCheckbox) return;

        // Get all checkboxes with the same selector
        const allCheckboxes = document.querySelectorAll(selector);

        allCheckboxes.forEach(checkbox => {
          checkbox.checked = clickedCheckbox.checked;
        });

        collectiveBundleCheckboxToggle();

        const selectedColor = getSelectedCollectiveBundleOption();
        logGA4Event('collective_product_checkbox_click', {
          color: selectedColor
        });
      });
    }

    function setActiveCollectiveBundleImage(closestBundle, color) {
      if (closestBundle.dataset.active === "true") {
        toggleActiveCollectiveImg(closestBundle, color)
      }
    }

    function toggleActiveCollectiveImg(closestBundle, color) {
      // Extract the base color from the selected color
      const baseColorMatch = color.match(/-([^-]+)$/);
      if (!baseColorMatch) return;
      const baseColor = baseColorMatch[1];

      const collectiveBundleImages = document.querySelectorAll(getClassSelector(SELECTORS.COLLECTIVE_MAIN_BUNDLE_IMAGE));

      collectiveBundleImages.forEach(function(image) {
        const imageColor = image.dataset.color;
        const imageBaseMatch = imageColor ? imageColor.match(/-([^-]+)$/) : null;
        const imageBaseColor = imageBaseMatch ? imageBaseMatch[1] : null;

        const isActive = imageBaseColor === baseColor;

        image.classList.toggle('active', isActive);

        const closestWrapper = image.closest(getClassSelector(SELECTORS.COLLECTIVE_MAIN_BUNDLE_IMAGE_WRAPPER));
        if (closestWrapper) {
          closestWrapper.classList.toggle('active', isActive);
        }
      });
    }

    function setActiveBundleOption(closestBundle, selectedColor) {
      if (closestBundle.dataset.active === "true") {
        toggleActiveBundleOption(closestBundle, selectedColor)
      }
    }

    function toggleActiveBundleOption(closestBundle, selectedColor) {
      // Extract base color from the selected color
      const baseColorMatch = selectedColor.match(/-([^-]+)$/);
      if (!baseColorMatch) return;
      const baseColor = baseColorMatch[1];

      const optionSelector = getClassSelector(SELECTORS.COLLECTIVE_BUNDLE_OPTION) + ', ' + getClassSelector(SELECTORS.COLLECTIVE_BUNDLE_OPTION_IMAGE);

      document.querySelectorAll(optionSelector).forEach(element => {
        const elementColor = element.dataset.color;
        const elementBaseMatch = elementColor ? elementColor.match(/-([^-]+)$/) : null;
        const elementBaseColor = elementBaseMatch ? elementBaseMatch[1] : null;

        const isSelected = elementBaseColor === baseColor;

        element.classList.toggle('active', isSelected);

        if (element.type === 'radio' || element.type === 'checkbox') {
          element.checked = isSelected;
        }
      });
    }


    function quickViewCarousel(carouselsSelector) {
      const carousels = carouselsSelector;
      if (!carousels.length) return;
    
      carousels.forEach((carousel) => {
        const track = carousel.querySelector(".action--quick-view--carousel-track");
        const btnLeft = carousel.querySelector(".action--quick-view--image-gallery-arrow-left");
        const btnRight = carousel.querySelector(".action--quick-view--image-gallery-arrow-right");
    
        if (!track || !btnLeft || !btnRight) return;
    
        let current = 0;
        let scrollDriven = true;
    
        function resetCarousel() {
          current = 0;
          const slides = Array.from(
            track.querySelectorAll(".action--quick-view--carousel-slide")
          );
          track.scrollLeft = 0;
    
          if (slides.length > 0) {
            scrollDriven = false;
            track.scrollTo({ left: 0, behavior: "auto" });
    
            setTimeout(() => {
              scrollDriven = true;
              updateButtons(slides);
            }, 10);
          }
        }
    
        // Attach reset so closePopup can call it
        carousel.resetQuickView = resetCarousel;
    
        function scrollToIndex(index, slides) {
          const slide = slides[index];
          if (!slide) return;
    
          const containerWidth = track.offsetWidth;
          const slideWidth = slide.offsetWidth;
          const offset = slide.offsetLeft;
    
          scrollDriven = false;
          track.scrollTo({
            left: offset - containerWidth / 2 + slideWidth / 2,
            behavior: "smooth"
          });
    
          setTimeout(() => (scrollDriven = true), 350);
          updateButtons(slides);
        }
    
        function updateButtons(slides) {
          const slidesCount = slides.length;
          btnLeft.disabled = current === 0;
          btnRight.disabled = current === slidesCount - 1;
        }
    
        function updateActiveNearest(slides) {
          if (!scrollDriven) return;
    
          const center = track.scrollLeft + track.offsetWidth / 2;
    
          let nearestIndex = 0;
          let minDist = Infinity;
    
          slides.forEach((slide, i) => {
            const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
            const dist = Math.abs(slideCenter - center);
            if (dist < minDist) {
              minDist = dist;
              nearestIndex = i;
            }
          });
    
          if (nearestIndex !== current) {
            current = nearestIndex;
            updateButtons(slides);
          }
        }
    
        // --- Event Listeners ---
        btnLeft.addEventListener("click", () => {
          const slides = Array.from(track.querySelectorAll(".action--quick-view--carousel-slide"));
          if (current > 0) {
            current -= 1;
            scrollToIndex(current, slides);
          }
        });
    
        btnRight.addEventListener("click", () => {
          const slides = Array.from(track.querySelectorAll(".action--quick-view--carousel-slide"));
          if (current < slides.length - 1) {
            current += 1;
            scrollToIndex(current, slides);
          }
        });
    
        track.addEventListener("scroll", () => {
          const slides = Array.from(track.querySelectorAll(".action--quick-view--carousel-slide"));
          updateActiveNearest(slides);
        });
    
        window.addEventListener("resize", () => {
          const slides = Array.from(track.querySelectorAll(".action--quick-view--carousel-slide"));
          scrollToIndex(current, slides);
        });
    
        // Wait for all slides to be ready
        const checkSlidesReady = setInterval(() => {
          const slides = Array.from(track.querySelectorAll(".action--quick-view--carousel-slide"));
          const allReady = slides.every(slide => slide.classList.contains('is-ready'));
    
          if (allReady) {
            clearInterval(checkSlidesReady);
            current = 0;
            scrollToIndex(current, slides);
            updateButtons(slides);
          }
        }, 20);
      });
    }
    
    $(getClassSelector(SELECTORS.ADD_TO_CART)).on('click', async function () {
      // Select the existing error container and clear previous errors
      const errorMsg = document.querySelector('.action--error-message');
      if (errorMsg) {
        errorMsg.textContent = '';
        errorMsg.style.opacity = '1';
      }

      const button = this;
      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = getAddingToCartTranslation();

      try {
        const currentActiveFrame = COLOR_TO_ENUM[activeFrame];
        if (bundleChecked()) {
          logGA4Event('bundle_checked', { color: currentActiveFrame });
          logPavedEvent('bundle_checked', { color: currentActiveFrame });

          const bundleCartItem = bundleFrameColorData();
          if (bundleCartItem.color === currentActiveFrame) {
            await addToCartFlow(currentActiveFrame, 2);
          } else {
            await addToCartFlow(currentActiveFrame, 1);
            await addToCartFlow(bundleCartItem.color, 1);
          }
        } else if (collectiveBundleUpsellChecked()) { //cs collective bundle box 
          await addToCartFlow(currentActiveFrame, 1);
          //get variant that is checked
          let activeCollectiveVariant = document.getElementById('action--collective-bundle-cta').dataset.color;
          addToCartFlow(activeCollectiveVariant, 1)
        }
          else if (isCollectiveBundleChecked()) {
          await addToCartFlow(COLOR_TO_ENUM[getSelectedCollectiveBundleOption()], 1);
           await addToCartFlow(currentActiveFrame, 1);
        } else {
          await addToCartFlow(currentActiveFrame, 1);
        }

        renderQuantity();
        if (!isCartOpen) {
          flashCartOpen();
        }
        bindCartToggleListeners();

      } catch (error) {
        console.error('Add to cart failed:', error);

        if (errorMsg && errorMsg.classList.contains('action--error-message')) {
          errorMsg.textContent = 'Could not add to cart. Please try again.';
          // Fade out after 3 seconds
          setTimeout(() => {
            let opacity = 1;
            const fadeInterval = setInterval(() => {
              opacity -= 0.05;
              if (opacity <= 0) {
                opacity = 0;
                clearInterval(fadeInterval);
                errorMsg.textContent = ''; // clear for next error
              }
              errorMsg.style.opacity = opacity;
            }, 30);
          }, 3000);
        }
      } finally {
        // Restore button text & enable
        button.disabled = false;
        button.textContent = originalText;
      }
    });

    $(getClassSelector(SELECTORS.CART_GIFT_CONTAINER)).on('click', function() {
      sendCartGiftAnalytics();
    });
    $(getClassSelector(SELECTORS.CART_OPENER)).on('click', function () {
      renderCart();
      renderOpenCart('Cart Button');
      sendOpenCartAnalytics();
      bindCartToggleListeners();
      findCartItemIndex();
    })

    $(getClassSelector(SELECTORS.CART_CLOSER)).on('click', function() {
      renderCloseCart('Close Button');
      unbindCartToggleListeners();
      hideOverlay();
    })

    $(getClassSelector(SELECTORS.CART_CHECKOUT)).on('click', function() {
      sendCartCheckoutAnalytics()
    });

    $(getClassSelector(SELECTORS.CART_POPUP)).mouseenter(function () {
      stopAutoCloseCountdown();
    });

    if(isOrderPage()){
      logGA4Event('view_item', {
        currency: getLocaleCurrency(),
        value: activeFrame.price,
        items: [buildAnalyticsCartItem(activeFrame, 1)]
      });
      logPavedEvent('view_item', {
        currency: getLocaleCurrency(),
        value: activeFrame.price,
        items: [JSON.stringify(buildAnalyticsCartItem(activeFrame, 1))]
      });
      logSnapEvent('VIEW_CONTENT', {
        'price': activeFrame.price,
        'currency': getLocaleCurrency(),
        'item_ids': [activeFrame.productId],
        'item_category': 'product',
      })
      let axonItem = window.getFrameDetailsByColor(activeFrame);
      logAxonEvent('view_item', {
        currency: getLocaleCurrency(),
        items: buildAxonCartItems(axonItem, 1),
        value: subtotal(),
      })
     window.addEventListener('popstate', function () {
        setActiveFrameFromUrl();
        onChangeFrame();
        const frameDetailsFound = window.getFrameDetailsByColor(activeFrame);
        renderActivePDPColor(frameDetailsFound, frameDetailsFound.class);
      });
      $(document).on('click', 'a[href^="/digital-frames/color"]', function (e) {
        if (!(e.shiftKey || e.metaKey || e.altKey)) {
          e.preventDefault();
          var path = $(this).attr('href');
          if (window.location.pathname != path) {
            window.history.pushState({
              path: path
            }, document.title, window.location.protocol + '//' + window.location.host + path);
            setActiveFrameFromUrl();
            onChangeFrame();
          }
        }
      });
    }
    localLocale();
    countryPickerLocale();
  }

  function initOnLoad() {
    if (isProductPage()) {
      renderMainImages(frameDetails);
      renderPDPVideo();
      hideBopisBannerOnClay(frameDetails.class);
    }
    if (isMultishipShippingMethodPage()) {
      giftNoteValidation();
      giftNoteCharCount();
    }
  }

  const frameDetails = window.getFrameDetailsByColor(activeFrame);
  init(frameDetails);
  
  if (document.readyState === "complete") {
    initOnLoad();
  } else {
    window.addEventListener("load", initOnLoad());
  }

})(jQuery)
;
(function($) {

  function initializeMousewheelScroll($carousel) {
    let blocked = false;
    let blockTimeout = null;
    let prevDeltaX = 0;

    $carousel.on('mousewheel DOMMouseScroll wheel', function(e) {
        let deltaX = e.originalEvent.deltaX;
        let deltaY = e.originalEvent.deltaY;

        // Ignore vertical scroll
        if (Math.abs(deltaX) > Math.abs(deltaY)) {
            e.preventDefault();
            e.stopPropagation();

            clearTimeout(blockTimeout);
            blockTimeout = setTimeout(function() {
                blocked = false;
            }, 10);

            if (deltaX > 0 && deltaX > prevDeltaX || deltaX < 0 && deltaX < prevDeltaX || !blocked) {
                blocked = true;
                prevDeltaX = deltaX;

                if (deltaX > 0) {
                    $carousel.slick('slickNext');
                } else {
                    $carousel.slick('slickPrev');
                }
            }
        }
    });
  }


  $('.ig-carousel-container').slick({
    centerMode: true,
    slidesToShow: 3,
    arrows: true,
    centerPadding: '10%',
    prevArrow: $('.section--carousel-ig #prevArr'),
    lazyLoad: false,
    nextArrow: $('.section--carousel-ig #nextArr'),
    responsive: [
      {
        breakpoint: 769,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '10%',
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: true,
          slidesToShow: 1
        }
      }
    ]
  });
  var $prevArr = $('.section-carousel .carousel-arrow--left');
  var $nextArr = $('.section-carousel .carousel-arrow--right');
  function isMobile() {
    if(window.innerWidth < 640){
      return true
    }
    return false
  }

  function makeDefaultCarousels(carousel){
    var $carousel = $(carousel).find('.carousel');
    $carousel.slick();
  }

  function makeCarousels(carousel) {
    var $carousel = $(carousel).find('.carousel');
    var $prevArr = $(carousel).find('.carousel-arrow-previous');
    var $nextArr = $(carousel).find('.carousel-arrow-next');
    $carousel.slick({
      arrows: true,
      dots: true,
      lazyLoad: false,
      dotsClass: 'carousel-dots-white',
      nextArrow: $nextArr,
      prevArrow: $prevArr,
    })
  }

  function makeMobileCarouselPDP(){
    var carousel = '.action--carousel-pdp--section';
    var $carousel = $(carousel).children('.action--carousel-pdp');
    $($carousel).not('.slick-initialized').slick({
      ada: false,
      arrows: false,
      dots: false,
      lazyLoad: false,
      speed: 300,
      dotsClass: 'carousel-dots-white',
      slidesToShow: 1.25,
      centerMode: false,
      lazyLoad: 'ondemand',
      centerPadding: '16px',
      mobileFirst: true,
      infinite: false,
      slickFilter: '.hide-from-slider',
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 640,
          settings: "unslick"
      }
    ]
    })
    $carousel.find(".slick-slide").on("click", function() {
      var clickedIndex = $(this).data("slick-index");
      var currentSlide = $carousel.slick("slickCurrentSlide");

      if (clickedIndex === currentSlide - 1) {
        $carousel.slick("slickPrev");
      } else if (clickedIndex === currentSlide + 1) {
        $carousel.slick("slickNext");
      }
    });
  }

  function makeMobileCarouselPDPFeatures(){
    var carousel = '.action--carousel-pdp-features--section';
    var $carousel = $(carousel).children('.action--carousel-pdp-features');
    var $prevArr = $(carousel).find('.carousel-arrow-previous');
    var $nextArr = $(carousel).find('.carousel-arrow-next');
    $($carousel).not('.slick-initialized').slick({
      ada: false,
      arrows: true,
      dots: false,
      lazyLoad: true,
      speed: 300,
      dotsClass: 'carousel-dots-white',
      slidesToShow: 1,
      centerMode: false,
      centerPadding: '16px',
      mobileFirst: true,
      infinite: false,
      slickFilter: '.hide-from-slider',
      swipeToSlide: true,
      nextArrow: $nextArr,
      prevArrow: $prevArr,
      responsive: [
        {
          breakpoint: 640,
          settings: "unslick"
      }
    ]
    })
    initializeMousewheelScroll($carousel);
  }

  function makeProductHighlightCarousel() {
    if(isMobile()){
      var carousel = '.action--carousel-product-highlight';
      var $carousel = $(carousel);

      // Initialize the Slick carousel if it's not already initialized
      if (!$carousel.hasClass('slick-initialized')) {
        $carousel.slick({
          useAutoplayToggleButton: false,
          centerMode: true,
          centerPadding: '60px',
          slidesToShow: 1,
          infinite: false,
          arrows: false,
          lazyLoad: true,
          touchMove: true,
          touchThreshold: 10,
          swipeToSlide: true,
        });
      }

      $carousel.find(".slick-slide").on("click", function() {
        var clickedIndex = $(this).data("slick-index");
        var currentSlide = $carousel.slick("slickCurrentSlide");

        if (clickedIndex === currentSlide - 1) {
          $carousel.slick("slickPrev");
        } else if (clickedIndex === currentSlide + 1) {
          $carousel.slick("slickNext");
        }
      });

      initializeMousewheelScroll($carousel);
    }
  }

  $(window).resize(function(e){
    var carouselPDP = '.action--carousel-pdp--section';
    var carouselFeatures = '.action--carousel-pdp-features--section';
    var carouselHighlights = '.action--carousel-product-highlight';
    var carouselHighlightsSlick = $(carouselHighlights).hasClass('slick-initialized')

    if (window.innerWidth < 640) {
      if (!$(carouselPDP).hasClass('slick-initialized')) {
        makeMobileCarouselPDP();
      }
      if (!$(carouselFeatures).hasClass('slick-initialized')) {
        makeMobileCarouselPDPFeatures();
      }
      if (!carouselHighlightsSlick) {
        makeProductHighlightCarousel();
      }

    } else {
      if (carouselHighlightsSlick) {
        $(carouselHighlights).slick('unslick');
      }
      if ($(carouselFeatures).hasClass('slick-initialized')) {
        $(carouselFeatures).slick('unslick');
      }
    }
  });

  function makeMobileCarousels(carousel){
    if(isMobile()){
      var $prevArr = $(carousel).find('.carousel-arrow-previous');
      var $nextArr = $(carousel).find('.carousel-arrow-next');
      var $carousel = $(carousel).children('.mobile-carousel');

      if($carousel.attr('data-slick')){
        $($carousel).slick({});
      } else {
        $($carousel).slick({
          arrows: true,
          dots: true,
          lazyLoad: false,
          dotsClass: 'carousel-dots-white',
          nextArrow: $nextArr,
          prevArrow: $prevArr,
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '16px'
        })
      }
      var experiment = $(carousel).children('.mason-experiment');
      if($(experiment).css('display') == 'none'){
        $(carousel).slick('slickRemove', $(experiment).attr('data-slide-index'));
      }
    }
  }

  function makePressTextCarousel() {
    $('.carousel--press_text').slick({
      useAutoplayToggleButton: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      dotsClass: 'carousel-dots',
      centerMode: true,
      fade: true,
      prevArrow: $('.carousel--press .carousel-arrow-previous'),
      nextArrow:  $('.carousel--press .carousel-arrow-next'),
      adaptiveHeight: false,
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      useTransform: true,
      speed: 300,
      cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
    });
  }

  function makePressLogoCarousel() {
  $('.action--carousel--press-logos')
    .on('init', function (event, slick) {
      $('.action--carousel--press-logos .slick-slide.slick-current').addClass('is-active');
    })
    .slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: false,
      fade: true,
      focusOnSelect: false,
      infinite: true,
      fade: false,
      arrows: false,
      lazyLoad: false,
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      }, {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          dotsClass: 'carousel-dots',
          draggable: 'false',
          swipe: 'false',
          swipeToSlide: 'false',
          touchMove: 'false',
          draggable: 'false',
                  }
      }]
    });
  }

  $('.carousel--press_text').on('afterChange', function (event, slick, currentSlide) {
    $('.action--carousel--press-logos').slick('slickGoTo', currentSlide);
    var currrentNavSlideElem = '.action--carousel--press-logos .slick-slide[data-slick-index="' + currentSlide + '"]';
    $('.action--carousel--press-logos .slick-slide.is-active').removeClass('is-active');
    $(currrentNavSlideElem).addClass('is-active');
  });

  $('.action--carousel--press-logos').on('click', '.slick-slide', function (event) {
    event.preventDefault();
    var goToSingleSlide = $(this).data('slick-index');
    $('.carousel--press_text').slick('slickGoTo', goToSingleSlide);
  });

  function addMoveLeftClass() {
    const slickList = document.querySelectorAll('.action--move-left .slick-track');
    slickList.forEach(element => {
      element.classList.add('move-left');
    });
  }

  function removeMoveLeftClass() {
    const slickList = document.querySelectorAll('.action--move-left .slick-track');
    slickList.forEach(element => {
      element.classList.remove('move-left');
    });
  }

  /* Check if the current page is the shop-frames page or homepage with an anchor link */
  function isShopFramesURL() {
    return window.location.pathname.includes('shop-frames') || window.location.hash.includes('shop-frames');
  }

  function init() {
    runMobileCarousel();

    window.addEventListener("load", function() {
      makePressTextCarousel();
      makePressLogoCarousel();
      var carouselPDP = '.action--carousel-pdp--section';
      var carouselPDPSlick = $(carouselPDP).hasClass('slick-initialized')

      var carouselFeatures = '.action--carousel-pdp-features--section';
      var carouselFeaturesSlick = $(carouselFeatures).hasClass('slick-initialized')

      var carouselHighlights = '.action--carousel-product-highlight';
      var carouselHighlightsSlick = $(carouselHighlights).hasClass('slick-initialized')

      var $regularCarousels = $('.carousel-section');
      var $defaultCarousels = $('.carousel-section--default');
      var $mobileCarousels = $('.mobile-carousel-section')

      $defaultCarousels.each(function () {
        makeDefaultCarousels(this);
      });
      $regularCarousels.each(function () {
        makeCarousels(this);
      });
      $mobileCarousels.each(function () {
        makeMobileCarousels(this);
      });

      if (!carouselHighlightsSlick) {
        makeProductHighlightCarousel();
      }
      if (!carouselPDPSlick) {
        makeMobileCarouselPDP();
      }
      if (!carouselFeaturesSlick) {
        makeMobileCarouselPDPFeatures();
      }

      addMoveLeftClass();
      setTimeout(() => {
        removeMoveLeftClass();
      }, 1000);
    });
  }


  function runMobileCarousel(){
    if (isMobile()) {
      $('.carousel-container').slick({
        arrows: true,
        centerMode: true,
        centerPadding: '10%',
        lazyLoad: false,
        nextArrow: $nextArr,
        prevArrow: $prevArr,
        slidesToShow: 1,
      });
    }
  }

  $('.mobile-specs-carousel-container').slick({
    centerMode: true,
    slidesToShow: 1,
    centerPadding: '7.5%',
    arrows: false,
    dots: true,
    swipe: true,
    dotsClass: 'carousel-dots',
    initialSlide: 1,
  });

  $('.product--carousel').slick({
      infinite: true,
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 3500,
      useAutoplayToggleButton: false,
      arrows: true,
      centerPadding: '0',
      prevArrow: $('#prevArr-product'),
      lazyLoad: false,
      nextArrow: $('#nextArr-product'),
      arrows: true,
      dots: false,
      swipe: true,
      centerMode: true
    });

   init();

  var shots = document.querySelectorAll('.ig-carousel-item.carousel-item');
  var $stampedModal = $('#modal--stamped');
  var $stampedPrevArrow = $("#stamped-prevArr");
  var $stampedNextArrow = $("#stamped-nextArr");
  $('#prevArr-igCarousel').on('click', function(e) {
    var width = Number($('#container-scroll-ig').width());
    var prev = $('#container-scroll-ig').scrollLeft();
    $('#container-scroll-ig').animate({
      scrollLeft: prev - width
    })
  })
  $('#nextArr-igCarousel').on('click', function(e) {
    var width = Number($('#container-scroll-ig').width());
    var prev = $('#container-scroll-ig').scrollLeft();

    $('#container-scroll-ig').animate ({
      scrollLeft: prev + width
    })
  })
  var $carouselIG = $('.stamped-ugc-wrapper');
  $carouselIG.on('change', function(e) {
    changeModalImage(shots[carouselIndex]);
    $stampedModal.modal();
  })
  $stampedPrevArrow.click( function(e) {
    var carouselIndex = parseFloat($carouselIG.attr('data-review-index'));

    if (carouselIndex == 0) {
      $carouselIG.attr('data-review-index', shots.length);
      changeModalImage(shots[shots.length]);
    } else {
      $carouselIG.attr('data-review-index',  carouselIndex - 1);
      changeModalImage(shots[carouselIndex - 1]);
    }
  })
  $stampedNextArrow.click( function(e) {
    var carouselIndex = parseFloat($carouselIG.attr('data-review-index'));
    if (carouselIndex == (shots.length - 1)) {
      $carouselIG.attr('data-review-index', 0);
      changeModalImage(shots[0]);
    } else {
      $carouselIG.attr('data-review-index',  carouselIndex + 1);
      changeModalImage(shots[carouselIndex + 1]);
    }
  })
  function changeModalImage(item){
    var data = $(item).data();
    $stampedModal.find('.stamped-ugc-image').attr('src', data.imageurl)
    $stampedModal.find('.stamped-ugc-created').text(data.datecreated)
    $stampedModal.find('.stamped-ugc-comments').text(data.countcomments)
    $stampedModal.find('.stamped-ugc-caption').text(data.mediatext)
    if(data.username.match(/auraframes/)){
      $stampedModal.find('.stamped-ugc-verified').addClass('invisible')
    } else {
      $stampedModal.find('.stamped-ugc-verified').removeClass('invisible')

    }
    $stampedModal.find('.stamped-ugc-user').text(data.username)
    $stampedModal.find('.stamped-ugc-product-img').attr('src', data.productimage)
    $stampedModal.find('.stamped-ugc-product-link').attr('href', data.productlink)
    $stampedModal.find('.stamped-ugc-product-title').text(data.producttitle)
  }
  if(shots.length > 0){
    shots.forEach(function(item, idx) {
      item.addEventListener('click', function() {
        changeModalImage(shots[idx])
        $stampedModal.modal()
      })
    })
  }

})(jQuery);
/* global jQuery */

(function ($) {
  'use strict';

  var REVEALED_CLASS = 'js-mobile-navbar--reveal'
  var BLUR_CLASS = 'blur'

  function dismiss ($target, $blur) {
    $target.removeClass(REVEALED_CLASS)
    $blur.removeClass(BLUR_CLASS)

    $target.off('click.mobile-navbar.dismiss')
    $(document).off('keydown.mobile-navbar.dismiss')
    $(window).off('resize.mobile-navbar.dismiss')
  }

  $(document).on('click.mobile-navbar', '[data-toggle="mobile-navbar"]', function (e) {
    var target = e.currentTarget.getAttribute('data-target')
    var $target = $(target)
    var $blur = $(document.body)

    $target.toggleClass(REVEALED_CLASS)
    $blur.toggleClass(BLUR_CLASS)
    $(document).on('click', function(e) {
      var target = e.target;
      if(target.classList.contains('overlay')){
        dismiss($target, $blur)
      }
    })
    $(document).on('keydown.mobile-navbar.dismiss', function (e) {
      if (e.which === 27) {
        dismiss($target, $blur)
      }
    })
    $(document).on('click', '.js-mobile-navbar--reveal a[href^="/#"]', function () {
      dismiss($target, $blur)
    });
  })

  const navbar = document.getElementById("navbar");
  const hamburger = document.querySelector('.container--hamburger');

  if (navbar) {
    function changeMargin() {
      if (hamburger) hamburger.style.paddingTop = navbar.offsetHeight + "px";
    }

    changeMargin();

    new ResizeObserver(changeMargin).observe(navbar);
  }

})(jQuery);

window.changeToFlagLocale = function(event){
    // See comment in other place we set `country_set` cookie with JavaScript for reason why we set it in multiple places
    if(!I18n){ return }
    var flagClasses = event.target.classList;
    var newLocale;
    flagClasses.forEach(function(className){
      if(className.match(/en/)){
        newLocale = className
      }
    })
    if(newLocale != I18n.locale){
      var expirationDate = new Date();
      expirationDate.setDate(expirationDate.getDate() + 365);
      switch (newLocale){
        case 'en-GB':
          document.cookie='country_set=GB;expires=' + expirationDate + ';path=/;';
          break;
        case 'en-CA':
          document.cookie='country_set=CA;expires=' + expirationDate + ';path=/;';
          break;
        case 'en':
          document.cookie='country_set=US;expires=' + expirationDate + ';path=/;';
          break;
        case 'fr':
          document.cookie='country_set=FR;expires=' + expirationDate + ';path=/;';
          break;
        case 'de':
          document.cookie='country_set=DE;expires=' + expirationDate + ';path=/;';
          break;
        default:
          document.cookie='country_set=US;expires=' + expirationDate + ';path=/;';
          break;
      }
      return true
    }
}
;
// FIXME: remove after mega nav A/B test (and the require in marketing/manifest.js)
(function () {
  function init() {
    var toggle = document.querySelector('.action--mega-nav-toggle');
    var panel = document.getElementById('mega-nav-shop-frames');
    var header = document.getElementById('navbar');
    if (!toggle || !panel) return;
    var showedOverlay = false;
    var lowerHeaderTimeout = null;
    var OVERLAY_FADE_MS = 300;

    var OVERLAY_OPENERS = '.cart-toggle, .action--location-selector-open';

    function onDocumentClick(event) {
      if (panel.contains(event.target) || toggle.contains(event.target)) return;
      close({ keepOverlay: !!event.target.closest(OVERLAY_OPENERS) });
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        close();
        toggle.focus();
      }
    }

    function open() {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      toggle.classList.add('is-open');
      clearTimeout(lowerHeaderTimeout);
      if (header) header.classList.add('navbar--mega-open');
      if (typeof window.showOverlay === 'function') {
        window.showOverlay();
        showedOverlay = true;
      }
      document.addEventListener('click', onDocumentClick);
      document.addEventListener('keydown', onKeydown);
      window.dispatchEvent(new Event('resize'));
    }

    function close(options) {
      var keepOverlay = options && options.keepOverlay;
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.classList.remove('is-open');
      if (showedOverlay && !keepOverlay && typeof window.hideOverlay === 'function') {
        window.hideOverlay();
      }
      clearTimeout(lowerHeaderTimeout);
      lowerHeaderTimeout = setTimeout(function () {
        if (header) header.classList.remove('navbar--mega-open');
      }, keepOverlay ? 0 : OVERLAY_FADE_MS);
      showedOverlay = false;
      document.removeEventListener('click', onDocumentClick);
      document.removeEventListener('keydown', onKeydown);
    }

    var HOVER_OPEN_DELAY_MS = 100;
    var HOVER_CLOSE_DELAY_MS = 250;
    var HOVER_CLICK_GRACE_MS = 600;
    var hoverOpenedAt = 0;
    var openTimeout = null;
    var closeTimeout = null;

    function isClickMode() {
      return document.body.classList.contains('ab-mega-nav-click');
    }

    function cancelHoverTimers() {
      clearTimeout(openTimeout);
      clearTimeout(closeTimeout);
      openTimeout = null;
      closeTimeout = null;
    }

    function openAndLog() {
      cancelHoverTimers();
      if (!panel.hidden) return;
      open();
      logEvent('mega_nav_open', {});
    }

    function wantOpen() {
      clearTimeout(closeTimeout);
      closeTimeout = null;
      if (panel.hidden && !openTimeout) {
        openTimeout = setTimeout(function () {
          openAndLog();
          hoverOpenedAt = Date.now();
        }, HOVER_OPEN_DELAY_MS);
      }
    }

    function wantClose() {
      clearTimeout(openTimeout);
      openTimeout = null;
      if (!panel.hidden && !closeTimeout) {
        closeTimeout = setTimeout(function () {
          closeTimeout = null;
          close();
        }, HOVER_CLOSE_DELAY_MS);
      }
    }

    [toggle, panel].forEach(function (el) {
      el.addEventListener('mouseenter', function () {
        if (!isClickMode()) wantOpen();
      });
      el.addEventListener('mouseleave', function () {
        if (!isClickMode()) wantClose();
      });
    });

    toggle.addEventListener('click', function (event) {
      var fromKeyboard = event.detail === 0;
      var justOpenedByHover = Date.now() - hoverOpenedAt < HOVER_CLICK_GRACE_MS;
      if (panel.hidden) {
        openAndLog();
      } else if (isClickMode() || fromKeyboard || !justOpenedByHover) {
        close();
      }
    });
  }

  function logEvent(name, params) {
    if (typeof window.logGA4Event === 'function') {
      window.logGA4Event(name, params);
    }
  }

  var NAV_LINKS = [
    { selector: '.mega-nav__shop-all, .nav-mobile__shop-all', link: 'shop_all' },
    { selector: '.mega-nav__compare, .nav-mobile__compare', link: 'compare_frames' }
  ];

  function initNavLinkTracking() {
    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;

      var card = event.target.closest('.featured-shop-section__product--nav');
      if (card && event.target.closest('a')) {
        logEvent('mega_nav_click', { link: 'product', color: card.dataset.color, sku: card.dataset.sku });
        return;
      }

      for (var i = 0; i < NAV_LINKS.length; i++) {
        if (event.target.closest(NAV_LINKS[i].selector)) {
          logEvent('mega_nav_click', { link: NAV_LINKS[i].link });
          return;
        }
      }
    });
  }

  function initNavProductVideos() {
    document.querySelectorAll('.action--nav-product-video-hover').forEach(function (video) {
      var card = video.closest('.featured-shop-section__product--nav') || video;
      var loaded = false;

      card.addEventListener('mouseenter', function () {
        if (!loaded) {
          video.load();
          loaded = true;
        }
        var playing = video.play();
        if (playing && typeof playing.catch === 'function') playing.catch(function () {});
      });

      card.addEventListener('mouseleave', function () {
        video.pause();
        video.currentTime = 0;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNavProductVideos);
  } else {
    initNavProductVideos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  initNavLinkTracking();
})();
(function ($) {
  const SELECTORS = {
    REVEAL_SCROLL_CONTAINER: "reveal-container",
    REVEAL_SCROLL_ELEMENTS: "reveal-element"
  };

  let scrollObserver;

  function getClassSelector(value) {
    return `.${value}`;
  }

  function showElement(element) {
    element.style.transition = "250ms all ease-in-out";
    element.style.opacity = "1";
    element.style.transform = "matrix(1, 0, 0, 1, 0, 0)";
  }

  function isIntersecting(element) {
    return element.isIntersecting || element.intersectionRatio > 0;
  }

  function observerSettings(settings) {
    return {
      root: settings.container === document ? null : settings.container,
      rootMargin: "-25%"
    };
  }

  function scrollObserverCallback(entries, observer) {
    entries.forEach((entry) => {
      if (isIntersecting(entry)) {
        const target = entry.target;
        const children = entry.target.querySelectorAll(getClassSelector(SELECTORS.REVEAL_SCROLL_ELEMENTS));
        const revealElements = children;
        for (let i = 0; i < revealElements.length; i++) {
          showElement(revealElements[i]);
          observer.unobserve(target);
        }
      }
    });
  }


  function observeScrollLoadComponents() {
    const scrollLoadComponents = document.querySelectorAll(getClassSelector(SELECTORS.REVEAL_SCROLL_CONTAINER));
    scrollLoadComponents.forEach((elem) => {
      scrollObserver.observe(elem);
    });
  }


  function init() {
    const runningOnBrowser = typeof window !== "undefined";
    const supportsIntersectionObserver = runningOnBrowser && "IntersectionObserver" in window;

    if (!supportsIntersectionObserver) {
      const revealElements = document.querySelectorAll(getClassSelector(SELECTORS.REVEAL_SCROLL_ELEMENTS));
      revealElements.forEach((element) => {
        showElement(element);
      });
    } else {
      const settings = {
        threshold: 1.0
      };
      scrollObserver = new IntersectionObserver(scrollObserverCallback, observerSettings(settings));

      observeScrollLoadComponents();
    }
  }

  window.addEventListener('load', init);
})(jQuery);
/* global jQuery */

(function($) {
  "use strict";

  var passwordField = $("#change-password-field");
  var strengthBar = $("#change-password-strength-bar");
  var strengthText = $("#change-password-strength-text");
  var hideShowButton = $(".hide-show");

  var grey = "#9E9E9E";
  var colorPassword1 = "#EC5858";
  var colorPassword2 = "#E5823A";
  var colorPassword3 = "#76B3D6";
  var colorPassword4 = "#00D16D";

  var userEmail;
  if (passwordField.length !== 0 && strengthBar.length !== 0 && strengthText.length !== 0) {
    userEmail = getParameterByName("email");
    setup();
  }

  function setup() {
    passwordField.on('input', checkPasswordStrength);

    $("#change-password-form").submit(function(event) {
      if (!validatePassword()) {
        event.preventDefault();
      }
    });

    handleFocus(true);
    passwordField.focus(function() {
      handleFocus(true);
    });
    passwordField.focusout(function() {
      handleFocus(false)
    });

    $('.hide-show span').addClass('show')
    $('.hide-show span').click(function(){
      if (passwordField.val().length == 0) {
        return
      }
      if( $(this).hasClass('show') ) {
        $(this).text('hide');
        passwordField.attr('type','text');
        $(this).removeClass('show');
      } else {
         $(this).text('show');
         passwordField.attr('type','password');
         $(this).addClass('show');
      }
    });
  }

  function validatePassword() {
    if (!window.zxcvbn) {
      return true;
    }

    var strength = zxcvbn(passwordField.val(), [userEmail]);

    if (strength.guesses_log10 < 8) {
      strengthText.html(getReadableFeedback(strength.feedback));
      return false;
    } else if (passwordField.val().length < 8) {
      strengthText.html("This password should be at least 8 characters");
      return false;
    }
    return true;
  }

  function getReadableFeedback(feedback) {
    var str = "";
    if (feedback.warning) {
      str += feedback.warning;
    }

    feedback.suggestions.forEach(function(suggestion) {
      if (str) {
        str += "<br>";
      }
      str += suggestion;
    });
    return str;
  }

  function handleFocus(hasFocus) {
    if (hasFocus) {
      strengthBar.addClass('full-height');
      checkPasswordStrength();
    } else {
      strengthText.html("");
    }
  }
  function disableShowPassword(){
    hideShowButton.attr("disabled", true);
    hideShowButton.addClass('is-disabled');
  }
  
  function enableShowPassword(){
    hideShowButton.attr("disabled", false)
    hideShowButton.removeClass('is-disabled');
  }
  function checkPasswordStrength() {
    if (passwordField.val().length == 0) {
      disableShowPassword();
      strengthText.text("");
      updatePasswordStrengthIndicator(grey, grey, grey, grey);
      return;
    }
    enableShowPassword();

    if (!window.zxcvbn) {
      strengthText.text("");
      return;
    }

    var strength = zxcvbn(passwordField.val(), [userEmail]);
    if (strength.guesses_log10 < 3) {
      strengthText.text("Very Weak");
      updatePasswordStrengthIndicator(colorPassword1, grey, grey, grey)
    } else if (strength.guesses_log10 < 6) {
      strengthText.text("Weak");
      updatePasswordStrengthIndicator(colorPassword1, grey, grey, grey)
    } else if (strength.guesses_log10 < 8) {
      strengthText.text("So-so");
      updatePasswordStrengthIndicator(colorPassword2, colorPassword2, grey, grey)
    } else if (strength.guesses_log10 < 10) {
      strengthText.text("Good");
      updatePasswordStrengthIndicator(colorPassword3, colorPassword3, colorPassword3, grey)
    } else {
      strengthText.text("Great");
      updatePasswordStrengthIndicator(colorPassword4, colorPassword4, colorPassword4, colorPassword4)
    }
  }

  function updatePasswordStrengthIndicator(color1, color2, color3, color4) {
    strengthText.css('color', color1);
    strengthBar.children().eq(0).css('background-color', color1);
    strengthBar.children().eq(1).css('background-color', color2);
    strengthBar.children().eq(2).css('background-color', color3);
    strengthBar.children().eq(3).css('background-color', color4);
  }

  // https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
  function getParameterByName(name) {
    var url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
    var results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
})(jQuery)
;
(function ($) {
  $(document).ready(function () {
    var heroMain = document.querySelector(".action--hero-main");
    if (!heroMain) {
      return;
    }

    var wordsSpan = document.querySelector(".replacement-words");
    if (!wordsSpan) {
      return;
    }

    var words = wordsSpan.textContent.split(",").map(function (word) {
      return word.trim();
    });

    var i = 0;
    var currentWord = document.querySelector(".current-word span");
    var nextWord = document.querySelector(".next-word span");

    if (!currentWord || !nextWord) {
      return;
    }

    currentWord.innerHTML = words[i];
    var pauseDuration = 1000;
    var animationDuration = 500;
    var animationDelay = 2000;

    function updateWords() {
      nextWord.innerHTML = words[(i + 1) % words.length];
      nextWord.classList.toggle("slide-in");
      nextWord.style.display = "inline-flex";
      currentWord.classList.toggle("slide-out");

      setTimeout(function () {
        currentWord.innerHTML = nextWord.innerHTML;
        nextWord.classList.toggle("slide-in");
        currentWord.classList.toggle("slide-out");
        i = (i + 1) % words.length;
      }, animationDuration);
    }

    function animateWords() {
      setTimeout(function () {
        updateWords();
        animateWords();
      }, pauseDuration + animationDuration + animationDelay);
    }

    if (!nextWord || !currentWord || !words) {
      return;
    } else {
      animateWords();
    }

    nextWord.addEventListener("animationend", function () {
      if (nextWord.classList.contains("slide-out")) {
        nextWord.style.transform = "translateY(100%)";
      }
    });
  });
  window.addEventListener("load", () => {
    const heroVideo = document.querySelector(".hero-main__video");
    if (!heroVideo) return;
  
    heroVideo.play()
  });
})(jQuery);

(function ($) {
  $(document).ready(function () {
    const tickerContainers = document.querySelectorAll(".hero-main__tickertape, .hero-video-main__tickertape");
    if (!tickerContainers) return;

    tickerContainers.forEach(function (tickerContainer) {
      const tickerTextElement = tickerContainer.querySelector(".ticker-text");
      if (!tickerTextElement) return;

      const TICKER_HTML = tickerTextElement.innerHTML.trim();
      const TICKER_REPEAT = 6;

      const group1 = `<span class="marquee--content">${TICKER_HTML.repeat(TICKER_REPEAT)}</span>`;
      const group2 = `<span class="marquee--content" aria-hidden="true">${TICKER_HTML.repeat(TICKER_REPEAT)}</span>`;

      tickerTextElement.innerHTML = group1 + group2;
      tickerTextElement.classList.add("active");
    });
  });
})(jQuery);
(function ($) {
  window.addEventListener('load', function () {

    const scrollAreas = document.querySelectorAll('.scroll-carousel');

    scrollAreas.forEach(function(area) {
      const scrollContent = area.querySelector('.scroll-carousel-content');
      const parent = area.parentNode;
      const areaIndex = area.getAttribute('data-index') || '0';
      const scrollLeftBtn = parent.querySelector('.scroll-carousel-left');
      const scrollRightBtn = parent.querySelector('.scroll-carousel-right');

      let moveLeftClassAdded = false;
      let childWidth;

      function handleButtonClick(direction) {
        const nextScrollLeft = scrollContent.scrollLeft + (direction === 'left' ? -childWidth : childWidth);
        scrollContent.scrollTo({
          left: nextScrollLeft,
          behavior: 'smooth'
        });
      }

      function checkScrollStatus() {
        const isScrollNeeded = scrollContent.scrollWidth > scrollContent.clientWidth;
        const isMobile = window.innerWidth < 640 && isMobileDisabled();

        scrollLeftBtn.classList.toggle('active', !isMobile && isScrollNeeded);
        scrollRightBtn.classList.toggle('active', !isMobile && isScrollNeeded);

        const tolerance = 1; // Small tolerance to account for floating-point inaccuracies
        scrollLeftBtn.classList.toggle('disabled', scrollContent.scrollLeft <= tolerance);
        scrollRightBtn.classList.toggle(
          'disabled',
          scrollContent.scrollLeft + scrollContent.clientWidth >= scrollContent.scrollWidth - tolerance
        );

        if (
          !moveLeftClassAdded &&
          isScrollNeeded && areaIndex === '0' && !area.classList.contains('move-left-added')) {

          setTimeout(() => {
            addMoveLeftClass();
          }, 1000);
          area.classList.add('move-left-added');
          moveLeftClassAdded = true;
        }

      }

      function isMobileDisabled() {
        const mobileDisabled = area.getAttribute('mobile-disabled');
        return mobileDisabled;
      }

      function addMoveLeftClass() {
        scrollContent.classList.add('scroll-bounce');
        setTimeout(() => {
          scrollContent.classList.remove('scroll-bounce');
        }, 1000);
      }

      function updateChildWidth() {
        const firstChild = scrollContent.firstElementChild;
        if (firstChild) {
          const computedStyle = getComputedStyle(scrollContent);
          const gap = parseFloat(computedStyle.gap) || 0;
          childWidth = firstChild.offsetWidth + gap;
        }
      }

      function renderButtons() {
        if (scrollContent.offsetParent === null) {
          // Skip rendering if the element is hidden
          return;
        }
        updateChildWidth();
        checkScrollStatus();
      }

      // Initial setup
      renderButtons();

      // Event listeners
      scrollContent.addEventListener('scroll', renderButtons);
      window.addEventListener('resize', renderButtons);

      scrollLeftBtn.addEventListener('click', () => handleButtonClick('left'));
      scrollRightBtn.addEventListener('click', () => handleButtonClick('right'));

      // Observe visibility changes for hidden elements
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            renderButtons();
          }
        });
      });
      observer.observe(area);
    });
  });

  //PDP reviews/media quote slider
  var slides = Array.from(document.querySelectorAll('.quote-slider__slide'));
  var slideCount = slides.length;
  //we use a fake first image to make the carousel look like an infinite loop. Start index at 1
  var currentIndex = 1;
  var isTransitioning = false;

  function updateCarousel(instant = false) {
    if (slides.length > 0){
      //find center positioning for active slide
      var offset;
      if (window.innerWidth >= 1680) {
        offset = 840;
      } else {
        offset = window.innerWidth / 2;
      }
      var centerPosition = offset - slides[currentIndex].offsetLeft - (slides[currentIndex].offsetWidth / 2);

      slides.forEach(function (slide, index) {
        //toggle active class on current slide
        if (index === currentIndex) {
            slide.classList.add('active');
        } else {
            slide.classList.remove('active');
        }
        //transition to next slide
        slide.style.transform = 'translateX(' + centerPosition + 'px)';

        // on last slide, kill transition and jump back to slide with index 1
        if (instant) {
            slide.style.transition = 'none';
        } else {
            slide.style.transition = 'transform 0.6s ease, opacity 0.3s ease';
        }
      });
    }
  }

  function autoSlide() {
    if (isTransitioning) return;
    isTransitioning = true;

    currentIndex++;
    updateCarousel();

    // Handle the fake-to-real slide jump
    if (currentIndex === slideCount - 1) {
      setTimeout(function () {
          // Jump to the real first slide
          currentIndex = 1;
          updateCarousel(true);
          isTransitioning = false;
      }, 600); // Match the main transition duration
    } else {
      setTimeout(() => (isTransitioning = false), 600); // Regular transition
    }
  }

  updateCarousel();
  setInterval(autoSlide, 5000);

})(jQuery);
(function () {
  'use strict';
  var videos = document.querySelectorAll('video[data-desktop-src]');
  var posters = document.querySelectorAll(".video--poster");

  function changeVideoSource() {
    var newWidth = window.innerWidth;

    videos.forEach(function (video, index) {
      // Determine the correct video sources based on screen size
      var dataSrc;
      
      if (newWidth > 800) {  // Desktop
        dataSrc = [
          { src: video.getAttribute('data-desktop-src'), type: 'video/mp4' }
        ]
      } else { // Mobile
        dataSrc = [
          { src: video.getAttribute('data-mobile-src'), type: 'video/mp4' }
        ]
      }

      // Add sources to the video element
      dataSrc.forEach(source => {
        // Check if the source element already exists for its type
        if(video.querySelector(`source[type="${source.type}"]`)) {
          let existing_source = video.querySelector(`source[type="${source.type}"]`);
          if (existing_source.src !== source.src) {
            existing_source.src = source.src;
          }
        } else {
          const sourceElement = document.createElement('source');
          sourceElement.src = source.src;
          sourceElement.type = source.type;
          video.appendChild(sourceElement);
        }
      });
      video.load();
      if (video.hasAttribute('autoplay')) {
        video.play().catch(function () {});
      }
    });
  }

  function playHighlightPdpVideo() {
    const highlightVideo = document.querySelectorAll('.highlight-carousel__video');
    if (!highlightVideo) return;
    highlightVideo.forEach(video => {
      video.play();
    })
  }

  function runInkVideos() {
    document.querySelectorAll('.video-pause-toggle').forEach(function(toggleBtn) {
      var video = document.getElementById(toggleBtn.getAttribute('aria-controls'));
      if (!video) return;

      // Safari needs an explicit play() to kick off autoplay for <source media> videos.
      if (video.hasAttribute('autoplay') && video.paused) {
        video.play().catch(function () {});
      }

      toggleBtn.addEventListener('click', function() {
        if (video.paused) {
          video.play();
          toggleBtn.setAttribute('aria-pressed', 'false');
          toggleBtn.setAttribute('aria-label', 'Pause background video');
          toggleBtn.classList.remove('is-paused');
        } else {
          video.pause();
          toggleBtn.setAttribute('aria-pressed', 'true');
          toggleBtn.setAttribute('aria-label', 'Play background video');
          toggleBtn.classList.add('is-paused');
        }
      });
    });
  }

  window.addEventListener("load", function () {
    changeVideoSource();
    playHighlightPdpVideo();
    runInkVideos()
  });
})();
class GooglePlacesAutocomplete {
  constructor(options) {
    this.apiKey = options.apiKey;
    this.inputId = options.inputId;
    this.countryInputId = options.countryInputId;
    this.addressInputId = options.addressInputId;
    this.address2InputId = options.address2InputId;
    this.cityInputId = options.cityInputId;
    this.provinceInputId = options.provinceInputId;
    this.provinceInputClass = options.provinceInputClass;
    this.zipInputId = options.zipInputId;
    this.countryRestrictions = options.countryRestrictions;

    if (this.apiKey) {
      this.loadGoogleMapsScript();
    }
  }

  loadGoogleMapsScript() {
    window.initMap = this.initMap.bind(this);
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&loading=async&libraries=places&callback=initMap`;
    document.head.appendChild(script);
  }

  initMap() {
    const input = document.getElementById(this.inputId);
    const options = {
      fields: ["address_components", "geometry", "icon", "name"],
      types: ["address"],
    };

    if (this.countryRestrictions) {
      options.componentRestrictions = { country: "us" };
    }

    const autocomplete = new google.maps.places.Autocomplete(input, options);
    autocomplete.addListener("place_changed", () =>
      this.handlePlaceChanged(autocomplete)
    );
  }

  handlePlaceChanged(autocomplete) {
    const place = autocomplete.getPlace();
    if (place) {
      const country = place.address_components.find((component) =>
        component.types.includes("country")
      );
      const isUS = country && country.short_name == "US";
      document.getElementById(this.countryInputId).value = country.short_name;

      const streetNumber = place.address_components.find((component) =>
        component.types.includes("street_number")
      );

      const address2 = place.address_components.find((component) =>
        component.types.includes("subpremise")
      );
      document.getElementById(this.address2InputId).value = address2
        ? address2.long_name
        : "";

      const route = place.address_components.find((component) =>
        component.types.includes("route")
      );
      document.getElementById(this.addressInputId).value = `${
        streetNumber ? streetNumber.long_name : ""
      } ${route ? route.long_name : ""}`;

      let city =
        place.address_components.find((component) =>
          component.types.includes("locality")
        ) ||
        place.address_components.find((component) =>
          component.types.includes("sublocality")
        ) ||
        place.address_components.find((component) =>
          component.types.includes("administrative_area_level_2")
        );
      document.getElementById(this.cityInputId).value = city
        ? city.long_name
        : "";

      const province = place.address_components.find((component) =>
        component.types.includes("administrative_area_level_1")
      );
      if (isUS) {
        document.getElementById(this.provinceInputClass).classList.add("hide");
        document.getElementById(this.provinceInputId).classList.remove("hide");
        document.getElementById(this.provinceInputId).value = province
          ? province.short_name
          : "";
      } else {
        document.getElementById(this.provinceInputId).classList.add("hide");
        document
          .getElementById(this.provinceInputClass)
          .classList.remove("hide");
        document.getElementById(this.provinceInputClass).value = province
          ? province.long_name
          : "";
      }

      const postalCode = place.address_components.find((component) =>
        component.types.includes("postal_code")
      );
      document.getElementById(this.zipInputId).value = postalCode
        ? postalCode.long_name
        : "";
    }
  }
}

function isMSBillingPage() {
  return document.querySelector(".action--section--multiship-billing") !== null;
}

function shouldShowAddressAutoComplete() {
  return (
    document.querySelector(".section--multiship") !== null ||
    document.querySelector(".section--multiship-shipping-methods") !== null ||
    isMSBillingPage()
  );
}

if (shouldShowAddressAutoComplete()) {
  const options = {
    apiKey: window.googleMapsApiKey,
    countryRestrictions: true,
    inputId: "ms-address1",
    countryInputId: "ms-country",
    addressInputId: "ms-address1",
    address2InputId: "ms-address2",
    cityInputId: "ms-city",
    provinceInputId: "ms-province",
    provinceInputClass: "ms-province-input",
    zipInputId: "ms-zip",
  };
  // country is restricted to US on all multiship pages except the billing page
  if (isMSBillingPage()) {
    options.countryRestrictions = false;
  }
  new GooglePlacesAutocomplete(options);
}
;
// https://developers.google.com/maps/documentation/address-validation
async function isValidAddress(params) {
  const apiKey = window.googleMapsApiKey;
  const url = `https://addressvalidation.googleapis.com/v1:validateAddress?key=${apiKey}`;

  let payload, options, response, json, invalidFields;

  payload = JSON.stringify({
    address: {
      regionCode: params.country,
      locality: params.city,
      administrativeArea: params.province,
      addressLines: [params.address1, params.address2],
      postalCode: params.zip,
    },
  });

  options = {
    muteHttpExceptions: true,
    method: "POST",
    "Content-Type": "application/json",
    body: payload,
  };

  try {
    response = await fetch(url, options);
    json = await response.json();
  } catch (error) {
    console.error("Fetch error:", error);
    return null;
  }
  if (!response.ok && json.error) {
    console.error("Fetch error:", json.error);
    return null;
  }
  if (!hasValidVerdict(json)) {
    const options = { isValid: false };
    if (hasUnconfirmedComponents(json)) {
      invalidFields = getInvalidFields(json);
      options.invalidFields = invalidFields;
    } else {
      // address might not have unconfirmed conponents but is invalid due to other reasons, like incompletness
      // in this case, we can return the confirmed address as a suggestion
      options.confirmedAddress = formatConfirmedAddress(
        json.result.address.addressComponents
      );
    }
    return options;
  } else {
    return {
      isValid: true,
      confirmedAddress: formatConfirmedAddress(
        json.result.address.addressComponents
      ),
    };
  }
}

// Verdicts are returned in the response object and are used to determine the validity of an address.
// If needed, we can remove "SUB_PREMISE" from validationGranularity for stricter validation.
// https://developers.google.com/maps/documentation/address-validation/understand-response
function hasValidVerdict(json) {
  if (json.result && json.result.verdict) {
    const verdict = json.result.verdict;
    if (
      verdict.addressComplete == true &&
      (verdict.validationGranularity == "PREMISE" ||
        verdict.validationGranularity == "SUB_PREMISE")
    ) {
      return true;
    }
  }
}

function hasUnconfirmedComponents(json) {
  if (
    json.result &&
    json.result.verdict &&
    json.result.verdict.hasUnconfirmedComponents
  ) {
    return json.result.verdict.hasUnconfirmedComponents;
  }
}

function getInvalidFields(json) {
  let fields = [];
  if (
    json.result &&
    json.result.address &&
    json.result.address.addressComponents
  ) {
    json.result.address.addressComponents.forEach((component) => {
      if (component.confirmationLevel !== "CONFIRMED") {
        fields.push(component);
      }
    });
  }
  if (fields.length > 0) {
    fields = mapFieldsToForm(fields);
  }
  return fields;
}

function mapFieldsToForm(fields) {
  const mappedFields = fields.map((field) => {
    switch (field.componentType) {
      case "locality":
        return "City";
      case "administrative_area_level_1":
        return "State/Province";
      case "postal_code":
        return "Zipcode";
      default:
        return "Address Line";
    }
  });
  return [...new Set(mappedFields.filter((field) => field !== null))];
}

function formatConfirmedAddress(addressComponents) {
  let formattedAddress = {};
  addressComponents.forEach((component) => {
    // address line 1
    if (component.componentType == "street_number") {
      formattedAddress.address1 = component.componentName.text;
    }
    if (component.componentType == "route") {
      formattedAddress.address1 += " " + component.componentName.text;
    }

    // address line 2
    if (component.componentType == "subpremise") {
      formattedAddress.address2 = component.componentName.text;
    }

    // city
    if (component.componentType == "locality") {
      formattedAddress.city = component.componentName.text;
    } else if (!formattedAddress.city && component.componentType == "sublocality_level_1") {
      formattedAddress.city = component.componentName.text;
    } else if (!formattedAddress.city && component.componentType == "neighborhood") {
      formattedAddress.city = component.componentName.text;
    } else if (!formattedAddress.city && component.componentType == "postal_town") {
      formattedAddress.city = component.componentName.text;
    } else if (!formattedAddress.city && component.componentType == "administrative_area_level_3") {
      formattedAddress.city = component.componentName.text;
    }

    // province
    if (component.componentType == "administrative_area_level_1") {
      formattedAddress.province = component.componentName.text;
    }

    // zip
    if (component.componentType == "postal_code") {
      formattedAddress.zip = component.componentName.text;
    }

    // country
    if (component.componentType == "country") {
      formattedAddress.country = component.componentName.text;
    }
  });
  return formattedAddress;
}
;
(function () {
  window.addEventListener('load', function () {
    const scrollAreas = document.querySelectorAll('.action--scroll-gallery');
    if (!scrollAreas.length) return;

    let childWidth = 0; // Define childWidth in the appropriate scope
    let currentSelectedThumbnail = null; // Variable to store the currently selected thumbnail

    function updateChildWidth(scrollContent) {
      childWidth = 0;
      const galleryItems = scrollContent.querySelectorAll('.action--scroll-gallery-item');
      const firstChild = galleryItems[0];
      if (firstChild) {
        const computedStyle = getComputedStyle(firstChild);
        const marginRight = parseFloat(computedStyle.marginRight) || 0;
        childWidth = firstChild.offsetWidth + marginRight;
      }
    }

    function observeSelectedThumbnail(scrollContent) {
      const thumbnails = scrollContent.querySelectorAll('.action--thumbnail-button');

      thumbnails.forEach((thumbnail) => {
        const updateSelectedThumbnail = () => {
          if (thumbnail.getAttribute('aria-pressed') === 'true') {
            currentSelectedThumbnail = thumbnail;
          }
        };

        const observer = new MutationObserver(updateSelectedThumbnail);
        observer.observe(thumbnail, { attributes: true, attributeFilter: ['aria-pressed'] });

        updateSelectedThumbnail(); // Initialize if already selected
      });
    }

    /** Handles left/right button clicks */
    function handleButtonClick(direction, scrollContent) {
      updateChildWidth(scrollContent); // Ensure we have the latest width

      if (currentSelectedThumbnail) {
        const scrollLeft = scrollContent.scrollLeft;
        const containerWidth = scrollContent.clientWidth;

        const visibleLeft = scrollLeft;
        const visibleRight = scrollLeft + containerWidth;

        const nextLeft = currentSelectedThumbnail.offsetLeft - childWidth;
        const nextRight = nextLeft + childWidth;

        if (nextLeft >= visibleLeft && nextRight <= visibleRight) {
          return;
        }
      }

      const scrollAmount = direction === 'left' ? -childWidth : childWidth;
      scrollContent.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }

    /** Initializes buttons and drag functionality */
    function renderButtons(scrollContent) {
      updateChildWidth(scrollContent);
    }

    /** Enable grab-scroll */
    function enableGrabScroll(scrollContent) {
      let isDown = false;
      let startX, scrollLeft, moved = false;

      scrollContent.addEventListener('mousedown', (e) => {
        isDown = true;
        moved = false;
        startX = e.pageX - scrollContent.offsetLeft;
        scrollLeft = scrollContent.scrollLeft;
        scrollContent.classList.add('active');
      });

      scrollContent.addEventListener('mouseleave', () => {
        isDown = false;
        scrollContent.classList.remove('active');
      });

      scrollContent.addEventListener('mouseup', (e) => {
        isDown = false;
        scrollContent.classList.remove('active');
        if (moved) e.stopPropagation(); // Prevent accidental click
      });

      scrollContent.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        moved = true;
        const x = e.pageX - scrollContent.offsetLeft;
        const walk = (x - startX) * 2; // Adjust scroll speed
        scrollContent.scrollLeft = scrollLeft - walk;
      });

      // Prevent button clicks if dragged
      scrollContent.querySelectorAll('button').forEach(button => {
        button.addEventListener('click', (e) => {
          if (moved) {
            e.preventDefault();
            e.stopPropagation();
          }
        });
      });
    }

    // Function to initialize the scroll gallery
    function initializeScrollGallery(area) {
      const scrollContent = area.querySelector('.action--scroll-gallery--content');
      if (!scrollContent) return;

      observeSelectedThumbnail(scrollContent);

      area.removeAttribute('inert');
      area.classList.add('active');
      area.setAttribute('tabindex', '0');

      // Run initial setup
      renderButtons(scrollContent);
      enableGrabScroll(scrollContent);

      // Add event listeners
      window.addEventListener('resize', () => renderButtons(scrollContent));
      window.addEventListener('resize', () => updateChildWidth(scrollContent));

      const mainImage = document.querySelector('.action--carousel-pdp--section');
      const leftArrow = mainImage.querySelector('.action--image-gallery--arrow-left');
      const rightArrow = mainImage.querySelector('.action--image-gallery--arrow-right');

      rightArrow.classList.add('visible');
      leftArrow.classList.add('visible');

      leftArrow.addEventListener('click', () => handleButtonClick('left', scrollContent));
      rightArrow.addEventListener('click', () => handleButtonClick('right', scrollContent));
    }

    scrollAreas.forEach(initializeScrollGallery); // Run the scroll script when class is added
  });
})();
(function () {
  'use strict';

  function isHomePage() {
    return $('body').hasClass("home-page");
  }

  function isShopAllPage() {
    return $('body').hasClass("shop-all");
  }

  function isCorporateGiftingPage() {
    return $('body').hasClass("corporate-gifting");
  }

  function isMobile() {
    return window.innerWidth < 640;
  }

  function displayShopSectionVideo() {
    const productVideos = document.querySelectorAll('.action--product-video-hover');

    productVideos.forEach(productVideo => {
      productVideo.preload = "none";
      let loaded = false;

      productVideo.addEventListener("mouseenter", function handleHover() {
        if (!loaded) {
          productVideo.load();
          loaded = true;
        }
        productVideo.play();
      });

      productVideo.addEventListener("mouseleave", function handleLeave() {
        productVideo.pause();
        productVideo.currentTime = 0;
      });
    });
  }

  window.addEventListener("load", function () {
    if (isShopAllPage() || isCorporateGiftingPage()) {
      displayShopSectionVideo();
    }
  });
})();
(function () {
  'use strict';

  function setElementImageAttributes(element, imagePath, imagePathWebp) {
    if (element.parentElement && element.parentElement.tagName.toLowerCase() === 'picture') {
        const sources = element.parentElement.querySelectorAll('source');

        sources.forEach(source => {
            const type = source.getAttribute('type');
            if (type === 'image/webp') {
                source.setAttribute('srcset', imagePathWebp);
                source.setAttribute('data-srcset', imagePathWebp);
            } else if (type === 'image/jpeg') {
                source.setAttribute('srcset', imagePath);
                source.setAttribute('data-srcset', imagePath);
            }
        });

        element.setAttribute('src', imagePath);
        element.setAttribute('data-src', imagePath);
    } else {
        element.setAttribute('src', imagePath);
        element.setAttribute('data-src', imagePath);
    }
  }

  function compareFrames() {
    const compareFrames = document.querySelector('.action---compare-frames');
    if (!compareFrames) return;
    const sections = compareFrames.querySelectorAll('.action---compare-frames-component');
    sections.forEach(section => {
      const products = section.querySelectorAll('.action---compare-frames-product');
      const selects = section.querySelectorAll('.action---compare-frames-select');
      if (!selects.length) return;
      const activeProduct = section.querySelector('.action---compare-frames-product.active');
      const activeSelect = activeProduct
        ? activeProduct.querySelector('.action---compare-frames-select')
        : selects[0];
      let selectedProduct = activeSelect ? activeSelect.value : selects[0].value;
      if (!selectedProduct) return;
      selects.forEach(select => { select.value = selectedProduct; });
      selects.forEach(select => {
        select.addEventListener('change', function () {
          selectedProduct = select.value;
          selects.forEach(otherSelect => {
            if (otherSelect !== select) otherSelect.value = selectedProduct;
          });
          updateDisplayedProducts(products, selectedProduct);
          logGA4Event('comp_frames_select_product', { product: selectedProduct });
        });
      });
  
      products.forEach(product => {
        colorSwatchColors(product);
        addToCartListeners(product);
        bindCompareFramesLearnMoreClick(product);
      });
      updateDisplayedProducts(products, selectedProduct);
    });
    if (document.querySelector('.compare-frames--collapsible')) {
      syncCollapsibleSections();
    }
  }

  function syncCollapsibleSections() {
    document.querySelectorAll('.compare-frames--collapsible-toggle').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const section = btn.getAttribute('data-section');
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        const newState = expanded ? 'false' : 'true';
    
        document.querySelectorAll(`.compare-frames--collapsible-toggle[data-section="${section}"]`).forEach(function(sectionBtn) {
          let newcollapsibleState = expanded ? 'true' : 'false'
          const content = sectionBtn.nextElementSibling;
          sectionBtn.setAttribute('aria-expanded', newState);
          content.classList.toggle('is-collapsed', expanded);
          content.toggleAttribute('inert', expanded);
          content.setAttribute('aria-hidden', newcollapsibleState);
        });
  
        logGA4Event('comp_frames_toggle_section', {
          section: section
        });
      });
    });
  }

  function bindCompareFramesLearnMoreClick(product) {
    const btns = product.querySelectorAll('.action--compare-frames--learn-more-btn');
    btns.forEach(function (btn) {
      if (btn.dataset.gaBound) return;
      btn.dataset.gaBound = 'true';
  
      btn.addEventListener('click', function () {
        logGA4Event('comp_frames_learn_more_btn', {
          product: product.dataset.product
        });
      });
    });
  }
 
  function formatPrice(amount) {
    const locale = (typeof I18n !== "undefined" && I18n.locale) ? I18n.locale : 'en';
    switch (locale) {
      case 'de':
      case 'fr':
        return `${amount} €`;
      case 'en-GB':
        return `£${amount}`;
      default:
        return `$${amount}`;
    }
  }

  function updatePricing(product, frameDetails) {
    const priceElement = product.querySelector('.action--shop-frames-price');
    const strikePriceElement = product.querySelector('.action--shop-frames-price-strike');
    const strikePriceWrapper = product.querySelector('.action--shop-frames-price-strike-wrapper');

    if (!priceElement) return;

    const price = frameDetails.price;
    const originalPrice = frameDetails.originalPrice;
    const colorClass = frameDetails.class;

    if (price) {
      priceElement.textContent = formatPrice(price);
      priceElement.setAttribute('data-color', colorClass);

      if (originalPrice && originalPrice !== price && strikePriceElement) {
        strikePriceElement.textContent = formatPrice(originalPrice);
        strikePriceElement.setAttribute('data-color', colorClass);

        if (strikePriceWrapper) {
          strikePriceWrapper.classList.remove('hide');
        }

        priceElement.classList.add('product__price-promo');
      } else {
        if (strikePriceWrapper) {
          strikePriceWrapper.classList.add('hide');
        }

        priceElement.classList.remove('product__price-promo');
      }
    }
  }

  function updateDisplayedProducts(products, selectedProduct) {
    products.forEach(product => {
      const shouldShow = selectedProduct === product.dataset.product;
      product.classList.toggle('active', shouldShow);
      product.setAttribute('aria-hidden', !shouldShow);
      product.setAttribute('tabindex', shouldShow ? '0' : '-1');
      product.toggleAttribute('inert', !shouldShow);
      product.classList.toggle('display-none', !shouldShow);
      if (shouldShow) {
        product.classList.add('z0');
        product.classList.remove('z1');
      } else {
        product.classList.add('z1');
        product.classList.remove('z0');
      }
    });
  }

  function updateProduct(product, selectedColor) {
    const frameDetails = window.getFrameDetailsByColor(selectedColor);
    if (!frameDetails) return;
    const productImage = product.querySelector('.action--compare-frames--product-image');
    const galleryImgs = (frameDetails.galleryImgs || '').split(',');
    const galleryImgsWebp = (frameDetails.galleryImgsWebp || '').split(',');

    // Use image 7 (index 6); fall back to image 1
    const imgsrc = galleryImgs[6] || galleryImgs[0];
    const imgsrcWebp = galleryImgsWebp[6] || galleryImgsWebp[0];

    if (!productImage) return;
    if (!imgsrc) return;
    if (!imgsrcWebp) return;

    setElementImageAttributes(productImage, imgsrc, imgsrcWebp);

    const colorClass = frameDetails.class
    if (!colorClass) return;
    addToCartUpdateButton(frameDetails, product, colorClass);
    updatePricing(product, frameDetails);
    updateImgUrl(product, frameDetails)
    if (document.querySelector('.compare-frames--collapsible')) {
      updateFinish(product, frameDetails);
    }
  }

  function addToCartUpdateButton(frameDetails, product, colorClass) {
    const isSoldOut = frameDetails.isSoldOut === 'true' || frameDetails.isSoldOut === true;
  
    // Show/hide in-stock vs oos buttons
    const inStockBtns = product.querySelectorAll('.in-stock-btns');
    const oosBtns = product.querySelectorAll('.oos-btns');
  
    if (inStockBtns.length && oosBtns.length) {
      if (isSoldOut) {
        inStockBtns.forEach(el => el.style.display = 'none');
        oosBtns.forEach(el => el.style.display = 'block');
      } else {
        inStockBtns.forEach(el => el.style.display = 'block');
        oosBtns.forEach(el => el.style.display = 'none');
  
        // update data-color attribute for ATC
        inStockBtns.forEach(container => {
          const quickAddBtns = container.querySelectorAll('.action--quick-add-btn');
          quickAddBtns.forEach(btn => {
            btn.dataset.color = colorClass;
          });
        });
      }
    }
  }

  function addToCartListener(product, selector, eventName) {
    const buttons = product.querySelectorAll(selector);
    if (!buttons || buttons.length === 0) return;

    buttons.forEach(button => {
      button.addEventListener('click', function () {
        const selectedColor = button.dataset.color;

        if (!selectedColor) return;

        logGA4Event(eventName, {
          color: selectedColor,
        });
      });
    });
  }

  function addToCartListeners(product) {
    addToCartListener(product, '.action--compare-frames--add-to-cart-btn', 'comp_frames_add_to_cart');
    addToCartListener(product, '.action--compare-frames--add-to-cart-btn-upsell', 'comp_frames_upsell_add_to_cart');
    addToCartListener(product, '.action--compare-frames--learn-more-btn', 'comp_frames_learn_more');
  }

  function updateActiveSwatch(product, buttons, button) {
    const swatchTitleContainer = product.querySelector('.action--comp-color-swatches')
    const swatchTitles = swatchTitleContainer.querySelectorAll('.action--comp-color-swatch');
    buttons.forEach(btn => {
      if (btn === button) {
        btn.classList.add('active');
        btn.setAttribute('aria-checked', 'true');
        btn.tabIndex = 0;
        btn.parentElement.classList.add('active');
      } else {
        btn.classList.remove('active');
        btn.setAttribute('aria-checked', 'false');
        btn.tabIndex = -1;
        btn.parentElement.classList.remove('active');
      }
    });

    swatchTitles.forEach(title => {
      if (title.dataset.color === button.dataset.color) {
        title.classList.add('active');
      } else {
        title.classList.remove('active');
      }
    }
    );
  }

  function colorSwatchColors(product) {
    const colorSwatchesLists = product.querySelectorAll('.action--comp-color-swatches');
    if (colorSwatchesLists.length === 0) return;
  
    colorSwatchesLists.forEach(colorSwatchList => {
      const colorSwatches = colorSwatchList.querySelectorAll('.action--comp-color-swatch');
      const colorSwatchButtons = Array.from(colorSwatchList.querySelectorAll('.action--comp-color-swatch--button'));
      if (!colorSwatches) return;
  
      function selectSwatch(colorSwatchButton) {
        const selectedColor = colorSwatchButton.dataset.color;
        if (!selectedColor) return;
        updateProduct(product, selectedColor);
        updateActiveSwatch(product, colorSwatchButtons, colorSwatchButton);
        logGA4Event('comp_frames_select_color', { color: selectedColor });
      }
  
      colorSwatches.forEach(colorSwatch => {
        const colorSwatchButton = colorSwatch.querySelector('.action--comp-color-swatch--button');
        if (!colorSwatchButton) return;
        colorSwatchButton.addEventListener('click', () => selectSwatch(colorSwatchButton));
      });
  
      colorSwatchList.addEventListener('keydown', function (e) {
        const keys = ['ArrowRight', 'ArrowLeft', 'Home', 'End'];
        if (!keys.includes(e.key)) return;
        e.preventDefault();
        const current = colorSwatchButtons.findIndex(btn => btn.tabIndex === 0);
        let idx = current === -1 ? 0 : current;
        if (e.key === 'ArrowRight') idx = (current + 1) % colorSwatchButtons.length;
        if (e.key === 'ArrowLeft') idx = (current - 1 + colorSwatchButtons.length) % colorSwatchButtons.length;
        if (e.key === 'Home') idx = 0;
        if (e.key === 'End') idx = colorSwatchButtons.length - 1;
        colorSwatchButtons[idx].focus();
        selectSwatch(colorSwatchButtons[idx]);
      });
    });
  }

  function updateImgUrl(product, frameDetails) {
    const imageLink = product.querySelectorAll('.action--compare-frames-product-url');
    const productUrl = window.location.origin + (frameDetails.productUrl || '');
    imageLink.forEach((link) => link.setAttribute('href', productUrl));
  }

  function updateFinish(product, frameDetails) {
    const finishCopy = product.querySelector('.action--compare-frames-finish');
    if (finishCopy) {
      finishCopy.innerText = frameDetails.title  
    }
  }

  window.addEventListener('load', compareFrames);
})();
(function () {
  'use strict';

  function exploreFrames() {
    const navButtons = document.querySelectorAll(".action--explore-frames--nav-btn");
    const cards = document.querySelectorAll(".action--explore-frames--card");
    const scrollContainer = document.querySelector(".action--explore-frames--cards");
    const prevBtn = document.querySelector(".action--explore-controls-prev");
    const nextBtn = document.querySelector(".action--explore-controls-next");
    const proxyBar = document.querySelector(".action--explore-frames--scroll-bar-proxy");

    if (!navButtons || !cards || !scrollContainer || !prevBtn || !nextBtn || !proxyBar) {
      return;
    }

    let scrollDriven = true;
    let scrollStep = 0;
    let currentIndex = 0;

    function setElementImageAttributes(element, imagePath, imagePathWebp) {
      if (element.parentElement && element.parentElement.tagName.toLowerCase() === 'picture') {
          const sources = element.parentElement.querySelectorAll('source');

          sources.forEach(source => {
              const type = source.getAttribute('type');
              if (type === 'image/webp') {
                  source.setAttribute('srcset', imagePathWebp);
                  source.setAttribute('data-srcset', imagePathWebp);
              } else if (type === 'image/jpeg') {
                  source.setAttribute('srcset', imagePath);
                  source.setAttribute('data-srcset', imagePath);
              }
          });

          element.setAttribute('src', imagePath);
          element.setAttribute('data-src', imagePath);
      } else {
          element.setAttribute('src', imagePath);
          element.setAttribute('data-src', imagePath);
      }
    }

    function setButtonState(button, isActive) {
      button.classList.toggle('active', isActive);
      button.setAttribute('aria-current', isActive ? 'true' : 'false');
    }

    function toggleButtonVisibility(button, isVisible) {
      button.classList.toggle('visible', isVisible);
      button.classList.toggle('hidden', !isVisible);
    }

    function updateControls() {
      navButtons.forEach((btn, i) => setButtonState(btn, i === currentIndex));
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex === cards.length - 1;
      setButtonState(prevBtn, currentIndex !== 0);
      setButtonState(nextBtn, currentIndex !== cards.length - 1);
    }

    // a11y: expose only the active slide to assistive tech. Non-active cards get
    // aria-hidden + inert (inert also removes their focusable descendants from
    // the tab order, avoiding a focusable-but-hidden state) so a screen reader
    // reads the active slide, then the prev/next buttons, then the next section.
    function updateCardExposure(activeIndex) {
      cards.forEach((card, i) => {
        const isActive = i === activeIndex;
        card.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        if (isActive) {
          card.removeAttribute('inert');
        } else {
          card.setAttribute('inert', '');
        }
      });
    }

    function updateButton(card, selectedColor) {
      const buttons = card.querySelectorAll('.action--explore-frames--shop-btn');
      buttons.forEach(button => toggleButtonVisibility(button, button.dataset.variant === selectedColor));
    }

    function updateActiveSwatch(card, buttons, button) {
      const swatchTitleContainer = card.querySelector('.action--product-swatch--titles')
      const swatchTitles = swatchTitleContainer.querySelectorAll('.action--product-swatch--title');
      buttons.forEach(btn => {
        if (btn === button) {
          btn.classList.add('active');
          btn.setAttribute('aria-checked', 'true');
          btn.parentElement.classList.add('active');
        } else {
          btn.classList.remove('active');
          btn.setAttribute('aria-checked', 'false');
          btn.parentElement.classList.remove('active');
        }
      });

      swatchTitles.forEach(title => {
        if (title.dataset.color === button.dataset.color) {
          title.classList.add('active');
        } else {
          title.classList.remove('active');
        }
      }
      );
    }

    function formatPrice(amount) {
      const locale = (typeof I18n !== "undefined" && I18n.locale) ? I18n.locale : 'en';
      switch (locale) {
        case 'de':
        case 'fr':
          return `${amount} €`;
        case 'en-GB':
          return `£${amount}`;
        default:
          return `$${amount}`;
      }
    }

    function updateProduct(card, selectedColor) {
      const frameDetails = window.getFrameDetailsByColor(selectedColor);
      if (!frameDetails) return;
      const productImage = card.querySelector('.action--explore-frames-card-image');
      const galleryImgs = (frameDetails.galleryImgs || '').split(',');
      const galleryImgsWebp = (frameDetails.galleryImgsWebp || '').split(',');

      // Use image 7 (index 6); fall back to image 1
      const imgsrc = galleryImgs[6] || galleryImgs[0];
      const imgsrcWebp = galleryImgsWebp[6] || galleryImgsWebp[0];

      if (!productImage) return;
      if (!imgsrc) return;
      if (!imgsrcWebp) return;

      setElementImageAttributes(productImage, imgsrc, imgsrcWebp);

      if (!frameDetails.class) return;
      updateButton(card, selectedColor);
      updatePricing(card, frameDetails);
    }

    function updatePricing(card, frameDetails) {
      const priceElement = card.querySelector('.action--shop-frames-price');
      const strikePriceElement = card.querySelector('.action--shop-frames-price-strike');
      const strikePriceWrapper = card.querySelector('.action--shop-frames-price-strike-wrapper');

      if (!priceElement) return;

      const price = frameDetails.price;
      const originalPrice = frameDetails.originalPrice;
      const colorClass = frameDetails.class;

      if (price) {
        priceElement.textContent = formatPrice(price);
        priceElement.setAttribute('data-color', colorClass);

        if (originalPrice && originalPrice !== price && strikePriceElement) {
          strikePriceElement.textContent = formatPrice(originalPrice);
          strikePriceElement.setAttribute('data-color', colorClass);

          if (strikePriceWrapper) {
            strikePriceWrapper.classList.remove('hide');
          }

          priceElement.classList.add('product__price-promo');
        } else {
          if (strikePriceWrapper) {
            strikePriceWrapper.classList.add('hide');
          }

          priceElement.classList.remove('product__price-promo');
        }
      }
    }

    function colorSwatchColors(card){
      const colorSwatchesLists = card.querySelectorAll('.action--product-swatches');

      if (colorSwatchesLists.length === 0) return;

      colorSwatchesLists.forEach(colorSwatchList => {
        const colorSwatches = colorSwatchList.querySelectorAll('.action--product-swatch');
        const colorSwatchButtons = colorSwatchList.querySelectorAll('.action--product-swatch--button');
        if (colorSwatches.length === 0) return;
          colorSwatches.forEach(colorSwatch => {
          const colorSwatchButton = colorSwatch.querySelector('.action--product-swatch--button');

          if (!colorSwatchButton) return;
            colorSwatchButton.addEventListener('click', function () {
              const selectedColor = colorSwatchButton.dataset.color;
              if (!selectedColor) return;
              updateProduct(card, selectedColor);
              updateActiveSwatch(card, colorSwatchButtons, colorSwatchButton);
              logGA4Event('explore_frames_select_color', {
                color: selectedColor,
              });
          });
        });

      });
    }

    function updateProxyScrollBar() {
      if (!proxyBar || !scrollContainer) return;
      const scrollWidth = scrollContainer.scrollWidth;
      const containerWidth = scrollContainer.offsetWidth;
      const scrollLeft = scrollContainer.scrollLeft;

      const barWidth = (containerWidth / scrollWidth) * 100;
      const barLeft = (scrollLeft / scrollWidth) * 100;

      proxyBar.style.width = `${barWidth}%`;
      proxyBar.style.left = `${barLeft}%`;
    }

    function updateScrollStep() {
      const card = cards[0];
      if (!card) return;

      const cardWidth = card.getBoundingClientRect().width;
      const containerStyle = window.getComputedStyle(scrollContainer);
      const gap = parseFloat(containerStyle.columnGap || containerStyle.gap || 0);

      scrollStep = cardWidth + gap;
    }

    function scrollToIndex(index) {
      const targetCard = cards[index];
      if (!targetCard) return;

      const containerWidth = scrollContainer.offsetWidth;
      const cardWidth = targetCard.getBoundingClientRect().width;
      const offset = targetCard.offsetLeft;

      let scrollLeft;

      if (window.innerWidth >= 1200 || window.innerWidth < 640) {
        // Small or large screens: center the card
        scrollLeft = offset - (containerWidth / 2) + (cardWidth / 2);
      } else {
        // Medium screens: align to left (active card fills left, next fills right)
        scrollLeft = offset;
      }

      scrollDriven = false;
      scrollContainer.scrollTo({
        left: scrollLeft,
        behavior: "smooth"
      });

      currentIndex = index;

      targetCard.classList.add("active");
      cards.forEach((card, i) => {
        if (i !== index) card.classList.remove("active");
      });

      updateCardExposure(index);
      updateControls();
      updateProxyScrollBar();

      setTimeout(() => scrollDriven = true, 400);
    }

    scrollContainer.addEventListener("scroll", () => {
      updateProxyScrollBar();
      if (scrollDriven) updateActiveNearest();
    });

    navButtons.forEach((btn, index) => {
      btn.addEventListener("click", () => {
        scrollToIndex(index);
        logGA4Event('explore_frames_select_nav', {
          product: btn.dataset.collection,
        });
      });
    });

    prevBtn.addEventListener("click", () => {
      if (currentIndex > 0) {
        scrollToIndex(currentIndex - 1);
        logGA4Event('explore_frames_select_prev', {
          index: currentIndex,
        });
      }
    });

    nextBtn.addEventListener("click", () => {
      if (currentIndex < cards.length - 1) {
        scrollToIndex(currentIndex + 1);
        logGA4Event('explore_frames_select_next', {
          index: currentIndex,
        });
      }
    });

    function updateActiveNearest() {
      const scrollCenter = scrollContainer.scrollLeft + scrollContainer.offsetWidth / 2;

      let closestIndex = 0;
      let minDistance = Infinity;

      cards.forEach((card, i) => {
        const cardCenter = card.offsetLeft + card.offsetWidth / 2;
        const distance = Math.abs(cardCenter - scrollCenter);

        if (distance < minDistance) {
          minDistance = distance;
          closestIndex = i;
        }
      });

      if (closestIndex !== currentIndex) {
        currentIndex = closestIndex;
        updateCardExposure(closestIndex);
        updateControls();
      }
    }


    // Debounced resize handler
    let resizeTimeout;
    window.addEventListener("resize", () => {
      scrollDriven = false;
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        updateScrollStep();
        scrollToIndex(currentIndex); // recenter active card
        updateProxyScrollBar();
      }, 100);
    });

    // Initialize
    currentIndex = 0;
    updateProxyScrollBar();
    updateCardExposure(0);
    updateControls();

    cards.forEach(card => {
      colorSwatchColors(card);
    });
  }
  // window.addEventListener('load', exploreFrames);
  window.addEventListener('load', () => {
    exploreFrames();

    // Fallback after 2s to load any remaining lazy images
    if (window.innerWidth < 640) {
      setTimeout(() => {
        const unloaded = document.querySelectorAll('img.action--explore-frames-card-image[lazy-loaded="false"]');
        if (unloaded.length > 0) {
          unloaded.forEach(img => {
            const src = img.dataset.src || img.getAttribute('src');
            if (src && !img.complete) {
              img.src = src;
            }

            const picture = img.closest('picture');
            if (picture) {
              picture.querySelectorAll('source').forEach(source => {
                const srcset = source.dataset.srcset || source.getAttribute('srcset');
                if (srcset) source.srcset = srcset;
              });
            }
            img.setAttribute('lazy-loaded', 'true');
          });
          console.warn(`Explore Frames: Loaded ${unloaded.length} lazy images after timeout.`);
        }
      }, 2000);
    }
  });
})();
/**
 * Ink Setup Page Animation Controller
 *
 * This IIFE manages scroll-triggered animations for the ink setup onboarding page.
 * It handles section-by-section animations, background color transitions, image effects,
 * and dynamic browser theme color updates as users scroll through the setup flow.
 */

(function() {

  window.addEventListener('load', function() {
    // Early exit if not on ink setup page
    if (!document.querySelector('.ink-setup-page')) return;

    // Reset scroll position to ensure consistent starting point
    window.scrollTo(0, 0);

    // Wait for images to be processed by the responsive helper
    setTimeout(function() {
      // ===== DOM ELEMENT SELECTION =====
      // Cache all necessary DOM elements for better performance

      // Section containers
      var section1 = document.querySelector(".action--ink-setup-1");
      var section2 = document.querySelector(".section--ink-setup-2");
      var section2Inner = document.querySelector(".action--ink-setup-2"); // Keep reference to inner content
      var section3 = document.querySelector(".section--ink-setup-3");
      var section3Img = section3 ? section3.querySelector(".action--ink-setup-3") : null;

      // Text elements with fade effects
      var fadeText1 = section1 ? section1.querySelector(".action--fade-text") : null;
      var imageFlip = section2Inner ? section2Inner.querySelector(".ink-setup-img-wrapper-2") : null;

      // Image elements
      var ditheringVideo = section2Inner ? section2Inner.querySelector(".action--ink-dithering-video") : null;
      var section2ImgOverlay = section2 ? section2.querySelector(".action--step-2-img-overlay") : null;
      var section3ImgOverlay = section3 ? section3.querySelector(".action--step-3-img-overlay") : null;
      var chevronContainer = section1 ? section1.querySelector(".action--chevron-container") : null;
      var chevron = section1 ? section1.querySelector(".action--chevron") : null;
      var img1 = section1 ? section1.querySelector(".action--ink-setup-img-1") : null;

      // Initialize GSAP ScrollTrigger plugin
      gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

      // ===== SECTION 1 ANIMATIONS =====
      // Initial hero section with fade-in animation and scroll-triggered fade-out
      if (section1) {
        // Initial move up animation when page loads
        gsap.to(
          section1,
          {
            transform: 'translateY(0%)',
            duration: 2.25,
            ease: "power1.out"
          }
        );

        // fade in image
        gsap.to(
          img1,
          {
            opacity: 1,
            duration: 3,
            ease: 'power1.out'
          }, "-=2")

        // Fade in text slightly after image
        gsap.to(
          fadeText1,
          {
            opacity: 1,
            duration: 3,
            ease: 'power1.out'
          }, "-=1")

        // Fade out text as user scrolls toward section 2 (delayed to not interfere with initial fade-in)
        if (fadeText1) {
          setTimeout(() => {
            gsap.fromTo(fadeText1,
              {
                opacity: 1
              },
              {
                opacity: 0,
                ease: "circ.inOut",
                scrollTrigger: {
                  trigger: section1,
                  start: "center 30%",
                  end: "bottom 30%",
                  scrub: 0.5,
                  toggleActions: "play none none reverse",
                  id: "fade-text-1",
                }
              }
            );
          }, 3000); // Wait for initial fade-in to complete
        }

         // Animate image flip effect with real-time scroll response
        if (imageFlip) {
          gsap.to(imageFlip,
            {
              scale: 1,
              rotateX: "0deg",
              width: "300px",
              scrollTrigger: {
                trigger: section2,
                start: "20% center",
                end: "center center",
                scrub: 0.01,
                id: "image-flip-up",
              }
            }
          );
        }

        // ===== SECTION 2 ANIMATIONS =====
        // Fade out white overlay for smooth transition
        if (section2ImgOverlay) {
          // Set initial state to prevent flashing
          gsap.set(section2ImgOverlay, { opacity: 1 });

          const section2OverlayTl = gsap.timeline({
            scrollTrigger: {
              trigger: section2,
              start: "top 60%",
              endTrigger: section3,
              end: "top center",
              scrub: 0.5,
              id: "section-2-overlay-timeline",
            }
          });

          section2OverlayTl
            .to(section2ImgOverlay, {
              opacity: 0,
              ease: "sine.inOut",
            })
            .to(section2ImgOverlay, {
              opacity: 1,
              ease: "sine.inOut",
            });
        }


        // Chevron fade-in and bobbing animation
        if (chevronContainer) {
            // Fade in the chevron 500ms after section 1 fade-in completes
            gsap.fromTo(chevron, {
              opacity: 0,
              y: 10
            }, {
              opacity: 1,
              y: 0,
              duration: 0.8,
              ease: "sine.inOut",
              delay: 2.1, // 1.6s (section1 duration) + 0.5s delay
            });

            // Continuous bobbing animation
            gsap.to(chevron, {
              y: -4,
              duration: 1.2,
              ease: "sine.inOut",
              yoyo: true,
              repeat: -1,
            });

            gsap.fromTo(chevronContainer,
            {
              opacity: 1
            },
            {
              opacity: 0,
              ease: "circ.inOut",
              scrollTrigger: {
              trigger: section1,
              start: "top 30%",
              end: "top 30%",
              endTrigger: section2,
              scrub: 0.5,
              toggleActions: "play none none reverse",
              id: "fade-chevron",
              }
            }
            );

          // Click handler to scroll to section 2
          chevronContainer.addEventListener('click', function() {
            if (section2) {
              // Smooth scroll to section 2 with GSAP
              gsap.to(window, {
                duration: 1.5,
                scrollTo: {
                  y: section2,
                  offsetY: 0
                },
                ease: "power2.inOut"
              });
            }
          });
        }

        if (ditheringVideo) {
          // Dithering video scrub animation
          if (ditheringVideo) {
            // Get video source - compatible with older browsers
            var videoSrc = ditheringVideo.src;
            if (!videoSrc) {
              var sourceElement = ditheringVideo.querySelector('source');
              videoSrc = sourceElement ? sourceElement.src : 'No source found';
            }

            // Wait for video metadata to load
            ditheringVideo.addEventListener('loadedmetadata', function() {
              if (!ditheringVideo.duration || ditheringVideo.duration === 0) {
                return; // Exit if no valid duration
              }

              // Speed up the video to 2x (makes 28s video play in 14s)
              ditheringVideo.playbackRate = 1.5;

              // Add event listener for when video finishes
              ditheringVideo.addEventListener('ended', function() {
                videoCompleted = true;
              });

              // Video auto-play animation
              ScrollTrigger.create({
                trigger: section2,
                start: "top center",
                end: "+=100%",
                id: "video-autoplay",
                onEnter: function() {
                  // Make video visible and start playing immediately
                  ditheringVideo.style.opacity = '1';
                  ditheringVideo.currentTime = 0;
                  videoCompleted = false;
                  ditheringVideo.play();
                },
                onEnterBack: function() {
                  // Only restart video if user has scrolled at least 50% before section2
                  const section2Top = section2 ? section2.offsetTop : 0;
                  const fiftyPercentBeforeSection2 = section2Top * 0.5;
                  const scrollY = window.scrollY;

                  if (scrollY <= fiftyPercentBeforeSection2) {
                    videoCompleted = false;
                    ditheringVideo.currentTime = 0;
                    ditheringVideo.play();
                  }
                },
              });
            });

            // Load the video metadata
            ditheringVideo.load();
          }
        }

        // Transition overlay from section 4 to section 5
        if (section3ImgOverlay) {
          gsap.to(section3ImgOverlay, {
            opacity: 0,
            ease: "circ.inOut",
            scrollTrigger: {
              trigger: section3,
              start: "top 70%",
              end: "center 90%",
              endTrigger: section3,
              scrub: 0.5,
              id: "step-3-overlay",
            }
          });
        }

        // ===== SECTION 5 ANIMATIONS =====
        // Final step sequence with staggered step reveals
        if (section3) {
          // Get references to individual step elements
          const step3_1 = section3.querySelector(".action--step-3-1");
          const step3_2 = section3.querySelector(".action--step-3-2");
          const step3_3 = section3.querySelector(".action--step-3-3");
          const step3_4 = section3.querySelector(".action--step-3-4");
          const step3_5 = section3.querySelector(".action--step-3-5");

          // Set initial states for steps 1-4 with transform effects
          if (step3_1) {
            gsap.set(step3_1, { y: 20, scale: 0.9, opacity: 0, transformOrigin: "center" });
          }
          if (step3_2) {
            gsap.set(step3_2, { y: 20, scale: 0.9, opacity: 0, transformOrigin: "center" });
          }
          if (step3_3) {
            gsap.set(step3_3, { y: 20, scale: 0.9, opacity: 0, transformOrigin: "center" });
          }
          if (step3_4) {
            gsap.set(step3_4, { y: 20, scale: 0.9, opacity: 0, transformOrigin: "center" });
          }

          if (step3_5) {
            gsap.set(step3_5, { opacity: 0 });
          }

          // Animate all steps together based on step3_1 trigger
          if (step3_1) {
            const tl = gsap.timeline({
              scrollTrigger: {
                trigger: section3,
                start: "top center",
                end: "top 50%",
                scrub: false,
                toggleActions: "play none none reverse",
                id: "step-5-all-in",
              }
            });

            // Animate step 1 with bounce effect
            tl.to(step3_1, {
              y: 0,
              scale: 1,
              opacity: 1,
              duration: 0.8,
              ease: "back.out(1.7)",
            })
            // Animate step 2 with slight delay
            .to(step3_2, {
              y: 0,
              scale: 1,
              opacity: 1,
              duration: 0.8,
              ease: "back.out(1.7)",
            }, "-=0.2")
            // Animate step 3 with slight delay
            .to(step3_3, {
              y: 0,
              scale: 1,
              opacity: 1,
              duration: 0.8,
              ease: "back.out(1.7)",
            }, "-=0.2")
            // Animate step 4 with slight delay
            .to(step3_4, {
              y: 0,
              scale: 1,
              opacity: 1,
              duration: 0.8,
              ease: "back.out(1.7)",
            }, "-=0.2")
            // Animate step 5 with simple fade
            .to(step3_5, {
              opacity: 1,
              duration: 0.8,
              ease: "circ.inOut",
            }, "-=0.2");
          }
        }

        // ===== STICKY DOWNLOAD BUTTON =====
        // Show sticky download button when user reaches section 2, hide only when back in section 1
        var stickyButton = document.querySelector('.action--sticky-download-button');
        if (stickyButton && section2) {
          ScrollTrigger.create({
            trigger: section3Img,
            start: "top center",
            end: "bottom bottom",
            endTrigger: section3Img,
            id: "sticky-download-button",
            onEnter: function() {
              stickyButton.classList.add('show-button');
            },
            onEnterBack: function() {
              stickyButton.classList.add('show-button');
            },
            onLeaveBack: function() {
              stickyButton.classList.remove('show-button');
            }
          });
        }

        // ===== FINALIZATION =====
        // Refresh ScrollTrigger after all animations are configured
        setTimeout(() => {
          ScrollTrigger.refresh();
        }, 100);

      }
    }, 500); // End of setTimeout - wait for images to load
  });
})();
/**
 * Ink Landing Page JavaScript
 */

(function() {

  // Press Slider functionality
  function initPressSlider() {
    const slider = document.querySelector('.action--ink-press-slider');
    if (!slider) return;

    const slides = slider.querySelectorAll('.ink-press-slide');
    if (slides.length <= 1) return;

    let currentSlide = 0;
    let intervalId;
    const slideInterval = 4000; // 4 seconds

    function showSlide(index) {
      // Remove active and not-active classes from all slides
      slides.forEach((slide, i) => {
        slide.classList.remove('active', 'not-active');

        if (i === index) {
          slide.classList.add('active');
        } else {
          slide.classList.add('not-active');
        }
      });
    }

    function nextSlide() {
      currentSlide = (currentSlide + 1) % slides.length;
      showSlide(currentSlide);
    }

    function startSlider() {
      intervalId = setInterval(nextSlide, slideInterval);
    }
    // Initialize first slide
    showSlide(0);

    // Start automatic sliding
    startSlider();
  }

  function brightnessAnimation() {
    const brightnessSection = document.querySelector('.action--ink-section--brightness-image-overlay');
    if (!brightnessSection) return;

    // Create timeline for brightness animation
    gsap.timeline({ repeat: -1, repeatDelay: 1 })
      .to(brightnessSection, {
        duration: 4,
        background: 'rgba(0, 0, 0, 0.65)',
        ease: 'power1.inOut'
      })
      // Pause for 1s after step 1
      .to({}, { duration: 1 }, "+=1")
      // Step 2: reset brightness
      .to(brightnessSection, {
        duration: 4,
        background: 'rgba(0, 0, 0, 0)',
        ease: 'power1.inOut'
      });
  }

  function observeFeaturesSection() {
    const featuresSection = document.querySelector('.action--ink-section--features');
    if (!featuresSection) return;

    let lastState = null; // "zoomedIn" or "zoomedOut"

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.85) {
          if (lastState !== "zoomedOut") {
            zoomOut();
            lastState = "zoomedOut";
          }
        }
      });
    }, {
      threshold: [0, 0.5, 0.9, 1]
    });

    observer.observe(featuresSection);

    // Also zoom in if scrolled to top of page
    window.addEventListener('scroll', () => {
      if (window.scrollY === 0 && lastState !== "zoomedIn") {
        zoomIn();
        lastState = "zoomedIn";
      }
    });
  }

  // Move zoomOut outside so it's accessible
  function zoomOut() {
    const featuresImage = document.querySelector('.action--ink-section--features-image');
    const featuresContent1 = document.querySelector('.action--ink-section--features-content-1');
    if (!featuresImage || !featuresContent1) return;

    const mobile = window.innerWidth < 640;

    const tl = gsap.timeline();
    tl.set(featuresContent1, { opacity: mobile ? 0 : 1 }) // Start hidden
      .to(featuresImage, {
        duration: 3.2,
        left: "49%",
        top: mobile ? "42%" : "16%",
        transform: `translateX(-50%) translateY(-50%) scale(${mobile ? 0.5 : 0.365})`,
        ease: 'circ.inout'
      })
      // Fade in featuresContent1 near the end of image animation
      .to(featuresContent1, {
        duration: 0.45,
        opacity: 1,
        ease: 'circ.inout'
      }, "-=1"); // starts 0.5s before image animation ends
  }

  function zoomIn() {
    const featuresImage = document.querySelector('.action--ink-section--features-image');
    const featuresContent1 = document.querySelector('.action--ink-section--features-content-1');
    if (!featuresImage || !featuresContent1) return;

    const mobile = window.innerWidth < 640;

    const tl = gsap.timeline();
      tl.to(featuresImage, {
        duration: 3.2,
        left: "70%",
        top: mobile ? "-18%" : "-40%",
        transform: `translateX(-50%) translateY(-50%) scale(${mobile ? 2.5 : 1.75})`,
        ease: 'circ.inout'
      })
      .to(featuresContent1, {
        duration: 0.45,
        opacity: mobile ? 0 : 1,
        ease: 'circ.inout'
      }, "-=2.5");
  }

  function toggleNavigationOnSteps() {
    const nav = document.querySelector('.ink-page-navigation');
    const stepsSection = document.querySelector('.action--ink-section--steps');
    const endNavSection = document.querySelector('.background-footer');

    if (!nav || !stepsSection) return;

    // Hide nav by default
    nav.style.opacity = '0';

    function updateNavVisibility() {
      const stepsTop = stepsSection.getBoundingClientRect().top + window.scrollY;
      const endTop = endNavSection
      ? endNavSection.getBoundingClientRect().top + window.scrollY
      : Infinity;
      const viewportBottom = window.scrollY + window.innerHeight;

      if (viewportBottom > stepsTop && viewportBottom < endTop) {
        nav.style.opacity = '1';
      } else {
        nav.style.opacity = '0';
      }
    }

    window.addEventListener('scroll', updateNavVisibility);
    window.addEventListener('resize', updateNavVisibility);
    updateNavVisibility(); // Initial check
  }

  function observeNavAnchors() {
    const navLinks = document.querySelectorAll('.action--ink-nav-link');
    if (!navLinks.length) return;

    let isScrollingToNavLink = false;
    let scrollTimeout = null;

    // Map nav links to their target sections
    const linkSectionPairs = Array.from(navLinks).map(link => {
      const href = link.getAttribute('href');
      if (!href || !href.startsWith('#')) return null;
      const section = document.querySelector(href);
      return section ? { link, section } : null;
    }).filter(Boolean);

    // Use IntersectionObserver to watch each section
    const observer = new IntersectionObserver((entries) => {
      if (isScrollingToNavLink) return; // Don't update while scrolling to nav link

      const activeEntry = entries.find(entry => entry.isIntersecting && entry.intersectionRatio > 0);
      navLinks.forEach(l => l.classList.remove('active'));
      if (activeEntry) {
        const pair = linkSectionPairs.find(p => p.section === activeEntry.target);
        if (pair) pair.link.classList.add('active');
      }
    }, {
      threshold: Array.from({length: 101}, (_, i) => i / 100) // 0.00 to 1.00
    });

    // Smooth scroll on click
    navLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        const href = link.getAttribute('href');
        if (href && href.startsWith('#')) {
          const section = document.querySelector(href);
          if (section) {
            e.preventDefault();
            isScrollingToNavLink = true;
            navLinks.forEach(l => l.classList.remove('active'));
            link.classList.add('active');
            const navbar = document.getElementById('navbar');
            const offset = navbar ? navbar.offsetHeight : 0;
            const sectionTop = section.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({ top: sectionTop, behavior: 'smooth' });

            // Wait for scroll to finish
            if (scrollTimeout) clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
              isScrollingToNavLink = false;
            }, 700);
          }
        }
      });
    });

    linkSectionPairs.forEach(pair => observer.observe(pair.section));
  }

  function heroCtaWorkaround() {
    $(function() {
      $('a[href*="#"]:not([href="#"])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
          if (target.length) {
            $('html, body').animate({
              scrollTop: target.offset().top - 115
            }, 1000);
            return false;
          }
        }
      });
    });    
  }

  window.addEventListener('load', function() {
    if (!document.querySelector('.ink-product-page-new')) return;
    initPressSlider();
    observeFeaturesSection();
    brightnessAnimation();
    toggleNavigationOnSteps();
    observeNavAnchors();
    heroCtaWorkaround();
  });
})();
(function() {
    document.addEventListener('DOMContentLoaded', function() {
        // Early exit if not on PDP
        if (!document.querySelector('.product-page')) return;

        // ===== DOM ELEMENT SELECTION =====
        // Cache all necessary DOM elements for better performance

        // Section containers
        const autoOnOffSection = document.querySelector('.auto-on-off');

        // Navbar Height Offset
        const navbar = document.querySelector('.navbar');
        const navbarHeight = navbar ? navbar.offsetHeight : 0;

        // ===== AUTO ON/OFF ANIMATIONS =====
        if (autoOnOffSection) {
            // Initialize GSAP ScrollTrigger plugin
            gsap.registerPlugin(ScrollTrigger);

            //Image elements
            const onOffImgs = autoOnOffSection.querySelectorAll("img");
            const imgOn = onOffImgs[0];
            const imgOff = onOffImgs[1];

            if (onOffImgs && imgOn && imgOff) {
                ScrollTrigger.create({
                    trigger: autoOnOffSection,
                    start: `top top+=${navbarHeight}`,
                    end: `+=150%`,
                    scrub: true,
                    pin: true,
                    pinSpacing: true,
                    onUpdate: (self) => {
                        const progress = self.progress;
                        const fadeProgress = Math.min(progress * 2, 1);

                        // Fade images
                        gsap.set(imgOn, { opacity: 1 - fadeProgress });
                        gsap.set(imgOff, { opacity: fadeProgress });
                        gsap.set([imgOn, imgOff], { force3D: true });


                        // Fade text from black to white
                        const textContainer = autoOnOffSection.querySelector(".auto-on-off__content-container");
                        const textColor = `rgb(${Math.round(255 * fadeProgress)}, ${Math.round(255 * fadeProgress)}, ${Math.round(255 * fadeProgress)})`;
                        gsap.set(textContainer, { color: textColor });

                        // Fade in overlay (night effect)
                        const overlay = autoOnOffSection.querySelector(".auto-on-off__overlay");
                        gsap.set(overlay, { opacity: fadeProgress * 0.7 });
                    }
                });
            }

            // Recalibrate on any page height change (e.g. async VWO/consent
            // content shifting layout above this section), not just when
            // this section itself resizes.
            const ro = new ResizeObserver(() => ScrollTrigger.refresh());
            ro.observe(autoOnOffSection);
            ro.observe(document.body);

            // The Cookiebot banner is position: fixed, so it doesn't
            // trigger the ResizeObserver above — refresh explicitly when
            // it appears/disappears.
            ['CookiebotOnDialogDisplay', 'CookiebotOnConsentReady', 'CookiebotOnAccept', 'CookiebotOnDecline']
                .forEach(function(evt) {
                    window.addEventListener(evt, () => ScrollTrigger.refresh());
                });
        }
    });
})();
(function() {
  'use strict';

    function sharePage() {
      if (!document.querySelector('.product-page')) return;
      const url = new URL(window.location.origin + window.location.pathname);
      url.search = "";
      url.searchParams.set("utm_content", "send-hint");
      const cleanUrl = url.toString();

      const shareData = {
        title:`${document.title}`,
        text: 'Check out this frame from Aura - this would make a great gift',
        url: cleanUrl
      }
      const sendHintOpenBtn = document.querySelector('.send-hint--open-popup-btn');

      if (sendHintOpenBtn) {
        if (navigator.canShare && navigator.canShare(shareData)) {
          sendHintOpenBtn.addEventListener('click', async () => {
            logGA4Event('share_page_btn_click', {});
              try {
                  await navigator.share(shareData);
              } catch (error) {
                  console.error('Error sharing:', error);
              }
          });
        } else {
          // Fallback for browsers that don't support Web Share API
          sendHintOpenBtn.addEventListener('click', () => {
              // email instead
              window.location.href = `mailto:?subject=${encodeURIComponent(document.title)}&body=${encodeURIComponent('Check out this frame from Aura  - this would make a great gift. ' + window.location.href)}`;
          });
        }  
      }
    }
    window.addEventListener('load', sharePage);
})();



(function ($) {
  $(document).ready(function () {
    var sliders = document.querySelectorAll(".action--slider");
    var slides = document.querySelectorAll(".action--slide");

    if (!sliders.length) {
      return;
    }

    function handleVideoLoad(slide) {
      const video = slide.querySelector(".slide-video");
      const image = slide.querySelector(".slide-image");
      if (!video) return;
    
      const onVideoLoaded = () => {
        video.classList.add("loaded");
        if (image) image.classList.add("video-loaded");
        video.removeEventListener("loadeddata", onVideoLoaded);
      };
    
      video.addEventListener("loadeddata", onVideoLoaded);

      // If the video is  already loaded, the event might not fire — so check readiness:
      if (video.readyState >= 2) {
        onVideoLoaded();
      }

      // Safari needs an explicit play() to kick off autoplay for <source media> videos.
      if (video.hasAttribute("autoplay") && video.paused) {
        video.play().catch(function () {});
      }
    }
    
    slides.forEach(slide => {
      slide.classList.remove('display-none')
      handleVideoLoad(slide);
    })

    // One slide: video is set up, but no dots/swipe/auto-advance needed
    if (slides.length <= 1) return;

    sliders.forEach(function (slider) {
      var slides = slider.querySelectorAll(".action--slide");
      var dots = slider.querySelectorAll(".action--dot");
      var current = 0;
      var isAnimating = false;
      var autoTimer;

      function startAutoScroll() {
        clearTimeout(autoTimer);
        autoTimer = setTimeout(() => {
          goToSlide(current + 1);
        }, 25000);
      }
      
      function lazyLoadVideo(slide) {
        const video = slide.querySelector(".slide-video");
        if (!video) return;
      
        const sources = video.querySelectorAll("source[data-src]");
        //return if already loaded
        if (!sources.length) return;
      
        sources.forEach(source => {
          source.setAttribute("src", source.dataset.src);
          source.removeAttribute("data-src");
        });
      
        video.load();
      }

      function goToSlide(index) {
        //check that current slide hasnt been removed from VWO experiement
        if (current >= slider.querySelectorAll(".action--slide").length) {
          current = slider.querySelectorAll(".action--slide").length - 1;
        }
        
        if (isAnimating || index === current) return;
        isAnimating = true;

        slides[current].classList.remove("z2");
        slides[current].classList.add("z0");
        slides[current].style.opacity = 0;

        dots[current].classList.remove("active");

        //allow for number of slides to be changed in VWO
        const maxSlides = slider.querySelectorAll(".action--slide").length;
        current = ((index % maxSlides) + maxSlides) % maxSlides;


        lazyLoadVideo(slides[current]);

        slides[current].classList.remove("z0");
        slides[current].classList.add("z2");
        slides[current].style.opacity = 1;
        slides[current].style.display = 'flex';

        dots[current].classList.add("active");

        setTimeout(() => { isAnimating = false; }, 400);

        startAutoScroll();

      }

      //dots click
      dots.forEach((dot, i) => {
        dot.addEventListener("click", () => {
          goToSlide(i)
        })
      })

      //mouse drag
      let isDown = false;
      let startMouseX = 0;
      
      slider.addEventListener("mousedown", (e) => {
        isDown = true;
        startMouseX = e.clientX;
      });
      
      slider.addEventListener("mouseup", (e) => {
        if (!isDown) return;
        isDown = false;
      
        let endX = e.clientX;
        if (endX - startMouseX > 50) {
          goToSlide(current - 1); // drag right
        } else if (startMouseX - endX > 50) {
          goToSlide(current + 1); // drag left
        }
      });

      // Touch drag / swipe
      let startX = 0;
      slider.addEventListener("touchstart", (e) => {
        startX = e.touches[0].clientX;
      });
      slider.addEventListener("touchend", (e) => {
        let endX = e.changedTouches[0].clientX;
        if (endX - startX > 50) {
          goToSlide(current - 1); // swipe right
        } else if (startX - endX > 50) {
          goToSlide(current + 1); // swipe left
        }
      });
      
      //return the slider data for VWO
      slider.sliderInstance = {
        goToSlide: goToSlide,
        slides: slides,
        dots: dots,
        getCurrent: () => current
      };

      startAutoScroll();
    });
  });
})(jQuery);

(function() {
    // Early exit if not on homepage
    if (!document.querySelector('.home-page') || !document.querySelector('.section--hp-ink-banner--frame-1')) return;   
    
    window.addEventListener('load', function() {
        // Wait for images to be processed by the responsive helper
        setTimeout(function() {
            //section 1
            const stickyEls = document.querySelectorAll('.sticky-statement');
            if (!stickyEls) return;
            
            stickyEls.forEach((el, i) => {
                const h1 = el.querySelector('h1');
            
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: el,
                        start: 'top 80%',
                        end: 'bottom top',
                        scrub: 1,
                        markers: false,
                    }
                });
            
                // Fade in as it reaches the center
                tl.fromTo(h1,
                    { opacity: 0, yPercent: 20 },
                    { opacity: 1, yPercent: 0, ease: 'none', duration: 1 }
                );
            
                // Fade/move out toward the top
                tl.to(h1,
                    { opacity: 0, yPercent: -20, ease: 'none', duration: 1 }
                );
            });

            //section 2
            //image scale in
            let mm = gsap.matchMedia();
            const inkBannerImage = document.querySelector('.ink-banner-image--1')
            //desktop
            mm.add("(min-width: 52rem)", () => {
                gsap.to(inkBannerImage, {
                    transform: 'scale(2)',
                    transformOrigin: "75% center",
                    ease: "none",
                    scrollTrigger: {
                    trigger: inkBannerImage,
                    start: "top 80%",
                    end: "top 20%", 
                    scrub: true,
                    markers: false
                    }
                });
            })
            //mobile
            mm.add("(max-width: 51.99rem)", () => {
                gsap.to(inkBannerImage, {
                    transform: 'scale(1.7)',
                    //transformOrigin: "75% center",
                    ease: "none",
                    scrollTrigger: {
                    trigger: inkBannerImage,
                    start: "top 50%",
                    end: "top 20%", 
                    scrub: 0.5,
                    markers: false
                    }
                });
            })

            //pin image and animate text
            let tl = gsap.timeline({
                scrollTrigger: {
                  trigger: '.action--hp-ink-banner--frame-2',
                  start: 'top top',
                  end: 'bottom bottom',
                  scrub: true,
                  markers: false
                }
            });
            
            tl.from(".action--ink-banner--section-2--text-1", { opacity: 0, y: 50, duration: 0.3 })
            .from(".ink-banner-svg--left", { opacity: 0, y: 30, duration: 0.3 }, "<") 
            .from(".action--disclaimer", { opacity: 0, y: 30, duration: 0.3 }, "<") 
            .to(".action--ink-banner--section-2--text-1", { opacity: 0, y: -20, duration: 0.3 }, 0.3)
            .fromTo(".action--ink-banner--section-2--text-2", 
                { opacity: 0, y: 30, display: "none" }, 
                { opacity: 1, y: 0, display: "flex", duration: 0.3 }, 
                0.6);

            //section 3
            const inkBannerVideo = document.querySelector(".ink-banner--video");
            if (!inkBannerVideo) return;

            ScrollTrigger.create({
                trigger: ".video-wrapper",
                start: "top 35%",
                markers: false,
                onEnter: () => {
                inkBannerVideo.play();
                gsap.to(".action--blk-to-white-text", {
                    color: "#F9F9F6",
                    duration: 1,
                    ease: "power1.out",
                    delay: 2
                });
                },
                onLeaveBack: () => {
                reverseVideo(inkBannerVideo);
                gsap.to(".action--blk-to-white-text", {
                    color: "#131C27",
                    duration: 1,
                    ease: "power3.out"
                });
                }
            });

            // helper to play in reverse
            function reverseVideo(video) {
            // if the browser doesn’t support negative playbackRate, simulate it:
                gsap.ticker.add(function reverseFrame() {
                    if (video.currentTime <= 0) {
                    gsap.ticker.remove(reverseFrame);
                    video.pause();
                    } else {
                    video.currentTime -= 1 / 30; // ~30fps reverse playback
                    }
                });
            }
        }, 500);

        //add intetrsection observer for each section to help with ga4 tracking
        const sections = document.querySelectorAll(
            ".section--hp-ink-banner--frame-1, .section--hp-ink-banner--frame-2, .section--hp-ink-banner--frame-3"
        );
        if (!sections.length) return;

        const seenSections = new WeakSet();
        const observer = new IntersectionObserver(
            (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && !seenSections.has(entry.target)) {
                    seenSections.add(entry.target);
                    let sectionName = "";

                    if (entry.target.classList.contains("section--hp-ink-banner--frame-1")) {
                        sectionName = "ink_banner_frame_1_viewed";
                    } else if (entry.target.classList.contains("section--hp-ink-banner--frame-2")) {
                        sectionName = "ink_banner_frame_2_viewed";
                    } else if (entry.target.classList.contains("section--hp-ink-banner--frame-3")) {
                        sectionName = "ink_banner_frame_3_viewed";
                    }
                    logGA4Event('ink-banner-view', { 'section': sectionName });
                    observer.unobserve(entry.target);
                }
            });
            },
            {
                root: null,
                threshold: 0.1,
            }
        )
        sections.forEach((section) => observer.observe(section));
    });
})();


  
(function () {
  const quickViewModal = document.querySelector(".action--product-quick-view");
  const quickViewBtns = document.querySelectorAll(
    ".action--product-quick-view-btn"
  );

  if (!quickViewModal || quickViewBtns.length === 0) return;

  const closeQuickViewBtn = quickViewModal.querySelector(
    ".action--product-quick-view--close"
  );
  const quickViewContent = quickViewModal.querySelector(
    ".action--product-quick-view--content"
  );
  const body = document.body;

  function logGA4Event(color, button) {
    window.gtag && window.gtag("event", "product_quick_view_open", {
      info: "click on quick view button",
      color: color,
      location: button ? button.dataset.location || "unknown" : "unknown",
    });
  }

  function toggleQuickViewModal() {
    if (quickViewModal.classList.contains("is-closed")) {
      document.body.classList.remove("is-open");
      quickViewModal.classList.remove("is-closed");
      quickViewModal.classList.add("is-open");
      body.classList.add("is-open");
    } else {
      quickViewModal.classList.toggle("is-open");
      body.classList.remove("is-open");
      document.body.classList.add("is-open");
    }
  }

  function closeQuickViewModal() {
    quickViewModal.classList.remove("is-open");
    quickViewModal.classList.add("is-closed");
    body.classList.remove("is-open");
  }

  function setQuickViewContent(color) {
    const details = window.getFrameDetailsByColor(color);
    if (color && quickViewContent) {
      const items = quickViewContent.querySelectorAll(".action--qv-item");
      items.forEach(function (item) {
        // Loop through all data-* keys on the item
        Object.keys(item.dataset).forEach(function (dataKey) {
          if (dataKey) {
            item.textContent = details[dataKey] || "";
          }
        });
      });
    }
  }

  function setPricing(color) {
    const details = window.getFrameDetailsByColor(color);

    const priceValue = quickViewContent.querySelector(".action--price-value");
    if (priceValue && details.price) {
      priceValue.textContent = "$" + details.price;
    }

    // Original price (strike-through)
    const priceStrikeWrapper = quickViewContent.querySelector(
      ".action--price-value-strike-wrapper"
    );
    const priceStrike = quickViewContent.querySelector(
      ".action--price-value-strike"
    );
    if (priceStrikeWrapper && priceStrike) {
      if (details.originalPrice) {
        priceStrikeWrapper.classList.remove("hide");
        priceStrike.textContent = "$" + details.originalPrice;
      } else {
        priceStrikeWrapper.classList.add("hide");
        priceStrike.textContent = "";
      }
    }
  }

  function addToCartBtn(color, button) {
    const atcData = button.dataset.atc;
    const atcTrue = atcData == "true";
    if (!atcTrue) return;
    const details = window.getFrameDetailsByColor(color);
    const addToCartBtn = quickViewContent.querySelector(
      ".action--quick-add-btn"
    );
    if (addToCartBtn && details) {
      addToCartBtn.setAttribute("data-color", color);
      addToCartBtn.classList.add(details.color);
      addToCartBtn.setAttribute(
        "aria-label",
        `Add ${details.framename || "product"} to cart`
      );
      addToCartBtn.classList.remove("hide");

      // Add event listener to close modal and log GA4 event on click
      addToCartBtn.addEventListener("click", function handleAddToCartClick() {
        closeQuickViewModal();
        window.gtag && window.gtag("event", "product_quick_view_add_to_cart", {
          info: "add to cart from quick view",
          color: color,
          location: button ? button.dataset.location || "unknown" : "unknown",
        });
        addToCartBtn.removeEventListener("click", handleAddToCartClick);
      });
    }
  }

  function setSpecsGallery(color) {
    const details = window.getFrameDetailsByColor(color);
    const specsGallery = quickViewContent.querySelector(
      ".action--specs-gallery-all"
    );
    const specsGalleryItems = Array.from(
      specsGallery.querySelectorAll(".action--specs-gallery--item")
    );
    if (specsGallery && specsGalleryItems.length > 0) {
      const colorCollection = details.collection;
      specsGalleryItems.forEach((item) => {
        const indexes = JSON.parse(item.dataset.indexes || "{}");
        item.dataset.originalIndex =
          indexes[colorCollection] !== undefined
            ? indexes[colorCollection]
            : 999;
      });
      specsGalleryItems
        .sort(
          (a, b) =>
            Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex)
        )
        .forEach((item) => specsGallery.appendChild(item));
      specsGalleryItems.forEach(function (item) {
        let show = true;
        const collections = item.dataset.collections
          ? item.dataset.collections.split(",")
          : [];
        const colorCollection = details.collection;

        if (
          collections.length &&
          (!colorCollection || !collections.includes(colorCollection))
        ) {
          show = false;
        }

        item.classList.toggle("hide", !show);

        const textContents = item.querySelectorAll(
          ".actions--specs-gallery--item-text-content"
        );
        textContents.forEach(function (textDiv) {
          if (!textDiv.hasAttribute("data-collection")) {
            textDiv.classList.remove("hide");
          } else if (textDiv.dataset.collection === colorCollection) {
            textDiv.classList.remove("hide");
          } else {
            textDiv.classList.add("hide");
          }
        });
      });
    }
  }

  function renderSwatches(color) {
    const details = window.getFrameDetailsByColor(color);
    const swatchContainer = quickViewContent.querySelector(
      ".action--product-quick-view--swatches"
    );
    const swatches = swatchContainer
      ? swatchContainer.querySelectorAll(".action--product-quick-view-swatch")
      : null;
    swatches.forEach((swatch) => {
      if (swatch.dataset.collection === details.collection) {
        swatch.classList.remove("hide");
      } else {
        swatch.classList.add("hide");
      }
    });
  }

  function renderImage(color) {
    const details = window.getFrameDetailsByColor(color);
    const imageElement = quickViewContent.querySelector(
      ".action--product-quick-view-image"
    );
    const picture = imageElement ? imageElement.closest("picture") : null;
    const galleryImgs = details.galleryImgs ? details.galleryImgs.split(",") : [];
    const galleryImgsWebp = details.galleryImgsWebp ? details.galleryImgsWebp.split(",") : [];

    // Use image 7 (index 6); fall back to image 1 if a color doesn't have 7 images
    const imgsrc = galleryImgs[6] || galleryImgs[0] || "";
    const imgsrcWebp = galleryImgsWebp[6] || galleryImgsWebp[0] || "";

    if (imageElement && picture && imgsrc) {
      // Remove any existing <source>
      picture.querySelectorAll("source").forEach((src) => src.remove());

      // Add webp source if available
      if (imgsrcWebp) {
        const source = document.createElement("source");
        source.type = "image/webp";
        source.srcset = imgsrcWebp;
        picture.insertBefore(source, imageElement);
      }

      imageElement.src = imgsrc;
      imageElement.alt = details.imagetext || "Product Image";
    }
  }

  function createTabs(color) {
    const tabContainer = quickViewModal.querySelector(
      ".action--product-info-tab-container"
    );
    const tabPanelParent = quickViewModal.querySelector(".frame-tabs");
    if (!tabContainer || !tabPanelParent) return;

    const tabTemplate = tabContainer.querySelector(".action--product-info-tab");
    const panelTemplate = tabPanelParent.querySelector(
      ".action--product-info-tab-panel"
    );
    if (!tabTemplate || !panelTemplate) return;

    tabContainer.innerHTML = "";
    tabPanelParent
      .querySelectorAll(".action--product-info-tab-panel")
      .forEach((panel) => panel.remove());

    const details = window.getFrameDetailsByColor(color);
    const tabDefs = [
      { key: "features", label: tabPanelParent.dataset.features },
      { key: "specs", label: tabPanelParent.dataset.specs },
      { key: "desc", label: tabPanelParent.dataset.description },
    ];

    tabDefs.forEach((tab, idx) => {
      // Clone and set up tab button
      const btn = tabTemplate.cloneNode(true);
      btn.id = `tab-${tab.key}`;
      btn.className =
        `action--product-info-tab tab-nav-title tab-${tab.key}` +
        (idx === 0 ? " active" : "");
      btn.setAttribute("role", "tab");
      btn.setAttribute("aria-selected", idx === 0 ? "true" : "false");
      btn.setAttribute("aria-controls", `tabpanel-${tab.key}`);
      btn.dataset.tabValue = tab.key;
      btn.textContent = tab.label;
      tabContainer.appendChild(btn);

      // Clone and set up tab panel
      const panel = panelTemplate.cloneNode(true);
      panel.id = `tabpanel-${tab.key}`;
      panel.className = `product-info-tab-panel action--product-info-tab-panel tab${
        tab.key
      } ${idx !== 0 ? "" : "active"}`;
      panel.setAttribute("role", "tabpanel");
      panel.dataset.tabValue = tab.key;
      panel.tabIndex = idx === 0 ? 0 : -1;
      panel.setAttribute("aria-labelledby", `tab-${tab.key}`);
      panel.setAttribute("aria-describedby", `tabpanel-${tab.key}-content`);
      if (idx !== 0) panel.setAttribute("inert", "");
      // Clear panel content
      panel.innerHTML = "";

      // Fill panel content
      let content = details[tab.key];
      if (content) {
        try {
          const parsed = JSON.parse(content);
          if (Array.isArray(parsed)) {
            const ul = document.createElement("ul");
            ul.className = "frameInfo-pdpList pl0--5 xs-py1 xs-pr0 width-100";
            ul.id = `tabpanel-${tab.key}-content`;
            parsed.forEach((bullet) => {
              if (Array.isArray(bullet)) {
                bullet.forEach((sub) => {
                  if (sub) {
                    const li = document.createElement("li");
                    li.className = "ml3 list-style-none";
                    li.innerHTML = sub;
                    ul.appendChild(li);
                  }
                });
              } else if (bullet) {
                const li = document.createElement("li");
                li.className = "list-style-hyphen small-detail--3";
                li.tabIndex = 0;
                li.innerHTML = bullet;
                ul.appendChild(li);
              }
            });
            panel.appendChild(ul);
          } else {
            const p = document.createElement("p");
            p.className = "p0 m0 small-detail--3";
            p.id = `tabpanel-${tab.key}-content`;
            p.tabIndex = 0;
            p.innerHTML = parsed;
            panel.appendChild(p);
          }
        } catch (e) {
          // Not JSON, just output as HTML
          const p = document.createElement("p");
          p.className = "p0 m0 small-detail--3";
          p.id = `tabpanel-${tab.key}-content`;
          p.tabIndex = 0;
          p.innerHTML = content;
          panel.appendChild(p);
        }
      }
      tabPanelParent.appendChild(panel);
    });

    // Tab switching logic
    tabContainer.querySelectorAll("button").forEach((btn, idx) => {
      btn.addEventListener("click", function () {
        tabContainer.querySelectorAll("button").forEach((b) => {
          b.classList.toggle("active", b === btn);
          b.setAttribute("aria-selected", b === btn ? "true" : "false");
        });
        tabPanelParent
          .querySelectorAll(".action--product-info-tab-panel")
          .forEach((panel, pidx) => {
            const show = panel.dataset.tabValue === btn.dataset.tabValue;
            panel.classList.toggle("active", show);
            panel.tabIndex = show ? 0 : -1;
            if (!show) {
              panel.setAttribute("inert", "");
            } else {
              panel.removeAttribute("inert");
            }
          });
      });
    });

    // --- Equalize tab panel heights to the tallest one ---
    setTimeout(() => {
      const panels = tabPanelParent.querySelectorAll(
        ".action--product-info-tab-panel"
      );
      let maxHeight = 0;
      // First, make all panels visible to measure their heights accurately

      // Measure heights
      panels.forEach((panel) => {
        const height = panel.getBoundingClientRect().height;
        if (height > maxHeight) maxHeight = height;
      });
      // Set minHeight
      panels.forEach((panel, idx) => {
        panel.style.minHeight = maxHeight + "px";
      });
    }, 0);
  }

  // Track last color loaded to avoid unnecessary updates
  let lastLoadedColor = null;

  function updateQuickView(color, button) {
    if (!color || !quickViewContent) return;
    if (lastLoadedColor === color) return; // Prevent duplicate updates
    lastLoadedColor = color;
    setQuickViewContent(color);
    createTabs(color);
    setPricing(color);
    renderImage(color);
    renderSwatches(color);
    setSpecsGallery(color); // <-- Add this line
    if (button) addToCartBtn(color, button);
  }

  window.addEventListener("load", function () {
    if (
      !quickViewModal ||
      quickViewBtns.length === 0 ||
      !closeQuickViewBtn ||
      !quickViewContent
    )
      return;

    quickViewBtns.forEach(function (button) {
      button.addEventListener("mouseenter", function (event) {
        var color = event.currentTarget.getAttribute("data-color");
        updateQuickView(color, button);
      });

      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        var color = event.currentTarget.getAttribute("data-color");
        updateQuickView(color, button);
        toggleQuickViewModal();
        logGA4Event(color, button);
      });
    });

    closeQuickViewBtn.addEventListener("click", function () {
      closeQuickViewModal();
    });

    quickViewModal.addEventListener("click", function (event) {
      if (!quickViewContent) return;
      if (!quickViewContent.contains(event.target)) {
        closeQuickViewModal();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (
        event.key === "Escape" &&
        quickViewModal.classList.contains("is-open")
      ) {
        closeQuickViewModal();
      }
    });
  });
})();
// Reports to Airbrake if available, falls back to console.error in development
function cookieConsentNotify(error, params) {
  if (window.airbrake) {
    airbrake.notify({ error: error, params: params });
  } else {
    console.error('[cookie-consent]', error, params);
  }
}

// Checks Cookiebot initialized after all resources load — only runs on locales where Cookiebot is injected
window.addEventListener('load', function() {
  if (window.__0xC00K13 && !window.Cookiebot) {
    var scriptEl = document.getElementById('Cookiebot');
    cookieConsentNotify('Cookiebot failed to load', {
      url: window.location.href,
      locale: document.documentElement.lang,
      cookiebotScriptPresent: !!scriptEl,
      cookiebotCbid: scriptEl ? scriptEl.getAttribute('data-cbid') : null,
    });
  }
});

// Attaches click handlers to consent triggers — runs immediately as marketing.js loads at end of <body>
try {
  var els = document.querySelectorAll('.cookieConsentLink, .js-cookiebot-show');

  // Only report missing elements on /privacy where they are always expected
  if (els.length === 0 && window.location.pathname === '/privacy') {
    cookieConsentNotify('No cookie consent elements found on privacy page', { url: window.location.href });
  }

  els.forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      if (window.Cookiebot) {
        Cookiebot.show();
      } else {
        // Reports which element was clicked to identify where on the page the failure occurred
        cookieConsentNotify('Cookiebot not available on click', { element: el.className, url: window.location.href });
      }
    });
  });
} catch(err) {
  // Catches unexpected setup errors and reports with full stack trace
  cookieConsentNotify('Unexpected error in cookie-consent setup', { message: err.message, stack: err.stack, url: window.location.href });
}
;
(function() {
  var forms = document.querySelectorAll('.action--email-signup-form');

  if (!forms.length) return;

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  forms.forEach(function (form) {
    var input = form.querySelector('.action--email-signup-input');

    var disclaimer = form.parentNode.querySelector(
      '.action--email-signup-message'
    );

    if (!input || !disclaimer) return;

    var signupUrl = form.dataset.emailCaptureUrl;
    var signup_source = form.dataset.signupSource;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = input.value.trim();
      if (!email || !isValidEmail(email)) {
        input.classList.add('is-error');
        disclaimer.textContent =
          disclaimer.dataset.emailSignupError;
        return;
      }

      input.classList.remove('is-error');

      fetch(signupUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': document
            .querySelector('meta[name="csrf-token"]')
            .getAttribute('content')
        },
        body: JSON.stringify({
          email: email,
          signup_source: signup_source
        })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Signup failed');
          }

          return response.json();
        })
        .then(function () {
          disclaimer.textContent =
            disclaimer.dataset.emailSignupSuccess;

          logGA4Event('email_signup', {
            signup_source: signup_source
          });

          input.value = '';
        })
        .catch(function (error) {
          console.error(error);

          disclaimer.textContent =
            disclaimer.dataset.emailSignupError;
        });
    });

    input.addEventListener('input', function () {
      input.classList.remove('is-error');
    });
  });
})();
(function() {
  const countryLanguageSelectorOptions = [
    { code: 'US', label: 'us', name: 'United States', lang: ['en', 'es'], domain: 'auraframes.com' },
    { code: 'GB', label: 'gb', name: 'United Kingdom', lang: ['en'], domain: 'auraframes.co.uk' },
    { code: 'CA', label: 'ca', name: 'Canada', lang: ['en'], domain: 'auraframes.ca' },
    { code: 'DE', label: 'de', name: 'Deutschland', lang: ['de'], domain: 'auraframes.de' },
    { code: 'FR', label: 'fr', name: 'France', lang: ['fr'], domain: 'auraframes.fr' },
    { code: 'MX', label: 'mx', name: 'Mexico', lang: ['es'], domain: 'auraframes.mx' },
    { code: 'BE', label: 'be', name: 'Belgium', lang: ['nl', 'fr', 'de'], domain: 'auraframes.be' },
    { code: 'NL', label: 'nl', name: 'Netherlands', lang: ['nl', 'fr', 'de'], domain: 'auraframes.nl' },
    { code: 'LU', label: 'lu', name: 'Luxembourg', lang: ['fr', 'de'], domain: 'auraframes.lu' },
  ];
  window.addEventListener('load', function() {
    const els = getElements();
    if (!els) return;
    const countries = getCountries();
    populateCountrySelect(els.countrySelect, countries);
    bindCountryChange(els.countrySelect, els.languageSelect, countries, els.submitBtn);
    bindLanguageChange(els.countrySelect, els.languageSelect, els.submitBtn);
    bindModalClose(els.locationSelector, els.locationSelectorClose);
    bindOverlayClose(els.locationSelector)
    bindModalOpen(els.locationSelector)
    bindFormSubmit(els, countries);
    setCurrentSelectionFromCookie(
      countries,
      els.currentCountry,
      els.currentLanguage,
      els.flagContainer,
      els.countrySelect,
      els.languageSelect
    );
    updateSubmitState(els.countrySelect, els.languageSelect, els.submitBtn);
  });
  // -------------------------
  // Element getters
  // -------------------------
  const LANGUAGES = {
    en: 'English',
    es: 'Español',
    fr: 'Français',
    de: 'Deutsch',
    nl: 'Nederlands'
  };

  function getElements() {
    const locationSelector = document.querySelector('.action--location-modal');
    const locationSelectorClose = document.querySelector('.action--location-close-btn');
    const locationSelectorOpen = document.querySelectorAll('.action--location-selector-open');
    const countrySelect = document.querySelector('.action--country-select');
    const languageSelect = document.querySelector('.action--language-select');
    const form = document.querySelector('.action--location-form');
    const currentCountry = document.querySelector('.action--current-country');
    const currentLanguage = document.querySelector('.action--current-language');
    const flagContainer = document.querySelector('.action--flag-container');
    const submitBtn = document.querySelector('.action--country-language-submit');
    if (!countrySelect || !languageSelect || !form) return null;
    return {
      locationSelector,
      locationSelectorClose,
      locationSelectorOpen,
      countrySelect,
      languageSelect,
      form,
      currentCountry,
      currentLanguage,
      flagContainer,
      submitBtn
    };
  }
  function getCountries() {
    return countryLanguageSelectorOptions;
  }
  // -------------------------
  // Populate country select
  // -------------------------
  function populateCountrySelect(selectEl, countries) {
    countries.forEach(function(country) {
      const option = document.createElement('option');
      option.value = country.code;
      option.textContent = country.name;
      selectEl.appendChild(option);
    });
  }
  // -------------------------
  // Country → Language sync
  // -------------------------
  function bindCountryChange(countrySelect, languageSelect, countries, submitBtn) {
    countrySelect.addEventListener('change', function() {
      const selected = countries.find(function(c) {
        return c.code === countrySelect.value;
      });
      resetLanguageSelect(languageSelect);
      
      if (!selected) return;
      //populate correct languages associated with selected country
      selected.lang.forEach(function(langCode) {
        const option = document.createElement('option');
        option.value = langCode;
        option.textContent = LANGUAGES[langCode];
        languageSelect.appendChild(option);
      });
      // Auto-select if only one language
      if (selected.lang.length === 1) {
        languageSelect.value = selected.lang[0];
      }
      // update submit button state
      updateSubmitState(countrySelect, languageSelect, submitBtn)
    });
  }

  function bindLanguageChange(countrySelect, languageSelect, submitBtn) {
      languageSelect.addEventListener('change', function() {
        updateSubmitState(countrySelect, languageSelect, submitBtn);
      });
  }

  function resetLanguageSelect(selectEl) {
      const options = selectEl.querySelectorAll('option');
      // keep only the first option (placeholder)
      for (let i = options.length - 1; i > 0; i--) {
        selectEl.removeChild(options[i]);
      }
      // reset selection to placeholder
      selectEl.value = '';
  }

  function updateSubmitState(countrySelect, languageSelect, submitBtn) {
    const isValid = countrySelect.value && languageSelect.value;
    submitBtn.classList.toggle('is-disabled', !isValid);
  }
  // -------------------------
  // Update site to selected country/language
  // -------------------------
  function getDomainForCountry(code) {
    const country = countryLanguageSelectorOptions.find(
      option => option.code === code
    );
  
    return country ? country.domain : 'auraframes.com';
  }
  function redirectToCountry(code, selectedLang) {
      const params = new URLSearchParams(window.location.search);    
      const langCode = selectedLang;
      setCookie('country_set', code);
      if (langCode) {
        setCookie('lang', langCode);
      }
      params.set('country_set', code);
      if (langCode) params.set('lang', langCode);
      else params.delete('lang');
      if (isDevOrStaging()) {
        window.location.href = window.location.pathname + '?' + params.toString();
      } else {
        const domain = getDomainForCountry(code);
        window.location.href = 'https://' + domain + window.location.pathname + '?' + params.toString();
      }
  }
  function setCurrentSelectionFromCookie(countries, currentCountryEl, currentLanguageEl, flagContainer, countrySelect, languageSelect) {
      const savedCountryCode = getCookie('country_set') || 'US'; // default to US
      const country = countries.find(c => c.code === savedCountryCode);
      if (!country) return;
      // Set current UI
      currentCountryEl.textContent = country.name;
      // Pick first language in list as default
      let savedLangCode = getCookie('lang') || country.lang[0];
      // If saved language isn't supported for this country, fallback
      if (country.lang.indexOf(savedLangCode) === -1) {
        // Prefer English if available, otherwise first language in list
        savedLangCode = country.lang[0];
      }
      currentLanguageEl.textContent = LANGUAGES[savedLangCode];
      // Populate country select & set value
      countrySelect.value = country.code;
      // Populate language select for that country
      const placeholderOption = languageSelect.querySelector('option');
      const placeholderText = placeholderOption ? placeholderOption.textContent : '';
      languageSelect.innerHTML = '';
      if (placeholderText) {
          const option = document.createElement('option');
          option.value = '';
          option.textContent = placeholderText;
          languageSelect.appendChild(option);
      }
      country.lang.forEach(function(langCode) {
          const option = document.createElement('option');
          option.value = langCode;
          option.textContent = LANGUAGES[langCode];
          languageSelect.appendChild(option);
      });
      languageSelect.value = savedLangCode;
      // Show correct flag
      const storedFlag = document.querySelector(`.flag-store [data-flag="${savedCountryCode}"]`);
      if (storedFlag) {
        flagContainer.innerHTML = storedFlag.innerHTML;
        const svg = flagContainer.querySelector('svg');
        if (svg) svg.classList.add('flag-icon', 'icon--country-flag', 'btn');
      }
  }
  // -------------------------
  // Modal open/close
  // -------------------------
  function bindModalClose(modal, closeButton) {
      closeButton.addEventListener('click', function() {
        modal.classList.add('hide');
        window.hideOverlay();
      });
  }
  function bindOverlayClose(modal) {
      const overlay = document.querySelector('.overlay');
      if (!overlay) return;
      overlay.addEventListener('click', function() {
        modal.classList.add('hide');
        window.hideOverlay();
      });
  }
  function bindModalOpen(modal) {
      document.addEventListener('click', function(e) {
        const trigger = e.target.closest('.action--location-selector-open');
        if (!trigger) return;
        modal.classList.remove('hide');
        window.showOverlay();
      });
  }
  // -------------------------
  // Form submit → update UI
  // -------------------------
  function bindFormSubmit(els, countries) {
    els.form.addEventListener('submit', function(e) {
      e.preventDefault();
      const selectedCode = els.countrySelect.value;
      const selectedLang = els.languageSelect.value;
      if (!selectedCode || !selectedLang) return;
      const selectedCountry = countries.find(function(c) {
        return c.code === selectedCode;
      });
      if (!selectedCountry) return;
      updateCurrentSelection(
        selectedCountry,
        selectedLang,
        els.currentCountry,
        els.currentLanguage
      );
      updateFlag(selectedCode, els.flagContainer);
      redirectToCountry(selectedCode, selectedLang);
      els.locationSelector.classList.add('hide');
      if (typeof window.logGA4Event === 'function') {
        window.logGA4Event('country-selector-submit', {
          selectedCountry: selectedCode,
          selectedLang: selectedLang
        });
      }
    });
  }
  function updateCurrentSelection(country, lang, countryEl, langEl) {
    countryEl.textContent = country.name;
    langEl.textContent = LANGUAGES[lang];
  }
  function updateFlag(code, container) {
    const storedFlag = document.querySelector(
      '.flag-store [data-flag="' + code + '"]'
    );
    if (!storedFlag) return;
    container.innerHTML = storedFlag.innerHTML;
    const svg = container.querySelector('svg');
    if (svg) {
      svg.classList.add('flag-icon', 'icon--country-flag', 'btn');
    }
  }
  // -------------------------
  // Helpers
  // -------------------------
  // Get a cookie by name
  function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;
  }
  // Set a cookie
  function setCookie(name, value, days = 365) {
      const expiration = new Date();
      expiration.setDate(expiration.getDate() + days);
      document.cookie = `${name}=${value};expires=${expiration.toUTCString()};path=/;`;
  }
  function isDevOrStaging() {
      const hostname = window.location.hostname;
      return hostname === 'localhost' || hostname.startsWith('localhost:') || hostname === 'staging.auraframes.com';
  }
})();
(function() {
    window.addEventListener('load', function() {
        if (!document.querySelector('#frame-worthy-features-section')) return;
        
        const nav = document.querySelector('.action--frame-worthy-nav');
        const mediaWrap = document.querySelector('.action--frame-worthy-media');
        const copyText = document.querySelector('.action--frame-worthy-copy-text');
        const pauseBtn = document.querySelector('.action--frame-worthy-media-toggle');

        const buttons = Array.from(nav.querySelectorAll('.action--frame-worthy-nav-btn'));
        const mediaAssets = Array.from(mediaWrap.querySelectorAll('.action--frame-worthy-media-asset'));
        const subtitles = Array.from(copyText.querySelectorAll('.action--frame-worthy-subtitle'));
        const descriptions = Array.from(copyText.querySelectorAll('.action--frame-worthy-description'));
        const panels = Array.from(copyText.querySelectorAll('.action--frame-worthy-panel'));
        const badges = Array.from(mediaWrap.querySelectorAll('.action--frame-worthy-badge'));

        let current = 0;
        let videoPlaying = true;

        if (pauseBtn) {
            const activeIsVideo = mediaAssets[current] && mediaAssets[current].tagName === 'VIDEO';
            pauseBtn.hidden = !activeIsVideo;
        }

        buttons.forEach((btn, i) => {
            btn.addEventListener('click', () => {
                setActive(i)
                logGA4Event('frame-worthy-nav-click', {
                    nav_btn: btn.dataset.label
                })
            });
        });

        nav.addEventListener('keydown', (e) => {
            const keys = ['ArrowRight', 'ArrowLeft', 'Home', 'End'];
            if (!keys.includes(e.key)) return;
            e.preventDefault();
            let idx = current;
            if (e.key === 'ArrowRight') idx = (current + 1) % buttons.length;
            if (e.key === 'ArrowLeft') idx = (current - 1 + buttons.length) % buttons.length;
            if (e.key === 'Home') idx = 0;
            if (e.key === 'End') idx = buttons.length - 1;
            setActive(idx);
            buttons[idx].focus();
        });
        nav.addEventListener('scroll', updateNavMask, { passive: true });
        window.addEventListener('resize', updateNavMask);
        updateNavMask();

        if (pauseBtn) {
            pauseBtn.addEventListener('click', () => {
                const video = mediaAssets.find(asset => asset.tagName === 'VIDEO');
                if (!video) return;
                if (videoPlaying) {
                    video.pause();
                    pauseBtn.setAttribute('aria-label', 'Play background video');
                    pauseBtn.setAttribute('aria-pressed', 'true');
                } else {
                    video.play();
                    pauseBtn.setAttribute('aria-label', 'Pause background video');
                    pauseBtn.setAttribute('aria-pressed', 'false');
                }
                videoPlaying = !videoPlaying;
            });
        }

        function setActive(index) {
            if (index === current) return;

            buttons.forEach((btn, i) => {
                const active = i === index;
                btn.classList.toggle('is-active', active);
                btn.setAttribute('aria-selected', String(active));
                btn.tabIndex = active ? 0 : -1;
            });

            mediaAssets.forEach((asset, i) => {
                const active = i === index;
                asset.classList.toggle('is-active', active);
                if (asset.tagName === 'VIDEO') {
                    if (active) { asset.currentTime = 0; if (videoPlaying) asset.play(); } else { asset.pause(); }
                }
            });

            badges.forEach((badge) => {
                badge.classList.toggle('is-active', Number(badge.dataset.slideIndex) === index);
            });

            if (pauseBtn) {
                const activeIsVideo = mediaAssets[index] && mediaAssets[index].tagName === 'VIDEO';
                pauseBtn.hidden = !activeIsVideo;
            }

            copyText.classList.add('is-fading');
            window.setTimeout(() => {
                subtitles.forEach((el, i) => el.classList.toggle('is-active', i === index));
                descriptions.forEach((el, i) => el.classList.toggle('is-active', i === index));
                panels.forEach((panel, i) => { panel.hidden = i !== index; });
                copyText.classList.remove('is-fading');
            }, 220);

            current = index;
            buttons[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }

        function updateNavMask() {
            const atEnd = nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 2;
            nav.classList.toggle('is-at-end', atEnd);
        }
    });
})();
document.querySelectorAll('.testimonials').forEach((section) => {
    const slides = Array.from(section.querySelectorAll('.testimonials__slide'));
    const dots = Array.from(section.querySelectorAll('.testimonials__dot'));
    const viewport = section.querySelector('.testimonials__viewport');
    const playPauseBtn = section.querySelector('.testimonials__play-pause');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  
    let current = 0;
    let timer = null;
    let hovering = false;
    let focused = false;
    let touching = false;
    let isPaused = false;
  
    function showSlide(index) {
      current = index;
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }
  
    function next() {
      showSlide((current + 1) % slides.length);
    }
  
    function prev() {
      showSlide((current - 1 + slides.length) % slides.length);
    }
  
    function stopAutoAdvance() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    }
  
    function scheduleNext() {
      stopAutoAdvance();
      if (prefersReducedMotion || hovering || focused || touching || slides.length < 2 || isPaused) return;
      const duration = Number(slides[current].dataset.duration) || 5000;
      timer = setTimeout(() => {
        next();
        scheduleNext();
      }, duration);
    }

    function togglePlayPause() {
      isPaused = !isPaused;
      playPauseBtn.setAttribute('aria-label', isPaused ? 'Play carousel' : 'Pause carousel');
      playPauseBtn.textContent = isPaused ? '▶' : '⏸';
      
      if (isPaused) {
        stopAutoAdvance();
      } else {
        scheduleNext();
      }
    }
  
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        showSlide(Number(dot.dataset.index));
        scheduleNext();
      });
    });

    if (playPauseBtn) {
      playPauseBtn.addEventListener('click', togglePlayPause);
    }
  
    section.addEventListener('mouseenter', () => { hovering = true; stopAutoAdvance(); });
    section.addEventListener('mouseleave', () => { hovering = false; scheduleNext(); });
    section.addEventListener('focusin', () => { focused = true; stopAutoAdvance(); });
    section.addEventListener('focusout', () => { focused = false; scheduleNext(); });
  
    // Swipe support
    let touchStartX = 0;
    let touchStartY = 0;
    const SWIPE_THRESHOLD = 40;
  
    viewport.addEventListener('touchstart', (e) => {
      touching = true;
      stopAutoAdvance();
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
  
    viewport.addEventListener('touchend', (e) => {
      const deltaX = e.changedTouches[0].clientX - touchStartX;
      const deltaY = e.changedTouches[0].clientY - touchStartY;
  
      if (Math.abs(deltaX) > SWIPE_THRESHOLD && Math.abs(deltaX) > Math.abs(deltaY)) {
        deltaX < 0 ? next() : prev();
      }
  
      touching = false;
      scheduleNext();
    }, { passive: true });
  
    scheduleNext();
});
(function () {
    'use strict';
  
    function initHeroVideo(video) {
      var toggle = document.querySelector('.video-pause-toggle[aria-controls="' + video.id + '"]');
      var media = video.parentElement;
  
      function userPaused() {
        return toggle && toggle.getAttribute('aria-pressed') === 'true';
      }
  
      function tryPlay() {
        if (!video.paused || userPaused()) return;
        var promise = video.play();
        if (promise && promise.catch) promise.catch(function (err) {
          // Autoplay blocked (Low Power Mode, Data Saver, etc.): show the paused state
          if (err && err.name === 'NotAllowedError' && toggle) {
            toggle.setAttribute('aria-pressed', 'true');
            toggle.setAttribute('aria-label', 'Play background video');
            toggle.classList.add('is-paused');
          }
        });
      }
  
      // Mark when the first frame is ready
      function onLoaded() { media.classList.add('is-loaded'); }
      if (video.readyState >= 2) {
        onLoaded();
      } else {
        video.addEventListener('loadeddata', onLoaded, { once: true });
      }
  
      // Safari needs an explicit play() for <source media> videos.
      // Try now, and again once enough data has arrived.
      tryPlay();
      video.addEventListener('canplay', tryPlay, { once: true });
  
      // Pause when off-screen; resume when visible (unless the user paused)
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (userPaused()) return;
            if (entry.isIntersecting) {
              tryPlay();
            } else {
              video.pause();
            }
          });
        }).observe(video);
      }
    }
  
    function init() {
      document.querySelectorAll('video[data-hero-video]').forEach(initHeroVideo);
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
})();
var webVitals=function(t){"use strict";var e,n,r=function(){var t=self.performance&&performance.getEntriesByType&&performance.getEntriesByType("navigation")[0];if(t&&t.responseStart>0&&t.responseStart<performance.now())return t},i=function(t){if("loading"===document.readyState)return"loading";var e=r();if(e){if(t<e.domInteractive)return"loading";if(0===e.domContentLoadedEventStart||t<e.domContentLoadedEventStart)return"dom-interactive";if(0===e.domComplete||t<e.domComplete)return"dom-content-loaded"}return"complete"},a=function(t){var e=t.nodeName;return 1===t.nodeType?e.toLowerCase():e.toUpperCase().replace(/^#/,"")},o=function(t,e){var n="";try{for(;t&&9!==t.nodeType;){var r=t,i=r.id?"#"+r.id:a(r)+(r.classList&&r.classList.value&&r.classList.value.trim()&&r.classList.value.trim().length?"."+r.classList.value.trim().replace(/\s+/g,"."):"");if(n.length+i.length>(e||100)-1)return n||i;if(n=n?i+">"+n:i,r.id)break;t=r.parentNode}}catch(t){}return n},c=-1,s=function(){return c},u=function(t){addEventListener("pageshow",(function(e){e.persisted&&(c=e.timeStamp,t(e))}),!0)},f=function(){var t=r();return t&&t.activationStart||0},d=function(t,e){var n=r(),i="navigate";s()>=0?i="back-forward-cache":n&&(document.prerendering||f()>0?i="prerender":document.wasDiscarded?i="restore":n.type&&(i=n.type.replace(/_/g,"-")));return{name:t,value:void 0===e?-1:e,rating:"good",delta:0,entries:[],id:"v4-".concat(Date.now(),"-").concat(Math.floor(8999999999999*Math.random())+1e12),navigationType:i}},l=function(t,e,n){try{if(PerformanceObserver.supportedEntryTypes.includes(t)){var r=new PerformanceObserver((function(t){Promise.resolve().then((function(){e(t.getEntries())}))}));return r.observe(Object.assign({type:t,buffered:!0},n||{})),r}}catch(t){}},m=function(t,e,n,r){var i,a;return function(o){e.value>=0&&(o||r)&&((a=e.value-(i||0))||void 0===i)&&(i=e.value,e.delta=a,e.rating=function(t,e){return t>e[1]?"poor":t>e[0]?"needs-improvement":"good"}(e.value,n),t(e))}},v=function(t){requestAnimationFrame((function(){return requestAnimationFrame((function(){return t()}))}))},p=function(t){document.addEventListener("visibilitychange",(function(){"hidden"===document.visibilityState&&t()}))},h=function(t){var e=!1;return function(){e||(t(),e=!0)}},g=-1,T=function(){return"hidden"!==document.visibilityState||document.prerendering?1/0:0},y=function(t){"hidden"===document.visibilityState&&g>-1&&(g="visibilitychange"===t.type?t.timeStamp:0,S())},E=function(){addEventListener("visibilitychange",y,!0),addEventListener("prerenderingchange",y,!0)},S=function(){removeEventListener("visibilitychange",y,!0),removeEventListener("prerenderingchange",y,!0)},b=function(){return g<0&&(g=T(),E(),u((function(){setTimeout((function(){g=T(),E()}),0)}))),{get firstHiddenTime(){return g}}},C=function(t){document.prerendering?addEventListener("prerenderingchange",(function(){return t()}),!0):t()},L=[1800,3e3],M=function(t,e){e=e||{},C((function(){var n,r=b(),i=d("FCP"),a=l("paint",(function(t){t.forEach((function(t){"first-contentful-paint"===t.name&&(a.disconnect(),t.startTime<r.firstHiddenTime&&(i.value=Math.max(t.startTime-f(),0),i.entries.push(t),n(!0)))}))}));a&&(n=m(t,i,L,e.reportAllChanges),u((function(r){i=d("FCP"),n=m(t,i,L,e.reportAllChanges),v((function(){i.value=performance.now()-r.timeStamp,n(!0)}))})))}))},D=[.1,.25],w=0,I=1/0,F=0,P=function(t){t.forEach((function(t){t.interactionId&&(I=Math.min(I,t.interactionId),F=Math.max(F,t.interactionId),w=F?(F-I)/7+1:0)}))},x=function(){return e?w:performance.interactionCount||0},k=function(){"interactionCount"in performance||e||(e=l("event",P,{type:"event",buffered:!0,durationThreshold:0}))},A=[],B=new Map,O=0,R=function(){var t=Math.min(A.length-1,Math.floor((x()-O)/50));return A[t]},j=[],q=function(t){if(j.forEach((function(e){return e(t)})),t.interactionId||"first-input"===t.entryType){var e=A[A.length-1],n=B.get(t.interactionId);if(n||A.length<10||t.duration>e.latency){if(n)t.duration>n.latency?(n.entries=[t],n.latency=t.duration):t.duration===n.latency&&t.startTime===n.entries[0].startTime&&n.entries.push(t);else{var r={id:t.interactionId,latency:t.duration,entries:[t]};B.set(r.id,r),A.push(r)}A.sort((function(t,e){return e.latency-t.latency})),A.length>10&&A.splice(10).forEach((function(t){return B.delete(t.id)}))}}},N=function(t){var e=self.requestIdleCallback||self.setTimeout,n=-1;return t=h(t),"hidden"===document.visibilityState?t():(n=e(t),p(t)),n},H=[200,500],V=function(t,e){"PerformanceEventTiming"in self&&"interactionId"in PerformanceEventTiming.prototype&&(e=e||{},C((function(){var n;k();var r,i=d("INP"),a=function(t){N((function(){t.forEach(q);var e=R();e&&e.latency!==i.value&&(i.value=e.latency,i.entries=e.entries,r())}))},o=l("event",a,{durationThreshold:null!==(n=e.durationThreshold)&&void 0!==n?n:40});r=m(t,i,H,e.reportAllChanges),o&&(o.observe({type:"first-input",buffered:!0}),p((function(){a(o.takeRecords()),r(!0)})),u((function(){O=x(),A.length=0,B.clear(),i=d("INP"),r=m(t,i,H,e.reportAllChanges)})))})))},W=[],z=[],U=0,_=new WeakMap,G=new Map,J=-1,K=function(t){W=W.concat(t),Q()},Q=function(){J<0&&(J=N(X))},X=function(){G.size>10&&G.forEach((function(t,e){B.has(e)||G.delete(e)}));var t=A.map((function(t){return _.get(t.entries[0])})),e=z.length-50;z=z.filter((function(n,r){return r>=e||t.includes(n)}));for(var n=new Set,r=0;r<z.length;r++){var i=z[r];et(i.startTime,i.processingEnd).forEach((function(t){n.add(t)}))}var a=W.length-1-50;W=W.filter((function(t,e){return t.startTime>U&&e>a||n.has(t)})),J=-1};j.push((function(t){t.interactionId&&t.target&&!G.has(t.interactionId)&&G.set(t.interactionId,t.target)}),(function(t){var e,n=t.startTime+t.duration;U=Math.max(U,t.processingEnd);for(var r=z.length-1;r>=0;r--){var i=z[r];if(Math.abs(n-i.renderTime)<=8){(e=i).startTime=Math.min(t.startTime,e.startTime),e.processingStart=Math.min(t.processingStart,e.processingStart),e.processingEnd=Math.max(t.processingEnd,e.processingEnd),e.entries.push(t);break}}e||(e={startTime:t.startTime,processingStart:t.processingStart,processingEnd:t.processingEnd,renderTime:n,entries:[t]},z.push(e)),(t.interactionId||"first-input"===t.entryType)&&_.set(t,e),Q()}));var Y,Z,$,tt,et=function(t,e){for(var n,r=[],i=0;n=W[i];i++)if(!(n.startTime+n.duration<t)){if(n.startTime>e)break;r.push(n)}return r},nt=[2500,4e3],rt={},it=[800,1800],at=function t(e){document.prerendering?C((function(){return t(e)})):"complete"!==document.readyState?addEventListener("load",(function(){return t(e)}),!0):setTimeout(e,0)},ot=function(t,e){e=e||{};var n=d("TTFB"),i=m(t,n,it,e.reportAllChanges);at((function(){var a=r();a&&(n.value=Math.max(a.responseStart-f(),0),n.entries=[a],i(!0),u((function(){n=d("TTFB",0),(i=m(t,n,it,e.reportAllChanges))(!0)})))}))},ct={passive:!0,capture:!0},st=new Date,ut=function(t,e){Y||(Y=e,Z=t,$=new Date,lt(removeEventListener),ft())},ft=function(){if(Z>=0&&Z<$-st){var t={entryType:"first-input",name:Y.type,target:Y.target,cancelable:Y.cancelable,startTime:Y.timeStamp,processingStart:Y.timeStamp+Z};tt.forEach((function(e){e(t)})),tt=[]}},dt=function(t){if(t.cancelable){var e=(t.timeStamp>1e12?new Date:performance.now())-t.timeStamp;"pointerdown"==t.type?function(t,e){var n=function(){ut(t,e),i()},r=function(){i()},i=function(){removeEventListener("pointerup",n,ct),removeEventListener("pointercancel",r,ct)};addEventListener("pointerup",n,ct),addEventListener("pointercancel",r,ct)}(e,t):ut(e,t)}},lt=function(t){["mousedown","keydown","touchstart","pointerdown"].forEach((function(e){return t(e,dt,ct)}))},mt=[100,300],vt=function(t,e){e=e||{},C((function(){var n,r=b(),i=d("FID"),a=function(t){t.startTime<r.firstHiddenTime&&(i.value=t.processingStart-t.startTime,i.entries.push(t),n(!0))},o=function(t){t.forEach(a)},c=l("first-input",o);n=m(t,i,mt,e.reportAllChanges),c&&(p(h((function(){o(c.takeRecords()),c.disconnect()}))),u((function(){var r;i=d("FID"),n=m(t,i,mt,e.reportAllChanges),tt=[],Z=-1,Y=null,lt(addEventListener),r=a,tt.push(r),ft()})))}))};return t.CLSThresholds=D,t.FCPThresholds=L,t.FIDThresholds=mt,t.INPThresholds=H,t.LCPThresholds=nt,t.TTFBThresholds=it,t.onCLS=function(t,e){!function(t,e){e=e||{},M(h((function(){var n,r=d("CLS",0),i=0,a=[],o=function(t){t.forEach((function(t){if(!t.hadRecentInput){var e=a[0],n=a[a.length-1];i&&t.startTime-n.startTime<1e3&&t.startTime-e.startTime<5e3?(i+=t.value,a.push(t)):(i=t.value,a=[t])}})),i>r.value&&(r.value=i,r.entries=a,n())},c=l("layout-shift",o);c&&(n=m(t,r,D,e.reportAllChanges),p((function(){o(c.takeRecords()),n(!0)})),u((function(){i=0,r=d("CLS",0),n=m(t,r,D,e.reportAllChanges),v((function(){return n()}))})),setTimeout(n,0))})))}((function(e){var n=function(t){var e,n={};if(t.entries.length){var r=t.entries.reduce((function(t,e){return t&&t.value>e.value?t:e}));if(r&&r.sources&&r.sources.length){var a=(e=r.sources).find((function(t){return t.node&&1===t.node.nodeType}))||e[0];a&&(n={largestShiftTarget:o(a.node),largestShiftTime:r.startTime,largestShiftValue:r.value,largestShiftSource:a,largestShiftEntry:r,loadState:i(r.startTime)})}}return Object.assign(t,{attribution:n})}(e);t(n)}),e)},t.onFCP=function(t,e){M((function(e){var n=function(t){var e={timeToFirstByte:0,firstByteToFCP:t.value,loadState:i(s())};if(t.entries.length){var n=r(),a=t.entries[t.entries.length-1];if(n){var o=n.activationStart||0,c=Math.max(0,n.responseStart-o);e={timeToFirstByte:c,firstByteToFCP:t.value-c,loadState:i(t.entries[0].startTime),navigationEntry:n,fcpEntry:a}}}return Object.assign(t,{attribution:e})}(e);t(n)}),e)},t.onFID=function(t,e){vt((function(e){var n=function(t){var e=t.entries[0],n={eventTarget:o(e.target),eventType:e.name,eventTime:e.startTime,eventEntry:e,loadState:i(e.startTime)};return Object.assign(t,{attribution:n})}(e);t(n)}),e)},t.onINP=function(t,e){n||(n=l("long-animation-frame",K)),V((function(e){var n=function(t){var e=t.entries[0],n=_.get(e),r=e.processingStart,a=n.processingEnd,c=n.entries.sort((function(t,e){return t.processingStart-e.processingStart})),s=et(e.startTime,a),u=t.entries.find((function(t){return t.target})),f=u&&u.target||G.get(e.interactionId),d=[e.startTime+e.duration,a].concat(s.map((function(t){return t.startTime+t.duration}))),l=Math.max.apply(Math,d),m={interactionTarget:o(f),interactionTargetElement:f,interactionType:e.name.startsWith("key")?"keyboard":"pointer",interactionTime:e.startTime,nextPaintTime:l,processedEventEntries:c,longAnimationFrameEntries:s,inputDelay:r-e.startTime,processingDuration:a-r,presentationDelay:Math.max(l-a,0),loadState:i(e.startTime)};return Object.assign(t,{attribution:m})}(e);t(n)}),e)},t.onLCP=function(t,e){!function(t,e){e=e||{},C((function(){var n,r=b(),i=d("LCP"),a=function(t){e.reportAllChanges||(t=t.slice(-1)),t.forEach((function(t){t.startTime<r.firstHiddenTime&&(i.value=Math.max(t.startTime-f(),0),i.entries=[t],n())}))},o=l("largest-contentful-paint",a);if(o){n=m(t,i,nt,e.reportAllChanges);var c=h((function(){rt[i.id]||(a(o.takeRecords()),o.disconnect(),rt[i.id]=!0,n(!0))}));["keydown","click"].forEach((function(t){addEventListener(t,(function(){return N(c)}),{once:!0,capture:!0})})),p(c),u((function(r){i=d("LCP"),n=m(t,i,nt,e.reportAllChanges),v((function(){i.value=performance.now()-r.timeStamp,rt[i.id]=!0,n(!0)}))}))}}))}((function(e){var n=function(t){var e={timeToFirstByte:0,resourceLoadDelay:0,resourceLoadDuration:0,elementRenderDelay:t.value};if(t.entries.length){var n=r();if(n){var i=n.activationStart||0,a=t.entries[t.entries.length-1],c=a.url&&performance.getEntriesByType("resource").filter((function(t){return t.name===a.url}))[0],s=Math.max(0,n.responseStart-i),u=Math.max(s,c?(c.requestStart||c.startTime)-i:0),f=Math.max(u,c?c.responseEnd-i:0),d=Math.max(f,a.startTime-i);e={element:o(a.element),timeToFirstByte:s,resourceLoadDelay:u-s,resourceLoadDuration:f-u,elementRenderDelay:d-f,navigationEntry:n,lcpEntry:a},a.url&&(e.url=a.url),c&&(e.lcpResourceEntry=c)}}return Object.assign(t,{attribution:e})}(e);t(n)}),e)},t.onTTFB=function(t,e){ot((function(e){var n=function(t){var e={waitingDuration:0,cacheDuration:0,dnsDuration:0,connectionDuration:0,requestDuration:0};if(t.entries.length){var n=t.entries[0],r=n.activationStart||0,i=Math.max((n.workerStart||n.fetchStart)-r,0),a=Math.max(n.domainLookupStart-r,0),o=Math.max(n.connectStart-r,0),c=Math.max(n.connectEnd-r,0);e={waitingDuration:i,cacheDuration:a-i,dnsDuration:o-a,connectionDuration:c-o,requestDuration:t.value-c,navigationEntry:n}}return Object.assign(t,{attribution:e})}(e);t(n)}),e)},t}({});

// Patch to add Page Load Time (PLT) to Web Vitals
webVitals.onPLT = function (onReport) {
  function reportPLT() {
    try {
      // Use newer Performance API for higher precision
      const navigation = performance.getEntriesByType('navigation')[0];
      if (navigation) {
        const pageLoadTime = navigation.loadEventEnd - navigation.startTime;

        onReport({
          name: 'PLT',
          delta: pageLoadTime,
          value: pageLoadTime,
          id: `v3-${Date.now()}-${Math.floor(8999999999999 * Math.random()) + 1e12}`, // Same as other Web Vitals metrics
          attribution: {
            pageLoadTime,
            navigationType: navigation.type,
            url: window.location.href
          }
        });
      } else {
        requestIdleCallback(reportPLT, { timeout: 1000 });
      }
    } catch (error) {
      console.warn('Failed to report PLT:', error);
    }
  }

  window.addEventListener('load', () => {
    setTimeout(reportPLT, 0);
  });
};

// https://github.com/GoogleChrome/web-vitals#which-build-is-right-for-you
function sendToGoogleAnalytics({name, delta, value, id, attribution}) {
  if (name == 'CLS') {
    switch (attribution.largestShiftTarget) {
      case '#cartPopup':
      case '#auto-on-off>div.pin-spacer>div.auto-on-off.relative.overflow-hidden.mb4':
        return;
    }
  }

  const eventParams = {
    // Built-in params:
    value: delta, // Use `delta` so the value can be summed.
    // Custom params:
    metric_id: id, // Needed to aggregate events.
    metric_value: value, // Optional.
    metric_delta: delta, // Optional.
  };

  switch (name) {
    case 'CLS':
      eventParams.debug_target = attribution.largestShiftTarget;
      break;
    case 'FCP':
      eventParams.debug_target = attribution.firstByteToFCP;
      break;
    case 'INP':
      eventParams.debug_target = attribution.interactionTarget;
      break;
    case 'LCP':
      eventParams.debug_target = attribution.element || attribution.target; // v4 is element, v5 when we upgrade is target
      break;
    case 'TTFB':
      eventParams.debug_target = attribution.requestDuration;
      break;
    case 'PLT':
      eventParams.debug_target = attribution.pageLoadTime;
      break;
  }
  if (typeof gtag === 'function') {
    gtag('event', name, eventParams);
  }
}

webVitals.onCLS(sendToGoogleAnalytics);
webVitals.onFCP(sendToGoogleAnalytics);
webVitals.onINP(sendToGoogleAnalytics);
webVitals.onLCP(sendToGoogleAnalytics);
webVitals.onTTFB(sendToGoogleAnalytics);
webVitals.onPLT(sendToGoogleAnalytics);
